import * as React from "react"
const SvgComponent = (props) => (
    <svg
        fill="none"
        viewBox="0 0 1314 962"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M1136.6.65.3 656.68l169.5 293.58 1136.3-656.03L1136.6.65z"
            fill="url(#a)"
        />
        <path
            d="M1226.3 154 90 810.03l87.555 151.65 1136.3-656.03-87.55-151.65z"
            fill="#191822"
        />
        <path d="m907.99 336.52-500 290.55z" fill="#35404D" />
        <path d="m907.99 336.52-500 290.55" stroke="#DEDDE2" />
        <path
            d="M657.49 545.55c58.705 0 106.29-27.431 106.29-61.268s-47.589-61.268-106.29-61.268c-58.704 0-106.29 27.431-106.29 61.268s47.59 61.268 106.29 61.268z"
            fill="#282739"
        />
        <path
            d="M657.49 545.05c58.429 0 105.79-27.207 105.79-60.768s-47.365-60.768-105.79-60.768c-58.428 0-105.79 27.207-105.79 60.768s47.366 60.768 105.79 60.768z"
            stroke="#DEDDE2"
        />
        <path
            d="m661.8 401.78-11.278-6.554-23.625 13.64.143 50.523 11.278 6.554 23.625-13.643-.143-50.52z"
            fill="#02314B"
        />
        <path
            d="m638.32 465.95-11.278-6.554-.143-50.523 11.278 6.554.143 50.523z"
            fill="#1F0952"
        />
        <path
            d="m638.17 415.42-11.278-6.554 23.625-13.64 11.278 6.554-23.625 13.64z"
            fill="#560BAD"
        />
        <path
            d="m661.8 401.78.143 50.523-23.625 13.64-.143-50.523 23.625-13.64z"
            fill="#331083"
        />
        <path
            d="m656.35 411.13.008 2.827-2.46 1.42-.008-2.827 2.46-1.42zM656.38 420.45l.008 2.827-2.46 1.42-.007-2.822 2.459-1.425zM656.37 417.14l.008 2.834-2.46 1.42-.008-2.834 2.46-1.42zM659.23 415.48l.008 2.834-2.46 1.42-.008-2.834 2.46-1.42zM659.25 424.8l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42zM653.57 440.73l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42zM653.56 437.42l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42zM659.29 437.43l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42zM659.28 434.12l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42zM647.85 444.04l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42zM656.43 439.08l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42zM656.42 435.77l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42zM650.67 429.76l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42z"
            fill="#2D1071"
        />
        <path
            d="M642.38 437.97c.627-.362 1.142-.075 1.145.646a2.5 2.5 0 0 1-1.137 1.969c-.627.362-1.142.075-1.145-.652a2.502 2.502 0 0 1 1.137-1.963z"
            fill="#4CC9F0"
        />
        <path
            d="m660.53 441.43.025 8.735-20.912 12.074-.025-8.735 20.912-12.074z"
            fill="#633AC1"
        />
        <path
            d="M642.4 443.73c.627-.362 1.142-.068 1.145.651a2.515 2.515 0 0 1-1.137 1.969c-.627.362-1.142.068-1.145-.652a2.51 2.51 0 0 1 1.137-1.968z"
            fill="#F72585"
        />
        <path
            d="m639.59 444.32 20.912-12.074.024 8.317-20.913 12.074-.023-8.317zm11.113-2.416-.008-2.827-2.46 1.421.008 2.827 2.46-1.421zm-2.861 1.652-.008-2.828-2.46 1.421.008 2.827 2.46-1.419v-.001zm8.582-4.955-.009-2.827-2.46 1.421.009 2.827 2.46-1.421zm2.86-1.651-.008-2.827-2.46 1.421.008 2.827 2.46-1.421zm-5.721 3.3-.008-2.827-2.46 1.421.008 2.827 2.46-1.421zm5.731 0-.009-2.827-2.46 1.421.009 2.827 2.46-1.421zm-8.582 4.955-.008-2.827-2.46 1.419.008 2.828 2.46-1.421v.001zm5.721-3.3-.008-2.828-2.46 1.421.008 2.827 2.46-1.419v-.001zm-8.581 4.954-.008-2.827-2.46 1.421.008 2.827 2.46-1.421zm5.721-3.3-.009-2.828-2.459 1.421.008 2.828 2.46-1.421zm-11.161 6.34a2.522 2.522 0 0 0 1.137-1.969c0-.72-.518-1.014-1.145-.651a2.51 2.51 0 0 0-1.137 1.968c0 .721.518 1.014 1.145.652zm-.01-3.548a2.522 2.522 0 0 0 1.137-1.969c0-.72-.518-1.013-1.145-.651a2.51 2.51 0 0 0-1.137 1.968c0 .721.518 1.014 1.145.652z"
            fill="#633AC1"
        />
        <path
            d="M642.37 434.42c.627-.362 1.142-.075 1.145.646a2.495 2.495 0 0 1-1.137 1.969c-.627.362-1.142.075-1.145-.652a2.5 2.5 0 0 1 1.137-1.963z"
            fill="#F72585"
        />
        <path
            d="m639.57 435 20.912-12.074.024 8.324-20.912 12.074-.024-8.324zm11.122.892-.008-2.828-2.46 1.421.008 2.827 2.46-1.419v-.001zm-2.86 1.651-.008-2.828-2.46 1.421.008 2.828 2.46-1.421zm11.442-6.606-.009-2.827-2.459 1.421.008 2.827 2.46-1.421zm-2.861 1.651-.008-2.827-2.46 1.421.008 2.827 2.46-1.421zm-2.86 1.651-.008-2.827-2.46 1.421.008 2.827 2.46-1.421zm-2.87-1.656-.008-2.827-2.46 1.421.008 2.827 2.46-1.421zm-2.861 1.651-.008-2.827-2.46 1.421.008 2.827 2.46-1.421zm8.582-4.954-.008-2.827-2.46 1.419.008 2.828 2.46-1.421v.001zm2.86-1.651-.008-2.828-2.46 1.421.008 2.827 2.46-1.419v-.001zm-5.721 3.3-.008-2.827-2.46 1.421.008 2.827 2.46-1.421zm-11.161 6.1a2.493 2.493 0 0 0 1.137-1.969c0-.721-.518-1.008-1.145-.646a2.494 2.494 0 0 0-1.137 1.962c0 .727.518 1.014 1.145.652v.001zm.01 3.548a2.503 2.503 0 0 0 1.137-1.969c0-.721-.518-1.008-1.145-.646a2.494 2.494 0 0 0-1.137 1.962c0 .727.518 1.014 1.145.652v.001z"
            fill="#633AC1"
        />
        <path
            d="m659.26 428.11.008 2.827-2.46 1.421-.008-2.827 2.46-1.421zM656.4 429.76l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42zM653.54 431.41l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42zM656.39 426.46l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42zM647.84 440.73l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42z"
            fill="#2D1071"
        />
        <path
            d="M642.41 447.28c.627-.362 1.142-.068 1.145.651a2.515 2.515 0 0 1-1.137 1.969c-.627.362-1.142.068-1.145-.652a2.502 2.502 0 0 1 1.137-1.968z"
            fill="#4CC9F0"
        />
        <path
            d="m650.65 423.75.008 2.827-2.46 1.42-.008-2.827 2.46-1.42zM647.79 422.09l.008 2.834-2.46 1.42-.008-2.834 2.46-1.42z"
            fill="#2D1071"
        />
        <path
            d="M642.35 428.65c.627-.362 1.142-.075 1.145.652a2.5 2.5 0 0 1-1.137 1.962c-.627.362-1.142.075-1.145-.646a2.502 2.502 0 0 1 1.137-1.968z"
            fill="#4CC9F0"
        />
        <path
            d="m639.54 425.69 20.913-12.074.023 8.317-20.911 12.073-.025-8.316zm11.113-2.416-.008-2.833-2.46 1.419.008 2.834 2.46-1.421v.001zm-2.861 1.651-.008-2.833-2.46 1.421.009 2.833 2.459-1.421zm8.582-4.954-.009-2.837-2.46 1.421.008 2.834 2.46-1.421.001.003zm2.86-1.651-.008-2.834-2.46 1.421.008 2.833 2.46-1.419v-.001zm-5.721 3.3-.008-2.833-2.46 1.419.008 2.834 2.46-1.421v.001zm5.731 0-.008-2.827-2.46 1.421.008 2.827 2.46-1.421zm-8.582 4.955-.008-2.828-2.46 1.421.008 2.827 2.46-1.419v-.001zm5.721-3.3-.008-2.827-2.46 1.421.008 2.827 2.46-1.421zm-8.581 4.955-.008-2.828-2.46 1.421.008 2.828 2.46-1.421zm5.721-3.3-.008-2.827-2.46 1.421.008 2.827 2.46-1.421zm-11.158 6.334a2.51 2.51 0 0 0 1.137-1.962c0-.727-.518-1.014-1.145-.652a2.5 2.5 0 0 0-1.137 1.969c0 .721.518 1.008 1.145.646v-.001zm-.01-3.548a2.51 2.51 0 0 0 1.137-1.963c0-.727-.518-1.014-1.145-.652a2.513 2.513 0 0 0-1.137 1.969c0 .721.518 1.008 1.145.646z"
            fill="#633AC1"
        />
        <path
            d="m659.24 418.8.008 2.827-2.46 1.42-.008-2.827 2.46-1.42zM650.68 433.06l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42zM653.53 428.11l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42zM653.52 422.1l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42zM659.21 409.48l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42zM653.5 418.79l.008 2.834-2.46 1.42-.008-2.834 2.46-1.42zM647.79 425.4l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42zM650.65 420.44l.008 2.834-2.46 1.42-.008-2.834 2.46-1.42zM653.49 412.78l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42zM656.34 407.82l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42zM650.63 414.44l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42zM653.48 409.48l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42z"
            fill="#2D1071"
        />
        <path
            d="M642.34 425.1c.627-.362 1.142-.075 1.145.652a2.497 2.497 0 0 1-1.137 1.963c-.627.362-1.142.075-1.145-.646a2.513 2.513 0 0 1 1.137-1.969z"
            fill="#F72585"
        />
        <path
            d="m647.77 416.09.008 2.827-2.46 1.42-.008-2.827 2.46-1.42zM650.62 411.13l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42zM647.76 412.78l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42z"
            fill="#2D1071"
        />
        <path
            d="M642.33 419.33c.627-.362 1.142-.075 1.145.652a2.512 2.512 0 0 1-1.137 1.969c-.627.362-1.142.068-1.145-.652a2.502 2.502 0 0 1 1.137-1.969z"
            fill="#4CC9F0"
        />
        <path
            d="M642.32 415.78c.627-.362 1.142-.075 1.145.652a2.515 2.515 0 0 1-1.137 1.969c-.627.362-1.142.068-1.145-.652a2.493 2.493 0 0 1 1.137-1.969z"
            fill="#F72585"
        />
        <path
            d="m639.51 416.37 20.913-12.073.023 8.316-20.912 12.074-.024-8.317zm16.834-5.719-.008-2.827-2.46 1.421.008 2.827 2.46-1.421zm-8.572 8.262-.008-2.827-2.46 1.421.008 2.827 2.46-1.421zm-.009-3.307-.009-2.827-2.46 1.421.009 2.827 2.46-1.421zm2.87 1.656-.009-2.827-2.465 1.422.009 2.827 2.46-1.421.005-.001zm-.01-3.307-.008-2.827-2.46 1.419.008 2.828 2.46-1.421v.001zm5.73 0-.008-2.827-2.46 1.421.008 2.827 2.46-1.421zm2.861-1.651-.008-2.828-2.46 1.421.008 2.828 2.46-1.421zm-.01-3.308-.008-2.827-2.46 1.421.008 2.827 2.46-1.421zm-5.711 6.61-.008-2.827-2.46 1.421.008 2.827 2.46-1.421zm-.01-3.307-.008-2.828-2.46 1.421.009 2.828 2.459-1.421zm-11.151 9.648a2.519 2.519 0 0 0 1.137-1.969c0-.727-.518-1.014-1.145-.652a2.503 2.503 0 0 0-1.137 1.969c0 .721.518 1.014 1.145.652zm-.01-3.548a2.519 2.519 0 0 0 1.137-1.969c0-.727-.518-1.014-1.145-.652a2.503 2.503 0 0 0-1.137 1.969c0 .721.518 1.014 1.145.652z"
            fill="#633AC1"
        />
        <path
            d="m659.2 406.17.008 2.827-2.46 1.42-.008-2.827 2.46-1.42zM647.82 434.72l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42zM647.81 431.41l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42zM650.71 442.38l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42zM650.7 439.08l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42z"
            fill="#2D1071"
        />
        <path
            d="m699.87 474.84-.017 6.3c-.007 2.593-1.711 5.181-5.111 7.157-6.851 3.982-17.99 3.982-24.886 0-3.466-2-5.2-4.628-5.189-7.253l.017-6.3c-.007 2.625 1.724 5.251 5.189 7.253 6.9 3.981 18.035 3.981 24.886 0 3.4-1.977 5.1-4.565 5.112-7.158l-.001.001z"
            fill="#3F37C9"
        />
        <path
            d="M694.68 467.58c6.9 3.981 6.926 10.437.081 14.415s-17.99 3.981-24.886 0-6.925-10.429-.075-14.412 17.99-3.981 24.88-.003z"
            fill="#331083"
        />
        <path
            d="m699.87 467.03-.017 6.3c-.007 2.592-1.711 5.181-5.111 7.157-6.851 3.981-17.99 3.981-24.886 0-3.466-2-5.2-4.628-5.189-7.252l.017-6.3c-.007 2.624 1.724 5.251 5.189 7.252 6.9 3.981 18.035 3.981 24.886 0 3.4-1.976 5.1-4.565 5.112-7.157h-.001z"
            fill="#3F37C9"
        />
        <path
            d="M694.68 459.77c6.9 3.981 6.926 10.437.081 14.414s-17.99 3.981-24.886 0-6.925-10.429-.075-14.41 17.99-3.98 24.88-.004z"
            fill="#331083"
        />
        <path
            d="m699.87 459.22-.017 6.3c-.007 2.592-1.711 5.181-5.111 7.157-6.851 3.982-17.99 3.982-24.886 0-3.466-2-5.2-4.63-5.189-7.253l.017-6.3c-.007 2.625 1.724 5.251 5.189 7.253 6.9 3.981 18.035 3.981 24.886 0 3.4-1.977 5.1-4.565 5.112-7.158l-.001.001z"
            fill="#3F37C9"
        />
        <path
            d="M694.68 451.96c6.9 3.981 6.926 10.437.081 14.414s-17.99 3.981-24.886 0-6.925-10.429-.075-14.412 17.99-3.979 24.88-.002z"
            fill="#331083"
        />
        <path
            d="m699.87 451.4-.017 6.3c-.007 2.593-1.711 5.182-5.111 7.158-6.851 3.981-17.99 3.981-24.886 0-3.466-2-5.2-4.628-5.189-7.253l.017-6.3c-.007 2.624 1.724 5.251 5.189 7.252 6.9 3.981 18.035 3.981 24.886 0 3.4-1.976 5.1-4.565 5.112-7.157h-.001z"
            fill="#3F37C9"
        />
        <path
            d="M694.68 444.15c6.9 3.981 6.926 10.437.081 14.414s-17.99 3.981-24.886 0-6.925-10.429-.075-14.41 17.99-3.982 24.88-.004z"
            fill="#331083"
        />
        <path
            d="m699.87 443.59-.017 6.3c-.007 2.592-1.711 5.181-5.111 7.157-6.851 3.981-17.99 3.981-24.886 0-3.466-2-5.2-4.628-5.189-7.252l.017-6.3c-.007 2.624 1.724 5.251 5.189 7.253 6.9 3.981 18.035 3.981 24.886 0 3.4-1.977 5.1-4.565 5.112-7.158h-.001z"
            fill="#3F37C9"
        />
        <path
            d="M694.68 436.34c6.9 3.981 6.926 10.437.081 14.414s-17.99 3.981-24.886 0-6.925-10.431-.075-14.412 17.99-3.979 24.88-.002z"
            fill="#331083"
        />
        <path
            d="m699.87 435.78-.017 6.3c-.007 2.593-1.711 5.181-5.111 7.158-6.851 3.981-17.99 3.981-24.886 0-3.466-2-5.2-4.628-5.189-7.253l.017-6.3c-.007 2.624 1.724 5.251 5.189 7.252 6.9 3.981 18.035 3.981 24.886 0 3.4-1.976 5.1-4.565 5.112-7.157h-.001z"
            fill="#3F37C9"
        />
        <path
            d="M694.68 428.52c6.9 3.981 6.926 10.437.081 14.414s-17.99 3.981-24.886 0-6.925-10.429-.075-14.412 17.99-3.98 24.88-.002z"
            fill="#331083"
        />
        <path
            d="m693.3 483.13-1.337-.777-.108-38.231 1.337.777.108 38.231z"
            fill="#9CB5CC"
        />
        <path
            d="m693.2 444.9-1.337-.777 25.071-14.475 1.337.777L693.2 444.9z"
            fill="#D7E7F7"
        />
        <path
            d="m718.27 430.42.108 38.231-25.071 14.475-.108-38.231 25.071-14.475z"
            fill="#F8F9FC"
        />
        <path
            d="m696.15 485.03-1.337-.777-.108-38.231 1.337.777.108 38.231z"
            fill="#9CB5CC"
        />
        <path
            d="m696.04 446.8-1.337-.777 25.071-14.475 1.337.777L696.04 446.8z"
            fill="#D7E7F7"
        />
        <path
            d="m721.11 432.32.108 38.231-25.071 14.475-.108-38.231 25.071-14.475z"
            fill="#F8F9FC"
        />
        <path
            d="m699.1 487.37-1.337-.777-.108-38.231 1.337.777.108 38.231z"
            fill="#9CB5CC"
        />
        <path
            d="m698.99 449.14-1.337-.777 25.071-14.475 1.337.777-25.071 14.475z"
            fill="#D7E7F7"
        />
        <path
            d="m724.06 434.66.108 38.231-25.071 14.475-.108-38.231 25.071-14.475z"
            fill="#F8F9FC"
        />
        <path
            d="m722.54 455.32.007 2.3-21.895 12.636-.007-2.3 21.895-12.636zM722.5 445.53l.006 2.3-21.892 12.639-.007-2.3L722.5 445.53z"
            fill="#9CB5CC"
        />
        <path
            d="m715.4 444.73.007 2.3-14.8 8.545-.006-2.3 14.799-8.545z"
            fill="#FA7564"
        />
        <path
            d="m722.52 450.43.006 2.3-21.893 12.638-.006-2.3 21.893-12.638zM722.56 465.12l.006 2.3-21.892 12.639-.006-2.3 21.892-12.639zM722.55 460.22l.007 2.3-21.892 12.639-.007-2.3 21.892-12.639z"
            fill="#9CB5CC"
        />
        <path
            d="m706.08 511.04-.674-.3-.071-.034 1.811 1.046.071.034.674.3c.015 0 .029.004.042.011l-1.81-1.046a.092.092 0 0 0-.043-.011zM704.08 516.13a.124.124 0 0 0-.058-.085l-1.811-1.046a.13.13 0 0 1 .038.036.13.13 0 0 1 .02.049l.376.732c.002.015.007.03.016.043a.1.1 0 0 0 .032.033l1.811 1.046a.115.115 0 0 1-.033-.033.112.112 0 0 1-.016-.043l-.375-.732z"
            fill="#331083"
        />
        <path
            d="M706.31 507.45a.095.095 0 0 0-.037-.012.09.09 0 0 0-.04.003.198.198 0 0 0-.057.022.327.327 0 0 0-.048.035l-.685.446.373-.709a.485.485 0 0 1 .066-.112.422.422 0 0 1 .1-.084.26.26 0 0 1 .058-.023.148.148 0 0 1 .042 0l.782.087a.102.102 0 0 1 .035.011l-1.811-1.046a.123.123 0 0 0-.034-.011l-.783-.087a.14.14 0 0 0-.041 0 .347.347 0 0 0-.158.107.489.489 0 0 0-.067.112l-.59 1.123-.064.111-1.193-.689a.096.096 0 0 0-.037-.013.135.135 0 0 0-.04.003c-.019.005-.037.012-.054.022s-.033.022-.048.035l-.882.757a.511.511 0 0 0-.045.048.377.377 0 0 0-.089.3l.06 1v.107a6.476 6.476 0 0 0-.542.727.378.378 0 0 1-.09.074.268.268 0 0 1-.068.027.162.162 0 0 1-.044 0l-.842.111a.193.193 0 0 0-.034 0 .213.213 0 0 0-.063.025.382.382 0 0 0-.168.199l-.464 1.169c-.046.113-.032.214.028.249l.764.441c-.053.234-.09.47-.111.709a.523.523 0 0 1-.161.242l-.82.9a.305.305 0 0 0-.047.048.37.37 0 0 0-.088.294l.218.893c.004.014.01.028.018.04a.11.11 0 0 0 .032.029l1.3.752-.1.38c-.046.113-.028.216.032.251l1.811 1.046c-.061-.035-.078-.138-.032-.251l.316-1.153a.328.328 0 0 0 .015-.248 1.617 1.617 0 0 1-.358-.415l-1.225-.708.741-.817a.397.397 0 0 0 .061-.062.488.488 0 0 0 .1-.181c.023-.273.065-.543.127-.81l-.826-.477c0-.038.006-.075.019-.111l.464-1.169a.459.459 0 0 1 .068-.115.367.367 0 0 1 .1-.084.213.213 0 0 1 .063-.025.193.193 0 0 1 .034 0l.842-.111c.015.002.03.002.044 0a.268.268 0 0 0 .068-.027.358.358 0 0 0 .089-.075 8.358 8.358 0 0 1 .543-.727v-.107l-.06-1a.377.377 0 0 1 .134-.348l.559-.479.986.569c.023.013.05.018.075.014a2.99 2.99 0 0 1 .622-.214h.011l.065-.113.068-.13 1.654.955.092-.054.9-.585a.235.235 0 0 1 .105-.058.103.103 0 0 1 .077.01l-1.815-1.043z"
            fill="#331083"
        />
        <path
            d="m705.16 510.77-1.811-1.046a.774.774 0 0 1 .342.5 2.563 2.563 0 0 1-.62 2.034c-.098.12-.206.231-.323.333a2.078 2.078 0 0 1-.316.228 1.34 1.34 0 0 1-.393.158.74.74 0 0 1-.534-.066l1.81 1.045a.737.737 0 0 0 .535.067c.138-.032.271-.085.393-.158a2.07 2.07 0 0 0 .315-.228c.117-.101.225-.213.323-.334a2.568 2.568 0 0 0 .621-2.033.762.762 0 0 0-.342-.5z"
            fill="#331083"
        />
        <path
            d="M708.39 509.46a.397.397 0 0 1-.141.346l-.82.9a.564.564 0 0 0-.152.245 4.8 4.8 0 0 1-.132.807l.071.034.674.3c.093 0 .121.125.067.257l-.464 1.169a.411.411 0 0 1-.161.2.158.158 0 0 1-.1.025l-.841.118a.206.206 0 0 0-.113.03.442.442 0 0 0-.1.078c-.166.25-.345.49-.537.721v.1l.06 1a.397.397 0 0 1-.14.345l-.877.761a.319.319 0 0 1-.042.03c-.088.051-.168.032-.188-.06l-.375-.732a.115.115 0 0 0-.132-.1c-.204.096-.418.17-.639.22l-.059.11-.6 1.12a.404.404 0 0 1-.16.2.183.183 0 0 1-.1.026l-.777-.09c-.088-.012-.121-.131-.067-.263l.316-1.153a.328.328 0 0 0 .015-.248 1.617 1.617 0 0 1-.358-.415l-.092.054-.9.585a.26.26 0 0 1-.046.034c-.083.048-.161.024-.184-.058l-.218-.893a.377.377 0 0 1 .024-.188.377.377 0 0 1 .11-.154l.821-.9a.51.51 0 0 0 .157-.243c.023-.273.065-.543.127-.81l-.066-.031-.679-.3c-.088-.012-.116-.128-.062-.26l.464-1.169a.423.423 0 0 1 .164-.2.188.188 0 0 1 .1-.029l.842-.111a.199.199 0 0 0 .112-.03.358.358 0 0 0 .089-.075c.166-.252.347-.494.543-.724v-.107l-.06-1a.389.389 0 0 1 .134-.349l.882-.757a.268.268 0 0 1 .048-.035c.084-.049.158-.024.182.058l.37.736a.125.125 0 0 0 .138.1 2.96 2.96 0 0 1 .633-.217l.065-.113.59-1.123a.419.419 0 0 1 .162-.2.161.161 0 0 1 .1-.025l.782.087c.088.012.116.128.062.266l-.316 1.153a.365.365 0 0 0-.015.248c.144.115.266.256.358.415l.092-.054.9-.585a.327.327 0 0 1 .048-.035c.086-.05.163-.026.182.059l.229.899zm-3.833 4.178a2.693 2.693 0 0 0 .944-2.367c-.148-.6-.687-.751-1.275-.41a2.068 2.068 0 0 0-.306.221 2.732 2.732 0 0 0-.949 2.376c.151.6.684.749 1.271.408.112-.066.218-.142.315-.228z"
            fill="#560BAD"
        />
        <path
            d="m710.87 496.95-.953-.422-.1-.049 1.811 1.046.1.049.954.422c.02.002.04.008.057.017l-1.811-1.046a.144.144 0 0 0-.058-.017zM707.3 503.72a.194.194 0 0 0-.029-.068.205.205 0 0 0-.054-.052l-1.811-1.046a.191.191 0 0 1 .083.12l.525 1.035a.161.161 0 0 0 .073.105l1.811 1.046a.166.166 0 0 1-.073-.1l-.525-1.04zM711.19 491.87a.148.148 0 0 0-.111-.014.29.29 0 0 0-.084.034.332.332 0 0 0-.062.044l-1.27.825-.131.083 1.811 1.041.131-.082 1.27-.826a.372.372 0 0 1 .145-.077.15.15 0 0 1 .112.014l-1.811-1.042zM708.82 496.12l-1.811-1.042a1.081 1.081 0 0 1 .486.709 3.65 3.65 0 0 1-.881 2.878 3.71 3.71 0 0 1-.462.476c-.136.12-.284.227-.441.319a1.884 1.884 0 0 1-.555.223 1.052 1.052 0 0 1-.758-.094l1.811 1.046c.233.125.503.158.758.093.196-.044.383-.119.555-.222.157-.092.305-.199.441-.319a3.71 3.71 0 0 0 .462-.476 3.638 3.638 0 0 0 .881-2.878 1.076 1.076 0 0 0-.486-.713z"
            fill="#4895EF"
        />
        <path
            d="m703.68 502.88-1.733-1 1.048-1.15a.762.762 0 0 0 .222-.35c.03-.385.09-.767.18-1.142l-1.172-.678a.435.435 0 0 1 .024-.16l.664-1.651a.644.644 0 0 1 .1-.167.487.487 0 0 1 .127-.112.27.27 0 0 1 .077-.031.167.167 0 0 1 .063 0l1.2-.173a.2.2 0 0 0 .069 0 .359.359 0 0 0 .1-.039.567.567 0 0 0 .124-.1c.201-.306.418-.602.649-.886l.111-.134v-.151l-.084-1.417a.52.52 0 0 1 .128-.422.712.712 0 0 1 .066-.069l.787-.679 1.391.8a.178.178 0 0 0 .109.02c.288-.132.59-.233.9-.3l.087-.157.839-1.589a.645.645 0 0 1 .1-.172.498.498 0 0 1 .129-.113.306.306 0 0 1 .084-.033.188.188 0 0 1 .058 0l1.1.129a.132.132 0 0 1 .051.016l-1.811-1.045a.134.134 0 0 0-.051-.017l-1.1-.129a.188.188 0 0 0-.058 0 .28.28 0 0 0-.084.034.482.482 0 0 0-.129.113.64.64 0 0 0-.1.171l-.839 1.589-.084.154-1.691-.977a.15.15 0 0 0-.11-.013.264.264 0 0 0-.082.032.505.505 0 0 0-.06.043l-1.247 1.077a.584.584 0 0 0-.194.49l.085 1.417v.151l-.111.134c-.231.284-.448.58-.649.887a.567.567 0 0 1-.124.1.33.33 0 0 1-.1.039.2.2 0 0 1-.069 0l-1.2.173a.222.222 0 0 0-.063 0 .27.27 0 0 0-.077.031.623.623 0 0 0-.226.28l-.664 1.65c-.063.165-.041.307.043.356l1.077.622a7.186 7.186 0 0 0-.152 1 .762.762 0 0 1-.222.35l-1.158 1.27a.807.807 0 0 0-.064.067.54.54 0 0 0-.13.424l.313 1.253a.159.159 0 0 0 .071.107l1.81 1.045a.158.158 0 0 1-.07-.106l-.313-1.253a.54.54 0 0 1 .194-.491l.084-.092c.125.194.278.37.454.52a.454.454 0 0 1-.02.345l-.445 1.631c-.065.163-.045.309.043.359l1.811 1.046c-.088-.051-.108-.2-.043-.359l.445-1.631a.454.454 0 0 0 .02-.345 2.438 2.438 0 0 1-.508-.592z"
            fill="#4895EF"
        />
        <path
            d="M713.39 494.27a.562.562 0 0 1-.194.49l-1.163 1.274a.75.75 0 0 0-.217.346 7.204 7.204 0 0 1-.185 1.14l.1.049.954.422c.132.011.171.178.1.366l-.658 1.654a.575.575 0 0 1-.229.279.225.225 0 0 1-.141.036l-1.191.17a.29.29 0 0 0-.167.043.556.556 0 0 0-.122.1 10.03 10.03 0 0 1-.766 1.024l.007.147.084 1.417a.55.55 0 0 1-.194.484l-1.247 1.077a.38.38 0 0 1-.069.05c-.12.07-.226.038-.259-.086l-.525-1.035a.166.166 0 0 0-.067-.109.165.165 0 0 0-.125-.031c-.288.133-.59.233-.9.3l-.093.161-.838 1.589a.594.594 0 0 1-.23.284.227.227 0 0 1-.135.034l-1.105-.125c-.126-.022-.165-.188-.09-.376l.445-1.631a.454.454 0 0 0 .02-.345 2.438 2.438 0 0 1-.506-.593l-.126.073-1.275.829a.36.36 0 0 1-.067.049c-.118.069-.228.038-.256-.088l-.313-1.253a.567.567 0 0 1 .194-.491l1.158-1.27a.76.76 0 0 0 .222-.35c.03-.385.091-.766.18-1.142l-.093-.047-.96-.418c-.126-.015-.17-.178-.1-.373l.664-1.65a.574.574 0 0 1 .225-.28.217.217 0 0 1 .14-.033l1.2-.173a.26.26 0 0 0 .165-.042.545.545 0 0 0 .124-.1c.233-.355.487-.695.76-1.02v-.151l-.084-1.417a.554.554 0 0 1 .194-.49l1.247-1.077a.505.505 0 0 1 .06-.043c.121-.07.234-.041.262.088l.526 1.036a.169.169 0 0 0 .192.14c.288-.133.59-.233.9-.3l.086-.157.839-1.589a.577.577 0 0 1 .228-.285.254.254 0 0 1 .142-.037l1.1.129c.126.015.171.184.1.372l-.45 1.634a.454.454 0 0 0-.02.345c.201.168.372.368.506.593l.131-.082 1.27-.826a.38.38 0 0 1 .062-.043c.123-.072.232-.042.266.079l.307 1.255zm-5.425 5.914a3.827 3.827 0 0 0 1.343-3.354c-.214-.849-.969-1.061-1.8-.579-.158.093-.307.2-.445.321a3.818 3.818 0 0 0-1.338 3.351c.209.848.969 1.061 1.8.58.157-.092.305-.199.441-.319h-.001z"
            fill="#4CC9F0"
        />
        <path
            d="m723.4 504.78 1.811 1.046a.263.263 0 0 1 .035.015l-1.811-1.046a.263.263 0 0 0-.035-.015z"
            fill="#D43E3E"
        />
        <path
            d="M724.42 497.63a.214.214 0 0 0-.155-.017.523.523 0 0 0-.16.067l-1.775.939a.488.488 0 0 1-.133.056l1.811 1.046a.495.495 0 0 0 .129-.056l1.776-.939a.534.534 0 0 1 .16-.067.219.219 0 0 1 .155.016l-1.808-1.045zM717.6 512.85a.265.265 0 0 0-.038-.12.27.27 0 0 0-.087-.091l-1.811-1.045a.277.277 0 0 1 .125.21l.545 1.584a.236.236 0 0 0 .029.1c.017.03.042.056.071.076l1.811 1.046a.234.234 0 0 1-.071-.076.236.236 0 0 1-.029-.1l-.545-1.584zM720.32 502.24l-1.811-1.046a1.593 1.593 0 0 1 .713 1.24 5.199 5.199 0 0 1-1.254 3.642 4.896 4.896 0 0 1-.882.85c-.108.08-.221.155-.338.223a2.61 2.61 0 0 1-.757.3 1.43 1.43 0 0 1-1.026-.127l1.811 1.046c.314.169.68.214 1.026.127a2.62 2.62 0 0 0 .757-.3c.117-.068.23-.143.338-.223a4.93 4.93 0 0 0 .882-.85 5.203 5.203 0 0 0 1.254-3.638 1.6 1.6 0 0 0-.713-1.244zM713.09 510.9l-1.81-1.046c.138.344.33.664.568.948a.71.71 0 0 1-.063.483l-.78 2.235c-.109.23-.1.457.035.532l1.811 1.045c-.13-.074-.144-.3-.036-.531l.781-2.235a.71.71 0 0 0 .063-.483 3.542 3.542 0 0 1-.569-.948zM717.9 496.96a.233.233 0 0 1-.1-.03l1.81 1.046c.03.017.065.027.1.03.184-.063.372-.114.563-.155.205-.044.413-.073.623-.087l.135-.211 1.274-2.086a.877.877 0 0 1 .111-.177.651.651 0 0 1 .178-.157.368.368 0 0 1 .111-.044.211.211 0 0 1 .106 0l1.392.419c.015.004.029.01.043.017l-1.814-1.044a.226.226 0 0 0-.043-.017l-1.392-.419a.211.211 0 0 0-.106 0 .39.39 0 0 0-.11.044.641.641 0 0 0-.179.157.877.877 0 0 0-.111.177l-1.274 2.087-.135.21c-.21.014-.418.043-.623.087-.189.04-.376.091-.559.153z"
            fill="#B5179E"
        />
        <path
            d="M715.19 501.62a.712.712 0 0 0 .125-.093 12.688 12.688 0 0 1 1.108-1.299.535.535 0 0 0 .01-.207l.071-2.036a.767.767 0 0 1 .308-.651l1.726-1.267c.017-.013.035-.024.051-.034a.387.387 0 0 1 .112-.045.203.203 0 0 1 .145.018l-1.81-1.046a.2.2 0 0 0-.146-.018.381.381 0 0 0-.111.045.655.655 0 0 0-.052.034l-1.726 1.265a.705.705 0 0 0-.124.12.759.759 0 0 0-.184.531l-.071 2.036a.535.535 0 0 1-.01.207 13.282 13.282 0 0 0-1.108 1.299.712.712 0 0 1-.125.093.43.43 0 0 1-.131.053.268.268 0 0 1-.132 0l-1.542-.01a.244.244 0 0 0-.114 0 .381.381 0 0 0-.111.045.668.668 0 0 0-.176.155.87.87 0 0 0-.111.176l-1.049 2.207c-.113.239-.095.464.031.536l.1.055 1.117.758.115.084a11.51 11.51 0 0 0-.38 1.586.977.977 0 0 1-.32.45l-1.643 1.565a.78.78 0 0 0-.124.12.768.768 0 0 0-.184.531l.24 1.856a.216.216 0 0 0 .03.099c.017.03.041.055.07.074l1.811 1.046a.216.216 0 0 1-.07-.074.216.216 0 0 1-.03-.099l-.24-1.856a.768.768 0 0 1 .184-.531.74.74 0 0 1 .124-.12l1.643-1.565a.977.977 0 0 0 .32-.45 11.51 11.51 0 0 1 .38-1.586l-.115-.084-1.175-.8-.05-.029c-.112-.08-.128-.293-.019-.523l1.049-2.208a.936.936 0 0 1 .11-.175.688.688 0 0 1 .177-.155.381.381 0 0 1 .111-.045.22.22 0 0 1 .114 0l1.542.01a.268.268 0 0 0 .132 0 .433.433 0 0 0 .127-.048z"
            fill="#B5179E"
        />
        <path
            d="M726.57 500.7a.807.807 0 0 1-.308.651l-1.643 1.571a.927.927 0 0 0-.32.444 11.51 11.51 0 0 1-.38 1.586l.116.09 1.174.791c.159.052.193.29.069.551l-1.049 2.208a.768.768 0 0 1-.287.331.302.302 0 0 1-.225.042l-1.542-.01a.333.333 0 0 0-.262.05.607.607 0 0 0-.125.093c-.339.459-.709.893-1.109 1.3a.54.54 0 0 0-.01.208l-.071 2.036a.796.796 0 0 1-.308.651l-1.726 1.273c-.231.138-.385.072-.411-.126l-.545-1.584a.251.251 0 0 0-.225-.241 4.864 4.864 0 0 1-1.186.248l-.135.205-1.274 2.087a.753.753 0 0 1-.286.333.291.291 0 0 1-.22.043l-1.392-.413c-.164-.049-.193-.3-.074-.548l.781-2.235a.716.716 0 0 0 .063-.483 3.49 3.49 0 0 1-.569-.948.482.482 0 0 0-.132.056l-1.771.943c-.231.138-.39.075-.416-.123l-.24-1.856a.785.785 0 0 1 .308-.651l1.643-1.565a.991.991 0 0 0 .32-.45 11.51 11.51 0 0 1 .38-1.586l-.115-.084-1.175-.8c-.159-.046-.193-.291-.069-.552l1.049-2.208a.76.76 0 0 1 .287-.33.289.289 0 0 1 .225-.042l1.542.01a.346.346 0 0 0 .263-.05.811.811 0 0 0 .125-.093c.341-.456.711-.891 1.108-1.3a.555.555 0 0 0 .01-.207l.071-2.036a.786.786 0 0 1 .308-.651l1.726-1.267a.902.902 0 0 1 .051-.034c.181-.1.334-.044.36.154l.545 1.584a.25.25 0 0 0 .225.24 4.573 4.573 0 0 1 1.186-.242l.135-.211 1.274-2.086a.762.762 0 0 1 .289-.334.28.28 0 0 1 .217-.042l1.392.419c.164.043.193.29.074.542l-.781 2.234a.718.718 0 0 0-.063.484c.238.283.431.603.569.947a.52.52 0 0 0 .129-.054l1.776-.939c.227-.136.385-.078.411.12l.243 1.856zm-7.671 7.275a5.417 5.417 0 0 0 2.136-4.488c-.178-1.351-1.258-1.782-2.494-1.063-.117.068-.23.142-.338.222a5.414 5.414 0 0 0-2.136 4.495c.178 1.345 1.258 1.775 2.494 1.057.116-.068.229-.143.338-.223z"
            fill="#F72585"
        />
        <path
            d="m663.73 514.22-30.965 17.994a5.852 5.852 0 0 1-5.3 0l-16.6-9.584 4.48-2.6v-1.219l3.073 1.764.439-.253.006-2.563-.008 3.07 6.7 3.843.423-.245v.492l8.844 5.077 4.1-2.392v-1.09l.938.538 1.375-.8 2.723-1.589 4.746-2.775v-1.374l1.187.683 4.094-2.4v-1.058l.914.527 4.094-2.4.008-3.069-4.286-2.463-.82.481v-.948l-4.288-2.465-.822.479v-.947l-4.286-2.463-.824.481v-.949l-4.286-2.463-.82.479v-.946l-4.286-2.463-.821.479v-.952l-4.292-2.459-.82.479v-.952l-4.291-2.462-.817.479v-.946l-4.293-2.466-.818.479v-.947l-4.293-2.463-4.091 2.393v1.062l-1.029-.59 2.399-1.377.007-3.069-4.285-2.463-4.1 2.393v1.059l-.913-.524-4.1 2.395v1.064l-.918-.529-4.1 2.395v1.065l-.918-.529-4.091 2.395v1.094l-.946-.543-4.092 2.392-.008 3.069 9.084 5.219.538-.314.006-2.448-.008 3.07 6.091 3.5-4.429 2.571v1.226l-20.3-11.72a1.88 1.88 0 0 1-1.1-1.545l-.009 3.068a1.876 1.876 0 0 0 1.1 1.547l53.835 31.08a5.867 5.867 0 0 0 5.3 0l30.964-18a1.853 1.853 0 0 0 1.085-1.524c0-1.023.003-2.046.008-3.069a1.843 1.843 0 0 1-.337.911c-.191.269-.45.482-.751.617z"
            fill="#331083"
        />
        <path
            d="m618.18 489.35-4.1 2.394-4.286-2.464 4.091-2.393 4.295 2.463zM612.38 491.83l-4.094 2.4-10.561-6.065 4.1-2.394 10.555 6.059zM623.28 492.28l-4.1 2.39-4.287-2.462 4.093-2.394 4.294 2.466zM604.67 493.21l-4.1 2.394-7.863-4.516 4.1-2.394 7.863 4.516zM628.39 495.21l-4.1 2.393-4.286-2.461 4.094-2.393 4.292 2.461zM609.52 496l-4.1 2.393-4.289-2.46 4.1-2.394L609.52 496zM622.36 497.56l-4.09 2.394-4.294-2.461 4.1-2.395 4.284 2.462zM602.36 497.69l-4.1 2.392-10.557-6.062 4.096-2.394 10.561 6.064zM633.49 498.14l-4.1 2.395-4.29-2.462 4.1-2.392 4.29 2.459zM614.34 498.76l-4.1 2.394-4.289-2.46 4.1-2.393 4.289 2.459zM595.84 499.79l-4.1 2.392-9.084-5.217 4.091-2.392 9.093 5.217zM627.25 500.37l-4.1 2.394-4.286-2.463 4.1-2.393 4.286 2.462zM607.24 500.49l-4.1 2.394-4.286-2.463 4.1-2.394 4.286 2.463zM619.16 501.54l-4.1 2.393-4.286-2.464 4.1-2.393 4.286 2.464zM612.01 503.24l-4.1 2.393-4.287-2.463 4.1-2.39 4.287 2.46zM643.7 504.01l-4.091 2.392-4.295-2.462 4.101-2.393 4.285 2.463zM603.08 503.94l-4.1 2.394-6.7-3.849 4.094-2.394 6.706 3.849zM623.99 504.31l-4.1 2.393-4.286-2.463 4.1-2.393 4.286 2.463zM616.83 506l-4.094 2.394-4.294-2.463 4.1-2.393L616.83 506zM648.8 506.94l-4.1 2.393-4.285-2.461 4.1-2.394 4.285 2.462zM628.82 507.08l-4.1 2.395-4.289-2.46 4.1-2.393 4.289 2.458zM641.88 508.78l-4.091 2.393-4.291-2.461 4.1-2.394 4.282 2.462zM621.6 508.75l-4.1 2.393-4.285-2.461 4.1-2.393 4.285 2.461zM653.91 509.87l-4.1 2.393-4.289-2.466 4.1-2.392 4.289 2.465zM659.02 512.8l-4.1 2.393-4.289-2.466 4.1-2.393 4.289 2.466zM633.64 509.85l-4.094 2.4-4.289-2.466 4.1-2.393 4.283 2.459zM646.76 511.58l-4.1 2.394-4.286-2.461 4.094-2.4 4.292 2.467zM626.59 511.61l-4.1 2.393-4.289-2.464 4.1-2.393 4.289 2.464zM638.46 512.62l-4.094 2.394-4.29-2.465 4.1-2.392 4.284 2.463zM631.36 514.35l-4.1 2.393-4.286-2.464 4.094-2.39 4.292 2.461zM643.29 515.39l-4.1 2.392-4.293-2.462 4.1-2.394 4.293 2.464zM654 515.73l-4.1 2.4-6.644-3.816 4.1-2.392L654 515.73zM636.18 517.12l-4.1 2.393-4.289-2.463 4.1-2.393 4.289 2.463zM615.36 516.96l-6.073 3.53-15.346-8.861 6.075-3.528 15.344 8.859zM629.67 519.22l-4.1 2.39-6.7-3.845 4.1-2.394 6.7 3.849z"
            fill="#F8F9FC"
        />
        <path
            d="m648.72 518.82-4.747 2.773-2.724 1.591-1.375.8-7.233-4.156 4.1-2.393 2.221 1.278 4.747-2.773 5.011 2.88z"
            fill="#F8F9FC"
        />
        <path
            d="M663.71 511.15c1.463.844 1.471 2.223.017 3.068l-30.965 17.994a5.852 5.852 0 0 1-5.3 0l-53.833-31.079c-1.462-.845-1.47-2.225-.016-3.072l30.964-17.992a5.853 5.853 0 0 1 5.3 0l53.833 31.081zm-54.432 9.339 6.073-3.529-15.344-8.86-6.074 3.528 15.345 8.861zm-9.688-13.8 18.837 10.82 4.1-2.393-18.846-10.82-4.092 2.393h.001zm41.654 16.5 2.724-1.591 4.747-2.773-5.011-2.878-4.747 2.773-2.221-1.278-4.1 2.393 7.233 4.156 1.374-.8.001-.002zm-28.863-31.354-10.556-6.064-4.1 2.395 10.561 6.065 4.093-2.4.002.004zm-10.03 5.861-10.561-6.065-4.091 2.395 10.556 6.063 4.1-2.392-.004-.001zm-19.692-.727 9.084 5.216 4.1-2.391-9.088-5.218-4.092 2.392-.004.001zm43.334 24.887 8.84 5.079 4.094-2.391-8.843-5.082-4.092 2.394h.001zm-21.322-28.64-7.864-4.516-4.1 2.394 7.863 4.516 4.1-2.395.001.001zm-12.392 9.278 6.7 3.849 4.1-2.393-6.7-3.85-4.094 2.394h-.006zm26.585 15.272 6.7 3.846 4.1-2.391-6.7-3.849-4.1 2.395v-.001zm24.395-3.45 6.645 3.815 4.094-2.4-6.644-3.812-4.1 2.392.005.005zm-8.36 1.002 4.293 2.461 4.1-2.391-4.293-2.465-4.1 2.395zm-18.069-9.317-4.289-2.462-4.1 2.393 4.294 2.462 4.093-2.393h.002zm16.662-7.862-4.293-2.462-4.1 2.391 4.289 2.462 4.1-2.395.004.004zm-6.906 13.466-4.289-2.465-4.1 2.393 4.289 2.465 4.1-2.393zm15.891-2.495-4.094 2.4 4.287 2.461 4.1-2.395-4.289-2.463-.004-.003zm-24.3-19.766-4.3-2.467-4.091 2.393 4.286 2.463 4.1-2.393.005.004zm-.1 5.751-4.1 2.395 4.294 2.461 4.091-2.393-4.286-2.462.001-.001zm-10.839 5.395-4.288-2.462-4.1 2.393 4.286 2.463 4.1-2.395.002.001zm30.362 5.818-4.1 2.395 4.292 2.461 4.092-2.392-4.287-2.463.003-.001zm-4.88-2.8-4.1 2.392 4.291 2.462 4.1-2.393-4.289-2.461h-.002zm-4.882-2.8-4.1 2.39 4.291 2.466 4.094-2.4-4.289-2.46.004.004zm31.18 12.1-4.286-2.463-4.1 2.393 4.288 2.466 4.094-2.4.004.004zm-5.1-2.93-4.288-2.465-4.1 2.392 4.289 2.466 4.1-2.393h-.001zm-52.781-13.947 4.288 2.46 4.1-2.392-4.289-2.462-4.1 2.395.001-.001zm19.3 11.083 4.289 2.46 4.1-2.395-4.288-2.459-4.1 2.393-.001.001zm-14.472-8.312 4.289 2.461 4.1-2.395-4.289-2.459-4.1 2.392v.001zm19.3 11.082 4.289 2.465 4.093-2.4-4.285-2.462-4.1 2.393.003.004zm18.446-5.77-4.286-2.463-4.1 2.393 4.294 2.461 4.091-2.391h.001zm-13.621 8.538 4.291 2.466 4.093-2.395-4.286-2.462-4.1 2.391h.002zm-6.811-20.275-4.293-2.466-4.093 2.395 4.288 2.461 4.1-2.39h-.002zm-12.5 9.183 4.286 2.465 4.1-2.393-4.285-2.465-4.1 2.393h-.001zm4.825 2.771 4.286 2.463 4.1-2.393-4.286-2.463-4.1 2.393zm1.879-9.478-4.289-2.461-4.1 2.392 4.287 2.462 4.1-2.393h.002zm31.316 12.185-4.286-2.463-4.1 2.395 4.285 2.461 4.1-2.392.001-.001zm-17.448 7.408-4.29-2.462-4.092 2.393 4.287 2.463 4.1-2.392-.005-.002zm-8.4-16.445-4.1 2.393 4.286 2.462 4.1-2.393-4.288-2.462h.002zm-1.352 10.84-4.285-2.461-4.1 2.393 4.285 2.461 4.1-2.393zm14.58 8.374-4.287-2.463-4.1 2.393 4.288 2.462 4.1-2.392h-.001zm-7.794-21.908-4.291-2.462-4.093 2.393 4.286 2.461 4.1-2.392h-.002zm-21.544-12.372-4.1 2.393 4.288 2.461 4.094-2.391-4.285-2.463h.003zm31.753 18.24-4.286-2.463-4.1 2.393 4.291 2.461 4.093-2.391h.002zm-26.595 2.156-4.289-2.461-4.1 2.391 4.288 2.462 4.1-2.392h.001z"
            fill="#4361EE"
        />
        <path
            d="m611.13 485.3-4.094 2.39-4.289-2.46 4.1-2.394 4.283 2.464zM617.48 494.76l-4.1 2.393-4.286-2.461 4.1-2.393 4.286 2.461zM638.6 501.08l-4.094 2.392-4.29-2.462 4.1-2.393 4.284 2.463zM632.12 503.17l-4.094 2.4-4.29-2.466 4.1-2.39 4.284 2.456zM637.01 505.97l-4.1 2.393-4.29-2.462 4.1-2.393 4.29 2.462zM622.53 515.12l-4.1 2.393-18.838-10.82 4.091-2.393 18.847 10.82zM638.93 524.54l-4.094 2.392-8.841-5.079 4.093-2.394 8.842 5.081z"
            fill="#F8F9FC"
        />
        <path
            d="m666.76 468.09-53.833-31.081a1.872 1.872 0 0 0-1.889-.182l-2.656 1.542a1.875 1.875 0 0 1 1.892.183l2.8 1.618a.684.684 0 0 0-.215.082c-.472.272-1.033.6-1.58.918-.357.208-.717.414-1.075.625a1.112 1.112 0 0 0-.466 1.024l-.095 32.792a3.5 3.5 0 0 0 1.588 2.751c.421-.242.837-.486 1.256-.73l-1.256.73 51.69 29.844a1.126 1.126 0 0 0 1.138.107l2.6-1.513-.009 3.235a1.866 1.866 0 0 1-.78 1.7c.441-.256.884-.514 1.326-.769s.885-.514 1.326-.773a1.86 1.86 0 0 0 .779-1.7l.1-35.815a5.854 5.854 0 0 0-2.641-4.588z"
            fill="#331083"
        />
        <path
            d="m663.03 471.75-51.689-29.844c-.88-.507-1.6-.091-1.6.916l-.095 32.792a3.5 3.5 0 0 0 1.588 2.751l51.69 29.844c.877.506 1.6.1 1.6-.909l.093-32.795a3.529 3.529 0 0 0-1.587-2.755z"
            fill="#E8ECEF"
        />
        <path
            d="m664.11 469.64-53.832-31.081c-1.465-.846-2.663-.161-2.668 1.518l-.1 35.814a5.871 5.871 0 0 0 2.648 4.6l53.833 31.078c1.463.843 2.663.155 2.669-1.526l.1-35.813a5.857 5.857 0 0 0-2.65-4.59zm.419 37.662c.017.313-.082.621-.277.865a1.018 1.018 0 0 1-1.326.044l-36.332-20.977-15.358-8.865c-.02-.01-.039-.026-.058-.037a2.369 2.369 0 0 1-.17-.119 2.58 2.58 0 0 1-.243-.2 3.564 3.564 0 0 1-.653-.834 3.237 3.237 0 0 1-.463-1.562l.095-32.792c0-.064 0-.125.008-.183a1.409 1.409 0 0 1 .118-.456.934.934 0 0 1 .172-.251c.023-.023.044-.046.069-.067s.032-.024.049-.036a.808.808 0 0 1 .355-.133 1.102 1.102 0 0 1 .506.062l.078.029c.083.034.164.074.242.119l51.69 29.844a3.53 3.53 0 0 1 1.592 2.755l-.094 32.794z"
            fill="#3F37C9"
        />
        <path
            d="M632.7 473.86a1.42 1.42 0 0 0-1.406-.143c-.777.443-.781 1.888-.009 3.226a4.011 4.011 0 0 0 1.4 1.478 1.41 1.41 0 0 0 1.405.143c.777-.443.782-1.888.009-3.226a4.04 4.04 0 0 0-1.399-1.478z"
            fill="#F72585"
        />
        <path
            d="M628.06 471.59a.962.962 0 0 0-.956-.1c-.529.3-.531 1.284-.006 2.194.227.411.555.757.953 1.005a.97.97 0 0 0 .956.1c.529-.3.532-1.284.006-2.194a2.735 2.735 0 0 0-.953-1.005zM623.56 469.1a.608.608 0 0 0-.6-.061c-.333.19-.335.809 0 1.381.142.259.349.477.6.633a.606.606 0 0 0 .6.061c.333-.19.335-.808 0-1.381a1.735 1.735 0 0 0-.6-.633zM646.56 483.1a.608.608 0 0 0-.6-.061c-.333.19-.335.809 0 1.381.142.259.349.477.6.633a.606.606 0 0 0 .6.061c.333-.19.335-.808 0-1.381a1.735 1.735 0 0 0-.6-.633zM643.06 480.33a.962.962 0 0 0-.956-.1c-.529.3-.531 1.284-.006 2.194.227.411.555.757.953 1.005a.96.96 0 0 0 .956.1c.529-.3.532-1.284.006-2.194a2.735 2.735 0 0 0-.953-1.005zM632.7 467.86a1.42 1.42 0 0 0-1.406-.143c-.777.443-.781 1.888-.009 3.226a4.011 4.011 0 0 0 1.4 1.478 1.41 1.41 0 0 0 1.405.143c.777-.443.782-1.888.009-3.226a4.04 4.04 0 0 0-1.399-1.478zM628.06 465.33a.962.962 0 0 0-.956-.1c-.529.3-.531 1.284-.006 2.194.227.411.555.757.953 1.005a.96.96 0 0 0 .956.1c.529-.3.532-1.284.006-2.194a2.735 2.735 0 0 0-.953-1.005zM623.56 462.84a.608.608 0 0 0-.6-.061c-.333.19-.335.809 0 1.381.142.259.349.477.6.633a.606.606 0 0 0 .6.061c.333-.19.335-.808 0-1.381a1.735 1.735 0 0 0-.6-.633zM646.56 476.84a.608.608 0 0 0-.6-.061c-.333.19-.335.809 0 1.381.142.259.349.477.6.633a.606.606 0 0 0 .6.061c.333-.19.335-.808 0-1.381a1.735 1.735 0 0 0-.6-.633zM638.06 461a.608.608 0 0 0-.6-.061c-.333.19-.335.809 0 1.381.142.259.349.477.6.633a.606.606 0 0 0 .6.061c.333-.19.335-.808 0-1.381a1.735 1.735 0 0 0-.6-.633zM638.06 489a.608.608 0 0 0-.6-.061c-.333.19-.335.809 0 1.381.142.259.349.477.6.633a.606.606 0 0 0 .6.061c.333-.19.335-.808 0-1.381a1.735 1.735 0 0 0-.6-.633zM633.06 458a.608.608 0 0 0-.6-.061c-.333.19-.335.809 0 1.381.142.259.349.477.6.633a.606.606 0 0 0 .6.061c.333-.19.335-.808 0-1.381a1.735 1.735 0 0 0-.6-.633zM633.06 486a.608.608 0 0 0-.6-.061c-.333.19-.335.809 0 1.381.142.259.349.477.6.633a.606.606 0 0 0 .6.061c.333-.19.335-.808 0-1.381a1.735 1.735 0 0 0-.6-.633zM628.06 459.33a.962.962 0 0 0-.956-.1c-.529.3-.531 1.284-.006 2.194.227.411.555.757.953 1.005a.96.96 0 0 0 .956.1c.529-.3.532-1.284.006-2.194a2.735 2.735 0 0 0-.953-1.005zM643.06 474.33a.962.962 0 0 0-.956-.1c-.529.3-.531 1.284-.006 2.194.227.411.555.757.953 1.005a.96.96 0 0 0 .956.1c.529-.3.532-1.284.006-2.194a2.735 2.735 0 0 0-.953-1.005zM633.06 462.33a.962.962 0 0 0-.956-.1c-.529.3-.531 1.284-.006 2.194.227.411.555.757.953 1.005a.96.96 0 0 0 .956.1c.529-.3.532-1.284.006-2.194a2.735 2.735 0 0 0-.953-1.005zM643.06 468.33a.962.962 0 0 0-.956-.1c-.529.3-.531 1.284-.006 2.194.227.411.555.757.953 1.005a.96.96 0 0 0 .956.1c.529-.3.532-1.284.006-2.194a2.735 2.735 0 0 0-.953-1.005zM633.06 480.77a.962.962 0 0 0-.956-.1c-.529.3-.531 1.284-.006 2.194.227.411.555.757.953 1.005a.97.97 0 0 0 .956.1c.529-.3.532-1.284.006-2.194a2.735 2.735 0 0 0-.953-1.005zM628.06 478.33a.962.962 0 0 0-.956-.1c-.529.3-.531 1.284-.006 2.194.227.411.555.757.953 1.005a.96.96 0 0 0 .956.1c.529-.3.532-1.284.006-2.194a2.735 2.735 0 0 0-.953-1.005zM643.06 486.33a.962.962 0 0 0-.956-.1c-.529.3-.531 1.284-.006 2.194.227.411.555.757.953 1.005a.96.96 0 0 0 .956.1c.529-.3.532-1.284.006-2.194a2.735 2.735 0 0 0-.953-1.005zM637.7 476.86a1.42 1.42 0 0 0-1.406-.143c-.777.443-.781 1.888-.009 3.226a4.011 4.011 0 0 0 1.4 1.478 1.41 1.41 0 0 0 1.405.143c.777-.443.782-1.888.009-3.226a4.04 4.04 0 0 0-1.399-1.478z"
            fill="#7209B7"
        />
        <path
            d="M637.7 470.86a1.42 1.42 0 0 0-1.406-.143c-.777.443-.781 1.888-.009 3.226a4.011 4.011 0 0 0 1.4 1.478 1.41 1.41 0 0 0 1.405.143c.777-.443.782-1.888.009-3.226a4.04 4.04 0 0 0-1.399-1.478z"
            fill="#F72585"
        />
        <path
            d="M638.06 465.33a.962.962 0 0 0-.956-.1c-.529.3-.531 1.284-.006 2.194.227.411.555.757.953 1.005a.96.96 0 0 0 .956.1c.529-.3.532-1.284.006-2.194a2.735 2.735 0 0 0-.953-1.005zM638.06 483.77a.962.962 0 0 0-.956-.1c-.529.3-.531 1.284-.006 2.194.227.411.555.757.953 1.005a.97.97 0 0 0 .956.1c.529-.3.532-1.284.006-2.194a2.735 2.735 0 0 0-.953-1.005z"
            fill="#7209B7"
        />
        <path
            d="m670 503.64 1.915-1.113-2.242-3.883-1.915 1.113L670 503.64z"
            fill="#D7E7F7"
        />
        <path
            d="M667.76 499.76a4.66 4.66 0 0 1-2.39 1.362l2.242 3.883 2.391-1.362-2.243-3.883z"
            fill="#F8F9FC"
        />
        <path
            d="m671.15 502.99-1.143.651-2.39 1.362-1.143.651 8.213 14.219 4.67-2.668-8.207-14.215z"
            fill="#F72585"
        />
        <path
            d="m679.35 517.2 1.915-1.113-8.207-14.216-1.915 1.113 8.207 14.216zM666.72 500.6l1.915-1.113a4.681 4.681 0 0 0 1.053-.838c2.6-2.77 2.258-8.894-1.048-14.615a22.792 22.792 0 0 0-2.091-3.037l-1.919 1.112c.778.954 1.477 1.97 2.091 3.037 3.306 5.721 3.652 11.844 1.047 14.615a4.605 4.605 0 0 1-1.052.838l.004.001zM664.62 482.1l1.915-1.113a17.382 17.382 0 0 0-4.633-4.059 9.997 9.997 0 0 0-2.907-1.158l-1.915 1.113c1.023.231 2.004.622 2.906 1.158a17.401 17.401 0 0 1 4.634 4.059z"
            fill="#B5179E"
        />
        <path
            d="m657.08 476.89 1.915-1.113a5.372 5.372 0 0 0-3.836.479l-1.915 1.114a5.367 5.367 0 0 1 3.836-.48z"
            fill="#B5179E"
        />
        <path
            d="M659.99 478.05a19.345 19.345 0 0 1 6.725 7.1c3.306 5.721 3.652 11.844 1.047 14.615a4.66 4.66 0 0 1-2.39 1.362 7.742 7.742 0 0 1-5.444-1.18 19.354 19.354 0 0 1-6.725-7.1c-3.706-6.419-3.686-13.349.044-15.474 1.867-1.068 4.307-.731 6.743.677zm-5.179 13.88a14.734 14.734 0 0 0 5.125 5.4c1.857 1.073 3.717 1.331 5.138.522 2.843-1.62 2.858-6.9.034-11.794a14.75 14.75 0 0 0-5.125-5.4c-1.857-1.073-3.717-1.332-5.139-.522-2.842 1.62-2.857 6.9-.033 11.794z"
            fill="#F72585"
        />
        <path
            d="M659.98 480.65c-1.857-1.073-3.717-1.332-5.139-.522-2.842 1.62-2.857 6.9-.033 11.794a14.726 14.726 0 0 0 5.125 5.4c1.857 1.073 3.717 1.331 5.138.522 2.843-1.62 2.858-6.9.034-11.794a14.757 14.757 0 0 0-5.125-5.4z"
            fill="#4CC9F0"
        />
        <path
            d="M1056 369.63c-.69.689-1.55 1.33-2.54 1.905l-124.65 71.88c-3.102 1.788-7.246 2.773-11.671 2.773s-8.57-.985-11.671-2.773l-124.65-71.88c-2.632-1.518-4.23-3.48-4.499-5.526-.223-1.685.454-3.37 1.958-4.873.689-.689 1.544-1.33 2.541-1.905l124.65-71.88c3.101-1.788 7.246-2.773 11.671-2.773s8.569.985 11.671 2.773l124.65 71.88c2.63 1.518 4.23 3.48 4.5 5.525.22 1.685-.46 3.37-1.96 4.874z"
            fill="#282739"
        />
        <path
            d="M778.94 361.84c-.889.889-1.901 2.311-1.673 4.036.228 1.73 1.651 3.431 4.007 4.789l124.65 71.88c2.952 1.702 6.919 2.64 11.171 2.64 4.253 0 8.22-.937 11.172-2.64l124.65-71.88c.92-.531 1.7-1.118 2.33-1.746.89-.889 1.9-2.311 1.67-4.035-.22-1.73-1.65-3.431-4-4.79l-124.65-71.88c-2.952-1.702-6.919-2.639-11.172-2.639-4.252 0-8.219.937-11.171 2.639l-124.65 71.88c-.921.532-1.706 1.119-2.334 1.746zm-1.414-1.414c.738-.738 1.654-1.433 2.749-2.064l124.65-71.88c6.722-3.876 17.619-3.876 24.341 0l124.66 71.88c6.72 3.876 6.72 10.16 0 14.036l-124.66 71.88c-6.722 3.876-17.619 3.876-24.341 0l-124.65-71.88c-5.627-3.245-6.543-8.178-2.749-11.972z"
            fill="#DEDDE2"
        />
        <path
            d="M1056 369.63c-.69.689-1.55 1.33-2.54 1.905l-124.65 71.88c-3.101 1.788-7.246 2.773-11.671 2.773s-8.57-.985-11.671-2.773l-181.38-104.9c-2.632-1.518-4.23-3.48-4.5-5.526-.222-1.685.455-3.37 1.958-4.873.689-.689 1.544-1.33 2.541-1.905l124.65-71.88c3.102-1.788 7.246-2.773 11.671-2.773s8.57.985 11.671 2.773l181.38 104.9c2.63 1.518 4.23 3.48 4.5 5.525.22 1.685-.46 3.371-1.96 4.874z"
            fill="#282739"
        />
        <path
            d="M722.21 328.82c-.889.889-1.901 2.311-1.674 4.036.228 1.73 1.651 3.431 4.01 4.791l181.37 104.9c2.952 1.702 6.919 2.639 11.172 2.639 4.252 0 8.219-.937 11.171-2.639l124.65-71.88c.92-.532 1.7-1.119 2.33-1.746.89-.889 1.9-2.311 1.67-4.036-.22-1.73-1.65-3.431-4.01-4.791l-181.37-104.9c-2.952-1.702-6.919-2.639-11.171-2.639s-8.22.937-11.172 2.639l-124.65 71.88c-.922.532-1.707 1.119-2.334 1.746zm-1.414-1.414c.738-.738 1.654-1.433 2.748-2.064l124.65-71.88c6.722-3.876 17.62-3.876 24.341 0l181.38 104.9c6.72 3.876 6.72 10.16 0 14.036l-124.66 71.88c-6.722 3.876-17.619 3.876-24.341 0l-181.38-104.9c-5.627-3.245-6.543-8.178-2.748-11.972z"
            fill="#DEDDE2"
        />
        <path
            d="M834.76 315.51c-4.774.592-3.109 1.158-3.109 2.243 0 1.532-2.481 2.217-5.494 2.217-5.375 0-7.985-2.291-7.985-4.259s3.318-3.926 8.7-3.926c5.665 0 9.222.653 10.115 1.949.651.961-1.324 1.664-2.227 1.776z"
            fill="#231F20"
            opacity={0.29}
            style={{ mixBlendMode: "multiply" }}
        />
        <path
            d="M779.07 335.24a3.006 3.006 0 0 1-3.131.028l-3.106-1.941c-.56-.443-.6-1.065.168-1.573l39.424-22.306c2.108-1.2 3.526-1.952 5.2-1.02l2.749 1.77c.884.54.738 1.179-.048 1.67L779.07 335.24z"
            fill="#231F20"
            opacity={0.21}
            style={{ mixBlendMode: "multiply" }}
        />
        <path
            d="M908.69 390.49a.814.814 0 0 1 .01 1.539l-12.737 7.4a2.93 2.93 0 0 1-2.654 0l-12.986-7.5a.811.811 0 0 1-.406-1.238.808.808 0 0 1 .398-.297l12.734-7.4a2.93 2.93 0 0 1 2.656 0l12.985 7.496zM875.25 374.1a.813.813 0 0 1 .01 1.539l-12.737 7.4a2.93 2.93 0 0 1-2.656 0l-12.984-7.5a.814.814 0 0 1-.008-1.538l12.736-7.4a2.917 2.917 0 0 1 2.654 0l12.985 7.499zM856.24 352.69a.811.811 0 0 1 .009 1.538l-12.736 7.4a2.929 2.929 0 0 1-2.654 0l-12.985-7.5a.812.812 0 0 1-.009-1.537l12.736-7.4a2.914 2.914 0 0 1 2.654 0l12.985 7.499z"
            fill="#000"
            opacity={0.22}
        />
        <path
            d="m781.63 331.7-.005.954a1.792 1.792 0 0 1-1.044 1.459 5.58 5.58 0 0 1-5.082 0 1.81 1.81 0 0 1-1.06-1.482v-.953a1.791 1.791 0 0 0 1.062 1.481 5.606 5.606 0 0 0 5.079 0 1.779 1.779 0 0 0 1.045-1.459h.005z"
            fill="#2D3E50"
        />
        <path
            d="M780.57 330.21c1.41.814 1.414 2.13.015 2.942a5.598 5.598 0 0 1-5.079 0c-1.407-.812-1.417-2.128-.017-2.942a5.597 5.597 0 0 1 5.081 0z"
            fill="#23303E"
        />
        <path
            d="m815.28 311.69-.007.954a1.78 1.78 0 0 1-1.042 1.462 5.597 5.597 0 0 1-5.081 0 1.802 1.802 0 0 1-1.061-1.48v-.957a1.802 1.802 0 0 0 1.063 1.483 5.604 5.604 0 0 0 5.079 0 1.803 1.803 0 0 0 1.045-1.462h.004z"
            fill="#2D3E50"
        />
        <path
            d="M814.22 310.21c1.406.812 1.414 2.128.016 2.943a5.601 5.601 0 0 1-5.079 0c-1.409-.815-1.418-2.131-.019-2.943a5.598 5.598 0 0 1 5.082 0z"
            fill="#23303E"
        />
        <path
            d="m779.37 296.23-.034 35.025a.64.64 0 0 1-.383.536 2.036 2.036 0 0 1-1.856 0 .664.664 0 0 1-.391-.542l.035-35.028a.655.655 0 0 0 .388.543 2.046 2.046 0 0 0 1.86 0 .648.648 0 0 0 .381-.534z"
            fill="#2D3E50"
        />
        <path
            d="M778.98 306.67a.57.57 0 0 1 .279.872.57.57 0 0 1-.279.209 2.084 2.084 0 0 1-1.86 0 .574.574 0 0 1-.286-.871.57.57 0 0 1 .278-.21 2.066 2.066 0 0 1 1.868 0z"
            fill="#273545"
        />
        <path
            d="m812.99 276.34-.035 35.026a.65.65 0 0 1-.382.534 2.028 2.028 0 0 1-1.859 0 .659.659 0 0 1-.388-.541l.033-35.025a.652.652 0 0 0 .387.541 2.047 2.047 0 0 0 1.861 0 .646.646 0 0 0 .383-.535z"
            fill="#2D3E50"
        />
        <path
            d="M812.6 286.79a.576.576 0 0 1 .278.208.579.579 0 0 1 0 .663.584.584 0 0 1-.278.209 2.062 2.062 0 0 1-1.861 0 .57.57 0 0 1 0-1.08 2.058 2.058 0 0 1 1.861 0z"
            fill="#273545"
        />
        <path
            d="m815.26 285.91-1.158-.673a.51.51 0 0 1 .512-.048l1.158.671a.506.506 0 0 0-.512.05z"
            fill="#2D3E50"
        />
        <path
            d="m775.38 308.93-1.154-.669 39.87-23.022 1.158.673-39.874 23.018z"
            fill="#273545"
        />
        <path
            d="m774.88 310.63-1.156-.669a.516.516 0 0 1-.209-.465 1.58 1.58 0 0 1 .211-.706c.124-.216.298-.4.507-.536l1.154.669a1.6 1.6 0 0 0-.715 1.244.503.503 0 0 0 .208.463z"
            fill="#2D3E50"
        />
        <path
            d="M815.26 285.91c.4-.23.719-.045.721.41a1.581 1.581 0 0 1-.715 1.244l-39.873 23.02c-.4.231-.72.047-.722-.413a1.6 1.6 0 0 1 .715-1.244l39.874-23.017z"
            fill="#23303E"
        />
        <path
            d="m800.05 283.76-.578-.336a.84.84 0 0 0 .855-.085 2.656 2.656 0 0 0 1.206-2.085c0-.123-.017-.246-.051-.364l.579.337c.033.119.05.242.051.365a2.653 2.653 0 0 1-1.206 2.083.842.842 0 0 1-.856.085z"
            fill="#F3D541"
        />
        <path
            d="m800.97 283.24-.579-.337.04.016.577.335-.038-.014z"
            fill="#993228"
        />
        <path
            d="m800.94 283.29-.58-.336.029-.053.579.337-.028.052z"
            fill="#A9372C"
        />
        <path
            d="m801.01 283.25-.577-.335.927-1.709.58.335-.93 1.709z"
            fill="#A9382D"
        />
        <path d="m801.9 281.53-.577-.336.04.017.58.335-.043-.016z" fill="#993228" />
        <path d="m801.9 281.53-.577-.336.161-.3.579.337-.163.299z" fill="#A9372C" />
        <path d="m800.94 283.29-.234-.159.263.108-.029.051z" fill="#B33B2F" />
        <path
            d="m800.94 283.29-.58-.336-.234-.159.58.336.234.159z"
            fill="#74261F"
        />
        <path
            d="m800.71 283.13-.58-.336.264.106.579.337-.263-.107z"
            fill="#993228"
        />
        <path
            d="m808.66 269.16-.579-.336a2.657 2.657 0 0 0 1.2-2.08.848.848 0 0 0-.352-.778l.577.336a.845.845 0 0 1 .352.776 2.653 2.653 0 0 1-1.2 2.082h.002z"
            fill="#F3D541"
        />
        <path
            d="m808.57 269.2-.579-.335.088-.047.579.336a.813.813 0 0 1-.088.046z"
            fill="#F3D541"
        />
        <path
            d="m802.06 281.23-.579-.337 6.512-12.024.578.335-6.511 12.026z"
            fill="#B19B2F"
        />
        <path
            d="m808.57 269.2-.578-.335.643-1.187.58.336-.645 1.186z"
            fill="#A9372D"
        />
        <path
            d="m808.66 269.16-.579-.336a2.657 2.657 0 0 0 1.2-2.08.848.848 0 0 0-.352-.778l.577.336a.845.845 0 0 1 .352.776 2.653 2.653 0 0 1-1.2 2.082h.002z"
            fill="#F3D541"
        />
        <path
            d="m800.85 281.11-.578-.334 1.053.415.577.336-1.052-.417z"
            fill="#993228"
        />
        <path
            d="m800.85 281.11-.578-.334.139-.254.577.333-.138.255z"
            fill="#A9372D"
        />
        <path
            d="m800.05 283.76-.578-.336a.847.847 0 0 1-.352-.777 1.544 1.544 0 0 1 .016-.245l.577.336a1.852 1.852 0 0 0-.017.247.856.856 0 0 0 .354.775z"
            fill="#E84C3D"
        />
        <path
            d="M802.06 281.23c.034.119.051.242.051.365a2.651 2.651 0 0 1-1.206 2.083c-.664.384-1.208.079-1.21-.69.001-.083.006-.165.017-.247l1 .391.235.16.028-.052.038.013.93-1.708-.043-.016.16-.299z"
            fill="#E24139"
        />
        <path
            d="m799.71 282.74-.572-.336.994.392.58.336-1.002-.392zM800.68 281.05l-.578-.337.161.064.578.334-.161-.061z"
            fill="#993228"
        />
        <path
            d="m800.98 280.85-.138.255-.161-.062c.069-.052.14-.1.214-.145.028-.017.056-.03.085-.048z"
            fill="#E24139"
        />
        <path
            d="m800.68 281.05-.578-.337c.068-.052.138-.099.211-.142.031-.017.059-.033.089-.047l.577.333c-.029.018-.057.031-.085.048a2.592 2.592 0 0 0-.214.145z"
            fill="#E84C3D"
        />
        <path
            d="m800.98 280.85-.577-.333 6.512-12.024.577.335-6.512 12.022z"
            fill="#A9372D"
        />
        <path
            d="m809.22 268.02-.58-.336-.932-.636.577.336.935.636z"
            fill="#74261F"
        />
        <path
            d="m808.28 267.38.935.636-.645 1.186-6.511 12.026-.163.3-1.052-.417.138-.255 6.512-12.022.786-1.454z"
            fill="#E24139"
        />
        <path
            d="m807.5 268.83-.577-.335.786-1.453.577.336-.786 1.452z"
            fill="#A9372D"
        />
        <path
            d="m808.65 266.38-.578-.336a.865.865 0 0 1 .856-.084l.577.336a.848.848 0 0 0-.855.084z"
            fill="#E84C3D"
        />
        <path
            d="M808.65 266.38c.664-.384 1.205-.075 1.207.692a2.644 2.644 0 0 1-1.2 2.082.566.566 0 0 1-.088.046l.644-1.186-.934-.636-.787 1.453a1.335 1.335 0 0 1-.048-.367 2.662 2.662 0 0 1 1.206-2.084z"
            fill="#E24139"
        />
        <path
            d="m807.49 268.83-.577-.335a1.3 1.3 0 0 1-.05-.367 2.655 2.655 0 0 1 1.206-2.085l.578.336a2.65 2.65 0 0 0-1.205 2.084 1.34 1.34 0 0 0 .048.367z"
            fill="#E84C3D"
        />
        <path
            d="m788.05 294.62-.58-.334a.858.858 0 0 0 .86-.083 2.631 2.631 0 0 0 1.2-2.085 1.234 1.234 0 0 0-.045-.358l.578.335c.034.116.05.237.049.359a2.665 2.665 0 0 1-1.2 2.085.853.853 0 0 1-.857.081h-.005z"
            fill="#F3D541"
        />
        <path
            d="m788.91 294.32-.576-.335.928-1.705.575.335-.927 1.705z"
            fill="#A9372D"
        />
        <path
            d="m788.82 294.36-.579-.335-.934-.632.577.335.936.632zM788.87 294.29l-.58-.338-.932-.632.575.336.937.634z"
            fill="#74261F"
        />
        <path
            d="m787.89 293.73-.577-.335.045-.078.575.336-.043.077z"
            fill="#AA382D"
        />
        <path d="m787.93 293.66-.575-.336-.2-.14.578.339.197.137z" fill="#74261F" />
        <path
            d="m788.05 294.62-.58-.334a.843.843 0 0 1-.35-.774 1.66 1.66 0 0 1 .03-.33l.578.339a1.612 1.612 0 0 0-.03.325.84.84 0 0 0 .352.774z"
            fill="#E84C3D"
        />
        <path
            d="M790.06 292.09c.034.117.051.238.049.359a2.649 2.649 0 0 1-.351 1.186 2.647 2.647 0 0 1-.849.899c-.665.382-1.207.074-1.209-.693a1.612 1.612 0 0 1 .03-.325l.2.137-.043.077.936.632.043-.075.04.026.926-1.705-.037-.025.265-.493z"
            fill="#E24139"
        />
        <path
            d="m788.91 294.32-.576-.335-.043-.029.58.338.039.026z"
            fill="#74261F"
        />
        <path
            d="m788.82 294.36.043-.075-.58-.336-.02.035.557.376z"
            fill="#AA382D"
        />
        <path
            d="m789.83 292.61-.575-.335-.038-.026.576.337.037.024z"
            fill="#74261F"
        />
        <path
            d="m789.8 292.59-.576-.337.267-.491.578.335-.269.493z"
            fill="#AA382D"
        />
        <path
            d="m796.25 281.37-.579-.337 3.468 1.367.577.336-3.466-1.366z"
            fill="#A08C2B"
        />
        <path
            d="m797.12 279.64-.577-.336 3.563 1.405.578.337-3.564-1.406z"
            fill="#993228"
        />
        <path
            d="m797.12 279.64-.577-.336v-.106a.832.832 0 0 0-.352-.772l.579.336a.85.85 0 0 1 .351.774v.1l-.001.004zM795.75 281.7l-.58-.336c.06-.023.118-.051.173-.083.12-.07.231-.152.333-.247l.579.337a2.093 2.093 0 0 1-.333.244 1.249 1.249 0 0 1-.172.085z"
            fill="#F3D541"
        />
        <path
            d="m790.07 292.09-.578-.335 5.68-10.394.58.336-5.682 10.393z"
            fill="#B29C30"
        />
        <path
            d="m795.98 281.27-.576-.335.265.1.579.337-.268-.102z"
            fill="#993228"
        />
        <path
            d="m795.75 281.7.238-.434.267.105a2.093 2.093 0 0 1-.333.244 1.195 1.195 0 0 1-.172.085z"
            fill="#E24139"
        />
        <path
            d="m795.75 281.7-.58-.336.241-.433.576.335-.237.434z"
            fill="#AA382D"
        />
        <path
            d="m795.98 281.27-.576-.335.8-1.47.579.339-.803 1.466z"
            fill="#AA382D"
        />
        <path
            d="m797.12 279.64-.577-.336v-.106a.832.832 0 0 0-.352-.772l.579.336a.85.85 0 0 1 .351.774v.1l-.001.004z"
            fill="#F3D541"
        />
        <path
            d="m787.89 293.73.043-.077.936.634-.043.075-.936-.632z"
            fill="#E24139"
        />
        <path
            d="m789.8 292.59-.576-.337-.936-.634.579.336.933.635z"
            fill="#74261F"
        />
        <path
            d="m788.86 291.95-.579-.336.131-.238.577.339-.129.235z"
            fill="#AA382D"
        />
        <path
            d="m788.74 291.87-.579-.34c.054-.037.11-.073.163-.106l.09-.048.577.339a.737.737 0 0 0-.087.048.983.983 0 0 0-.164.107z"
            fill="#E84C3D"
        />
        <path
            d="m788.99 291.72-.128.236-.123-.081a.924.924 0 0 1 .164-.107.737.737 0 0 1 .087-.048z"
            fill="#E24139"
        />
        <path
            d="m788.86 291.95-.579-.336-.122-.085.579.34.122.081z"
            fill="#74261F"
        />
        <path
            d="m788.99 291.72-.577-.339 5.745-10.505.577.335-5.745 10.509z"
            fill="#AA382D"
        />
        <path
            d="m796.79 279.8-.579-.339-.923-.622.579.338.923.623z"
            fill="#74261F"
        />
        <path
            d="m795.88 279.15 1.242.488 3.564 1.406.161.062 1.052.417.043.016-.93 1.709-.12.216-.181-.337-1-.392-3.461-1.366-.268-.1.8-1.466-.923-.623.021-.03z"
            fill="#E24139"
        />
        <path
            d="m795.88 279.15-.576-.338 1.241.49.577.336-1.242-.488z"
            fill="#993228"
        />
        <path
            d="m794.74 281.21-.577-.335 1.116-2.042.576.337-1.115 2.04z"
            fill="#AA382D"
        />
        <path
            d="m795.85 279.17.937.635-.8 1.466-.237.434-5.682 10.393-.269.493-.933-.635.129-.235 5.744-10.51 1.111-2.041z"
            fill="#E24139"
        />
        <path
            d="m795.87 279.18-.579-.338-.011-.011.576.337.014.012z"
            fill="#74261F"
        />
        <path
            d="m795.91 278.85-.579-.339a.852.852 0 0 1 .862-.083l.579.336a.854.854 0 0 0-.862.086z"
            fill="#E84C3D"
        />
        <path
            d="M795.91 278.85c.667-.387 1.211-.081 1.213.688v.1l-1.242-.488-.012.025-.014-.011-1.115 2.04a1.318 1.318 0 0 1-.029-.28 2.645 2.645 0 0 1 1.199-2.074z"
            fill="#E24139"
        />
        <path
            d="m794.74 281.21-.578-.335a1.301 1.301 0 0 1-.028-.279 2.649 2.649 0 0 1 1.2-2.083l.579.339a2.647 2.647 0 0 0-1.2 2.078c0 .094.009.188.029.28h-.002z"
            fill="#E84C3D"
        />
        <path
            d="m788.74 291.87-.579-.34-1.766-1.2.578.334 1.767 1.206z"
            fill="#7A6B21"
        />
        <path
            d="m787.73 293.52-.578-.339-1.812-1.228.576.334 1.814 1.233z"
            fill="#74261F"
        />
        <path
            d="m786.98 290.67-.578-.334c.027-.131.041-.265.042-.4a.844.844 0 0 0-.352-.776l.576.335a.867.867 0 0 1 .281.34.867.867 0 0 1 .074.435 2.095 2.095 0 0 1-.043.395v.005z"
            fill="#F3D541"
        />
        <path
            d="m785.76 292.18-.578-.336.717-1.193.576.336-.715 1.193z"
            fill="#AE392E"
        />
        <path
            d="m785.92 292.29-.576-.334-.16-.108.578.336.158.106z"
            fill="#74261F"
        />
        <path
            d="m785.6 292.46-.578-.335a1.812 1.812 0 0 0 .317-.17l.576.334a1.688 1.688 0 0 1-.1.065c-.071.04-.144.075-.219.106h.004z"
            fill="#F3D541"
        />
        <path
            d="m785.6 292.46-.578-.335.162-.278.578.336-.162.277z"
            fill="#AE392E"
        />
        <path
            d="m778.45 303.28-.578-.336a.848.848 0 0 0 .86-.082 2.654 2.654 0 0 0 1.2-2.079.908.908 0 0 0-.01-.147l.58.335c0 .046.006.1.006.146a2.637 2.637 0 0 1-.351 1.183 2.629 2.629 0 0 1-.849.896.837.837 0 0 1-.861.084h.003z"
            fill="#F3D541"
        />
        <path
            d="m778.45 303.28-.578-.336a.848.848 0 0 0 .86-.082 2.654 2.654 0 0 0 1.2-2.079.908.908 0 0 0-.01-.147l.58.335c0 .046.006.1.006.146a2.637 2.637 0 0 1-.351 1.183 2.629 2.629 0 0 1-.849.896.837.837 0 0 1-.861.084h.003z"
            fill="#F3D541"
        />
        <path
            d="m780.5 300.97-.58-.335 5.094-8.516.578.335-5.092 8.516z"
            fill="#B69F31"
        />
        <path
            d="m779.64 302.41-.58-.336.859-1.436.58.335-.859 1.437z"
            fill="#AE392E"
        />
        <path
            d="m786.98 290.67-.578-.334c.027-.131.041-.265.042-.4a.844.844 0 0 0-.352-.776l.576.335a.867.867 0 0 1 .281.34.867.867 0 0 1 .074.435 2.095 2.095 0 0 1-.043.395v.005zM778.45 303.28l-.578-.336a.848.848 0 0 0 .86-.082 2.654 2.654 0 0 0 1.2-2.079.908.908 0 0 0-.01-.147l.58.335c0 .046.006.1.006.146a2.637 2.637 0 0 1-.351 1.183 2.629 2.629 0 0 1-.849.896.837.837 0 0 1-.861.084h.003z"
            fill="#F3D541"
        />
        <path
            d="m785.73 290.64-.576-.334.742.35.576.336-.742-.352z"
            fill="#953127"
        />
        <path
            d="m786.98 290.67-.578-.334-.922-.626.579.338.921.622z"
            fill="#74261F"
        />
        <path
            d="m786.05 290.04.921.622 1.767 1.2.122.081.933.635.037.024-.927 1.705-.039-.026-.936-.634-.2-.137-1.814-1.232-.158-.107.715-1.193-.742-.352.321-.586z"
            fill="#E24139"
        />
        <path
            d="m785.73 290.64-.576-.334.32-.595.579.338-.323.591z"
            fill="#A9382D"
        />
        <path
            d="m785.45 290.5-.581-.334.282.133.576.334-.277-.133z"
            fill="#953127"
        />
        <path
            d="m784.62 291.89-.578-.337.827-1.384.581.334-.83 1.387z"
            fill="#AE392E"
        />
        <path
            d="m779.6 300.3-.581-.335 5.03-8.414.578.337-5.027 8.412z"
            fill="#AE392E"
        />
        <path
            d="m785.8 289.58-.576-.333a.842.842 0 0 1 .858-.086l.576.335a.857.857 0 0 0-.858.084z"
            fill="#E84C3D"
        />
        <path
            d="m778.62 301.93-.578-.333 1.02.48.58.336-1.022-.483z"
            fill="#953127"
        />
        <path
            d="m778.62 301.93-.578-.333.97-1.627.581.335-.973 1.625z"
            fill="#AE392E"
        />
        <path
            d="m779.3 300.43-.575-.339c.091-.051.188-.093.289-.124l.581.335a1.38 1.38 0 0 0-.295.128z"
            fill="#E84C3D"
        />
        <path
            d="M785.8 289.58c.668-.382 1.208-.076 1.213.691a2.016 2.016 0 0 1-.043.395l-.921-.623-.323.591-.278-.133-.83 1.387a1.661 1.661 0 0 1-.017-.223 2.65 2.65 0 0 1 1.199-2.085z"
            fill="#E24139"
        />
        <path
            d="m784.62 291.89-.578-.337a1.373 1.373 0 0 1-.015-.222 2.638 2.638 0 0 1 1.2-2.082l.576.333a2.647 2.647 0 0 0-1.2 2.085c.001.075.006.149.017.223zM778.45 303.28l-.578-.336a.843.843 0 0 1-.351-.771 2.656 2.656 0 0 1 1.2-2.085l.575.339a2.653 2.653 0 0 0-1.2 2.082.826.826 0 0 0 .071.433.829.829 0 0 0 .28.338h.003z"
            fill="#E84C3D"
        />
        <path
            d="M779.3 300.43a1.38 1.38 0 0 1 .295-.128l-.973 1.625 1.022.484.859-1.437c0 .046.006.1.006.146a2.657 2.657 0 0 1-1.2 2.079c-.666.387-1.21.08-1.212-.687a2.649 2.649 0 0 1 1.203-2.082z"
            fill="#E24139"
        />
        <path
            d="m775.31 280.42 38.468-22.207.077 27.816-38.466 22.208-.079-27.817z"
            fill="#DEDDE2"
        />
        <path
            d="m775.39 308.23-.577-.335-.079-27.818.577.336.079 27.817z"
            fill="#ADABB9"
        />
        <path
            d="m775.31 280.42-.577-.336 38.465-22.207.58.337-38.468 22.206z"
            fill="#D1B738"
        />
        <path
            d="m814.66 257.84-1.155-.674a.504.504 0 0 1 .51-.047l1.157.672a.497.497 0 0 0-.512.049z"
            fill="#2D3E50"
        />
        <path
            d="m774.79 280.86-1.158-.672 39.873-23.021 1.155.675-39.87 23.018z"
            fill="#273545"
        />
        <path
            d="m774.28 282.56-1.157-.673a.497.497 0 0 1-.209-.46 1.59 1.59 0 0 1 .717-1.244l1.158.672a1.576 1.576 0 0 0-.719 1.245.49.49 0 0 0 .21.46z"
            fill="#2D3E50"
        />
        <path
            d="M814.66 257.84c.4-.231.721-.046.721.412a1.585 1.585 0 0 1-.715 1.242l-39.872 23.022c-.4.229-.722.043-.723-.412a1.582 1.582 0 0 1 .719-1.245l39.87-23.019z"
            fill="#23303E"
        />
        <path
            d="M888.44 393.91a1.947 1.947 0 0 0-.885 1.535c0 .563.4.789.889.507a1.954 1.954 0 0 0 .886-1.536c0-.564-.4-.79-.89-.506zm0 1.636c-.3.174-.539.035-.539-.3a1.183 1.183 0 0 1 .535-.929c.3-.171.537-.035.538.308a1.18 1.18 0 0 1-.528.921h-.006z"
            fill="#3B3B3B"
        />
        <path
            d="M888.44 394.32c.3-.171.537-.035.538.308a1.173 1.173 0 0 1-.534.924c-.3.174-.539.035-.539-.3a1.177 1.177 0 0 1 .535-.932z"
            fill="#747474"
        />
        <path
            d="M888.33 393.42a.623.623 0 0 0-.63.061 1.945 1.945 0 0 0-.885 1.53.627.627 0 0 0 .259.574l.741.429a.608.608 0 0 1-.258-.568 1.936 1.936 0 0 1 .885-1.535.63.63 0 0 1 .631-.061l-.743-.43z"
            fill="#4C4C4C"
        />
        <path
            d="M901.41 386.43a1.95 1.95 0 0 0-.885 1.534c0 .564.4.788.89.506a1.957 1.957 0 0 0 .885-1.531c-.002-.565-.402-.791-.89-.509zm0 1.637c-.3.17-.537.034-.537-.3a1.176 1.176 0 0 1 .535-.93c.3-.169.538-.034.538.309-.01.185-.064.364-.157.524-.092.16-.221.296-.377.397h-.002z"
            fill="#3B3B3B"
        />
        <path
            d="M901.41 386.83c.3-.169.538-.034.538.309a1.179 1.179 0 0 1-.536.925c-.3.17-.537.034-.537-.3a1.17 1.17 0 0 1 .535-.934z"
            fill="#747474"
        />
        <path
            d="M901.3 385.94a.63.63 0 0 0-.634.063 1.942 1.942 0 0 0-.882 1.534.62.62 0 0 0 .256.567l.74.429a.615.615 0 0 1-.258-.568 1.947 1.947 0 0 1 .886-1.534.607.607 0 0 1 .629-.06l-.737-.431z"
            fill="#4C4C4C"
        />
        <path
            d="M900.85 393.73a.633.633 0 0 0-.634-.06c-.059.036-.123.072-.185.107-.086.052-.172.1-.258.15l-.294.174a.609.609 0 0 1 .63.061c.11.064.211.142.301.231l-.301.174a1.177 1.177 0 0 1 .535.926.371.371 0 0 1-.157.344l.5-.29a.925.925 0 0 1 .01.149.617.617 0 0 1-.256.57l.739-.43a.628.628 0 0 0 .26-.57 1.969 1.969 0 0 0-.89-1.536z"
            fill="#3B3B3B"
        />
        <path
            d="m899.72 394.53.742-.431a.376.376 0 0 0-.158.344 1.197 1.197 0 0 0 .537.928l-.742.429a1.174 1.174 0 0 1-.534-.926.378.378 0 0 1 .155-.344z"
            fill="#4C4C4C"
        />
        <path
            d="M900.11 394.16c-.492-.283-.889-.055-.893.508a1.943 1.943 0 0 0 .886 1.534c.491.283.89.057.892-.508a1.946 1.946 0 0 0-.885-1.534zm0 1.638a1.164 1.164 0 0 1-.378-.399 1.165 1.165 0 0 1-.156-.527c0-.34.243-.48.537-.307a1.169 1.169 0 0 1 .534.926c-.005.34-.246.483-.542.307h.005z"
            fill="#4C4C4C"
        />
        <path
            d="M900.11 394.56c-.294-.173-.537-.033-.537.307a1.178 1.178 0 0 0 .534.926c.3.171.537.033.537-.307a1.164 1.164 0 0 0-.534-.926z"
            fill="#7B7B7B"
        />
        <path
            d="M887.89 386.24a.632.632 0 0 0-.632-.064c-.062.037-.123.075-.184.109-.087.049-.175.1-.26.15l-.3.174a.627.627 0 0 1 .634.062c.11.064.211.142.3.233l-.3.171c.155.102.284.238.377.399.092.161.145.341.155.526a.373.373 0 0 1-.157.345l.5-.286c.007.049.012.097.014.146a.624.624 0 0 1-.26.568l.74-.428a.628.628 0 0 0 .259-.571 1.95 1.95 0 0 0-.886-1.534z"
            fill="#3B3B3B"
        />
        <path
            d="M887.15 386.67c-.491-.285-.893-.056-.894.507a1.957 1.957 0 0 0 .886 1.534c.492.285.892.056.9-.507a1.953 1.953 0 0 0-.892-1.534zm0 1.638a1.18 1.18 0 0 1-.535-.929c0-.341.242-.476.539-.3a1.176 1.176 0 0 1 .532.925c-.005.336-.246.477-.541.306l.005-.002z"
            fill="#4C4C4C"
        />
        <path
            d="M887.15 387.08c-.3-.171-.537-.036-.539.3a1.191 1.191 0 0 0 .535.929c.294.171.535.03.536-.309a1.17 1.17 0 0 0-.532-.92z"
            fill="#7B7B7B"
        />
        <path
            d="m901.38 385.22-6.076 3.53v1.174l6.075-3.529a.439.439 0 0 0 .257-.361v-1.172a.436.436 0 0 1-.256.358z"
            fill="#303030"
        />
        <path
            d="M886.69 385.22a.442.442 0 0 1-.26-.363v1.171a.435.435 0 0 0 .261.367l6.116 3.531v-1.176l-6.117-3.53z"
            fill="#3E3E3E"
        />
        <path
            d="M901.38 384.5a1.375 1.375 0 0 0-1.249 0l-6.076 3.53.005.246 6.519-3.788a.398.398 0 0 1 .36 0c.021.007.04.021.053.04.013.018.02.04.02.063s-.007.045-.02.063a.105.105 0 0 1-.053.04l-6.52 3.791.888.267 6.076-3.53a.383.383 0 0 0 .257-.362.38.38 0 0 0-.26-.36z"
            fill="#414141"
        />
        <path
            d="M887.14 384.49a.399.399 0 0 1 .359 0l6.561 3.786-.005-.246-6.116-3.531a1.375 1.375 0 0 0-1.251 0 .384.384 0 0 0-.259.361.381.381 0 0 0 .259.361l6.117 3.53.893-.267-6.558-3.788c-.1-.057-.1-.148 0-.206z"
            fill="#494949"
        />
        <path
            d="M900.94 384.49a.107.107 0 0 1 .074.103.107.107 0 0 1-.074.103l-6.52 3.791 6.562 3.789a.107.107 0 0 1 .074.103.107.107 0 0 1-.074.103.387.387 0 0 1-.358 0l-6.562-3.79-6.521 3.79a.401.401 0 0 1-.361 0c-.1-.057-.1-.149 0-.206l6.521-3.791-6.561-3.789c-.1-.057-.1-.148 0-.206a.404.404 0 0 1 .359 0l6.561 3.786 6.519-3.788a.407.407 0 0 1 .361.002z"
            fill="#303030"
        />
        <path
            d="M901.43 393a1.35 1.35 0 0 1-1.247 0l-6.119-3.53v1.173l6.119 3.535a1.39 1.39 0 0 0 1.247 0 .449.449 0 0 0 .257-.361l.005-1.174a.44.44 0 0 1-.262.357z"
            fill="#3E3E3E"
        />
        <path
            d="m901.43 392.28-6.12-3.534-.888-.267 6.564 3.789c.021.007.04.021.053.04.013.018.02.04.02.063s-.007.045-.02.063a.11.11 0 0 1-.053.04.401.401 0 0 1-.358 0l-6.563-3.79v.785l6.119 3.53a1.356 1.356 0 0 0 1.247 0 .378.378 0 0 0 .254-.36.383.383 0 0 0-.255-.359zM894.06 388.69l-6.521 3.79a.398.398 0 0 1-.361 0c-.1-.057-.1-.149 0-.206l6.521-3.791-.893.267-6.077 3.534a.387.387 0 0 0-.188.138.386.386 0 0 0 0 .445.387.387 0 0 0 .188.138 1.36 1.36 0 0 0 1.249 0l6.077-3.53.005-.785z"
            fill="#4C4C4C"
        />
        <path
            d="M887.99 393a1.36 1.36 0 0 1-1.249 0 .437.437 0 0 1-.26-.359v1.173a.435.435 0 0 0 .258.364 1.379 1.379 0 0 0 1.248 0l6.079-3.533v-1.173L887.99 393zM895.16 385.59a.547.547 0 0 0-.311-.444 1.701 1.701 0 0 0-1.553-.013.547.547 0 0 0-.331.453l-.013 3.062a.287.287 0 0 0 .014.066.684.684 0 0 0 .008.051c.009.025.02.049.033.072.01.015.014.03.024.044a.62.62 0 0 0 .065.079.317.317 0 0 1 .03.034c.043.038.09.072.139.1a1.722 1.722 0 0 0 1.551.015.62.62 0 0 0 .144-.1.21.21 0 0 0 .036-.031.434.434 0 0 0 .098-.124c.009-.023.025-.048.032-.071a.707.707 0 0 0 .024-.123c.005-.926.005-2.149.01-3.07z"
            fill="#303030"
        />
        <path
            d="M894.46 382.88a.867.867 0 0 0-.789-.007.287.287 0 0 0-.115.092.288.288 0 0 0-.052.138l-.008 2.291a.165.165 0 0 0 .006.032v.028c0 .012.012.02.018.034l.006.017a.24.24 0 0 0 .037.041c.004.009.01.017.017.023.022.02.046.037.071.052a.859.859 0 0 0 .788 0 .3.3 0 0 0 .074-.047l.009-.013a.305.305 0 0 0 .044-.044.037.037 0 0 0 .008-.018.232.232 0 0 0 .022-.041.136.136 0 0 0 .006-.029c0-.011.006-.023.006-.033V383.107a.277.277 0 0 0-.148-.227z"
            fill="#969696"
        />
        <path
            d="M908.28 388.37c.292.389.721.65 1.2.731.524.109 2.258.324 2.258.324.86.108 1.9.381 2.066 1.225.03.186.04.376.029.564-.108.47-.566.656-1.124.856-.615.215-1.245.388-1.884.519a6.692 6.692 0 0 1-2.558.054 13.833 13.833 0 0 0-1.436-.177c-.456 0-.38.332-.432.761l-1.455.38a2.226 2.226 0 0 1-2.379-1.454l.393-3.2 5.322-.583z"
            fill="#545454"
        />
        <path
            d="M907.35 392.4a11.2 11.2 0 0 0 2.682.113 16.682 16.682 0 0 0 2.854-.768c.493-.175.916-.48.951-.761.011.092.011.185 0 .277-.1.473-.564.66-1.122.858-.616.217-1.246.392-1.885.524a6.794 6.794 0 0 1-2.558.049s-1.173-.167-1.218-.172c-.269-.043-.537.03-.542.079.005-.021.114-.271.838-.199zM905.02 393.04l1.44-.375c-.013.143-.05.474-.065.614l-1.454.379a2.235 2.235 0 0 1-2.381-1.456l.08-.614a2.225 2.225 0 0 0 2.38 1.452z"
            fill="#383736"
        />
        <path
            d="M903.66 385.19a1.078 1.078 0 0 0 .936.916c.505.044 1.236.064 1.236.064.864-.159 1.944-.146 2.145.5.046.124.072.254.075.386-.043.477.125.079-.524.656-.63.48-1.296.909-1.992 1.285a3.19 3.19 0 0 1-1.756.436 4.194 4.194 0 0 0-1-.076c-.431.053-.321.594-.321 1.018l-1.318.546a2.083 2.083 0 0 1-2.4-1.134v-3.392l4.919-1.205z"
            fill="#545454"
        />
        <path
            d="M903.25 389.24a7.489 7.489 0 0 0 1.909-.377 9.99 9.99 0 0 0 2.285-1.2 1.21 1.21 0 0 0 .586-.815c.015.09.024.18.028.271.032.431-.345.669-.658.889a8.192 8.192 0 0 1-1.858 1.052 4.268 4.268 0 0 1-1.647.324s-.589.025-.979.044c-.173.008-.416.112-.416.158.01-.029.063-.33.75-.346zM901.14 390.55l1.306-.54c0 .141.012.287.012.422l-1.318.544a2.092 2.092 0 0 1-2.4-1.132v-.427a2.085 2.085 0 0 0 2.4 1.133z"
            fill="#383736"
        />
        <path
            d="m907.03 371.41 2.99 3.184s-.855 14.363-.965 14.654c-.144.384-.771 1.347-2.989 1.736-1.1.189-3.378-.836-3.423-1.207l.341-10.845 4.046-7.522z"
            fill="#383736"
        />
        <path
            d="m902.64 374.25 2.942 1.593s-.615 11.57-.723 11.857c-.145.385-1.145 1.916-3.9 1.207-1.685-.433-2.557-1.173-2.6-1.542l.387-11.009 3.894-2.106zM888.66 372.08l3.328-1.543 7.037-2.844c1.764-.835 5.591-.963 5.495 2.7l.051 1.3-6.748 3.565s-5.254 2.29-7.522 2.076c-4.052-.385-1.641-5.254-1.641-5.254z"
            fill="#282827"
        />
        <path
            d="m886.74 377.91 7.163-4.121a.675.675 0 0 1 .679-.071l8.066 4.65a.67.67 0 0 0-.682.066l-7.157 4.122a2.11 2.11 0 0 0-.957 1.654.676.676 0 0 0 .279.61c-1.988-1.153-6.076-3.489-8.064-4.644a.669.669 0 0 1-.28-.613 2.107 2.107 0 0 1 .953-1.653z"
            fill="silver"
        />
        <path
            d="M894.81 382.55a2.11 2.11 0 0 0-.957 1.654c0 .606.432.853.959.546l7.161-4.126a2.079 2.079 0 0 0 .954-1.648c0-.61-.43-.854-.96-.548l-7.157 4.122z"
            fill="#ADADAD"
        />
        <path
            d="M835.61 357.94a1.947 1.947 0 0 0-.884 1.534c0 .563.4.787.889.506a1.936 1.936 0 0 0 .886-1.531c-.001-.567-.399-.792-.891-.509zm0 1.64c-.294.167-.538.031-.538-.309a1.205 1.205 0 0 1 .534-.928c.3-.171.539-.035.539.309-.01.186-.063.366-.155.528a1.2 1.2 0 0 1-.376.4h-.004z"
            fill="#3B3B3B"
        />
        <path
            d="M835.61 358.35c.3-.171.539-.035.539.309a1.183 1.183 0 0 1-.535.928c-.294.167-.538.031-.538-.309a1.197 1.197 0 0 1 .534-.928z"
            fill="#747474"
        />
        <path
            d="M835.5 357.45a.627.627 0 0 0-.632.064 1.935 1.935 0 0 0-.882 1.531.626.626 0 0 0 .255.571l.741.43a.619.619 0 0 1-.258-.569 1.936 1.936 0 0 1 .884-1.534.623.623 0 0 1 .631-.064l-.739-.429z"
            fill="#4C4C4C"
        />
        <path
            d="M848.57 350.46a1.96 1.96 0 0 0-.882 1.535c0 .563.4.789.888.505a1.932 1.932 0 0 0 .886-1.531c-.001-.564-.4-.791-.892-.509zm.006 1.637c-.3.172-.539.035-.539-.306a1.179 1.179 0 0 1 .534-.927c.3-.169.539-.033.542.306a1.17 1.17 0 0 1-.537.927z"
            fill="#3B3B3B"
        />
        <path
            d="M848.58 350.86c.3-.169.539-.033.542.306a1.17 1.17 0 0 1-.537.927c-.3.172-.539.035-.539-.306a1.178 1.178 0 0 1 .534-.927z"
            fill="#747474"
        />
        <path
            d="M848.47 349.97a.635.635 0 0 0-.634.063 1.967 1.967 0 0 0-.884 1.533.627.627 0 0 0 .26.57l.738.431a.614.614 0 0 1-.257-.569 1.961 1.961 0 0 1 .882-1.535.63.63 0 0 1 .633-.061l-.738-.432z"
            fill="#4C4C4C"
        />
        <path
            d="M848.02 357.76a.63.63 0 0 0-.633-.061c-.063.035-.123.074-.185.106-.086.051-.173.1-.258.151s-.2.116-.3.173a.626.626 0 0 1 .634.063c.108.063.207.141.294.231l-.3.172a1.196 1.196 0 0 1 .535.927.385.385 0 0 1-.158.346l.5-.29c0 .048.01.1.01.147a.627.627 0 0 1-.258.57l.74-.429a.626.626 0 0 0 .26-.571 1.967 1.967 0 0 0-.881-1.535z"
            fill="#3B3B3B"
        />
        <path
            d="m846.9 358.56.742-.43a.376.376 0 0 0-.156.344 1.18 1.18 0 0 0 .532.929l-.739.429a1.174 1.174 0 0 1-.535-.925.378.378 0 0 1 .156-.347z"
            fill="#4C4C4C"
        />
        <path
            d="M847.28 358.19c-.492-.284-.89-.055-.892.507a1.955 1.955 0 0 0 .885 1.536c.491.28.888.053.891-.51a1.95 1.95 0 0 0-.884-1.533zm-.005 1.637a1.174 1.174 0 0 1-.535-.925c0-.343.241-.479.538-.309a1.193 1.193 0 0 1 .535.927c-.002.34-.241.479-.538.307z"
            fill="#4C4C4C"
        />
        <path
            d="M847.28 358.59c-.3-.17-.538-.034-.538.309a1.178 1.178 0 0 0 .535.925c.3.172.536.033.538-.307a1.179 1.179 0 0 0-.535-.927z"
            fill="#7B7B7B"
        />
        <path
            d="M835.06 350.27a.63.63 0 0 0-.633-.061c-.058.035-.119.072-.183.107l-.26.152c-.087.052-.2.114-.295.171a.624.624 0 0 1 .631.062c.11.063.211.142.3.234l-.3.172a1.17 1.17 0 0 1 .534.925.371.371 0 0 1-.158.345l.5-.289c0 .05.011.1.011.148a.623.623 0 0 1-.259.569l.74-.43a.622.622 0 0 0 .259-.571 1.957 1.957 0 0 0-.887-1.534z"
            fill="#3B3B3B"
        />
        <path
            d="M834.32 350.71c-.489-.287-.889-.057-.891.506a1.965 1.965 0 0 0 .887 1.537c.49.281.892.054.892-.508a1.955 1.955 0 0 0-.888-1.535zm0 1.637a1.18 1.18 0 0 1-.531-.926c0-.34.24-.477.535-.3a1.174 1.174 0 0 1 .534.925c-.004.335-.244.474-.542.301h.004z"
            fill="#4C4C4C"
        />
        <path
            d="M834.31 351.11c-.295-.172-.534-.035-.535.3a1.19 1.19 0 0 0 .531.926c.3.173.538.034.538-.306a1.166 1.166 0 0 0-.534-.92z"
            fill="#7B7B7B"
        />
        <path
            d="m848.56 349.25-6.076 3.533v1.173l6.073-3.531a.434.434 0 0 0 .257-.359v-1.173a.441.441 0 0 1-.078.213.442.442 0 0 1-.176.144z"
            fill="#303030"
        />
        <path
            d="M833.87 349.25a.436.436 0 0 1-.262-.363v1.175a.425.425 0 0 0 .08.217.428.428 0 0 0 .18.146l6.117 3.531v-1.173l-6.115-3.533z"
            fill="#3E3E3E"
        />
        <path
            d="M848.55 348.53a1.368 1.368 0 0 0-1.247 0l-6.076 3.53v.248l6.519-3.788a.394.394 0 0 1 .358 0 .11.11 0 0 1 .073.103.107.107 0 0 1-.02.063.105.105 0 0 1-.053.04l-6.523 3.79.893.268 6.076-3.533a.379.379 0 0 0 .257-.36.383.383 0 0 0-.257-.361z"
            fill="#414141"
        />
        <path
            d="M834.31 348.52a.397.397 0 0 1 .357 0l6.567 3.79v-.248l-6.118-3.531a1.367 1.367 0 0 0-1.249 0 .383.383 0 0 0-.187.582.38.38 0 0 0 .187.139l6.117 3.533.891-.268-6.563-3.79c-.101-.055-.102-.155-.002-.207z"
            fill="#494949"
        />
        <path
            d="M848.11 348.52a.12.12 0 0 1 .054.04.112.112 0 0 1 0 .127.111.111 0 0 1-.054.039l-6.523 3.79 6.567 3.789a.11.11 0 0 1 .074.105.109.109 0 0 1-.074.104.385.385 0 0 1-.359 0l-6.561-3.793-6.524 3.791a.383.383 0 0 1-.359 0c-.1-.058-.1-.15 0-.209l6.518-3.789-6.563-3.79c-.1-.057-.1-.151 0-.206a.399.399 0 0 1 .357 0l6.567 3.79 6.519-3.788a.393.393 0 0 1 .361 0z"
            fill="#303030"
        />
        <path
            d="M848.6 357.04a1.38 1.38 0 0 1-1.248 0l-6.117-3.536v1.176l6.117 3.531a1.38 1.38 0 0 0 1.248 0 .415.415 0 0 0 .176-.145.425.425 0 0 0 .078-.214l.006-1.178a.448.448 0 0 1-.26.366z"
            fill="#3E3E3E"
        />
        <path
            d="m848.6 356.32-6.117-3.532-.893-.268 6.567 3.789a.11.11 0 0 1 .074.105.113.113 0 0 1-.02.064.115.115 0 0 1-.054.04.385.385 0 0 1-.359 0l-6.561-3.793v.785l6.117 3.536a1.385 1.385 0 0 0 1.248 0 .375.375 0 0 0 .187-.141.38.38 0 0 0-.001-.445.381.381 0 0 0-.188-.14z"
            fill="#4C4C4C"
        />
        <path
            d="m841.24 352.72-6.524 3.791a.385.385 0 0 1-.359 0c-.1-.058-.1-.15 0-.209l6.518-3.789-.891.268-6.076 3.532a.383.383 0 0 0 0 .726 1.386 1.386 0 0 0 1.25 0l6.076-3.536.006-.783z"
            fill="#4C4C4C"
        />
        <path
            d="M835.16 357.04a1.38 1.38 0 0 1-1.25 0 .45.45 0 0 1-.262-.368v1.174a.443.443 0 0 0 .262.365 1.373 1.373 0 0 0 1.248 0l6.078-3.531v-1.176l-6.076 3.536zM842.33 349.63a.542.542 0 0 0-.313-.445 1.727 1.727 0 0 0-1.554-.018.563.563 0 0 0-.331.455l-.009 3.062a.522.522 0 0 0 .011.069.202.202 0 0 0 .009.049.3.3 0 0 0 .035.072.317.317 0 0 0 .023.045.421.421 0 0 0 .066.074c.009.014.02.027.032.039a.78.78 0 0 0 .136.1 1.707 1.707 0 0 0 1.553.015.735.735 0 0 0 .176-.137.44.44 0 0 0 .071-.072c.009-.016.018-.032.025-.049l.037-.071c.011-.023.005-.035.01-.055a.285.285 0 0 0 .011-.065l.012-3.068z"
            fill="#303030"
        />
        <path
            d="M841.63 346.91a.853.853 0 0 0-.787-.005.28.28 0 0 0-.169.229l-.006 2.291a.193.193 0 0 0 0 .034v.018a.203.203 0 0 0 .02.042c.005.008.005.017.011.024l.029.035a.18.18 0 0 0 .02.019c.022.018.046.035.07.053a.875.875 0 0 0 .791.008.873.873 0 0 0 .071-.051l.018-.02a.29.29 0 0 0 .036-.034.123.123 0 0 0 .012-.026.253.253 0 0 0 .018-.037.054.054 0 0 0 0-.018.212.212 0 0 0 .005-.044c0-.344.005-.746.005-1.145v-1.145a.285.285 0 0 0-.042-.133.3.3 0 0 0-.102-.095z"
            fill="#969696"
        />
        <path d="M851.68 351.17c.063-.033.121.034 0 0z" fill="#E8C5AC" />
        <path
            d="M847.36 337.78c-.011-1.044-7.33-2.261-7.157-3.02 0 0 8.43-2.632 10.026-2.588 3.718.1 2.781 3.205 2.781 3.205l-4.465 12.495-.028.043c0 .407.11.807.318 1.157.209.349.509.636.867.829.29.2 1.932 1.263 1.958 1.27a.048.048 0 0 0 .023.007c-.035.021-.07.071-.07.2 0 .424-4.329.046-4.329.046a2.899 2.899 0 0 1-1.564-.3c-.428-.321-.6-1.775-.6-2.17.106-9.174 2.24-11.174 2.24-11.174z"
            fill="#E8C5AC"
        />
        <path
            d="m846.61 351.49-.108 1.008a.92.92 0 0 1-.607.139.952.952 0 0 1-.586-.281l-.328-1.581a1.719 1.719 0 0 0 1.187.69c.146.03.295.039.442.025z"
            fill="#7C7676"
        />
        <path
            d="M847.48 350.15c1.652 1.053 2.684.482 2.832.4.6-.322.35-.7.023-.928a.979.979 0 0 0-.327-.136 4.991 4.991 0 0 1 2.033.178c.152.1.29.244.3.358a.607.607 0 0 1-.16.419s-.951.385-1.611.72c-1.122.577-3.846.228-4.865.271-.348.014-.827-.522-.855-1.19a2.1 2.1 0 0 1 .266-1.3c.433.005.85.163 1.178.446.182.131.841.545 1.186.762z"
            fill="#B21B0B"
        />
        <path
            d="M845.81 351.27c.15.032.7.061 1.543.142a5.697 5.697 0 0 0 3.17-.324 9.724 9.724 0 0 0 1.349-.629c.164-.1.505-.293.467-.438a.488.488 0 0 1-.069.415 12.56 12.56 0 0 1-2.028 1.008 13.121 13.121 0 0 1-3.217.093 14.118 14.118 0 0 1-1.565-.093c-.341-.066-.4-.481-.423-.537.234.166.496.288.773.363z"
            fill="#7C7676"
        />
        <path
            d="M844 342.64s-3.027-4.1-1.031-5.8c0 0 6.207-1.944 7.146-2.312 6.053-2.375 5.482 3.321 5.482 3.321l-4.194 12.041s-.026.548-.006.73c.043.444.534.634 1.755 1 .368.111 1.258.416 1.278.42.24.081.781.406.156.516-.418.071-4.192 1.166-4.192 1.166s-1.481-.323-1.9-.358c-.536-.039-.589-.478-.589-.875l.156-.651c-.149-8.921 1.853-10.2 1.781-10.818L844 342.64z"
            fill="#FFE1CC"
        />
        <path
            d="m849.24 353.64-.223.989a.972.972 0 0 1-.641.065 1.008 1.008 0 0 1-.575-.351l-.157-1.613a1.855 1.855 0 0 0 1.3.887c.296.009.296.023.296.023z"
            fill="#7C7676"
        />
        <path
            d="M850.4 352.3a3.358 3.358 0 0 0 2.783.338c.649-.243.705-.579.4-.844a1.216 1.216 0 0 0-.421-.174 7.93 7.93 0 0 1 2.295.713.575.575 0 0 1 .15.39.594.594 0 0 1-.21.4s-1.025.269-1.742.521c-1.217.437-4.272-.074-5.325-.157-.36-.028-.794-.619-.744-1.289a2.029 2.029 0 0 1 .421-1.252c.442.058.851.265 1.16.586.393.284.805.54 1.233.768z"
            fill="#D32A1E"
        />
        <path
            d="M848.28 353.2c.53.163 1.071.288 1.618.376a7.912 7.912 0 0 0 3.716-.012c.498-.118.987-.271 1.462-.46.176-.076.526-.292.525-.381.01.322-.114.408-.114.408-.717.294-1.452.545-2.2.751a9.164 9.164 0 0 1-3.878-.186c-.644-.074-.9.027-1.191-.139a1.158 1.158 0 0 1-.523-.676c.171.145.371.254.585.319z"
            fill="#7C7676"
        />
        <path
            d="m833.92 341.94 7.163-4.121a.688.688 0 0 1 .681-.067l8.064 4.647a.675.675 0 0 0-.68.066l-7.16 4.124a2.113 2.113 0 0 0-.955 1.654.673.673 0 0 0 .278.611c-1.988-1.155-6.076-3.49-8.065-4.644a.681.681 0 0 1-.277-.616 2.116 2.116 0 0 1 .951-1.654z"
            fill="silver"
        />
        <path
            d="M841.98 346.59a2.106 2.106 0 0 0-.955 1.654c0 .605.431.85.96.547l7.16-4.123a2.097 2.097 0 0 0 .953-1.651c0-.61-.43-.856-.958-.551l-7.16 4.124z"
            fill="#ADADAD"
        />
        <path
            d="M845.37 332.95c1.08 0 5.171 2.888 5.171 2.888a3.127 3.127 0 0 1 .923 4.53s-4.4 1.633-5.423 2.047c-1.6.652-5.274 1.081-7.245.331a10.189 10.189 0 0 1-3.236-1.485 3.767 3.767 0 0 1-1.154-3.423c.1-.873.258-1.739.474-2.592 0 0 10.309-2.296 10.49-2.296z"
            fill="#3A3535"
        />
        <path
            d="m819.04 312.4.014 2.549a2.716 2.716 0 0 0 2.738 2.962h.934s1.556-.17 1.18-2.363c-.131-.76-.592-3.361-.592-3.361l-4.274.213z"
            fill="#383736"
        />
        <path
            d="M819.04 311.85a20.49 20.49 0 0 0 .014 2.737 2.495 2.495 0 0 0 .756 1.929 2.483 2.483 0 0 0 1.954.687c.9 0 1.133.019 1.157.019.655-.019 1.137-.69.942-2.091-.086-.607-.68-3.273-.722-3.273l-4.101-.008z"
            fill="#545454"
        />
        <path
            d="M829.53 291.4c.135.517.924.677 1.4.556.16-.042.512.9.848 1.2a.442.442 0 0 0 .593.028.446.446 0 0 0 .129-.171 17.53 17.53 0 0 0-.963-1.746c-.63-1.122-1.126-1.039-1.6-.922s-.539.531-.407 1.055z"
            fill="#FFE8D9"
        />
        <path
            d="M829.54 290.99c-.535.116-1.785-.7-1.785-.7l-.137-.352c-.488-1.262-2.255-5.579-2.645-7.213-.43-1.8-.979-5.065-.979-5.065s-.9-3.788.934-4.663c1.048-.5 2.976.227 3.28 3.244.118 1.161.646 6.028.646 6.028l1.833 7.039s-.104 1.454-1.147 1.682z"
            fill="#6EDBCE"
        />
        <path
            d="m828.71 290.68 1.36-.367.931 1.481.067.262.338 2.164a1.103 1.103 0 0 1-.443 1.147 1.105 1.105 0 0 1-.396.173c-.706.19-.076.019-.076.019a1.13 1.13 0 0 1-1.327-.758l-.954-2.658c-.167-.569-.121-1.295.5-1.463z"
            fill="#FFE8D9"
        />
        <path
            d="M831.14 290.14c.054.24-.377.826-1.064 1.042a3.246 3.246 0 0 1-1.366.2c-.455-.052-.721-.171-.819-.462 0 0-.369-1.074-.468-1.419-.065-.22.044-.246.044-.246a.927.927 0 0 0 .107.23 1.662 1.662 0 0 0 1.552.272c1.423-.259 1.409-1.13 1.409-1.13.207-.043.293.033.334.274l.271 1.239z"
            fill="#B8FFF5"
        />
        <path
            d="m832.28 309.68.864.619s3.472 1.223 3.71 1.314c.271.1.866.27.845.757a.57.57 0 0 1-.055.293 1.966 1.966 0 0 1-1.221.732 15.31 15.31 0 0 1-3.327.171 7.903 7.903 0 0 1-1.911-.321s-.581-.11-.661.094c.004.154.029.307.074.454l-1.452-.429a3.726 3.726 0 0 1-.333-.979l-.162-1.961 3.629-.744z"
            fill="#545454"
        />
        <path
            d="M837 313a3.538 3.538 0 0 1-1.038.342c-1.31.178-2.637.183-3.948.015-.238-.031-1.143-.162-1.143-.162s-.361.062-.341.145c0-.044.006-.008-.014 0 .012.154.041.306.088.453l.351-.271s1.1.137 1.3.176a15.25 15.25 0 0 0 3.866-.018 2.51 2.51 0 0 0 1.554-.939.509.509 0 0 0 .014-.416A2.501 2.501 0 0 1 837 313z"
            fill="#282827"
        />
        <path
            d="m830.53 313.34-1.6-.532c.056.19.123.377.2.559l1.453.43c-.005-.045-.037-.336-.053-.457z"
            fill="#282827"
        />
        <path
            d="M828.33 290.67s2.834 8.366 3.662 11.169a71.915 71.915 0 0 1 1.12 7.73c.182.824.314.981.1 1.283-.818 1.133-3.71 2.953-4.424 1.238a71.542 71.542 0 0 0-1.865-8.154c-1.188-2.971-5.226-11.2-5.226-11.2l6.633-2.066z"
            fill="#282827"
        />
        <path
            d="M826.72 273.27c1 1.708 1.522 3.144 1.658 6.638l.143 9.734c.019.47.117 1.033-.274 1.311 0 0-3.515 3.053-5.359 2.908a18.392 18.392 0 0 1-3.676-1.132c-.874-.379-.9-.9-.933-1.136l-1.273-14.081c-.087-1.089 3.775-3.563 4.42-3.978l2.644-.92s1.972-.504 2.65.656z"
            fill="#81F2E7"
        />
        <path
            d="M824.99 274.6c-1.441 1.435-2.285-.052-3.225-1.158l-.177-3.992 3.3.948.102 4.202z"
            fill="#E8C5AC"
        />
        <path
            d="M821.71 272.1c-.004.212.004.425.024.636.369 1.615 2.371 2.208 2.371 2.208.254.121.249.419.226.807l-.1 1.152c-.027.373-.22.344-.374.193 0 0-1.547-1.245-1.984-1.668-1.027-.992-.947-1.227-.613-2.532.202-.787.45-.796.45-.796zM824.58 274.87a.339.339 0 0 0-.008.494l.613.825c.318.359.345.055.34-.247l-.006-2.188c-.179-1.373-.546-1.425-.546-1.425-.006.2.003.401.026.6a2.875 2.875 0 0 1-.419 1.941z"
            fill="#B8FFF5"
        />
        <path
            d="M822.61 267.17a.89.89 0 0 1 .932.744l.064 1.632a.487.487 0 0 1-.33.432c-.456.113-.673-.284-.9-.719-.014-.027-.3-.673-.321-.712-.247-.546-.212-1.348.555-1.377z"
            fill="#FFE8D9"
        />
        <path
            d="m824.23 264.74-3.141.136.173 5.67c.058.39.053.74.131 1.066a1.609 1.609 0 0 0 .716 1.006 7.241 7.241 0 0 0 1.572.863c.339.144.71.197 1.076.153.327-.122.639-.281.93-.473a1.823 1.823 0 0 0 .989-1.121c.16-.513.283-1.036.367-1.567l.31-3.38.09-3.036-3.213.683z"
            fill="#FFE1CC"
        />
        <path
            d="M826.78 263.46a1.823 1.823 0 0 1 1.142 1.771c-.01.25-.072.496-.182.721-.309 1.121-.428 1.34-.411 1.355s.009-.748.011-1.2c0-.667-.673-.421-.941-.191-.4.334-1.334.966-1.361.982-.353.222-.43.069-.468-.191-.006-.059-.021-.4-.021-.4-.047.036-.865.459-1.085.6a1.43 1.43 0 0 0-.665 1.454l.018.492c.01.259.066.55-.188.532-.271-.019-.251-.121-.338-.395 0 0-.07-1.279-1.1-.743-.545.282-.1 1.505-.058 1.575l.269 1.853c-.227.08-.758-.286-1.079-.918-.59-1.162-.965-2-1.13-2.353a4.286 4.286 0 0 1 5.176-6.053c.832.305 1.638.676 2.411 1.109z"
            fill="#D1D3D3"
        />
        <path d="m820.63 267.88.21-.1-.482.229-.211.1.483-.229z" fill="#232323" />
        <path d="m823.26 269.74.213-.1.023-.286-.214.1-.022.286z" fill="#222" />
        <path
            d="M820.84 267.77a.497.497 0 0 1 .5.092l2.16 1.484-.214.1-2.157-1.489a.517.517 0 0 0-.238-.111.519.519 0 0 0-.262.023l.211-.099z"
            fill="#1F1F1F"
        />
        <path
            d="M821.13 267.96a.503.503 0 0 0-.5-.088l-.483.227c-.056.025-.063.118-.019.207a.275.275 0 0 0 .084.107.102.102 0 0 0 .091.016l.524-.248c.042-.014.087-.017.13-.009s.083.028.116.057l2.188 1.5.022-.283-2.153-1.486z"
            fill="#3A3A3A"
        />
        <path
            d="M823.41 269.64v.067c0 .005.002.009.004.013a.024.024 0 0 0 .009.011.089.089 0 0 0 .078.006l.005-.066a.09.09 0 0 1-.04.005.107.107 0 0 1-.038-.013.022.022 0 0 1-.01-.009.025.025 0 0 1-.004-.014h-.004z"
            fill="#6B6B6B"
        />
        <path
            d="M823.43 269.62c-.022.012-.023.031-.005.044a.095.095 0 0 0 .038.013.11.11 0 0 0 .04-.005l.059-.029a.022.022 0 0 0 .01-.009c.003-.003.004-.008.004-.013a.022.022 0 0 0-.004-.013c-.002-.004-.006-.006-.01-.008a.073.073 0 0 0-.037-.014.065.065 0 0 0-.039.006l-.056.028z"
            fill="#6B6B6B"
        />
        <path
            d="M823.57 269.65a.027.027 0 0 0 .012-.009.026.026 0 0 0 .006-.013l-.007.067c0 .011-.006.016-.018.022l-.057.028.005-.066.059-.029z"
            fill="#4F4F4F"
        />
        <path
            d="m823.37 269.55.053.036-.005.07-.052-.039c-.005-.002-.008-.006-.011-.01a.032.032 0 0 1-.003-.014v-.067c0 .005.002.01.005.014a.03.03 0 0 0 .013.01z"
            fill="#4B4B4B"
        />
        <path
            d="m823.42 269.58-.005.07a.097.097 0 0 0 .041.008.095.095 0 0 0 .04-.008.049.049 0 0 0 .011-.004.055.055 0 0 0 .007-.009l.008-.075c0 .009-.009.015-.02.022a.094.094 0 0 1-.082-.007v.003z"
            fill="#959595"
        />
        <path
            d="M823.37 269.5c-.022.014-.025.034 0 .049l.053.036a.094.094 0 0 0 .082.007c.024-.012.026-.032 0-.046l-.052-.04a.102.102 0 0 0-.083-.006z"
            fill="#6B6B6B"
        />
        <path
            d="m823.43 269.49-.005.068c0 .01 0 .016.015.025a.07.07 0 0 0 .038.01.075.075 0 0 0 .038-.01l.005-.064a.09.09 0 0 1-.078-.006.035.035 0 0 1-.01-.011.04.04 0 0 1-.003-.015v.003z"
            fill="#8D8D8D"
        />
        <path
            d="M823.45 269.47c-.024.011-.026.03-.006.045a.089.089 0 0 0 .078.006l.057-.03c.022-.01.025-.027 0-.041a.078.078 0 0 0-.037-.013.088.088 0 0 0-.039.005l-.053.028z"
            fill="#959595"
        />
        <path
            d="M823.58 269.49a.038.038 0 0 0 .017-.012v.06a.025.025 0 0 1-.008.012.028.028 0 0 1-.011.008l-.058.026.005-.064.055-.03z"
            fill="#4F4F4F"
        />
        <path d="m828.17 267.75.213-.1.025-.286-.213.1-.025.286z" fill="#222" />
        <path
            d="m828.33 267.66-.006.067a.046.046 0 0 0 .013.021.077.077 0 0 0 .078.007v-.067a.095.095 0 0 1-.037.005.094.094 0 0 1-.037-.011.093.093 0 0 1-.014-.014l.003-.008z"
            fill="#6B6B6B"
        />
        <path
            d="M828.34 267.64a.044.044 0 0 0-.011.008.033.033 0 0 0-.004.013c0 .005.002.01.004.013a.031.031 0 0 0 .011.009c.011.006.024.01.036.011a.097.097 0 0 0 .038-.005l.062-.028c.023-.009.024-.029 0-.043a.085.085 0 0 0-.038-.012.088.088 0 0 0-.039.005l-.059.029z"
            fill="#6B6B6B"
        />
        <path
            d="M828.48 267.66a.037.037 0 0 0 .017-.013v.059c0 .009-.006.016-.019.021l-.058.028v-.067l.06-.028z"
            fill="#4F4F4F"
        />
        <path
            d="m828.28 267.56.054.038v.066l-.054-.036c-.011-.007-.016-.014-.015-.024l.006-.067a.02.02 0 0 0 .002.013c.001.004.004.007.007.01z"
            fill="#4B4B4B"
        />
        <path
            d="M828.33 267.6v.066a.083.083 0 0 0 .081.007.031.031 0 0 0 .017-.022l.005-.066c0 .008-.007.015-.019.021a.08.08 0 0 1-.04.008.092.092 0 0 1-.039-.014h-.005z"
            fill="#959595"
        />
        <path
            d="M828.28 267.51c-.025.012-.026.032-.005.047l.054.038c.012.008.025.013.039.014s.028-.002.041-.008c.025-.01.026-.032 0-.047l-.05-.038a.104.104 0 0 0-.079-.006z"
            fill="#6B6B6B"
        />
        <path
            d="m828.34 267.5-.006.066c0 .005.001.01.003.014a.035.035 0 0 0 .011.01.082.082 0 0 0 .074.006l.006-.068a.084.084 0 0 1-.039.006.08.08 0 0 1-.036-.014.025.025 0 0 1-.01-.008.027.027 0 0 1-.003-.012z"
            fill="#8D8D8D"
        />
        <path
            d="M828.36 267.48c-.023.01-.024.031 0 .041a.098.098 0 0 0 .037.014.082.082 0 0 0 .038-.006l.061-.028c.02-.009.02-.029 0-.043a.083.083 0 0 0-.079-.006l-.057.028z"
            fill="#959595"
        />
        <path
            d="M828.49 267.5a.026.026 0 0 0 .011-.007.02.02 0 0 0 .004-.013v.065c0 .008-.007.015-.015.023l-.063.028.006-.068.057-.028z"
            fill="#4F4F4F"
        />
        <path
            d="m827.98 268.03.053-.706a.144.144 0 0 0-.048-.129l.193.136a.129.129 0 0 1 .041.057.133.133 0 0 1 .008.071l-.055.707a.43.43 0 0 1-.22.317l-.193-.132a.443.443 0 0 0 .221-.321z"
            fill="#2F2F2F"
        />
        <path
            d="m828.37 267.05-.2-.133a.31.31 0 0 0-.312 0l.194.133a.32.32 0 0 1 .313 0h.005z"
            fill="#3A3A3A"
        />
        <path
            d="m826.59 268.9 1.163-.553.193.132-1.162.558a.14.14 0 0 1-.138 0l-.193-.135a.14.14 0 0 0 .069.018.138.138 0 0 0 .068-.02z"
            fill="#1F1F1F"
        />
        <path
            d="M826.8 267.82a.435.435 0 0 0-.219.322l-.054.7c-.01.122.075.18.185.127l1.162-.55a.442.442 0 0 0 .22-.322l.055-.706c.007-.123-.075-.179-.187-.126l-1.162.555z"
            fill="#B2D3D3"
            opacity={0.67}
            style={{ mixBlendMode: "screen" }}
        />
        <path
            d="m828.06 267.05-.194-.133-1.159.554.193.136 1.16-.557z"
            fill="#282828"
        />
        <path
            d="M826.22 268.51a.046.046 0 0 1 .013.021.04.04 0 0 1 .001.024v.071a.144.144 0 0 0 .04.126l.036.022a.133.133 0 0 1 .045.049c.01.02.014.043.012.065l-.011.145a.308.308 0 0 0 .106.29l-.194-.133a.316.316 0 0 1-.1-.293l.011-.142a.103.103 0 0 0-.008-.055.106.106 0 0 0-.033-.045l-.045-.031a.146.146 0 0 1-.042-.059.147.147 0 0 1-.006-.072v-.072a.049.049 0 0 0 0-.024.047.047 0 0 0-.012-.02l.187.133z"
            fill="#2F2F2F"
        />
        <path
            d="m826.9 267.61-.194-.136a.971.971 0 0 0-.495.72l.194.132a.96.96 0 0 1 .495-.716z"
            fill="#3A3A3A"
        />
        <path
            d="m826.4 268.3-.191-.133-.009.071.193.137.007-.075z"
            fill="#1D1D1D"
        />
        <path
            d="m826.36 268.31-.2-.134c-.045-.03-.118-.031-.231.022a.577.577 0 0 0-.291.287l.194.133a.573.573 0 0 1 .291-.285c.114-.053.187-.052.232-.023h.005z"
            fill="#3A3A3A"
        />
        <path
            d="m825.33 269.29.053-.707a.123.123 0 0 0-.006-.071.126.126 0 0 0-.041-.058l.195.133a.141.141 0 0 1 .046.129l-.054.706a.417.417 0 0 1-.22.32l-.193-.132a.428.428 0 0 0 .22-.32z"
            fill="#2F2F2F"
        />
        <path
            d="m825.73 268.31-.193-.135a.314.314 0 0 0-.314.006l.193.132a.318.318 0 0 1 .314 0v-.003z"
            fill="#3A3A3A"
        />
        <path
            d="m823.95 270.16 1.162-.553.193.132-1.159.554a.134.134 0 0 1-.07.019.132.132 0 0 1-.07-.019l-.2-.133a.149.149 0 0 0 .144 0z"
            fill="#1F1F1F"
        />
        <path
            d="M824.15 269.07a.431.431 0 0 0-.22.321l-.054.705c-.008.125.076.18.186.127l1.16-.552a.442.442 0 0 0 .223-.322l.052-.7c.011-.125-.072-.182-.184-.128l-1.163.549z"
            fill="#B2D3D3"
            opacity={0.67}
            style={{ mixBlendMode: "screen" }}
        />
        <path
            d="m823.76 269.58-.053.708a.308.308 0 0 0 .106.289l-.193-.133a.296.296 0 0 1-.1-.29l.053-.7.187.126z"
            fill="#2F2F2F"
        />
        <path
            d="m825.42 268.31-.193-.132-1.161.553.193.135 1.161-.556z"
            fill="#282828"
        />
        <path
            d="M825.42 268.31c.252-.118.439.009.42.285v.023a.573.573 0 0 1 .291-.285c.167-.081.25-.039.275.042l.006-.052a.949.949 0 0 1 .495-.716l1.16-.557c.252-.117.44.009.42.285l-.056.707a.969.969 0 0 1-.495.72l-1.16.553c-.253.119-.442-.009-.419-.284l.011-.145a.128.128 0 0 0-.02-.076.127.127 0 0 0-.059-.051.131.131 0 0 1-.048-.059.132.132 0 0 1-.006-.076v-.071c.006-.058-.036-.068-.124-.024-.131.06-.135.122-.138.15l-.006.071a.4.4 0 0 1-.069.186.543.543 0 0 0-.105.219l-.01.145a.965.965 0 0 1-.494.72l-1.163.556c-.251.118-.439-.009-.418-.286l.053-.708a.966.966 0 0 1 .5-.716l1.159-.556zm1.19.6c-.012.121.074.177.184.128l1.162-.558a.427.427 0 0 0 .22-.317l.055-.707c.011-.122-.073-.18-.189-.124l-1.16.55a.417.417 0 0 0-.22.321l-.052.707zm-2.648 1.257c-.008.125.075.18.19.128l1.159-.554a.415.415 0 0 0 .22-.32l.054-.706c.01-.121-.074-.178-.185-.127l-1.162.554a.424.424 0 0 0-.22.32l-.056.7v.005z"
            fill="#1F1F1F"
        />
        <path
            d="m824.25 268.87-.193-.135a.966.966 0 0 0-.5.721l.192.13a.96.96 0 0 1 .5-.716h.001z"
            fill="#3A3A3A"
        />
        <path
            d="M821.14 268.01a.901.901 0 0 1 .936.748l.063 1.63s-.025.36-.328.433c-.459.114-.677-.284-.9-.721-.013-.026-.3-.671-.321-.71-.25-.546-.217-1.349.55-1.38z"
            fill="#FFE8D9"
        />
        <path
            d="m824.57 275.74.759.9-.253 1.236-.7-.676.194-1.46z"
            fill="#305670"
        />
        <path
            d="m824.88 276.45 1.834 7.905-.673 3-1.126-2.343-.035-8.562z"
            fill="#305670"
        />
        <path
            d="M825.56 291.15a7.087 7.087 0 0 0 2.978-1.032l.011.759.188 1.162-2.21 1.049-.967-1.938z"
            fill="#282827"
        />
        <path
            d="m825.76 292-1.978 19.339-.061 1.778c-.006.6-.8 1.251-1.8 1.427a3.4 3.4 0 0 1-1.921-.117 1.917 1.917 0 0 1-.773-.518 1.919 1.919 0 0 1-.436-.823l-.219-9.085-.172-11.58 7.36-.421z"
            fill="#383736"
        />
        <path
            d="M820.1 290.88c-.466.7-1.851.4-1.851.4s-2.152-1.406-4.015-2.825-1.992-2.519-1.044-4.317l2.939-5.365s.941-2.378 2.415-2.3c1.692.085 2.634 2.433 1.789 3.988-.465.856-2.468 3.429-3.4 4.611-.313.393-.263.726-.059.873l3.206 2.973a1.665 1.665 0 0 1 .02 1.962z"
            fill="#A4FFF4"
        />
        <path
            d="m818.44 294.1-.3-2.808c2.628.081 5.258.009 7.878-.215.269-.053.855 2.386.141 3.436a8.25 8.25 0 0 0-.974 2.922l-6.745-3.335z"
            fill="#383736"
        />
        <path
            d="m819.18 291.64-.043-.548 1.267-1.682 1.835.409s1.695.356 2.008 1.4c.573 1.9-.874 1.864-.874 1.864a6.184 6.184 0 0 0-1.253-.437c-.154 0-1.484-.144-1.484-.144-.816-.092-1.261-.248-1.456-.862z"
            fill="#FFE8D9"
        />
        <path
            d="M821.06 289.43a1.856 1.856 0 0 1-.395 1.9c-.566.689-.882.7-.882.7-.392.173-.665.21-.882.019 0 0-.8-.593-1.044-.826-.156-.151-.064-.244-.064-.244.08.07.182.109.288.112.485-.029.94-.244 1.27-.6.961-.981.6-1.733.6-1.733.143-.139.306-.119.454.058l.655.614z"
            fill="#DCFFF9"
        />
        <path
            d="m934.97 318.49-.8-.465v.562a.896.896 0 0 1-.4.7l-.487.277.8.467.49-.283a.868.868 0 0 0 .4-.691l-.003-.567z"
            fill="#323232"
        />
        <path
            d="M935.59 318.13v.812a1.773 1.773 0 0 1-.8 1.389l-.7.4v-.71l.49-.283a.874.874 0 0 0 .4-.691v-.563l.61-.354z"
            fill="#232323"
        />
        <path
            d="M926.46 337.66a1.952 1.952 0 0 0-.877 1.524c0 .559.4.784.884.5a1.934 1.934 0 0 0 .88-1.523c-.002-.559-.402-.785-.887-.501zm0 1.63c-.292.169-.531.034-.531-.31a1.162 1.162 0 0 1 .529-.919c.293-.17.536-.034.538.3a1.194 1.194 0 0 1-.532.929h-.004z"
            fill="#3B3B3B"
        />
        <path
            d="M926.46 338.06c.293-.17.536-.034.538.3a1.185 1.185 0 0 1-.536.925c-.292.169-.531.034-.531-.31a1.155 1.155 0 0 1 .529-.915z"
            fill="#747474"
        />
        <path
            d="M926.35 337.17a.619.619 0 0 0-.628.063 1.936 1.936 0 0 0-.881 1.522.625.625 0 0 0 .257.569l.734.424a.599.599 0 0 1-.203-.248.603.603 0 0 1-.051-.316 1.948 1.948 0 0 1 .877-1.524.628.628 0 0 1 .629-.064l-.734-.426z"
            fill="#4C4C4C"
        />
        <path
            d="M939.34 330.21a1.941 1.941 0 0 0-.88 1.528c0 .557.4.784.885.5a1.952 1.952 0 0 0 .883-1.525c.001-.559-.396-.784-.888-.503zm.005 1.627c-.294.17-.532.035-.536-.3a1.195 1.195 0 0 1 .531-.923c.3-.17.537-.033.538.306a1.168 1.168 0 0 1-.529.917h-.004z"
            fill="#3B3B3B"
        />
        <path
            d="M939.34 330.62c.3-.17.537-.033.538.306a1.162 1.162 0 0 1-.533.919c-.294.17-.532.036-.536-.299a1.196 1.196 0 0 1 .531-.926z"
            fill="#747474"
        />
        <path
            d="M939.24 329.72a.616.616 0 0 0-.626.064 1.939 1.939 0 0 0-.881 1.524.608.608 0 0 0 .257.565l.735.428a.615.615 0 0 1-.258-.564 1.94 1.94 0 0 1 .88-1.528.63.63 0 0 1 .631-.06l-.738-.429z"
            fill="#4C4C4C"
        />
        <path
            d="M938.79 337.47a.63.63 0 0 0-.63-.059c-.061.033-.122.07-.181.107-.086.047-.172.1-.258.15s-.2.114-.3.168a.64.64 0 0 1 .63.062c.106.065.204.143.292.232l-.294.17a1.168 1.168 0 0 1 .53.92.365.365 0 0 1-.154.345l.494-.287c.007.049.012.099.014.148a.625.625 0 0 1-.26.565l.736-.43a.602.602 0 0 0 .205-.247.606.606 0 0 0 .053-.317 1.952 1.952 0 0 0-.877-1.527z"
            fill="#3B3B3B"
        />
        <path
            d="m937.68 338.26.734-.428a.382.382 0 0 0-.154.342 1.167 1.167 0 0 0 .529.922l-.734.428a1.162 1.162 0 0 1-.53-.922.38.38 0 0 1 .155-.342z"
            fill="#4C4C4C"
        />
        <path
            d="M938.06 337.9c-.489-.28-.886-.053-.886.505a1.934 1.934 0 0 0 .879 1.527c.487.282.887.055.889-.5a1.967 1.967 0 0 0-.882-1.532zm-.005 1.63a1.152 1.152 0 0 1-.53-.922c0-.337.239-.476.533-.306a1.168 1.168 0 0 1 .53.92c0 .339-.24.48-.533.308z"
            fill="#4C4C4C"
        />
        <path
            d="M938.05 338.3c-.294-.17-.533-.031-.533.306.009.185.061.365.153.526.093.16.222.296.377.396.293.172.534.031.534-.308a1.173 1.173 0 0 0-.531-.92z"
            fill="#7B7B7B"
        />
        <path
            d="M925.9 330.03a.63.63 0 0 0-.629-.062c-.061.037-.12.073-.184.109-.086.048-.17.1-.256.151s-.2.11-.294.169a.616.616 0 0 1 .627.06c.107.066.206.144.295.233l-.295.171a1.177 1.177 0 0 1 .531.92.38.38 0 0 1-.031.194.382.382 0 0 1-.125.151l.494-.288c.008.049.012.097.013.146a.62.62 0 0 1-.26.566l.739-.428a.615.615 0 0 0 .256-.566 1.945 1.945 0 0 0-.881-1.526z"
            fill="#3B3B3B"
        />
        <path
            d="M925.17 330.46c-.487-.283-.883-.054-.883.506a1.943 1.943 0 0 0 .878 1.525c.488.283.885.055.887-.5a1.951 1.951 0 0 0-.882-1.531zm0 1.631a1.18 1.18 0 0 1-.531-.922c0-.339.238-.475.534-.3a1.17 1.17 0 0 1 .531.92c-.003.333-.244.471-.537.302h.003z"
            fill="#4C4C4C"
        />
        <path
            d="M925.17 330.86c-.3-.17-.534-.034-.534.3a1.169 1.169 0 0 0 .531.922c.293.169.534.031.534-.307a1.178 1.178 0 0 0-.531-.915z"
            fill="#7B7B7B"
        />
        <path
            d="m939.32 329.01-6.044 3.512v1.166l6.041-3.513a.425.425 0 0 0 .255-.354v-1.165a.434.434 0 0 1-.252.354z"
            fill="#303030"
        />
        <path
            d="M924.72 329.01a.432.432 0 0 1-.262-.361v1.167a.436.436 0 0 0 .26.359l6.084 3.513v-1.165l-6.082-3.513z"
            fill="#3E3E3E"
        />
        <path
            d="M939.32 328.3a1.366 1.366 0 0 0-1.243 0l-6.043 3.51.006.244 6.482-3.767a.405.405 0 0 1 .357 0c.1.057.1.152 0 .206l-6.482 3.766.881.27 6.044-3.512c.345-.197.34-.518-.002-.717z"
            fill="#414141"
        />
        <path
            d="M925.16 328.28a.414.414 0 0 1 .36 0l6.524 3.767-.006-.244-6.08-3.512a1.37 1.37 0 0 0-1.242 0c-.344.2-.34.52.006.717l6.08 3.513.888-.269-6.527-3.768a.106.106 0 0 1-.072-.101.109.109 0 0 1 .069-.103z"
            fill="#494949"
        />
        <path
            d="M938.88 328.28c.1.057.1.152 0 .206l-6.482 3.766 6.525 3.77a.103.103 0 0 1 .054.04c.014.018.021.041.021.064s-.007.045-.021.064a.107.107 0 0 1-.054.039.39.39 0 0 1-.355 0l-6.528-3.768-6.483 3.768a.392.392 0 0 1-.356 0c-.1-.055-.1-.146 0-.207l6.485-3.768-6.527-3.768a.105.105 0 0 1-.053-.04.11.11 0 0 1 .053-.166.417.417 0 0 1 .36 0l6.524 3.767 6.482-3.767a.404.404 0 0 1 .355 0z"
            fill="#303030"
        />
        <path
            d="M939.37 336.75a1.365 1.365 0 0 1-1.24 0l-6.082-3.51v1.167l6.082 3.513a1.374 1.374 0 0 0 1.24 0 .444.444 0 0 0 .255-.361l.007-1.165a.445.445 0 0 1-.262.356z"
            fill="#3E3E3E"
        />
        <path
            d="m939.37 336.04-6.086-3.512-.881-.27 6.525 3.77a.109.109 0 0 1 .054.04.107.107 0 0 1 0 .128.107.107 0 0 1-.054.039.392.392 0 0 1-.355 0l-6.528-3.768v.781l6.082 3.51a1.35 1.35 0 0 0 1.24 0 .378.378 0 0 0 .189-.579.385.385 0 0 0-.186-.139zM932.04 332.46l-6.483 3.768a.39.39 0 0 1-.355 0c-.1-.055-.1-.146 0-.207l6.484-3.768-.888.269-6.04 3.511a.381.381 0 0 0-.258.359.378.378 0 0 0 .258.359 1.356 1.356 0 0 0 1.242 0l6.044-3.51-.004-.781z"
            fill="#4C4C4C"
        />
        <path
            d="M926 336.76a1.355 1.355 0 0 1-1.243 0 .439.439 0 0 1-.256-.359l-.005 1.166a.442.442 0 0 0 .26.363 1.374 1.374 0 0 0 1.24 0l6.043-3.51v-1.167L926 336.76zM933.13 329.38a.526.526 0 0 0-.309-.439 1.687 1.687 0 0 0-1.542-.017.544.544 0 0 0-.331.451l-.009 3.046a.487.487 0 0 0 .01.065l.008.053c.01.023.021.046.034.068a.271.271 0 0 1 .022.049c.021.025.043.049.066.072a.217.217 0 0 1 .032.036.803.803 0 0 0 .139.1 1.705 1.705 0 0 0 1.541.013.962.962 0 0 0 .143-.1c.012-.013.021-.024.034-.036a.972.972 0 0 0 .068-.076.659.659 0 0 0 .062-.118.193.193 0 0 0 .011-.052.404.404 0 0 0 .012-.068c.003-.912.005-2.132.009-3.047z"
            fill="#303030"
        />
        <path
            d="M932.44 326.69a.862.862 0 0 0-.785-.008.29.29 0 0 0-.167.23l-.005 2.277a.182.182 0 0 0 0 .033.086.086 0 0 1 .005.027c.004.012.01.024.016.034 0 .007 0 .017.014.025a.254.254 0 0 0 .029.036c.007.005.011.012.018.018.021.02.045.038.07.052a.842.842 0 0 0 .781.007.469.469 0 0 0 .076-.049.086.086 0 0 1 .013-.014c.015-.018.028-.029.039-.042a.084.084 0 0 0 .013-.027.099.099 0 0 0 .017-.034c0-.008 0-.017.006-.026a.186.186 0 0 0 .006-.034v-1.141l.005-1.139a.287.287 0 0 0-.046-.132.294.294 0 0 0-.105-.093z"
            fill="#969696"
        />
        <path
            d="M937.96 308.18a2.274 2.274 0 0 1 1.054 2.15l-.217.931c-.1.448-.159 3.535-.161 4.058l-.015 4.872c0 .361-.258.51-.575.324l-6.746-3.893a1.248 1.248 0 0 1-.404-.426 1.245 1.245 0 0 1-.167-.563l.014-4.868c0-.524-.05-3.671-.151-4.242l-.217-1.179c-.154-.881.364-1.333 1.068-.929l6.517 3.765z"
            fill="#ADADAD"
        />
        <path
            d="m939.68 307.18-6.519-3.761a.767.767 0 0 0-.774-.078l-1.714 1a.77.77 0 0 1 .775.076l6.517 3.765a2.274 2.274 0 0 1 1.054 2.15l-.217.931c-.1.448-.159 3.535-.161 4.058l-.015 4.872a.403.403 0 0 1-.167.367l1.716-1a.399.399 0 0 0 .165-.366l.011-4.869c.006-.523.058-3.61.163-4.058l.22-.933a2.298 2.298 0 0 0-1.054-2.154z"
            fill="#969696"
        />
        <path
            d="m937.9 322.19-7.761-4.479a.641.641 0 0 0-.652-.064l-7.719 4.448a.65.65 0 0 1 .652.065l7.758 4.479a2.014 2.014 0 0 1 .914 1.58.658.658 0 0 1-.268.591c1.9-1.107 5.816-3.343 7.717-4.452a.624.624 0 0 0 .268-.584 2.007 2.007 0 0 0-.909-1.584z"
            fill="silver"
        />
        <path
            d="M930.18 326.64a2.017 2.017 0 0 1 .914 1.58c0 .584-.414.819-.922.525l-7.758-4.475a2.016 2.016 0 0 1-.912-1.584c0-.581.411-.815.92-.522l7.758 4.476z"
            fill="#ADADAD"
        />
        <path d="m930.36 305.59.649-.433v16.846l-.649.79V305.59z" fill="#894E0E" />
        <path
            d="m929.42 305.07.658-.435.929.518-.649.433-.938-.516z"
            fill="#995710"
        />
        <path d="M930.36 305.59V321l-.937-.68v-15.25l.937.52z" fill="#5F360A" />
        <path
            d="m921.37 324.16.688-.363v13.215l-.684.417-.004-13.269z"
            fill="#894E0E"
        />
        <path
            d="M921.14 328.16s1.956 2.3 2.482 2.73c.93.458 1.925.77 2.95.926.543.1 1.07.309 1.371-.364.409-.909-1.938-6.732-1.938-6.732l-4.865.292v3.148z"
            fill="#352F2F"
        />
        <path
            d="M918.86 340.26c.019-.015 1.367-1.739 1.638-2.108a2.768 2.768 0 0 0 .43-2.279l-1.792-7.719a2.985 2.985 0 0 1 .1-1.8c.084-.192.198-.37.338-.527l7.743-5.636 1.3.557c1.485 1.733.744 2.531.744 3.592 0 .056-4.179 3.025-5.2 3.777a1.58 1.58 0 0 0-.434.744c.123.954.344 6.17.51 8l.06.842a1.629 1.629 0 0 1-.353 1 19.174 19.174 0 0 1-2.322 2.137 2.805 2.805 0 0 1-2.553.63.65.65 0 0 1-.278-1.142l.069-.068z"
            fill="#E8C5AC"
        />
        <path
            d="m923.46 340.76-1.034-.452.712-.823h.577l-.255 1.275z"
            fill="#5B5454"
        />
        <path
            d="m924.37 339.35-.211 1.02s-.026.187-.439.328c-.1.034-.255.065-.255.065l-.094-1.158.999-.255z"
            fill="#7C7676"
        />
        <path
            d="M918.16 342.38a.774.774 0 0 1-.251-.953.706.706 0 0 1 .727-.472c-.247.324 2.215.889 1.184.691-.638-.122 1.325-.434 2.067-.852.515-.37.983-.801 1.393-1.285a3.207 3.207 0 0 0 1.074-1.863c.062.281.092.569.087.857 0 .779-.327.913-.327.913s-.041.273-.743.582c-.789.349-1.329 1.73-2.362 2.245-.436.23-.917.362-1.409.386a3.378 3.378 0 0 1-1.44-.249z"
            fill="#7C7676"
        />
        <path
            d="M918.19 342.14c-.531-.326-.445-.77.4-1.619.035-.037.228-.215.228-.215-.247.323-.183.811.669.95a2.751 2.751 0 0 0 2.183-.649 9.325 9.325 0 0 0 1.859-1.626 3.085 3.085 0 0 0 .711-2.114 1.357 1.357 0 0 1 .473 1.37 3.544 3.544 0 0 1-.406 1.251l-1.15.537c-.766.364-.918 1.381-2.159 1.957a3.12 3.12 0 0 1-2.808.158z"
            fill="#B21B0B"
        />
        <path
            d="M922.06 342.04a220.63 220.63 0 0 0 1.7-2.3 3.22 3.22 0 0 0 .376-2.607l-1.8-7.2a2.82 2.82 0 0 1 .454-2.79l6.243-6.287s2.574-1.2 3.942.563c1.4 1.8 1.465 2.879.436 4.291-.032.044-5.174 3.4-6.266 4.044-.373.223-.254.733-.217.883.607 2.657.408 5.613.495 7.807l.01.13.065.913a1.628 1.628 0 0 1-.353.991 19.063 19.063 0 0 1-2.325 2.139 2.796 2.796 0 0 1-2.549.632.647.647 0 0 1-.5-.482.646.646 0 0 1 .219-.66c.026-.026.045-.049.07-.067z"
            fill="#FFE1CC"
        />
        <path
            d="m926.66 342.54-1.036-.456.712-.82h.58l-.256 1.276z"
            fill="#5B5454"
        />
        <path
            d="m927.57 341.12-.211 1.025s-.027.183-.439.323c-.107.035-.256.069-.256.069l-.093-1.16.999-.257z"
            fill="#7C7676"
        />
        <path
            d="M921.36 344.16a.776.776 0 0 1-.252-.956.712.712 0 0 1 .727-.471c-.247.326 2.215.892 1.183.691-.639-.125 1.324-.432 2.068-.852a7.58 7.58 0 0 0 1.393-1.285 3.193 3.193 0 0 0 1.076-1.861c.062.281.091.569.086.856 0 .777-.327.913-.327.913s-.041.272-.743.582c-.789.348-1.328 1.728-2.362 2.245a3.359 3.359 0 0 1-2.849.138z"
            fill="#7C7676"
        />
        <path
            d="M921.39 343.91c-.535-.325-.448-.773.4-1.62.036-.035.231-.213.231-.213-.249.322-.187.81.667.952a2.749 2.749 0 0 0 2.183-.65 8.273 8.273 0 0 0 1.86-1.626 2.93 2.93 0 0 0 .706-2.185c.198.179.346.406.43.658.083.253.1.523.048.784a3.539 3.539 0 0 1-.409 1.249l-1.147.537c-.766.365-.918 1.378-2.16 1.958a3.105 3.105 0 0 1-2.809.156z"
            fill="#B21B0B"
        />
        <path
            d="M924.92 320.89c-.721.607-5.1 4.121-5.172 4.179-.952.786-.5 1.286-.5 1.286 0-.037.364-.767 1-.694 1.556.276 3.061.792 4.46 1.528 2.48 1.178 3.236 4.269 3.236 4.269a9.41 9.41 0 0 0 1.115-1.293c.495-.618 5.936-2.175 6.271-5.836a18.612 18.612 0 0 0-.341-4.272s-1.693 2.409-5.753 1.472c-3.064-.7-3.2-2.072-3.2-2.072a3.049 3.049 0 0 1-1.116 1.433z"
            fill="#5B5353"
        />
        <path
            d="m921.48 315.2 6.345-7.221c.811-1.246 1.329-4.229-.265-4.2-1.035.018-3.106 2.589-4.284 3.919a74.589 74.589 0 0 0-4.769 6.026c-.882 1.4.863 1.922.727 2.008a1.818 1.818 0 0 0 2.246-.532z"
            fill="#911309"
        />
        <path
            d="m926.34 303.75-1.367 5.87a6.002 6.002 0 0 0-.186 1.82c.147.65.451 1.253.887 1.757a3.998 3.998 0 0 1 .629 3.007l-.3 3.525s-.19.954 2.344 1.908c5.581 2.108 6.85-.114 6.85-.114.09-.246.115-.511.071-.77-.163-.788-.3-1.309-.465-1.9l-.666-3a4.945 4.945 0 0 1-.209-1.334l.792-3.859s1.1-2.668.166-3.83a18.327 18.327 0 0 0-4.094-3.295 5.218 5.218 0 0 0-1.275-.387 5.145 5.145 0 0 0-3.177.602z"
            fill="#B21B0B"
        />
        <path
            d="M927.63 305.53c1.6 1.242 2.246-.329 3.039-1.538l-.288-4.218-3.324.655.573 5.101z"
            fill="#E8C5AC"
        />
        <path
            d="M930.57 302.66s.066.531.056.63c-.17 1.639-2.072 2.469-2.072 2.469-.234.151-.2.445-.123.828l.243 1.12c.07.366.26.313.39.145 0 0 1.376-1.419 1.755-1.887.889-1.1.786-1.329.293-2.573-.295-.753-.542-.732-.542-.732z"
            fill="#EDEDED"
        />
        <path
            d="M928.23 305.53c.177.191.253.344.156.507l-.732 1.074c-.311.417-.411.126-.442-.175l-.2-2.183c.008-1.376.365-1.472.365-1.472s.007.1.038.387c.077.689.361 1.338.815 1.862z"
            fill="#EDEDED"
        />
        <path
            d="M929.41 320.6s-.538.261-.428.523c.322.499.731.936 1.208 1.29a.514.514 0 0 0 .639.128c.183-.147.662-1.163.165-1.611s-1.411-.533-1.584-.33z"
            fill="#911309"
        />
        <path
            d="M923.84 304.63s1.147-.435.837-2.2a7.703 7.703 0 0 0-.466-1.67c-1.32-3.741.447-5.686 2.2-6.688a5.63 5.63 0 0 1 4.637.007c.984.584.085 1.577-.807 3.177a10.176 10.176 0 0 0-1.191 5.021c.476 2.37-4.101 3.345-5.21 2.353z"
            fill="#562D07"
        />
        <path
            d="M926.4 296.92c-2.173.538-1.769 2.357-1.528 3.572.169.851.666 2.4.666 2.4.591 1.508 1.341 2.287 2.232 2.368 1.114.1 2.356-.925 3.216-2.574a4.54 4.54 0 0 0 .7-2.488l-.352-4.858s-3.78 1.297-4.934 1.58z"
            fill="#FFE1CC"
        />
        <path
            d="M924.01 296.89c.293-1.382 2.953-3.472 5.277-3.316a4.924 4.924 0 0 1 1.965.617c1.913 1.088 2.336 3.133 2.028 5.547-.216 1.7.342 2.228 1.04 2.709a6.834 6.834 0 0 1-1.565 2.058 8.28 8.28 0 0 1-3.282 1.8 6.909 6.909 0 0 0 .372-3.653c-.25-1.8-.528-2.478-.713-2.51s-.558 0-1.114-.061a2.738 2.738 0 0 1-.343-.866c-.182-.735-.2-.814-.2-.822a2.32 2.32 0 0 0-.029.978c.013.26.05.518.109.771a4.979 4.979 0 0 1-1.678-.183 3.56 3.56 0 0 1-.212-.806 2.642 2.642 0 0 1-.016-.462 2.53 2.53 0 0 0-.123.662c-.011.221-.014.436-.016.568a2.54 2.54 0 0 1-1.424-.55c-.294-.302-.374-1.088-.076-2.481z"
            fill="#562D07"
        />
        <path
            d="m846.37 290.54.817-.472v.572a.898.898 0 0 0 .407.709l.5.288-.815.475-.5-.292a.888.888 0 0 1-.407-.706l-.002-.574z"
            fill="#323232"
        />
        <path
            d="M845.74 290.17v.827a1.804 1.804 0 0 0 .818 1.417l.716.413v-.724l-.5-.291a.882.882 0 0 1-.288-.304.886.886 0 0 1-.119-.402v-.574l-.627-.362z"
            fill="#232323"
        />
        <path
            d="M854.15 310.6a1.977 1.977 0 0 0 .9 1.553c.5.287.9.055.9-.516a1.975 1.975 0 0 0-.9-1.554c-.494-.289-.9-.057-.9.517zm.355.2c0-.346.245-.487.547-.311.159.103.29.241.384.405.095.163.149.346.158.534 0 .346-.247.483-.545.311a1.19 1.19 0 0 1-.544-.935v-.004z"
            fill="#3B3B3B"
        />
        <path
            d="M855.05 310.5c-.3-.176-.547-.035-.547.311a1.19 1.19 0 0 0 .544.939c.3.172.545.035.545-.311a1.196 1.196 0 0 0-.542-.939z"
            fill="#747474"
        />
        <path
            d="M855.16 309.59a.628.628 0 0 1 .639.064c.263.169.482.397.638.668.157.27.247.573.262.885a.64.64 0 0 1-.262.581l-.748.435a.637.637 0 0 0 .261-.58 1.988 1.988 0 0 0-.263-.885 1.989 1.989 0 0 0-.637-.669.638.638 0 0 0-.639-.065l.749-.434z"
            fill="#4C4C4C"
        />
        <path
            d="M841 303.01a1.975 1.975 0 0 0 .9 1.555c.5.287.9.056.9-.514a1.97 1.97 0 0 0-.9-1.554c-.494-.289-.9-.061-.9.513zm.354.206c0-.346.249-.486.548-.313a1.21 1.21 0 0 1 .541.941c0 .346-.244.487-.544.311a1.2 1.2 0 0 1-.545-.939z"
            fill="#3B3B3B"
        />
        <path
            d="M841.9 302.9c-.3-.173-.547-.033-.548.313a1.2 1.2 0 0 0 .545.939c.3.176.544.035.544-.311a1.191 1.191 0 0 0-.541-.941z"
            fill="#747474"
        />
        <path
            d="M842.01 302a.634.634 0 0 1 .641.058 1.986 1.986 0 0 1 .9 1.557.636.636 0 0 1-.262.578l-.75.434a.63.63 0 0 0 .261-.575 1.97 1.97 0 0 0-.9-1.554.642.642 0 0 0-.311-.121.64.64 0 0 0-.329.055l.75-.432z"
            fill="#4C4C4C"
        />
        <path
            d="M842.47 309.9a.63.63 0 0 1 .641-.062c.063.035.126.072.189.109l.26.15c.1.061.2.119.3.176a.645.645 0 0 0-.643.063 1.5 1.5 0 0 0-.3.237l.3.174a1.188 1.188 0 0 0-.543.937.384.384 0 0 0 .16.353l-.5-.295c-.008.05-.013.1-.014.15a.626.626 0 0 0 .263.577l-.749-.432a.627.627 0 0 1-.263-.581 1.988 1.988 0 0 1 .899-1.556z"
            fill="#3B3B3B"
        />
        <path
            d="m843.61 310.71-.749-.435a.381.381 0 0 1 .159.348 1.205 1.205 0 0 1-.542.941l.748.437a1.21 1.21 0 0 0 .545-.943.387.387 0 0 0-.161-.348z"
            fill="#4C4C4C"
        />
        <path
            d="M842.32 311.89c0 .571.408.8.9.514.263-.168.482-.398.638-.668a1.95 1.95 0 0 0 .262-.886c0-.572-.408-.8-.9-.516a1.982 1.982 0 0 0-.9 1.556zm.358-.208a1.19 1.19 0 0 1 .543-.937c.3-.174.546-.034.547.309a1.197 1.197 0 0 1-.545.943c-.3.171-.545.034-.545-.315z"
            fill="#4C4C4C"
        />
        <path
            d="M843.22 310.74c.3-.174.546-.034.547.309a1.198 1.198 0 0 1-.545.943c-.3.171-.545.034-.545-.315.01-.188.064-.371.158-.534.095-.162.227-.301.385-.403z"
            fill="#7B7B7B"
        />
        <path
            d="M855.61 302.31a.65.65 0 0 1 .64-.062l.188.109c.087.05.177.1.263.152s.2.117.3.174a.632.632 0 0 0-.64.065 1.377 1.377 0 0 0-.3.236l.3.173a1.192 1.192 0 0 0-.545.939.391.391 0 0 0 .158.351l-.5-.293c-.007.05-.012.1-.014.15a.634.634 0 0 0 .263.576l-.749-.435a.63.63 0 0 1-.263-.578 1.98 1.98 0 0 1 .899-1.557z"
            fill="#3B3B3B"
        />
        <path
            d="M855.46 304.3c0 .569.407.8.907.514a1.992 1.992 0 0 0 .9-1.557c0-.57-.406-.8-.9-.513a1.964 1.964 0 0 0-.907 1.556zm.359-.208a1.197 1.197 0 0 1 .545-.939c.3-.172.541-.034.541.31a1.204 1.204 0 0 1-.54.941c-.3.174-.543.033-.546-.312z"
            fill="#4C4C4C"
        />
        <path
            d="M856.37 303.16c.3-.172.541-.034.541.31a1.203 1.203 0 0 1-.54.941c-.3.174-.543.033-.546-.312a1.194 1.194 0 0 1 .545-.939z"
            fill="#7B7B7B"
        />
        <path
            d="m841.92 301.27 6.165 3.581v1.191l-6.159-3.582a.432.432 0 0 1-.261-.362v-1.191a.443.443 0 0 0 .255.363z"
            fill="#303030"
        />
        <path
            d="M856.82 301.27a.442.442 0 0 0 .264-.369l.005 1.189a.451.451 0 0 1-.265.37l-6.207 3.582v-1.19l6.203-3.582z"
            fill="#3E3E3E"
        />
        <path
            d="M841.93 300.54a1.387 1.387 0 0 1 1.264 0l6.163 3.579-.006.252-6.61-3.844a.412.412 0 0 0-.362 0c-.1.059-.1.153 0 .211l6.613 3.842-.9.272-6.169-3.579a.387.387 0 0 1-.187-.594.387.387 0 0 1 .194-.139z"
            fill="#414141"
        />
        <path
            d="M856.37 300.53a.412.412 0 0 0-.363 0l-6.657 3.844.006-.252 6.2-3.581a1.395 1.395 0 0 1 1.268 0 .385.385 0 0 1-.005.731l-6.2 3.582-.9-.273 6.656-3.842a.11.11 0 0 0 .069-.106.119.119 0 0 0-.021-.063.123.123 0 0 0-.053-.04z"
            fill="#494949"
        />
        <path
            d="M842.38 300.53c-.1.059-.1.153 0 .211l6.613 3.842-6.656 3.844a.118.118 0 0 0-.055.041.114.114 0 0 0 0 .129.11.11 0 0 0 .055.04.383.383 0 0 0 .363 0l6.652-3.844 6.612 3.843a.388.388 0 0 0 .367 0 .107.107 0 0 0 .053-.041.11.11 0 0 0 0-.127.115.115 0 0 0-.053-.042l-6.612-3.844 6.656-3.842a.113.113 0 0 0 .054-.04.116.116 0 0 0 0-.13.122.122 0 0 0-.054-.041.412.412 0 0 0-.363 0l-6.657 3.844-6.61-3.844a.414.414 0 0 0-.365.001z"
            fill="#303030"
        />
        <path
            d="M841.88 309.17a1.4 1.4 0 0 0 1.268 0l6.2-3.58v1.185l-6.2 3.587a1.411 1.411 0 0 1-1.268 0 .452.452 0 0 1-.259-.368v-1.189a.456.456 0 0 0 .259.365z"
            fill="#3E3E3E"
        />
        <path
            d="m841.88 308.43 6.205-3.583.9-.272-6.656 3.844a.11.11 0 0 0-.054.041.11.11 0 0 0 .054.169.383.383 0 0 0 .363 0l6.652-3.844v.8l-6.2 3.58a1.412 1.412 0 0 1-1.268 0 .388.388 0 0 1 .004-.735zM849.35 304.79l6.612 3.843a.394.394 0 0 0 .367 0 .113.113 0 0 0 .073-.105.113.113 0 0 0-.073-.105l-6.612-3.844.9.273 6.162 3.582a.387.387 0 0 1 0 .733 1.395 1.395 0 0 1-1.266 0l-6.163-3.58v-.797z"
            fill="#4C4C4C"
        />
        <path
            d="M855.51 309.17a1.393 1.393 0 0 0 1.266 0 .439.439 0 0 0 .261-.368l.006 1.188a.445.445 0 0 1-.264.372 1.411 1.411 0 0 1-1.267 0l-6.163-3.587v-1.185l6.161 3.58zM848.24 301.65a.546.546 0 0 1 .313-.45 1.735 1.735 0 0 1 1.574-.018.575.575 0 0 1 .339.462l.006 3.108a.493.493 0 0 1-.017.117.369.369 0 0 1-.035.072.238.238 0 0 1-.023.045.697.697 0 0 1-.067.077.3.3 0 0 1-.033.038.97.97 0 0 1-.138.1 1.737 1.737 0 0 1-1.576.016 1.1 1.1 0 0 1-.145-.1c-.014-.012-.02-.026-.032-.037a.745.745 0 0 1-.071-.077.287.287 0 0 1-.028-.048c-.012-.024-.027-.047-.039-.073a.485.485 0 0 1-.008-.055.31.31 0 0 1-.011-.069c-.009-.932-.009-2.174-.009-3.108z"
            fill="#303030"
        />
        <path
            d="M848.94 298.9a.879.879 0 0 1 .8-.008.304.304 0 0 1 .119.094.3.3 0 0 1 .055.14l.007 2.322a.097.097 0 0 1-.006.034v.027a.1.1 0 0 1-.018.034l-.011.026a.22.22 0 0 1-.033.035l-.011.015a.493.493 0 0 1-.078.058.893.893 0 0 1-.8.008.757.757 0 0 1-.092-.07.205.205 0 0 1-.035-.037.089.089 0 0 1-.015-.029l-.017-.032c0-.008 0-.017-.007-.028s0-.025-.005-.035c0-.347 0-.755-.006-1.161v-1.163a.288.288 0 0 1 .153-.23z"
            fill="#969696"
        />
        <path
            d="m852.05 286.84-.581-.339-2.745 1.6.581.336 2.745-1.597z"
            fill="#313131"
        />
        <path
            d="m851.28 287.38 1.2-5.388.581.34 2.55 1.473v.673l-2.682-1.546-1.07 4.788-.579-.34z"
            fill="#313131"
        />
        <path
            d="m848.73 288.87.581.34v-.775l-.581-.338v.773zM856.31 283.4v.674l-.7.4v-.673l.7-.401z"
            fill="#464646"
        />
        <path
            d="m856.31 283.4-.7.405-3.131-1.812.7-.405 3.131 1.812z"
            fill="#363636"
        />
        <path
            d="m852.06 286.84.872-3.9.517.3-.918 4.1-3.217 1.86v-.767l2.746-1.593z"
            fill="#464646"
        />
        <path
            d="M843.68 291.24a.19.19 0 0 1 .089.184v1.376l-1.746-1.015-.006-1.374a.19.19 0 0 0-.016-.105.183.183 0 0 0-.067-.081l1.746 1.015z"
            fill="#818182"
        />
        <path
            d="M843.32 278.82a2.323 2.323 0 0 0-1.074 2.193l.221.949c.107.459.162 3.607.164 4.141l.014 4.968c0 .371.265.519.588.331l.251-.145c.161-.094.295-.018.295.165v1.376l5.646-3.259a.278.278 0 0 0 .106-.104.29.29 0 0 0 .039-.144l-.005-1.211a.642.642 0 0 1 .292-.5l.254-.147a1.29 1.29 0 0 0 .584-1.009l-.016-4.965c0-.534.05-3.743.154-4.325l.218-1.2c.161-.893-.368-1.355-1.089-.943l-6.642 3.829z"
            fill="#ADADAD"
        />
        <path
            d="m841.57 277.81 6.647-3.838a.795.795 0 0 1 .788-.077l1.749 1.016a.787.787 0 0 0-.794.077l-6.644 3.838a2.327 2.327 0 0 0-1.074 2.193l.221.949c.107.459.162 3.607.164 4.141l.014 4.968a.416.416 0 0 0 .17.372l-1.746-1.017a.4.4 0 0 1-.171-.373l-.015-4.966c0-.534-.056-3.681-.163-4.138l-.223-.953a2.334 2.334 0 0 1 .227-1.249c.191-.387.485-.713.85-.943z"
            fill="#969696"
        />
        <path
            d="m845.64 274.11-.483-.281v2.769l.484.28-.001-2.768z"
            fill="#3B3B3B"
        />
        <path d="M845.64 274.11v2.768l.727-.419v-2.769l-.727.42z" fill="#292929" />
        <path
            d="m843.38 294.32 7.911-4.567a.653.653 0 0 1 .664-.066l7.873 4.536a.65.65 0 0 0-.665.066l-7.913 4.568a2.048 2.048 0 0 0-.929 1.615.66.66 0 0 0 .271.6c-1.94-1.128-5.931-3.406-7.871-4.537a.655.655 0 0 1-.273-.6 2.057 2.057 0 0 1 .932-1.615z"
            fill="silver"
        />
        <path
            d="M851.25 298.85a2.048 2.048 0 0 0-.929 1.615c0 .591.42.83.934.533l7.915-4.569a2.042 2.042 0 0 0 .931-1.614c0-.593-.421-.831-.938-.533l-7.913 4.568z"
            fill="#ADADAD"
        />
        <path
            d="m842.78 271.81 4.468-2.579a.415.415 0 0 1 .417-.042l1.163.679a.42.42 0 0 0-.415.039l-4.466 2.581a1.277 1.277 0 0 0-.582 1.008l.006 1.946a.42.42 0 0 0 .167.375l-1.163-.678a.413.413 0 0 1-.17-.375l-.006-1.945a1.285 1.285 0 0 1 .581-1.009z"
            fill="#969696"
        />
        <path
            d="M843.95 272.49a1.277 1.277 0 0 0-.582 1.008l.006 1.946c0 .369.262.522.586.333l4.465-2.58a1.27 1.27 0 0 0 .582-1.009v-1.944c0-.371-.263-.523-.587-.335l-4.47 2.581z"
            fill="#ADADAD"
        />
        <path
            d="m843.25 291.73-.583-.342-3 1.732.582.338 3.001-1.728z"
            fill="#313131"
        />
        <path
            d="m839.51 290.14.989 3.173 2.753-1.587v.763l-3.22 1.857-1.2-3.82.678-.386z"
            fill="#3B3B3B"
        />
        <path d="M842.09 291.6v.674l-.7.4v-.672l.7-.402z" fill="#3B3B3B" />
        <path
            d="m838.84 290.53 2.551 1.473v.672l-2.289-1.321.936 3-.582-.336-1.2-3.824.584.336z"
            fill="#2C2C2C"
        />
        <path
            d="m842.09 291.6-.7.406-3.133-1.812.7-.406 3.133 1.812z"
            fill="#363636"
        />
        <path
            d="m838.74 289.32 1.107-.642a.488.488 0 0 1 .47-.048l5.823 3.388a.464.464 0 0 0-.465.046l-1.11.641a1.444 1.444 0 0 0-.655 1.133.46.46 0 0 0 .193.421l-5.826-3.384a.456.456 0 0 1-.191-.422 1.453 1.453 0 0 1 .654-1.133z"
            fill="#C6C6C6"
        />
        <path
            d="M844.56 292.7a1.444 1.444 0 0 0-.655 1.133c0 .416.3.585.66.377l1.11-.642a1.445 1.445 0 0 0 .652-1.136c0-.415-.3-.584-.657-.373l-1.11.641z"
            fill="#ADADAD"
        />
        <path
            d="m852.27 280.72 1.112-.644a.477.477 0 0 1 .466-.045l5.825 3.385a.471.471 0 0 0-.467.047l-1.109.641a1.448 1.448 0 0 0-.656 1.131.451.451 0 0 0 .193.423l-5.826-3.387a.45.45 0 0 1-.191-.42 1.443 1.443 0 0 1 .653-1.131z"
            fill="#C6C6C6"
        />
        <path
            d="M858.09 284.1a1.436 1.436 0 0 0-.655 1.131c0 .419.299.588.657.379l1.111-.644a1.429 1.429 0 0 0 .654-1.133c0-.416-.3-.583-.658-.374l-1.109.641z"
            fill="#ADADAD"
        />
        <path
            d="m960.54 337.16-.8-.468v.563a.89.89 0 0 1-.4.694l-.489.283.8.465.488-.282a.893.893 0 0 0 .4-.7l.001-.555z"
            fill="#323232"
        />
        <path
            d="M961.16 336.8v.81a1.768 1.768 0 0 1-.8 1.391l-.7.406v-.711l.488-.282a.874.874 0 0 0 .284-.302.874.874 0 0 0 .116-.398v-.56l.612-.354z"
            fill="#232323"
        />
        <path
            d="M952.03 356.32a1.936 1.936 0 0 0-.881 1.523c0 .563.4.787.886.506a1.936 1.936 0 0 0 .879-1.524c0-.562-.397-.788-.884-.505zm.005 1.626c-.3.17-.536.035-.536-.3a1.164 1.164 0 0 1 .533-.923c.291-.168.534-.034.534.306a1.162 1.162 0 0 1-.531.917z"
            fill="#3B3B3B"
        />
        <path
            d="M952.03 356.72c.291-.168.534-.034.534.306a1.177 1.177 0 0 1-.531.92c-.3.17-.536.035-.536-.3a1.162 1.162 0 0 1 .533-.926z"
            fill="#747474"
        />
        <path
            d="M951.92 355.83a.629.629 0 0 0-.629.062 1.955 1.955 0 0 0-.878 1.526.62.62 0 0 0 .259.565l.735.427a.614.614 0 0 1-.258-.567c.016-.305.104-.603.258-.867.153-.265.366-.49.623-.656a.619.619 0 0 1 .627-.063l-.737-.427z"
            fill="#4C4C4C"
        />
        <path
            d="M964.92 348.88a1.952 1.952 0 0 0-.88 1.527c0 .56.4.785.887.5a1.934 1.934 0 0 0 .88-1.522c-.004-.56-.401-.785-.887-.505zm.005 1.629c-.3.168-.533.033-.535-.3a1.167 1.167 0 0 1 .53-.921c.3-.17.534-.037.538.3a1.193 1.193 0 0 1-.533.921z"
            fill="#3B3B3B"
        />
        <path
            d="M964.92 349.28c.3-.17.534-.037.538.3a1.19 1.19 0 0 1-.533.921c-.3.168-.533.033-.535-.3a1.163 1.163 0 0 1 .53-.921z"
            fill="#747474"
        />
        <path
            d="M964.81 348.39a.618.618 0 0 0-.628.062 1.942 1.942 0 0 0-.881 1.526.621.621 0 0 0 .258.566l.735.427a.61.61 0 0 1-.257-.565 1.945 1.945 0 0 1 .88-1.527.623.623 0 0 1 .628-.06l-.735-.429z"
            fill="#4C4C4C"
        />
        <path
            d="M964.36 356.14a.618.618 0 0 0-.627-.062l-.184.108-.257.15-.294.169a.619.619 0 0 1 .629.061c.106.065.205.143.293.232l-.3.172a1.167 1.167 0 0 1 .534.92.385.385 0 0 1-.032.192.38.38 0 0 1-.125.15l.494-.286c.006.048.009.097.009.146a.622.622 0 0 1-.255.568l.735-.43a.596.596 0 0 0 .256-.564 1.913 1.913 0 0 0-.254-.869 1.909 1.909 0 0 0-.622-.657z"
            fill="#3B3B3B"
        />
        <path
            d="m963.25 356.93.733-.428a.38.38 0 0 0-.153.341 1.185 1.185 0 0 0 .53.924l-.735.427a1.168 1.168 0 0 1-.529-.921.372.372 0 0 1 .154-.343z"
            fill="#4C4C4C"
        />
        <path
            d="M963.63 356.56c-.488-.282-.885-.053-.886.507a1.937 1.937 0 0 0 .878 1.524c.492.283.886.058.886-.505a1.926 1.926 0 0 0-.878-1.526zm-.006 1.631a1.178 1.178 0 0 1-.529-.921c0-.34.239-.476.533-.306a1.167 1.167 0 0 1 .534.92c0 .337-.242.475-.538.307z"
            fill="#4C4C4C"
        />
        <path
            d="M963.62 356.97c-.294-.17-.533-.034-.533.306a1.167 1.167 0 0 0 .529.921c.3.168.538.03.538-.307a1.171 1.171 0 0 0-.534-.92z"
            fill="#7B7B7B"
        />
        <path
            d="M951.47 348.7a.612.612 0 0 0-.626-.06c-.062.037-.125.071-.185.106l-.258.148-.293.174a.62.62 0 0 1 .629.059c.108.064.206.141.293.231l-.3.173a1.18 1.18 0 0 1 .533.92.372.372 0 0 1-.156.342l.492-.286c.008.048.013.097.014.146a.61.61 0 0 1-.053.318.608.608 0 0 1-.206.249l.735-.429a.606.606 0 0 0 .206-.248.608.608 0 0 0 .053-.317 1.94 1.94 0 0 0-.878-1.526z"
            fill="#3B3B3B"
        />
        <path
            d="M950.74 349.12c-.49-.283-.887-.054-.889.5a1.946 1.946 0 0 0 .881 1.527c.489.28.885.056.889-.505a1.944 1.944 0 0 0-.881-1.522zm-.006 1.629a1.18 1.18 0 0 1-.534-.92c0-.34.242-.475.538-.3.154.101.283.237.376.396.092.16.146.34.157.524-.001.334-.245.471-.538.3h.001z"
            fill="#4C4C4C"
        />
        <path
            d="M950.74 349.53c-.3-.17-.534-.035-.538.3a1.183 1.183 0 0 0 .534.92c.293.171.537.034.537-.3a1.167 1.167 0 0 0-.533-.92z"
            fill="#7B7B7B"
        />
        <path
            d="m964.89 347.68-6.039 3.511v1.165l6.04-3.511a.438.438 0 0 0 .256-.356v-1.166a.43.43 0 0 1-.257.357z"
            fill="#303030"
        />
        <path
            d="M950.29 347.68a.451.451 0 0 1-.26-.362v1.164a.437.437 0 0 0 .258.363l6.083 3.512v-1.166l-6.081-3.511z"
            fill="#3E3E3E"
        />
        <path
            d="M964.89 346.96a1.362 1.362 0 0 0-1.24 0l-6.043 3.511.005.243 6.484-3.766a.388.388 0 0 1 .352 0c.1.058.1.152 0 .206l-6.48 3.768.885.268 6.039-3.511a.378.378 0 0 0-.002-.719z"
            fill="#414141"
        />
        <path
            d="M950.73 346.95a.393.393 0 0 1 .356 0l6.527 3.766-.005-.243-6.082-3.512a1.366 1.366 0 0 0-1.242 0 .383.383 0 0 0-.257.359.378.378 0 0 0 .257.36l6.083 3.511.886-.268-6.526-3.768c-.096-.053-.096-.147.003-.205z"
            fill="#494949"
        />
        <path
            d="M964.45 346.95c.1.058.1.152 0 .206l-6.48 3.768 6.527 3.768a.103.103 0 0 1 .054.04.104.104 0 0 1 .021.063.105.105 0 0 1-.021.064.103.103 0 0 1-.054.04.393.393 0 0 1-.357 0l-6.524-3.769-6.484 3.769a.393.393 0 0 1-.357 0 .111.111 0 0 1-.075-.104.11.11 0 0 1 .075-.103l6.482-3.768-6.526-3.768c-.1-.054-.1-.148 0-.206a.393.393 0 0 1 .356 0l6.527 3.766 6.484-3.766a.388.388 0 0 1 .352 0z"
            fill="#303030"
        />
        <path
            d="M964.94 355.42a1.366 1.366 0 0 1-1.243 0l-6.082-3.511v1.167l6.08 3.509a1.386 1.386 0 0 0 1.243 0 .439.439 0 0 0 .256-.36v-1.163a.442.442 0 0 1-.254.358z"
            fill="#3E3E3E"
        />
        <path
            d="m964.94 354.7-6.082-3.513-.885-.268 6.527 3.768a.107.107 0 0 1 .054.039c.014.019.021.041.021.064s-.007.046-.021.064a.103.103 0 0 1-.054.04.393.393 0 0 1-.357 0l-6.524-3.769v.783l6.082 3.511a1.386 1.386 0 0 0 1.243 0 .388.388 0 0 0 .184-.14.377.377 0 0 0-.188-.579z"
            fill="#4C4C4C"
        />
        <path
            d="m957.62 351.13-6.484 3.769a.393.393 0 0 1-.357 0 .103.103 0 0 1-.054-.04c-.014-.018-.021-.041-.021-.064s.007-.045.021-.064a.107.107 0 0 1 .054-.039l6.482-3.768-.886.268-6.042 3.513a.383.383 0 0 0-.185.58.387.387 0 0 0 .185.139 1.378 1.378 0 0 0 1.242 0l6.041-3.511.004-.783z"
            fill="#4C4C4C"
        />
        <path
            d="M951.58 355.42a1.366 1.366 0 0 1-1.242 0 .449.449 0 0 1-.259-.36v1.163a.44.44 0 0 0 .258.362 1.386 1.386 0 0 0 1.243 0l6.042-3.508v-1.167l-6.042 3.51zM958.7 348.05a.529.529 0 0 0-.308-.441 1.71 1.71 0 0 0-1.545-.019.558.558 0 0 0-.33.452l-.01 3.048c0 .021.01.042.011.064s0 .033.01.053a.336.336 0 0 0 .035.068.267.267 0 0 0 .02.046c.021.026.044.05.067.074a.642.642 0 0 0 .169.136c.237.124.501.19.769.192s.533-.059.773-.178a.883.883 0 0 0 .144-.1.29.29 0 0 0 .033-.037.687.687 0 0 0 .069-.074.46.46 0 0 0 .026-.049.755.755 0 0 0 .037-.069.192.192 0 0 0 .011-.054.353.353 0 0 0 .011-.065v-.006c.002-.91.007-2.128.008-3.041z"
            fill="#303030"
        />
        <path
            d="M958.01 345.36a.861.861 0 0 0-.783-.008.288.288 0 0 0-.172.228l-.005 2.279c.001.01.002.021.005.031a.1.1 0 0 1 .005.025c0 .014.011.024.016.035s.008.016.014.025a.097.097 0 0 0 .03.034.211.211 0 0 0 .019.023.56.56 0 0 0 .068.049.875.875 0 0 0 .785.01.598.598 0 0 0 .073-.051l.017-.02a.188.188 0 0 0 .034-.035c.004-.01.01-.02.016-.029l.021-.031a.113.113 0 0 1 0-.026.193.193 0 0 0 0-.034c0-.339.005-.737.007-1.138v-1.137a.267.267 0 0 0-.15-.23z"
            fill="#969696"
        />
        <path
            d="M963.53 326.85a2.304 2.304 0 0 1 1.058 2.152l-.223.932c-.106.447-.161 3.535-.161 4.059l-.011 4.869c0 .363-.26.509-.577.327l-6.746-3.9a1.239 1.239 0 0 1-.57-.988l.014-4.867c0-.525-.051-3.673-.156-4.243l-.211-1.182c-.158-.878.364-1.33 1.064-.926l6.519 3.767z"
            fill="#ADADAD"
        />
        <path
            d="m965.24 325.85-6.519-3.762a.767.767 0 0 0-.775-.078l-1.71 1a.765.765 0 0 1 .773.074l6.519 3.762a2.297 2.297 0 0 1 1.058 2.152l-.223.932c-.106.447-.161 3.535-.161 4.059l-.011 4.869a.385.385 0 0 1-.17.365l1.715-.994a.396.396 0 0 0 .166-.367l.013-4.867c0-.525.058-3.612.164-4.061l.217-.932a2.272 2.272 0 0 0-1.056-2.152z"
            fill="#969696"
        />
        <path
            d="m963.47 340.86-7.759-4.481a.642.642 0 0 0-.652-.062l-7.722 4.445a.647.647 0 0 1 .655.067l7.756 4.48a1.993 1.993 0 0 1 .911 1.58.636.636 0 0 1-.263.586c1.9-1.1 5.815-3.339 7.719-4.446a.651.651 0 0 0 .268-.588 2.012 2.012 0 0 0-.913-1.581z"
            fill="silver"
        />
        <path
            d="M955.75 345.31a1.993 1.993 0 0 1 .911 1.58c0 .583-.412.817-.917.525l-7.756-4.48a2.017 2.017 0 0 1-.914-1.582c0-.583.413-.816.92-.523l7.756 4.48z"
            fill="#ADADAD"
        />
        <path
            d="M947.76 330.29c.911-1.012 3.493-3.987 3.493-3.987s2.616-4.648 1.3-5.328c-1.3-.672-2.107-.4-3.72 2.105-.377.589-3.762 4.97-4.21 5.463a3.83 3.83 0 0 0-.716 2.642s.989 2.284 3.853-.895z"
            fill="#3A566D"
        />
        <path
            d="m956.95 322.76 1.19-.692-.041 16.241-1.19.694.041-16.243z"
            fill="#894E0E"
        />
        <path
            d="m955.53 321.94 1.193-.691 1.42.821-1.192.692-1.421-.822z"
            fill="#995710"
        />
        <path
            d="m956.95 322.76-.038 16.243-1.421-.823.038-16.242 1.421.822z"
            fill="#5F360A"
        />
        <path
            d="m953.65 337.13 1.586-.924 1.423.82-1.585.924-1.424-.82z"
            fill="#995710"
        />
        <path
            d="m947.46 342.36 1.591-.922-.042 13.99-1.588.923.039-13.991z"
            fill="#894E0E"
        />
        <path
            d="m946.04 341.54 1.588-.924 1.424.821-1.591.922-1.421-.819z"
            fill="#995710"
        />
        <path
            d="m947.46 342.36-.039 13.991-1.421-.822.039-13.988 1.421.819z"
            fill="#5F360A"
        />
        <path
            d="m946 353.17-.828.706s-3.8 1.845-4.053 1.937a.632.632 0 0 0-.425.56.457.457 0 0 0 .083.3 2.01 2.01 0 0 0 1.3.639c1.17.066 2.345-.017 3.495-.247.262-.124 1.822-.392 1.947-.489 0 0 .482-.016.581.185.01.158-.003.316-.037.469l1.448-.559c.133-.329.22-.675.258-1.029l.256-2.031-4.025-.441z"
            fill="#545454"
        />
        <path
            d="M940.76 356.5c.355.389.838.638 1.36.7a8.717 8.717 0 0 0 3.941-.568 5.243 5.243 0 0 1 1.568-.3s.494.05.476.426c0 .075.031.02.018.107a.227.227 0 0 0-.011-.1c-.1-.2-.5.079-.5.079-.164-.181-.045-.376-1.211-.02a10.671 10.671 0 0 1-3.987.76 2.56 2.56 0 0 1-1.663-.828.522.522 0 0 1-.051-.424c.017.057.037.114.06.168z"
            fill="#282827"
        />
        <path
            d="m948.12 356.67 1.569-.6a5.445 5.445 0 0 1-.159.589l-1.451.559c.008-.038.035-.417.041-.548zM959.15 333.71l-5.656 1.648-7.935 5.549s-1.653.857-1.374 3.824c.242 2.544.45 9.336.45 9.336.007.619.281.816.78 1.083 3.07 1.622 4.64.339 4.64.339.245-.141.224-.307.245-.52l-.157-10.128 5.855-3.215s2.812-1.268 2.989-3.411c.075-.882.163-4.505.163-4.505z"
            fill="#282827"
        />
        <path
            d="m948.66 355.83-2.516 2.112s-1.272 1.021-1.739 1.292a.845.845 0 0 0-.373.66.598.598 0 0 0 .149.459c.401.341.883.572 1.4.671a4.559 4.559 0 0 0 2.978-.581c.245-.158 1.915-1.233 2.039-1.334.347-.277.664-.387.784-.2 0 0-.013.456-.013.524l1.4-.963c.048-.274.078-.551.09-.829v-2.042l-4.199.231z"
            fill="#282827"
        />
        <path
            d="m948.66 355.53-2.516 2.114s-1.272 1.02-1.739 1.292a.835.835 0 0 0-.373.66.603.603 0 0 0 .149.461c.401.34.883.57 1.4.669a4.565 4.565 0 0 0 2.978-.582c.245-.154 1.915-1.232 2.039-1.332.347-.279.664-.386.784-.2 0 0-.013.459-.013.527l1.4-.964a6.36 6.36 0 0 0 .09-.826V355.3l-4.199.23z"
            fill="#545454"
        />
        <path
            d="m961.38 335.83-5.224 1.607-7.641 5.436s-1.673.659-1.524 3.645c.092 1.853.227 1.964.476 9.644.008.617.425.929.927 1.2 3.066 1.618 4.322.21 4.322.21.248-.138.226-.3.248-.522l-.152-9.3c-.007-.622.05-.866.6-1.164l5.251-2.873s2.81-1.266 2.988-3.412c.074-.888-.271-4.471-.271-4.471z"
            fill="#383736"
        />
        <path
            d="M951.18 320.97c-.844 1.846-1.228 3.366-1.008 6.942l.964 12.366a1.681 1.681 0 0 0 .647 1.42s3.655 1.553 5.531 1.293a9.476 9.476 0 0 0 3.672-1.523 2.69 2.69 0 0 0 .836-2.477s.491-10.752.064-13.941a2.861 2.861 0 0 0-1.187-1.7c-.583-.447-4.093-2.656-4.093-2.656l-2.793-.668s-2.061-.312-2.633.944z"
            fill="#4D6B89"
        />
        <path
            d="M952.64 324.74c-.577-.73-.617-3.635.522-4.743.218-.006.436.004.653.031l2.793.668s.657.388 1.458.925c-.38.032-1.223 1.2-2.424 2.5-1.12 1.198-2.202 1.631-3.002.619z"
            fill="#BDCCD1"
        />
        <path
            d="M953.09 322.14c1.615 1.316 2.325-.286 3.168-1.515l-.232-4.089-3.268 1.309.332 4.295z"
            fill="#E8C5AC"
        />
        <path
            d="M956.18 319.25s.059.551.047.651c-.216 1.687-2.193 2.5-2.193 2.5-.248.152-.212.455-.147.851l.223 1.163c.064.378.259.325.4.158 0 0 1.447-1.432 1.852-1.906.944-1.119.839-1.348.365-2.646-.285-.788-.547-.771-.547-.771zM953.54 322.38a.347.347 0 0 1 .134.238.346.346 0 0 1-.075.262l-.539.9c-.288.406-.349.093-.374-.215l-.22-2.232c.04-1.413.411-1.506.411-1.506.023.204.035.408.034.613a2.969 2.969 0 0 0 .629 1.94z"
            fill="#EDEDED"
        />
        <path
            d="M954.76 314.32a.912.912 0 0 0-.877.855l.1 1.673s.063.361.381.407c.478.067.659-.359.845-.83l.252-.757c.197-.582.082-1.397-.701-1.348z"
            fill="#FFE8D9"
        />
        <path
            d="m951.85 312.79 3.2-.348.7 5.775c0 .4.058.755.032 1.1a1.624 1.624 0 0 1-.173.622 1.63 1.63 0 0 1-.399.508 7.335 7.335 0 0 1-1.458 1.118c-.32.198-.687.31-1.064.324a4.551 4.551 0 0 1-1.015-.338 1.855 1.855 0 0 1-1.178-.979 11.352 11.352 0 0 1-.615-1.533l-.836-3.378-.564-3.064 3.37.193z"
            fill="#FFE1CC"
        />
        <path
            d="M949.07 311.88c-.844.606-1.192 1.328-.59 2.671.488 1.089.642 1.3.629 1.314s-.124-.757-.2-1.212c-.107-.674.616-.53.922-.341.453.279 1.5.773 1.535.787.387.168.444 0 .44-.268 0-.061-.041-.41-.041-.41.054.027.949.328 1.2.438a1.447 1.447 0 0 1 .9 1.369l.046.569c.029.264.034.552.3.538.121-.005.3-.014.407-.5 0 0 .34-.989.863-.972.627.016.328 1.507.3 1.584l.017 1.921c.242.045.723-.408.95-1.094.421-1.273.669-2.177.782-2.562a4.388 4.388 0 0 0-1.283-4.763 4.396 4.396 0 0 0-4.901-.569c-.798.438-1.559.939-2.276 1.5z"
            fill="#633A11"
        />
        <path
            d="M955.37 315.86c-.784-.125-.763 1.129-.763 1.129l.1 1.4s.1.509.417.506c.373-.005.607-.3.767-.773.01-.028.252-.7.261-.746a1.118 1.118 0 0 0-.037-.941 1.103 1.103 0 0 0-.745-.575z"
            fill="#FFE8D9"
        />
        <path
            d="m900.31 302.49-.8-.466v.56a.882.882 0 0 1-.4.7l-.49.281.8.466.489-.282a.88.88 0 0 0 .4-.694l.001-.565z"
            fill="#323232"
        />
        <path
            d="M900.93 302.14v.809a1.78 1.78 0 0 1-.8 1.391l-.7.4v-.709l.489-.282a.9.9 0 0 0 .283-.299.901.901 0 0 0 .117-.395v-.56l.611-.355z"
            fill="#232323"
        />
        <path
            d="M891.8 321.66a1.927 1.927 0 0 0-.879 1.523c0 .561.4.784.886.5a1.94 1.94 0 0 0 .88-1.519c-.002-.562-.401-.792-.887-.504zm.005 1.628c-.295.168-.534.034-.534-.309a1.173 1.173 0 0 1 .531-.92c.293-.17.536-.035.536.307a1.182 1.182 0 0 1-.533.922z"
            fill="#3B3B3B"
        />
        <path
            d="M891.8 322.06c.293-.17.536-.035.536.307a1.17 1.17 0 0 1-.533.922c-.295.168-.534.034-.534-.309a1.178 1.178 0 0 1 .531-.92z"
            fill="#747474"
        />
        <path
            d="M891.7 321.17a.632.632 0 0 0-.324-.054.633.633 0 0 0-.306.118 1.93 1.93 0 0 0-.879 1.524.61.61 0 0 0 .258.566l.733.427a.618.618 0 0 1-.257-.566 1.932 1.932 0 0 1 .879-1.523.619.619 0 0 1 .629-.062l-.733-.43z"
            fill="#4C4C4C"
        />
        <path
            d="M904.69 314.22a1.927 1.927 0 0 0-.878 1.525c0 .56.395.788.885.5a1.946 1.946 0 0 0 .883-1.521c-.004-.561-.401-.785-.89-.504zm0 1.627c-.291.17-.53.034-.534-.3a1.17 1.17 0 0 1 .531-.921c.3-.171.537-.035.539.3a1.19 1.19 0 0 1-.533.921h-.003z"
            fill="#3B3B3B"
        />
        <path
            d="M904.69 314.62c.3-.171.537-.035.539.3a1.18 1.18 0 0 1-.536.921c-.291.17-.53.034-.534-.3a1.178 1.178 0 0 1 .531-.921z"
            fill="#747474"
        />
        <path
            d="M904.59 313.73a.634.634 0 0 0-.631.063 1.912 1.912 0 0 0-.623.657 1.923 1.923 0 0 0-.256.868.61.61 0 0 0 .258.565l.735.429a.627.627 0 0 1-.257-.567 1.936 1.936 0 0 1 .878-1.525.62.62 0 0 1 .63-.06l-.734-.43z"
            fill="#4C4C4C"
        />
        <path
            d="M904.14 321.47a.622.622 0 0 0-.627-.06c-.064.034-.122.069-.186.105-.086.051-.174.1-.259.15s-.194.115-.295.172a.63.63 0 0 1 .634.06c.106.065.204.143.29.232l-.293.173a1.159 1.159 0 0 1 .53.919.372.372 0 0 1-.154.342l.493-.285c.007.048.011.097.012.146a.61.61 0 0 1-.258.565l.736-.426a.618.618 0 0 0 .258-.566 1.941 1.941 0 0 0-.881-1.527z"
            fill="#3B3B3B"
        />
        <path
            d="m903.02 322.27.735-.429a.366.366 0 0 0-.156.34 1.156 1.156 0 0 0 .533.92l-.734.431a1.17 1.17 0 0 1-.533-.924.354.354 0 0 1 .155-.338z"
            fill="#4C4C4C"
        />
        <path
            d="M903.4 321.9c-.492-.28-.888-.054-.888.5a1.934 1.934 0 0 0 .881 1.529c.487.28.883.054.885-.506a1.96 1.96 0 0 0-.878-1.523zm-.005 1.631a1.18 1.18 0 0 1-.379-.397 1.18 1.18 0 0 1-.154-.527c0-.338.238-.475.535-.3a1.165 1.165 0 0 1 .53.919c0 .336-.241.474-.532.305z"
            fill="#4C4C4C"
        />
        <path
            d="M903.4 322.31c-.3-.173-.535-.036-.535.3a1.16 1.16 0 0 0 .533.924c.291.169.532.031.532-.307a1.155 1.155 0 0 0-.53-.917z"
            fill="#7B7B7B"
        />
        <path
            d="M891.25 314.03a.632.632 0 0 0-.629-.063c-.061.036-.125.073-.183.109a17.17 17.17 0 0 0-.258.15c-.1.055-.195.113-.295.171a.616.616 0 0 1 .627.06c.109.065.21.144.3.234l-.3.17c.155.1.284.236.377.395.092.16.145.34.155.524a.367.367 0 0 1-.156.342l.494-.287c.008.049.012.099.013.149a.609.609 0 0 1-.26.564l.738-.427a.615.615 0 0 0 .256-.566 1.936 1.936 0 0 0-.879-1.525z"
            fill="#3B3B3B"
        />
        <path
            d="M890.51 314.46c-.486-.282-.883-.054-.885.505a1.945 1.945 0 0 0 .881 1.526c.488.281.887.055.887-.5a1.95 1.95 0 0 0-.883-1.531zm0 1.63a1.171 1.171 0 0 1-.53-.923c0-.337.241-.473.534-.3a1.168 1.168 0 0 1 .532.919c-.006.336-.245.475-.54.304h.004z"
            fill="#4C4C4C"
        />
        <path
            d="M890.51 314.86c-.293-.17-.534-.034-.534.3a1.167 1.167 0 0 0 .53.923c.295.171.536.032.536-.307a1.174 1.174 0 0 0-.532-.916z"
            fill="#7B7B7B"
        />
        <path
            d="m904.67 313.02-6.041 3.512v1.163l6.043-3.508a.438.438 0 0 0 .255-.355v-1.169a.434.434 0 0 1-.257.357z"
            fill="#303030"
        />
        <path
            d="M890.06 313.02a.44.44 0 0 1-.18-.145.436.436 0 0 1-.078-.217v1.168a.435.435 0 0 0 .259.361l6.076 3.509v-1.162l-6.077-3.514z"
            fill="#3E3E3E"
        />
        <path
            d="M904.66 312.3a1.367 1.367 0 0 0-1.241 0l-6.041 3.511.005.245 6.481-3.766a.38.38 0 0 1 .355 0c.02.007.038.021.05.039s.019.039.019.061a.11.11 0 0 1-.069.1l-6.485 3.77.887.267 6.041-3.512a.387.387 0 0 0 .182-.14.385.385 0 0 0-.002-.437.377.377 0 0 0-.182-.138z"
            fill="#414141"
        />
        <path
            d="M890.5 312.29a.39.39 0 0 1 .36 0l6.527 3.766-.005-.245-6.084-3.511a1.366 1.366 0 0 0-1.241 0c-.344.2-.342.518 0 .719l6.082 3.514.885-.269-6.526-3.77a.114.114 0 0 1-.052-.04.104.104 0 0 1-.019-.063.107.107 0 0 1 .073-.101z"
            fill="#494949"
        />
        <path
            d="M904.22 312.29a.106.106 0 0 1 .069.1.107.107 0 0 1-.019.06.114.114 0 0 1-.05.04l-6.485 3.77 6.529 3.765a.11.11 0 0 1 .073.104.113.113 0 0 1-.073.105.392.392 0 0 1-.356 0l-6.525-3.767-6.484 3.767a.407.407 0 0 1-.356 0 .113.113 0 0 1-.053-.169.108.108 0 0 1 .053-.041l6.481-3.765-6.526-3.77a.107.107 0 0 1-.067-.1c0-.022.006-.043.018-.061a.111.111 0 0 1 .049-.039.386.386 0 0 1 .36 0l6.527 3.766 6.481-3.766a.376.376 0 0 1 .354.001z"
            fill="#303030"
        />
        <path
            d="M904.71 320.76a1.365 1.365 0 0 1-1.24 0l-6.082-3.509v1.166l6.08 3.509a1.36 1.36 0 0 0 1.24 0 .449.449 0 0 0 .176-.144.447.447 0 0 0 .08-.213v-1.166a.444.444 0 0 1-.254.357z"
            fill="#3E3E3E"
        />
        <path
            d="m904.71 320.04-6.083-3.51-.887-.267 6.529 3.765a.11.11 0 0 1 .073.104.113.113 0 0 1-.073.105.392.392 0 0 1-.356 0l-6.525-3.767v.781l6.082 3.509a1.362 1.362 0 0 0 1.24 0 .382.382 0 0 0 0-.72z"
            fill="#4C4C4C"
        />
        <path
            d="m897.39 316.47-6.484 3.767a.404.404 0 0 1-.356 0 .113.113 0 0 1-.053-.169.113.113 0 0 1 .053-.041l6.481-3.765-.885.269-6.043 3.508a.379.379 0 0 0-.186.581.385.385 0 0 0 .186.139 1.366 1.366 0 0 0 1.242 0l6.043-3.509.002-.78z"
            fill="#4C4C4C"
        />
        <path
            d="M891.35 320.76a1.37 1.37 0 0 1-1.242 0 .444.444 0 0 1-.258-.361v1.166a.438.438 0 0 0 .258.361 1.367 1.367 0 0 0 1.244 0l6.043-3.509v-1.166l-6.045 3.509zM898.48 313.39a.542.542 0 0 0-.306-.441 1.693 1.693 0 0 0-1.544-.018.561.561 0 0 0-.333.453l-.008 3.046c0 .022.008.043.01.067a.25.25 0 0 0 .045.118.162.162 0 0 0 .022.046.66.66 0 0 0 .064.076c.011.011.022.022.031.034a.89.89 0 0 0 .137.1 1.693 1.693 0 0 0 1.543.015.694.694 0 0 0 .141-.1c.015-.011.024-.025.037-.034.025-.026.05-.05.07-.074a.459.459 0 0 0 .024-.05.324.324 0 0 0 .036-.069.254.254 0 0 0 .01-.055.221.221 0 0 0 .013-.067l.008-3.047z"
            fill="#303030"
        />
        <path
            d="M897.78 310.69a.861.861 0 0 0-.785-.005.289.289 0 0 0-.17.226v2.311a.09.09 0 0 1 .007.027c0 .009.011.021.015.035l.015.024a.108.108 0 0 0 .03.034.1.1 0 0 0 .016.02c.022.02.046.037.071.053.12.063.254.096.39.097a.857.857 0 0 0 .391-.088.352.352 0 0 0 .087-.066.325.325 0 0 0 .041-.042.135.135 0 0 1 .015-.026.15.15 0 0 0 .016-.034.087.087 0 0 0 .005-.028.18.18 0 0 0 .006-.032v-2.28a.274.274 0 0 0-.15-.226z"
            fill="#969696"
        />
        <path
            d="M903.31 292.19a2.278 2.278 0 0 1 1.055 2.15l-.22.936c-.105.448-.157 3.534-.157 4.057l-.016 4.87c0 .365-.261.51-.575.328l-6.748-3.9a1.26 1.26 0 0 1-.57-.986l.015-4.869c0-.526-.053-3.671-.154-4.241l-.212-1.18c-.157-.881.361-1.33 1.063-.927l6.519 3.762z"
            fill="#ADADAD"
        />
        <path
            d="m905.02 291.19-6.52-3.762a.763.763 0 0 0-.773-.076l-1.713.994a.763.763 0 0 1 .774.077l6.519 3.763a2.278 2.278 0 0 1 1.055 2.15l-.22.936c-.105.448-.157 3.534-.157 4.057l-.016 4.87a.41.41 0 0 1-.035.207.41.41 0 0 1-.135.16l1.716-.994a.406.406 0 0 0 .167-.371l.014-4.866c0-.527.053-3.612.164-4.061l.216-.932a2.278 2.278 0 0 0-1.056-2.152z"
            fill="#969696"
        />
        <path
            d="m903.24 306.2-7.757-4.479a.648.648 0 0 0-.651-.064l-7.72 4.447a.635.635 0 0 1 .335-.056.632.632 0 0 1 .317.122l7.757 4.48a1.994 1.994 0 0 1 .913 1.58.627.627 0 0 1-.268.589c1.9-1.107 5.819-3.341 7.722-4.448a.645.645 0 0 0 .265-.588 2.021 2.021 0 0 0-.265-.902 2.01 2.01 0 0 0-.648-.681z"
            fill="silver"
        />
        <path
            d="M895.53 310.65a2.005 2.005 0 0 1 .913 1.58c0 .583-.412.817-.92.524l-7.758-4.478a2.017 2.017 0 0 1-.911-1.583c0-.581.411-.813.919-.523l7.757 4.48z"
            fill="#ADADAD"
        />
        <path
            d="M887.54 295.63c.911-1.014 3.493-3.986 3.493-3.986s2.616-4.647 1.3-5.329c-1.3-.674-2.1-.4-3.717 2.105-.379.591-3.762 4.969-4.209 5.463a3.818 3.818 0 0 0-.716 2.642s.983 2.284 3.849-.895z"
            fill="#3A566D"
        />
        <path
            d="m896.73 288.1 1.189-.691-.037 16.241-1.193.692.041-16.242z"
            fill="#894E0E"
        />
        <path
            d="m895.3 287.27 1.191-.689 1.421.82-1.189.691-1.423-.822z"
            fill="#995710"
        />
        <path
            d="m896.73 288.1-.041 16.242-1.422-.82.04-16.245 1.423.823z"
            fill="#5F360A"
        />
        <path
            d="m893.42 302.47 1.588-.925 1.423.822-1.59.923-1.421-.82z"
            fill="#995710"
        />
        <path
            d="m887.24 307.7 1.586-.924-.039 13.99-1.588.924.041-13.99z"
            fill="#894E0E"
        />
        <path
            d="m885.82 306.88 1.587-.924 1.421.82-1.586.924-1.422-.82z"
            fill="#995710"
        />
        <path
            d="m887.24 307.7-.041 13.99-1.422-.82.041-13.99 1.422.82z"
            fill="#5F360A"
        />
        <path
            d="m885.78 318.5-.828.707s-3.809 1.845-4.055 1.937a.63.63 0 0 0-.425.556.465.465 0 0 0 .083.3c.339.371.806.6 1.307.642 1.17.063 2.343-.02 3.492-.248.264-.123 1.822-.394 1.948-.494 0 0 .482-.012.581.187a1.72 1.72 0 0 1-.037.469l1.447-.558a3.75 3.75 0 0 0 .258-1.027l.258-2.031-4.029-.44z"
            fill="#545454"
        />
        <path
            d="M880.54 321.84c.355.386.837.632 1.358.693a8.708 8.708 0 0 0 3.942-.565 5.343 5.343 0 0 1 1.567-.309s.5.052.477.426c0 .079.032.023.017.11a.227.227 0 0 0-.01-.1c-.1-.2-.506.08-.506.08-.164-.18-.045-.377-1.21-.02a10.6 10.6 0 0 1-3.985.759 2.566 2.566 0 0 1-1.664-.827.52.52 0 0 1-.05-.426c.017.061.038.121.064.179z"
            fill="#282827"
        />
        <path
            d="m887.89 322.01 1.568-.6a5.005 5.005 0 0 1-.159.588l-1.448.561c.008-.044.035-.422.039-.549zM898.92 299.04l-5.658 1.648-7.933 5.551s-1.656.856-1.375 3.821c.241 2.546.451 9.337.451 9.337.008.62.281.816.783 1.083 3.066 1.62 4.636.34 4.636.34.245-.14.226-.306.245-.521l-.157-10.13 5.855-3.215s2.809-1.264 2.989-3.411c.072-.881.164-4.503.164-4.503z"
            fill="#282827"
        />
        <path
            d="m888.44 321.17-2.515 2.114s-1.27 1.019-1.741 1.289a.847.847 0 0 0-.372.662.593.593 0 0 0 .148.459c.401.341.883.572 1.4.672a4.542 4.542 0 0 0 2.976-.583c.25-.159 1.916-1.232 2.04-1.333.351-.278.664-.388.789-.2 0 0-.016.459-.016.527l1.4-.963c.047-.274.077-.551.089-.829v-2.045l-4.198.23z"
            fill="#282827"
        />
        <path
            d="m888.44 320.87-2.515 2.112s-1.27 1.02-1.741 1.293a.825.825 0 0 0-.265.286.82.82 0 0 0-.107.374.597.597 0 0 0 .148.458c.4.342.883.573 1.4.671a4.548 4.548 0 0 0 2.976-.583c.25-.154 1.916-1.232 2.04-1.332.351-.28.664-.388.789-.2 0 0-.016.459-.016.524l1.4-.961c.047-.275.077-.552.089-.831v-2.045l-4.198.234z"
            fill="#545454"
        />
        <path
            d="m901.16 301.16-5.225 1.608-7.645 5.437s-1.669.66-1.522 3.646c.1 1.852.228 1.963.478 9.645.007.617.423.927.927 1.191 3.069 1.624 4.324.215 4.324.215.248-.141.223-.3.248-.522l-.155-9.307c-.01-.623.051-.866.6-1.166l5.254-2.869s2.809-1.27 2.987-3.412c.071-.883-.271-4.466-.271-4.466z"
            fill="#383736"
        />
        <path
            d="M890.96 286.3c-.845 1.844-1.229 3.366-1.009 6.941l.967 12.371a1.675 1.675 0 0 0 .648 1.418s3.653 1.553 5.529 1.293a9.543 9.543 0 0 0 3.674-1.523 2.697 2.697 0 0 0 .837-2.474s.488-10.755.062-13.944a2.855 2.855 0 0 0-1.183-1.7c-.586-.449-4.1-2.66-4.1-2.66l-2.794-.663s-2.059-.314-2.631.941z"
            fill="#4D6B89"
        />
        <path
            d="M892.42 290.07c-.577-.728-.617-3.637.52-4.743.218-.005.436.007.652.034l2.794.663s.659.388 1.461.926c-.378.033-1.222 1.2-2.424 2.495-1.126 1.206-2.207 1.638-3.003.625z"
            fill="#BDCCD1"
        />
        <path
            d="M892.87 287.48c1.611 1.317 2.322-.287 3.166-1.515l-.231-4.092-3.273 1.31.338 4.297z"
            fill="#E8C5AC"
        />
        <path
            d="M895.95 284.59s.057.549.045.647c-.214 1.69-2.191 2.5-2.191 2.5-.248.152-.212.454-.148.849l.224 1.161c.061.379.257.328.4.161 0 0 1.449-1.433 1.852-1.906.944-1.118.843-1.349.363-2.646-.289-.783-.545-.766-.545-.766zM893.32 287.71a.338.338 0 0 1 .092.107.354.354 0 0 1-.031.399l-.543.9c-.287.4-.344.092-.373-.215l-.22-2.233c.041-1.42.411-1.51.411-1.51.026.204.037.41.033.616a2.97 2.97 0 0 0 .631 1.936z"
            fill="#EDEDED"
        />
        <path
            d="M894.53 279.66a.913.913 0 0 0-.876.854l.1 1.672s.063.359.379.406c.481.068.661-.358.845-.828.01-.026.237-.716.254-.757.2-.583.091-1.399-.702-1.347z"
            fill="#FFE8D9"
        />
        <path
            d="m891.63 278.13 3.2-.348.706 5.773c0 .4.058.757.032 1.1a1.66 1.66 0 0 1-.57 1.127 7.516 7.516 0 0 1-1.459 1.12c-.321.199-.689.31-1.066.322a4.78 4.78 0 0 1-1.016-.334 1.864 1.864 0 0 1-1.173-.984 10.49 10.49 0 0 1-.619-1.534l-.839-3.376-.56-3.063 3.364.197z"
            fill="#FFE1CC"
        />
        <path
            d="M888.84 277.22c-.843.605-1.191 1.328-.587 2.671.487 1.09.641 1.3.628 1.314s-.127-.758-.2-1.21c-.106-.677.613-.533.922-.341.455.277 1.5.772 1.534.784.388.169.444 0 .442-.266 0-.062-.039-.411-.039-.411.051.028.947.328 1.192.439a1.45 1.45 0 0 1 .9 1.368l.045.57c.031.264.035.552.3.539.122-.005.3-.015.41-.5 0 0 .335-.988.862-.972.625.018.329 1.511.3 1.589l.016 1.917c.242.044.721-.407.949-1.1.419-1.271.669-2.177.782-2.562a4.388 4.388 0 0 0-1.284-4.763 4.391 4.391 0 0 0-4.9-.567c-.796.438-1.556.94-2.272 1.501z"
            fill="#633A11"
        />
        <path
            d="M895.14 281.2c-.785-.122-.764 1.129-.764 1.129l.1 1.4s.1.508.418.506c.372-.005.606-.3.767-.773.009-.029.249-.7.26-.745a1.12 1.12 0 0 0-.036-.941 1.116 1.116 0 0 0-.745-.576z"
            fill="#FFE8D9"
        />
        <path
            d="M886.17 300.61c-.341-.19-.348-.506-.019-.7l1.49-.914c.186-.1.392-.155.603-.161.211-.005.421.04.611.13l2.408 1.317a.373.373 0 0 1 .262.345.37.37 0 0 1-.24.36l-1.49.912a1.331 1.331 0 0 1-1.216.027l-2.409-1.316z"
            fill="#9E9D9D"
        />
        <path
            d="M889.89 307.34v.242l-.563.326v-.242l.563-.326zM890.74 306.85v.243l-.561.324v-.243l.561-.324z"
            fill="#393939"
        />
        <path
            d="m889.38 307.8.513-.3v-.17l-.513.293v.177zM890.23 307.32l.508-.3v-.17l-.511.293.003.177z"
            fill="#1C1C1C"
        />
        <path
            d="M830.51 312.9c0 .988.002 1.975.008 2.961.015 5.015 3.308 10.025 9.9 13.853l-.009-2.962c-6.588-3.825-9.885-8.834-9.899-13.852z"
            fill="#9B7049"
        />
        <path
            d="m830.51 312.9.008 2.961c.015 5.015 3.308 10.025 9.9 13.853l-.009-2.962c-6.586-3.825-9.883-8.834-9.9-13.852h.001z"
            fill="#916627"
        />
        <path
            d="m840.41 326.76.01 2.962 68.1 39.8-.007-2.962-68.103-39.8z"
            fill="#9B7049"
        />
        <path
            d="m908.51 366.56.007 2.962c13.257 7.7 34.816 7.7 48.159 0 6.714-3.875 10.07-8.964 10.056-14.046l-.01-2.961c.016 5.082-3.34 10.168-10.056 14.048-13.34 7.7-34.9 7.7-48.156 0v-.003z"
            fill="#9B7049"
        />
        <path
            d="M840.56 298.86c-13.343 7.7-13.409 20.2-.155 27.9l68.1 39.8c13.255 7.7 34.816 7.7 48.156 0s13.417-20.193.161-27.9l-68.1-39.8c-13.256-7.703-34.819-7.705-48.162 0z"
            fill="#CCA475"
        />
        <path
            d="m887.59 308.36-12.854-7.4v.37a.737.737 0 0 0 .363.63l12.124 6.981a.745.745 0 0 0 .725 0l8.871-5.235a.536.536 0 0 0 .272-.474v-.235l-9.501 5.363z"
            fill="#848484"
        />
        <path
            d="M896.87 302.69a.385.385 0 0 1 .01.682l-9.3 4.983-12.854-7.4 9.275-4.187a1.555 1.555 0 0 1 1.326.031l11.543 5.891z"
            fill="#D3D3D3"
        />
        <path
            d="M892.61 304.65c.116.067.237.346-.219.54l-4.122 2.247c-.339.212-.629.023-.945-.157l-10.859-6.258a.244.244 0 0 1-.113-.366.25.25 0 0 1 .113-.09l3.97-2.506a.7.7 0 0 1 .636-.088l11.539 6.678z"
            fill="#898686"
        />
        <path
            d="M883.44 299.44c.055.031.055.08 0 .109l-.545.319a.205.205 0 0 1-.193 0l-.551-.319c-.054-.029-.054-.078 0-.111l.549-.316a.204.204 0 0 1 .189 0l.551.318zM880.74 302.32a.06.06 0 0 1 .027.023c.007.01.011.022.011.034s-.004.024-.011.034a.053.053 0 0 1-.027.022l-.55.318a.204.204 0 0 1-.192 0l-.552-.32c-.054-.03-.054-.079 0-.111l.549-.316a.201.201 0 0 1 .191 0l.554.316zM881.7 302.87c.054.033.054.078 0 .111l-.548.319a.214.214 0 0 1-.191 0l-.553-.319c-.055-.033-.055-.078 0-.111l.549-.319a.214.214 0 0 1 .191 0l.552.319zM882.66 303.42c.054.029.054.079 0 .112l-.549.316a.2.2 0 0 1-.19 0l-.554-.318c-.012-.004-.021-.012-.028-.022s-.011-.022-.011-.034.004-.024.011-.034.016-.017.028-.022l.549-.319a.228.228 0 0 1 .193 0l.551.321zM881.53 299.5c.054.029.054.077 0 .11l-.548.319a.204.204 0 0 1-.192 0l-1.516-.876a.055.055 0 0 1-.029-.021.055.055 0 0 1 0-.069.06.06 0 0 1 .029-.021l.548-.319a.211.211 0 0 1 .19 0l1.518.877zM882.45 300c.054.034.054.082 0 .114l-.551.319c-.029.016-.062.023-.095.023s-.066-.007-.096-.023l-.55-.319c-.055-.032-.055-.08 0-.114l.55-.315a.211.211 0 0 1 .19 0l.552.315zM883.49 300.6a.054.054 0 0 1 .03.021c.008.01.012.022.012.035s-.004.025-.012.035a.06.06 0 0 1-.03.022l-.552.321a.204.204 0 0 1-.188 0l-.552-.319c-.012-.005-.022-.012-.029-.022s-.011-.023-.011-.035.004-.024.011-.035a.056.056 0 0 1 .029-.021l.547-.317a.198.198 0 0 1 .191 0l.554.315zM884.45 301.16c.056.032.056.082 0 .11l-.549.319a.191.191 0 0 1-.096.025.195.195 0 0 1-.097-.025l-.548-.315c-.052-.028-.052-.079 0-.11l.548-.318a.204.204 0 0 1 .192 0l.55.314zM885.42 301.72c.053.03.053.077 0 .111l-.55.317a.204.204 0 0 1-.188 0l-.555-.317c-.052-.034-.052-.083 0-.114l.551-.319a.219.219 0 0 1 .189 0l.553.322zM880.6 300.04a.056.056 0 0 1 .028.02c.007.01.01.022.01.034a.058.058 0 0 1-.01.033.065.065 0 0 1-.028.021l-.547.32a.216.216 0 0 1-.193 0l-1.516-.877c-.012-.005-.022-.012-.029-.022s-.01-.022-.01-.034.003-.024.01-.034.017-.017.029-.021l.553-.32a.21.21 0 0 1 .189 0l1.514.88zM881.57 300.59c.052.031.055.079 0 .11l-.55.319a.193.193 0 0 1-.187 0l-.555-.319c-.054-.031-.054-.081 0-.11l.549-.321c.03-.014.063-.022.096-.022s.066.008.096.022l.551.321zM882.56 301.18c.052.032.053.081 0 .111l-.549.32a.228.228 0 0 1-.191 0l-.553-.32c-.055-.03-.055-.079 0-.111l.551-.317c.029-.015.062-.022.095-.022s.065.007.095.022l.552.317zM883.53 301.74c.052.03.052.079 0 .112l-.547.315a.204.204 0 0 1-.192 0l-.553-.319a.058.058 0 0 1-.029-.022.055.055 0 0 1-.011-.034c0-.012.004-.024.011-.033a.058.058 0 0 1 .029-.022l.55-.319a.224.224 0 0 1 .095-.022c.034 0 .066.008.096.022l.551.322zM883.63 303.97a.07.07 0 0 1 .028.023c.006.01.01.022.01.034s-.004.024-.01.034a.06.06 0 0 1-.028.022l-.55.321a.204.204 0 0 1-.192 0l-.553-.321a.06.06 0 0 1-.028-.022c-.006-.01-.01-.022-.01-.034s.004-.024.01-.034a.07.07 0 0 1 .028-.023l.551-.316c.029-.016.062-.024.096-.024s.067.008.096.024l.552.316zM886.38 302.27c.055.031.055.081 0 .11l-.549.32a.222.222 0 0 1-.193 0l-.551-.32a.058.058 0 0 1-.028-.089.065.065 0 0 1 .028-.021l.55-.318a.211.211 0 0 1 .19 0l.553.318zM884.49 302.3c.055.03.055.08 0 .111l-.549.321a.22.22 0 0 1-.19 0l-.554-.321c-.011-.005-.021-.012-.028-.022s-.011-.022-.011-.034.004-.024.011-.034.017-.017.028-.021l.548-.319a.228.228 0 0 1 .192 0l.553.319zM885.46 302.85c.055.031.055.082 0 .109l-.547.32a.205.205 0 0 1-.193 0l-.554-.32c-.053-.027-.053-.078 0-.109l.547-.317c.03-.016.063-.025.097-.025s.067.009.097.025l.553.317zM881.64 301.75c.055.03.055.079 0 .112l-.547.316a.201.201 0 0 1-.191 0l-.555-.316c-.051-.033-.051-.082 0-.112l.551-.321a.208.208 0 0 1 .191 0l.551.321zM882.6 302.31c.055.03.055.08 0 .113l-.55.317a.204.204 0 0 1-.188 0l-.554-.318c-.054-.034-.054-.082 0-.112l.55-.318a.197.197 0 0 1 .189 0l.553.318zM883.56 302.86c.053.032.053.08 0 .111l-.545.318a.204.204 0 0 1-.097.023.203.203 0 0 1-.096-.023l-.552-.318c-.053-.031-.055-.079 0-.111l.549-.32a.22.22 0 0 1 .19 0l.551.32zM884.53 303.42c.054.029.054.079 0 .112l-.55.316a.198.198 0 0 1-.191 0l-.553-.318c-.056-.032-.056-.081 0-.11l.547-.321a.228.228 0 0 1 .192 0l.555.321zM884.59 304.54c.053.029.053.077 0 .108l-.549.319a.204.204 0 0 1-.192 0l-.551-.319c-.054-.033-.054-.081 0-.108l.549-.322a.214.214 0 0 1 .191 0l.552.322zM887.48 302.9c.051.034.053.082 0 .111l-.551.321a.208.208 0 0 1-.191 0l-.55-.321c-.055-.03-.055-.081 0-.111l.549-.318a.22.22 0 0 1 .19 0l.553.318zM886.42 303.41c.054.031.054.08 0 .109l-.551.318a.198.198 0 0 1-.191 0l-.553-.316c-.012-.004-.021-.011-.028-.021s-.011-.022-.011-.034.004-.024.011-.034.016-.018.028-.022l.553-.323a.23.23 0 0 1 .093-.021.23.23 0 0 1 .094.021l.555.323zM885.5 303.97a.053.053 0 0 1 .029.022.06.06 0 0 1 0 .069.064.064 0 0 1-.029.022l-.55.321a.208.208 0 0 1-.19 0l-.556-.321a.06.06 0 0 1-.027-.023c-.007-.01-.011-.022-.011-.034s.004-.024.011-.034a.053.053 0 0 1 .027-.022l.551-.316a.198.198 0 0 1 .191 0l.554.316zM877.88 300.63a.06.06 0 0 1 .029.091.06.06 0 0 1-.029.021l-.551.319a.197.197 0 0 1-.189 0l-.555-.319a.053.053 0 0 1-.027-.022c-.007-.01-.01-.022-.01-.034s.003-.023.01-.033a.06.06 0 0 1 .027-.023l.551-.319a.204.204 0 0 1 .189 0l.555.319zM878.8 301.16c.054.031.055.081 0 .11l-.548.319a.204.204 0 0 1-.192 0l-.553-.319c-.011-.005-.02-.012-.027-.022s-.01-.022-.01-.033c0-.012.003-.024.01-.034s.016-.017.027-.021l.551-.318a.18.18 0 0 1 .189 0l.553.318zM879.76 301.72c.011.004.021.012.028.022s.011.022.011.034-.004.024-.011.034-.017.017-.028.021l-.55.318a.204.204 0 0 1-.189 0l-.555-.318a.053.053 0 0 1-.027-.022c-.007-.01-.01-.021-.01-.033a.059.059 0 0 1 .037-.056l.551-.32a.216.216 0 0 1 .189 0l.554.32zM888.41 302.36c.011.003.021.011.028.021s.011.021.011.034a.055.055 0 0 1-.011.033.06.06 0 0 1-.028.022l-.549.321a.229.229 0 0 1-.193 0l-4.409-2.546c-.053-.034-.053-.085 0-.114l.549-.316a.2.2 0 0 1 .19 0l4.412 2.545zM889.39 302.93c.056.032.056.081 0 .113l-.548.318a.23.23 0 0 1-.094.021.238.238 0 0 1-.094-.021l-.556-.318c-.054-.032-.054-.081 0-.113l.55-.318a.206.206 0 0 1 .094-.022c.033 0 .065.007.094.022l.554.318zM890.37 303.51c.055.032.055.081 0 .11l-.549.32a.216.216 0 0 1-.189 0l-.553-.32c-.054-.029-.054-.078 0-.11l.549-.32a.204.204 0 0 1 .188 0l.554.32zM888.42 303.48c.053.031.053.081 0 .109l-.55.321a.2.2 0 0 1-.191 0l-.555-.321a.058.058 0 0 1-.028-.021c-.006-.01-.01-.021-.01-.033s.004-.024.01-.033a.06.06 0 0 1 .028-.022l.551-.319a.228.228 0 0 1 .192 0l.553.319zM878.77 300.02c.051.031.051.078 0 .108l-.55.321a.219.219 0 0 1-.189 0l-.554-.321c-.054-.03-.054-.077 0-.111l.549-.317a.211.211 0 0 1 .19 0l.554.32zM879.73 300.58c.056.033.056.08 0 .111l-.546.319c-.03.014-.063.022-.096.022s-.066-.008-.096-.022l-.554-.319c-.052-.031-.053-.078 0-.111l.549-.318a.197.197 0 0 1 .189 0l.554.318zM880.7 301.14a.053.053 0 0 1 .027.022c.007.01.01.022.01.034s-.003.023-.01.033a.06.06 0 0 1-.027.023l-.552.32a.216.216 0 0 1-.189 0l-.551-.32c-.056-.033-.056-.08 0-.112l.551-.317a.193.193 0 0 1 .187 0l.554.317zM887.4 304.04c.053.031.053.078 0 .11l-.55.317a.21.21 0 0 1-.096.024.21.21 0 0 1-.095-.024l-.553-.317c-.054-.032-.054-.081 0-.11l.549-.321c.03-.015.063-.022.096-.022s.066.007.096.022l.553.321zM888.48 304.59c.053.031.053.082 0 .111l-.549.318a.208.208 0 0 1-.191 0l-.553-.32a.058.058 0 0 1-.028-.089.06.06 0 0 1 .028-.022l.551-.32a.223.223 0 0 1 .189 0l.553.322zM890.35 305.68a.058.058 0 0 1 .039.056c0 .012-.003.024-.01.034s-.017.017-.029.021l-.552.319a.2.2 0 0 1-.19 0l-1.516-.875c-.054-.032-.054-.08 0-.113l.549-.316a.197.197 0 0 1 .189 0l1.52.874zM886.46 304.54c.051.029.051.077 0 .108l-.55.319a.197.197 0 0 1-.189 0l-.555-.319c-.053-.033-.053-.081 0-.108l.549-.322a.211.211 0 0 1 .096-.022c.033 0 .066.007.096.022l.553.322zM887.44 305.13a.053.053 0 0 1 .029.022.06.06 0 0 1 0 .069.064.064 0 0 1-.029.022l-.551.317a.182.182 0 0 1-.189 0l-.553-.317c-.052-.032-.054-.08 0-.113l.549-.316a.199.199 0 0 1 .192 0l.552.316zM889.35 306.21c.054.033.054.08 0 .109l-.547.321a.228.228 0 0 1-.191 0l-1.519-.878c-.053-.032-.053-.08 0-.109l.55-.318a.196.196 0 0 1 .188 0l1.519.875zM885.55 305.06c.055.032.055.08 0 .111l-.548.318a.204.204 0 0 1-.189 0l-.555-.32c-.052-.029-.052-.078 0-.109l.549-.321a.21.21 0 0 1 .192 0l.551.321zM888.44 306.74c.056.031.056.081 0 .111l-.549.32c-.03.014-.063.022-.096.022s-.066-.008-.096-.022l-1.516-.876c-.055-.032-.055-.082 0-.112l.548-.318a.197.197 0 0 1 .19 0l1.519.875zM891.33 304.06c.054.029.054.079 0 .109l-.549.318a.199.199 0 0 1-.192 0l-.551-.318c-.053-.03-.053-.08 0-.109l.546-.319c.03-.016.063-.025.097-.025s.067.009.097.025l.552.319zM892.31 304.61c.056.028.056.079 0 .109l-.547.32a.211.211 0 0 1-.191 0l-.554-.321c-.053-.029-.055-.08 0-.108l.551-.319a.208.208 0 0 1 .19 0l.551.319z"
            fill="#4A4A4A"
        />
        <path
            d="m890.58 304.49-.551-.318a.066.066 0 0 1-.029-.021.071.071 0 0 1-.013-.034v.111c0 .017.015.037.042.055l.551.32v-.113z"
            fill="#636363"
        />
        <path
            d="M891.37 304.12a.063.063 0 0 1-.012.033.06.06 0 0 1-.028.022l-.549.318a.199.199 0 0 1-.192 0v.113a.228.228 0 0 0 .192 0l.548-.32a.073.073 0 0 0 .041-.055v-.111z"
            fill="#3D3D3D"
        />
        <path
            d="m891.57 305.04-.554-.321a.067.067 0 0 1-.028-.022.054.054 0 0 1-.011-.032v.109a.062.062 0 0 0 .013.034c.007.01.017.017.029.022l.554.319-.003-.109z"
            fill="#636363"
        />
        <path
            d="M892.35 304.67a.068.068 0 0 1-.011.031.055.055 0 0 1-.026.019l-.549.321a.204.204 0 0 1-.191 0v.109a.204.204 0 0 0 .191 0l.549-.319a.058.058 0 0 0 .027-.022.067.067 0 0 0 .01-.034v-.105z"
            fill="#3D3D3D"
        />
        <path
            d="m882.7 299.87-.551-.319c-.011-.005-.021-.012-.028-.022s-.01-.022-.011-.034v.111a.07.07 0 0 0 .039.057l.551.319v-.112z"
            fill="#636363"
        />
        <path
            d="M883.48 299.5a.06.06 0 0 1-.013.033.07.07 0 0 1-.03.02l-.545.319a.215.215 0 0 1-.193 0v.112a.229.229 0 0 0 .193 0l.545-.319a.068.068 0 0 0 .043-.057v-.108z"
            fill="#3D3D3D"
        />
        <path
            d="m879.99 302.74-.554-.318a.08.08 0 0 1-.04-.056v.109c0 .021.015.039.04.057l.554.318v-.11z"
            fill="#636363"
        />
        <path
            d="M880.77 302.36a.068.068 0 0 1-.013.033.067.067 0 0 1-.026.024l-.548.317a.199.199 0 0 1-.192 0v.11a.199.199 0 0 0 .192 0l.548-.318c.023-.018.039-.035.039-.057v-.109z"
            fill="#3D3D3D"
        />
        <path
            d="m880.96 303.29-.553-.318c-.029-.015-.042-.035-.04-.056v.111c0 .021.013.04.041.063l.554.321-.002-.121z"
            fill="#636363"
        />
        <path
            d="M881.74 302.92c-.001.013-.005.024-.012.034s-.017.018-.028.022l-.548.318a.201.201 0 0 1-.191 0v.11a.201.201 0 0 0 .191 0l.548-.319c.011-.005.02-.012.027-.022s.012-.022.013-.034v-.109z"
            fill="#3D3D3D"
        />
        <path
            d="m881.92 303.85-.554-.318a.058.058 0 0 1-.026-.023.063.063 0 0 1-.012-.032v.108a.085.085 0 0 0 .011.034c.007.01.016.018.027.024l.553.318.001-.111z"
            fill="#636363"
        />
        <path
            d="M882.7 303.47a.07.07 0 0 1-.039.057l-.549.316c-.029.015-.062.024-.095.024s-.066-.009-.095-.024v.111c.03.014.062.022.095.022a.225.225 0 0 0 .096-.022l.549-.318c.011-.005.02-.013.027-.023s.011-.021.012-.033l-.001-.11z"
            fill="#3D3D3D"
        />
        <path
            d="m880.79 299.92-1.516-.876a.062.062 0 0 1-.027-.021.07.07 0 0 1-.014-.033v.109a.07.07 0 0 0 .012.034.072.072 0 0 0 .029.02l1.516.88v-.113z"
            fill="#636363"
        />
        <path
            d="M881.57 299.55a.067.067 0 0 1-.041.055l-.548.319a.204.204 0 0 1-.192 0v.113a.222.222 0 0 0 .189 0l.551-.32a.076.076 0 0 0 .028-.022.071.071 0 0 0 .013-.034v-.111z"
            fill="#3D3D3D"
        />
        <path
            d="m881.71 300.44-.55-.319a.066.066 0 0 1-.029-.023.066.066 0 0 1-.011-.035v.112c.002.012.007.023.014.033s.017.018.028.023l.55.318-.002-.109z"
            fill="#636363"
        />
        <path
            d="M882.49 300.06a.072.072 0 0 1-.013.033.087.087 0 0 1-.027.023l-.551.319a.212.212 0 0 1-.191 0v.109a.21.21 0 0 0 .095.024.21.21 0 0 0 .096-.024l.551-.318a.087.087 0 0 0 .027-.023.08.08 0 0 0 .013-.032v-.111z"
            fill="#3D3D3D"
        />
        <path
            d="m882.75 301.03-.552-.319a.058.058 0 0 1-.028-.021.065.065 0 0 1-.014-.033v.109c.001.012.006.024.013.034s.016.018.027.023l.553.316.001-.109z"
            fill="#636363"
        />
        <path
            d="M883.53 300.66a.064.064 0 0 1-.01.033.062.062 0 0 1-.027.021l-.552.321a.193.193 0 0 1-.188 0v.109a.197.197 0 0 0 .189 0l.552-.316a.068.068 0 0 0 .037-.055l-.001-.113z"
            fill="#3D3D3D"
        />
        <path
            d="m883.71 301.59-.551-.315c-.011-.005-.02-.012-.027-.022s-.012-.021-.013-.033v.11a.068.068 0 0 0 .013.033.062.062 0 0 0 .027.021l.551.319v-.113z"
            fill="#636363"
        />
        <path
            d="M884.49 301.21a.076.076 0 0 1-.011.033.078.078 0 0 1-.026.022l-.549.319a.195.195 0 0 1-.097.025.191.191 0 0 1-.096-.025v.109a.191.191 0 0 0 .096.025.195.195 0 0 0 .097-.025l.549-.317c.023-.016.037-.032.037-.053v-.113z"
            fill="#3D3D3D"
        />
        <path
            d="m884.68 302.15-.555-.317a.077.077 0 0 1-.039-.058v.111a.08.08 0 0 0 .013.032.096.096 0 0 0 .026.023l.555.32v-.111z"
            fill="#636363"
        />
        <path
            d="M885.46 301.77c0 .021-.013.039-.04.057l-.55.317a.207.207 0 0 1-.188 0v.111a.204.204 0 0 0 .188 0l.55-.32c.01-.004.019-.012.026-.022s.011-.021.012-.033l.002-.11z"
            fill="#3D3D3D"
        />
        <path
            d="m879.86 300.46-1.516-.877a.06.06 0 0 1-.028-.022.065.065 0 0 1-.011-.033v.111c0 .012.005.023.011.033a.065.065 0 0 0 .028.021l1.516.879v-.112z"
            fill="#636363"
        />
        <path
            d="M880.64 300.09c0 .013-.005.024-.012.034s-.017.018-.029.022l-.547.32a.205.205 0 0 1-.193 0v.112a.229.229 0 0 0 .193 0l.547-.319a.06.06 0 0 0 .028-.022.057.057 0 0 0 .013-.033v-.114z"
            fill="#3D3D3D"
        />
        <path
            d="m880.83 301.02-.555-.319a.058.058 0 0 1-.027-.022.063.063 0 0 1-.012-.033v.108a.07.07 0 0 0 .012.034c.006.01.016.017.027.021l.552.32.003-.109z"
            fill="#636363"
        />
        <path
            d="M881.61 300.65a.06.06 0 0 1-.011.034.065.065 0 0 1-.028.021l-.55.319a.192.192 0 0 1-.187 0v.109a.197.197 0 0 0 .19 0l.55-.32a.054.054 0 0 0 .028-.019.057.057 0 0 0 .011-.033l-.003-.111z"
            fill="#3D3D3D"
        />
        <path
            d="m881.82 301.61-.553-.32a.07.07 0 0 1-.039-.057v.112c.002.012.006.023.013.033s.016.018.026.023l.552.318.001-.109z"
            fill="#636363"
        />
        <path
            d="M882.6 301.24a.057.057 0 0 1-.011.033.056.056 0 0 1-.026.022l-.549.32a.214.214 0 0 1-.191 0v.109a.215.215 0 0 0 .192 0l.549-.318c.011-.005.02-.013.026-.023s.01-.021.011-.033l-.001-.11z"
            fill="#3D3D3D"
        />
        <path
            d="m882.79 302.17-.553-.32a.058.058 0 0 1-.027-.022.063.063 0 0 1-.012-.033v.109c0 .013.004.025.011.035s.017.019.028.023l.553.318v-.11z"
            fill="#636363"
        />
        <path
            d="M883.56 301.79a.07.07 0 0 1-.039.057l-.547.316a.201.201 0 0 1-.192 0v.11a.197.197 0 0 0 .189 0l.55-.318a.067.067 0 0 0 .027-.023.072.072 0 0 0 .011-.033l.001-.109z"
            fill="#3D3D3D"
        />
        <path
            d="m882.88 304.41-.553-.321a.056.056 0 0 1-.027-.021.06.06 0 0 1-.012-.032v.108c0 .012.004.023.011.033.006.01.015.017.026.022l.555.32v-.109z"
            fill="#636363"
        />
        <path
            d="M883.66 304.04a.064.064 0 0 1-.011.03.072.072 0 0 1-.025.021l-.55.321a.215.215 0 0 1-.192 0v.109a.225.225 0 0 0 .192 0l.55-.32a.059.059 0 0 0 .025-.022.058.058 0 0 0 .011-.031v-.108z"
            fill="#3D3D3D"
        />
        <path
            d="m885.64 302.7-.551-.32c-.012-.005-.022-.012-.029-.022s-.012-.022-.013-.034v.109a.07.07 0 0 0 .04.059l.553.317v-.109z"
            fill="#636363"
        />
        <path
            d="M886.42 302.33a.073.073 0 0 1-.012.033.074.074 0 0 1-.027.023l-.549.32a.229.229 0 0 1-.193 0v.109a.208.208 0 0 0 .191 0l.551-.317a.088.088 0 0 0 .027-.024.091.091 0 0 0 .012-.035v-.109z"
            fill="#3D3D3D"
        />
        <path
            d="m883.75 302.73-.554-.321a.06.06 0 0 1-.027-.023.066.066 0 0 1-.012-.033v.111a.063.063 0 0 0 .012.032c.007.01.016.017.027.022l.554.318v-.106z"
            fill="#636363"
        />
        <path
            d="M884.53 302.35a.064.064 0 0 1-.013.032.067.067 0 0 1-.028.022l-.549.321a.223.223 0 0 1-.19 0v.106a.208.208 0 0 0 .19 0l.548-.318a.072.072 0 0 0 .029-.02.068.068 0 0 0 .013-.032v-.111z"
            fill="#3D3D3D"
        />
        <path
            d="m884.72 303.28-.554-.32a.066.066 0 0 1-.039-.055v.111a.07.07 0 0 0 .012.034.073.073 0 0 0 .027.022l.554.321v-.113z"
            fill="#636363"
        />
        <path
            d="M885.5 302.91c-.001.012-.006.023-.013.033s-.016.017-.027.022l-.547.32a.216.216 0 0 1-.193 0v.113a.214.214 0 0 0 .191 0l.549-.321c.026-.017.04-.035.04-.056v-.111z"
            fill="#3D3D3D"
        />
        <path
            d="m880.9 302.18-.555-.316a.078.078 0 0 1-.026-.025.08.08 0 0 1-.011-.034v.109c0 .012.004.024.011.034s.016.018.028.022l.555.321-.002-.111z"
            fill="#636363"
        />
        <path
            d="M881.68 301.8a.06.06 0 0 1-.011.035.067.067 0 0 1-.029.024l-.547.316a.208.208 0 0 1-.191 0v.111a.208.208 0 0 0 .191 0l.547-.321c.012-.004.021-.011.028-.021s.012-.021.012-.033v-.111z"
            fill="#3D3D3D"
        />
        <path
            d="m881.86 302.74-.554-.318a.07.07 0 0 1-.028-.023.073.073 0 0 1-.014-.034v.108c0 .023.016.041.042.059l.554.318v-.11z"
            fill="#636363"
        />
        <path
            d="M882.64 302.36a.06.06 0 0 1-.013.034.063.063 0 0 1-.028.023l-.55.317a.193.193 0 0 1-.188 0v.11a.196.196 0 0 0 .188 0l.55-.318c.027-.018.041-.035.041-.057v-.109z"
            fill="#3D3D3D"
        />
        <path
            d="m882.83 303.29-.552-.318c-.011-.004-.021-.012-.028-.022s-.011-.021-.012-.034v.111a.078.078 0 0 0 .013.034c.008.01.017.018.028.022l.552.317-.001-.11z"
            fill="#636363"
        />
        <path
            d="M883.61 302.92a.06.06 0 0 1-.014.034.058.058 0 0 1-.029.022l-.545.318a.204.204 0 0 1-.193 0v.11a.205.205 0 0 0 .193 0l.545-.317a.076.076 0 0 0 .043-.056v-.111z"
            fill="#3D3D3D"
        />
        <path
            d="m883.79 303.85-.553-.318a.085.085 0 0 1-.028-.022.066.066 0 0 1-.012-.033v.108a.07.07 0 0 0 .04.058l.553.318v-.111z"
            fill="#636363"
        />
        <path
            d="M884.57 303.47a.078.078 0 0 1-.04.057l-.55.316a.198.198 0 0 1-.191 0v.111a.22.22 0 0 0 .095.022.22.22 0 0 0 .094-.022l.55-.318a.07.07 0 0 0 .028-.023.06.06 0 0 0 .013-.033l.001-.11z"
            fill="#3D3D3D"
        />
        <path
            d="m883.85 304.96-.551-.319c-.011-.005-.02-.012-.027-.022s-.012-.021-.013-.033v.111c.001.012.006.023.013.032s.016.016.027.02l.551.323v-.112z"
            fill="#636363"
        />
        <path
            d="M884.63 304.59a.07.07 0 0 1-.013.032.068.068 0 0 1-.026.022l-.549.319a.199.199 0 0 1-.192 0v.112a.21.21 0 0 0 .192 0l.549-.32a.071.071 0 0 0 .026-.023.083.083 0 0 0 .013-.032v-.11z"
            fill="#3D3D3D"
        />
        <path
            d="m886.61 303.26-.555-.32a.066.066 0 0 1-.039-.055v.111a.068.068 0 0 0 .041.055l.555.318-.002-.109z"
            fill="#636363"
        />
        <path
            d="M887.52 302.96a.064.064 0 0 1-.01.033.054.054 0 0 1-.026.021l-.551.321a.208.208 0 0 1-.191 0v.11a.228.228 0 0 0 .191 0l.551-.319a.067.067 0 0 0 .036-.054v-.112z"
            fill="#3D3D3D"
        />
        <path
            d="m885.68 303.84-.553-.316a.06.06 0 0 1-.027-.023.073.073 0 0 1-.012-.035v.111a.063.063 0 0 0 .012.033c.007.01.016.018.027.022l.553.322v-.114z"
            fill="#636363"
        />
        <path
            d="M886.46 303.46a.08.08 0 0 1-.011.034.064.064 0 0 1-.027.022l-.551.318a.198.198 0 0 1-.191 0v.114a.223.223 0 0 0 .191 0l.551-.322a.066.066 0 0 0 .026-.021.082.082 0 0 0 .012-.032v-.113z"
            fill="#3D3D3D"
        />
        <path
            d="m884.76 304.41-.556-.321a.075.075 0 0 1-.026-.021.078.078 0 0 1-.012-.032v.108a.066.066 0 0 0 .038.055l.554.32.002-.109z"
            fill="#636363"
        />
        <path
            d="M885.54 304.04c-.002.011-.006.021-.013.03s-.016.016-.026.021l-.55.321a.211.211 0 0 1-.19 0v.109a.225.225 0 0 0 .192 0l.55-.32a.067.067 0 0 0 .026-.021.066.066 0 0 0 .012-.032l-.001-.108z"
            fill="#3D3D3D"
        />
        <path
            d="m877.14 301.06-.555-.319a.067.067 0 0 1-.027-.023.063.063 0 0 1-.012-.033v.11a.062.062 0 0 0 .039.054l.555.318v-.107z"
            fill="#636363"
        />
        <path
            d="M877.92 300.68a.066.066 0 0 1-.012.032.067.067 0 0 1-.026.021l-.55.319a.211.211 0 0 1-.19 0v.111a.21.21 0 0 0 .189 0l.551-.32a.07.07 0 0 0 .025-.023.06.06 0 0 0 .012-.031l.001-.109z"
            fill="#3D3D3D"
        />
        <path
            d="m878.06 301.59-.553-.319c-.011-.005-.021-.013-.028-.023s-.011-.022-.011-.035v.111c.001.012.005.024.012.034s.016.018.027.024l.553.317v-.109z"
            fill="#636363"
        />
        <path
            d="M878.84 301.22c0 .012-.004.024-.011.034s-.016.018-.028.022l-.547.319a.206.206 0 0 1-.097.025.205.205 0 0 1-.096-.025v.109a.195.195 0 0 0 .193 0l.547-.317c.011-.005.021-.012.028-.022s.011-.022.011-.034v-.111z"
            fill="#3D3D3D"
        />
        <path
            d="m879.03 302.15-.555-.318a.07.07 0 0 1-.039-.057v.11a.066.066 0 0 0 .039.055l.553.321.002-.111z"
            fill="#636363"
        />
        <path
            d="M879.8 301.77c-.001.012-.006.024-.013.034s-.016.018-.027.023l-.55.318a.204.204 0 0 1-.189 0v.111a.214.214 0 0 0 .191 0l.55-.321c.011-.005.02-.012.027-.022s.012-.021.013-.033l-.002-.11z"
            fill="#3D3D3D"
        />
        <path
            d="m887.67 302.79-4.427-2.57a.07.07 0 0 1-.028-.023.073.073 0 0 1-.012-.035v.113c0 .02.012.04.058.077l4.409 2.549v-.111zM888.65 303.36l-.556-.318a.07.07 0 0 1-.041-.058v.112a.063.063 0 0 0 .041.056l.556.318v-.11z"
            fill="#636363"
        />
        <path
            d="M889.43 302.98a.063.063 0 0 1-.013.035.063.063 0 0 1-.028.023l-.548.318a.215.215 0 0 1-.188 0v.11a.196.196 0 0 0 .188 0l.548-.318a.056.056 0 0 0 .028-.022.052.052 0 0 0 .012-.034l.001-.112zM888.45 302.42c-.002.011-.006.022-.013.031s-.016.017-.026.021l-.549.32c-.03.015-.063.022-.096.022s-.066-.007-.096-.022v.111a.229.229 0 0 0 .193 0l.549-.319a.07.07 0 0 0 .027-.024.077.077 0 0 0 .012-.034l-.001-.106z"
            fill="#3D3D3D"
        />
        <path
            d="m889.63 303.94-.553-.32c-.011-.004-.021-.011-.028-.02s-.011-.021-.012-.033v.109c.001.012.005.024.012.033s.017.016.028.02l.553.322v-.111z"
            fill="#636363"
        />
        <path
            d="M890.41 303.56a.057.057 0 0 1-.013.033.056.056 0 0 1-.028.02l-.549.32a.208.208 0 0 1-.189 0v.111a.197.197 0 0 0 .189 0l.549-.322a.05.05 0 0 0 .028-.02.057.057 0 0 0 .013-.033v-.109z"
            fill="#3D3D3D"
        />
        <path
            d="M882.5 298.88c.052.032.052.079 0 .113l-.548.315a.199.199 0 0 1-.192 0l-1.519-.875c-.052-.03-.052-.079 0-.111l.549-.32a.22.22 0 0 1 .191 0l1.519.878z"
            fill="#4A4A4A"
        />
        <path
            d="m881.76 299.31-1.519-.875c-.011-.005-.02-.012-.027-.022s-.011-.022-.012-.034v.111a.063.063 0 0 0 .012.033c.007.01.016.018.027.022l1.517.877.002-.112z"
            fill="#636363"
        />
        <path
            d="M882.54 298.94a.073.073 0 0 1-.012.035.067.067 0 0 1-.027.023l-.548.315a.194.194 0 0 1-.192 0v.112a.212.212 0 0 0 .192 0l.55-.319a.078.078 0 0 0 .026-.022.083.083 0 0 0 .013-.032l-.002-.112z"
            fill="#3D3D3D"
        />
        <path
            d="m887.69 303.91-.555-.321a.064.064 0 0 1-.027-.022.06.06 0 0 1-.012-.032v.11c0 .02.015.039.039.056l.554.318.001-.109z"
            fill="#636363"
        />
        <path
            d="M888.47 303.54a.103.103 0 0 1-.014.03.075.075 0 0 1-.026.021l-.55.321a.208.208 0 0 1-.191 0v.109a.208.208 0 0 0 .191 0l.551-.32a.08.08 0 0 0 .025-.023.078.078 0 0 0 .012-.032l.002-.106z"
            fill="#3D3D3D"
        />
        <path
            d="m878.03 300.45-.554-.321a.07.07 0 0 1-.029-.022.062.062 0 0 1-.014-.032v.109a.058.058 0 0 0 .014.033c.007.01.017.018.029.023l.554.317v-.107z"
            fill="#636363"
        />
        <path
            d="M878.8 300.08a.06.06 0 0 1-.012.031.072.072 0 0 1-.026.023l-.55.321a.223.223 0 0 1-.189 0v.107a.197.197 0 0 0 .189 0l.55-.317a.083.083 0 0 0 .026-.023.066.066 0 0 0 .012-.032v-.11z"
            fill="#3D3D3D"
        />
        <path
            d="m878.99 301.01-.554-.319c-.011-.005-.02-.013-.027-.023s-.011-.022-.012-.035v.111a.07.07 0 0 0 .039.057l.554.319v-.11z"
            fill="#636363"
        />
        <path
            d="M879.77 300.63c-.001.012-.005.024-.012.034s-.017.017-.028.022l-.546.319a.212.212 0 0 1-.192 0v.11a.215.215 0 0 0 .192 0l.546-.319a.062.062 0 0 0 .027-.021.068.068 0 0 0 .013-.033v-.112z"
            fill="#3D3D3D"
        />
        <path
            d="m879.96 301.57-.551-.32a.068.068 0 0 1-.029-.022.067.067 0 0 1-.013-.034v.111a.065.065 0 0 0 .014.033c.007.01.017.017.028.021l.551.32v-.109z"
            fill="#636363"
        />
        <path
            d="M880.74 301.19a.064.064 0 0 1-.013.033.058.058 0 0 1-.027.022l-.552.32a.208.208 0 0 1-.189 0v.109a.196.196 0 0 0 .189 0l.552-.319c.01-.005.019-.012.026-.021s.011-.019.013-.031l.001-.113z"
            fill="#3D3D3D"
        />
        <path
            d="m886.64 304.4-.548-.318c-.029-.017-.042-.036-.042-.056v.108c0 .022.013.04.042.057l.548.32v-.111z"
            fill="#636363"
        />
        <path
            d="M887.44 304.09a.066.066 0 0 1-.039.055l-.55.317a.198.198 0 0 1-.191 0v.114a.228.228 0 0 0 .192 0l.548-.32a.076.076 0 0 0 .028-.022.071.071 0 0 0 .013-.034l-.001-.11z"
            fill="#3D3D3D"
        />
        <path
            d="m887.74 305.02-.553-.32a.07.07 0 0 1-.038-.058v.111c.001.012.004.024.011.034s.016.018.027.023l.553.318v-.108z"
            fill="#636363"
        />
        <path
            d="M888.52 304.64a.063.063 0 0 1-.011.035.076.076 0 0 1-.03.023l-.549.318a.208.208 0 0 1-.191 0v.108a.198.198 0 0 0 .191 0l.549-.316a.073.073 0 0 0 .029-.023.07.07 0 0 0 .012-.034v-.111z"
            fill="#3D3D3D"
        />
        <path
            d="m889.6 306.12-1.516-.875c-.027-.017-.043-.037-.043-.056v.109a.08.08 0 0 0 .014.033.08.08 0 0 0 .029.023l1.516.877v-.111z"
            fill="#636363"
        />
        <path
            d="M890.39 305.74a.073.073 0 0 1-.012.032.07.07 0 0 1-.027.021l-.552.319a.2.2 0 0 1-.19 0v.111a.226.226 0 0 0 .19 0l.552-.321a.051.051 0 0 0 .027-.021.06.06 0 0 0 .012-.032v-.109z"
            fill="#3D3D3D"
        />
        <path
            d="m885.72 304.96-.555-.319a.074.074 0 0 1-.028-.022.079.079 0 0 1-.013-.033v.111c.002.012.007.023.014.032s.016.016.027.02l.555.323v-.112z"
            fill="#636363"
        />
        <path
            d="M886.5 304.59a.057.057 0 0 1-.011.033.06.06 0 0 1-.026.021l-.55.319a.194.194 0 0 1-.189 0v.112a.204.204 0 0 0 .189 0l.55-.323a.063.063 0 0 0 .026-.02.068.068 0 0 0 .011-.031v-.111z"
            fill="#3D3D3D"
        />
        <path
            d="m886.68 305.52-.553-.317a.067.067 0 0 1-.036-.058v.111c0 .012.004.023.011.033.006.01.015.017.026.022l.554.32-.002-.111z"
            fill="#636363"
        />
        <path
            d="M887.48 305.18c-.001.012-.005.023-.012.033s-.017.018-.028.023l-.551.317a.182.182 0 0 1-.189 0v.111a.22.22 0 0 0 .095.022.22.22 0 0 0 .094-.022l.551-.319c.011-.006.02-.013.027-.023s.012-.021.013-.033v-.109z"
            fill="#3D3D3D"
        />
        <path
            d="m888.62 306.64-1.519-.878a.073.073 0 0 1-.027-.022.06.06 0 0 1-.013-.032v.109c0 .023.014.039.04.058l1.519.877v-.112z"
            fill="#636363"
        />
        <path
            d="M889.39 306.26a.066.066 0 0 1-.012.032.074.074 0 0 1-.028.021l-.547.321a.223.223 0 0 1-.191 0v.112a.22.22 0 0 0 .191 0l.547-.322c.011-.005.021-.012.028-.022s.011-.021.012-.033v-.109z"
            fill="#3D3D3D"
        />
        <path
            d="m884.81 305.49-.555-.32a.065.065 0 0 1-.028-.021.057.057 0 0 1-.011-.033v.108c.001.012.005.024.012.034s.017.018.028.023l.555.319-.001-.11z"
            fill="#636363"
        />
        <path
            d="M885.59 305.12a.06.06 0 0 1-.012.032.07.07 0 0 1-.029.022l-.548.318a.216.216 0 0 1-.189 0v.11a.204.204 0 0 0 .189 0l.548-.319a.064.064 0 0 0 .029-.022.052.052 0 0 0 .012-.033v-.108z"
            fill="#3D3D3D"
        />
        <path
            d="m885.78 306.05-.552-.318a.068.068 0 0 1-.03-.023.07.07 0 0 1-.012-.035v.114c0 .019.014.038.042.054l.552.317v-.109z"
            fill="#636363"
        />
        <path
            d="M886.56 305.67c-.001.012-.005.024-.012.034s-.016.019-.027.024l-.551.318a.2.2 0 0 1-.19 0v.109a.2.2 0 0 0 .19 0l.549-.317c.025-.016.041-.035.041-.054v-.114z"
            fill="#3D3D3D"
        />
        <path
            d="M886.52 305.62c.011.003.021.011.028.021s.011.021.011.034a.055.055 0 0 1-.011.033.06.06 0 0 1-.028.022l-.551.318a.212.212 0 0 1-.095.024.206.206 0 0 1-.095-.024l-.552-.318c-.056-.031-.056-.082 0-.111l.548-.319a.198.198 0 0 1 .191 0l.554.32z"
            fill="#4A4A4A"
        />
        <path
            d="m887.7 307.17-1.516-.876c-.011-.004-.021-.012-.028-.022s-.012-.022-.013-.035v.112a.068.068 0 0 0 .013.033.06.06 0 0 0 .027.02l1.517.876v-.108z"
            fill="#636363"
        />
        <path
            d="M888.48 306.79a.06.06 0 0 1-.013.032.056.056 0 0 1-.026.022l-.549.321c-.03.014-.063.022-.096.022s-.066-.008-.096-.022v.105a.194.194 0 0 0 .192 0l.549-.318a.056.056 0 0 0 .026-.022.06.06 0 0 0 .013-.032v-.108z"
            fill="#3D3D3D"
        />
        <path
            d="M891.31 305.14c.012.004.021.011.028.021s.011.021.011.033-.004.024-.011.033a.054.054 0 0 1-.028.021l-.55.322a.208.208 0 0 1-.191 0l-2.436-1.413c-.054-.03-.054-.078 0-.11l.55-.319a.211.211 0 0 1 .19 0l2.437 1.412z"
            fill="#4A4A4A"
        />
        <path
            d="m890.57 305.57-2.436-1.413a.06.06 0 0 1-.028-.022.063.063 0 0 1-.012-.033v.11a.063.063 0 0 0 .012.033c.007.01.016.018.027.023l2.437 1.41v-.108z"
            fill="#636363"
        />
        <path
            d="M891.35 305.2a.056.056 0 0 1-.012.031.062.062 0 0 1-.026.022l-.55.32a.208.208 0 0 1-.191 0v.11a.208.208 0 0 0 .191 0l.55-.319a.054.054 0 0 0 .026-.021.056.056 0 0 0 .01-.033l.002-.11z"
            fill="#3D3D3D"
        />
        <path
            d="M893.02 304.96c-.519.174-1.1-.413-1.256-.886-.056-.165-1.064.063-1.508-.057a.457.457 0 0 1-.28-.7 18.238 18.238 0 0 1 2.037-.15c1.316-.084 1.526.39 1.682.862s-.154.756-.675.931z"
            fill="#FFE8D9"
        />
        <path
            d="M893.19 304.43c.28.487.394.234.394.234.636.422 1.317.77 2.031 1.038a22.518 22.518 0 0 0 5.8-3.3 4.25 4.25 0 0 0 1.25-4.014s-.552-6.331-.932-7.766c-.64-2.4-3.467-1.332-3.68 1.281.109 2.323.383 4.636.819 6.92a1.583 1.583 0 0 1-.744 1.679l-3.787 2.111s-1.7.866-1.151 1.817z"
            fill="#688CAA"
        />
        <path
            d="m894.1 305.26-.443-1.37-1.79.026-.266.09-2.049.918a1.123 1.123 0 0 0-.736 1.022 1.12 1.12 0 0 0 .076.436c.226.714.02.078.02.078a1.163 1.163 0 0 0 1.4.714l2.816-.664c.582-.177 1.176-.621.972-1.25z"
            fill="#FFE8D9"
        />
        <path
            d="M892.88 302.88c-.244.1-.486.852-.241 1.605.132.494.367.954.688 1.35.335.371.6.536.922.441 0 0 1.176-.347 1.538-.472.234-.083.184-.2.184-.2a.966.966 0 0 1-.267.047c-.3-.036-.79-.3-1.216-1.216-.672-1.436.1-1.97.1-1.97-.092-.21-.215-.24-.453-.125l-1.255.54z"
            fill="#E4EFF4"
        />
        <path
            d="M888.16 297.19a9.1 9.1 0 0 0-.85-2.774c-.62-.736-1.066-1.356-2.33-.852-1.342.538-1.458 2.888-1.237 3.471.21.544 1.371 1.411 1.371 1.411l3.046-1.256z"
            fill="#3A566D"
        />
        <path
            d="M887.04 299.19c.213.5 1.036.547 1.5.351.159-.068.658.84 1.042 1.1a.458.458 0 0 0 .711-.256 17.753 17.753 0 0 0-1.239-1.624c-.807-1.045-1.3-.884-1.76-.691s-.461.614-.254 1.12z"
            fill="#FFE8D9"
        />
        <path
            d="m886.11 298.59 1.32-.576 1.167 1.359.11.257.663 2.143s.192.693-.893 1.069a1.527 1.527 0 0 1-1.792-.716l-.864-1.978c-.256-.557-.318-1.295.289-1.558z"
            fill="#FFE8D9"
        />
        <path
            d="M888.24 296.71c-.111-.232-.848-.435-1.576-.166a3.54 3.54 0 0 0-1.286.721c-.35.343-.5.61-.4.917 0 0 .381 1.124.519 1.474.09.222.2.17.2.17a.95.95 0 0 1-.055-.258c.025-.292.266-.779 1.141-1.233 1.375-.711 1.921.016 1.921.016.205-.1.227-.218.109-.441l-.573-1.2z"
            fill="#E4EFF4"
        />
        <path
            d="M875.65 291.94a.536.536 0 0 0-.547 0l-.142.086 12.37 7.284.255 9.044.3-.172v-8.587a1.1 1.1 0 0 0-.546-.945l-11.69-6.71z"
            fill="#8E8D8D"
        />
        <path
            d="M887.04 298.82a1.094 1.094 0 0 1 .548.948v8.586l-12.854-7.4v-8.584a.362.362 0 0 1 .183-.316.362.362 0 0 1 .364 0l11.759 6.766z"
            fill="#C1BFBD"
        />
        <path
            d="M948.05 332.25a9.073 9.073 0 0 0-.852-2.775c-.621-.734-1.066-1.356-2.329-.852-1.341.538-1.459 2.889-1.236 3.469.209.547 1.371 1.416 1.371 1.416l3.046-1.258z"
            fill="#3A566D"
        />
        <path
            d="M954.3 339.89c-.094.016-8.771-5.31-8.771-5.31l-6 3.616.734.449 5.281-3.147 7.96 5.063.796-.671z"
            fill="#7C7C7C"
        />
        <path
            d="M942.07 336.34a.23.23 0 0 0 .227.233.231.231 0 0 0 .231-.233.229.229 0 0 0-.458 0z"
            fill="#686868"
        />
        <path
            d="M942.12 336.35c-.081.048-.081.119 0 .167a.329.329 0 0 0 .289 0c.079-.048.079-.119 0-.167a.319.319 0 0 0-.289 0z"
            fill="#7C7C7C"
        />
        <path
            d="m939.89 338.42 8.533 4.958 5.654-3.268-8.53-4.956-5.657 3.266z"
            fill="#14AAB2"
        />
        <path
            d="M945.06 334.25a.982.982 0 0 1 .884 0l9.368 5.446c.243.14.241.369 0 .512l-6.48 3.739a.97.97 0 0 1-.883 0l-9.369-5.445a.274.274 0 0 1-.132-.098.273.273 0 0 1 .132-.412l6.48-3.742zm3.367 8.985 5.654-3.263-8.53-4.96-5.657 3.27 8.533 4.953zm3.51-1.236c.034-.011.063-.034.084-.063s.032-.064.032-.1-.011-.071-.032-.101a.176.176 0 0 0-.084-.063.645.645 0 0 0-.566 0 .178.178 0 0 0-.085.063c-.02.03-.032.065-.032.101s.012.071.032.1a.172.172 0 0 0 .085.063.603.603 0 0 0 .564 0h.002zm-9.8-5.716c-.077.047-.081.121 0 .167a.302.302 0 0 0 .288 0c.081-.046.081-.12 0-.167a.326.326 0 0 0-.286 0h-.002z"
            fill="#BFC1C1"
        />
        <path
            d="m938.58 338.5 9.369 5.445a.966.966 0 0 0 .883 0l6.48-3.739a.308.308 0 0 0 .126-.103.313.313 0 0 0 .059-.153v.808a.324.324 0 0 1-.187.26l-6.478 3.74a.973.973 0 0 1-.883 0l-9.37-5.441a.312.312 0 0 1-.179-.255v-.815a.3.3 0 0 0 .18.253z"
            fill="#A7A9AA"
        />
        <path
            d="M951.18 341.84v.05c.003.04.018.078.041.111a.23.23 0 0 0 .091.078.736.736 0 0 0 .653 0 .248.248 0 0 0 .092-.078.247.247 0 0 0 .042-.114v-.051a.234.234 0 0 1-.134.189.714.714 0 0 1-.653 0 .227.227 0 0 1-.132-.185z"
            fill="#616464"
        />
        <path
            d="M951.32 341.65c-.18.107-.182.273 0 .377a.726.726 0 0 0 .653 0 .203.203 0 0 0 .134-.189.197.197 0 0 0-.037-.115.195.195 0 0 0-.097-.073.725.725 0 0 0-.653 0z"
            fill="#CCCECE"
        />
        <path
            d="m952.92 342.19-.017-.295-1.366.788.012.3 1.371-.793z"
            fill="#4F4F4F"
        />
        <path
            d="m952.92 342.19-.24-.172-1.143.665.012.3 1.371-.793z"
            fill="#838484"
        />
        <path
            d="M939.69 339.38a.075.075 0 0 1 .044-.008.09.09 0 0 1 .043.017l1.554.894a.144.144 0 0 1 .039.035.278.278 0 0 1 .087.187.1.1 0 0 1-.008.045.091.091 0 0 1-.028.034l-.176.1c.012-.009.022-.022.028-.036s.009-.029.008-.045a.304.304 0 0 0-.079-.183c-.014-.014-.03-.025-.044-.037l-1.555-.9c-.013-.009-.028-.014-.044-.015s-.031.002-.045.009l.176-.097z"
            fill="#BFC1C1"
        />
        <path
            d="M939.6 339.49c-.07-.035-.127-.006-.127.073a.259.259 0 0 0 .127.216l1.552.9c.071.038.126.008.126-.071a.287.287 0 0 0-.123-.22l-1.555-.898z"
            fill="#838484"
        />
        <path
            d="M946.94 334.25c.214.5 1.035.548 1.5.352.158-.067.656.841 1.044 1.1a.459.459 0 0 0 .422.06.45.45 0 0 0 .286-.316 17.846 17.846 0 0 0-1.236-1.623c-.811-1.047-1.3-.886-1.764-.692s-.47.614-.252 1.119z"
            fill="#FFE8D9"
        />
        <path
            d="m946 333.64 1.324-.575 1.165 1.359.109.258.668 2.142s.188.694-.9 1.07a1.536 1.536 0 0 1-1.023-.041 1.536 1.536 0 0 1-.767-.677l-.865-1.976c-.253-.559-.314-1.295.289-1.56z"
            fill="#FFE8D9"
        />
        <path
            d="M948.13 331.77c-.109-.232-.85-.435-1.575-.168a3.617 3.617 0 0 0-1.286.72c-.351.343-.5.612-.4.919 0 0 .381 1.123.519 1.471.086.227.2.171.2.171a.993.993 0 0 1-.057-.258c.028-.289.269-.777 1.142-1.23 1.372-.711 1.92.015 1.92.015.206-.1.227-.219.11-.446l-.573-1.194z"
            fill="#E4EFF4"
        />
        <path
            d="M953.25 339.62c-.521.177-1.1-.412-1.256-.887-.058-.162-1.067.065-1.51-.051a.464.464 0 0 1-.353-.494.461.461 0 0 1 .074-.206 18 18 0 0 1 2.035-.149c1.32-.086 1.528.386 1.686.861s-.158.755-.676.926z"
            fill="#FFE8D9"
        />
        <path
            d="M953.42 339.1c.279.49.4.234.4.234.634.422 1.313.772 2.026 1.041a22.534 22.534 0 0 0 5.8-3.3 4.246 4.246 0 0 0 1.249-4.012s-.554-6.332-.936-7.764c-.639-2.4-3.464-1.336-3.678 1.279a49.39 49.39 0 0 0 .82 6.922 1.588 1.588 0 0 1-.745 1.677l-3.785 2.111s-1.697.86-1.151 1.812z"
            fill="#688CAA"
        />
        <path
            d="m954.33 339.93-.444-1.372-1.792.025-.266.09-2.047.919a1.133 1.133 0 0 0-.637.59 1.141 1.141 0 0 0-.1.431c-.004.149.022.297.075.436.228.714.024.077.024.077a1.158 1.158 0 0 0 1.391.716l2.819-.667c.585-.174 1.18-.618.977-1.245z"
            fill="#FFE8D9"
        />
        <path
            d="M953.1 337.54c-.242.107-.485.854-.241 1.611.133.492.368.95.688 1.346.338.372.605.536.923.442 0 0 1.174-.346 1.539-.473.233-.082.186-.2.186-.2a.952.952 0 0 1-.27.048c-.3-.039-.79-.3-1.218-1.217-.672-1.436.1-1.967.1-1.967-.09-.215-.212-.242-.451-.127l-1.256.537z"
            fill="#E4EFF4"
        />
        <path
            d="M940.32 348.29c0 .4-.528.73-1.179.73s-1.182-.329-1.182-.73.531-.736 1.182-.736 1.179.328 1.179.736z"
            fill="#B9DBD8"
        />
        <path
            d="M940.1 347.34a2.112 2.112 0 0 0-1.9-.022.696.696 0 0 0-.407.559c.04-.003.08.009.111.035a.148.148 0 0 1 .056.102v.28a.611.611 0 0 1 .36-.494 1.846 1.846 0 0 1 1.666.022.578.578 0 0 1 .335.476v-.279a.154.154 0 0 1 .168-.135.66.66 0 0 0-.389-.544z"
            fill="#CAEDEB"
        />
        <path
            d="M939.7 347.45c-.01.04-.122.051-.248.015s-.22-.093-.211-.136.125-.049.25-.017.22.094.209.138z"
            fill="#DCF9F7"
        />
        <path
            d="M940.51 343.68a3.022 3.022 0 0 1-2.757-.027c-.751-.449-.734-1.164.039-1.6a3.038 3.038 0 0 1 2.757.029c.751.449.734 1.164-.039 1.598z"
            fill="#CAEDEB"
            opacity={0.73}
        />
        <path
            d="M940.55 342.47c.242.127.429.338.525.594a.874.874 0 0 0-.525-.982 3.039 3.039 0 0 0-2.757-.029c-.481.27-.667.648-.562 1 .101-.27.302-.491.562-.617a3.035 3.035 0 0 1 2.757.034z"
            fill="#CAEDEB"
            opacity={0.73}
        />
        <path
            d="M941.31 343.09a.765.765 0 0 0-.03-.285 1.192 1.192 0 0 0-.052-.141l-.024-.046a.07.07 0 0 0-.009-.017l-.006-.013c0-.008-.01-.013-.013-.02s-.016-.027-.024-.037a1.45 1.45 0 0 0-.087-.119 1.645 1.645 0 0 0-.138-.139 1.56 1.56 0 0 0-.27-.2 2.52 2.52 0 0 0-.245-.131h-.016c-.126-.056-.237-.088-.284-.105s-.152-.044-.3-.073-.245-.039-.313-.047a3.91 3.91 0 0 0-.631 0h-.01a3.594 3.594 0 0 0-.609.106h-.012a.639.639 0 0 0-.113.032.17.17 0 0 1-.038.013l-.022.009c-.035.012-.071.022-.1.037a2.672 2.672 0 0 0-.27.129 1.201 1.201 0 0 0-.113.072c-.007.004-.014.008-.022.01h-.005a1.63 1.63 0 0 0-.216.172 1.694 1.694 0 0 0-.168.198.835.835 0 0 0-.047.074l-.005.011a1.082 1.082 0 0 0-.061.129v.016a1.057 1.057 0 0 0-.042.156c-.006.041-.009.1-.012.14v.069a1.084 1.084 0 0 0 .61.822 3.352 3.352 0 0 0 3.052.03 1.106 1.106 0 0 0 .651-.838v-.023l-.006.009zm-.8.593a3.026 3.026 0 0 1-2.757-.027c-.751-.449-.734-1.164.039-1.6a3.038 3.038 0 0 1 2.757.029c.753.449.736 1.164-.037 1.598h-.002z"
            fill="#B9DBD8"
        />
        <path
            d="M941.3 343.11a1.103 1.103 0 0 1-.651.84 3.352 3.352 0 0 1-1.529.351 3.351 3.351 0 0 1-1.523-.381 1.094 1.094 0 0 1-.61-.822l.325 4.545v.006-.006a.343.343 0 0 0 .007.056c.002.022.006.043.01.064a.672.672 0 0 0 .028.1c0 .009.009.023.014.037v.017a1.033 1.033 0 0 0 .265.372 1.557 1.557 0 0 0 .471.302c.068.028.145.057.232.086h.009c.034.011.077.022.112.03h.014c.04.009.1.023.181.037h.008c.026 0 .055.008.087.015a.15.15 0 0 1 .03 0c.02 0 .044.006.073.007h.029a.865.865 0 0 0 .088.005h.01c.044 0 .081 0 .121.005s.067 0 .1 0a.486.486 0 0 0 .054 0h.026c.076-.002.152-.009.227-.019l.067-.013.039-.007.039-.005.075-.016h.009a.82.82 0 0 0 .13-.031.675.675 0 0 0 .224-.077c.038-.016.087-.037.125-.055s.07-.035.1-.054c.047-.025.091-.054.134-.085a1.226 1.226 0 0 0 .314-.299.903.903 0 0 0 .109-.2 1.85 1.85 0 0 0 .045-.131.59.59 0 0 0 .015-.084c0-.016 0-.034.005-.049.126-1.513.247-3.027.362-4.541z"
            fill="#CAEDEB"
            opacity={0.73}
        />
        <path
            d="M927.72 367.17c0 .4-.526.735-1.18.735s-1.177-.33-1.177-.735.527-.731 1.177-.731 1.18.331 1.18.731z"
            fill="#B9DBD8"
        />
        <path
            d="M927.51 366.22a2.113 2.113 0 0 0-1.9-.02.679.679 0 0 0-.407.558c.04-.003.08.009.112.034a.16.16 0 0 1 .056.103v.279a.6.6 0 0 1 .357-.49 1.848 1.848 0 0 1 1.667.019.577.577 0 0 1 .333.477v-.277a.152.152 0 0 1 .169-.137.67.67 0 0 0-.387-.546z"
            fill="#CAEDEB"
        />
        <path
            d="M927.12 366.33c-.012.042-.124.049-.25.013s-.218-.093-.209-.137.123-.048.248-.014.222.095.211.138z"
            fill="#DCF9F7"
        />
        <path
            d="M927.92 362.57a3.051 3.051 0 0 1-2.758-.027c-.752-.45-.734-1.164.037-1.6a3.04 3.04 0 0 1 2.758.024c.75.449.735 1.165-.037 1.603z"
            fill="#CAEDEB"
            opacity={0.73}
        />
        <path
            d="M927.96 361.36c.242.126.428.336.524.59.1-.342-.07-.709-.524-.982a3.035 3.035 0 0 0-2.758-.024c-.478.268-.667.646-.56 1a1.12 1.12 0 0 1 .56-.614 3.024 3.024 0 0 1 2.758.03z"
            fill="#CAEDEB"
            opacity={0.73}
        />
        <path
            d="M928.72 361.97a.836.836 0 0 0-.033-.29 1.038 1.038 0 0 0-.052-.141l-.024-.046v-.008l-.011-.019-.012-.019a.383.383 0 0 1-.025-.044 1.376 1.376 0 0 0-.222-.254 1.822 1.822 0 0 0-.271-.2l-.031-.017a1.572 1.572 0 0 0-.217-.109l-.01-.007a2.256 2.256 0 0 0-.29-.1 2.803 2.803 0 0 0-.612-.12 3.287 3.287 0 0 0-.635-.007h-.008a2.993 2.993 0 0 0-.608.108h-.011c-.015.003-.029.008-.043.013a.105.105 0 0 1-.024.006c-.018.007-.031.01-.046.017-.013.003-.026.006-.038.011l-.023.009a2.696 2.696 0 0 0-.485.236 1.415 1.415 0 0 0-.239.186c-.021.022-.05.051-.069.074a1.31 1.31 0 0 0-.1.123.595.595 0 0 0-.045.077l-.006.009a1.013 1.013 0 0 0-.063.128v.016a1.368 1.368 0 0 0-.039.156c-.007.041-.01.1-.014.141v.072a1.093 1.093 0 0 0 .608.818 3.37 3.37 0 0 0 3.054.033 1.128 1.128 0 0 0 .652-.837v-.02l-.008.005zm-.8.59a3.051 3.051 0 0 1-2.758-.027c-.752-.45-.734-1.164.037-1.6a3.04 3.04 0 0 1 2.758.024c.752.459.737 1.175-.035 1.613l-.002-.01z"
            fill="#B9DBD8"
        />
        <path
            d="M928.72 362a1.125 1.125 0 0 1-.652.837 3.368 3.368 0 0 1-3.054-.033 1.093 1.093 0 0 1-.608-.818 2485.381 2485.381 0 0 0 .329 4.597l.011.065a.878.878 0 0 0 .029.1l.013.035v.014l.012.032a1.088 1.088 0 0 0 .235.329l.018.013a1.565 1.565 0 0 0 .427.284l.045.018c.075.033.152.062.23.086h.006a.945.945 0 0 0 .116.031l.019.007c.035.008.1.023.177.038h.008c.029 0 .056.009.086.011h.029l.071.011a.64.64 0 0 1 .121.007h.229a.468.468 0 0 1 .053 0h.018a4.009 4.009 0 0 0 .341-.037l.037-.008a.405.405 0 0 0 .077-.016h.007c.041-.01.094-.021.131-.033a.89.89 0 0 0 .134-.045l.089-.033c.041-.015.089-.037.126-.055s.069-.037.1-.051.1-.057.139-.087.105-.082.149-.121a.967.967 0 0 0 .273-.384.83.83 0 0 0 .044-.127.44.44 0 0 0 .015-.087l.005-.049c.125-1.506.247-3.016.365-4.531z"
            fill="#CAEDEB"
            opacity={0.73}
        />
        <path
            d="M920.98 335.25c0 .406-.529.733-1.18.733s-1.179-.327-1.179-.733.529-.731 1.179-.731 1.18.328 1.18.731z"
            fill="#B9DBD8"
        />
        <path
            d="M920.77 334.3a2.101 2.101 0 0 0-1.906-.017.67.67 0 0 0-.4.557.151.151 0 0 1 .164.136v.277a.602.602 0 0 1 .357-.488 1.821 1.821 0 0 1 1.667.019.584.584 0 0 1 .335.475v-.284a.158.158 0 0 1 .056-.102.158.158 0 0 1 .111-.034.652.652 0 0 0-.12-.321.651.651 0 0 0-.264-.218z"
            fill="#CAEDEB"
        />
        <path
            d="M920.37 334.41c-.01.04-.122.047-.248.013s-.219-.1-.209-.137.124-.049.251-.015.217.1.206.139z"
            fill="#DCF9F7"
        />
        <path
            d="M921.18 330.64a3.03 3.03 0 0 1-2.759-.027c-.748-.45-.731-1.164.042-1.6a3.048 3.048 0 0 1 2.757.025c.752.456.733 1.17-.04 1.602z"
            fill="#CAEDEB"
            opacity={0.73}
        />
        <path
            d="M921.22 329.44c.241.126.427.336.523.591.1-.344-.071-.708-.523-.982a3.048 3.048 0 0 0-2.757-.025c-.48.27-.67.648-.562 1 .099-.27.301-.491.562-.614a3.035 3.035 0 0 1 2.757.03z"
            fill="#CAEDEB"
            opacity={0.73}
        />
        <path
            d="M921.98 330.06a.97.97 0 0 0-.085-.429c-.01-.014-.016-.031-.026-.046l-.006-.015-.007-.01c-.006-.011-.012-.015-.013-.023l-.026-.043a1.196 1.196 0 0 0-.084-.114c-.04-.045-.1-.1-.136-.14a1.855 1.855 0 0 0-.271-.194l-.033-.019a1.754 1.754 0 0 0-.217-.108l-.009-.007c-.133-.056-.243-.088-.289-.105s-.155-.046-.3-.077-.247-.036-.313-.043a3.522 3.522 0 0 0-.633 0h-.008a3.091 3.091 0 0 0-.611.107h-.006l-.045.01a.114.114 0 0 1-.026.009c-.014.007-.03.009-.045.017s-.025.01-.037.01l-.023.008a2.64 2.64 0 0 0-.499.247l-.01.006a1.688 1.688 0 0 0-.215.172c-.02.024-.049.049-.069.073s-.071.085-.1.127a.703.703 0 0 0-.046.074l-.005.01a.766.766 0 0 0-.06.13l-.007.014a.854.854 0 0 0-.051.297v.07a1.086 1.086 0 0 0 .611.82 3.38 3.38 0 0 0 3.053.031 1.128 1.128 0 0 0 .653-.838v-.014l-.006-.007zm-.8.59a3.042 3.042 0 0 1-2.759-.027c-.748-.45-.731-1.164.042-1.6a3.048 3.048 0 0 1 2.757.025c.75.456.731 1.17-.042 1.602h.002z"
            fill="#B9DBD8"
        />
        <path
            d="M921.98 330.07a1.117 1.117 0 0 1-.653.839 3.381 3.381 0 0 1-3.053-.031 1.092 1.092 0 0 1-.611-.82l.326 4.543c0 .015 0 .032.005.05s.007.05.012.067l.025.1c.007.01.008.023.016.035v.017c0 .011.008.02.011.03a1.028 1.028 0 0 0 .236.324l.017.013a.129.129 0 0 0 .019.021c.074.064.154.122.237.174a4.99 4.99 0 0 0 .216.11c.076.033.155.062.234.086h.006c.032.01.077.021.113.03l.019.005c.059.016.119.027.179.035a.384.384 0 0 0 .089.014c.01.001.019.004.028.007a.597.597 0 0 0 .073.005l.033.006.085.005h.314c.077-.003.154-.01.23-.023a.742.742 0 0 0 .106-.015l.036-.005c.027-.006.051-.011.078-.019.045-.009.1-.02.134-.031.011 0 .022-.011.033-.013a.9.9 0 0 0 .1-.033c.032-.01.061-.023.09-.032s.087-.037.123-.057.072-.037.1-.051.1-.056.135-.083.109-.084.151-.123a1.018 1.018 0 0 0 .317-.514.577.577 0 0 0 .02-.133c.13-1.505.254-3.016.371-4.533z"
            fill="#CAEDEB"
            opacity={0.73}
        />
        <path
            d="M852.99 316.97c0 .4-.525.731-1.177.731s-1.18-.327-1.18-.731.529-.733 1.18-.733 1.177.333 1.177.733z"
            fill="#B9DBD8"
        />
        <path
            d="M852.78 316.02a2.101 2.101 0 0 0-1.9-.017.68.68 0 0 0-.409.557.156.156 0 0 1 .167.135v.28a.605.605 0 0 1 .357-.488 1.832 1.832 0 0 1 1.667.017.577.577 0 0 1 .333.477v-.277a.154.154 0 0 1 .166-.137.669.669 0 0 0-.381-.547z"
            fill="#CAEDEB"
        />
        <path
            d="M852.38 316.13c-.014.042-.124.049-.251.015s-.219-.094-.206-.136.122-.049.247-.016.219.095.21.137z"
            fill="#DCF9F7"
        />
        <path
            d="M853.19 312.37a3.037 3.037 0 0 1-2.758-.03c-.751-.447-.734-1.165.038-1.6a3.04 3.04 0 0 1 2.758.028c.751.449.734 1.162-.038 1.602z"
            fill="#CAEDEB"
            opacity={0.73}
        />
        <path
            d="M853.23 311.16c.244.126.431.341.522.6a.872.872 0 0 0-.522-.983 3.038 3.038 0 0 0-2.758-.028c-.478.27-.668.647-.559 1.005.098-.271.299-.493.559-.62a3.054 3.054 0 0 1 2.758.026z"
            fill="#CAEDEB"
            opacity={0.73}
        />
        <path
            d="M853.99 311.77a.97.97 0 0 0-.083-.428c-.009-.014-.015-.03-.025-.048v-.009l-.012-.02-.011-.019-.025-.041a1.075 1.075 0 0 0-.086-.115 1.813 1.813 0 0 0-.406-.337l-.03-.018a3.39 3.39 0 0 0-.218-.111l-.016-.006a2.254 2.254 0 0 0-.286-.1 2.854 2.854 0 0 0-.3-.074c-.139-.028-.248-.038-.313-.047a4.206 4.206 0 0 0-.635 0h-.007a3.2 3.2 0 0 0-.608.107h-.008a.565.565 0 0 0-.066.022.336.336 0 0 0-.048.014.11.11 0 0 0-.036.012l-.023.007a.864.864 0 0 0-.1.041 1.894 1.894 0 0 0-.27.126c-.035.019-.076.047-.115.071l-.022.015h-.005a1.05 1.05 0 0 0-.214.172c-.019.021-.051.047-.069.071a1.348 1.348 0 0 0-.147.202h-.006c-.023.048-.045.092-.061.132l-.005.015a.594.594 0 0 0-.037.155.969.969 0 0 0-.017.141v.074a1.105 1.105 0 0 0 .608.82 3.359 3.359 0 0 0 3.055.028 1.131 1.131 0 0 0 .653-.839v-.02l-.006.007zm-.8.593a3.029 3.029 0 0 1-2.758-.03c-.751-.447-.734-1.165.038-1.6a3.038 3.038 0 0 1 2.758.028c.753.456.736 1.169-.036 1.609l-.002-.007z"
            fill="#B9DBD8"
        />
        <path
            d="M853.99 311.8a1.12 1.12 0 0 1-.653.839 3.36 3.36 0 0 1-3.055-.028 1.105 1.105 0 0 1-.608-.822c.109 1.514.217 3.029.324 4.544 0 .017.002.035.007.051a.72.72 0 0 0 .012.067c.006.032.017.069.025.1a.239.239 0 0 1 .015.037v.01l.005.011c.005.007.008.015.011.023a1.043 1.043 0 0 0 .228.316l.017.017a2.054 2.054 0 0 0 .262.2c.038.021.1.055.172.089.017.006.031.014.045.02.065.027.145.059.232.087h.009l.111.029a3.364 3.364 0 0 0 .195.04h.01a.6.6 0 0 0 .085.012l.029.006c.024 0 .048.002.072.006h.031a.44.44 0 0 1 .088.006h.014a.784.784 0 0 0 .119.006h.1a.523.523 0 0 0 .056 0h.025c.079 0 .156-.011.228-.019a.386.386 0 0 0 .068-.011.287.287 0 0 0 .041-.005.115.115 0 0 0 .036-.007c.025-.004.05-.008.075-.01h.007a.99.99 0 0 0 .165-.046c.037-.011.071-.023.1-.035s.065-.022.089-.032a1.37 1.37 0 0 0 .226-.108 1.674 1.674 0 0 0 .285-.203 1.057 1.057 0 0 0 .274-.381 1.134 1.134 0 0 0 .057-.215c0-.015.006-.032.009-.05l.357-4.544z"
            fill="#CAEDEB"
            opacity={0.73}
        />
        <path
            d="M874.22 311.27c0 .4-.527.732-1.179.732s-1.178-.328-1.178-.732.527-.73 1.178-.73 1.179.33 1.179.73z"
            fill="#B9DBD8"
        />
        <path
            d="M874.01 310.32a2.074 2.074 0 0 0-1.9-.018.667.667 0 0 0-.408.555.15.15 0 0 1 .111.035.15.15 0 0 1 .056.103v.278a.6.6 0 0 1 .358-.488 1.824 1.824 0 0 1 1.667.018.59.59 0 0 1 .23.193.588.588 0 0 1 .102.283v-.276a.152.152 0 0 1 .168-.137.661.661 0 0 0-.384-.546z"
            fill="#CAEDEB"
        />
        <path
            d="M873.61 310.43c-.009.041-.122.05-.249.017s-.219-.1-.208-.139.122-.051.249-.016.219.095.208.138z"
            fill="#DCF9F7"
        />
        <path
            d="M874.42 306.67a3.038 3.038 0 0 1-2.757-.028c-.751-.449-.732-1.165.039-1.6a3.038 3.038 0 0 1 2.758.027c.748.452.732 1.167-.04 1.601z"
            fill="#CAEDEB"
            opacity={0.73}
        />
        <path
            d="M874.46 305.46c.242.127.428.338.523.593.1-.343-.071-.71-.523-.981a3.037 3.037 0 0 0-2.758-.027c-.479.269-.668.649-.561 1 .1-.27.301-.49.561-.614a3.044 3.044 0 0 1 2.758.029z"
            fill="#CAEDEB"
            opacity={0.73}
        />
        <path
            d="M875.22 306.07a.851.851 0 0 0-.085-.428l-.023-.048-.008-.013-.008-.014a.2.2 0 0 0-.01-.021l-.026-.042a.954.954 0 0 0-.087-.114 3.494 3.494 0 0 0-.134-.142 2.322 2.322 0 0 0-.269-.194l-.033-.018a2.11 2.11 0 0 0-.218-.109l-.014-.01a3.1 3.1 0 0 0-.585-.175 3.616 3.616 0 0 0-.943-.052h-.009a3.57 3.57 0 0 0-.607.106h-.009a.29.29 0 0 0-.042.012c-.01.001-.019.004-.028.007-.014.005-.031.009-.046.016l-.035.01a.075.075 0 0 1-.024.008l-.1.038a2.94 2.94 0 0 0-.271.131 1.175 1.175 0 0 0-.113.069l-.023.016a1.19 1.19 0 0 0-.213.174l-.071.071a1.466 1.466 0 0 0-.15.201v.012a.741.741 0 0 0-.063.126v.014a1.096 1.096 0 0 0-.037.158c-.009.04-.011.1-.016.137a.58.58 0 0 0 .005.072 1.095 1.095 0 0 0 .606.822 3.372 3.372 0 0 0 3.056.031 1.133 1.133 0 0 0 .653-.84v-.015l-.02.004zm-.8.59a3.038 3.038 0 0 1-2.757-.028c-.751-.449-.732-1.165.039-1.6a3.038 3.038 0 0 1 2.758.027c.748.457.732 1.172-.04 1.606v-.005z"
            fill="#B9DBD8"
        />
        <path
            d="M875.22 306.1a1.138 1.138 0 0 1-.653.841 3.373 3.373 0 0 1-3.056-.031 1.095 1.095 0 0 1-.606-.822c.106 1.516.214 3.03.323 4.543v.005-.005c.002.02.006.039.01.057l.008.064a.817.817 0 0 0 .04.135v.02l.013.025c.051.115.123.218.211.306l.023.021.008.011.027.024c.074.066.154.123.239.173.055.035.113.065.172.09a.282.282 0 0 0 .042.022c.065.028.144.056.232.084h.012l.112.032h.016c.059.017.118.03.177.04l.09.013a.07.07 0 0 0 .029 0 .453.453 0 0 0 .103.008c.028 0 .059.006.089.008h.284a.113.113 0 0 0 .026 0c.08 0 .156-.011.225-.02.025 0 .047-.006.067-.01s.029 0 .043-.006l.035-.007a.685.685 0 0 1 .076-.016h.009c.039-.012.092-.022.131-.035l.033-.008a.71.71 0 0 0 .1-.038c.033-.01.063-.018.091-.029s.088-.039.126-.058l.1-.051a1.276 1.276 0 0 0 .286-.205.94.94 0 0 0 .161-.178c.043-.063.082-.13.115-.2.012-.038.032-.089.04-.129a.271.271 0 0 0 .013-.086.17.17 0 0 0 .008-.051c.128-1.508.252-3.02.37-4.537z"
            fill="#CAEDEB"
            opacity={0.73}
        />
        <path
            d="M888.84 340.27c0 .4-.529.731-1.179.731s-1.178-.33-1.178-.731.526-.733 1.178-.733 1.179.333 1.179.733z"
            fill="#B9DBD8"
        />
        <path
            d="M888.62 339.32a2.095 2.095 0 0 0-1.9-.021.69.69 0 0 0-.408.557.155.155 0 0 1 .167.137v.279a.59.59 0 0 1 .357-.489c.26-.128.547-.193.836-.189.29.003.575.074.831.208a.578.578 0 0 1 .333.476v-.277a.163.163 0 0 1 .017-.057.187.187 0 0 1 .038-.046.149.149 0 0 1 .111-.034.655.655 0 0 0-.382-.544z"
            fill="#CAEDEB"
        />
        <path
            d="M888.23 339.43c-.011.042-.124.048-.249.015s-.22-.1-.208-.135.123-.055.25-.018.222.095.207.138z"
            fill="#DCF9F7"
        />
        <path
            d="M889.03 335.67a3.05 3.05 0 0 1-2.762-.028c-.749-.449-.733-1.166.041-1.6a3.038 3.038 0 0 1 2.758.029c.749.451.732 1.165-.037 1.599z"
            fill="#CAEDEB"
            opacity={0.73}
        />
        <path
            d="M889.07 334.46c.241.125.427.337.519.593.108-.345-.068-.711-.519-.98a3.04 3.04 0 0 0-2.758-.029c-.481.269-.67.648-.563 1.005.102-.27.303-.491.563-.617a3.038 3.038 0 0 1 2.758.028z"
            fill="#CAEDEB"
            opacity={0.73}
        />
        <path
            d="M889.83 335.07a.883.883 0 0 0-.11-.476l-.005-.009-.008-.017c0-.008-.008-.014-.011-.022a.954.954 0 0 0-.112-.154 1.656 1.656 0 0 0-.408-.34l-.029-.019a2.022 2.022 0 0 0-.218-.11h-.009a2.864 2.864 0 0 0-.591-.182c-.139-.026-.248-.036-.311-.043a3.741 3.741 0 0 0-.635-.008h-.008c-.206.017-.41.053-.609.107h-.012a.156.156 0 0 1-.041.015l-.026.01-.048.01a.15.15 0 0 1-.033.013l-.024.011a.962.962 0 0 0-.1.036 2.897 2.897 0 0 0-.382.198 1.095 1.095 0 0 0-.235.188.981.981 0 0 0-.173.2.444.444 0 0 0-.049.073l-.006.01a.679.679 0 0 0-.058.129l-.005.008v.007a.847.847 0 0 0-.054.295.457.457 0 0 0 0 .074 1.107 1.107 0 0 0 .609.819 3.366 3.366 0 0 0 3.055.031 1.121 1.121 0 0 0 .652-.839v-.014l-.006-.001zm-.8.592a3.05 3.05 0 0 1-2.762-.028c-.749-.449-.733-1.166.041-1.6a3.038 3.038 0 0 1 2.758.029c.753.454.736 1.168-.033 1.602l-.004-.003z"
            fill="#B9DBD8"
        />
        <path
            d="M889.83 335.1a1.117 1.117 0 0 1-.652.84 3.367 3.367 0 0 1-3.055-.031 1.104 1.104 0 0 1-.609-.819l.326 4.541v.007-.005c0 .016 0 .036.007.053s.01.045.013.066a.7.7 0 0 0 .026.1c0 .012.008.024.011.033s.006.009.006.009v.012c.006.011.007.019.013.028.051.114.123.217.211.306l.023.02.01.009a1.851 1.851 0 0 0 .264.2c.039.025.1.054.171.091l.042.018c.077.033.155.061.235.086h.009l.112.034h.011c.043.009.108.024.184.036h.008c.027 0 .056.01.084.012h.031l.072.01h.031c.029 0 .059 0 .089.007h.281a.122.122 0 0 0 .027 0c.078 0 .156-.011.226-.02l.069-.008a.274.274 0 0 1 .039-.009c.012 0 .024-.005.037-.007s.052-.01.076-.013h.01c.043-.009.086-.02.129-.034l.032-.01c.036-.011.072-.024.1-.035a1.148 1.148 0 0 0 .214-.086c.032-.015.071-.035.1-.053.047-.025.093-.053.137-.083.047-.035.1-.084.15-.123.06-.053.114-.114.16-.18.045-.062.084-.129.114-.2.016-.043.03-.087.042-.132.007-.035.008-.043.014-.085a.207.207 0 0 0 .006-.05c.13-1.506.247-3.023.364-4.535z"
            fill="#CAEDEB"
            opacity={0.73}
        />
        <path
            d="M935.67 344.56c.761.458.734 1.189-.058 1.631a3.098 3.098 0 0 1-2.817-.027c-.761-.457-.736-1.189.06-1.631a3.112 3.112 0 0 1 2.815.027z"
            fill="#B9DBD8"
        />
        <path
            d="M932.8 346.16a1.788 1.788 0 0 1-.571-.534 1.417 1.417 0 0 1-.236-.75 1.096 1.096 0 0 0 .624.885 3.49 3.49 0 0 0 3.171.03 1.126 1.126 0 0 0 .689-.928 1.525 1.525 0 0 1-.784 1.279.584.584 0 0 1-.076.045c-.438.219-.922.33-1.412.325a3.088 3.088 0 0 1-1.405-.352z"
            fill="#B9DBD8"
        />
        <path
            d="M935.38 337.89c.017.01.039.02.055.031h-.007a.155.155 0 0 0-.048-.028v-.003zM935.4 337.91a.06.06 0 0 0-.024-.015.17.17 0 0 1 .044.024c-.006-.003-.013-.007-.02-.009z"
            fill="#171F28"
        />
        <path
            d="m931.99 344.87-.047-5.069a1.118 1.118 0 0 0 .632.9 3.55 3.55 0 0 0 3.218.034 1.158 1.158 0 0 0 .7-.95l-.02 5.069a1.122 1.122 0 0 1-.689.934 3.489 3.489 0 0 1-3.171-.03 1.112 1.112 0 0 1-.624-.89l.001.002z"
            fill="#CAEDEB"
            opacity={0.73}
        />
        <path
            d="M934.98 335.33c.406.245.393.636-.031.872a1.665 1.665 0 0 1-1.506-.016c-.408-.242-.391-.634.031-.869a1.644 1.644 0 0 1 1.506.013z"
            fill="#273545"
        />
        <path
            d="M935.46 337.94a.884.884 0 0 1-.182-.551v-1.64a.537.537 0 0 1-.327.448 1.658 1.658 0 0 1-1.506-.016.537.537 0 0 1-.206-.172.534.534 0 0 1-.094-.252l.006 1.639c0 .035-.006.071-.008.107a.842.842 0 0 1-.175.445c.03-.023.063-.039.09-.056a2.157 2.157 0 0 0-1.112 1.906 1.113 1.113 0 0 0 .632.9 3.55 3.55 0 0 0 3.218.034 1.161 1.161 0 0 0 .7-.963 2.163 2.163 0 0 0-1.036-1.829z"
            fill="#E9FFFD"
            opacity={0.77}
        />
        <path
            d="M935.43 335.55v.769a.582.582 0 0 1-.351.487 1.86 1.86 0 0 1-1.7 0 .598.598 0 0 1-.354-.495v-.767a.604.604 0 0 0 .354.494 1.863 1.863 0 0 0 1.7 0 .584.584 0 0 0 .349-.488h.002z"
            fill="#70AD40"
        />
        <path
            d="M935.08 335.05c.471.275.473.714.005.985a1.867 1.867 0 0 1-1.7 0 .516.516 0 0 1-.357-.49.525.525 0 0 1 .351-.495 1.883 1.883 0 0 1 1.701 0z"
            fill="#85C44E"
        />
        <path
            d="M880.37 313.08c.762.459.737 1.189-.056 1.631a3.09 3.09 0 0 1-2.818-.026c-.76-.459-.734-1.189.058-1.632a3.109 3.109 0 0 1 2.816.027z"
            fill="#B9DBD8"
        />
        <path
            d="M877.5 314.69a1.898 1.898 0 0 1-.571-.533 1.435 1.435 0 0 1-.234-.749 1.107 1.107 0 0 0 .625.882 3.496 3.496 0 0 0 3.168.033 1.144 1.144 0 0 0 .69-.93 1.516 1.516 0 0 1-.784 1.278c-.026.017-.049.03-.076.045a3.1 3.1 0 0 1-2.818-.026z"
            fill="#B9DBD8"
        />
        <path
            d="M880.08 306.42c.014.008.037.022.052.029h-.01c-.015-.008-.028-.018-.042-.026v-.003zM880.1 306.44l-.023-.016c.014.008.027.018.042.026l-.012-.008-.007-.002z"
            fill="#171F28"
        />
        <path
            d="m876.69 313.4-.051-5.069a1.13 1.13 0 0 0 .636.9 3.538 3.538 0 0 0 3.217.031 1.145 1.145 0 0 0 .7-.951l-.021 5.072a1.14 1.14 0 0 1-.69.936 3.489 3.489 0 0 1-3.168-.033 1.09 1.09 0 0 1-.625-.891l.002.005z"
            fill="#CAEDEB"
            opacity={0.73}
        />
        <path
            d="M879.68 303.86c.4.245.392.635-.033.872a1.645 1.645 0 0 1-1.505-.018c-.409-.244-.4-.631.032-.87a1.664 1.664 0 0 1 1.506.016z"
            fill="#273545"
        />
        <path
            d="M880.16 306.47a.835.835 0 0 1-.184-.551l-.006-1.638a.534.534 0 0 1-.326.446 1.646 1.646 0 0 1-1.505-.018.506.506 0 0 1-.3-.422v1.638c0 .037 0 .073-.005.108a.852.852 0 0 1-.177.445c.033-.022.062-.041.092-.057a2.16 2.16 0 0 0-1.116 1.906 1.121 1.121 0 0 0 .636.9 3.53 3.53 0 0 0 3.217.031 1.15 1.15 0 0 0 .7-.962 2.182 2.182 0 0 0-1.026-1.826z"
            fill="#E9FFFD"
            opacity={0.77}
        />
        <path
            d="M880.13 304.08v.767a.597.597 0 0 1-.348.489 1.883 1.883 0 0 1-1.7 0 .597.597 0 0 1-.352-.5v-.766a.607.607 0 0 0 .352.5 1.89 1.89 0 0 0 1.7 0 .6.6 0 0 0 .347-.49h.001z"
            fill="#70AD40"
        />
        <path
            d="M879.78 303.58a.521.521 0 0 1 .351.495.525.525 0 0 1-.351.494 1.883 1.883 0 0 1-1.7 0 .522.522 0 0 1-.257-.795.524.524 0 0 1 .251-.194 1.89 1.89 0 0 1 1.706 0z"
            fill="#85C44E"
        />
        <path
            d="M935.97 328.06v-.015c0-.013-.006-.026-.009-.04l-.006-.017a.166.166 0 0 0-.017-.047v-.008a.174.174 0 0 1-.025-.049l-.007-.01c-.012-.016-.019-.033-.029-.047h-.005a.193.193 0 0 0-.029-.035v-.008l-.007-.007c-.017-.013-.028-.027-.044-.039-.016-.014-.031-.023-.045-.034a.183.183 0 0 0-.084-.031.18.18 0 0 0-.089.015l-.494.29a.163.163 0 0 1 .17.016c.017.008.032.02.044.033h.007a.24.24 0 0 1 .041.037l.01.014a.18.18 0 0 1 .028.034.355.355 0 0 1 .032.047l.006.007c.009.022.019.036.025.054v.006l.018.051v.012a.311.311 0 0 1 .011.041v.015a.262.262 0 0 1 0 .056.166.166 0 0 1-.066.151c.164-.093.327-.191.492-.284a.17.17 0 0 0 .072-.157.146.146 0 0 0 0-.051z"
            fill="#FC6B6B"
        />
        <path
            d="M935.61 328.27a.048.048 0 0 1 0-.017c0-.013-.007-.025-.011-.041v-.009a.352.352 0 0 0-.019-.051v-.011l-.027-.048-.008-.013a.141.141 0 0 0-.029-.04v-.006a.19.19 0 0 0-.027-.038l-.009-.01-.007-.006a.292.292 0 0 0-.041-.037.317.317 0 0 0-.046-.033.164.164 0 0 0-.17-.018l-7.55 4.378a.177.177 0 0 1 .088-.013c.03.004.059.015.083.033a.112.112 0 0 1 .046.03h.005a.774.774 0 0 1 .041.039l.006.009c.013.012.024.027.035.039v.009c.011.015.02.03.028.045l.005.007a.177.177 0 0 1 .029.054v.009c0 .014.01.03.016.048l.006.012a.338.338 0 0 1 .009.041l.005.017a.468.468 0 0 1 0 .053.159.159 0 0 1-.071.153l7.536-4.377a.17.17 0 0 0 .057-.068.18.18 0 0 0 .014-.089c.01-.016.007-.031.006-.051z"
            fill="#0E3C55"
        />
        <path
            d="M935.47 328.35v-.009c0-.017-.007-.032-.01-.044v-.015l-.018-.051v-.006c-.006-.018-.016-.032-.023-.05l-.008-.011a.251.251 0 0 0-.032-.046.154.154 0 0 0-.028-.034l-.006-.011-.008-.005a.205.205 0 0 0-.041-.037h-.007a.13.13 0 0 0-.044-.033.158.158 0 0 0-.083-.032.154.154 0 0 0-.087.016c-2.511 1.46-5.024 2.919-7.538 4.377a.173.173 0 0 1 .173.018c.016.009.03.02.043.033h.008a.265.265 0 0 1 .038.037l.007.008a.838.838 0 0 0 .039.045v.006l.031.043v.013c.011.015.02.032.028.049v.009a.198.198 0 0 1 .018.05l.005.014a.177.177 0 0 1 .008.04v.016a.226.226 0 0 1 0 .052.172.172 0 0 1-.016.086.176.176 0 0 1-.055.069l7.538-4.381a.166.166 0 0 0 .068-.153.331.331 0 0 0 0-.063z"
            fill="#FC6B6B"
        />
        <path
            d="m927.87 332.55 7.561-4.34a.488.488 0 0 1 .043.191.163.163 0 0 1-.068.153l-7.538 4.381a.173.173 0 0 0 .055-.068.173.173 0 0 0 .016-.087.497.497 0 0 0-.041-.181l-.028-.049z"
            fill="#ED4A4A"
        />
        <path
            d="M927.53 332.35c-.035.024-.335.588-.335.588.23.013.461.01.69-.007a.182.182 0 0 0 .047-.066.164.164 0 0 0 .011-.079.522.522 0 0 0-.242-.417.172.172 0 0 0-.173-.018l.002-.001z"
            fill="#FFC892"
        />
        <path
            d="m927.19 332.94.174.007c.008-.005-.005-.045-.031-.087s-.054-.073-.061-.069l-.082.149z"
            fill="#FC6B6B"
        />
        <path
            d="M939.04 355.79v-.016l-.007-.038v-.013c-.008-.019-.012-.037-.021-.054v-.006a.398.398 0 0 1-.024-.051l-.008-.006c-.012-.017-.018-.035-.029-.047l-.033-.037v-.006l-.012-.012-.037-.033-.008-.006a.283.283 0 0 0-.043-.032.173.173 0 0 0-.174-.017l-.492.289a.163.163 0 0 1 .168.017.13.13 0 0 1 .046.033h.007a.334.334 0 0 1 .038.037l.01.006v.006l.031.039h.006a.153.153 0 0 0 .028.046l.005.011c.009.016.016.035.025.05a.1.1 0 0 1 .018.047l.007.013a.297.297 0 0 0 .007.043.434.434 0 0 1 0 .07.155.155 0 0 1-.012.085.151.151 0 0 1-.053.067c.165-.093.329-.189.493-.285a.173.173 0 0 0 .072-.155.178.178 0 0 0-.008-.045z"
            fill="#6CBA5A"
        />
        <path
            d="M938.68 356v-.013c0-.019-.008-.031-.01-.045l-.005-.017a.326.326 0 0 0-.02-.048v-.006l-.025-.047a.04.04 0 0 0-.008-.014c-.008-.014-.019-.028-.028-.041v-.005l-.03-.04-.009-.007v-.009c-.012-.009-.027-.024-.04-.035h-.005l-.046-.031c-.024-.018-.053-.029-.083-.032s-.06.002-.088.014l-7.537 4.378a.177.177 0 0 1 .172.018c.016.01.031.021.045.032.015.013.027.028.038.039l.01.005c.014.014.023.032.034.045a.272.272 0 0 1 .031.047l.007.011.027.052v.008a.27.27 0 0 1 .016.045c.001.005.002.009.005.012.005.018.006.032.009.045v.009c.003.02.004.04.005.059a.167.167 0 0 1-.013.088.168.168 0 0 1-.057.067l7.537-4.377a.177.177 0 0 0 .071-.157c.001-.017-.003-.034-.003-.05z"
            fill="#3E0F36"
        />
        <path
            d="M938.54 356.07v-.012a.118.118 0 0 1-.009-.046l-.009-.017a.1.1 0 0 0-.017-.047c-.009-.015-.017-.034-.026-.05l-.004-.011a.121.121 0 0 1-.028-.046h-.007a.347.347 0 0 1-.026-.037l-.008-.008-.005-.006-.043-.037a.161.161 0 0 0-.048-.034.163.163 0 0 0-.168-.017 11352.61 11352.61 0 0 1-7.538 4.38.159.159 0 0 1 .172.016l.046.032h.005a.304.304 0 0 1 .039.041h.005a.367.367 0 0 0 .04.047l.028.044.008.013c.01.016.019.035.028.051v.008c0 .015.011.029.016.045v.017a.207.207 0 0 1 .014.042v.013a.305.305 0 0 1 .005.052.176.176 0 0 1-.07.158l7.535-4.384a.157.157 0 0 0 .069-.152.348.348 0 0 0-.004-.055z"
            fill="#6CBA5A"
        />
        <path
            d="m930.94 360.28 7.561-4.337a.42.42 0 0 1 .04.187.152.152 0 0 1-.069.152l-7.534 4.384a.176.176 0 0 0 .07-.158.523.523 0 0 0-.04-.177l-.028-.051z"
            fill="#56AE42"
        />
        <path
            d="M930.6 360.07c-.034.02-.332.586-.332.586.229.011.458.009.687-.007h.005a.187.187 0 0 0 .059-.147.532.532 0 0 0-.242-.414.169.169 0 0 0-.175-.016l-.002-.002z"
            fill="#FFC892"
        />
        <path
            d="M930.27 360.66h.174a.305.305 0 0 0-.035-.086c-.027-.043-.052-.075-.052-.075l-.087.161z"
            fill="#6CBA5A"
        />
        <path
            d="M898.5 306.79v-.017a.137.137 0 0 0-.008-.035v-.019l-.017-.049-.006-.006a.323.323 0 0 0-.025-.049v-.008a.4.4 0 0 1-.03-.049l-.029-.035-.007-.009-.008-.006a.63.63 0 0 0-.039-.037l-.007-.006-.043-.032a.182.182 0 0 0-.175-.017l-.493.293a.157.157 0 0 1 .087-.02c.03.003.059.014.082.033.016.01.032.02.046.032l.008.005c.015.01.027.023.038.037h.01l.007.009c.008.013.019.024.029.038l.029.047.005.009c.01.016.019.034.025.052a.227.227 0 0 1 .017.05l.006.014.009.041.006.018v.051a.166.166 0 0 1-.069.152c.165-.097.329-.192.493-.285a.17.17 0 0 0 .057-.068.172.172 0 0 0 .002-.134z"
            fill="#FC6B6B"
        />
        <path
            d="M898.14 307v-.016a.639.639 0 0 0-.01-.042v-.015c0-.016-.013-.032-.017-.049l-.026-.051-.008-.013a.17.17 0 0 0-.029-.041v-.008a.509.509 0 0 0-.028-.034l-.01-.011v-.005l-.04-.039h-.005l-.044-.031a.16.16 0 0 0-.173-.017 6392.795 6392.795 0 0 0-7.535 4.38.174.174 0 0 1 .087-.017c.03.003.059.013.084.031.016.01.03.021.044.034h.005l.04.039.009.008a.34.34 0 0 1 .033.042l.006.006c.008.014.021.03.029.047a.024.024 0 0 1 .006.011c.01.015.018.034.027.05v.006l.016.048v.012c.005.015.009.03.012.046l.005.014v.051a.166.166 0 0 1-.014.088.16.16 0 0 1-.057.069l7.535-4.377a.177.177 0 0 0 .057-.07.18.18 0 0 0 .014-.089c-.013-.022-.013-.041-.013-.057z"
            fill="#0E3C55"
        />
        <path
            d="M898.01 307.08v-.012a.647.647 0 0 1-.011-.047l-.006-.01a.2.2 0 0 0-.017-.054.249.249 0 0 0-.025-.052l-.005-.009-.029-.047c-.01-.014-.021-.025-.029-.038h-.006l-.011-.01a.167.167 0 0 0-.038-.037v-.005l-.05-.032a.152.152 0 0 0-.082-.033.155.155 0 0 0-.087.02l-7.534 4.375a.166.166 0 0 1 .088-.015c.03.004.058.015.082.033l.044.031h.009c.01.012.025.024.037.04v.006c.02.017.028.032.041.044v.008a.185.185 0 0 1 .03.039.418.418 0 0 1 .052.115v.016a.099.099 0 0 1 .009.042v.016a.224.224 0 0 1 .006.052.175.175 0 0 1-.071.155l7.535-4.381a.168.168 0 0 0 .057-.067.172.172 0 0 0 .014-.087l-.003-.056z"
            fill="#FC6B6B"
        />
        <path
            d="m890.4 311.28 7.56-4.339a.459.459 0 0 1 .044.189.153.153 0 0 1-.014.087.16.16 0 0 1-.057.067l-7.535 4.381a.167.167 0 0 0 .056-.068.163.163 0 0 0 .015-.087.51.51 0 0 0-.043-.18l-.026-.05z"
            fill="#ED4A4A"
        />
        <path
            d="M890.06 311.07c-.037.022-.335.588-.335.588.229.011.46.009.69-.007a.183.183 0 0 0 .061-.146.541.541 0 0 0-.244-.417.165.165 0 0 0-.172-.018z"
            fill="#FFC892"
        />
        <path
            d="m889.73 311.66.172.005c.011-.005 0-.047-.033-.085s-.051-.075-.058-.07l-.081.15z"
            fill="#FC6B6B"
        />
        <path
            d="m918.86 326.67-13.33-7.675v.384a.751.751 0 0 0 .376.651l12.574 7.24a.734.734 0 0 0 .753 0l9.2-5.427a.561.561 0 0 0 .283-.491v-.247l-9.856 5.565z"
            fill="#848484"
        />
        <path
            d="M928.5 320.8a.4.4 0 0 1 .01.71l-9.642 5.164-13.33-7.675 9.62-4.34a1.581 1.581 0 0 1 1.373.033L928.5 320.8z"
            fill="#E2E1E0"
        />
        <path
            d="M924.08 322.83c.119.074.244.36-.23.559l-4.272 2.335c-.352.217-.653.021-.982-.166l-11.26-6.486a.255.255 0 0 1-.16-.238.254.254 0 0 1 .16-.237l4.116-2.6a.703.703 0 0 1 .66-.093l11.968 6.926z"
            fill="#898686"
        />
        <path
            d="M914.56 317.42c.056.033.055.086 0 .116l-.569.332a.217.217 0 0 1-.2 0l-.572-.332c-.057-.03-.057-.083 0-.116l.57-.327a.208.208 0 0 1 .1-.027c.036 0 .07.01.1.027l.571.327zM911.76 320.41c.055.033.055.083 0 .114l-.568.331a.232.232 0 0 1-.2 0l-.572-.333c-.056-.029-.056-.079 0-.112l.568-.33c.031-.016.065-.025.1-.025s.069.009.1.025l.572.33zM912.76 320.98c.056.032.056.083 0 .114l-.569.33a.198.198 0 0 1-.2 0l-.576-.328a.058.058 0 0 1-.029-.022c-.008-.01-.012-.022-.012-.035s.004-.025.012-.035a.058.058 0 0 1 .029-.022l.572-.334a.22.22 0 0 1 .2 0l.573.332zM913.76 321.55c.056.032.056.082 0 .114l-.572.332a.22.22 0 0 1-.2 0l-.575-.332a.058.058 0 0 1-.028-.023.06.06 0 0 1 0-.07.058.058 0 0 1 .028-.023l.572-.328a.215.215 0 0 1 .2 0l.575.33zM912.59 317.48c.054.028.054.081 0 .114l-.568.332a.215.215 0 0 1-.2 0l-1.575-.913c-.055-.028-.055-.081 0-.112l.57-.332a.207.207 0 0 1 .2 0l1.573.911zM913.54 318.01a.058.058 0 0 1 .029.022.057.057 0 0 1 0 .07.053.053 0 0 1-.029.022l-.571.33a.207.207 0 0 1-.2 0l-.574-.332c-.055-.032-.055-.083 0-.114l.571-.333a.23.23 0 0 1 .1-.024c.034 0 .069.009.1.024l.574.335zM914.62 318.62c.054.036.054.085 0 .118l-.573.332a.232.232 0 0 1-.2 0l-.574-.33c-.055-.033-.055-.082 0-.118l.568-.328a.217.217 0 0 1 .2 0l.579.326zM915.61 319.21c.055.03.055.08 0 .112l-.57.333a.217.217 0 0 1-.2 0l-.573-.333c-.057-.032-.057-.082 0-.114l.569-.331a.207.207 0 0 1 .2 0l.574.333zM916.61 319.78c.055.031.055.082 0 .114l-.569.331a.217.217 0 0 1-.2 0l-.574-.334c-.057-.029-.057-.08 0-.113l.573-.329c.03-.017.063-.025.097-.025s.068.008.097.025l.576.331zM911.62 318.04c.056.03.056.083 0 .115l-.567.33a.23.23 0 0 1-.2 0l-1.572-.909c-.057-.031-.057-.082 0-.115l.568-.33c.031-.016.065-.025.1-.025s.069.009.1.025l1.571.909zM912.62 318.62c.012.004.022.011.029.021s.011.023.011.035-.004.024-.011.035a.056.056 0 0 1-.029.021l-.568.334a.231.231 0 0 1-.1.022.228.228 0 0 1-.1-.022l-.573-.334c-.058-.029-.058-.082 0-.115l.57-.328a.198.198 0 0 1 .2 0l.571.331zM913.66 319.23a.07.07 0 0 1 .028.023c.006.011.01.023.01.035s-.004.024-.01.035a.07.07 0 0 1-.028.023l-.57.331a.22.22 0 0 1-.2 0l-.575-.331a.061.061 0 0 1-.041-.058.061.061 0 0 1 .041-.058l.572-.332a.23.23 0 0 1 .2 0l.573.332zM914.66 319.81a.07.07 0 0 1 .028.023c.007.011.01.023.01.035s-.003.025-.01.035-.017.018-.028.023l-.572.329a.198.198 0 0 1-.2 0l-.575-.329c-.055-.034-.055-.087 0-.116l.569-.33a.23.23 0 0 1 .2 0l.578.33zM914.76 322.13a.07.07 0 0 1 .028.023.063.063 0 0 1 0 .071.057.057 0 0 1-.028.023l-.571.33c-.031.017-.065.025-.1.025s-.07-.008-.1-.025l-.574-.33a.055.055 0 0 1-.029-.023.063.063 0 0 1 0-.071.066.066 0 0 1 .029-.023l.57-.332a.23.23 0 0 1 .1-.024c.034 0 .069.009.1.024l.575.332zM917.62 320.36c.055.028.055.08 0 .114l-.57.33c-.031.017-.065.025-.1.025s-.069-.008-.1-.025l-.574-.33c-.054-.034-.059-.086 0-.116l.568-.332a.23.23 0 0 1 .2 0l.576.334zM915.66 320.39c.012.004.022.012.029.022s.011.023.011.035-.004.024-.011.035a.058.058 0 0 1-.029.022l-.571.332a.23.23 0 0 1-.2 0l-.572-.332c-.057-.031-.057-.084 0-.114l.568-.331a.207.207 0 0 1 .2 0l.575.331zM916.66 320.96c.055.032.055.082 0 .114l-.571.329a.207.207 0 0 1-.2 0l-.574-.329c-.055-.032-.055-.082 0-.114l.57-.334a.243.243 0 0 1 .2 0l.575.334zM912.7 319.82c.055.028.055.082 0 .114l-.57.33a.23.23 0 0 1-.2 0l-.573-.33c-.054-.032-.054-.086 0-.114l.57-.335c.031-.016.065-.025.1-.025s.069.009.1.025l.573.335zM913.69 320.4c.054.032.056.085 0 .115l-.569.33c-.031.016-.065.025-.1.025s-.069-.009-.1-.025l-.572-.332c-.057-.029-.057-.081 0-.113l.57-.328a.198.198 0 0 1 .2 0l.571.328zM914.7 320.97c.055.03.055.081 0 .115l-.569.328c-.03.018-.065.027-.1.027s-.07-.009-.1-.027l-.573-.33c-.054-.032-.054-.083 0-.113l.569-.334a.23.23 0 0 1 .2 0l.573.334zM915.69 321.55c.055.032.055.082 0 .114l-.57.332a.233.233 0 0 1-.1.024.23.23 0 0 1-.1-.024l-.573-.332c-.056-.032-.056-.082 0-.114l.57-.33a.209.209 0 0 1 .2 0l.573.33zM915.76 322.71c.055.031.055.083 0 .113l-.569.332c-.031.016-.065.025-.1.025s-.069-.009-.1-.025l-.576-.332a.06.06 0 0 1-.04-.057.06.06 0 0 1 .04-.056l.571-.332a.207.207 0 0 1 .2 0l.574.332zM918.75 321.02a.06.06 0 0 1 .042.057c0 .012-.004.025-.012.035s-.018.017-.03.021l-.57.332a.207.207 0 0 1-.2 0l-.574-.332c-.054-.031-.054-.085 0-.113l.571-.332a.204.204 0 0 1 .2 0l.573.332zM917.66 321.54a.053.053 0 0 1 .027.022.058.058 0 0 1 0 .068.055.055 0 0 1-.027.023l-.573.332a.207.207 0 0 1-.2 0l-.575-.332c-.055-.032-.055-.08 0-.113l.569-.332a.198.198 0 0 1 .2 0l.579.332zM916.7 322.13a.06.06 0 0 1 .028.024.06.06 0 0 1 .01.035.059.059 0 0 1-.01.034.06.06 0 0 1-.028.024l-.571.33a.23.23 0 0 1-.2 0l-.572-.33c-.056-.033-.058-.083 0-.117l.569-.332a.22.22 0 0 1 .2 0l.574.332zM908.8 318.66c.057.029.057.08 0 .113l-.57.33a.216.216 0 0 1-.195 0l-.576-.328c-.05-.035-.05-.086 0-.115l.57-.334a.22.22 0 0 1 .2 0l.571.334zM909.75 319.21c.058.033.058.085 0 .115l-.572.332c-.031.016-.065.025-.1.025s-.069-.009-.1-.025l-.575-.332c-.054-.03-.054-.082 0-.115l.572-.33c.031-.016.065-.025.1-.025s.069.009.1.025l.575.33zM910.75 319.79c.054.034.056.083 0 .116l-.569.332a.23.23 0 0 1-.2 0l-.575-.332a.059.059 0 0 1-.029-.023.06.06 0 0 1 0-.07.059.059 0 0 1 .029-.023l.571-.329c.031-.017.065-.025.1-.025s.07.008.1.025l.573.329zM919.72 320.45c.054.032.054.079 0 .113l-.57.331a.217.217 0 0 1-.2 0l-4.576-2.644c-.055-.029-.055-.081 0-.113l.571-.333a.23.23 0 0 1 .2 0l4.575 2.646zM920.74 321.04c.011.005.02.014.027.024s.01.023.01.035-.003.025-.01.035-.016.019-.027.024l-.571.328a.22.22 0 0 1-.2 0l-.575-.33c-.056-.033-.056-.083 0-.116l.571-.33a.212.212 0 0 1 .195 0l.58.33zM921.75 321.64a.058.058 0 0 1 .029.022c.008.01.012.022.012.035s-.004.025-.012.035a.058.058 0 0 1-.029.022l-.568.334a.22.22 0 0 1-.2 0l-.572-.334c-.059-.031-.059-.083 0-.114l.568-.329a.215.215 0 0 1 .2 0l.572.329zM919.73 321.61a.058.058 0 0 1 .029.022.06.06 0 0 1 .012.036.06.06 0 0 1-.012.035.058.058 0 0 1-.029.022l-.569.33a.217.217 0 0 1-.2 0l-.572-.33c-.056-.032-.057-.085 0-.115l.569-.332a.217.217 0 0 1 .2 0l.572.332zM909.72 318.03a.054.054 0 0 1 .031.022.058.058 0 0 1 0 .071.054.054 0 0 1-.031.022l-.567.329a.237.237 0 0 1-.201 0l-.574-.329c-.054-.033-.054-.086 0-.115l.571-.332a.224.224 0 0 1 .201 0l.57.332zM910.72 318.6a.058.058 0 0 1 .029.022.066.066 0 0 1 .011.036.066.066 0 0 1-.011.035.058.058 0 0 1-.029.022l-.569.332a.207.207 0 0 1-.2 0l-.575-.332a.065.065 0 0 1-.03-.022.066.066 0 0 1-.011-.035c0-.013.004-.025.011-.036a.065.065 0 0 1 .03-.022l.572-.329a.203.203 0 0 1 .194 0l.578.329zM911.72 319.18c.053.035.053.083 0 .116l-.571.332a.23.23 0 0 1-.1.024.233.233 0 0 1-.1-.024l-.573-.332a.07.07 0 0 1-.028-.023c-.006-.01-.01-.023-.01-.035s.004-.024.01-.035a.07.07 0 0 1 .028-.023l.57-.33a.232.232 0 0 1 .2 0l.574.33zM918.67 322.19c.056.032.056.085 0 .115l-.571.329a.204.204 0 0 1-.2 0l-.574-.329c-.055-.03-.055-.083 0-.115l.572-.33a.208.208 0 0 1 .194 0l.579.33zM919.8 322.76c.053.036.053.086 0 .116l-.571.328c-.03.018-.065.028-.1.029s-.07-.007-.1-.024l-.575-.333a.058.058 0 0 1-.028-.023.06.06 0 0 1 0-.07.058.058 0 0 1 .028-.023l.573-.328a.209.209 0 0 1 .2 0l.573.328zM921.73 323.9c.055.034.055.084 0 .115l-.57.331a.217.217 0 0 1-.2 0l-1.573-.91c-.055-.03-.055-.084 0-.112l.57-.333a.217.217 0 0 1 .2 0l1.573.909zM917.7 322.71c.055.031.055.083 0 .113l-.569.332a.217.217 0 0 1-.2 0l-.572-.332c-.056-.031-.056-.082 0-.113l.568-.332a.207.207 0 0 1 .2 0l.573.332zM918.71 323.32c.055.028.055.082 0 .112l-.567.331c-.031.016-.065.025-.1.025s-.069-.009-.1-.025l-.574-.331c-.011-.004-.021-.012-.028-.022s-.011-.023-.011-.035.004-.024.011-.035a.06.06 0 0 1 .028-.022l.571-.331a.22.22 0 0 1 .2 0l.57.333zM920.7 324.44a.063.063 0 0 1 .04.058.063.063 0 0 1-.011.035.08.08 0 0 1-.029.023l-.57.33a.237.237 0 0 1-.1.024.238.238 0 0 1-.101-.024l-1.572-.91c-.056-.032-.056-.086 0-.115l.571-.331a.214.214 0 0 1 .199 0l1.573.91zM916.75 323.26c.057.035.057.082 0 .117l-.569.329a.217.217 0 0 1-.2 0l-.574-.331a.065.065 0 0 1-.03-.022.066.066 0 0 1-.011-.036c0-.012.004-.024.011-.035a.065.065 0 0 1 .03-.022l.569-.332a.23.23 0 0 1 .2 0l.574.332zM919.75 324.99c.059.031.059.082 0 .114l-.568.328a.215.215 0 0 1-.2 0l-1.573-.907c-.054-.032-.054-.083 0-.113l.571-.332a.204.204 0 0 1 .2 0l1.57.91zM922.74 322.22a.063.063 0 0 1 .04.058.06.06 0 0 1-.011.035.055.055 0 0 1-.029.023l-.57.331a.23.23 0 0 1-.2 0l-.575-.332a.057.057 0 0 1-.028-.023.06.06 0 0 1 0-.069.07.07 0 0 1 .028-.023l.57-.33a.215.215 0 0 1 .2 0l.575.33zM923.76 322.79c.056.033.056.082 0 .115l-.569.332a.25.25 0 0 1-.2 0l-.574-.332a.058.058 0 0 1-.028-.023.06.06 0 0 1 0-.069.05.05 0 0 1 .028-.023l.571-.331a.204.204 0 0 1 .2 0l.572.331z"
            fill="#4A4A4A"
        />
        <path
            d="m921.98 322.66-.575-.332c-.011-.005-.021-.013-.028-.023s-.011-.022-.012-.034v.113a.064.064 0 0 0 .012.035.07.07 0 0 0 .028.023l.573.332.002-.114z"
            fill="#636363"
        />
        <path
            d="M922.78 322.27a.08.08 0 0 1-.04.056l-.57.331a.23.23 0 0 1-.2 0v.114a.23.23 0 0 0 .2 0l.57-.332a.074.074 0 0 0 .04-.056v-.113z"
            fill="#3D3D3D"
        />
        <path
            d="m922.99 323.23-.574-.332a.08.08 0 0 1-.029-.023.071.071 0 0 1-.013-.034v.115c.001.012.006.024.013.034s.017.018.029.023l.574.33v-.113z"
            fill="#636363"
        />
        <path
            d="M923.8 322.84a.08.08 0 0 1-.014.033.08.08 0 0 1-.029.023l-.569.332c-.031.015-.065.024-.1.024s-.069-.009-.1-.024v.113c.031.017.065.025.1.025s.069-.008.1-.025l.571-.33a.066.066 0 0 0 .041-.057v-.114z"
            fill="#3D3D3D"
        />
        <path
            d="m913.8 317.87-.572-.332a.073.073 0 0 1-.029-.023.064.064 0 0 1-.013-.033v.112c0 .012.005.025.012.035.008.01.018.018.03.022l.572.333v-.114z"
            fill="#636363"
        />
        <path
            d="M914.61 317.48c0 .019-.013.038-.042.055l-.569.332a.217.217 0 0 1-.2 0v.114c.031.017.065.025.1.025s.069-.008.1-.025l.569-.331a.066.066 0 0 0 .029-.023.063.063 0 0 0 .013-.035v-.112z"
            fill="#3D3D3D"
        />
        <path
            d="m910.99 320.84-.575-.332a.067.067 0 0 1-.041-.055v.114a.057.057 0 0 0 .013.033.06.06 0 0 0 .028.022l.575.333v-.115z"
            fill="#636363"
        />
        <path
            d="M911.79 320.46c0 .023-.011.042-.043.057l-.567.33a.215.215 0 0 1-.2 0v.115a.215.215 0 0 0 .2 0l.567-.333a.052.052 0 0 0 .03-.02.055.055 0 0 0 .013-.034v-.115z"
            fill="#3D3D3D"
        />
        <path
            d="m911.99 321.42-.575-.33c-.011-.004-.021-.012-.028-.022s-.012-.022-.013-.034v.114c0 .02.013.04.041.066l.574.33.001-.124z"
            fill="#636363"
        />
        <path
            d="M912.79 321.03c0 .013-.004.025-.011.035s-.017.018-.029.023l-.57.328a.198.198 0 0 1-.2 0v.115a.22.22 0 0 0 .2 0l.57-.333a.076.076 0 0 0 .028-.022.07.07 0 0 0 .012-.034v-.112z"
            fill="#3D3D3D"
        />
        <path
            d="m912.99 322-.575-.332a.078.078 0 0 1-.027-.024.077.077 0 0 1-.012-.033v.113a.07.07 0 0 0 .012.034.072.072 0 0 0 .027.025l.575.332V322z"
            fill="#636363"
        />
        <path
            d="M913.8 321.61a.06.06 0 0 1-.011.034.073.073 0 0 1-.029.023l-.572.332a.217.217 0 0 1-.2 0v.115a.22.22 0 0 0 .2 0l.57-.332a.06.06 0 0 0 .03-.022.057.057 0 0 0 .012-.035v-.115z"
            fill="#3D3D3D"
        />
        <path
            d="m911.82 317.93-1.575-.913a.068.068 0 0 1-.029-.022.064.064 0 0 1-.013-.033v.115a.071.071 0 0 0 .013.034c.008.01.018.017.029.022l1.575.909v-.112z"
            fill="#636363"
        />
        <path
            d="M912.63 317.54a.071.071 0 0 1-.041.057l-.568.332a.215.215 0 0 1-.2 0v.112a.215.215 0 0 0 .2 0l.568-.332a.074.074 0 0 0 .028-.022.07.07 0 0 0 .013-.032v-.115z"
            fill="#3D3D3D"
        />
        <path
            d="m912.77 318.46-.574-.332c-.011-.005-.02-.013-.027-.023s-.012-.021-.014-.033v.112a.073.073 0 0 0 .014.034.072.072 0 0 0 .027.025l.574.329v-.112z"
            fill="#636363"
        />
        <path
            d="M913.58 318.07a.071.071 0 0 1-.038.056l-.571.33a.209.209 0 0 1-.2 0v.112a.22.22 0 0 0 .2 0l.573-.329a.075.075 0 0 0 .038-.058l-.002-.111z"
            fill="#3D3D3D"
        />
        <path
            d="m913.85 319.07-.574-.33c-.028-.018-.043-.037-.043-.057v.113a.083.083 0 0 0 .014.035c.008.01.018.019.029.024l.574.329v-.114z"
            fill="#636363"
        />
        <path
            d="M914.66 318.69c0 .02-.014.037-.04.055l-.573.332a.232.232 0 0 1-.2 0v.114c.03.017.065.025.1.025s.069-.008.1-.025l.573-.329c.026-.018.04-.036.04-.057v-.115z"
            fill="#3D3D3D"
        />
        <path
            d="m914.85 319.65-.573-.333a.063.063 0 0 1-.029-.022.064.064 0 0 1-.014-.035v.116c0 .02.013.039.043.057l.573.33v-.113z"
            fill="#636363"
        />
        <path
            d="M915.66 319.26a.065.065 0 0 1-.013.035.06.06 0 0 1-.028.022l-.57.333a.22.22 0 0 1-.2 0v.113a.217.217 0 0 0 .2 0l.57-.33a.077.077 0 0 0 .028-.023.083.083 0 0 0 .013-.034v-.116z"
            fill="#3D3D3D"
        />
        <path
            d="m915.85 320.23-.574-.334a.073.073 0 0 1-.042-.056v.116a.083.083 0 0 0 .013.034c.008.01.017.018.028.023l.575.331v-.114z"
            fill="#636363"
        />
        <path
            d="M916.66 319.84c0 .021-.014.039-.043.057l-.569.331a.22.22 0 0 1-.2 0v.114a.23.23 0 0 0 .2 0l.569-.331a.073.073 0 0 0 .043-.057v-.114z"
            fill="#3D3D3D"
        />
        <path
            d="m910.85 318.49-1.572-.909a.066.066 0 0 1-.041-.058v.115a.063.063 0 0 0 .041.056l1.572.909v-.113z"
            fill="#636363"
        />
        <path
            d="M911.66 318.1a.07.07 0 0 1-.04.058l-.568.33a.23.23 0 0 1-.199 0v.113a.228.228 0 0 0 .199 0l.568-.329c.011-.005.021-.014.028-.025s.011-.023.011-.036l.001-.111z"
            fill="#3D3D3D"
        />
        <path
            d="m911.86 319.07-.573-.334a.07.07 0 0 1-.041-.058v.114a.07.07 0 0 0 .013.035.065.065 0 0 0 .028.024l.572.33.001-.111z"
            fill="#636363"
        />
        <path
            d="M912.66 318.67a.055.055 0 0 1-.012.033.063.063 0 0 1-.028.023l-.568.334a.228.228 0 0 1-.1.022.227.227 0 0 1-.099-.022v.111a.214.214 0 0 0 .199 0l.571-.33c.011-.005.02-.013.027-.023s.011-.021.013-.033l-.003-.115z"
            fill="#3D3D3D"
        />
        <path
            d="m912.89 319.67-.575-.331c-.011-.005-.02-.013-.027-.023s-.012-.022-.013-.034v.113a.066.066 0 0 0 .04.057l.575.331v-.113z"
            fill="#636363"
        />
        <path
            d="M913.7 319.29a.093.093 0 0 1-.012.033.085.085 0 0 1-.026.024l-.57.331a.22.22 0 0 1-.2 0v.113a.198.198 0 0 0 .2 0l.572-.329a.07.07 0 0 0 .038-.057l-.002-.115z"
            fill="#3D3D3D"
        />
        <path
            d="m913.89 320.25-.575-.329a.078.078 0 0 1-.04-.058v.112c0 .024.012.042.039.061l.574.327.002-.113z"
            fill="#636363"
        />
        <path
            d="M914.7 319.87a.08.08 0 0 1-.04.056l-.572.329a.198.198 0 0 1-.2 0v.113a.198.198 0 0 0 .2 0l.572-.327c.025-.019.039-.037.039-.057l.001-.114z"
            fill="#3D3D3D"
        />
        <path
            d="m913.99 322.57-.574-.33a.07.07 0 0 1-.043-.06v.116c.001.013.006.025.013.035s.017.019.028.024l.576.329v-.114z"
            fill="#636363"
        />
        <path
            d="M914.8 322.19a.063.063 0 0 1-.04.058l-.571.33a.215.215 0 0 1-.2 0v.114a.22.22 0 0 0 .2 0l.571-.329a.081.081 0 0 0 .028-.024.077.077 0 0 0 .012-.035v-.114z"
            fill="#3D3D3D"
        />
        <path
            d="m916.85 320.81-.574-.33a.062.062 0 0 1-.029-.024.069.069 0 0 1-.013-.036v.115c.001.012.005.025.012.035s.017.018.028.023l.576.33v-.113z"
            fill="#636363"
        />
        <path
            d="M917.66 320.42a.074.074 0 0 1-.015.034.081.081 0 0 1-.028.024l-.57.33a.215.215 0 0 1-.2 0v.113a.217.217 0 0 0 .2 0l.571-.33a.09.09 0 0 0 .029-.022.085.085 0 0 0 .014-.034l-.001-.115z"
            fill="#3D3D3D"
        />
        <path
            d="m914.89 320.83-.572-.332c-.011-.005-.022-.013-.029-.023s-.012-.022-.013-.035v.113a.069.069 0 0 0 .042.059l.572.332v-.114z"
            fill="#636363"
        />
        <path
            d="M915.7 320.44c-.001.012-.005.024-.012.034s-.016.018-.027.024l-.571.332a.232.232 0 0 1-.2 0v.114a.204.204 0 0 0 .2 0l.571-.328a.064.064 0 0 0 .026-.023.07.07 0 0 0 .013-.032v-.121z"
            fill="#3D3D3D"
        />
        <path
            d="m915.89 321.41-.574-.329a.08.08 0 0 1-.029-.023.07.07 0 0 1-.013-.035v.113c0 .023.014.041.042.06l.574.331v-.117z"
            fill="#636363"
        />
        <path
            d="M916.7 321.02a.077.077 0 0 1-.012.035.07.07 0 0 1-.028.023l-.571.329a.207.207 0 0 1-.2 0v.117a.23.23 0 0 0 .2 0l.571-.331a.075.075 0 0 0 .04-.06v-.113z"
            fill="#3D3D3D"
        />
        <path
            d="m911.93 320.26-.573-.33c-.011-.005-.021-.014-.028-.024s-.012-.022-.013-.035v.115a.065.065 0 0 0 .014.033c.007.01.016.018.027.023l.573.331v-.113z"
            fill="#636363"
        />
        <path
            d="M912.74 319.87a.07.07 0 0 1-.04.059l-.57.33a.232.232 0 0 1-.2 0v.113a.217.217 0 0 0 .2 0l.57-.331a.074.074 0 0 0 .04-.056v-.115z"
            fill="#3D3D3D"
        />
        <path
            d="m912.93 320.84-.572-.332a.068.068 0 0 1-.043-.057v.116a.075.075 0 0 0 .014.033c.007.01.017.017.028.022l.573.333v-.115z"
            fill="#636363"
        />
        <path
            d="M913.74 320.46a.07.07 0 0 1-.015.034.073.073 0 0 1-.029.023l-.569.33c-.031.016-.065.025-.1.025s-.069-.009-.1-.025v.115c.031.016.065.025.1.025s.069-.009.1-.025l.569-.332a.075.075 0 0 0 .029-.021.071.071 0 0 0 .013-.034l.002-.115z"
            fill="#3D3D3D"
        />
        <path
            d="m913.93 321.42-.573-.33a.068.068 0 0 1-.029-.022.078.078 0 0 1-.013-.034v.114a.069.069 0 0 0 .014.034.06.06 0 0 0 .028.022l.573.331v-.115z"
            fill="#636363"
        />
        <path
            d="M914.74 321.03a.072.072 0 0 1-.014.035.07.07 0 0 1-.028.023l-.569.328a.198.198 0 0 1-.2 0v.115c.031.016.065.025.1.025s.069-.009.1-.025l.569-.331a.074.074 0 0 0 .04-.056l.002-.114z"
            fill="#3D3D3D"
        />
        <path
            d="m914.93 322-.573-.332c-.011-.005-.02-.013-.027-.023s-.011-.022-.013-.034v.113a.079.079 0 0 0 .013.035c.007.01.016.018.027.024l.573.332V322z"
            fill="#636363"
        />
        <path
            d="M915.74 321.61a.08.08 0 0 1-.041.057l-.57.332a.233.233 0 0 1-.1.024.23.23 0 0 1-.1-.024v.115a.217.217 0 0 0 .2 0l.569-.332c.026-.016.043-.035.043-.057l-.001-.115z"
            fill="#3D3D3D"
        />
        <path
            d="m914.99 323.16-.576-.332a.065.065 0 0 1-.028-.024.063.063 0 0 1-.013-.035v.114c0 .023.015.041.041.06l.576.33v-.113z"
            fill="#636363"
        />
        <path
            d="M915.8 322.77c0 .012-.005.024-.012.034s-.016.017-.028.022l-.569.332c-.031.016-.065.025-.1.025s-.069-.009-.1-.025v.117c.031.016.065.025.1.025s.069-.009.1-.025l.569-.33a.066.066 0 0 0 .04-.06v-.115z"
            fill="#3D3D3D"
        />
        <path
            d="m917.85 321.38-.571-.331a.07.07 0 0 1-.041-.058v.115c.002.012.006.024.013.034s.017.018.028.023l.571.331v-.114z"
            fill="#636363"
        />
        <path
            d="M918.8 321.07a.062.062 0 0 1-.013.034.064.064 0 0 1-.029.022l-.57.332a.204.204 0 0 1-.2 0v.114a.215.215 0 0 0 .2 0l.57-.332a.076.076 0 0 0 .029-.024.065.065 0 0 0 .013-.035v-.111z"
            fill="#3D3D3D"
        />
        <path
            d="m916.89 321.99-.575-.332c-.026-.016-.041-.034-.041-.056v.111a.07.07 0 0 0 .012.035.07.07 0 0 0 .029.023l.575.332v-.113z"
            fill="#636363"
        />
        <path
            d="M917.7 321.6a.066.066 0 0 1-.012.033.058.058 0 0 1-.026.023l-.573.332a.207.207 0 0 1-.2 0v.113a.204.204 0 0 0 .2 0l.573-.332a.058.058 0 0 0 .026-.023.063.063 0 0 0 .012-.033v-.113z"
            fill="#3D3D3D"
        />
        <path
            d="m915.93 322.57-.572-.33a.067.067 0 0 1-.029-.024.066.066 0 0 1-.013-.036v.116a.081.081 0 0 0 .043.059l.573.329-.002-.114z"
            fill="#636363"
        />
        <path
            d="M916.74 322.19a.07.07 0 0 1-.041.058l-.571.33a.232.232 0 0 1-.2 0v.114a.217.217 0 0 0 .2 0l.571-.329a.063.063 0 0 0 .027-.024.077.077 0 0 0 .012-.035l.002-.114z"
            fill="#3D3D3D"
        />
        <path
            d="m908.03 319.11-.576-.328a.083.083 0 0 1-.042-.06v.113c.002.013.007.025.014.035s.017.019.028.024l.576.331v-.115z"
            fill="#636363"
        />
        <path
            d="M908.84 318.71c0 .022-.015.041-.043.058l-.567.332a.217.217 0 0 1-.2 0v.113a.209.209 0 0 0 .195 0l.57-.33a.07.07 0 0 0 .041-.059l.004-.114z"
            fill="#3D3D3D"
        />
        <path
            d="m908.98 319.66-.575-.332c-.011-.005-.021-.013-.028-.023s-.011-.022-.012-.034v.114c.002.012.007.024.014.034s.017.019.028.024l.575.332-.002-.115z"
            fill="#636363"
        />
        <path
            d="M909.79 319.27a.066.066 0 0 1-.041.057l-.572.332a.215.215 0 0 1-.2 0v.115a.22.22 0 0 0 .2 0l.572-.332c.012-.005.021-.014.028-.024s.011-.022.012-.034l.001-.114z"
            fill="#3D3D3D"
        />
        <path
            d="m909.98 320.24-.575-.332a.062.062 0 0 1-.028-.023.06.06 0 0 1-.013-.034v.114c0 .023.014.041.041.059l.575.328v-.112z"
            fill="#636363"
        />
        <path
            d="M910.79 319.85a.06.06 0 0 1-.013.034.06.06 0 0 1-.029.023l-.569.332a.23.23 0 0 1-.2 0v.112a.22.22 0 0 0 .2 0l.569-.328c.012-.005.022-.013.029-.023s.012-.022.013-.035v-.115z"
            fill="#3D3D3D"
        />
        <path
            d="m918.95 320.89-4.594-2.665c-.027-.019-.04-.037-.04-.058v.115c0 .015.013.04.056.08l4.578 2.64v-.112zM919.97 321.49l-.575-.33c-.028-.019-.042-.039-.042-.058v.113a.069.069 0 0 0 .013.036c.007.01.017.019.029.024l.575.329v-.114z"
            fill="#636363"
        />
        <path
            d="M920.78 321.1c0 .021-.014.039-.039.06l-.571.328a.217.217 0 0 1-.2 0v.114a.23.23 0 0 0 .2 0l.574-.33a.08.08 0 0 0 .027-.025.086.086 0 0 0 .012-.035l-.003-.112zM919.76 320.51c0 .021-.016.039-.04.056l-.571.332c-.031.016-.065.025-.1.025s-.069-.009-.1-.025v.112c.031.017.065.027.1.027s.07-.01.1-.027l.57-.328c.011-.006.02-.014.027-.024s.011-.022.012-.034l.002-.114z"
            fill="#3D3D3D"
        />
        <path
            d="m920.98 322.09-.572-.334a.063.063 0 0 1-.03-.021.058.058 0 0 1-.014-.034v.114a.07.07 0 0 0 .012.035c.008.01.018.018.029.022l.575.332v-.114z"
            fill="#636363"
        />
        <path
            d="M921.79 321.7a.07.07 0 0 1-.012.034.063.063 0 0 1-.029.02l-.568.334a.22.22 0 0 1-.2 0v.114a.215.215 0 0 0 .2 0l.568-.332a.068.068 0 0 0 .029-.022.07.07 0 0 0 .012-.035v-.113z"
            fill="#3D3D3D"
        />
        <path
            d="M913.58 316.85c.056.03.057.081 0 .113l-.568.33c-.031.017-.065.025-.1.025s-.07-.008-.1-.025l-1.574-.907a.06.06 0 0 1-.03-.022.06.06 0 0 1 0-.072.057.057 0 0 1 .03-.023l.571-.33a.23.23 0 0 1 .2 0l1.571.911z"
            fill="#4A4A4A"
        />
        <path
            d="m912.82 317.29-1.574-.907a.066.066 0 0 1-.029-.023.078.078 0 0 1-.013-.036v.113a.078.078 0 0 0 .013.036c.007.01.017.019.029.024l1.572.91.002-.117z"
            fill="#636363"
        />
        <path
            d="M913.63 316.9a.065.065 0 0 1-.013.035.063.063 0 0 1-.028.023l-.568.33c-.03.017-.065.025-.1.025s-.069-.008-.1-.025v.117a.243.243 0 0 0 .2 0l.57-.332a.068.068 0 0 0 .029-.024.069.069 0 0 0 .013-.036l-.003-.113z"
            fill="#3D3D3D"
        />
        <path
            d="m918.97 322.06-.572-.33a.085.085 0 0 1-.029-.024.079.079 0 0 1-.013-.035v.116a.064.064 0 0 0 .013.033c.008.01.017.018.029.023l.572.33v-.113z"
            fill="#636363"
        />
        <path
            d="M919.78 321.67a.079.079 0 0 1-.013.035.081.081 0 0 1-.028.024l-.569.33a.217.217 0 0 1-.2 0v.113c.03.017.065.027.1.027s.069-.01.1-.027l.568-.33a.074.074 0 0 0 .028-.021.07.07 0 0 0 .014-.033v-.118z"
            fill="#3D3D3D"
        />
        <path
            d="m908.95 318.47-.574-.329a.073.073 0 0 1-.029-.023.079.079 0 0 1-.013-.035v.113a.062.062 0 0 0 .013.034.06.06 0 0 0 .029.023l.574.331v-.114z"
            fill="#636363"
        />
        <path
            d="M909.76 318.08c-.001.012-.005.024-.012.034s-.016.018-.027.024l-.568.329a.23.23 0 0 1-.2 0v.114a.217.217 0 0 0 .2 0l.568-.33a.063.063 0 0 0 .027-.024.07.07 0 0 0 .012-.034v-.113z"
            fill="#3D3D3D"
        />
        <path
            d="m909.95 319.05-.575-.332a.08.08 0 0 1-.029-.023.071.071 0 0 1-.013-.034v.115a.062.062 0 0 0 .013.034c.007.01.017.017.029.021l.575.334v-.115z"
            fill="#636363"
        />
        <path
            d="M910.76 318.66a.063.063 0 0 1-.041.055l-.569.332a.204.204 0 0 1-.2 0v.115a.217.217 0 0 0 .2 0l.571-.334a.058.058 0 0 0 .028-.021.054.054 0 0 0 .013-.032l-.002-.115z"
            fill="#3D3D3D"
        />
        <path
            d="m910.95 319.63-.573-.332a.078.078 0 0 1-.029-.025.07.07 0 0 1-.013-.035v.117a.085.085 0 0 0 .014.034.091.091 0 0 0 .028.023l.573.331v-.113z"
            fill="#636363"
        />
        <path
            d="M911.76 319.24a.07.07 0 0 1-.012.034.07.07 0 0 1-.029.022l-.571.332a.217.217 0 0 1-.2 0v.113a.198.198 0 0 0 .2 0l.571-.327a.071.071 0 0 0 .041-.057v-.117z"
            fill="#3D3D3D"
        />
        <path
            d="m917.89 322.56-.576-.329c-.011-.005-.021-.014-.028-.024s-.01-.023-.011-.035v.114c.001.012.005.024.012.034s.017.018.028.023l.576.33-.001-.113z"
            fill="#636363"
        />
        <path
            d="M918.71 322.25a.067.067 0 0 1-.01.034.07.07 0 0 1-.028.023l-.571.329a.204.204 0 0 1-.2 0v.117a.22.22 0 0 0 .2 0l.569-.332c.011-.005.021-.012.028-.022s.011-.021.012-.033v-.116z"
            fill="#3D3D3D"
        />
        <path
            d="m919.02 323.21-.575-.333a.096.096 0 0 1-.026-.023.066.066 0 0 1-.012-.033v.111a.076.076 0 0 0 .011.035c.007.01.016.018.027.024l.575.333v-.114z"
            fill="#636363"
        />
        <path
            d="M919.83 322.82c0 .012-.004.023-.011.033s-.017.018-.028.023l-.571.328a.204.204 0 0 1-.2.005v.114a.23.23 0 0 0 .2 0l.571-.333a.067.067 0 0 0 .026-.024.065.065 0 0 0 .011-.033l.002-.113z"
            fill="#3D3D3D"
        />
        <path
            d="m920.96 324.35-1.573-.91c-.012-.005-.022-.013-.03-.023s-.013-.022-.014-.034v.116a.06.06 0 0 0 .013.032c.008.01.018.017.029.021l1.575.912v-.114z"
            fill="#636363"
        />
        <path
            d="M921.77 323.96c-.001.012-.006.024-.013.034s-.016.018-.027.023l-.57.331a.217.217 0 0 1-.2 0v.114c.031.017.065.025.1.025s.069-.008.1-.025l.573-.332a.07.07 0 0 0 .028-.023.063.063 0 0 0 .012-.033l-.003-.114z"
            fill="#3D3D3D"
        />
        <path
            d="m916.93 323.16-.572-.332a.065.065 0 0 1-.041-.059v.114c0 .023.011.041.041.06l.572.33v-.113z"
            fill="#636363"
        />
        <path
            d="M917.74 322.77c0 .021-.014.04-.04.056l-.569.332a.22.22 0 0 1-.2 0v.117a.217.217 0 0 0 .2 0l.569-.33c.01-.006.02-.014.027-.024s.011-.022.013-.034v-.117z"
            fill="#3D3D3D"
        />
        <path
            d="m917.93 323.73-.571-.33a.076.076 0 0 1-.03-.023.078.078 0 0 1-.013-.036v.116c0 .021.015.04.045.056l.571.333-.002-.116z"
            fill="#636363"
        />
        <path
            d="M918.76 323.38c0 .022-.014.041-.043.057l-.567.331a.217.217 0 0 1-.2 0v.114c.031.017.065.025.1.025s.07-.008.1-.025l.567-.333a.06.06 0 0 0 .029-.02.052.052 0 0 0 .012-.033l.002-.116z"
            fill="#3D3D3D"
        />
        <path
            d="m919.93 324.89-1.573-.91a.074.074 0 0 1-.04-.056v.113a.066.066 0 0 0 .012.033c.006.01.016.018.026.023l1.575.908v-.111z"
            fill="#636363"
        />
        <path
            d="M920.74 324.5a.085.085 0 0 1-.014.034.072.072 0 0 1-.027.025l-.57.33a.22.22 0 0 1-.2 0V325a.198.198 0 0 0 .2 0l.57-.33a.066.066 0 0 0 .039-.055l.002-.115z"
            fill="#3D3D3D"
        />
        <path
            d="m915.99 323.7-.574-.331c-.026-.018-.042-.037-.042-.056v.112a.079.079 0 0 0 .013.035.08.08 0 0 0 .029.023l.574.333v-.116z"
            fill="#636363"
        />
        <path
            d="M916.79 323.31c0 .019-.013.039-.043.058l-.569.329a.22.22 0 0 1-.2 0v.116a.23.23 0 0 0 .2 0l.569-.333a.065.065 0 0 0 .043-.056v-.114z"
            fill="#3D3D3D"
        />
        <path
            d="m916.99 324.28-.577-.333c-.011-.005-.021-.013-.028-.023s-.011-.022-.012-.034v.111a.08.08 0 0 0 .012.037c.008.01.017.019.029.025l.577.33-.001-.113z"
            fill="#636363"
        />
        <path
            d="M917.79 323.89a.059.059 0 0 1-.01.034.06.06 0 0 1-.027.023l-.57.333a.23.23 0 0 1-.2 0v.113a.22.22 0 0 0 .2 0l.568-.33a.066.066 0 0 0 .039-.06v-.113z"
            fill="#3D3D3D"
        />
        <path
            d="M917.76 323.83a.058.058 0 0 1 .029.022c.008.01.011.023.011.035a.059.059 0 0 1-.011.036.058.058 0 0 1-.029.022l-.57.333a.231.231 0 0 1-.1.022.228.228 0 0 1-.1-.022l-.577-.333a.065.065 0 0 1-.03-.022.063.063 0 0 1 0-.071.065.065 0 0 1 .03-.022l.571-.331a.217.217 0 0 1 .2 0l.576.331z"
            fill="#4A4A4A"
        />
        <path
            d="m918.99 325.43-1.573-.907a.083.083 0 0 1-.029-.024.073.073 0 0 1-.012-.035v.116a.075.075 0 0 0 .043.056l1.573.909-.002-.115z"
            fill="#636363"
        />
        <path
            d="M919.8 325.05c-.001.012-.006.023-.013.033s-.017.018-.028.024l-.568.328c-.031.016-.065.025-.1.025s-.069-.009-.1-.025v.115c.031.017.065.027.1.027s.07-.01.1-.027l.566-.331a.065.065 0 0 0 .043-.056v-.113z"
            fill="#3D3D3D"
        />
        <path
            d="M922.73 323.34c.055.032.055.084 0 .113l-.57.333a.217.217 0 0 1-.2 0l-2.525-1.465c-.055-.03-.055-.08 0-.113l.568-.33c.031-.017.065-.025.1-.025s.069.008.1.025l2.527 1.462z"
            fill="#4A4A4A"
        />
        <path
            d="m921.96 323.78-2.525-1.465a.058.058 0 0 1-.029-.022.06.06 0 0 1-.013-.034v.114a.06.06 0 0 0 .013.034c.007.01.017.018.029.022l2.525 1.462v-.111z"
            fill="#636363"
        />
        <path
            d="M922.77 323.4a.067.067 0 0 1-.041.055l-.57.332c-.031.016-.065.025-.1.025s-.069-.009-.1-.025v.115a.217.217 0 0 0 .2 0l.57-.33c.025-.019.041-.037.041-.06v-.112z"
            fill="#3D3D3D"
        />
        <path
            d="M917.4 318.64a.384.384 0 0 1-.022-.726l1.547-.948a1.401 1.401 0 0 1 1.26-.031l2.5 1.365a.385.385 0 0 1 .272.358.383.383 0 0 1-.25.373l-1.545.948a1.384 1.384 0 0 1-1.26.028l-2.502-1.367z"
            fill="#9E9D9D"
        />
        <path
            d="m920.72 326.09.531-.308v-.177l-.531.306v.179zM921.6 325.6l.528-.306v-.178l-.53.3.002.184z"
            fill="#1C1C1C"
        />
        <path
            d="M906.48 309.64a.565.565 0 0 0-.565 0l-.15.087 12.831 7.556.264 9.378.3-.178v-8.9a1.126 1.126 0 0 0-.567-.978l-12.113-6.965z"
            fill="#8E8D8D"
        />
        <path
            d="M918.3 316.78a1.14 1.14 0 0 1 .57.984v8.9l-13.33-7.675v-8.9a.376.376 0 0 1 .188-.326.375.375 0 0 1 .376-.001l12.196 7.018z"
            fill="#C1BFBD"
        />
        <path
            d="m926.64 321.37.555-.606-.989-.874-3.459.5-1.863 1.2s-.267.252-.065.482c.077.087.3.013.424-.043.315-.145.827-.4.913-.459.254-.164.4.148.4.148.048.118.407.688.55.934.174.3.446.376.83.474.523.135.555-.024.686-.158.032-.034-.035-.184-.035-.184.982-.127 2.143-.677 2.053-1.414z"
            fill="#FFE8D9"
        />
        <path
            d="M926.02 319.9s.239-.157.562.792a1.395 1.395 0 0 1-.185 1.324s6.207-1.06 7.142-1.42a5.147 5.147 0 0 0 1.817-1c.469-.581.7-1.32.644-2.066l.005-7.9c-.122-2.138-1.062-3.233-2.475-2.944-1.952.4-1.356 3.258-1.13 4.557.149.849.441 4.413.559 5.562a1.08 1.08 0 0 1-.713 1.051l-6.226 2.044z"
            fill="#D32A1E"
        />
        <path
            d="M922.36 317.25c.4.286 1.041-.061 1.299-.422.09-.123.701.8 1.115.815.433.018.26-.306.208-.417a3.455 3.455 0 0 0-1.32-1.208c-1.256-.395-1.372-.1-1.633.263s-.064.688.331.969z"
            fill="#FFE8D9"
        />
        <path
            d="m921.34 316.56.6-.861 1.906.955.58.347 1.278 1.626s.232.324-.674.7c-.443.18-1.58-.421-1.58-.421l-1.425-.589c-.443-.307-1.02-1.279-.685-1.757z"
            fill="#FFE8D9"
        />
        <path
            d="M922.55 315.84s-1.031-1.28-1.671-1.951c-.464-.487-1.643-1.066-2.371-.1-.775 1.026.269 2.152.687 2.519a12.356 12.356 0 0 0 2.405 1.621 1.604 1.604 0 0 1 0-1.254 1.41 1.41 0 0 1 .95-.835z"
            fill="#B21B0B"
        />
        <path
            d="m927.87 325.42 1.189.751.107-.212-1.161-.772-.135.233z"
            fill="#898B8C"
        />
        <path
            d="M929.06 326.07a.062.062 0 0 1-.016.02.053.053 0 0 1-.047.011.048.048 0 0 1-.023-.01l-1.009-.585a.071.071 0 0 1-.029-.039.068.068 0 0 1 .007-.048.069.069 0 0 1 .016-.018c.007-.005.015-.009.023-.011s.016-.002.025-.001a.063.063 0 0 1 .023.008l1.009.589a.055.055 0 0 1 .018.016.046.046 0 0 1 .011.022c.002.007.002.016.001.024s-.005.015-.009.022z"
            fill="#616465"
        />
        <path
            d="m927.16 325.25-3.337 1.941v.386l3.337-1.941 2.164 1.25v-.384l-2.164-1.252z"
            fill="#8B8D8E"
        />
        <path
            d="M925.98 328.45v.387l-2.157-1.252v-.386l2.157 1.251z"
            fill="#C1C1C1"
        />
        <path d="M929.33 326.5v.384l-3.344 1.943v-.387l3.344-1.94z" fill="gray" />
        <path
            d="m929.33 326.58-3.343 1.94-2.159-1.253 3.337-1.94 2.165 1.253z"
            fill="#DBDDDD"
        />
        <path
            d="m929.85 326.47-4.076 2.37a.595.595 0 0 1-.556 0l-2.074-1.197a.208.208 0 0 1-.078-.066.214.214 0 0 1-.035-.096v.383a.202.202 0 0 0 .117.162l2.071 1.194a.601.601 0 0 0 .556 0l4.078-2.366a.195.195 0 0 0 .079-.066.185.185 0 0 0 .036-.096v-.384a.187.187 0 0 1-.118.162z"
            fill="#C1C7C8"
        />
        <path
            d="m929.84 326.15-2.073-1.2a.622.622 0 0 0-.555 0l-4.072 2.371c-.154.09-.154.232 0 .324l2.073 1.194a.599.599 0 0 0 .556 0l4.076-2.37a.168.168 0 0 0 .113-.161.17.17 0 0 0-.118-.158zm-3.861 2.3-2.16-1.251 3.336-1.941 2.166 1.251-3.342 1.941z"
            fill="#A0A5A6"
        />
        <path
            d="M928.84 325.72v.031a.143.143 0 0 1-.026.071.14.14 0 0 1-.057.048.475.475 0 0 1-.411 0 .139.139 0 0 1-.058-.049.143.143 0 0 1-.026-.071v-.032a.143.143 0 0 0 .084.119.455.455 0 0 0 .411 0 .138.138 0 0 0 .057-.047.14.14 0 0 0 .026-.07z"
            fill="#616464"
        />
        <path
            d="M928.76 325.6c.113.068.113.172 0 .238a.455.455 0 0 1-.411 0 .13.13 0 0 1-.06-.046.13.13 0 0 1 0-.145.126.126 0 0 1 .06-.047.461.461 0 0 1 .411 0z"
            fill="#C1C7C8"
        />
        <path d="M850.47 303.92v.078l9.3 5.4v-.08l-9.3-5.398z" fill="#AAA9A9" />
        <path
            d="M859.77 309.33v.08l7.078-4.088v-.08l-7.078 4.088z"
            fill="#676767"
        />
        <path
            d="m850.47 303.92 9.3 5.4 7.078-4.088-9.275-5.392-7.103 4.08z"
            fill="#fff"
        />
        <path d="M850.47 303.52v.078l9.3 5.4v-.081l-9.3-5.397z" fill="#AAA9A9" />
        <path
            d="M859.77 308.92v.081l7.078-4.087v-.081l-7.078 4.087z"
            fill="#676767"
        />
        <path
            d="m850.47 303.52 9.3 5.4 7.078-4.087-9.275-5.389-7.103 4.076z"
            fill="#fff"
        />
        <path d="M850.47 303.11v.078l9.3 5.4v-.079l-9.3-5.399z" fill="#AAA9A9" />
        <path
            d="M859.77 308.52v.079l7.078-4.086v-.082l-7.078 4.089z"
            fill="#676767"
        />
        <path
            d="m850.47 303.11 9.3 5.4 7.078-4.089-9.275-5.389-7.103 4.078z"
            fill="#fff"
        />
        <path d="M850.47 302.71v.08l9.3 5.4v-.077l-9.3-5.403z" fill="#AAA9A9" />
        <path
            d="M859.77 308.11v.077l7.078-4.086v-.081l-7.078 4.09z"
            fill="#676767"
        />
        <path
            d="m850.47 302.7 9.3 5.405 7.078-4.089-9.275-5.39-7.103 4.074z"
            fill="#fff"
        />
        <path d="M850.47 302.3v.08l9.3 5.4v-.078l-9.3-5.402z" fill="#AAA9A9" />
        <path
            d="M859.77 307.7v.078l7.078-4.085v-.079l-7.078 4.086z"
            fill="#676767"
        />
        <path
            d="m850.47 302.3 9.3 5.4 7.078-4.086-9.275-5.389-7.103 4.075z"
            fill="#fff"
        />
        <path d="M850.47 301.89v.08l9.3 5.4v-.082l-9.3-5.398z" fill="#AAA9A9" />
        <path
            d="M859.77 307.29v.082l7.078-4.086v-.078l-7.078 4.082z"
            fill="#676767"
        />
        <path
            d="m850.47 301.89 9.3 5.4 7.078-4.082-9.275-5.393-7.103 4.075z"
            fill="#fff"
        />
        <path d="M850.47 301.49v.079l9.3 5.4v-.078l-9.3-5.401z" fill="#AAA9A9" />
        <path
            d="M859.77 306.89v.078l7.078-4.085v-.082l-7.078 4.089z"
            fill="#676767"
        />
        <path
            d="m850.47 301.49 9.3 5.4 7.078-4.089-9.275-5.388-7.103 4.077z"
            fill="#fff"
        />
        <path d="M850.47 301.08v.078l9.3 5.4v-.077l-9.3-5.401z" fill="#AAA9A9" />
        <path
            d="M859.77 306.49v.077l7.078-4.087v-.079l-7.078 4.089z"
            fill="#676767"
        />
        <path
            d="m850.47 301.08 9.3 5.4 7.078-4.089-9.275-5.391-7.103 4.08z"
            fill="#fff"
        />
        <path d="M850.47 300.67v.079l9.3 5.4v-.078l-9.3-5.401z" fill="#AAA9A9" />
        <path
            d="M859.77 306.08v.078l7.078-4.087v-.079l-7.078 4.088z"
            fill="#676767"
        />
        <path
            d="m850.47 300.67 9.3 5.405 7.078-4.088-9.275-5.391-7.103 4.074z"
            fill="#fff"
        />
        <path d="M850.47 300.27v.078l9.3 5.4v-.078l-9.3-5.4z" fill="#AAA9A9" />
        <path
            d="M859.77 305.67v.079l7.078-4.086v-.079l-7.078 4.086z"
            fill="#676767"
        />
        <path
            d="m850.47 300.27 9.3 5.4 7.078-4.086-9.275-5.39-7.103 4.076z"
            fill="#fff"
        />
        <path
            d="M850.45 299.84v.08l9.335 5.414v-.08l-9.335-5.414z"
            fill="#AAA9A9"
        />
        <path
            d="M859.78 305.26v.08l5.072-2.961.02-.082-5.092 2.963z"
            fill="#787878"
        />
        <path
            d="m850.45 299.84 9.335 5.414 1.3-.754 3.8-2.209.5-1.976-7.856-4.562-7.079 4.087z"
            fill="#fff"
        />
        <path d="M852.31 300.2v.019l.951.553v-.022l-.951-.55z" fill="#A0A0A0" />
        <path
            d="M853.26 300.75v.022l6.054-3.5v-.021l-6.054 3.499z"
            fill="#616161"
        />
        <path
            d="m852.31 300.2.951.55 6.054-3.5-.948-.553-6.057 3.503z"
            fill="#B9B9B9"
        />
        <path d="M853.74 301.05v.022l.95.551v-.021l-.95-.552z" fill="#A0A0A0" />
        <path d="M854.69 301.6v.021l6.055-3.5v-.02l-6.055 3.499z" fill="#616161" />
        <path
            d="m853.74 301.05.951.553 6.056-3.5-.948-.553-6.059 3.5z"
            fill="#B9B9B9"
        />
        <path d="M855.2 301.9v.021l.95.552v-.018l-.95-.555z" fill="#A0A0A0" />
        <path d="M856.15 302.46v.019l6.058-3.5v-.019l-6.058 3.5z" fill="#616161" />
        <path
            d="m855.2 301.9.95.554 6.058-3.5-.947-.553-6.061 3.499z"
            fill="#B9B9B9"
        />
        <path d="M856.72 302.79v.02l.95.551v-.019l-.95-.552z" fill="#A0A0A0" />
        <path d="M857.67 303.34v.019l6.058-3.5v-.02l-6.058 3.501z" fill="#616161" />
        <path
            d="m856.72 302.79.95.552 6.058-3.5-.951-.549-6.057 3.497z"
            fill="#B9B9B9"
        />
        <path d="M858.26 303.68v.021l.948.554v-.022l-.948-.553z" fill="#A0A0A0" />
        <path
            d="M859.21 304.23v.022l5.834-3.37v-.02l-5.834 3.368z"
            fill="#616161"
        />
        <path
            d="m858.26 303.68.948.553 5.836-3.367.058-.225-.786-.457-6.056 3.496z"
            fill="#B9B9B9"
        />
        <path d="m864.88 302.3.5-1.976-1.24.736.74 1.24z" fill="#fff" />
        <path d="m864.82 302.32.051-.028-.734-1.24v.105l.683 1.163z" fill="#999" />
        <path
            d="m859.33 333.3-13.28-7.6v.3a.574.574 0 0 0 .294.505l12.3 7.085a1.337 1.337 0 0 0 1.352 0l8.7-5.053a.78.78 0 0 0 .283-.287.78.78 0 0 0 .106-.389v-.388l-9.755 5.827z"
            fill="#9E9D9D"
        />
        <path
            d="m869.08 327.47-9.191 5.874a1.104 1.104 0 0 1-1.15.023l-12.49-7.184a.4.4 0 0 1-.012-.692l9.195-5.875 13.648 7.854z"
            fill="#D3D3D3"
        />
        <path
            d="M856.12 310.24a.563.563 0 0 0-.575 0l-.153.091 13.1 7.755.272 9.611.313-.18v-9.132a1.177 1.177 0 0 0-.579-1.007l-12.378-7.138z"
            fill="#8E8D8D"
        />
        <path
            d="M868.18 317.56a1.16 1.16 0 0 1 .583 1.007v9.128l-13.616-7.872v-9.13a.387.387 0 0 1 .387-.387.384.384 0 0 1 .193.054l12.453 7.2z"
            fill="#C1BFBD"
        />
        <path
            d="M867.48 327.33a.3.3 0 0 1 .108.214.291.291 0 0 1-.088.223l-4.289 2.736c-.36.224-.669.024-1.006-.169l-11.546-6.65a.258.258 0 0 1-.121-.389.254.254 0 0 1 .121-.096l4.219-2.665a.72.72 0 0 1 .678-.093l11.924 6.889z"
            fill="#898686"
        />
        <path
            d="M859.24 327.43c-.001.013-.005.025-.012.036s-.017.019-.029.024l-.58.341a.23.23 0 0 1-.2 0v.118a.23.23 0 0 0 .2 0l.58-.341a.07.07 0 0 0 .041-.062v-.116z"
            fill="#737373"
        />
        <path
            d="M857.3 328.12a.421.421 0 0 1 .283.397.416.416 0 0 1-.283.396l-1.701.987a1.49 1.49 0 0 1-1.368 0l-2.679-1.545a.417.417 0 0 1-.205-.641.418.418 0 0 1 .205-.153l1.705-.988a1.51 1.51 0 0 1 1.366 0l2.677 1.547z"
            fill="#9E9D9D"
        />
        <path
            d="M867.72 318.6v7.342l-11.814-6.821v-7.341l11.814 6.82z"
            fill="#8E8D8D"
        />
        <path
            d="m856.03 319 11.693 6.751V318.6l-11.693-6.746V319z"
            fill="#4AACEE"
        />
        <path
            d="M856 320.81c.057.032.057.082 0 .116l-.582.341a.243.243 0 0 1-.2 0l-.59-.341a.07.07 0 0 1-.028-.023c-.006-.01-.01-.023-.01-.035s.004-.024.01-.035a.07.07 0 0 1 .028-.023l.584-.343a.25.25 0 0 1 .2 0l.588.343zM858.07 322c.06.034.057.087 0 .118l-.583.341a.232.232 0 0 1-.2 0l-.588-.341c-.058-.031-.058-.084 0-.118l.582-.338a.216.216 0 0 1 .206 0l.583.338zM856.98 321.36c.057.031.057.084 0 .118l-.584.337a.215.215 0 0 1-.2 0l-.588-.339c-.056-.032-.056-.085 0-.116l.585-.342a.23.23 0 0 1 .2 0l.587.342zM859.1 322.6c.057.033.057.085 0 .122l-.585.336a.217.217 0 0 1-.2 0l-.584-.34c-.06-.033-.06-.085 0-.118l.585-.338a.223.223 0 0 1 .2 0l.584.338zM860.12 323.18c.06.033.06.087 0 .118l-.583.338a.217.217 0 0 1-.2 0l-.589-.338a.07.07 0 0 1-.03-.023c-.007-.011-.011-.023-.011-.036s.004-.025.011-.036a.062.062 0 0 1 .03-.023l.584-.34a.241.241 0 0 1 .205 0l.583.34zM861.15 323.77a.061.061 0 0 1 .041.059.066.066 0 0 1-.011.036.065.065 0 0 1-.03.022l-.585.339a.232.232 0 0 1-.2 0l-.588-.341c-.059-.031-.059-.084 0-.115l.583-.34a.215.215 0 0 1 .2 0l.59.34zM856.04 322.05c.057.033.057.088 0 .119l-.585.341a.23.23 0 0 1-.2 0l-1.614-.932c-.057-.036-.057-.085 0-.118l.583-.342a.243.243 0 0 1 .2 0l1.616.932zM857.02 322.6c.057.033.057.085 0 .118l-.582.34a.235.235 0 0 1-.2 0l-.589-.34a.055.055 0 0 1-.029-.023.06.06 0 0 1 0-.072.066.066 0 0 1 .029-.023l.583-.338a.232.232 0 0 1 .2 0l.588.338zM858.12 323.23c.053.031.055.083 0 .113l-.585.343c-.031.015-.065.022-.1.022s-.069-.007-.1-.022l-.588-.341a.059.059 0 0 1-.042-.057.059.059 0 0 1 .042-.056l.585-.341a.23.23 0 0 1 .2 0l.588.339zM859.15 323.83c.055.031.057.081 0 .113l-.583.341c-.031.016-.065.025-.1.025s-.069-.009-.1-.025l-.587-.341c-.058-.032-.058-.086 0-.113l.584-.343c.031-.015.065-.024.1-.024s.069.009.1.024l.586.343zM860.17 324.42a.066.066 0 0 1 .029.023.064.064 0 0 1 0 .072.062.062 0 0 1-.029.024l-.587.34a.232.232 0 0 1-.2 0l-.59-.34c-.054-.035-.055-.085 0-.119l.587-.339a.23.23 0 0 1 .2 0l.59.339zM855.05 322.63c.058.034.058.086 0 .12l-.585.337c-.031.015-.065.024-.1.024s-.069-.009-.1-.024l-1.617-.931a.057.057 0 0 1-.03-.023.06.06 0 0 1 0-.072.06.06 0 0 1 .03-.022l.586-.339c.031-.016.065-.025.1-.025s.069.009.1.025l1.616.93zM856.08 323.22c.055.032.055.084 0 .114l-.586.341a.23.23 0 0 1-.2 0l-.588-.341a.062.062 0 0 1-.028-.023.06.06 0 0 1 .028-.091l.584-.34a.232.232 0 0 1 .2 0l.59.34zM857.14 323.85a.064.064 0 0 1 .031.023.066.066 0 0 1 0 .073.064.064 0 0 1-.031.023l-.584.338a.217.217 0 0 1-.2 0l-.588-.338c-.058-.033-.058-.086 0-.119l.585-.341a.243.243 0 0 1 .2 0l.587.341zM858.16 324.44a.057.057 0 0 1 .03.023.064.064 0 0 1 0 .072.06.06 0 0 1-.03.022l-.584.34a.25.25 0 0 1-.2 0l-.588-.34c-.056-.033-.056-.085 0-.117l.587-.342c.031-.015.065-.022.1-.022s.069.007.1.022l.585.342zM862.17 324.37c.058.034.058.085 0 .118l-.583.339a.243.243 0 0 1-.2 0l-.589-.339a.07.07 0 0 1-.03-.023c-.007-.011-.011-.023-.011-.036s.004-.025.011-.036a.07.07 0 0 1 .03-.023l.583-.34a.241.241 0 0 1 .205 0l.584.34zM861.2 325.01a.07.07 0 0 1 .03.023c.007.011.011.023.011.036s-.004.025-.011.036-.018.019-.03.023l-.586.341a.217.217 0 0 1-.2 0l-.586-.341a.068.068 0 0 1-.031-.022c-.008-.011-.012-.024-.012-.037s.004-.026.012-.036a.064.064 0 0 1 .031-.023l.585-.337a.217.217 0 0 1 .2 0l.587.337zM859.19 325.03a.066.066 0 0 1 .029.023.066.066 0 0 1 .011.035.066.066 0 0 1-.011.036.066.066 0 0 1-.029.023l-.586.337c-.031.016-.065.025-.1.025s-.069-.009-.1-.025l-.59-.337a.057.057 0 0 1-.03-.023.058.058 0 0 1 0-.071.057.057 0 0 1 .03-.023l.588-.34a.228.228 0 0 1 .1-.022c.034 0 .069.007.1.022l.588.34zM860.21 325.62c.055.033.057.085 0 .121l-.583.337a.217.217 0 0 1-.2 0l-.59-.337c-.056-.036-.056-.088 0-.122l.584-.337a.204.204 0 0 1 .2 0l.589.338zM855.15 323.86a.065.065 0 0 1 .03.022.066.066 0 0 1 .011.036.066.066 0 0 1-.011.035.065.065 0 0 1-.03.022l-.586.342c-.031.016-.065.025-.1.025s-.069-.009-.1-.025l-2.639-1.523c-.058-.034-.058-.085 0-.121l.581-.338a.232.232 0 0 1 .2 0l2.644 1.525zM856.15 324.45c.057.035.057.09 0 .119l-.583.34a.22.22 0 0 1-.2 0l-.588-.338c-.059-.031-.059-.084 0-.119l.582-.338a.223.223 0 0 1 .205 0l.584.336zM857.18 325.05c.057.031.059.083 0 .115l-.582.34a.217.217 0 0 1-.2 0l-.589-.34c-.057-.032-.057-.084 0-.119l.583-.338a.23.23 0 0 1 .2 0l.588.342zM858.2 325.64c.056.032.056.087 0 .114l-.584.342a.23.23 0 0 1-.2 0l-.588-.342c-.056-.027-.056-.082 0-.114l.585-.342a.242.242 0 0 1 .205 0l.582.342zM859.23 326.23a.06.06 0 0 1 .03.022.06.06 0 0 1 0 .072.06.06 0 0 1-.03.022l-.583.339a.217.217 0 0 1-.2 0l-.589-.339c-.059-.031-.059-.086 0-.116l.583-.341a.23.23 0 0 1 .207 0l.582.341zM863.2 324.96c.054.031.054.082 0 .116l-.583.34a.242.242 0 0 1-.206 0l-.586-.342c-.057-.032-.057-.083 0-.114l.584-.34a.23.23 0 0 1 .2 0l.591.34zM862.22 325.6c.057.033.057.086 0 .118l-.586.34a.217.217 0 0 1-.2 0l-.588-.34c-.057-.032-.057-.085 0-.118l.584-.341a.22.22 0 0 1 .2 0l.59.341zM861.24 326.22a.057.057 0 0 1 .03.023.058.058 0 0 1 0 .071.057.057 0 0 1-.03.023l-.586.338c-.031.017-.065.025-.1.025s-.069-.008-.1-.025l-.587-.337c-.06-.033-.06-.087 0-.12l.584-.338c.031-.017.065-.025.1-.025s.07.008.1.025l.589.34zM860.26 326.82c.057.031.057.084 0 .116l-.582.341a.248.248 0 0 1-.205 0l-.586-.341c-.057-.034-.057-.085 0-.116l.582-.34a.23.23 0 0 1 .2 0l.591.34zM852.16 323.27a.063.063 0 0 1 .031.022.064.064 0 0 1 0 .072.063.063 0 0 1-.031.022l-.583.339a.212.212 0 0 1-.205 0l-.588-.339a.06.06 0 0 1-.03-.022.06.06 0 0 1 0-.072.06.06 0 0 1 .03-.022l.585-.34a.215.215 0 0 1 .2 0l.591.34zM853.13 323.83a.068.068 0 0 1 .031.022c.007.011.012.024.012.037s-.005.026-.012.036a.064.064 0 0 1-.031.023l-.582.34a.235.235 0 0 1-.2 0l-.588-.34a.07.07 0 0 1-.03-.023.064.064 0 0 1 0-.072.057.057 0 0 1 .03-.023l.586-.34a.23.23 0 0 1 .2 0l.584.34zM854.16 324.42c.056.031.056.085 0 .119l-.586.337a.22.22 0 0 1-.2 0l-.59-.337a.057.057 0 0 1-.031-.024.063.063 0 0 1 0-.074.062.062 0 0 1 .031-.024l.585-.337a.23.23 0 0 1 .2 0l.591.34zM859.29 327.38c.061.034.061.087 0 .118l-.584.338c-.03.017-.065.025-.1.025s-.069-.008-.1-.025l-4.691-2.709c-.057-.031-.057-.083 0-.117l.586-.338c.031-.017.065-.027.1-.027s.07.01.1.027l4.689 2.708zM864.22 325.55c.058.034.058.084 0 .117l-.582.34a.23.23 0 0 1-.206 0l-.584-.34c-.059-.033-.059-.083 0-.117l.584-.339a.217.217 0 0 1 .2 0l.588.339zM865.25 326.14c.057.033.057.087 0 .118l-.584.341a.242.242 0 0 1-.2 0l-.586-.341c-.058-.031-.058-.087 0-.116l.585-.34a.22.22 0 0 1 .2 0l.585.338zM867.3 327.33a.058.058 0 0 1 .031.022c.008.01.013.023.013.036a.062.062 0 0 1-.013.037.058.058 0 0 1-.031.022l-.585.34a.217.217 0 0 1-.2 0l-1.614-.931c-.058-.034-.058-.087 0-.118l.583-.34a.217.217 0 0 1 .2 0l1.616.932zM863.25 326.19c.055.034.056.084 0 .118l-.584.34a.23.23 0 0 1-.2 0l-.59-.34c-.012-.004-.023-.012-.03-.023s-.011-.023-.011-.036.004-.025.011-.036a.07.07 0 0 1 .03-.023l.584-.34a.214.214 0 0 1 .102-.025c.036 0 .071.008.103.025l.585.34zM864.28 326.79a.062.062 0 0 1 .029.024.063.063 0 0 1 0 .071.066.066 0 0 1-.029.023l-.584.337c-.031.016-.065.025-.1.025s-.069-.009-.1-.025l-.588-.339a.063.063 0 0 1-.029-.022.063.063 0 0 1 0-.071.073.073 0 0 1 .029-.023l.587-.34a.215.215 0 0 1 .2 0l.585.34zM865.3 327.38a.068.068 0 0 1 .031.022c.008.011.012.024.012.037s-.004.026-.012.036a.064.064 0 0 1-.031.023l-.584.339c-.031.016-.065.025-.1.025s-.069-.009-.1-.025l-.59-.339c-.055-.033-.057-.085 0-.118l.585-.338a.23.23 0 0 1 .2 0l.589.338zM866.33 327.97a.068.068 0 0 1 .031.022c.008.011.012.024.012.037s-.004.026-.012.036a.056.056 0 0 1-.031.022l-.584.342a.22.22 0 0 1-.2 0l-.588-.342a.057.057 0 0 1-.03-.022.06.06 0 0 1 0-.072.058.058 0 0 1 .03-.023l.584-.338a.23.23 0 0 1 .2 0l.588.338zM862.27 326.81c.057.036.057.086 0 .117l-.587.34a.22.22 0 0 1-.2 0l-.589-.34c-.056-.031-.056-.081 0-.117l.585-.337a.215.215 0 0 1 .2 0l.591.337zM863.29 327.4c.054.029.054.082 0 .115l-.586.341a.228.228 0 0 1-.2 0l-.588-.341c-.057-.033-.057-.086 0-.117l.583-.338a.221.221 0 0 1 .1-.025c.035 0 .07.009.101.025l.59.34zM865.34 328.59a.066.066 0 0 1 .029.023.063.063 0 0 1 0 .071.055.055 0 0 1-.029.023l-.585.339a.23.23 0 0 1-.2 0l-1.611-.931c-.061-.033-.061-.086 0-.119l.584-.338a.232.232 0 0 1 .2 0l1.612.932zM861.28 327.42c.056.029.056.083 0 .116l-.583.339a.223.223 0 0 1-.207 0l-.585-.339c-.059-.033-.059-.087 0-.116l.582-.341a.217.217 0 0 1 .2 0l.593.341zM862.31 328.01c.057.031.057.081 0 .114l-.582.34c-.031.016-.065.025-.1.025s-.069-.009-.1-.025l-.588-.34c-.057-.033-.057-.083 0-.119l.587-.339a.232.232 0 0 1 .2 0l.583.344zM864.36 329.19a.076.076 0 0 1 .03.023.064.064 0 0 1-.03.096l-.586.335c-.031.016-.065.025-.1.025s-.069-.009-.1-.025l-1.613-.931c-.056-.033-.057-.085 0-.117l.582-.339a.22.22 0 0 1 .2 0l1.617.933zM860.32 327.97c.057.034.057.084 0 .117l-.585.34a.23.23 0 0 1-.2 0l-.589-.34c-.055-.033-.055-.083 0-.117l.585-.339a.217.217 0 0 1 .2 0l.589.339zM863.39 329.75c.054.036.056.086 0 .119l-.583.341a.23.23 0 0 1-.2 0l-1.614-.932c-.057-.034-.057-.086 0-.117l.584-.34c.031-.015.065-.024.1-.024s.069.009.1.024l1.613.929z"
            fill="#4A4A4A"
        />
        <path
            d="m855.21 321.27-.59-.341a.07.07 0 0 1-.041-.059v.116a.07.07 0 0 0 .014.036.07.07 0 0 0 .029.025l.59.338-.002-.115z"
            fill="#636363"
        />
        <path
            d="M856.04 320.87a.064.064 0 0 1-.014.035.062.062 0 0 1-.029.024l-.582.341a.243.243 0 0 1-.2 0v.115a.217.217 0 0 0 .2 0l.582-.338a.096.096 0 0 0 .029-.024.083.083 0 0 0 .014-.035v-.118z"
            fill="#3D3D3D"
        />
        <path
            d="m856.19 321.82-.589-.339a.07.07 0 0 1-.029-.025.07.07 0 0 1-.013-.035v.117a.063.063 0 0 0 .013.035c.007.01.017.019.029.024l.589.338v-.115z"
            fill="#636363"
        />
        <path
            d="M857.02 321.42a.07.07 0 0 1-.012.034.072.072 0 0 1-.027.025l-.585.339a.23.23 0 0 1-.2 0v.115c.031.017.065.025.1.025s.07-.008.1-.025l.584-.336c.028-.019.043-.04.043-.058l-.003-.119z"
            fill="#3D3D3D"
        />
        <path
            d="m857.28 322.46-.588-.341a.07.07 0 0 1-.03-.024.08.08 0 0 1-.012-.037v.119a.078.078 0 0 0 .013.036c.008.01.018.019.029.024l.588.339v-.116z"
            fill="#636363"
        />
        <path
            d="M858.11 322.05a.082.082 0 0 1-.013.037.073.073 0 0 1-.031.024l-.583.341a.23.23 0 0 1-.2 0v.116a.232.232 0 0 0 .2 0l.583-.339a.078.078 0 0 0 .03-.024.08.08 0 0 0 .014-.036v-.119z"
            fill="#3D3D3D"
        />
        <path
            d="m858.31 323.05-.586-.34a.068.068 0 0 1-.028-.025.07.07 0 0 1-.013-.035v.117c0 .013.004.025.011.035s.018.018.03.022l.586.342v-.116z"
            fill="#636363"
        />
        <path
            d="M859.14 322.65a.08.08 0 0 1-.014.036.081.081 0 0 1-.028.024l-.583.34a.232.232 0 0 1-.206 0v.116a.241.241 0 0 0 .205 0l.584-.342a.08.08 0 0 0 .029-.023.083.083 0 0 0 .013-.034v-.117z"
            fill="#3D3D3D"
        />
        <path
            d="m859.33 323.64-.587-.339a.076.076 0 0 1-.03-.023.083.083 0 0 1-.014-.035v.116c0 .021.016.042.044.07l.588.339-.001-.128z"
            fill="#636363"
        />
        <path
            d="M860.16 323.24a.07.07 0 0 1-.043.06l-.582.337a.217.217 0 0 1-.103.027.216.216 0 0 1-.102-.027v.119a.228.228 0 0 0 .205 0l.582-.339a.07.07 0 0 0 .041-.059l.002-.118z"
            fill="#3D3D3D"
        />
        <path
            d="m860.36 324.23-.588-.341a.062.062 0 0 1-.029-.024.067.067 0 0 1-.014-.036v.119a.07.07 0 0 0 .013.035.066.066 0 0 0 .03.023l.588.338v-.114z"
            fill="#636363"
        />
        <path
            d="M861.19 323.83a.079.079 0 0 1-.04.06l-.585.339a.23.23 0 0 1-.2 0v.114a.217.217 0 0 0 .2 0l.585-.338a.07.07 0 0 0 .04-.058v-.117z"
            fill="#3D3D3D"
        />
        <path
            d="m855.26 322.51-1.614-.932a.07.07 0 0 1-.042-.062v.117c.001.013.006.025.014.036s.018.019.03.025l1.614.932-.002-.116z"
            fill="#636363"
        />
        <path
            d="M856.08 322.11a.082.082 0 0 1-.013.035.08.08 0 0 1-.029.023l-.585.341a.232.232 0 0 1-.2 0v.116c.031.017.065.025.1.025s.069-.008.1-.025l.585-.34a.07.07 0 0 0 .028-.023.069.069 0 0 0 .014-.034v-.118z"
            fill="#3D3D3D"
        />
        <path
            d="m856.23 323.06-.589-.34a.073.073 0 0 1-.029-.023.071.071 0 0 1-.013-.034v.115a.077.077 0 0 0 .012.036.07.07 0 0 0 .03.024l.589.338v-.116z"
            fill="#636363"
        />
        <path
            d="M857.06 322.66a.074.074 0 0 1-.044.056l-.582.34a.23.23 0 0 1-.2 0v.116a.22.22 0 0 0 .2 0l.584-.338c.012-.005.022-.013.03-.023s.013-.022.014-.035l-.002-.116z"
            fill="#3D3D3D"
        />
        <path
            d="m857.34 323.69-.588-.341a.058.058 0 0 1-.029-.022.062.062 0 0 1-.013-.034v.116c.001.013.006.025.013.035s.017.018.029.023l.587.343.001-.12z"
            fill="#636363"
        />
        <path
            d="M858.16 323.29a.057.057 0 0 1-.013.033.058.058 0 0 1-.028.021l-.585.343a.232.232 0 0 1-.2 0v.12a.243.243 0 0 0 .2 0l.585-.343a.067.067 0 0 0 .041-.056v-.118z"
            fill="#3D3D3D"
        />
        <path
            d="m858.36 324.28-.587-.341a.07.07 0 0 1-.029-.022.079.079 0 0 1-.013-.035v.117c0 .013.004.025.012.035a.055.055 0 0 0 .029.023l.588.339v-.116z"
            fill="#636363"
        />
        <path
            d="M859.19 323.88a.07.07 0 0 1-.013.035.068.068 0 0 1-.031.022l-.583.341a.217.217 0 0 1-.2 0v.116a.217.217 0 0 0 .2 0l.583-.339a.076.076 0 0 0 .03-.023.071.071 0 0 0 .013-.034l.001-.118z"
            fill="#3D3D3D"
        />
        <path
            d="m859.39 324.87-.59-.34a.078.078 0 0 1-.041-.061v.12a.068.068 0 0 0 .013.033c.006.01.015.018.026.023l.592.341v-.116z"
            fill="#636363"
        />
        <path
            d="M860.21 324.47a.075.075 0 0 1-.04.061l-.587.34a.232.232 0 0 1-.2 0v.116a.23.23 0 0 0 .2 0l.587-.339a.062.062 0 0 0 .027-.024.071.071 0 0 0 .013-.034v-.12z"
            fill="#3D3D3D"
        />
        <path
            d="m854.27 323.09-1.617-.931a.065.065 0 0 1-.028-.024.08.08 0 0 1-.011-.035v.114c0 .025.011.044.039.064l1.617.929v-.117z"
            fill="#636363"
        />
        <path
            d="M855.09 322.69a.07.07 0 0 1-.012.035.083.083 0 0 1-.028.025l-.585.337a.22.22 0 0 1-.2 0v.117a.209.209 0 0 0 .2 0l.585-.337a.078.078 0 0 0 .027-.024.079.079 0 0 0 .013-.035v-.118z"
            fill="#3D3D3D"
        />
        <path
            d="m855.29 323.68-.588-.341a.056.056 0 0 1-.029-.021.06.06 0 0 1-.013-.034v.115a.072.072 0 0 0 .042.061l.588.337v-.117z"
            fill="#636363"
        />
        <path
            d="M856.12 323.28a.055.055 0 0 1-.011.033.058.058 0 0 1-.027.022l-.586.341a.23.23 0 0 1-.2 0v.117c.031.016.065.025.1.025s.069-.009.1-.025l.586-.337a.072.072 0 0 0 .038-.06v-.116z"
            fill="#3D3D3D"
        />
        <path
            d="m856.35 324.3-.588-.338a.07.07 0 0 1-.03-.024.083.083 0 0 1-.014-.035v.116a.064.064 0 0 0 .014.035.07.07 0 0 0 .03.024l.586.34.002-.118z"
            fill="#636363"
        />
        <path
            d="M857.18 323.91a.093.093 0 0 1-.013.035.075.075 0 0 1-.026.024l-.584.338a.22.22 0 0 1-.2 0v.118a.23.23 0 0 0 .2 0l.586-.34c.011-.005.02-.014.027-.024s.011-.022.012-.035l-.002-.116z"
            fill="#3D3D3D"
        />
        <path
            d="m857.38 324.9-.588-.34c-.027-.017-.043-.039-.041-.059v.115a.092.092 0 0 0 .013.036c.007.01.017.019.028.025l.59.339-.002-.116z"
            fill="#636363"
        />
        <path
            d="M858.2 324.5a.073.073 0 0 1-.042.059l-.584.34a.25.25 0 0 1-.2 0v.116a.217.217 0 0 0 .2 0l.584-.339a.07.07 0 0 0 .028-.023.062.062 0 0 0 .013-.034l.001-.119z"
            fill="#3D3D3D"
        />
        <path
            d="m861.39 324.82-.589-.339a.075.075 0 0 1-.028-.025.07.07 0 0 1-.013-.035v.117a.069.069 0 0 0 .013.036c.007.01.017.019.028.024l.589.338v-.116z"
            fill="#636363"
        />
        <path
            d="M862.22 324.42a.082.082 0 0 1-.044.06l-.583.339a.235.235 0 0 1-.2 0v.116a.217.217 0 0 0 .2 0l.583-.338a.072.072 0 0 0 .028-.024.08.08 0 0 0 .014-.036l.002-.117z"
            fill="#3D3D3D"
        />
        <path
            d="m860.41 325.47-.586-.341a.057.057 0 0 1-.03-.023.066.066 0 0 1-.013-.036v.12c0 .022.014.039.043.058l.586.339v-.117z"
            fill="#636363"
        />
        <path
            d="M861.24 325.07a.058.058 0 0 1-.039.055l-.586.341a.217.217 0 0 1-.2 0v.117c.031.016.065.025.1.025s.069-.009.1-.025l.584-.339c.03-.018.041-.036.041-.058v-.116z"
            fill="#3D3D3D"
        />
        <path
            d="m858.4 325.49-.59-.337a.077.077 0 0 1-.04-.058v.117c.001.012.006.024.013.034s.016.017.027.022l.59.343v-.121z"
            fill="#636363"
        />
        <path
            d="M859.23 325.09a.07.07 0 0 1-.012.034.057.057 0 0 1-.027.024l-.586.337c-.03.017-.065.025-.1.025s-.069-.008-.1-.025v.121a.235.235 0 0 0 .2 0l.586-.343a.067.067 0 0 0 .027-.023.063.063 0 0 0 .012-.033v-.117z"
            fill="#3D3D3D"
        />
        <path
            d="m859.43 326.08-.59-.337a.073.073 0 0 1-.03-.025.085.085 0 0 1-.015-.037v.116c0 .025.016.044.045.06l.59.341v-.118z"
            fill="#636363"
        />
        <path
            d="M860.26 325.68c-.002.013-.006.025-.013.036s-.017.02-.028.026l-.583.337a.22.22 0 0 1-.2 0v.118a.215.215 0 0 0 .2 0l.583-.341a.07.07 0 0 0 .041-.058v-.118z"
            fill="#3D3D3D"
        />
        <path
            d="m854.36 324.32-2.639-1.523a.072.072 0 0 1-.044-.062v.118a.071.071 0 0 0 .043.061l2.64 1.525v-.119zM855.37 324.91l-.588-.338c-.03-.016-.044-.036-.042-.06v.116a.066.066 0 0 0 .013.036.067.067 0 0 0 .031.024l.588.34-.002-.118z"
            fill="#636363"
        />
        <path
            d="M856.19 324.51a.074.074 0 0 1-.012.036.07.07 0 0 1-.03.024l-.583.34a.217.217 0 0 1-.2 0v.118a.217.217 0 0 0 .2 0l.583-.34a.07.07 0 0 0 .03-.024.074.074 0 0 0 .012-.036v-.118z"
            fill="#3D3D3D"
        />
        <path
            d="m856.39 325.5-.589-.34c-.029-.016-.044-.038-.042-.058v.116c0 .023.015.041.044.057l.586.344.001-.119z"
            fill="#636363"
        />
        <path
            d="M857.22 325.11a.085.085 0 0 1-.014.034.08.08 0 0 1-.029.023l-.582.34a.23.23 0 0 1-.2 0v.119a.242.242 0 0 0 .2 0l.584-.34c.029-.02.043-.038.043-.059l-.002-.117z"
            fill="#3D3D3D"
        />
        <path
            d="m857.42 326.1-.588-.342a.065.065 0 0 1-.03-.022.083.083 0 0 1-.014-.035v.117c0 .022.016.041.042.062l.588.338.002-.118z"
            fill="#636363"
        />
        <path
            d="M858.24 325.7a.065.065 0 0 1-.041.055l-.584.342a.23.23 0 0 1-.2 0v.118a.23.23 0 0 0 .103.025.23.23 0 0 0 .102-.025l.584-.338a.088.088 0 0 0 .029-.025.08.08 0 0 0 .012-.037l-.005-.115z"
            fill="#3D3D3D"
        />
        <path
            d="m858.44 326.69-.589-.339c-.013-.005-.024-.013-.032-.024s-.012-.024-.013-.038v.119c0 .023.015.043.045.06l.589.34v-.118z"
            fill="#636363"
        />
        <path
            d="M859.27 326.29a.067.067 0 0 1-.014.036.064.064 0 0 1-.03.024l-.583.339a.217.217 0 0 1-.2 0v.118a.22.22 0 0 0 .2 0l.583-.339c.027-.018.044-.038.044-.058v-.12z"
            fill="#3D3D3D"
        />
        <path
            d="m862.41 325.42-.586-.342a.07.07 0 0 1-.043-.057v.115c0 .024.014.042.043.061l.586.339v-.116z"
            fill="#636363"
        />
        <path
            d="M863.24 325.02a.07.07 0 0 1-.041.059l-.583.34a.242.242 0 0 1-.206 0v.116c.032.016.067.025.103.025s.071-.009.103-.025l.583-.339a.064.064 0 0 0 .029-.025.065.065 0 0 0 .012-.036v-.115z"
            fill="#3D3D3D"
        />
        <path
            d="m861.44 326.06-.588-.34a.078.078 0 0 1-.03-.024.077.077 0 0 1-.012-.036v.119c0 .013.005.025.012.035a.068.068 0 0 0 .03.023l.588.338v-.115z"
            fill="#636363"
        />
        <path
            d="M862.26 325.66a.064.064 0 0 1-.012.035.063.063 0 0 1-.028.023l-.586.34a.22.22 0 0 1-.2 0v.115a.22.22 0 0 0 .2 0l.584-.338a.066.066 0 0 0 .029-.023.063.063 0 0 0 .013-.035v-.117z"
            fill="#3D3D3D"
        />
        <path
            d="m860.46 326.67-.587-.337a.07.07 0 0 1-.029-.025.069.069 0 0 1-.013-.036v.119a.073.073 0 0 0 .014.034c.007.01.017.018.028.024l.589.339-.002-.118z"
            fill="#636363"
        />
        <path
            d="M861.28 326.28a.08.08 0 0 1-.042.058l-.586.338a.207.207 0 0 1-.2 0v.118c.031.016.065.025.1.025s.069-.009.1-.025l.584-.339c.028-.017.044-.036.044-.058v-.117z"
            fill="#3D3D3D"
        />
        <path
            d="m859.47 327.28-.586-.341a.078.078 0 0 1-.03-.024.078.078 0 0 1-.013-.036v.118a.073.073 0 0 0 .014.034c.007.01.017.019.029.024l.586.338v-.113z"
            fill="#636363"
        />
        <path
            d="M860.3 326.88a.07.07 0 0 1-.014.036.068.068 0 0 1-.029.024l-.582.341a.241.241 0 0 1-.103.022.24.24 0 0 1-.102-.022v.113c.03.017.065.025.1.025s.069-.008.1-.025l.584-.338a.073.073 0 0 0 .043-.057l.003-.119z"
            fill="#3D3D3D"
        />
        <path
            d="m851.37 323.72-.588-.339a.08.08 0 0 1-.029-.023.082.082 0 0 1-.013-.035v.118c.002.012.007.024.014.034s.017.017.028.022l.588.343v-.12z"
            fill="#636363"
        />
        <path
            d="M852.2 323.32a.083.083 0 0 1-.013.034.075.075 0 0 1-.028.025l-.585.34a.214.214 0 0 1-.102.025.218.218 0 0 1-.103-.025v.116a.23.23 0 0 0 .103.025.23.23 0 0 0 .102-.025l.583-.338a.073.073 0 0 0 .043-.057v-.12z"
            fill="#3D3D3D"
        />
        <path
            d="m852.35 324.29-.588-.34a.057.057 0 0 1-.027-.024.06.06 0 0 1-.011-.034v.115a.06.06 0 0 0 .012.036c.007.01.016.019.028.024l.588.34-.002-.117z"
            fill="#636363"
        />
        <path
            d="M853.18 323.89a.08.08 0 0 1-.014.034.065.065 0 0 1-.028.024l-.582.34a.23.23 0 0 1-.2 0v.117a.217.217 0 0 0 .2 0l.582-.34a.073.073 0 0 0 .029-.024.077.077 0 0 0 .012-.036l.001-.115z"
            fill="#3D3D3D"
        />
        <path
            d="m853.38 324.88-.59-.337a.084.084 0 0 1-.028-.025.092.092 0 0 1-.013-.036v.113a.07.07 0 0 0 .011.037c.008.011.018.02.03.025l.587.338.003-.115z"
            fill="#636363"
        />
        <path
            d="M854.2 324.48a.07.07 0 0 1-.013.035.077.077 0 0 1-.028.026l-.586.337a.217.217 0 0 1-.2 0v.115c.03.017.065.027.1.027s.07-.01.1-.027l.586-.338a.068.068 0 0 0 .041-.06v-.115z"
            fill="#3D3D3D"
        />
        <path
            d="m858.5 327.84-4.691-2.709a.062.062 0 0 1-.03-.023.064.064 0 0 1-.014-.035v.116a.077.077 0 0 0 .012.036c.008.01.018.018.03.023l4.693 2.71v-.118zM863.44 326.01l-.584-.34c-.029-.017-.045-.036-.045-.058v.117c.001.013.006.025.014.035s.019.017.031.022l.584.342v-.118z"
            fill="#636363"
        />
        <path
            d="M864.27 325.61c-.002.013-.007.025-.015.035s-.018.017-.03.021l-.582.34a.232.232 0 0 1-.206 0v.118a.22.22 0 0 0 .206 0l.582-.339a.073.073 0 0 0 .029-.024.092.092 0 0 0 .013-.036l.003-.115z"
            fill="#3D3D3D"
        />
        <path
            d="m864.46 326.6-.586-.341a.064.064 0 0 1-.031-.023.067.067 0 0 1-.014-.036v.115a.08.08 0 0 0 .012.037c.008.011.018.02.03.025l.587.339.002-.116z"
            fill="#636363"
        />
        <path
            d="M865.29 326.2a.07.07 0 0 1-.043.057l-.584.341a.25.25 0 0 1-.2 0v.116a.23.23 0 0 0 .2 0l.584-.339a.076.076 0 0 0 .03-.023.078.078 0 0 0 .013-.036v-.116z"
            fill="#3D3D3D"
        />
        <path
            d="m866.52 327.79-1.614-.931a.078.078 0 0 1-.03-.024.082.082 0 0 1-.013-.037v.117a.08.08 0 0 0 .014.036c.008.01.018.018.03.023l1.614.934-.001-.118z"
            fill="#636363"
        />
        <path
            d="M867.34 327.39c-.001.013-.006.025-.013.035s-.018.018-.029.022l-.585.34a.22.22 0 0 1-.2 0v.118a.215.215 0 0 0 .2 0l.585-.341a.065.065 0 0 0 .028-.024.072.072 0 0 0 .014-.035v-.115z"
            fill="#3D3D3D"
        />
        <path
            d="m862.46 326.65-.59-.34c-.011-.006-.021-.015-.028-.026s-.012-.023-.013-.036v.121a.083.083 0 0 0 .013.034.083.083 0 0 0 .028.025l.59.338v-.116z"
            fill="#636363"
        />
        <path
            d="M863.29 326.25a.07.07 0 0 1-.013.035.075.075 0 0 1-.028.025l-.584.34a.232.232 0 0 1-.2 0v.116a.217.217 0 0 0 .2 0l.586-.338c.011-.005.021-.013.028-.023s.011-.022.013-.034l-.002-.121z"
            fill="#3D3D3D"
        />
        <path
            d="m863.49 327.24-.588-.339c-.026-.017-.044-.037-.044-.058v.116c.002.013.007.025.015.035s.018.019.029.024l.588.339v-.117z"
            fill="#636363"
        />
        <path
            d="M864.32 326.85c0 .023-.011.041-.042.06l-.584.337c-.031.016-.065.025-.1.025s-.069-.009-.1-.025v.117a.207.207 0 0 0 .2 0l.584-.339a.065.065 0 0 0 .03-.022.06.06 0 0 0 .011-.035l.001-.118z"
            fill="#3D3D3D"
        />
        <path
            d="m864.52 327.84-.59-.339a.073.073 0 0 1-.029-.026.064.064 0 0 1-.011-.036v.119a.074.074 0 0 0 .012.036c.008.011.018.02.03.025l.589.339-.001-.118z"
            fill="#636363"
        />
        <path
            d="M865.34 327.44a.073.073 0 0 1-.015.035.067.067 0 0 1-.029.024l-.584.339c-.031.017-.065.025-.1.025s-.07-.008-.1-.025v.118a.23.23 0 0 0 .1.024.233.233 0 0 0 .1-.024l.584-.339c.028-.017.044-.037.044-.058v-.119z"
            fill="#3D3D3D"
        />
        <path
            d="m865.54 328.43-.588-.342a.066.066 0 0 1-.029-.023.078.078 0 0 1-.013-.036v.115a.077.077 0 0 0 .012.037c.008.011.018.02.03.025l.588.338v-.114z"
            fill="#636363"
        />
        <path
            d="M866.37 328.03a.08.08 0 0 1-.014.034.065.065 0 0 1-.03.022l-.584.342a.217.217 0 0 1-.2 0v.114c.031.017.065.025.1.025s.069-.008.1-.025l.584-.338a.058.058 0 0 0 .029-.022.063.063 0 0 0 .013-.035l.002-.117z"
            fill="#3D3D3D"
        />
        <path
            d="m861.48 327.27-.589-.34a.073.073 0 0 1-.029-.023.06.06 0 0 1-.011-.034v.117a.06.06 0 0 0 .011.035.062.062 0 0 0 .029.024l.589.341v-.12z"
            fill="#636363"
        />
        <path
            d="M862.31 326.87a.062.062 0 0 1-.011.033.07.07 0 0 1-.028.023l-.587.34a.22.22 0 0 1-.2 0v.12a.209.209 0 0 0 .2 0l.585-.338a.068.068 0 0 0 .041-.059v-.119z"
            fill="#3D3D3D"
        />
        <path
            d="m862.51 327.86-.588-.341a.062.062 0 0 1-.03-.023.063.063 0 0 1-.013-.035v.119a.065.065 0 0 0 .043.057l.587.339.001-.116z"
            fill="#636363"
        />
        <path
            d="M863.33 327.46a.071.071 0 0 1-.041.057l-.585.341a.232.232 0 0 1-.2 0v.116c.031.016.065.025.1.025s.069-.009.1-.025l.585-.339a.071.071 0 0 0 .041-.057v-.118z"
            fill="#3D3D3D"
        />
        <path
            d="m864.56 329.04-1.611-.931c-.03-.018-.046-.037-.046-.059v.118c0 .022.016.039.043.058l1.614.932v-.118z"
            fill="#636363"
        />
        <path
            d="M865.39 328.65c-.001.013-.006.025-.013.035s-.017.019-.028.024l-.585.339a.235.235 0 0 1-.2 0v.118a.209.209 0 0 0 .2 0l.586-.34a.072.072 0 0 0 .028-.024.069.069 0 0 0 .013-.036l-.001-.116z"
            fill="#3D3D3D"
        />
        <path
            d="m860.49 327.87-.585-.339c-.012-.005-.022-.013-.03-.023s-.012-.023-.013-.036v.114a.072.072 0 0 0 .013.037.064.064 0 0 0 .03.024l.585.34v-.117z"
            fill="#636363"
        />
        <path
            d="M861.32 327.47a.06.06 0 0 1-.04.057l-.583.339a.219.219 0 0 1-.207 0v.117a.23.23 0 0 0 .103.025.23.23 0 0 0 .102-.025l.585-.34a.064.064 0 0 0 .029-.025.064.064 0 0 0 .011-.036v-.112z"
            fill="#3D3D3D"
        />
        <path
            d="m861.52 328.46-.588-.34a.07.07 0 0 1-.043-.062v.121a.07.07 0 0 0 .043.059l.588.338v-.116z"
            fill="#636363"
        />
        <path
            d="M862.35 328.07a.055.055 0 0 1-.012.035.058.058 0 0 1-.029.022l-.582.34a.218.218 0 0 1-.1.025.221.221 0 0 1-.1-.025v.116a.207.207 0 0 0 .2 0l.584-.338a.066.066 0 0 0 .041-.058l-.002-.117z"
            fill="#3D3D3D"
        />
        <path
            d="m863.57 329.65-1.613-.931c-.012-.004-.022-.012-.029-.022s-.012-.022-.013-.034v.116a.07.07 0 0 0 .013.035.08.08 0 0 0 .029.023l1.612.931.001-.118z"
            fill="#636363"
        />
        <path
            d="M864.4 329.25a.07.07 0 0 1-.012.035.068.068 0 0 1-.027.026l-.586.335c-.031.016-.065.025-.1.025s-.069-.009-.1-.025v.118a.217.217 0 0 0 .2 0l.586-.34a.07.07 0 0 0 .039-.057v-.117z"
            fill="#3D3D3D"
        />
        <path
            d="m859.53 328.43-.589-.34a.073.073 0 0 1-.042-.059v.119a.069.069 0 0 0 .014.034.07.07 0 0 0 .028.023l.589.339v-.116z"
            fill="#636363"
        />
        <path
            d="M860.36 328.04c-.001.012-.005.023-.012.033s-.017.017-.028.022l-.585.34a.23.23 0 0 1-.2 0v.116c.031.016.065.025.1.025s.069-.009.1-.025l.585-.339c.011-.005.021-.013.028-.023s.011-.022.012-.034v-.115z"
            fill="#3D3D3D"
        />
        <path
            d="m860.56 329.03-.59-.34a.078.078 0 0 1-.041-.061v.118a.07.07 0 0 0 .013.035.075.075 0 0 0 .028.025l.59.337v-.114z"
            fill="#636363"
        />
        <path
            d="M861.38 328.63a.07.07 0 0 1-.012.035.075.075 0 0 1-.027.026l-.587.34a.23.23 0 0 1-.2 0v.114a.217.217 0 0 0 .2 0l.585-.337a.065.065 0 0 0 .028-.024.071.071 0 0 0 .013-.034v-.12z"
            fill="#3D3D3D"
        />
        <path
            d="M861.34 328.57a.066.066 0 0 1 .04.06.066.066 0 0 1-.04.06l-.587.34a.23.23 0 0 1-.2 0l-.59-.34a.064.064 0 0 1-.042-.06.07.07 0 0 1 .011-.037.065.065 0 0 1 .031-.023l.584-.339a.23.23 0 0 1 .2 0l.593.339z"
            fill="#4A4A4A"
        />
        <path
            d="m862.61 330.21-1.614-.932a.073.073 0 0 1-.029-.024.077.077 0 0 1-.012-.036v.117a.066.066 0 0 0 .013.036.062.062 0 0 0 .029.024l1.614.933-.001-.118z"
            fill="#636363"
        />
        <path
            d="M863.44 329.81a.07.07 0 0 1-.012.034.073.073 0 0 1-.029.023l-.583.341a.23.23 0 0 1-.2 0v.118a.232.232 0 0 0 .2 0l.585-.341a.071.071 0 0 0 .041-.057l-.002-.118zM855.19 323.92a.06.06 0 0 1-.014.033.056.056 0 0 1-.029.021l-.582.342a.23.23 0 0 1-.2 0v.117a.231.231 0 0 0 .1.022.228.228 0 0 0 .1-.022l.582-.338a.068.068 0 0 0 .029-.024.06.06 0 0 0 .012-.036l.002-.115z"
            fill="#3D3D3D"
        />
        <path
            d="m867.56 328.71.013.256-.584.372-.012-.257.583-.371zM868.45 328.16l.012.258-.584.371-.012-.258.584-.371z"
            fill="#393939"
        />
        <path
            d="m868.4 328.4-.53.336-.011-.2.531-.337.01.201zM867.53 328.93l-.537.343-.009-.191.535-.342.011.19z"
            fill="#000"
        />
        <path
            d="M848.76 323.09s2.925-.656 3.468-.752a7.303 7.303 0 0 1 3.072.752l1.24 1.147s.163.259-.28.353-1.112-.7-1.112-.7l-1.3-.377s-.836-.028-.867.377c-.023.3.7.462 1.008.515.212.037.689.181.773.4a.358.358 0 0 1-.164.468c-.396 0-.79-.046-1.174-.139-.8-.141-1.392-.172-1.848-.258a1.851 1.851 0 0 1-1.011-.586l-1.451.376-.354-1.576zM856.52 330a15.46 15.46 0 0 1 2.772 0c.766.162 3.014 1.045 3.014 1.045s.644.241.282.645c-.284.229-.579.443-.883.642-.2.16-.8.2-2.008-.04a4.238 4.238 0 0 0-1.649-.039 4.01 4.01 0 0 1-1.569-.241l.041-2.012z"
            fill="#FFE1CC"
        />
        <path
            d="M838.69 317.62s-1.931-.419-2.057 2.893c-.021.613 1.3 3.12 2.133 4.585a4.262 4.262 0 0 0 3.48 1.777 30.453 30.453 0 0 0 7.864-2.226 1.158 1.158 0 0 0 .072-.941c-.19-.79-.544-.882-.544-.882l-7.392.89-3.556-6.096z"
            fill="#911309"
        />
        <path
            d="m842.62 318.6 2.959 6.263a1.7 1.7 0 0 1 .256.781 2.477 2.477 0 0 1-.464 1.495 2.367 2.367 0 0 1-.148.208 3.623 3.623 0 0 0-.981 2.107l.126 5.3s-.066.829-.09 1.351a4.357 4.357 0 0 1-3.443 1.456 11.861 11.861 0 0 1-5.955-2.311l1.318-4.941c.094-.445.126-.902.094-1.357l-.563-5.206a13.735 13.735 0 0 1 .19-3.143 5.026 5.026 0 0 1 2.823-3.464s3.654 1.073 3.878 1.461z"
            fill="#B21B0B"
        />
        <path
            d="M838.46 317.04c.14-.61.259-.518.54-.3l2.272.681c.278.255 1.641.912 1.877 1.589l.468 1.5a10.668 10.668 0 0 0-1.221-1.076 15.727 15.727 0 0 0-4.4-1.925c-.097-.002.464-.469.464-.469z"
            fill="#EDEDED"
        />
        <path
            d="m843.23 307.77 2.842.137-1.452 7.508c-.281 1.4-1.113 2.01-1.747 2.031-1.237.039-2.1-.9-3.221-2.4a3.188 3.188 0 0 1-.8-2.369l-.425-4.9 4.803-.007z"
            fill="#FFE1CC"
        />
        <path
            d="M844.03 319.04s-7.069-.36-8.284-5.567c-.658-2.81.468-6.968 3.657-7.935a5.617 5.617 0 0 1 6.468 2.217 4.92 4.92 0 0 1-.185 5.25c-1.578 1.867-2.064 1.875-2.44 3.187a2.626 2.626 0 0 0 .784 2.848z"
            fill="#684005"
        />
        <path
            d="M857.18 331.19c-.051 1.076-.588 1.082-.588 1.082s-5.795-.149-6.553-.094a3.823 3.823 0 0 1-2.547-.907c-.8-.484-5.642-5.577-5.642-5.577s-1.985-1.838-1.178-3.285c.883-1.583 2.716-1.179 3.7.066.919 1.164 2.991 4.285 4.174 5.686a1.94 1.94 0 0 0 1.577.865l6.213.864c.188.065.353.185.474.344.221.271.351.606.37.956z"
            fill="#D32A1E"
        />
        <path
            d="M873.49 350.22c-.006.586.753.979 1.268.985.181 0 .278 1.1.536 1.513a.466.466 0 0 0 .6.199.466.466 0 0 0 .178-.145 19.939 19.939 0 0 0-.5-2.119c-.334-1.366-.866-1.423-1.381-1.427s-.695.406-.701.994z"
            fill="#FFE8D9"
        />
        <path
            d="M872.85 349.23h1.487l.546 1.826-.005.3-.253 2.384a1.191 1.191 0 0 1-.369.833 1.175 1.175 0 0 1-.85.322h-.084c-1.062 0-1.344-1.183-1.344-1.183l-.242-3.083c-.014-.658.431-1.399 1.114-1.399z"
            fill="#FFE8D9"
        />
        <path
            d="M874.68 349.53h-2.388l-1.16-8.836.306-5.181c-.046-1.641.8-4.567 2.456-4.816 1.943-.3 1.391 3.023 1.391 3.023l-.81 6.84.205 8.97z"
            fill="#01797F"
        />
        <path
            d="M871.2 356.14c-.009-1.043-.36-6.679-.189-7.435l7.308 3.816c-.023.25-.037.337-.037.337l-2.811 17.346-.027.041a2.25 2.25 0 0 0 1.182 1.984c.29.2 1.935 1.264 1.96 1.273l.022.007c-.036.02-.071.069-.071.193 0 .428-4.328.05-4.328.05a2.872 2.872 0 0 1-1.562-.3c-.43-.322-.541-.37-.541-.767l-.906-16.545z"
            fill="#E8C5AC"
        />
        <path
            d="m873.55 373.82-.1 1.007a.962.962 0 0 1-1.2-.143l-.326-1.58a1.722 1.722 0 0 0 1.187.692c.144.029.292.037.439.024z"
            fill="#7C7676"
        />
        <path
            d="M874.42 372.48c1.655 1.053 2.686.483 2.832.4.6-.319.35-.7.025-.925a1.24 1.24 0 0 0-.326-.14 5.103 5.103 0 0 1 2.03.18c.15.1.289.247.3.36a.587.587 0 0 1-.158.418s-.952.384-1.614.721c-1.119.577-3.843.226-4.861.271-.347.016-.819-.521-.854-1.192a1.947 1.947 0 0 1 .261-1.322c.434.029.848.195 1.183.472.18.124.838.538 1.182.757z"
            fill="#070707"
        />
        <path
            d="M872.75 373.61c.151.032.7.058 1.545.141a5.726 5.726 0 0 0 3.17-.321 9.753 9.753 0 0 0 1.345-.633c.165-.1.506-.293.466-.437a.488.488 0 0 1-.067.414c-.644.396-1.322.733-2.025 1.007a12.897 12.897 0 0 1-3.219.1 13.404 13.404 0 0 1-1.564-.1c-.342-.065-.4-.479-.425-.534.235.164.497.287.774.363z"
            fill="#7C7676"
        />
        <path
            d="m875.81 348.29-.454 22.935h-3.33l-.823-15.09c-.009-1.043-.553-7.66.009-8.783l4.598.938z"
            fill="#423B3B"
        />
        <path d="M878.61 373.51c.063-.034.121.034 0 0z" fill="#E8C5AC" />
        <path d="M878.61 373.51c.063-.034.121.034 0 0z" fill="#E8C5AC" />
        <path
            d="M871.98 350.04a8.927 8.927 0 0 1 .537-2.33l7.851.84v1.063l-.107 1.7s-1.943 21.171-1.943 21.352c-.008.7.691 1.079 2.031 1.5.362.132.716.285 1.06.457.241.08.688.77.1 1a15.62 15.62 0 0 1-4.178.421s-1.48-.321-1.9-.353c-.536-.044-.433-1.528-.433-1.528-.154-1.684-1.785-19.465-1.855-20.087-.134-1.066-1.006-1.928-1.163-4.035z"
            fill="#FFE1CC"
        />
        <path
            d="m876.18 375.97-.223.987a.977.977 0 0 1-.641.067.999.999 0 0 1-.57-.351l-.16-1.613a1.836 1.836 0 0 0 1.3.886c.29.009.294.024.294.024z"
            fill="#7C7676"
        />
        <path
            d="M877.61 374.84a3.405 3.405 0 0 0 2.84.465c.809-.3.887-.756-.119-1.137-.151-.058 1.887.307 2.1.749a.973.973 0 0 1 .147.392.583.583 0 0 1-.21.4s-1.023.268-1.74.522c-1.217.433-4.319-.33-5.373-.414-.359-.027-.794-.621-.744-1.29a2.026 2.026 0 0 1 .42-1.252 1.97 1.97 0 0 1 1.161.588c.174.14 1.253.821 1.518.977z"
            fill="#070707"
        />
        <path
            d="M875.21 375.53c.152.048.92.178 1.766.319 1.808.3 1.968.516 3.21.4a5.917 5.917 0 0 0 1.793-.493c.2-.094.6-.358.6-.446.009.321-.115.4-.115.4a4.464 4.464 0 0 1-2.252.863c-1.639.232-2.97-.453-3.872-.553a3.54 3.54 0 0 1-1.29-.253.75.75 0 0 1-.421-.56c.168.147.366.258.581.323z"
            fill="#7C7676"
        />
        <path
            d="M880.37 348.56v1.063l-.107 1.7s-1.943 21.171-1.943 21.352a.806.806 0 0 0 .055.3h-3.492c-.406-4.4-1.849-18.272-1.914-18.821-.123-1.066-.945-1.921-1.1-4.025a11.8 11.8 0 0 1 .247-2.472l8.254.903z"
            fill="#5B5353"
        />
        <path
            d="M880.37 349.23s-.283 1.768-4.406 1.381a8.791 8.791 0 0 1-4.931-2.179c.018-.308.063-.613.133-.913l9.105.2c0 .159.114.208.1.386-.026.318.014 1.001-.001 1.125z"
            fill="#3A3535"
            opacity={0.52}
        />
        <path
            d="m878.84 331.36 2.956 6.262c.148.236.236.505.255.782a2.459 2.459 0 0 1-.46 1.49c-.05.075-.1.144-.148.207a3.649 3.649 0 0 0-.982 2.106l.128 5.3s0 .77-.031.869a4.6 4.6 0 0 1-3.477 1.388c-2.707.029-5.954-2.063-6.006-1.921l1.253-4.457a5.192 5.192 0 0 0 .186-1.678l-.563-5.2a13.94 13.94 0 0 1 .187-3.14 5.03 5.03 0 0 1 2.822-3.466s3.658 1.073 3.88 1.458z"
            fill="#0592A0"
        />
        <path
            d="M878.42 352.96c-.006.537.69.9 1.162.9.166 0 .255 1.01.493 1.389a.415.415 0 0 0 .343.22.422.422 0 0 0 .37-.171 18.86 18.86 0 0 0-.461-1.944c-.308-1.255-.792-1.3-1.267-1.307a.543.543 0 0 0-.546.349c-.068.18-.1.372-.094.564z"
            fill="#FFE8D9"
        />
        <path
            d="M877.83 352.05h1.364l.5 1.676v.273l-.233 2.185a1.081 1.081 0 0 1-1.119 1.062h-.076c-.975 0-1.1-1.369-1.1-1.369l-.119-2.343c-.021-.599.156-1.484.783-1.484z"
            fill="#FFE8D9"
        />
        <path
            d="M879.77 352.24a3.894 3.894 0 0 1-1.45.274 2.612 2.612 0 0 1-1-.183l-.167-1.637-.653-7.147.1-5.6c-.1-1.5.354-3.843 1.994-3.843 1.966 0 1.654 2.656 1.654 2.656l-.813 6.842.335 8.638z"
            fill="#14AAB2"
        />
        <path
            d="m879.45 320.54 2.837.132-1.446 7.505c-.281 1.407-1.114 2.011-1.748 2.032-1.231.038-2.1-.9-3.219-2.407a3.166 3.166 0 0 1-.8-2.368l-.424-4.9 4.8.006z"
            fill="#FFE1CC"
        />
        <path
            d="M872.53 325.37c-.242-2.252.023-5.736 3.211-6.7 2.783-.847 5.132-.023 6.353 1.851a4.267 4.267 0 0 1 .522 3.367 2.517 2.517 0 0 1-.476.183c.025-.163.037-.328.036-.494a3.709 3.709 0 0 0-.125-1.064 6.024 6.024 0 0 1-.253 1.638c-1.425.5-1.867 2.593-1.714 4.174a5.837 5.837 0 0 0 1.525 3.1s-.1.031-.28.072c-.2-.117-.589.114-.79-.115a8.462 8.462 0 0 1-.892-1.235c.106.471.265.928.473 1.363.087.2.367.033.443.183a12.83 12.83 0 0 1-5.906-.68 7.341 7.341 0 0 1-3.126-2.376c1.149-.686 1.093-2.393.999-3.267z"
            fill="#684005"
        />
        <path
            d="M887.89 377.82c-1.734-1.35-1.781-4.869-1.781-4.869l.964-7.421 7.422 3.854 2.411 3.664 7.134-1.784c2.362-.723 6.072-.434 5.977 3.471l-.194 2.266s-.233 1.1-1.445-.289c-.674-.771-2.263-.384-2.263-.384s-7.39 3.021-9.546 3.758c-3.665 1.254-7.021-.978-8.679-2.266z"
            fill="#383736"
        />
        <path
            d="m912.38 368.93-13.658-7.819v.309a.593.593 0 0 0 .3.516l12.651 7.287a1.405 1.405 0 0 0 1.393 0l8.944-5.2a.802.802 0 0 0 .4-.691v-.406l-10.03 6.004z"
            fill="#9E9D9D"
        />
        <path
            d="m922.4 362.93-9.455 6.045a1.14 1.14 0 0 1-1.18.021l-12.842-7.388a.417.417 0 0 1-.015-.712l9.455-6.039 14.037 8.073z"
            fill="#D3D3D3"
        />
        <path
            d="M909.08 345.21a.584.584 0 0 0-.594.005l-.158.093 13.472 7.972.277 9.887.324-.187v-9.389a1.187 1.187 0 0 0-.6-1.035l-12.721-7.346z"
            fill="#8E8D8D"
        />
        <path
            d="M921.48 352.75a1.187 1.187 0 0 1 .6 1.035v9.388l-14-8.1v-9.388c0-.07.018-.14.054-.2a.396.396 0 0 1 .546-.147l12.8 7.412z"
            fill="#C1BFBD"
        />
        <path
            d="M920.75 362.79a.303.303 0 0 1 .112.22.298.298 0 0 1-.09.229l-4.413 2.817c-.369.227-.685.022-1.032-.176l-11.875-6.837a.27.27 0 0 1 0-.5l4.337-2.738a.755.755 0 0 1 .7-.1l12.261 7.085z"
            fill="#898686"
        />
        <path
            d="M912.28 362.9a.093.093 0 0 1-.013.035.081.081 0 0 1-.028.024l-.6.35a.24.24 0 0 1-.209 0v.122a.24.24 0 0 0 .209 0l.6-.355c.012-.005.022-.013.029-.023s.011-.023.012-.035v-.118z"
            fill="#737373"
        />
        <path
            d="M910.29 363.6c.392.228.393.588.006.813l-1.752 1.019a1.556 1.556 0 0 1-1.406 0l-2.754-1.588a.431.431 0 0 1-.005-.816l1.752-1.018a1.549 1.549 0 0 1 1.406 0l2.753 1.59z"
            fill="#9E9D9D"
        />
        <path
            d="M921 353.82v7.548l-12.151-7.014v-7.551L921 353.82z"
            fill="#8E8D8D"
        />
        <path
            d="m908.98 354.23 12.024 6.94v-7.349l-12.024-6.945v7.354z"
            fill="#80F9E4"
        />
        <path
            d="M908.95 356.09c.057.033.057.086 0 .12l-.6.347a.22.22 0 0 1-.207 0l-.606-.347a.064.064 0 0 1-.03-.024c-.008-.01-.012-.023-.012-.036s.004-.026.012-.037a.057.057 0 0 1 .03-.023l.6-.348a.219.219 0 0 1 .206 0l.607.348zM911.08 357.31a.067.067 0 0 1 .031.024.07.07 0 0 1 0 .075.07.07 0 0 1-.031.025l-.6.349a.261.261 0 0 1-.208 0l-.606-.349a.068.068 0 0 1-.031-.025.063.063 0 0 1-.012-.037.066.066 0 0 1 .043-.062l.6-.349a.24.24 0 0 1 .209 0l.605.349zM909.96 356.66a.061.061 0 0 1 .033.021.064.064 0 0 1 .012.038.063.063 0 0 1-.012.037.069.069 0 0 1-.033.022l-.6.352a.248.248 0 0 1-.104.024.247.247 0 0 1-.103-.024l-.606-.352c-.013-.004-.023-.012-.031-.023s-.012-.023-.012-.036a.06.06 0 0 1 .043-.059l.6-.35a.22.22 0 0 1 .212 0l.601.35zM912.14 357.93c.06.032.06.087 0 .121l-.6.347a.219.219 0 0 1-.206 0l-.607-.349a.072.072 0 0 1-.031-.023.07.07 0 0 1-.011-.037c0-.013.004-.026.011-.036a.06.06 0 0 1 .031-.023l.6-.349c.032-.019.068-.028.105-.028s.074.009.106.028l.602.349zM913.19 358.53c.058.035.058.09 0 .121l-.6.349c-.032.017-.068.025-.104.025s-.071-.008-.103-.025l-.6-.349c-.057-.032-.057-.086 0-.121l.6-.348c.032-.016.068-.025.104-.025s.072.009.104.025l.599.348zM914.24 359.14c.057.037.057.089 0 .122l-.6.349a.234.234 0 0 1-.209 0l-.6-.349a.062.062 0 0 1-.031-.024.063.063 0 0 1-.012-.037.064.064 0 0 1 .043-.061l.6-.347a.228.228 0 0 1 .212 0l.597.347zM909 357.37a.059.059 0 0 1 .03.024.063.063 0 0 1 0 .074.064.064 0 0 1-.03.024l-.6.348a.23.23 0 0 1-.211 0l-1.66-.957c-.055-.036-.055-.089 0-.121l.6-.35a.231.231 0 0 1 .208 0l1.663.958zM910 357.93c.059.032.059.087 0 .119l-.6.349a.223.223 0 0 1-.209 0l-.6-.349c-.059-.032-.059-.087 0-.119l.6-.349a.199.199 0 0 1 .208 0l.601.349zM911.13 358.58c.059.033.059.087 0 .119l-.6.349a.232.232 0 0 1-.207 0l-.606-.349a.079.079 0 0 1-.031-.023.07.07 0 0 1-.011-.037c0-.013.004-.026.011-.036a.064.064 0 0 1 .031-.023l.6-.353a.245.245 0 0 1 .103-.022c.036 0 .071.007.103.022l.607.353zM912.19 359.19a.065.065 0 0 1 .033.021.064.064 0 0 1 .012.038.063.063 0 0 1-.012.037.074.074 0 0 1-.033.022l-.6.352a.245.245 0 0 1-.212 0l-.6-.352a.072.072 0 0 1-.031-.023.07.07 0 0 1-.012-.037c0-.013.005-.026.012-.036a.06.06 0 0 1 .031-.023l.6-.351a.249.249 0 0 1 .104-.025.257.257 0 0 1 .105.025l.603.352zM913.24 359.8c.059.036.059.085 0 .12l-.6.349a.23.23 0 0 1-.207 0l-.6-.349c-.058-.035-.058-.084 0-.12l.6-.348a.219.219 0 0 1 .21 0l.597.348zM907.98 357.96a.073.073 0 0 1 .029.023.064.064 0 0 1 0 .072.067.067 0 0 1-.029.024l-.6.351a.237.237 0 0 1-.207 0l-1.662-.959a.066.066 0 0 1-.03-.024.07.07 0 0 1-.011-.037c0-.013.004-.026.011-.037s.017-.019.03-.024l.6-.349a.231.231 0 0 1 .208 0l1.661.96zM909.04 358.57a.057.057 0 0 1 .029.024.06.06 0 0 1 .011.037.059.059 0 0 1-.011.036.064.064 0 0 1-.029.025l-.6.35a.255.255 0 0 1-.21 0l-.6-.35a.062.062 0 0 1-.031-.024.063.063 0 0 1-.012-.037c0-.014.004-.027.012-.038a.056.056 0 0 1 .031-.023l.6-.347a.22.22 0 0 1 .211 0l.599.347zM910.12 359.21a.064.064 0 0 1 0 .12l-.6.35a.25.25 0 0 1-.207 0l-.606-.35c-.058-.034-.058-.087 0-.12l.6-.35a.219.219 0 0 1 .21 0l.603.35zM911.17 359.82c.06.031.063.085 0 .12l-.6.349a.234.234 0 0 1-.209 0l-.6-.349c-.057-.035-.057-.091 0-.12l.6-.35a.23.23 0 0 1 .21 0l.599.35zM915.3 359.75c.058.031.058.086 0 .12l-.6.35a.24.24 0 0 1-.21 0l-.6-.35c-.057-.034-.057-.089 0-.12l.6-.352a.231.231 0 0 1 .208 0l.602.352zM914.3 360.41c.058.033.058.086 0 .12l-.6.347a.225.225 0 0 1-.208 0l-.601-.347c-.061-.034-.061-.087 0-.12l.601-.349a.207.207 0 0 1 .207 0l.601.349zM912.23 360.43a.064.064 0 0 1 .03.024c.008.011.012.023.012.036s-.004.026-.012.037a.064.064 0 0 1-.03.024l-.6.349a.24.24 0 0 1-.21 0l-.6-.349a.064.064 0 0 1-.032-.024.071.071 0 0 1-.012-.038.07.07 0 0 1 .012-.037.064.064 0 0 1 .032-.024l.6-.349a.235.235 0 0 1 .21 0l.6.351zM913.29 361.04a.064.064 0 0 1 .03.024c.008.01.011.023.011.036s-.003.026-.011.037a.064.064 0 0 1-.03.024l-.6.349a.233.233 0 0 1-.207 0l-.606-.349a.07.07 0 0 1-.03-.024.07.07 0 0 1-.011-.037.064.064 0 0 1 .041-.06l.6-.349c.033-.016.068-.025.104-.025s.072.009.104.025l.605.349zM908.08 359.22c.06.033.06.086 0 .119l-.6.351a.222.222 0 0 1-.104.025.226.226 0 0 1-.105-.025l-2.715-1.567c-.058-.034-.058-.087 0-.12l.6-.349a.223.223 0 0 1 .207 0l2.717 1.566zM909.11 359.84c.058.033.06.087 0 .121l-.6.348a.235.235 0 0 1-.21 0l-.6-.347c-.059-.035-.059-.088 0-.121l.6-.351a.24.24 0 0 1 .21 0l.6.35zM910.16 360.44c.059.032.059.086 0 .121l-.6.349a.234.234 0 0 1-.209 0l-.6-.35a.067.067 0 0 1-.031-.024.066.066 0 0 1 0-.073.06.06 0 0 1 .031-.023l.6-.35a.229.229 0 0 1 .21 0l.599.35zM911.22 361.05c.06.032.06.085 0 .118l-.6.351a.25.25 0 0 1-.208 0l-.6-.353c-.059-.031-.059-.084 0-.116l.6-.352a.233.233 0 0 1 .208 0l.6.352zM912.27 361.66c.012.005.022.013.029.024s.011.024.011.037-.004.026-.011.037-.017.019-.029.025l-.6.347a.231.231 0 0 1-.208 0l-.605-.35c-.059-.032-.059-.087 0-.12l.6-.349a.233.233 0 0 1 .208 0l.605.349zM916.36 360.36a.072.072 0 0 1 .031.023c.007.011.011.024.011.037a.064.064 0 0 1-.042.06l-.6.348c-.032.017-.067.025-.103.025s-.072-.008-.104-.025l-.6-.35c-.06-.031-.06-.087 0-.118l.6-.351a.25.25 0 0 1 .207 0l.6.351zM915.35 361.01a.057.057 0 0 1 .031.024.066.066 0 0 1 0 .076.064.064 0 0 1-.031.025l-.6.347a.234.234 0 0 1-.209 0l-.6-.347c-.057-.037-.057-.091 0-.125l.6-.347a.223.223 0 0 1 .207 0l.602.347zM914.34 361.65c.058.035.058.088 0 .122l-.6.349a.223.223 0 0 1-.209 0l-.6-.349c-.06-.034-.059-.087 0-.122l.6-.35a.237.237 0 0 1 .208 0l.601.35zM913.33 362.27a.063.063 0 0 1 .046.06.065.065 0 0 1-.046.061l-.6.348a.223.223 0 0 1-.208 0l-.606-.348a.067.067 0 0 1-.03-.025.063.063 0 0 1 0-.074.064.064 0 0 1 .03-.024l.6-.349c.032-.017.068-.025.104-.025s.072.008.104.025l.606.351zM905 358.62c.058.033.058.088 0 .119l-.6.352a.256.256 0 0 1-.21 0l-.6-.352c-.013-.004-.025-.012-.033-.023a.063.063 0 0 1 0-.074.057.057 0 0 1 .033-.022l.6-.35a.22.22 0 0 1 .211 0l.599.35zM906 359.19c.058.035.06.088 0 .122l-.6.346a.223.223 0 0 1-.208 0l-.609-.346a.067.067 0 0 1-.03-.098.064.064 0 0 1 .03-.024l.6-.351a.23.23 0 0 1 .2 0l.617.351zM907.06 359.8c.058.036.058.087 0 .123l-.6.349a.233.233 0 0 1-.207 0l-.605-.349c-.058-.036-.058-.087 0-.125l.6-.345a.214.214 0 0 1 .21 0l.602.347zM912.33 362.85c.058.033.058.088 0 .119l-.6.351a.239.239 0 0 1-.211 0l-4.822-2.785a.067.067 0 0 1-.043-.061.064.064 0 0 1 .043-.061l.6-.348a.223.223 0 0 1 .209 0l4.824 2.785zM917.41 360.96c.057.032.057.086 0 .12l-.6.35a.247.247 0 0 1-.207 0l-.608-.35c-.057-.034-.057-.088 0-.12l.6-.351a.229.229 0 0 1 .21 0l.605.351zM918.46 361.57c.059.033.059.088 0 .122l-.6.348a.235.235 0 0 1-.209 0l-.6-.348c-.059-.034-.059-.089 0-.122l.6-.348a.212.212 0 0 1 .209 0l.6.348zM920.57 362.79a.066.066 0 0 1 .031.099.068.068 0 0 1-.031.025l-.6.347a.224.224 0 0 1-.209 0l-1.659-.959a.07.07 0 0 1-.032-.024.07.07 0 0 1-.012-.037.07.07 0 0 1 .012-.037.062.062 0 0 1 .032-.023l.6-.349a.24.24 0 0 1 .209 0l1.659.958zM916.41 361.63c.059.032.059.086 0 .12l-.6.349a.239.239 0 0 1-.211 0l-.6-.348a.07.07 0 0 1-.03-.024.066.066 0 0 1 0-.073.07.07 0 0 1 .03-.024l.6-.347a.212.212 0 0 1 .208 0l.603.347zM917.46 362.23c.057.033.057.086 0 .122l-.6.348a.226.226 0 0 1-.105.025.222.222 0 0 1-.104-.025l-.607-.348c-.057-.036-.057-.089 0-.122l.6-.348a.24.24 0 0 1 .211 0l.605.348zM918.52 362.84c.057.034.057.085 0 .12l-.6.349a.229.229 0 0 1-.209 0l-.6-.349c-.057-.035-.058-.086 0-.12l.6-.35a.233.233 0 0 1 .207 0l.602.35zM919.57 363.45c.059.033.059.089 0 .124l-.6.348a.255.255 0 0 1-.211 0l-.6-.348c-.061-.035-.061-.091 0-.126l.6-.346a.223.223 0 0 1 .208 0l.603.348zM915.4 362.26a.068.068 0 0 1 .03.023c.007.011.011.024.011.037s-.004.026-.011.037a.078.078 0 0 1-.03.024l-.6.349a.23.23 0 0 1-.207 0l-.606-.349c-.059-.033-.059-.087 0-.121l.6-.346a.209.209 0 0 1 .206 0l.607.346zM916.45 362.87c.059.035.059.09 0 .119l-.6.351a.219.219 0 0 1-.104.025.222.222 0 0 1-.104-.025l-.6-.351c-.059-.029-.059-.084 0-.119l.6-.349a.247.247 0 0 1 .214 0l.594.349zM918.56 364.09c.057.031.057.086 0 .119l-.6.35a.237.237 0 0 1-.208 0l-1.658-.959a.075.075 0 0 1-.032-.023.063.063 0 0 1-.012-.037c0-.014.004-.027.012-.038a.066.066 0 0 1 .032-.022l.6-.352a.242.242 0 0 1 .211 0l1.655.962zM914.38 362.88c.056.036.057.088 0 .122l-.6.347a.23.23 0 0 1-.212 0l-.606-.347c-.057-.034-.057-.086 0-.122l.6-.347a.224.224 0 0 1 .211 0l.607.347zM915.44 363.49c.058.035.058.09 0 .12l-.6.351a.235.235 0 0 1-.21 0l-.6-.352c-.06-.029-.06-.084 0-.119l.6-.35a.237.237 0 0 1 .208 0l.602.35zM917.55 364.71c.057.034.057.087 0 .124l-.6.344a.22.22 0 0 1-.208 0l-1.658-.959c-.058-.033-.06-.087 0-.12l.6-.349a.23.23 0 0 1 .211 0l1.655.96zM913.39 363.46c.057.033.057.086 0 .123l-.6.347a.223.223 0 0 1-.209 0l-.6-.347c-.061-.037-.061-.09 0-.123l.6-.349a.231.231 0 0 1 .208 0l.601.349zM916.55 365.28c.059.034.061.087 0 .121l-.6.348a.229.229 0 0 1-.21 0l-1.661-.959a.057.057 0 0 1-.03-.023c-.008-.01-.012-.023-.012-.036s.004-.026.012-.037a.07.07 0 0 1 .03-.023l.6-.35a.237.237 0 0 1 .208 0l1.663.959z"
            fill="#4A4A4A"
        />
        <path
            d="m908.14 356.56-.606-.347a.096.096 0 0 1-.029-.024.075.075 0 0 1-.013-.035v.119a.073.073 0 0 0 .014.037c.007.011.017.02.029.026l.606.347-.001-.123z"
            fill="#636363"
        />
        <path
            d="M908.99 356.15a.07.07 0 0 1-.013.035.083.083 0 0 1-.029.024l-.6.347a.223.223 0 0 1-.207 0v.121a.216.216 0 0 0 .207 0l.6-.347c.012-.006.022-.015.029-.026s.012-.024.013-.037v-.117z"
            fill="#3D3D3D"
        />
        <path
            d="m909.15 357.12-.606-.35a.067.067 0 0 1-.042-.06v.117c0 .026.015.044.044.063l.606.348-.002-.118z"
            fill="#636363"
        />
        <path
            d="M910 356.71a.063.063 0 0 1-.013.035.064.064 0 0 1-.03.024l-.6.35c-.031.017-.067.025-.103.025s-.072-.008-.104-.025v.118c.032.017.068.025.104.025s.072-.008.103-.025l.6-.348a.08.08 0 0 0 .03-.025.07.07 0 0 0 .013-.035v-.119z"
            fill="#3D3D3D"
        />
        <path
            d="m910.27 357.78-.606-.349a.076.076 0 0 1-.03-.026.073.073 0 0 1-.014-.037v.119a.079.079 0 0 0 .013.038.084.084 0 0 0 .031.025l.606.349v-.119z"
            fill="#636363"
        />
        <path
            d="M911.12 357.37a.074.074 0 0 1-.041.063l-.6.349a.261.261 0 0 1-.208 0v.119a.237.237 0 0 0 .208 0l.6-.349a.079.079 0 0 0 .029-.025.077.077 0 0 0 .012-.035v-.122z"
            fill="#3D3D3D"
        />
        <path
            d="m911.33 358.39-.6-.349a.069.069 0 0 1-.044-.06v.12a.065.065 0 0 0 .013.035.07.07 0 0 0 .029.025l.605.349-.003-.12z"
            fill="#636363"
        />
        <path
            d="M912.18 357.98a.059.059 0 0 1-.013.036.067.067 0 0 1-.031.024l-.6.349c-.032.016-.068.025-.104.025s-.072-.009-.104-.025v.12c.032.016.068.025.104.025s.072-.009.104-.025l.6-.349a.069.069 0 0 0 .044-.06v-.12z"
            fill="#3D3D3D"
        />
        <path
            d="m912.38 359-.605-.348a.075.075 0 0 1-.04-.06v.121a.092.092 0 0 0 .014.039.11.11 0 0 0 .028.029l.605.349-.002-.13z"
            fill="#636363"
        />
        <path
            d="M913.23 358.59a.08.08 0 0 1-.014.036.073.073 0 0 1-.029.026l-.6.346a.224.224 0 0 1-.209 0v.121a.223.223 0 0 0 .208 0l.6-.348a.081.081 0 0 0 .028-.024.074.074 0 0 0 .015-.034l.001-.123z"
            fill="#3D3D3D"
        />
        <path
            d="m913.44 359.61-.6-.349a.076.076 0 0 1-.031-.025.079.079 0 0 1-.013-.038v.122c0 .022.013.042.044.059l.6.352v-.121z"
            fill="#636363"
        />
        <path
            d="M914.29 359.2a.078.078 0 0 1-.013.036.076.076 0 0 1-.03.023l-.6.349a.229.229 0 0 1-.209 0v.121a.24.24 0 0 0 .209 0l.6-.352a.076.076 0 0 0 .03-.023.07.07 0 0 0 .013-.035v-.119z"
            fill="#3D3D3D"
        />
        <path
            d="m908.19 357.84-1.66-.957a.09.09 0 0 1-.029-.026.092.092 0 0 1-.013-.036v.119a.082.082 0 0 0 .013.037c.007.01.017.019.029.025l1.66.958v-.12z"
            fill="#636363"
        />
        <path
            d="M909.04 357.43a.087.087 0 0 1-.015.034.096.096 0 0 1-.029.024l-.6.348a.23.23 0 0 1-.211 0v.12a.234.234 0 0 0 .209 0l.6-.35a.083.083 0 0 0 .03-.023.089.089 0 0 0 .014-.035l.002-.118z"
            fill="#3D3D3D"
        />
        <path
            d="m909.19 358.4-.6-.349a.075.075 0 0 1-.047-.061v.12a.075.075 0 0 0 .013.036c.008.011.018.02.03.026l.608.35-.004-.122z"
            fill="#636363"
        />
        <path
            d="M910.04 357.99a.063.063 0 0 1-.013.035.064.064 0 0 1-.03.024l-.6.349a.223.223 0 0 1-.209 0v.122a.227.227 0 0 0 .209 0l.6-.35a.07.07 0 0 0 .03-.024.064.064 0 0 0 .014-.034l-.001-.122z"
            fill="#3D3D3D"
        />
        <path
            d="m910.33 359.05-.606-.349a.085.085 0 0 1-.029-.024.066.066 0 0 1-.011-.035v.12a.084.084 0 0 0 .042.063l.606.348-.002-.123z"
            fill="#636363"
        />
        <path
            d="M911.18 358.64a.064.064 0 0 1-.012.035.07.07 0 0 1-.03.024l-.6.349c-.032.015-.067.024-.103.024s-.072-.009-.104-.024v.123a.23.23 0 0 0 .207 0l.6-.348a.073.073 0 0 0 .029-.026.073.073 0 0 0 .015-.035l-.002-.122z"
            fill="#3D3D3D"
        />
        <path
            d="m911.38 359.66-.6-.352a.078.078 0 0 1-.029-.025.072.072 0 0 1-.014-.035v.12a.078.078 0 0 0 .013.036c.008.01.018.019.03.024l.6.35v-.118z"
            fill="#636363"
        />
        <path
            d="M912.23 359.25c-.002.012-.007.025-.015.035s-.019.018-.031.023l-.6.352a.242.242 0 0 1-.212 0v.118a.235.235 0 0 0 .21 0l.6-.348a.084.084 0 0 0 .031-.025.068.068 0 0 0 .015-.036l.002-.119z"
            fill="#3D3D3D"
        />
        <path
            d="m912.43 360.27-.6-.349c-.031-.015-.046-.038-.042-.061v.123c0 .021.015.041.046.059l.6.349-.004-.121z"
            fill="#636363"
        />
        <path
            d="M913.29 359.86c-.001.013-.005.026-.013.037s-.019.019-.031.024l-.6.349c-.032.017-.068.025-.104.025s-.072-.008-.103-.025v.121a.237.237 0 0 0 .207 0l.6-.347c.029-.02.044-.04.044-.059v-.125z"
            fill="#3D3D3D"
        />
        <path
            d="m907.17 358.43-1.662-.959c-.012-.006-.023-.014-.031-.025s-.012-.024-.013-.037v.12c0 .024.017.045.044.063l1.66.959.002-.121z"
            fill="#636363"
        />
        <path
            d="M908.02 358.02a.079.079 0 0 1-.013.035.081.081 0 0 1-.028.024l-.6.351c-.032.015-.068.024-.104.024s-.071-.009-.103-.024v.121a.248.248 0 0 0 .104.024.252.252 0 0 0 .105-.024l.6-.347a.094.094 0 0 0 .029-.027.08.08 0 0 0 .012-.037l-.002-.12z"
            fill="#3D3D3D"
        />
        <path
            d="m908.22 359.04-.6-.35c-.013-.005-.024-.013-.032-.024s-.013-.024-.015-.037v.119c.002.013.007.026.015.037s.019.02.031.026l.6.348.001-.119z"
            fill="#636363"
        />
        <path
            d="M909.08 358.63a.077.077 0 0 1-.012.036.084.084 0 0 1-.028.025l-.6.35a.256.256 0 0 1-.105.024.249.249 0 0 1-.105-.024v.119a.229.229 0 0 0 .21 0l.6-.348a.075.075 0 0 0 .027-.026.082.082 0 0 0 .013-.035v-.121z"
            fill="#3D3D3D"
        />
        <path
            d="m909.31 359.68-.606-.35a.078.078 0 0 1-.03-.024.07.07 0 0 1-.014-.037v.121a.08.08 0 0 0 .015.037c.007.011.017.02.029.026l.605.345.001-.118z"
            fill="#636363"
        />
        <path
            d="M910.16 359.27a.064.064 0 0 1-.011.036.062.062 0 0 1-.029.024l-.6.35a.237.237 0 0 1-.207 0v.118a.203.203 0 0 0 .104.028.198.198 0 0 0 .104-.028l.6-.345a.06.06 0 0 0 .029-.026.067.067 0 0 0 .011-.037l-.001-.12z"
            fill="#3D3D3D"
        />
        <path
            d="m910.37 360.29-.6-.349a.084.084 0 0 1-.031-.025.082.082 0 0 1-.013-.037v.12c0 .013.005.026.013.037.007.011.018.02.031.025l.6.351v-.122z"
            fill="#636363"
        />
        <path
            d="M911.22 359.88c-.001.013-.006.026-.014.037s-.018.02-.031.025l-.6.349a.222.222 0 0 1-.104.025.223.223 0 0 1-.105-.025v.122a.238.238 0 0 0 .209 0l.6-.351a.064.064 0 0 0 .03-.024.069.069 0 0 0 .013-.036l.002-.122z"
            fill="#3D3D3D"
        />
        <path
            d="m914.49 360.22-.6-.35a.079.079 0 0 1-.043-.06v.117c.001.013.005.025.013.036s.018.019.03.025l.6.348v-.116z"
            fill="#636363"
        />
        <path
            d="M915.34 359.81a.07.07 0 0 1-.014.036.08.08 0 0 1-.03.024l-.6.35a.249.249 0 0 1-.105.024.256.256 0 0 1-.105-.024v.116a.23.23 0 0 0 .21 0l.6-.346c.029-.018.044-.037.044-.062v-.118z"
            fill="#3D3D3D"
        />
        <path
            d="m913.49 360.87-.6-.347c-.013-.006-.023-.015-.031-.026s-.012-.024-.013-.037v.121c0 .013.004.026.012.037.008.01.019.018.032.022l.6.352v-.122z"
            fill="#636363"
        />
        <path
            d="M914.34 360.47a.07.07 0 0 1-.043.061l-.6.347c-.032.016-.068.025-.104.025s-.072-.009-.104-.025V361c.033.015.068.024.104.024s.072-.009.104-.024l.6-.352a.064.064 0 0 0 .031-.023.055.055 0 0 0 .012-.035v-.12z"
            fill="#3D3D3D"
        />
        <path
            d="m911.42 360.9-.6-.349c-.031-.019-.045-.039-.045-.062v.119a.073.073 0 0 0 .045.061l.6.351v-.12z"
            fill="#636363"
        />
        <path
            d="M912.28 360.49a.093.093 0 0 1-.014.036.099.099 0 0 1-.029.025l-.6.349a.256.256 0 0 1-.105.024.252.252 0 0 1-.105-.024v.12a.233.233 0 0 0 .207 0l.6-.351a.096.096 0 0 0 .029-.024.08.08 0 0 0 .014-.035l.003-.12z"
            fill="#3D3D3D"
        />
        <path
            d="m912.48 361.51-.606-.349a.067.067 0 0 1-.041-.062v.121a.067.067 0 0 0 .041.062l.606.349v-.121z"
            fill="#636363"
        />
        <path
            d="M913.33 361.1a.07.07 0 0 1-.014.035.089.089 0 0 1-.03.024l-.6.349a.237.237 0 0 1-.207 0v.121c.033.015.068.024.104.024s.071-.009.103-.024l.6-.349a.08.08 0 0 0 .03-.025.064.064 0 0 0 .012-.035l.002-.12z"
            fill="#3D3D3D"
        />
        <path
            d="m907.27 359.69-2.715-1.567a.072.072 0 0 1-.042-.061v.122c0 .021.015.04.042.06l2.715 1.567v-.121zM908.3 360.3l-.6-.347a.08.08 0 0 1-.031-.027.075.075 0 0 1-.013-.038v.123c.002.013.007.026.015.037s.019.019.031.025l.6.348-.002-.121z"
            fill="#636363"
        />
        <path
            d="M909.15 359.9a.082.082 0 0 1-.045.061l-.6.348a.235.235 0 0 1-.21 0v.121a.24.24 0 0 0 .21 0l.6-.348a.07.07 0 0 0 .03-.024.067.067 0 0 0 .014-.035l.001-.123z"
            fill="#3D3D3D"
        />
        <path
            d="m909.36 360.91-.6-.35a.078.078 0 0 1-.029-.025.07.07 0 0 1-.013-.035v.118a.077.077 0 0 0 .015.036c.008.011.019.02.031.026l.6.35-.004-.12z"
            fill="#636363"
        />
        <path
            d="M910.21 360.51c0 .02-.012.04-.044.059l-.601.349c-.032.017-.068.025-.104.025s-.072-.008-.104-.025v.12c.032.016.068.025.104.025s.072-.009.104-.025l.601-.35a.07.07 0 0 0 .044-.059v-.119z"
            fill="#3D3D3D"
        />
        <path
            d="m910.41 361.52-.6-.353a.067.067 0 0 1-.043-.06v.122c0 .013.005.025.012.036.008.01.019.018.031.023l.6.351v-.119z"
            fill="#636363"
        />
        <path
            d="M911.26 361.12a.056.056 0 0 1-.013.035.062.062 0 0 1-.03.023l-.6.351c-.032.015-.068.022-.104.022s-.071-.007-.104-.022v.119a.233.233 0 0 0 .208 0l.6-.351a.068.068 0 0 0 .03-.023.07.07 0 0 0 .012-.034l.001-.12z"
            fill="#3D3D3D"
        />
        <path
            d="m911.46 362.13-.605-.35a.085.085 0 0 1-.029-.024.078.078 0 0 1-.013-.036v.12a.078.078 0 0 0 .013.036.08.08 0 0 0 .03.025l.6.348.004-.119z"
            fill="#636363"
        />
        <path
            d="M912.32 361.72c-.002.013-.006.025-.013.036s-.017.02-.028.027l-.6.347c-.032.016-.068.025-.104.025s-.072-.009-.104-.025v.119a.224.224 0 0 0 .21 0l.6-.346c.027-.019.043-.037.043-.062l-.004-.121z"
            fill="#3D3D3D"
        />
        <path
            d="m915.54 360.82-.6-.35a.07.07 0 0 1-.044-.059v.119a.09.09 0 0 0 .013.038c.008.011.019.02.031.026l.6.346v-.12z"
            fill="#636363"
        />
        <path
            d="M916.4 360.42a.07.07 0 0 1-.014.036.073.073 0 0 1-.03.025l-.6.348a.23.23 0 0 1-.207 0v.12a.223.223 0 0 0 .208 0l.6-.346a.069.069 0 0 0 .03-.026.063.063 0 0 0 .012-.037l.001-.12z"
            fill="#3D3D3D"
        />
        <path
            d="m914.54 361.49-.6-.347a.106.106 0 0 1-.029-.027.082.082 0 0 1-.013-.037v.123a.071.071 0 0 0 .013.034c.008.01.018.017.029.022l.6.352v-.12z"
            fill="#636363"
        />
        <path
            d="M915.4 361.07a.093.093 0 0 1-.014.036.083.083 0 0 1-.03.026l-.6.347a.223.223 0 0 1-.105.025.222.222 0 0 1-.104-.025v.12a.234.234 0 0 0 .209 0l.6-.352a.065.065 0 0 0 .043-.056l.001-.121z"
            fill="#3D3D3D"
        />
        <path
            d="m913.53 362.12-.6-.349a.073.073 0 0 1-.031-.024.073.073 0 0 1-.015-.035v.117c0 .024.017.043.044.062l.606.349-.004-.12z"
            fill="#636363"
        />
        <path
            d="M914.38 361.71a.063.063 0 0 1-.013.035.07.07 0 0 1-.03.024l-.6.349a.223.223 0 0 1-.209 0v.12a.226.226 0 0 0 .105.025.222.222 0 0 0 .104-.025l.6-.349c.029-.019.043-.038.043-.06v-.119z"
            fill="#3D3D3D"
        />
        <path
            d="m912.52 362.74-.606-.348a.073.073 0 0 1-.029-.026.072.072 0 0 1-.013-.037v.12a.072.072 0 0 0 .013.037c.007.011.017.02.029.026l.6.349.006-.121z"
            fill="#636363"
        />
        <path
            d="M913.37 362.33a.078.078 0 0 1-.015.035.078.078 0 0 1-.029.025l-.6.348a.223.223 0 0 1-.208 0v.121a.247.247 0 0 0 .209 0l.6-.349a.086.086 0 0 0 .029-.025.08.08 0 0 0 .011-.036l.003-.119z"
            fill="#3D3D3D"
        />
        <path
            d="m904.19 359.09-.6-.352a.07.07 0 0 1-.029-.025.07.07 0 0 1-.013-.035v.119a.069.069 0 0 0 .013.036c.007.01.017.018.029.024l.6.351v-.118z"
            fill="#636363"
        />
        <path
            d="M905.04 358.67a.065.065 0 0 1-.013.035.07.07 0 0 1-.029.025l-.6.35a.248.248 0 0 1-.21 0v.117a.235.235 0 0 0 .21 0l.6-.35c.03-.017.042-.035.043-.056l-.001-.121z"
            fill="#3D3D3D"
        />
        <path
            d="m905.2 359.66-.609-.346a.075.075 0 0 1-.027-.026.073.073 0 0 1-.012-.035v.119a.077.077 0 0 0 .012.036c.006.011.016.02.027.027l.609.347v-.122z"
            fill="#636363"
        />
        <path
            d="M906.05 359.25a.066.066 0 0 1-.013.036.08.08 0 0 1-.03.025l-.6.346a.22.22 0 0 1-.208 0v.122a.237.237 0 0 0 .208 0l.6-.349a.084.084 0 0 0 .043-.063v-.117z"
            fill="#3D3D3D"
        />
        <path
            d="m906.25 360.27-.605-.349a.084.084 0 0 1-.028-.025.082.082 0 0 1-.015-.036v.119a.07.07 0 0 0 .043.06l.605.351v-.12z"
            fill="#636363"
        />
        <path
            d="M907.11 359.86a.093.093 0 0 1-.014.036.099.099 0 0 1-.029.025l-.6.349a.23.23 0 0 1-.207 0v.12a.246.246 0 0 0 .207 0l.6-.351a.068.068 0 0 0 .029-.024.07.07 0 0 0 .014-.036v-.119z"
            fill="#3D3D3D"
        />
        <path
            d="m911.53 363.32-4.822-2.785c-.031-.019-.046-.039-.046-.061v.119a.073.073 0 0 0 .014.037.073.073 0 0 0 .03.025l4.824 2.786v-.121zM916.6 361.44l-.608-.35a.07.07 0 0 1-.041-.061v.121a.083.083 0 0 0 .014.035.07.07 0 0 0 .03.024l.606.35-.001-.119z"
            fill="#636363"
        />
        <path
            d="M917.45 361.02a.073.073 0 0 1-.043.061l-.599.35a.25.25 0 0 1-.207 0v.119c.032.016.068.025.104.025s.072-.009.104-.025l.601-.35c.011-.005.021-.013.028-.023s.011-.023.012-.035v-.122z"
            fill="#3D3D3D"
        />
        <path
            d="m917.66 362.04-.6-.348c-.012-.006-.022-.015-.03-.026s-.013-.024-.014-.037v.122c0 .013.005.025.013.036.008.01.018.018.031.022l.6.351v-.12z"
            fill="#636363"
        />
        <path
            d="M918.51 361.63a.078.078 0 0 1-.013.036.091.091 0 0 1-.03.025l-.6.348a.234.234 0 0 1-.209 0v.12a.23.23 0 0 0 .21 0l.6-.351a.064.064 0 0 0 .029-.022.062.062 0 0 0 .013-.034v-.122z"
            fill="#3D3D3D"
        />
        <path
            d="m919.76 363.26-1.659-.959a.078.078 0 0 1-.03-.024.072.072 0 0 1-.013-.037v.12a.066.066 0 0 0 .013.036.07.07 0 0 0 .032.024l1.66.96-.003-.12z"
            fill="#636363"
        />
        <path
            d="M920.62 362.85a.098.098 0 0 1-.014.037.094.094 0 0 1-.03.026l-.6.347a.224.224 0 0 1-.209 0v.12a.24.24 0 0 0 .209 0l.6-.349a.083.083 0 0 0 .03-.026.076.076 0 0 0 .014-.036v-.119z"
            fill="#3D3D3D"
        />
        <path
            d="m915.6 362.09-.6-.348c-.029-.02-.045-.038-.045-.062v.12a.098.098 0 0 0 .014.037c.008.011.018.02.029.027l.6.346.002-.12z"
            fill="#636363"
        />
        <path
            d="M916.45 361.68a.078.078 0 0 1-.013.036.08.08 0 0 1-.03.025l-.6.349a.239.239 0 0 1-.211 0v.12a.234.234 0 0 0 .209 0l.6-.346a.083.083 0 0 0 .03-.026.08.08 0 0 0 .012-.037l.003-.121z"
            fill="#3D3D3D"
        />
        <path
            d="m916.66 362.7-.607-.348a.091.091 0 0 1-.03-.025.093.093 0 0 1-.014-.036v.118a.082.082 0 0 0 .013.038.08.08 0 0 0 .031.027l.6.348.007-.122z"
            fill="#636363"
        />
        <path
            d="M917.51 362.3c0 .021-.015.04-.045.058l-.6.348a.222.222 0 0 1-.104.025.226.226 0 0 1-.105-.025v.122a.243.243 0 0 0 .213 0l.6-.348c.029-.019.045-.039.045-.06l-.004-.12z"
            fill="#3D3D3D"
        />
        <path
            d="m917.71 363.31-.6-.349a.07.07 0 0 1-.03-.024.067.067 0 0 1-.014-.036v.119a.09.09 0 0 0 .013.038.084.084 0 0 0 .031.025l.6.349v-.122z"
            fill="#636363"
        />
        <path
            d="M918.56 362.9a.07.07 0 0 1-.043.059l-.6.349a.235.235 0 0 1-.209 0v.122a.232.232 0 0 0 .207 0l.6-.349a.076.076 0 0 0 .043-.059l.002-.122z"
            fill="#3D3D3D"
        />
        <path
            d="m918.76 363.92-.6-.348a.086.086 0 0 1-.031-.026.093.093 0 0 1-.014-.038v.121a.087.087 0 0 0 .013.035c.008.011.017.02.028.026l.6.348.004-.118z"
            fill="#636363"
        />
        <path
            d="M919.62 363.51c0 .022-.016.043-.046.062l-.6.348a.256.256 0 0 1-.211 0v.118a.24.24 0 0 0 .211 0l.6-.348c.03-.019.044-.037.044-.061l.002-.119z"
            fill="#3D3D3D"
        />
        <path
            d="m914.59 362.73-.606-.349a.081.081 0 0 1-.031-.024.07.07 0 0 1-.014-.036v.119a.082.082 0 0 0 .013.037.09.09 0 0 0 .029.026l.609.349v-.122z"
            fill="#636363"
        />
        <path
            d="M915.44 362.32a.07.07 0 0 1-.013.035.086.086 0 0 1-.029.025l-.6.349c-.032.017-.068.025-.104.025s-.071-.008-.103-.025v.122a.233.233 0 0 0 .207 0l.6-.347a.079.079 0 0 0 .029-.025.082.082 0 0 0 .015-.036l-.002-.123z"
            fill="#3D3D3D"
        />
        <path
            d="m915.64 363.34-.6-.351a.073.073 0 0 1-.045-.06v.121c0 .022.014.042.045.061l.6.349v-.12z"
            fill="#636363"
        />
        <path
            d="M916.49 362.93a.06.06 0 0 1-.012.036.057.057 0 0 1-.03.023l-.6.351a.231.231 0 0 1-.208 0v.12a.237.237 0 0 0 .208 0l.6-.349a.08.08 0 0 0 .03-.025.078.078 0 0 0 .013-.036l-.001-.12z"
            fill="#3D3D3D"
        />
        <path
            d="m917.75 364.56-1.658-.959a.073.073 0 0 1-.045-.061v.123a.064.064 0 0 0 .014.034.07.07 0 0 0 .03.024l1.659.959v-.12z"
            fill="#636363"
        />
        <path
            d="M918.6 364.15a.079.079 0 0 1-.013.035.08.08 0 0 1-.029.023l-.6.35c-.032.016-.068.025-.104.025s-.072-.009-.104-.025v.12a.223.223 0 0 0 .208 0l.6-.348a.08.08 0 0 0 .03-.025.08.08 0 0 0 .012-.037v-.118z"
            fill="#3D3D3D"
        />
        <path
            d="m913.57 363.35-.606-.347a.07.07 0 0 1-.029-.025.069.069 0 0 1-.013-.036v.121a.078.078 0 0 0 .013.036c.007.01.017.019.029.025l.606.349v-.123z"
            fill="#636363"
        />
        <path
            d="M914.43 362.94a.07.07 0 0 1-.043.059l-.6.347a.228.228 0 0 1-.212 0v.123a.256.256 0 0 0 .211 0l.6-.349a.067.067 0 0 0 .03-.025.066.066 0 0 0 .013-.036l.001-.119z"
            fill="#3D3D3D"
        />
        <path
            d="m914.63 363.96-.6-.352a.068.068 0 0 1-.031-.022.07.07 0 0 1-.014-.036v.12c0 .023.014.043.045.06l.6.349v-.119z"
            fill="#636363"
        />
        <path
            d="M915.48 363.55a.07.07 0 0 1-.041.059l-.6.351a.229.229 0 0 1-.21 0v.119c.032.018.068.027.105.027s.073-.009.105-.027l.6-.347c.027-.019.041-.038.041-.058v-.124z"
            fill="#3D3D3D"
        />
        <path
            d="m916.74 365.18-1.658-.959a.069.069 0 0 1-.043-.059v.119a.069.069 0 0 0 .013.036.064.064 0 0 0 .03.024l1.658.958v-.119z"
            fill="#636363"
        />
        <path
            d="M917.59 364.77a.079.079 0 0 1-.043.062l-.6.344a.212.212 0 0 1-.208 0v.119a.212.212 0 0 0 .208 0l.6-.348a.068.068 0 0 0 .03-.023.074.074 0 0 0 .012-.036l.001-.118z"
            fill="#3D3D3D"
        />
        <path
            d="m912.58 363.93-.6-.347c-.031-.02-.045-.04-.045-.063v.119c0 .013.004.026.012.036.008.011.02.018.033.022l.6.353v-.12z"
            fill="#636363"
        />
        <path
            d="M913.43 363.52a.079.079 0 0 1-.013.035.096.096 0 0 1-.027.026l-.6.347a.234.234 0 0 1-.209 0v.12a.224.224 0 0 0 .209 0l.6-.353a.057.057 0 0 0 .03-.023.057.057 0 0 0 .012-.035l-.002-.117z"
            fill="#3D3D3D"
        />
        <path
            d="m913.63 364.54-.6-.349c-.012-.006-.023-.015-.031-.026s-.013-.024-.015-.038v.121c.001.014.006.026.014.037s.02.019.032.024l.6.348v-.117z"
            fill="#636363"
        />
        <path
            d="M914.49 364.13a.078.078 0 0 1-.013.036.096.096 0 0 1-.029.024l-.6.351a.242.242 0 0 1-.211 0v.117a.224.224 0 0 0 .211 0l.6-.348a.07.07 0 0 0 .044-.059l-.002-.121z"
            fill="#3D3D3D"
        />
        <path
            d="M914.44 364.07c.058.034.058.087 0 .121l-.6.351a.256.256 0 0 1-.105.024.257.257 0 0 1-.106-.024l-.6-.349c-.057-.036-.057-.089 0-.123l.6-.351a.237.237 0 0 1 .208 0l.603.351z"
            fill="#4A4A4A"
        />
        <path
            d="m915.74 365.76-1.661-.959a.092.092 0 0 1-.029-.023.085.085 0 0 1-.014-.034v.12a.095.095 0 0 0 .014.035c.008.01.018.018.029.024l1.661.959v-.122z"
            fill="#636363"
        />
        <path
            d="M916.6 365.35c0 .025-.015.042-.043.061l-.6.348a.24.24 0 0 1-.21 0v.122a.223.223 0 0 0 .208 0l.6-.351c.028-.02.043-.037.043-.058l.002-.122zM908.12 359.28a.067.067 0 0 1-.014.036.067.067 0 0 1-.03.025l-.6.351a.255.255 0 0 1-.209 0v.117a.234.234 0 0 0 .209 0l.6-.346a.064.064 0 0 0 .029-.025.066.066 0 0 0 .013-.036l.002-.122z"
            fill="#3D3D3D"
        />
        <path
            d="m920.84 364.21.011.264-.6.385-.013-.265.602-.384zM921.75 363.65l.016.268-.6.383-.011-.265.595-.386z"
            fill="#393939"
        />
        <path
            d="m921.7 363.89-.546.346-.009-.2.545-.348.01.202zM920.8 364.44l-.55.352-.011-.2.553-.353.008.201z"
            fill="#000"
        />
        <path
            d="M901.51 358.44s3.009-.676 3.569-.773a7.444 7.444 0 0 1 3.156.773l1.276 1.178s.168.265-.289.365-1.145-.724-1.145-.724l-1.338-.385s-.862-.03-.893.384c-.024.315.719.479 1.04.533.219.037.706.184.791.408a.374.374 0 0 1-.167.484 5.272 5.272 0 0 1-1.207-.146c-.819-.146-1.432-.177-1.9-.267a1.869 1.869 0 0 1-1.036-.6l-1.5.385-.357-1.615z"
            fill="#FFE1CC"
        />
        <path
            d="M890.8 353.03s-2.7-.225-2.829 3.182a25.85 25.85 0 0 0 2.313 5.75 3.408 3.408 0 0 0 3.536 1.366c1.87-.286 8.969-2.458 8.969-2.458s.351-.385-.067-1.574a1.626 1.626 0 0 0-.8-1l-7.746.8-3.376-6.066z"
            fill="#3D5A72"
        />
        <path
            d="m893.95 359.67 1.46-.829 1.124.652-1.423.829-1.161-.652z"
            fill="#995710"
        />
        <path
            d="m897.64 343.81 2.815.609-1.872 7.218c-.495 2.078-1.435 2.24-2.072 2.135a7.727 7.727 0 0 1-3.321-1.792c-1.284-1.1-.82-3.547-.795-3.748l.4-4.969 4.845.547z"
            fill="#FFE1CC"
        />
        <path
            d="m891.33 353.24 1.177-4.345 3.634 1.207-.877 4.245c-.059.61 1.774 6.1 1.6 7.994l-6.805-2.9c.069-.813 1.271-6.201 1.271-6.201z"
            fill="#FFE1CC"
        />
        <path
            d="M899.98 343.33c1.442 1.15 1.141 2.444-.1 3.184a4.225 4.225 0 0 0-1.408 2.145l-.231.751c-.037.285-.483.633-.615.188-.15-.5.246-.788.082-1.058s-.73-.456-1.548 1.018l-.5 1.162a2 2 0 0 1-2.692.867 3.481 3.481 0 0 1-1.134-.831 17.503 17.503 0 0 1-1.177-3.142c-.658-3.709 1.621-7.9 6.891-5.771a9.035 9.035 0 0 1 2.432 1.487z"
            fill="#633A11"
        />
        <path
            d="M897.73 347.72a1.075 1.075 0 0 0-.9.678 1.237 1.237 0 0 0 0 1.031c.104.196.267.355.465.455 0 0 .144-1.169.185-1.384.067-.265.151-.525.25-.78z"
            fill="#EFCFBD"
        />
        <path
            d="M898.05 347.5s.343.027.038.485a2.47 2.47 0 0 0-.448 1.023c-.042.252-.08 1.019-.08 1.019s-.254.283-.4-.205a3.068 3.068 0 0 1 0-1.2c.031-.215.532-1.281.89-1.122z"
            fill="#FFE8D9"
        />
        <path
            d="M897.5 357.75c.741.921.972 1.886.694 4.86l-.754 11.4a4.199 4.199 0 0 1-2.458 3.616 6.818 6.818 0 0 1-4.916.291c-.742-.328-4.13-2.657-4.03-3.745l1.385-15.281c.606-5.156 3.649-5.971 3.649-5.971l3.426 1.563 3.004 3.267z"
            fill="#4D6B89"
        />
        <path
            d="M891.85 351.96c-.488-.164-.619-.089-.745.206a5.55 5.55 0 0 1-.265.589c-.115.231-.008.259-.008.259 1.495.584 2.9 1.377 4.172 2.354 1.237 1.021 1.328 1.116 1.328 1.116l-.214-1.042c-.157-.885-1.081-1.831-2.507-2.624a15.07 15.07 0 0 0-1.761-.858z"
            fill="#E4EFF4"
        />
        <path
            d="M909.44 365.3a18.303 18.303 0 0 1 3.327 0c.914.192 3.615 1.253 3.615 1.253s.77.287.337.772a11.74 11.74 0 0 1-1.06.771c-.242.191-.964.239-2.412-.048a5.312 5.312 0 0 0-1.975-.047 4.788 4.788 0 0 1-1.879-.289l.047-2.412z"
            fill="#FFE1CC"
        />
        <path
            d="M910.5 366.53a3.572 3.572 0 0 1-.446 1.7s-5.765.552-6.543.606a4.183 4.183 0 0 1-2.626-.6c-1.82-.914-5.483-4.9-5.483-4.9s-2.666-2.572-1.537-4.839c.833-1.67 3.022-1.441 4.033-.159.944 1.2 3.085 4.079 4.3 5.517a2.28 2.28 0 0 0 1.816.822l5.336.149a.874.874 0 0 1 .89.32c.213.428.303.908.26 1.384z"
            fill="#688CAA"
        />
        <path d="M912.22 333.33v.85l-8.7 5.059v-.853l8.7-5.056z" fill="#CFCFCF" />
        <path
            d="M903.52 338.38v.853l-17.026-9.834v-.849l17.026 9.83z"
            fill="#9D9D9D"
        />
        <path
            d="m912.22 333.33-8.7 5.056-17.029-9.83 8.7-5.058 17.029 9.832z"
            fill="#E2E2E2"
        />
        <path
            d="m895.73 320.84-.006 6.582-2.193 1.271v-6.579l2.199-1.274z"
            fill="#3581D9"
        />
        <path
            d="M893.54 322.11v6.579l-2.208-1.271v-6.582l2.208 1.274z"
            fill="#4895EF"
        />
        <path
            d="m895.73 320.84-2.2 1.273-2.208-1.273 2.194-1.278 2.214 1.278z"
            fill="#4CC9F0"
        />
        <path
            d="M899.22 317.28v12.248l-2.2 1.274v-12.247l2.2-1.275z"
            fill="#8CC149"
        />
        <path
            d="M897.02 318.55v12.247l-2.206-1.274v-12.248l2.206 1.275z"
            fill="#AAD86F"
        />
        <path
            d="m899.22 317.28-2.2 1.275-2.207-1.275 2.194-1.271 2.213 1.271z"
            fill="#C7F08F"
        />
        <path
            d="M902.78 322.03v9.563l-2.2 1.273v-9.562l2.2-1.274z"
            fill="#65149A"
        />
        <path
            d="M900.58 323.31v9.562l-2.208-1.273v-9.563l2.208 1.274z"
            fill="#7209B7"
        />
        <path
            d="m902.78 322.03-2.2 1.274-2.208-1.274 2.194-1.277 2.214 1.277z"
            fill="#9133D0"
        />
        <path
            d="M906.84 315.77v18.139l-2.193 1.272v-18.136l2.193-1.275z"
            fill="#D3176D"
        />
        <path
            d="M904.64 317.05v18.136l-2.21-1.272v-18.139l2.21 1.275z"
            fill="#F72585"
        />
        <path
            d="m906.84 315.77-2.194 1.275-2.209-1.275 2.2-1.274 2.203 1.274z"
            fill="#F856A0"
        />
        <path
            d="m932.86 363.19 6.814-3.944a.367.367 0 0 0-.154.338c.009.219.082.43.211.608a1.066 1.066 0 0 0 .312.301l-6.813 3.945a.968.968 0 0 1-.311-.302 1.092 1.092 0 0 1-.214-.607.375.375 0 0 1 .155-.339z"
            fill="#C6C6C6"
        />
        <path
            d="m933.63 363.46 6.813-3.945v-.1l-6.812 3.945-.001.1z"
            fill="#878787"
        />
        <path
            d="M939.61 359.14a.437.437 0 0 1 .439.042l.392.228-6.813 3.945-.39-.228a.432.432 0 0 0-.441-.041l6.813-3.946zM941.79 369.38l6.814-3.943-8.559-4.939-6.813 3.945 8.558 4.937z"
            fill="#F2F2F2"
        />
        <path
            d="m941.79 369.49 6.814-3.946v-.106l-6.814 3.943v.109z"
            fill="#878787"
        />
        <path
            d="M933.24 363.13c-.344-.2-.623-.037-.623.355a1.365 1.365 0 0 0 .616 1.066l8.557 4.942v-.11l-8.557-4.937a1.16 1.16 0 0 1-.525-.909c0-.333.24-.466.53-.3l.392.227v-.1l-.39-.234z"
            fill="#BCBCBC"
        />
        <path
            d="M935.51 364.72c-.078.046-.042.14.081.212a.437.437 0 0 0 .367.049l2.167-1.253 1.557-.895c.077-.047.04-.143-.086-.215a.433.433 0 0 0-.361-.047l-1.557.9-2.168 1.249zM939.49 366.87c-.1.057-.083.164.037.234a.457.457 0 0 0 .408.027l2.774-1.6 1.995-1.15c.1-.057.081-.165-.044-.233a.457.457 0 0 0-.4-.027l-1.995 1.149-2.775 1.6zM938.37 366.31c-.079.044-.038.141.083.211a.426.426 0 0 0 .364.048l2.127-1.228 1.527-.882c.074-.044.039-.137-.085-.209a.426.426 0 0 0-.36-.048l-1.528.881-2.128 1.227zM937.38 365.69c-.112.064-.1.174.026.242a.468.468 0 0 0 .42.02l3.022-1.745 2.171-1.255c.1-.061.093-.17-.03-.244a.488.488 0 0 0-.418-.015l-2.172 1.254-3.019 1.743zM936.44 365.17c-.1.057-.08.164.042.236a.443.443 0 0 0 .4.024l2.776-1.6 1.994-1.154c.1-.057.078-.163-.043-.235a.472.472 0 0 0-.4-.025l-1.995 1.152-2.774 1.602zM934.71 364.22c-.11.066-.1.173.023.248a.482.482 0 0 0 .423.012l3.02-1.742 2.171-1.254c.107-.064.1-.174-.028-.244a.453.453 0 0 0-.417-.015l-2.172 1.25-3.02 1.745z"
            fill="#838383"
        />
        <path
            d="M946.89 364.87a.538.538 0 0 1-.005 1.017 1.968 1.968 0 0 1-1.761 0 .537.537 0 0 1-.357-.513.538.538 0 0 1 .365-.506 1.944 1.944 0 0 1 1.758.002zm-.068.98a.502.502 0 0 0 .005-.945 1.787 1.787 0 0 0-1.634 0 .5.5 0 0 0-.006.945 1.788 1.788 0 0 0 1.635 0z"
            fill="#B84F4F"
        />
        <path
            d="m945.89 365.42.061.039.275-.163-.061-.037-.275.161zM945.39 364.97l.063.032a1.28 1.28 0 0 1 .467-.116v-.05a1.318 1.318 0 0 0-.53.134zM945.3 365.02a.503.503 0 0 0-.224.284h.087a.457.457 0 0 1 .2-.247l-.063-.037zM946.1 365.87v.048a1.32 1.32 0 0 0 .533-.138l-.063-.035a1.208 1.208 0 0 1-.47.125zM945.07 365.38a.318.318 0 0 0 .029.139l.081-.012a.345.345 0 0 1-.024-.127h-.086zM946.04 364.84v.05c.076.001.151.009.225.022l.018-.047a1.517 1.517 0 0 0-.243-.025zM946.85 365.25c.018.04.027.084.028.128h.085a.41.41 0 0 0-.029-.139l-.084.011zM945.46 365.66l.062.039.352-.209-.06-.031-.354.201z"
            fill="#B84F4F"
        />
        <path
            d="m946.88 365.14-1.307.759-.442-.257 1.308-.757.441.255zm-1.307.688 1.183-.688-.317-.182-1.186.684.32.186z"
            fill="#B84F4F"
        />
        <path
            d="m946.23 365.22.06.033.255-.145-.061-.034-.254.146zM946.85 365.46a.45.45 0 0 1-.19.245l.061.038a.49.49 0 0 0 .216-.283h-.087zM945.76 365.85l-.023.051c.081.014.163.02.245.02v-.045a1.865 1.865 0 0 1-.222-.026z"
            fill="#B84F4F"
        />
        <path
            d="M959.84 395.47c-.272.364-.675.61-1.124.686-.5.105-2.128.306-2.128.306-.81.1-1.792.358-1.946 1.152a2.56 2.56 0 0 0-.026.532c.1.444.532.619 1.061.807.58.202 1.172.365 1.773.489.789.17 1.604.188 2.4.051.448-.08.899-.136 1.353-.168.431 0 .359.313.408.717l1.37.355a2.095 2.095 0 0 0 2.237-1.368l-.369-3.01-5.009-.549z"
            fill="#545454"
        />
        <path
            d="M960.73 399.26a10.53 10.53 0 0 1-2.527.1 15.606 15.606 0 0 1-2.685-.721c-.465-.166-.862-.453-.9-.717a1.246 1.246 0 0 0 0 .259c.1.446.535.623 1.062.809.58.204 1.172.368 1.774.491a6.365 6.365 0 0 0 2.406.048l1.145-.162c.254-.037.506.03.51.074-.001-.017-.106-.249-.785-.181zM962.91 399.86l-1.355-.354c.015.132.046.447.06.577l1.372.358a2.092 2.092 0 0 0 2.236-1.371l-.076-.575a2.094 2.094 0 0 1-2.237 1.365z"
            fill="#383736"
        />
        <path
            d="M962.74 392.47a1.016 1.016 0 0 1-.879.864c-.479.04-1.164.062-1.164.062-.812-.154-1.831-.139-2.018.467-.043.117-.068.24-.074.365.043.447-.115.074.5.618.594.45 1.221.854 1.876 1.208a3.042 3.042 0 0 0 1.653.409c.312-.062.63-.085.946-.068.4.048.3.558.3.957l1.243.512a1.965 1.965 0 0 0 2.253-1.066v-3.193l-4.636-1.135z"
            fill="#545454"
        />
        <path
            d="M963.13 396.28a7.318 7.318 0 0 1-1.8-.356 9.662 9.662 0 0 1-2.149-1.133 1.163 1.163 0 0 1-.552-.769c-.015.085-.024.17-.029.257-.028.407.33.628.621.834a8.01 8.01 0 0 0 1.75.995 3.982 3.982 0 0 0 1.554.3l.918.044c.163.005.391.1.391.147-.007-.026-.061-.305-.704-.319zM965.12 397.51l-1.233-.51c0 .132-.01.269-.01.4l1.243.516a1.965 1.965 0 0 0 2.253-1.071v-.4a1.96 1.96 0 0 1-2.253 1.065z"
            fill="#383736"
        />
        <path
            d="M966.92 376.01c-.027.555-.8.886-1.3.859-.176-.008-.334 1.028-.611 1.4a.454.454 0 0 1-.379.206.466.466 0 0 1-.384-.199c.165-.671.37-1.331.613-1.978.4-1.275.926-1.3 1.431-1.271s.654.43.63.983z"
            fill="#FFE8D9"
        />
        <path
            d="M966.83 374.87c.568 0 1.671-1.082 1.671-1.082s.025-.14.065-.388c.232-1.384 1.28-6.115 1.338-7.86a63.04 63.04 0 0 0-.7-6.992s-.341-4.29-3.247-4.169c-1.756.073-.842 2.591-.86 4.13-.014 1.208.607 7.352.607 7.352l-.388 7.548s.402 1.451 1.514 1.461z"
            fill="#38556D"
        />
        <path
            d="m967.6 375.11-1.458-.091-.638 1.7-.013.285.113 2.272a1.13 1.13 0 0 0 .319.82 1.14 1.14 0 0 0 .81.345c.757.048.082.006.082.006 1.039.064 1.187-1.054 1.187-1.054l.414-2.9c.047-.623-.148-1.345-.816-1.383z"
            fill="#FFE8D9"
        />
        <path
            d="M965.02 375.07c-.006.256.553.757 1.3.835.477.075.964.047 1.43-.081.45-.152.7-.328.737-.645 0 0 .148-1.171.175-1.54.022-.239-.1-.242-.1-.242-.009.088-.03.175-.061.258-.148.248-.567.576-1.52.6-1.5.036-1.671-.85-1.671-.85-.217 0-.291.094-.282.346l-.008 1.319z"
            fill="#E4EFF4"
        />
        <path
            d="M968.04 375.15s.683-3.2-3.279-3.2c-3.136 0-3.136 3.331-3.136 3.331l1.583 19.184h3.92l.912-19.315z"
            fill="#E8C5AC"
        />
        <path
            d="m960.25 345.15-2.692.33 1.126 6.926c.285 1.988 1.153 2.223 1.76 2.178a7.232 7.232 0 0 0 3.263-1.39c1.3-.916 1.078-3.253 1.076-3.444l.054-4.691-4.587.091z"
            fill="#FFE1CC"
        />
        <path
            d="m965.35 354.53-.727-4.173-3.507.815.452 4.054c0 .576-2.192 5.562-2.192 7.353l6.629-2.129c0-.764-.655-5.92-.655-5.92z"
            fill="#FFE1CC"
        />
        <path
            d="M960.6 370.11v1.835c.043 1.23.151 2.457.324 3.676l6.274.237c.787-.155 1.088-1.235 1.088-2.32v-3.428H960.6z"
            fill="#14546D"
        />
        <path
            d="M968.04 375.15a2.736 2.736 0 0 0-3.024-2.224h-1.089a3.104 3.104 0 0 0-3.011 2.7l1.647 18.76 4.2.079 1.277-19.315z"
            fill="#FFE1CC"
        />
        <path
            d="M958.11 344.49c-1.449.953-1.28 2.2-.181 2.995.59.575.987 1.321 1.135 2.132l.152.726c.01.267.4.633.56.228.182-.452-.163-.76.014-1s.726-.362 1.36 1.089l.367 1.134a1.87 1.87 0 0 0 1.007 1.027 1.874 1.874 0 0 0 1.44.014c.42-.147.806-.378 1.135-.679a16.542 16.542 0 0 0 1.376-2.841c.938-3.419-.833-7.549-5.959-6.005a8.603 8.603 0 0 0-2.406 1.18z"
            fill="#633A11"
        />
        <path
            d="m960.95 373.55.169 21.933a5.926 5.926 0 0 0 3.809 1.33c1.333 0 2.634-.859 2.665-1.23l.793-22.417-7.436.384z"
            fill="#282827"
        />
        <path
            d="m959.15 375.79.387 19.443c-.01-.009-.045.477-.249.589s-.194.522-.091.8a4.285 4.285 0 0 0 4.084 2.244c.815-.039 1.775-.351 1.814-.7l1.334-22.359-7.279-.017z"
            fill="#383736"
        />
        <path
            d="M959.18 358.22c-.775.8-1.077 1.686-1.077 4.5l.269 12.8a1.813 1.813 0 0 0 .856 1.888c.212.125.447.206.691.237a7.852 7.852 0 0 0 4.038-.006c.727-.241 4.535-2 4.535-3.023l.031-14.444c-.118-4.885-2.9-5.914-2.9-5.914l-3.344 1.17-3.099 2.792z"
            fill="#4D6B89"
        />
        <path
            d="M964.97 353.29c.471-.113.59-.032.681.256.054.196.121.389.2.576.089.226-.018.241-.018.241a16.074 16.074 0 0 0-4.112 1.846c-1.247.849-1.345.93-1.345.93l.293-.956a4.298 4.298 0 0 1 2.577-2.243c.56-.253 1.136-.47 1.724-.65z"
            fill="#E4EFF4"
        />
        <path
            d="m947.18 366.09.393-1.691-.191-.415-2.407-.8-2.706.016s-.551 0-.551.4c0 .215.518.252 1.653.215.536-.015.351.353.351.353a3.516 3.516 0 0 0 0 1.956.937.937 0 0 0 1.085.464c.054-.02.052-.213.052-.213 1.119.316 2.18.471 2.321-.285z"
            fill="#FFE8D9"
        />
        <path
            d="M959.83 348.8a1.005 1.005 0 0 1 .783.716 1.175 1.175 0 0 1-.081.967 1.037 1.037 0 0 1-.479.386s-.034-1.11-.051-1.313a7.25 7.25 0 0 0-.172-.756z"
            fill="#EFCFBD"
        />
        <path
            d="M959.55 348.57s-.326 0-.076.453c.186.303.298.646.328 1 .018.236-.015.961-.015.961s.214.284.4-.159a2.86 2.86 0 0 0 .1-1.119c-.011-.215-.388-1.255-.737-1.136z"
            fill="#FFE8D9"
        />
        <path
            d="M946.18 365.26a3.41 3.41 0 0 0 .272 1.635s5.354 1.014 6.08 1.132a3.935 3.935 0 0 0 2.51-.334c1.787-.7 5.565-4.112 5.565-4.112s2.723-2.177 1.861-4.4a2.25 2.25 0 0 0-3.766-.5c-.988 1.037-3.243 3.552-4.51 4.8a2.144 2.144 0 0 1-1.774.61l-5.011-.327a.848.848 0 0 0-.866.23 2.44 2.44 0 0 0-.361 1.266z"
            fill="#688CAA"
        />
        <path
            d="M955.46 357.17a.073.073 0 0 0 .029-.026.072.072 0 0 0 .013-.038v-1.642a.075.075 0 0 1-.012.039.071.071 0 0 1-.03.027v1.64z"
            fill="#49240B"
        />
        <path
            d="M947.36 351.26v1.623l7.76 4.482v-1.621l-7.76-4.484z"
            fill="#271306"
        />
        <path
            d="m947.36 351.25 7.738 4.5.362-.211c.061-.034.061-.09 0-.121l-7.523-4.377a.254.254 0 0 0-.216 0l-.361.209z"
            fill="#271306"
        />
        <path
            d="m941.39 356.19 7.371 4.282a.395.395 0 0 0 .369 0v.354a.41.41 0 0 1-.368 0l-7.37-4.284c-.022-.009-.04-.024-.054-.043s-.022-.041-.024-.064v-.35c.002.022.01.044.024.062a.128.128 0 0 0 .052.043z"
            fill="#532C12"
        />
        <path
            d="M941.39 355.98a.118.118 0 0 0-.055.041.117.117 0 0 0-.021.065.11.11 0 0 0 .076.106l7.371 4.282a.398.398 0 0 0 .369 0l5.971-3.447-7.738-4.5-5.973 3.453z"
            fill="#451E03"
        />
        <path
            d="M948.97 359.14v1.235l5.922-3.464v-1.234l-5.922 3.463z"
            fill="#B1B2B4"
        />
        <path
            d="M941.71 355.07v1.107l7.263 4.2v-1.235l-7.263-4.072z"
            fill="#C6C7C9"
        />
        <path
            d="m949.03 359.09 5.692-3.354-5.858-3.348-5.861 3.362 6.027 3.34z"
            fill="#7B7C7D"
        />
        <path
            d="M955.1 356.2a.057.057 0 0 0-.008-.028.058.058 0 0 0-.049-.027c-.01 0-.02.003-.028.008l-5.886 3.4v-.353l6.337-3.662v1.64l-6.336 3.656v-.358l5.922-3.421a.085.085 0 0 0 .049-.079l-.001-.776z"
            fill="#391F0C"
        />
        <path
            d="m941.39 354.91 7.371 4.283a.418.418 0 0 0 .368 0v.352a.387.387 0 0 1-.183.045.388.388 0 0 1-.183-.043l-7.369-4.284c-.05-.03-.079-.065-.079-.1v-.354a.145.145 0 0 0 .025.06c.013.017.03.031.05.041z"
            fill="#532C12"
        />
        <path
            d="M941.39 354.7a.118.118 0 0 0-.055.041.116.116 0 0 0 0 .13.112.112 0 0 0 .055.041l7.373 4.283a.416.416 0 0 0 .366 0l5.974-3.447-7.738-4.5-5.975 3.452z"
            fill="#5C3114"
        />
        <path
            d="m950.67 358.93-.557.344 1.068.613-.2-.449.616.079-.927-.587z"
            fill="#FC6363"
        />
        <path
            d="m950.99 359.44.616.079v.086l-.578-.074-.038-.091zM951.19 359.88v.086l-1.068-.613v-.086l1.068.613z"
            fill="#E53535"
        />
        <path
            d="m837.91 345.37-1.367-.792.386-.221 1.366.793-.385.22zM836.99 345.46l-1.365-.793a.918.918 0 0 0 .913-.088l1.367.792a.903.903 0 0 1-.915.089zM836.61 346.13l-1.364-.795a1.276 1.276 0 0 1-.536-1.172l1.366.793a1.292 1.292 0 0 0 .534 1.174z"
            fill="#606060"
        />
        <path d="m836.07 344.96-1.365-.793v-.9l1.366.793-.001.9z" fill="#606060" />
        <path
            d="m836.07 344.05-1.366-.793.55-.317 1.366.793-.55.317z"
            fill="#2B2B2B"
        />
        <path
            d="M836.62 343.74v.9c0 .817.58 1.144 1.288.736l.385-.22v.633l-.385.214c-1.009.585-1.838.118-1.839-1.044v-.9l.551-.319z"
            fill="#272727"
        />
        <path
            d="M838.79 344.13a.24.24 0 0 0-.079.094.25.25 0 0 0-.021.121v1.556l1.98-1.15v-1.558a.235.235 0 0 1 .021-.12.235.235 0 0 1 .079-.092l-1.98 1.149z"
            fill="#818182"
        />
        <path
            d="M839.22 330.07a2.63 2.63 0 0 1 1.219 2.482l-.252 1.077c-.124.522-.185 4.085-.187 4.693l-.017 5.624c0 .421-.3.59-.662.378l-.287-.165c-.184-.1-.332-.022-.332.19v1.556l-6.4-3.694a.323.323 0 0 1-.162-.281v-1.369a.717.717 0 0 0-.329-.571l-.285-.164a1.456 1.456 0 0 1-.661-1.142l.016-5.627c0-.608-.058-4.243-.177-4.9l-.245-1.365c-.183-1.013.416-1.537 1.231-1.068l7.53 4.346z"
            fill="#ADADAD"
        />
        <path
            d="m841.2 328.92-7.531-4.346a.894.894 0 0 0-.894-.09l-1.979 1.151a.89.89 0 0 1 .9.089l7.529 4.348a2.63 2.63 0 0 1 1.219 2.482l-.252 1.077c-.124.522-.185 4.085-.187 4.693l-.017 5.624a.464.464 0 0 1-.037.238.461.461 0 0 1-.154.185l1.98-1.149a.468.468 0 0 0 .194-.424l.014-5.628c0-.6.065-4.169.187-4.69l.251-1.075a2.638 2.638 0 0 0-1.223-2.485z"
            fill="#969696"
        />
        <path
            d="m890.74 381.34-1.365-.793.385-.218 1.364.793-.384.218zM889.82 381.43l-1.363-.795a.906.906 0 0 0 .912-.088l1.366.793a.913.913 0 0 1-.915.09zM889.43 382.1l-1.365-.8a1.282 1.282 0 0 1-.535-1.172l1.366.79c-.023.226.015.454.109.66.093.207.24.386.425.518v.004z"
            fill="#606060"
        />
        <path d="m888.9 380.92-1.366-.79v-.906l1.365.795.001.901z" fill="#606060" />
        <path
            d="m888.89 380.02-1.365-.795.549-.315 1.365.792-.549.318z"
            fill="#2B2B2B"
        />
        <path
            d="M889.44 379.7v.906c0 .81.58 1.14 1.289.731l.383-.217v.632l-.386.217c-1.007.582-1.833.114-1.837-1.05v-.9l.551-.319z"
            fill="#272727"
        />
        <path
            d="M891.62 380.1a.227.227 0 0 0-.1.212l-.006 1.558 1.981-1.152v-1.557a.25.25 0 0 1 .022-.12.253.253 0 0 1 .078-.094l-1.975 1.153z"
            fill="#818182"
        />
        <path
            d="M892.04 366.04a2.64 2.64 0 0 1 1.218 2.483l-.251 1.077c-.122.516-.188 4.084-.188 4.69l-.018 5.625c0 .42-.3.587-.664.378l-.284-.166c-.183-.107-.331-.02-.331.19l-.006 1.558-6.4-3.7a.315.315 0 0 1-.117-.118.32.32 0 0 1-.044-.162v-1.374a.715.715 0 0 0-.332-.568l-.283-.164a1.466 1.466 0 0 1-.661-1.143l.015-5.625c0-.607-.056-4.243-.173-4.905l-.247-1.361c-.182-1.013.415-1.539 1.23-1.071l7.536 4.356z"
            fill="#ADADAD"
        />
        <path
            d="m894.02 364.88-7.531-4.347a.877.877 0 0 0-.434-.166.878.878 0 0 0-.457.082l-1.982 1.146a.905.905 0 0 1 .895.087l7.531 4.351a2.64 2.64 0 0 1 1.218 2.483l-.251 1.077c-.122.516-.188 4.084-.188 4.69l-.018 5.625a.462.462 0 0 1-.19.424l1.978-1.149a.461.461 0 0 0 .192-.425l.019-5.626c0-.6.061-4.172.186-4.689l.254-1.077a2.634 2.634 0 0 0-1.222-2.486z"
            fill="#969696"
        />
        <path
            d="M855.21 377.99a1.96 1.96 0 0 0-.886 1.533c0 .565.4.793.892.507a1.951 1.951 0 0 0 .887-1.531c-.002-.566-.402-.794-.893-.509zm0 1.639c-.295.169-.537.033-.539-.3a1.191 1.191 0 0 1 .537-.929c.295-.173.537-.035.538.309a1.166 1.166 0 0 1-.532.92h-.004z"
            fill="#3B3B3B"
        />
        <path
            d="M855.21 378.39c.295-.173.537-.035.538.309a1.175 1.175 0 0 1-.536.925c-.295.169-.537.033-.539-.3a1.176 1.176 0 0 1 .537-.934z"
            fill="#747474"
        />
        <path
            d="M855.1 377.5a.647.647 0 0 0-.633.061 1.944 1.944 0 0 0-.883 1.535.617.617 0 0 0 .257.569l.739.432a.617.617 0 0 1-.259-.572 1.943 1.943 0 0 1 .886-1.533.634.634 0 0 1 .634-.062l-.741-.43z"
            fill="#4C4C4C"
        />
        <path
            d="M868.17 370.51a1.96 1.96 0 0 0-.886 1.532c0 .564.4.792.892.507a1.948 1.948 0 0 0 .885-1.532c0-.565-.402-.79-.891-.507zm0 1.637c-.294.169-.534.033-.534-.3a1.173 1.173 0 0 1 .532-.93c.3-.167.538-.035.539.307a1.186 1.186 0 0 1-.535.923h-.002z"
            fill="#3B3B3B"
        />
        <path
            d="M868.17 370.91c.3-.167.538-.035.539.307a1.192 1.192 0 0 1-.537.928c-.294.169-.534.033-.534-.3a1.16 1.16 0 0 1 .532-.935z"
            fill="#747474"
        />
        <path
            d="M868.06 370.01a.625.625 0 0 0-.632.064 1.941 1.941 0 0 0-.885 1.532.627.627 0 0 0 .258.569l.739.431a.628.628 0 0 1-.259-.571 1.943 1.943 0 0 1 .886-1.532.63.63 0 0 1 .629-.062l-.736-.431z"
            fill="#4C4C4C"
        />
        <path
            d="M867.62 377.81a.64.64 0 0 0-.634-.062c-.063.036-.12.072-.185.1-.086.054-.171.1-.259.152s-.195.115-.3.173a.627.627 0 0 1 .632.062c.108.064.207.142.294.232l-.294.172a1.186 1.186 0 0 1 .535.926.384.384 0 0 1-.159.346l.5-.29c.007.049.011.098.011.147a.627.627 0 0 1-.259.57l.742-.431a.602.602 0 0 0 .207-.248.603.603 0 0 0 .052-.319 1.941 1.941 0 0 0-.883-1.53z"
            fill="#3B3B3B"
        />
        <path
            d="m866.49 378.6.741-.429a.374.374 0 0 0-.157.343 1.183 1.183 0 0 0 .534.928l-.739.428a1.162 1.162 0 0 1-.533-.925.376.376 0 0 1 .154-.345z"
            fill="#4C4C4C"
        />
        <path
            d="M866.88 378.24c-.489-.285-.889-.055-.889.507a1.954 1.954 0 0 0 .884 1.534c.491.284.89.056.89-.508a1.928 1.928 0 0 0-.885-1.533zm0 1.637a1.17 1.17 0 0 1-.533-.925c0-.34.24-.48.536-.308a1.183 1.183 0 0 1 .535.926c-.005.342-.247.478-.541.307h.003z"
            fill="#4C4C4C"
        />
        <path
            d="M866.87 378.64c-.3-.172-.536-.032-.536.308a1.164 1.164 0 0 0 .533.925c.294.171.536.035.538-.307a1.193 1.193 0 0 0-.535-.926z"
            fill="#7B7B7B"
        />
        <path
            d="M854.65 370.32a.623.623 0 0 0-.633-.064c-.064.036-.124.074-.187.109-.083.051-.174.1-.259.152l-.294.169a.633.633 0 0 1 .63.063c.11.064.211.142.3.234l-.3.171a1.18 1.18 0 0 1 .536.925.371.371 0 0 1-.158.345l.5-.286c.006.048.01.097.01.147a.62.62 0 0 1-.258.568l.741-.432a.622.622 0 0 0 .258-.568 1.943 1.943 0 0 0-.886-1.533z"
            fill="#3B3B3B"
        />
        <path
            d="M853.91 370.75c-.492-.283-.888-.057-.889.508.017.308.106.607.259.874.154.266.369.493.626.661.491.283.89.055.891-.507a1.937 1.937 0 0 0-.887-1.536zm0 1.64a1.194 1.194 0 0 1-.532-.928c0-.341.239-.476.536-.307a1.186 1.186 0 0 1 .536.925c-.01.34-.247.482-.544.31h.004z"
            fill="#4C4C4C"
        />
        <path
            d="M853.91 371.16c-.3-.169-.536-.034-.536.307a1.194 1.194 0 0 0 .532.928c.3.172.538.03.54-.31a1.193 1.193 0 0 0-.536-.925z"
            fill="#7B7B7B"
        />
        <path
            d="m868.15 369.3-6.079 3.531v1.173l6.076-3.53a.436.436 0 0 0 .255-.36v-1.173a.445.445 0 0 1-.252.359z"
            fill="#303030"
        />
        <path
            d="M853.46 369.3a.448.448 0 0 1-.26-.363v1.173a.46.46 0 0 0 .081.217.453.453 0 0 0 .18.147l6.117 3.53v-1.171l-6.118-3.533z"
            fill="#3E3E3E"
        />
        <path
            d="M868.15 368.57a1.38 1.38 0 0 0-1.248 0l-6.078 3.532v.246l6.521-3.789a.385.385 0 0 1 .357 0c.022.008.04.022.053.041a.11.11 0 0 1-.053.166l-6.519 3.792.889.266 6.079-3.531a.38.38 0 0 0 .185-.583.38.38 0 0 0-.186-.14z"
            fill="#414141"
        />
        <path
            d="M853.9 368.56a.386.386 0 0 1 .36 0l6.563 3.789v-.246l-6.118-3.534a1.382 1.382 0 0 0-1.248 0 .39.39 0 0 0-.188.139.386.386 0 0 0 0 .445.384.384 0 0 0 .188.139l6.117 3.533.894-.268-6.565-3.792c-.101-.056-.101-.148-.003-.205z"
            fill="#494949"
        />
        <path
            d="M867.7 368.56a.113.113 0 0 1 .073.104.11.11 0 0 1-.073.103l-6.519 3.792 6.563 3.788c.1.057.1.15 0 .2a.365.365 0 0 1-.355 0l-6.567-3.787-6.517 3.787a.376.376 0 0 1-.361 0c-.1-.055-.1-.146 0-.2l6.522-3.788-6.565-3.792c-.1-.058-.1-.15 0-.207a.39.39 0 0 1 .36 0l6.563 3.789 6.521-3.789a.393.393 0 0 1 .355 0z"
            fill="#303030"
        />
        <path
            d="M868.2 377.08a1.356 1.356 0 0 1-1.248 0l-6.119-3.53v1.173l6.118 3.533a1.368 1.368 0 0 0 1.248 0 .441.441 0 0 0 .257-.361v-1.174a.425.425 0 0 1-.256.359z"
            fill="#3E3E3E"
        />
        <path
            d="m868.19 376.36-6.12-3.534-.889-.266 6.563 3.788c.1.057.1.151 0 .201a.37.37 0 0 1-.355 0l-6.567-3.788v.785l6.119 3.53a1.356 1.356 0 0 0 1.248 0 .379.379 0 0 0 .183-.576.383.383 0 0 0-.182-.14z"
            fill="#4C4C4C"
        />
        <path
            d="m860.83 372.77-6.517 3.787a.383.383 0 0 1-.361 0c-.1-.055-.1-.146 0-.2l6.522-3.788-.894.268-6.075 3.532a.383.383 0 0 0-.187.582.376.376 0 0 0 .187.139 1.36 1.36 0 0 0 1.251 0l6.075-3.53-.001-.79z"
            fill="#4C4C4C"
        />
        <path
            d="M854.75 377.08a1.36 1.36 0 0 1-1.251 0 .448.448 0 0 1-.259-.364v1.173a.442.442 0 0 0 .26.367 1.368 1.368 0 0 0 1.247 0l6.078-3.532v-1.173l-6.075 3.529zM861.93 369.67a.543.543 0 0 0-.312-.444 1.706 1.706 0 0 0-1.553-.015.547.547 0 0 0-.332.452l-.008 3.064a.455.455 0 0 0 .01.066.264.264 0 0 0 .008.049.27.27 0 0 0 .034.073c.009.014.014.031.024.047.019.026.041.05.065.071a.213.213 0 0 0 .033.04.96.96 0 0 0 .137.1c.239.125.504.191.774.193.27.003.536-.058.778-.179a.832.832 0 0 0 .145-.1c.013-.012.02-.023.032-.036a.624.624 0 0 0 .071-.074.248.248 0 0 0 .024-.049.327.327 0 0 0 .035-.07.122.122 0 0 0 .012-.054.721.721 0 0 0 .013-.067v-.005c.002-.921.005-2.146.01-3.062z"
            fill="#303030"
        />
        <path
            d="M861.23 366.96a.875.875 0 0 0-.79-.01.279.279 0 0 0-.169.231l-.005 2.291c0 .01.002.02.005.031a.15.15 0 0 0 0 .03l.019.034.005.016.037.042.019.022a.53.53 0 0 0 .07.052.878.878 0 0 0 .788.007.407.407 0 0 0 .072-.051l.019-.018.035-.037a.153.153 0 0 0 .011-.027.24.24 0 0 0 .021-.034l.005-.028v-2.322a.274.274 0 0 0-.142-.229z"
            fill="#969696"
        />
        <path
            d="m853.51 361.98 7.159-4.121a.68.68 0 0 1 .682-.071l8.064 4.65a.669.669 0 0 0-.681.068l-7.158 4.121a2.094 2.094 0 0 0-.955 1.653.666.666 0 0 0 .279.613c-1.989-1.155-6.075-3.49-8.065-4.647a.663.663 0 0 1-.279-.615 2.116 2.116 0 0 1 .954-1.651z"
            fill="silver"
        />
        <path
            d="M861.58 366.63a2.094 2.094 0 0 0-.955 1.653c0 .608.43.85.959.549l7.159-4.125a2.094 2.094 0 0 0 .957-1.652c0-.609-.432-.854-.962-.546l-7.158 4.121z"
            fill="#ADADAD"
        />
        <path
            d="m857.5 365.42-1.361-.793.385-.219 1.366.793-.39.219z"
            fill="#606060"
        />
        <path
            d="m856.59 365.51-1.365-.795a.885.885 0 0 0 .911-.087l1.365.792a.897.897 0 0 1-.911.09zM856.2 366.17l-1.365-.792a1.29 1.29 0 0 1-.534-1.173l1.364.789a1.293 1.293 0 0 0 .535 1.176z"
            fill="#606060"
        />
        <path d="m855.66 365-1.364-.79v-.9l1.364.793V365z" fill="#606060" />
        <path
            d="m855.66 364.1-1.364-.793.549-.319 1.364.8-.549.312z"
            fill="#2B2B2B"
        />
        <path
            d="M856.21 363.78v.9c0 .811.581 1.142 1.289.731l.386-.217v.632l-.387.218c-1.008.582-1.834.115-1.838-1.05l-.005-.9.555-.314z"
            fill="#272727"
        />
        <path
            d="M858.39 364.18a.224.224 0 0 0-.1.21v1.558l1.981-1.148v-1.558a.238.238 0 0 1 .1-.213l-1.981 1.151z"
            fill="#818182"
        />
        <path
            d="M858.81 350.11c.413.261.746.631.962 1.069.215.439.305.929.26 1.415l-.255 1.076c-.12.519-.186 4.085-.187 4.69l-.016 5.627c0 .418-.3.589-.664.377l-.286-.165c-.182-.1-.332-.021-.332.187v1.558l-6.4-3.693a.318.318 0 0 1-.163-.28l.006-1.368a.738.738 0 0 0-.33-.574l-.287-.165a1.45 1.45 0 0 1-.658-1.141l.013-5.627c0-.608-.055-4.242-.176-4.9l-.245-1.363c-.183-1.016.418-1.54 1.231-1.071l7.527 4.348z"
            fill="#ADADAD"
        />
        <path
            d="m860.79 348.96-7.53-4.347a.872.872 0 0 0-.9-.089l-1.975 1.15a.884.884 0 0 1 .894.088l7.529 4.348a2.649 2.649 0 0 1 1.222 2.484l-.255 1.076c-.12.519-.186 4.085-.187 4.69l-.016 5.627a.461.461 0 0 1-.192.423l1.981-1.152a.453.453 0 0 0 .152-.186.451.451 0 0 0 .038-.238l.018-5.624c0-.606.062-4.172.187-4.691l.253-1.077a2.636 2.636 0 0 0-1.219-2.482z"
            fill="#969696"
        />
        <path
            d="m805.75 282.8.014 5.131-4.465 2.578-.015-5.131 2-1.151.476-.275 1.99-1.152z"
            fill="#F72585"
        />
        <path
            d="m799.97 284.49 3.775-2.178.006 1.643-.476.275v-1.114l-3.3 1.906-.005-.532zM799.97 284.23v1.161l-1.011.584v-1.158l.247-.144.475-.273.289-.17z"
            fill="#496876"
        />
        <path
            d="M799.21 284.67v-.972l.474-.272v.971l-.474.273zM794.7 289.18l-.006-1.645 4.271-2.465v.529l-3.795 2.192v1.115l-.47.274z"
            fill="#496876"
        />
        <path
            d="m797.16 287.76.015 5.13-2 1.154-.463.267-2 1.155-.016-5.129 2-1.153.476-.272 1.988-1.152zM801.72 277.11l.017 5.129-2.059 1.188-.474.272-1.933 1.116-.013-5.128 1.881-1.087.462-.267 2.119-1.223z"
            fill="#331083"
        />
        <path
            d="m795.41 279.16 4.188-2.417v1.6l-.462.267v-1.062l-3.723 2.151-.003-.539zM795.41 278.84v1.161l-1.01.583v-1.16l.272-.157.462-.267.276-.16zM794.67 279.26v-.7l.46-.267v.7l-.46.267zM791.05 288.41v1.759l-4.475 2.583v1.115l-.461.267v-1.647l4.474-2.58v-1.23l.462-.267z"
            fill="#496876"
        />
        <path
            d="m788.58 292.71.014 5.132-4.456 2.577-.017-5.132 2-1.154.461-.267 1.998-1.156z"
            fill="#331083"
        />
        <path
            d="M790.56 283.56v-1.594l3.846-2.222v.532l-3.385 1.954v1.06l-.461.27z"
            fill="#496876"
        />
        <path
            d="m793.03 282.13.015 5.127-1.991 1.15-.463.268-2.012 1.162-.014-5.129 2-1.155.463-.269 2.002-1.154z"
            fill="#F72585"
        />
        <path
            d="m797.12 272.02.014 5.128-2 1.157-.46.267-2 1.155-.015-5.128 4.461-2.579z"
            fill="#331083"
        />
        <path
            d="M554.39 631.31c-.689.689-1.544 1.33-2.542 1.905l-124.65 71.88c-3.101 1.788-7.246 2.773-11.671 2.773-4.424 0-8.569-.985-11.67-2.773l-124.65-71.88c-2.632-1.518-4.23-3.48-4.5-5.525-.222-1.685.455-3.371 1.958-4.874.689-.689 1.544-1.33 2.542-1.905l124.65-71.88c3.101-1.788 7.246-2.773 11.67-2.773 4.425 0 8.57.985 11.671 2.773l124.65 71.88c2.632 1.518 4.23 3.48 4.5 5.525.222 1.685-.455 3.37-1.958 4.874z"
            fill="#282739"
        />
        <path
            d="M277.37 623.52c-.889.889-1.901 2.311-1.674 4.036.229 1.73 1.652 3.431 4.008 4.79l124.65 71.88c2.952 1.702 6.919 2.639 11.171 2.639s8.22-.937 11.172-2.639l124.65-71.881c.921-.531 1.706-1.118 2.333-1.745.889-.889 1.902-2.311 1.674-4.036-.228-1.73-1.651-3.431-4.007-4.79l-124.65-71.88c-2.952-1.702-6.92-2.639-11.172-2.639s-8.219.937-11.171 2.639l-124.65 71.88c-.922.532-1.707 1.119-2.334 1.746zm-1.414-1.414c.738-.738 1.654-1.433 2.749-2.064l124.65-71.88c6.721-3.876 17.619-3.876 24.341 0l124.65 71.88c6.721 3.876 6.721 10.16 0 14.036l-124.65 71.88c-6.722 3.876-17.62 3.876-24.341 0l-124.65-71.88c-5.627-3.245-6.544-8.178-2.749-11.972z"
            fill="#DEDDE2"
        />
        <path
            d="m405.53 576.3 1.083-.628v.76a1.198 1.198 0 0 0 .543.939l.661.381-1.082.629-.66-.382a1.2 1.2 0 0 1-.542-.94l-.003-.759z"
            fill="#323232"
        />
        <path
            d="m404.7 575.82-.006 1.094a2.389 2.389 0 0 0 1.085 1.879l.952.549v-.959l-.66-.382a1.2 1.2 0 0 1-.542-.94v-.759l-.829-.482z"
            fill="#232323"
        />
        <path
            d="M415.84 602.9a2.613 2.613 0 0 0 1.189 2.062c.66.38 1.2.075 1.2-.683a2.622 2.622 0 0 0-1.191-2.06c-.661-.381-1.198-.08-1.198.681zm.47.274c0-.46.327-.642.725-.414a1.573 1.573 0 0 1 .717 1.248c0 .455-.324.641-.723.41a1.591 1.591 0 0 1-.719-1.244z"
            fill="#4C4C4C"
        />
        <path
            d="M417.04 602.76c-.4-.228-.726-.046-.726.414a1.589 1.589 0 0 0 .719 1.244c.4.231.724.045.724-.41a1.586 1.586 0 0 0-.717-1.248z"
            fill="#747474"
        />
        <path
            d="M417.18 601.56a.838.838 0 0 1 .851.083 2.633 2.633 0 0 1 1.191 2.061.827.827 0 0 1-.349.765l-.993.578a.837.837 0 0 0 .347-.765 2.608 2.608 0 0 0-1.191-2.06.845.845 0 0 0-.848-.085l.992-.577z"
            fill="#3B3B3B"
        />
        <path
            d="M398.41 592.84a2.627 2.627 0 0 0 1.192 2.062c.659.379 1.2.074 1.2-.683a2.626 2.626 0 0 0-1.191-2.063c-.662-.38-1.2-.075-1.201.684zm.472.271c0-.458.327-.641.723-.412a1.588 1.588 0 0 1 .72 1.247c0 .458-.325.643-.722.414a1.582 1.582 0 0 1-.721-1.249z"
            fill="#4C4C4C"
        />
        <path
            d="M399.6 592.7c-.4-.229-.722-.046-.723.412a1.582 1.582 0 0 0 .721 1.249c.4.229.722.044.722-.414a1.593 1.593 0 0 0-.72-1.247z"
            fill="#747474"
        />
        <path
            d="M399.75 591.49a.85.85 0 0 1 .851.082 2.624 2.624 0 0 1 1.189 2.063.837.837 0 0 1-.346.765l-.994.578a.836.836 0 0 0 .347-.766 2.63 2.63 0 0 0-1.191-2.063.843.843 0 0 0-.85-.081l.994-.578z"
            fill="#3B3B3B"
        />
        <path
            d="M400.36 601.97a.833.833 0 0 1 .85-.084c.082.05.166.1.249.144.115.07.234.136.348.2l.4.231a.838.838 0 0 0-.85.083 1.92 1.92 0 0 0-.4.313l.4.23a1.583 1.583 0 0 0-.719 1.246.518.518 0 0 0 .211.464l-.67-.389c-.006.068-.013.134-.013.2a.837.837 0 0 0 .346.767l-.994-.579a.841.841 0 0 1-.349-.766 2.637 2.637 0 0 1 1.191-2.06z"
            fill="#4C4C4C"
        />
        <path
            d="m401.87 603.04-1-.578a.503.503 0 0 1 .21.462 1.578 1.578 0 0 1-.716 1.246l.995.58a1.585 1.585 0 0 0 .716-1.248.491.491 0 0 0-.208-.462h.003z"
            fill="#4C4C4C"
        />
        <path
            d="M400.16 604.61c0 .757.538 1.064 1.2.682a2.622 2.622 0 0 0 1.19-2.061c0-.76-.54-1.064-1.2-.684a2.627 2.627 0 0 0-1.19 2.063zm.472-.274a1.6 1.6 0 0 1 .719-1.246c.4-.228.723-.044.723.414-.013.25-.084.493-.208.71a1.595 1.595 0 0 1-.508.538c-.402.229-.724.041-.726-.416z"
            fill="#3F3F3F"
        />
        <path
            d="M401.35 603.09c.4-.228.723-.044.723.414a1.586 1.586 0 0 1-.716 1.248c-.4.229-.724.041-.726-.416a1.579 1.579 0 0 1 .719-1.246z"
            fill="#7B7B7B"
        />
        <path
            d="M417.79 591.9a.848.848 0 0 1 .848-.081l.25.143c.115.069.234.136.347.2l.4.232a.848.848 0 0 0-.85.082 1.994 1.994 0 0 0-.4.314l.4.231a1.585 1.585 0 0 0-.721 1.246.502.502 0 0 0 .212.464l-.67-.39c-.006.067-.016.135-.016.2a.84.84 0 0 0 .351.767l-.995-.579a.846.846 0 0 1-.352-.765 2.65 2.65 0 0 1 .351-1.175c.208-.358.498-.663.845-.889z"
            fill="#4C4C4C"
        />
        <path
            d="M417.59 594.55c0 .757.539 1.063 1.2.683a2.627 2.627 0 0 0 1.191-2.064c0-.755-.538-1.063-1.2-.683a2.63 2.63 0 0 0-1.191 2.064zm.474-.273a1.587 1.587 0 0 1 .721-1.246c.4-.229.72-.045.72.414a1.594 1.594 0 0 1-.716 1.246c-.398.234-.722.044-.725-.414z"
            fill="#3F3F3F"
        />
        <path
            d="M418.78 593.03c.4-.229.72-.045.72.414a1.59 1.59 0 0 1-.715 1.246c-.4.23-.722.044-.726-.414.013-.25.085-.494.211-.71.125-.217.3-.401.51-.536z"
            fill="#7B7B7B"
        />
        <path
            d="m399.64 590.53 8.17 4.747.005 1.577-8.171-4.747a.587.587 0 0 1-.343-.483v-1.578a.586.586 0 0 0 .339.484z"
            fill="#3E3E3E"
        />
        <path
            d="M419.39 590.53a.603.603 0 0 0 .35-.491l.006 1.579a.597.597 0 0 1-.352.489l-8.226 4.75v-1.578l8.222-4.749z"
            fill="#303030"
        />
        <path
            d="M399.64 589.56a1.846 1.846 0 0 1 1.677 0l8.171 4.747-.006.332-8.766-5.1a.56.56 0 0 0-.481 0 .149.149 0 0 0-.099.14.146.146 0 0 0 .099.139l8.767 5.104-1.2.36-8.17-4.747a.51.51 0 0 1-.25-.79.513.513 0 0 1 .258-.185z"
            fill="#414141"
        />
        <path
            d="M418.79 589.54a.556.556 0 0 0-.482 0l-8.826 5.1.006-.332 8.225-4.749a1.848 1.848 0 0 1 1.68 0 .512.512 0 0 1-.006.971l-8.225 4.749-1.2-.362 8.825-5.1a.147.147 0 0 0 .003-.277z"
            fill="#494949"
        />
        <path
            d="M400.24 589.54a.149.149 0 0 0-.099.139.149.149 0 0 0 .099.14l8.767 5.1-8.827 5.1a.149.149 0 0 0-.099.139.149.149 0 0 0 .099.14.532.532 0 0 0 .483 0l8.826-5.1 8.765 5.094a.536.536 0 0 0 .484 0 .146.146 0 0 0 .1-.14.149.149 0 0 0-.027-.086.154.154 0 0 0-.073-.053l-8.768-5.1 8.825-5.1a.146.146 0 0 0 .1-.14.149.149 0 0 0-.027-.086.154.154 0 0 0-.073-.053.546.546 0 0 0-.482 0l-8.826 5.1-8.766-5.1a.548.548 0 0 0-.481.006z"
            fill="#303030"
        />
        <path
            d="M399.58 601a1.84 1.84 0 0 0 1.677 0l8.226-4.75v1.578l-8.225 4.749a1.836 1.836 0 0 1-1.677 0 .594.594 0 0 1-.346-.484v-1.577a.592.592 0 0 0 .345.484z"
            fill="#303030"
        />
        <path
            d="m399.58 600.03 8.225-4.751 1.2-.36-8.827 5.1a.142.142 0 0 0-.071.054.146.146 0 0 0-.027.085.146.146 0 0 0 .098.14.536.536 0 0 0 .483 0l8.826-5.1v1.054l-8.226 4.75a1.836 1.836 0 0 1-1.677 0 .512.512 0 0 1-.004-.972z"
            fill="#4C4C4C"
        />
        <path
            d="m409.48 595.2 8.765 5.094a.524.524 0 0 0 .484 0 .145.145 0 0 0 .101-.139.147.147 0 0 0-.101-.14l-8.768-5.1 1.2.362 8.168 4.749a.513.513 0 0 1 0 .971 1.844 1.844 0 0 1-1.68 0l-8.169-4.75V595.2z"
            fill="#4C4C4C"
        />
        <path
            d="M417.65 601a1.848 1.848 0 0 0 1.68 0 .59.59 0 0 0 .351-.489v1.579a.583.583 0 0 1-.35.487 1.834 1.834 0 0 1-1.677 0l-8.171-4.748v-1.578L417.65 601z"
            fill="#3E3E3E"
        />
        <path
            d="M408 591.03a.725.725 0 0 1 .415-.6 2.3 2.3 0 0 1 2.088-.023.746.746 0 0 1 .446.613l.013 4.119a.494.494 0 0 1-.014.087.387.387 0 0 1-.012.068.6.6 0 0 1-.045.1.321.321 0 0 1-.032.061.68.68 0 0 1-.085.1c-.016.017-.028.035-.045.051a1.163 1.163 0 0 1-.185.134 2.29 2.29 0 0 1-1.041.26 2.285 2.285 0 0 1-1.045-.24 1.161 1.161 0 0 1-.193-.133c-.019-.015-.032-.034-.048-.048a.89.89 0 0 1-.094-.1c-.013-.022-.019-.045-.033-.067a.628.628 0 0 1-.05-.092.301.301 0 0 1-.012-.073.742.742 0 0 1-.018-.094 808.65 808.65 0 0 0-.01-4.123z"
            fill="#303030"
        />
        <path
            d="M408.95 587.39a1.177 1.177 0 0 1 1.06-.012.365.365 0 0 1 .227.313l.01 3.078a.222.222 0 0 1-.007.045c0 .012 0 .023-.006.034a.265.265 0 0 1-.023.048c-.004.011-.01.021-.016.031-.013.018-.028.032-.042.049l-.027.028a.352.352 0 0 1-.092.066 1.16 1.16 0 0 1-1.061.013.734.734 0 0 1-.1-.068.132.132 0 0 0-.022-.026c-.016-.017-.033-.031-.047-.049l-.018-.035a.337.337 0 0 1-.025-.046c0-.014 0-.026-.007-.039a.34.34 0 0 1-.006-.046v-1.538l-.006-1.54a.375.375 0 0 1 .208-.306z"
            fill="#969696"
        />
        <path
            d="M403.32 589.88c.018-.02.039-.039.059-.06.045-.045.093-.086.14-.127.019-.016.038-.034.057-.047.063-.051.13-.098.2-.14l3.658-2.111-.361-.208-3.657 2.109c-.07.042-.137.088-.2.138l-.062.052a1.302 1.302 0 0 0-.134.123.808.808 0 0 0-.065.066c-.045.048-.088.1-.131.151-.017.021-.033.037-.047.058l-.013.015a2.178 2.178 0 0 0-.155.228l-1.929 3.168.361.208 1.927-3.166c.054-.086.11-.168.169-.247a2.742 2.742 0 0 1 .183-.21z"
            fill="#4C4C4C"
        />
        <path
            d="m400.82 593.52-.362-.212a.217.217 0 0 1 .218-.021l.36.209a.212.212 0 0 0-.216.024z"
            fill="#4C4C4C"
        />
        <path
            d="M400.68 593.29a.217.217 0 0 0-.218.021l-1.686.974a.372.372 0 0 0-.078.059l-.02.02a.38.38 0 0 0-.063.07l-.006.006a.31.31 0 0 0-.05.074c0 .009-.01.016-.014.025a.867.867 0 0 1-.028.063v.019a.634.634 0 0 0-.023.074v.025a.527.527 0 0 0-.01.089c-.005.038.001.077.017.112s.041.066.072.088l.362.21a.216.216 0 0 1-.091-.2.642.642 0 0 1 .009-.087.161.161 0 0 0 .009-.029c0-.022.012-.043.017-.064l.01-.028.029-.059.01-.024c.017-.027.033-.053.051-.077l.013-.013a.51.51 0 0 1 .056-.067l.023-.018a.294.294 0 0 1 .077-.058l1.688-.973a.212.212 0 0 1 .216-.024l-.372-.208z"
            fill="#6B6B6B"
        />
        <path
            d="M407.44 587.39v.243l-3.658 2.111a1.973 1.973 0 0 0-.664.686l-1.99 3.261a.658.658 0 0 1-.3.53l-1.686.973c-.171.1-.307.019-.308-.177a.665.665 0 0 1 .3-.524l1.688-.973a.213.213 0 0 1 .222-.022l1.927-3.166c.198-.339.476-.624.81-.831l3.659-2.111z"
            fill="#2A2A2A"
        />
        <path
            d="m413.07 571.4-.773-.45-3.64 2.118.773.449 3.64-2.117z"
            fill="#313131"
        />
        <path
            d="m412.04 572.12 1.6-7.144.771.449 3.382 1.953v.892l-3.556-2.049-1.419 6.347-.778-.448z"
            fill="#313131"
        />
        <path
            d="m408.66 574.08.773.449v-1.027l-.773-.449v1.027zM418.71 566.84v.893l-.923.537v-.892l.923-.538z"
            fill="#464646"
        />
        <path
            d="m418.71 566.84-.924.539-4.153-2.4.924-.536 4.153 2.397z"
            fill="#363636"
        />
        <path
            d="m413.07 571.4 1.162-5.175.684.4-1.22 5.441-4.265 2.462v-1.013l3.639-2.115z"
            fill="#464646"
        />
        <path
            d="M401.98 577.23c.039.029.07.067.09.111s.028.092.023.14l.006 1.822-2.318-1.348-.006-1.821a.266.266 0 0 0-.114-.25l2.319 1.346z"
            fill="#818182"
        />
        <path
            d="M401.48 560.77a3.083 3.083 0 0 0-1.426 2.9l.3 1.262c.143.607.215 4.779.217 5.489l.018 6.584c0 .492.351.69.78.443l.333-.194c.214-.126.39-.024.39.223l.006 1.822 7.486-4.323a.384.384 0 0 0 .188-.33v-1.6a.84.84 0 0 1 .389-.668l.331-.193c.225-.146.413-.343.547-.576.135-.232.213-.493.227-.761l-.019-6.586c0-.707.069-4.963.207-5.734l.288-1.6c.214-1.189-.489-1.8-1.441-1.252l-8.821 5.094z"
            fill="#19242B"
        />
        <path
            d="m399.16 559.42 8.813-5.089a1.039 1.039 0 0 1 1.047-.1l2.317 1.346a1.027 1.027 0 0 0-1.048.1l-8.814 5.09a3.081 3.081 0 0 0-1.426 2.9l.3 1.262c.143.607.215 4.779.217 5.489l.018 6.584a.543.543 0 0 0 .227.5l-2.318-1.347a.532.532 0 0 1-.224-.495l-.02-6.583c0-.712-.076-4.884-.218-5.492l-.295-1.259a3.08 3.08 0 0 1 1.424-2.906z"
            fill="#344049"
        />
        <path
            d="m404.56 554.52-.64-.371v3.667l.641.374-.001-3.67z"
            fill="#3B3B3B"
        />
        <path
            d="m404.56 554.52.007 3.67.967-.557-.008-3.669-.966.556z"
            fill="#292929"
        />
        <path
            d="m401.56 581.31 10.492-6.058a.878.878 0 0 1 .881-.086l10.438 6.014a.867.867 0 0 0-.881.088l-10.488 6.054a2.726 2.726 0 0 0-1.234 2.139.874.874 0 0 0 .36.795c-2.574-1.494-7.863-4.519-10.44-6.014a.871.871 0 0 1-.359-.8 2.715 2.715 0 0 1 1.231-2.132z"
            fill="#344049"
        />
        <path
            d="M412 587.32a2.722 2.722 0 0 0-1.234 2.139c0 .787.556 1.1 1.243.709l10.49-6.058a2.706 2.706 0 0 0 1.235-2.138c0-.786-.557-1.1-1.244-.708L412 587.32z"
            fill="#969696"
        />
        <path
            d="m400.78 551.47 5.922-3.419a.548.548 0 0 1 .554-.054l1.544.9a.541.541 0 0 0-.551.052l-5.923 3.418a1.706 1.706 0 0 0-.771 1.339l.006 2.581a.542.542 0 0 0 .225.495l-1.545-.9a.537.537 0 0 1-.225-.5l-.008-2.581a1.693 1.693 0 0 1 .772-1.331z"
            fill="#344049"
        />
        <path
            d="M402.33 552.37a1.697 1.697 0 0 0-.771 1.339l.006 2.581c0 .49.35.689.775.442l5.926-3.418a1.697 1.697 0 0 0 .772-1.34l-.008-2.578c0-.493-.351-.69-.777-.444l-5.923 3.418z"
            fill="#19242B"
        />
        <path
            d="m401.39 577.88-.773-.449-3.977 2.294.773.448 3.977-2.293z"
            fill="#313131"
        />
        <path
            d="m396.43 575.78 1.312 4.207 3.65-2.106v1.015l-4.267 2.465-1.584-5.069.889-.512z"
            fill="#3B3B3B"
        />
        <path d="M399.85 577.7v.895l-.927.536v-.893l.927-.538z" fill="#3B3B3B" />
        <path
            d="m395.54 576.29 3.382 1.951v.893l-3.033-1.752 1.239 3.977-.773-.451-1.583-5.07.768.452z"
            fill="#2C2C2C"
        />
        <path
            d="m399.85 577.7-.925.538-4.154-2.4.924-.535 4.155 2.397z"
            fill="#363636"
        />
        <path
            d="m395.41 574.68 1.473-.849a.608.608 0 0 1 .619-.06l7.723 4.488a.6.6 0 0 0-.619.061l-1.471.848a1.907 1.907 0 0 0-.869 1.5.597.597 0 0 0 .255.56l-7.724-4.489a.596.596 0 0 1-.254-.559 1.907 1.907 0 0 1 .867-1.5z"
            fill="#344049"
        />
        <path
            d="M403.14 579.17a1.91 1.91 0 0 0-.869 1.5c0 .555.394.777.875.5l1.471-.85a1.914 1.914 0 0 0 .866-1.5c0-.552-.392-.776-.872-.5l-1.471.85z"
            fill="#19242B"
        />
        <path
            d="m413.35 563.28 1.472-.85a.605.605 0 0 1 .618-.061l7.725 4.489a.617.617 0 0 0-.622.06l-1.47.851a1.91 1.91 0 0 0-.869 1.5.606.606 0 0 0 .255.559l-7.723-4.488a.614.614 0 0 1-.254-.561 1.892 1.892 0 0 1 .868-1.499z"
            fill="#344049"
        />
        <path
            d="M421.08 567.77a1.91 1.91 0 0 0-.869 1.5c0 .551.394.775.873.5l1.472-.85a1.904 1.904 0 0 0 .867-1.505c0-.553-.392-.774-.873-.5l-1.47.855z"
            fill="#19242B"
        />
        <path
            d="m418.61 590.6.876.744s4.021 1.951 4.281 2.047a.662.662 0 0 1 .446.588.483.483 0 0 1-.083.317c-.36.389-.852.631-1.381.679a14.788 14.788 0 0 1-3.69-.264c-.276-.131-1.922-.415-2.058-.516 0 0-.506-.018-.612.2-.01.166.003.333.039.495l-1.529-.592a4.098 4.098 0 0 1-.273-1.084l-.271-2.146 4.255-.468z"
            fill="#545454"
        />
        <path
            d="M424.14 594.13a2.31 2.31 0 0 1-1.435.733 9.21 9.21 0 0 1-4.163-.6 5.508 5.508 0 0 0-1.654-.325s-.525.054-.505.451c0 .081-.031.022-.018.115a.213.213 0 0 1 .012-.106c.1-.214.534.084.534.084.173-.192.046-.4 1.276-.023a11.23 11.23 0 0 0 4.209.8 2.712 2.712 0 0 0 1.757-.875.567.567 0 0 0 .056-.449 1.964 1.964 0 0 1-.069.195z"
            fill="#282827"
        />
        <path
            d="m416.37 594.31-1.651-.634c.044.21.099.418.165.623l1.531.594a15.767 15.767 0 0 1-.045-.583z"
            fill="#282827"
        />
        <path
            d="m415.8 593.42 2.659 2.231s1.34 1.078 1.834 1.363a.868.868 0 0 1 .281.303.877.877 0 0 1 .114.397.643.643 0 0 1-.156.483 3.194 3.194 0 0 1-1.482.71 4.795 4.795 0 0 1-3.142-.614c-.26-.166-2.025-1.3-2.153-1.408-.368-.294-.7-.409-.832-.213 0 0 .015.485.015.557l-1.478-1.017a6.954 6.954 0 0 1-.1-.875v-2.167l4.44.25z"
            fill="#282827"
        />
        <path
            d="m415.8 593.1 2.659 2.23s1.34 1.077 1.834 1.363a.89.89 0 0 1 .395.7.627.627 0 0 1-.156.483 3.184 3.184 0 0 1-1.482.71 4.81 4.81 0 0 1-3.142-.615c-.26-.168-2.025-1.3-2.153-1.4-.368-.3-.7-.412-.832-.215 0 0 .015.486.015.556l-1.478-1.016a6.986 6.986 0 0 1-.1-.877v-2.158l4.44.239z"
            fill="#545454"
        />
        <path
            d="M412.03 577.82v.257l.593.342v-.256l-.593-.343zM411.13 577.32v.257l.594.345v-.258l-.594-.344z"
            fill="#393939"
        />
        <path
            d="m412.57 578.32-.539-.314v-.179l.539.311v.182zM411.67 577.81l-.538-.311v-.18l.541.31-.003.181z"
            fill="#1C1C1C"
        />
        <path d="m409.93 560.51-.641-.429v16.665l.641.777V560.51z" fill="#894E0E" />
        <path d="m410.86 560-.65-.429-.918.513.641.429.927-.513z" fill="#995710" />
        <path
            d="M409.94 560.51v15.246l.928-.672v-15.087l-.928.513zM411.66 575.83l.034 12.077.883-.483.015-12.008-.932.414z"
            fill="#5F360A"
        />
        <path
            d="m418.83 578.88-.681-.365v13.079l.677.413.004-13.127z"
            fill="#894E0E"
        />
        <path
            d="m418.78 579.96.045 12.039.873-.443.016-12.009-.934.413z"
            fill="#5F360A"
        />
        <path
            d="m411.41 584.47 9.013-5.239a1.555 1.555 0 0 1 .569 1.248.684.684 0 0 1-.238.6l-9.011 5.235c.087-.072.155-.165.197-.27s.056-.218.042-.33a1.54 1.54 0 0 0-.572-1.244z"
            fill="#414F5A"
        />
        <path
            d="M421.31 594.81c-.018-.017-1.35-1.723-1.623-2.089a2.721 2.721 0 0 1-.421-2.254l1.77-7.637a2.948 2.948 0 0 0-.1-1.779 1.861 1.861 0 0 0-.334-.524l-7.658-5.575-1.287.552c-1.471 1.715-.734 2.5-.734 3.554 0 .054 4.135 2.991 5.146 3.738.209.2.358.455.43.735-.122.942-.341 6.105-.5 7.919l-.06.833c.004.357.126.703.347.983a18.791 18.791 0 0 0 2.3 2.114 2.758 2.758 0 0 0 2.525.626.647.647 0 0 0 .494-.478.642.642 0 0 0-.219-.652.434.434 0 0 0-.076-.066z"
            fill="#E8C5AC"
        />
        <path
            d="m416.76 595.31 1.022-.451-.7-.812h-.576l.254 1.263z"
            fill="#5B5454"
        />
        <path
            d="m415.86 593.91.208 1.012s.027.183.434.32c.105.034.254.068.254.068l.091-1.147-.987-.253z"
            fill="#7C7676"
        />
        <path
            d="M422.01 596.91a.758.758 0 0 0 .248-.943.7.7 0 0 0-.72-.468c.247.321-2.191.883-1.169.684.633-.121-1.313-.427-2.049-.841a7.644 7.644 0 0 1-1.375-1.272 3.145 3.145 0 0 1-1.064-1.842 3.76 3.76 0 0 0-.084.846c0 .77.32.9.32.9s.042.268.736.573c.781.345 1.315 1.712 2.334 2.223a3.33 3.33 0 0 0 2.823.14z"
            fill="#7C7676"
        />
        <path
            d="M421.97 596.66c.531-.322.444-.765-.4-1.6l-.224-.211c.244.321.184.8-.664.943a2.705 2.705 0 0 1-2.158-.644 9.243 9.243 0 0 1-1.84-1.607 3.051 3.051 0 0 1-.7-2.092 1.348 1.348 0 0 0-.471 1.355c.056.434.192.854.4 1.239l1.136.532c.756.358.911 1.365 2.135 1.935a3.074 3.074 0 0 0 2.786.15z"
            fill="#B21B0B"
        />
        <path
            d="M418.14 596.57c-.017-.018-1.416-1.9-1.681-2.276a3.172 3.172 0 0 1-.372-2.578l1.782-7.126a2.8 2.8 0 0 0-.449-2.758l-6.178-6.221s-2.547-1.187-3.9.556c-1.385 1.785-1.452 2.848-.434 4.246.034.045 5.122 3.365 6.2 4 .367.217.251.721.214.874-.6 2.625-.4 5.553-.489 7.72l-.008.13-.068.9c.004.358.127.704.351.984a18.775 18.775 0 0 0 2.3 2.112 2.758 2.758 0 0 0 2.527.626.638.638 0 0 0 .478-.834.646.646 0 0 0-.204-.294c-.022-.019-.049-.039-.069-.061z"
            fill="#FFE1CC"
        />
        <path
            d="m413.59 597.07 1.022-.451-.7-.811h-.574l.252 1.262z"
            fill="#5B5454"
        />
        <path
            d="m412.7 595.67.209 1.01s.026.183.435.322c.1.034.252.068.252.068l.091-1.149-.987-.251z"
            fill="#7C7676"
        />
        <path
            d="M418.84 598.67a.768.768 0 0 0 .248-.947.694.694 0 0 0-.718-.464c.244.322-2.192.884-1.171.684.633-.122-1.311-.428-2.047-.843a7.848 7.848 0 0 1-1.375-1.27 3.172 3.172 0 0 1-1.066-1.844c-.06.278-.088.562-.084.847 0 .769.322.9.322.9s.041.271.734.574c.783.346 1.313 1.712 2.336 2.225.431.229.908.361 1.396.385.487.023.974-.061 1.425-.247z"
            fill="#7C7676"
        />
        <path
            d="M418.8 598.42c.53-.323.445-.765-.4-1.6l-.225-.212c.245.321.185.8-.662.941a2.721 2.721 0 0 1-2.16-.642 8.228 8.228 0 0 1-1.838-1.609 2.887 2.887 0 0 1-.7-2.161 1.516 1.516 0 0 0-.474 1.425c.055.434.19.854.4 1.237l1.134.534c.756.358.91 1.364 2.135 1.935a3.095 3.095 0 0 0 2.79.152z"
            fill="#B21B0B"
        />
        <path
            d="M415.31 575.65c.713.6 5.051 4.078 5.118 4.134.944.775.5 1.273.5 1.273 0-.039-.36-.759-.988-.687-1.54.274-3.028.785-4.412 1.515-2.453 1.164-3.2 4.22-3.2 4.22a9.246 9.246 0 0 1-1.1-1.278c-.49-.613-5.873-2.153-6.2-5.775-.053-1.417.06-2.836.336-4.228 0 0 1.676 2.384 5.694 1.459 3.031-.7 3.166-2.051 3.166-2.051a3.044 3.044 0 0 0 1.086 1.418z"
            fill="#5B5353"
        />
        <path
            d="M417.31 571.19c-.558-.352 1.563-1.517.691-2.713l-5.562-5.6c-.8-1.236-1.312-4.185.264-4.156 1.022.021 3.071 2.563 4.24 3.879a50.944 50.944 0 0 1 4 4.871c.874 1.379-.136 2.992 0 3.08-.003-.003-2.391 1.422-3.633.639z"
            fill="#911309"
        />
        <path
            d="m413.91 558.69 1.351 5.81c.155.587.219 1.194.189 1.8a4.088 4.088 0 0 1-.88 1.738 3.96 3.96 0 0 0-.623 2.974l.292 3.486s.187.944-2.319 1.888c-5.524 2.083-6.778-.113-6.778-.113a1.5 1.5 0 0 1-.07-.76c.162-.78.291-1.295.463-1.883l.658-2.968c.128-.428.196-.872.2-1.319l-.782-3.819s-1.091-2.638-.165-3.787a18.255 18.255 0 0 1 4.051-3.262 5.368 5.368 0 0 1 1.263-.382 5.08 5.08 0 0 1 3.15.597z"
            fill="#B21B0B"
        />
        <path
            d="M412.63 560.45c-1.579 1.227-2.224-.328-3.008-1.522l.285-4.172 3.288.645-.565 5.049z"
            fill="#E8C5AC"
        />
        <path
            d="M409.73 557.6s-.068.527-.058.623c.168 1.624 2.05 2.445 2.05 2.445.234.149.2.438.123.817l-.242 1.108c-.068.364-.254.31-.386.144 0 0-1.358-1.4-1.733-1.868-.881-1.093-.779-1.312-.291-2.544.296-.746.537-.725.537-.725z"
            fill="#EDEDED"
        />
        <path
            d="M412.04 560.45c-.176.189-.25.344-.155.5l.723 1.061c.306.413.406.122.442-.174l.191-2.157c-.008-1.362-.359-1.459-.359-1.459s-.009.1-.039.383a3.363 3.363 0 0 1-.803 1.846z"
            fill="#EDEDED"
        />
        <path
            d="M410.88 575.36s.533.257.426.517a4.848 4.848 0 0 1-1.194 1.275c-.183.165-.451.269-.633.127s-.655-1.15-.165-1.594 1.399-.524 1.566-.325z"
            fill="#911309"
        />
        <path
            d="M416.39 559.56s-1.133-.429-.828-2.174a7.917 7.917 0 0 1 .46-1.654c1.308-3.7-.441-5.628-2.174-6.618a5.56 5.56 0 0 0-4.589.009c-.969.574-.082 1.56.8 3.141a10.045 10.045 0 0 1 1.174 4.969c-.47 2.344 4.055 3.314 5.157 2.327z"
            fill="#562D07"
        />
        <path
            d="M413.85 551.93c2.151.534 1.752 2.33 1.512 3.534-.165.84-.658 2.375-.658 2.375-.585 1.494-1.328 2.263-2.209 2.345-1.1.1-2.33-.916-3.182-2.548a4.463 4.463 0 0 1-.687-2.462l.347-4.808s3.735 1.278 4.877 1.564z"
            fill="#FFE1CC"
        />
        <path
            d="M416.22 551.9c-.29-1.365-2.924-3.432-5.22-3.279a4.858 4.858 0 0 0-1.946.608c-1.893 1.077-2.311 3.1-2.006 5.49.213 1.683-.338 2.2-1.03 2.679a6.798 6.798 0 0 0 1.549 2.037 8.202 8.202 0 0 0 3.248 1.777 6.839 6.839 0 0 1-.367-3.615c.244-1.777.519-2.451.7-2.482s.55 0 1.1-.061c.162-.263.276-.553.338-.857.183-.729.2-.806.2-.806.08.315.09.643.029.961-.014.257-.05.513-.107.763a4.939 4.939 0 0 0 1.662-.183 3.74 3.74 0 0 0 .209-.8 2.73 2.73 0 0 0 .015-.461c.068.214.109.436.121.66.01.217.014.429.014.559a2.478 2.478 0 0 0 1.408-.542c.297-.291.374-1.071.083-2.448z"
            fill="#562D07"
        />
        <path
            d="M417.57 571.3c-.389.284-1.029-.057-1.285-.415-.092-.123-.7.79-1.1.807-.43.015-.256-.306-.207-.415a3.447 3.447 0 0 1 1.312-1.193c1.238-.392 1.355-.1 1.611.257s.062.676-.331.959z"
            fill="#FFE8D9"
        />
        <path
            d="m418.58 570.61-.6-.849-1.884.942-.575.345-1.261 1.609s-.231.321.666.688c.437.18 1.56-.413 1.56-.413l1.41-.584c.451-.305 1.02-1.264.684-1.738z"
            fill="#FFE8D9"
        />
        <path
            d="M417.38 569.9s1.024-1.268 1.656-1.932c.457-.482 1.627-1.052 2.346-.1.767 1.015-.266 2.129-.678 2.49a12.208 12.208 0 0 1-2.382 1.608 1.592 1.592 0 0 0 0-1.242 1.39 1.39 0 0 0-.942-.824z"
            fill="#B21B0B"
        />
        <path
            d="m411.7 622.52-20.842-12.112 44.35-25.374 20.9 12.112L411.7 622.52z"
            fill="#231F20"
            opacity={0.24}
            style={{ mixBlendMode: "multiply" }}
        />
        <path
            d="m438.4 567.96-.02 23.44a.699.699 0 0 1-.412.574 2.191 2.191 0 0 1-1.989 0 .712.712 0 0 1-.415-.58l.024-23.438a.702.702 0 0 0 .414.578 2.213 2.213 0 0 0 1.989 0 .706.706 0 0 0 .409-.574z"
            fill="#646D6D"
        />
        <path
            d="m438.4 567.96-.02 23.44a.699.699 0 0 1-.412.574 2.191 2.191 0 0 1-1.989 0 .712.712 0 0 1-.415-.58l.024-23.438a.702.702 0 0 0 .414.578 2.213 2.213 0 0 0 1.989 0 .706.706 0 0 0 .409-.574zM451.14 574.31l-.02 23.44a.702.702 0 0 1-.412.574 2.191 2.191 0 0 1-1.989 0 .718.718 0 0 1-.415-.58l.024-23.438a.702.702 0 0 0 .414.578 2.213 2.213 0 0 0 1.989 0 .7.7 0 0 0 .409-.574z"
            fill="#646D6D"
        />
        <path
            d="m451.14 574.31-.02 23.44a.702.702 0 0 1-.412.574 2.191 2.191 0 0 1-1.989 0 .718.718 0 0 1-.415-.58l.024-23.438a.702.702 0 0 0 .414.578 2.213 2.213 0 0 0 1.989 0 .7.7 0 0 0 .409-.574zM412.5 595.26l-.02 22a.656.656 0 0 1-.384.538c-.833.485-2.258.132-2.258-.546l.025-22c-.006.677 1.423 1.025 2.254.542a.657.657 0 0 0 .383-.535v.001zM400.44 587.82l-.023 22a.653.653 0 0 1-.381.538 2.07 2.07 0 0 1-1.867 0 .677.677 0 0 1-.39-.545l.021-22a.671.671 0 0 0 .389.546 2.073 2.073 0 0 0 1.866 0 .664.664 0 0 0 .385-.539z"
            fill="#646D6D"
        />
        <path
            d="m413.21 602.43-20.2-11.7 44.242-25.476 20.2 11.7-44.242 25.476z"
            fill="#fff"
        />
        <path
            d="m457.45 576.95-44.239 25.481-20.2-11.7v.991l20.2 11.7 44.239-25.48v-.992z"
            fill="#E0E0E0"
        />
        <path
            d="m448.24 578.46-.025 15.571a.705.705 0 0 1-.408.574 2.185 2.185 0 0 1-1.988 0 .71.71 0 0 1-.415-.579l.023-15.575a.702.702 0 0 0 .415.582 2.205 2.205 0 0 0 1.989 0 .697.697 0 0 0 .409-.573z"
            fill="#D3D3D3"
        />
        <path
            d="m422.9 586.81 14.95-8.611v.428a.857.857 0 0 1-.424.733l-14.1 8.124a.847.847 0 0 1-.844 0l-10.32-6.089a.63.63 0 0 1-.315-.55v-.278l11.053 6.243z"
            fill="#848484"
        />
        <path
            d="M412.09 580.22a.448.448 0 0 0-.181.626c.042.07.102.128.174.166l10.818 5.8 14.95-8.612-10.795-4.871a1.783 1.783 0 0 0-1.541.039l-13.425 6.852z"
            fill="#E2E1E0"
        />
        <path
            d="M417.05 582.5c-.135.078-.275.4.255.628l4.793 2.616c.4.245.735.022 1.1-.188l12.64-7.277a.286.286 0 0 0 0-.532l-4.618-2.913a.816.816 0 0 0-.74-.106l-13.43 7.772z"
            fill="#898686"
        />
        <path
            d="M427.73 576.43c-.064.035-.064.094 0 .128l.635.371a.24.24 0 0 0 .224 0l.643-.371c.063-.034.063-.093 0-.13l-.64-.367a.227.227 0 0 0-.222 0l-.64.369zM430.86 579.78c-.062.035-.063.091 0 .129l.64.368a.236.236 0 0 0 .221 0l.643-.372c.062-.034.064-.09 0-.125l-.641-.371a.22.22 0 0 0-.22 0l-.643.371zM429.75 580.42c-.061.037-.061.093 0 .129l.64.371a.235.235 0 0 0 .22 0l.644-.371c.064-.036.064-.092 0-.129l-.639-.374a.256.256 0 0 0-.223 0l-.642.374zM428.63 581.07c-.065.036-.065.093 0 .129l.638.37a.243.243 0 0 0 .219 0l.645-.37c.013-.005.025-.013.033-.025s.013-.026.013-.04-.005-.028-.013-.04a.075.075 0 0 0-.033-.025l-.639-.369a.236.236 0 0 0-.221 0l-.642.37zM429.94 576.5a.07.07 0 0 0-.033.026.068.068 0 0 0-.013.039.07.07 0 0 0 .046.065l.639.372a.23.23 0 0 0 .22 0l1.766-1.019c.063-.032.063-.093 0-.13l-.64-.369a.248.248 0 0 0-.223 0l-1.762 1.016zM428.87 577.09c-.061.037-.061.092 0 .127l.638.37a.24.24 0 0 0 .223 0l.645-.373c.06-.034.06-.089 0-.126l-.642-.371a.237.237 0 0 0-.222 0l-.642.373zM427.66 577.79a.066.066 0 0 0-.032.025c-.008.011-.012.024-.012.038s.004.027.012.039a.07.07 0 0 0 .032.024l.643.373a.236.236 0 0 0 .221 0l.642-.373a.063.063 0 0 0 .034-.024c.008-.011.013-.025.013-.039s-.005-.028-.013-.039a.069.069 0 0 0-.034-.024l-.638-.372a.243.243 0 0 0-.225 0l-.643.372zM426.55 578.44c-.062.032-.062.093 0 .129l.637.37a.259.259 0 0 0 .224 0l.643-.373a.065.065 0 0 0 .048-.063.065.065 0 0 0-.048-.064l-.64-.373a.253.253 0 0 0-.222 0l-.642.374zM425.42 579.08c-.061.037-.061.1 0 .13l.639.369a.243.243 0 0 0 .223 0l.643-.372c.062-.032.062-.092 0-.127l-.639-.372a.251.251 0 0 0-.221 0l-.645.372zM431.02 577.13c-.062.034-.062.089 0 .125l.641.371c.034.019.072.028.111.028s.077-.009.111-.028l1.764-1.019a.061.061 0 0 0 .034-.025.066.066 0 0 0 .013-.04.067.067 0 0 0-.013-.041.072.072 0 0 0-.034-.025l-.641-.371a.263.263 0 0 0-.221 0l-1.765 1.025zM429.9 577.78a.068.068 0 0 0-.033.025c-.008.011-.013.025-.013.039s.005.028.013.039.02.02.033.024l.638.372a.243.243 0 0 0 .223 0l.643-.372a.061.061 0 0 0 .034-.025.064.064 0 0 0 .013-.04.062.062 0 0 0-.013-.04.068.068 0 0 0-.034-.026l-.641-.37a.26.26 0 0 0-.221 0l-.642.374zM428.74 578.46a.075.075 0 0 0-.035.026.068.068 0 0 0 .035.105l.641.37a.242.242 0 0 0 .222 0l.643-.37a.066.066 0 0 0 .032-.025c.009-.012.013-.026.013-.04s-.004-.028-.013-.04a.074.074 0 0 0-.032-.026l-.639-.371a.26.26 0 0 0-.221 0l-.646.371zM427.62 579.11c-.062.036-.066.094 0 .129l.64.371a.255.255 0 0 0 .222 0l.644-.373a.065.065 0 0 0 .034-.025.068.068 0 0 0 .013-.039.07.07 0 0 0-.013-.04.07.07 0 0 0-.034-.025l-.642-.371a.248.248 0 0 0-.222 0l-.642.373zM427.51 581.71c-.063.037-.063.1 0 .13l.642.37a.237.237 0 0 0 .222 0l.641-.37c.063-.033.063-.093 0-.13l-.639-.373a.251.251 0 0 0-.223 0l-.643.373zM424.3 579.73a.07.07 0 0 0-.034.025.069.069 0 0 0 0 .078c.009.011.02.02.034.024l.638.373a.255.255 0 0 0 .223 0l.643-.373c.061-.035.063-.093 0-.131l-.637-.371a.255.255 0 0 0-.222 0l-.645.375zM426.5 579.76c-.062.036-.062.093 0 .128l.64.372a.247.247 0 0 0 .221 0l.646-.372a.064.064 0 0 0 .032-.024c.008-.012.013-.026.013-.04a.07.07 0 0 0-.045-.064l-.641-.373a.261.261 0 0 0-.222 0l-.644.373zM425.38 580.4c-.063.04-.063.1 0 .13l.638.371a.243.243 0 0 0 .223 0l.644-.371c.062-.032.062-.09 0-.13l-.639-.369a.25.25 0 0 0-.111-.027.256.256 0 0 0-.111.027l-.644.369zM429.82 579.12c-.062.037-.063.094 0 .128l.641.372a.247.247 0 0 0 .219 0l.644-.372c.06-.034.061-.091 0-.128l-.639-.371a.243.243 0 0 0-.219 0l-.646.371zM428.7 579.77a.072.072 0 0 0-.032.025.069.069 0 0 0 0 .078c.008.011.019.02.032.024l.643.373c.034.017.072.025.11.025s.076-.008.11-.025l.643-.373c.059-.037.059-.093 0-.127l-.64-.372a.247.247 0 0 0-.22 0l-.646.372zM427.58 580.42c-.062.037-.062.093 0 .128l.64.373a.242.242 0 0 0 .222 0l.644-.371a.064.064 0 0 0 .032-.024c.008-.012.013-.026.013-.04a.07.07 0 0 0-.045-.064l-.638-.371a.261.261 0 0 0-.222 0l-.646.369zM426.45 581.07a.068.068 0 0 0-.047.065c0 .014.005.028.013.039.009.012.02.021.034.025l.64.37a.247.247 0 0 0 .22 0l.643-.37c.064-.036.064-.093 0-.129l-.639-.37a.237.237 0 0 0-.223 0l-.641.37zM426.39 582.37c-.062.033-.062.091 0 .128l.64.37a.236.236 0 0 0 .221 0l.644-.37c.061-.037.061-.1 0-.128l-.642-.373a.236.236 0 0 0-.221 0l-.642.373zM423.02 580.46c-.06.038-.06.1 0 .128l.642.372a.247.247 0 0 0 .221 0l.642-.372c.063-.037.063-.093 0-.129l-.642-.371a.23.23 0 0 0-.219 0l-.644.372zM424.25 581.05c-.063.038-.063.094 0 .127l.641.373a.23.23 0 0 0 .222 0l.643-.371c.059-.035.059-.091 0-.129l-.64-.372a.25.25 0 0 0-.111-.027.256.256 0 0 0-.111.027l-.644.372zM425.33 581.71c-.06.037-.064.1 0 .13l.637.37a.237.237 0 0 0 .222 0l.645-.37c.013-.005.025-.013.033-.025s.013-.026.013-.04-.005-.028-.013-.04a.075.075 0 0 0-.033-.025l-.639-.373a.256.256 0 0 0-.223 0l-.642.373zM434.19 577.83c-.061.036-.061.09 0 .128l.641.371c.034.017.071.025.109.025s.075-.008.109-.025l.645-.371c.062-.038.062-.092 0-.128l-.64-.371a.247.247 0 0 0-.221 0l-.643.371zM433.12 578.44c-.065.034-.065.092 0 .131l.637.369a.229.229 0 0 0 .111.028.23.23 0 0 0 .112-.028l.643-.369c.06-.039.06-.1 0-.131l-.639-.37a.23.23 0 0 0-.223 0l-.641.37zM432 579.09c-.059.037-.059.091 0 .127l.64.372a.255.255 0 0 0 .222 0l.642-.372c.065-.036.065-.09 0-.129l-.637-.37a.241.241 0 0 0-.224 0l-.643.372zM421.94 579.83a.065.065 0 0 0-.034.024c-.009.012-.014.026-.014.04s.005.028.014.04c.008.011.02.02.034.024l.639.37a.237.237 0 0 0 .222 0l5.13-2.964c.061-.035.061-.091 0-.129l-.637-.369a.237.237 0 0 0-.222 0l-5.132 2.964zM420.8 580.49c-.063.036-.063.093 0 .13l.638.37a.243.243 0 0 0 .223 0l.642-.371c.063-.036.063-.093 0-.129l-.64-.37c-.034-.018-.072-.027-.111-.027s-.077.009-.111.027l-.641.37zM419.66 581.17a.07.07 0 0 0-.045.065.067.067 0 0 0 .045.064l.639.373a.253.253 0 0 0 .222 0l.641-.373c.062-.038.062-.093 0-.129l-.64-.372a.242.242 0 0 0-.222 0l-.64.372zM421.92 581.14c-.061.033-.065.09 0 .127l.64.371a.233.233 0 0 0 .223 0l.641-.371c.062-.037.066-.094 0-.127l-.637-.37a.243.243 0 0 0-.225 0l-.642.37zM433.16 577.11c-.064.035-.064.092 0 .129l.638.37a.247.247 0 0 0 .22 0l.643-.37c.064-.038.064-.094 0-.131l-.639-.372a.268.268 0 0 0-.111-.025.27.27 0 0 0-.112.025l-.639.374zM432.04 577.76c-.064.042-.064.1 0 .131l.637.372a.227.227 0 0 0 .221 0l.647-.372c.06-.036.06-.089 0-.131l-.639-.37a.27.27 0 0 0-.224 0l-.642.37zM430.92 578.41a.075.075 0 0 0-.033.025.073.073 0 0 0-.013.04.07.07 0 0 0 .046.065l.639.371a.247.247 0 0 0 .221 0l.646-.371a.072.072 0 0 0 .032-.025c.008-.012.012-.026.012-.04s-.004-.027-.012-.039-.019-.021-.032-.026l-.64-.372a.247.247 0 0 0-.111-.025.246.246 0 0 0-.11.025l-.645.372zM423.11 581.78a.068.068 0 0 0-.032.026c-.007.012-.012.025-.012.039s.005.028.012.039a.068.068 0 0 0 .032.026l.64.37a.23.23 0 0 0 .222 0l.643-.37a.07.07 0 0 0 .034-.025.072.072 0 0 0 0-.08.078.078 0 0 0-.034-.025l-.637-.372a.267.267 0 0 0-.222 0l-.646.372zM421.86 582.42c-.062.036-.062.091 0 .128l.641.372a.244.244 0 0 0 .219 0l.645-.372c.063-.037.063-.094 0-.128l-.642-.373a.247.247 0 0 0-.221 0l-.642.373zM419.69 583.7a.072.072 0 0 0-.032.025c-.008.012-.012.026-.012.04s.004.027.012.039c.008.011.019.02.032.025l.64.371c.034.018.072.027.111.027s.077-.009.111-.027l1.761-1.021c.067-.034.067-.092 0-.128l-.637-.371a.227.227 0 0 0-.222 0l-1.764 1.02zM424.21 582.37c-.062.033-.062.091 0 .128l.637.37a.243.243 0 0 0 .223 0l.643-.37c.062-.037.062-.1 0-.128l-.641-.373a.236.236 0 0 0-.221 0l-.641.373zM423.07 583.05c-.062.036-.062.094 0 .128l.638.372a.248.248 0 0 0 .221 0l.643-.372c.062-.034.064-.094 0-.128l-.636-.371a.227.227 0 0 0-.222 0l-.644.371zM420.84 584.31a.075.075 0 0 0-.033.025c-.008.012-.012.025-.012.039s.004.028.012.04c.008.011.02.02.033.024l.637.371a.243.243 0 0 0 .224 0l1.764-1.019a.073.073 0 0 0 .034-.024.072.072 0 0 0 0-.08.084.084 0 0 0-.034-.025l-.639-.371a.248.248 0 0 0-.221 0l-1.765 1.02zM425.27 582.98a.067.067 0 0 0-.045.064.067.067 0 0 0 .045.064l.64.368a.237.237 0 0 0 .222 0l.642-.372c.062-.033.062-.09 0-.124l-.637-.374a.247.247 0 0 0-.225 0l-.642.374zM421.9 584.92c-.064.035-.064.092 0 .127l.637.372a.242.242 0 0 0 .222 0l1.767-1.02c.063-.035.063-.093 0-.129l-.641-.372a.257.257 0 0 0-.22 0l-1.765 1.022zM418.55 581.81c-.063.037-.063.1 0 .13l.638.37a.242.242 0 0 0 .222 0l.644-.372c.061-.033.061-.091 0-.128l-.639-.372a.248.248 0 0 0-.222 0l-.643.372zM417.4 582.45c-.063.038-.063.092 0 .128l.638.373a.248.248 0 0 0 .223 0l.642-.373c.061-.036.061-.09 0-.128l-.639-.371a.236.236 0 0 0-.221 0l-.643.371z"
            fill="#4A4A4A"
        />
        <path
            d="m419.41 582.31.644-.372a.064.064 0 0 0 .032-.024.071.071 0 0 0 .012-.038v.126a.067.067 0 0 1-.012.039.066.066 0 0 1-.032.025l-.643.371-.001-.127z"
            fill="#636363"
        />
        <path
            d="M418.5 581.88a.086.086 0 0 0 .048.064l.638.37c.034.018.072.027.111.027s.077-.009.111-.027v.127a.229.229 0 0 1-.111.028.23.23 0 0 1-.112-.028l-.636-.371a.068.068 0 0 1-.033-.025.067.067 0 0 1-.015-.039l-.001-.126z"
            fill="#3D3D3D"
        />
        <path
            d="m418.27 582.95.643-.373a.077.077 0 0 0 .045-.065v.129c-.002.014-.007.028-.015.039s-.019.021-.032.026l-.643.371.002-.127z"
            fill="#636363"
        />
        <path
            d="M417.36 582.51a.1.1 0 0 0 .016.038.08.08 0 0 0 .031.027l.638.371a.243.243 0 0 0 .224 0v.127a.235.235 0 0 1-.22 0l-.642-.371a.086.086 0 0 1-.047-.065v-.127z"
            fill="#3D3D3D"
        />
        <path
            d="m428.58 576.93.643-.371a.073.073 0 0 0 .047-.063v.127a.073.073 0 0 1-.015.039.072.072 0 0 1-.032.025l-.643.371v-.128z"
            fill="#636363"
        />
        <path
            d="M427.68 576.5a.077.077 0 0 0 .014.039c.009.011.021.02.035.024l.635.371a.24.24 0 0 0 .224 0v.128a.241.241 0 0 1-.224 0l-.635-.369a.066.066 0 0 1-.034-.025.07.07 0 0 1-.015-.039v-.129z"
            fill="#3D3D3D"
        />
        <path
            d="m431.74 580.27.643-.373a.072.072 0 0 0 .032-.025.07.07 0 0 0 .015-.039v.131c0 .021-.016.042-.047.06l-.643.373v-.127z"
            fill="#636363"
        />
        <path
            d="M430.83 579.84a.073.073 0 0 0 .045.062l.64.373a.25.25 0 0 0 .111.025.246.246 0 0 0 .11-.025v.127a.247.247 0 0 1-.221 0l-.64-.373c-.031-.018-.045-.037-.045-.06v-.129z"
            fill="#3D3D3D"
        />
        <path
            d="m430.62 580.92.643-.373a.066.066 0 0 0 .031-.026.068.068 0 0 0 .013-.039v.127a.094.094 0 0 1-.013.044.09.09 0 0 1-.031.033l-.643.37v-.136z"
            fill="#636363"
        />
        <path
            d="M429.71 580.48a.076.076 0 0 0 .045.065l.64.373a.27.27 0 0 0 .112.025.268.268 0 0 0 .111-.025v.127a.24.24 0 0 1-.223 0l-.64-.371c-.013-.007-.023-.017-.031-.029s-.013-.025-.014-.039v-.126z"
            fill="#3D3D3D"
        />
        <path
            d="m429.49 581.57.645-.37a.086.086 0 0 0 .031-.026.092.092 0 0 0 .014-.037v.125a.068.068 0 0 1-.013.039.068.068 0 0 1-.032.026l-.645.372v-.129z"
            fill="#636363"
        />
        <path
            d="M428.59 581.13c0 .022.013.044.047.063l.638.37a.231.231 0 0 0 .219 0v.129c-.034.018-.072.026-.11.026s-.075-.008-.109-.026l-.638-.372c-.013-.004-.025-.013-.033-.024s-.013-.025-.014-.039v-.127z"
            fill="#3D3D3D"
        />
        <path
            d="m430.8 577 1.766-1.019a.078.078 0 0 0 .033-.024.08.08 0 0 0 .014-.039v.127a.072.072 0 0 1-.013.038.07.07 0 0 1-.033.024l-1.767 1.023V577z"
            fill="#636363"
        />
        <path
            d="M429.9 576.56a.088.088 0 0 0 .015.039.07.07 0 0 0 .031.026l.639.372a.225.225 0 0 0 .11.028.22.22 0 0 0 .11-.028v.13a.217.217 0 0 1-.218 0l-.641-.371a.075.075 0 0 1-.031-.025.093.093 0 0 1-.015-.039v-.132z"
            fill="#3D3D3D"
        />
        <path
            d="m429.73 577.59.645-.373a.072.072 0 0 0 .044-.063v.127c0 .024-.019.045-.046.066l-.645.37.002-.127z"
            fill="#636363"
        />
        <path
            d="M428.83 577.16a.084.084 0 0 0 .015.038c.009.011.02.02.032.025l.638.37a.243.243 0 0 0 .223 0v.127a.24.24 0 0 1-.223 0l-.638-.37a.1.1 0 0 1-.032-.026.084.084 0 0 1-.015-.038v-.126z"
            fill="#3D3D3D"
        />
        <path
            d="m428.53 578.29.642-.373a.07.07 0 0 0 .033-.026.068.068 0 0 0 .013-.039v.128a.084.084 0 0 1-.014.04.084.084 0 0 1-.032.027l-.642.372v-.129z"
            fill="#636363"
        />
        <path
            d="M427.62 577.85c.001.014.005.027.013.038s.019.019.031.024l.643.373a.236.236 0 0 0 .221 0v.129a.235.235 0 0 1-.221 0l-.643-.372a.08.08 0 0 1-.028-.027.072.072 0 0 1-.013-.037l-.003-.128z"
            fill="#3D3D3D"
        />
        <path
            d="m427.41 578.94.643-.373c.012-.006.023-.015.031-.026s.013-.024.015-.037v.127a.08.08 0 0 1-.014.039.082.082 0 0 1-.032.026l-.642.37-.001-.126z"
            fill="#636363"
        />
        <path
            d="M426.5 578.5a.079.079 0 0 0 .044.066l.637.37c.035.017.073.025.112.025s.077-.008.112-.025v.126a.256.256 0 0 1-.225 0l-.637-.369a.068.068 0 0 1-.031-.027.076.076 0 0 1-.013-.039l.001-.127z"
            fill="#3D3D3D"
        />
        <path
            d="m426.28 579.58.643-.372a.067.067 0 0 0 .045-.064v.136a.072.072 0 0 1-.045.063l-.643.373v-.136z"
            fill="#636363"
        />
        <path
            d="M425.38 579.15a.107.107 0 0 0 .014.039c.008.011.019.02.031.026l.639.369a.243.243 0 0 0 .223 0v.13a.255.255 0 0 1-.223 0l-.639-.373a.08.08 0 0 1-.044-.063l-.001-.128z"
            fill="#3D3D3D"
        />
        <path
            d="m431.88 577.63 1.764-1.019c.013-.005.024-.014.032-.025s.013-.025.014-.039v.129c0 .023-.013.045-.046.064l-1.764 1.019v-.129z"
            fill="#636363"
        />
        <path
            d="M430.98 577.19c0 .014.005.027.013.038s.019.019.032.024l.641.371a.232.232 0 0 0 .222 0v.129a.242.242 0 0 1-.222 0l-.641-.372a.066.066 0 0 1-.03-.027.064.064 0 0 1-.012-.038l-.003-.125z"
            fill="#3D3D3D"
        />
        <path
            d="m430.76 578.28.643-.372c.031-.021.046-.042.046-.065v.129c-.002.014-.007.027-.015.038s-.019.02-.031.025l-.643.372v-.127z"
            fill="#636363"
        />
        <path
            d="M429.85 577.84a.073.073 0 0 0 .016.037c.008.011.018.02.031.026l.638.372a.243.243 0 0 0 .223 0v.127a.226.226 0 0 1-.111.028.225.225 0 0 1-.11-.028l-.64-.372c-.029-.017-.047-.038-.045-.061l-.002-.129z"
            fill="#3D3D3D"
        />
        <path
            d="m429.6 578.96.643-.37a.095.095 0 0 0 .032-.028.09.09 0 0 0 .016-.039v.128a.078.078 0 0 1-.015.039.07.07 0 0 1-.033.026l-.643.374v-.13z"
            fill="#636363"
        />
        <path
            d="M428.7 578.52a.097.097 0 0 0 .015.04.09.09 0 0 0 .031.027l.641.37a.242.242 0 0 0 .222 0v.13a.242.242 0 0 1-.222 0l-.641-.372c-.012-.005-.022-.014-.03-.025s-.012-.023-.014-.037l-.002-.133z"
            fill="#3D3D3D"
        />
        <path
            d="m428.48 579.61.644-.373c.029-.018.047-.041.044-.063v.128c0 .025-.018.044-.047.064l-.644.37.003-.126z"
            fill="#636363"
        />
        <path
            d="M427.57 579.18c0 .022.016.043.047.061l.64.371a.255.255 0 0 0 .222 0v.126a.242.242 0 0 1-.222 0l-.64-.37c-.031-.02-.047-.039-.047-.064v-.124z"
            fill="#3D3D3D"
        />
        <path
            d="m428.37 582.21.641-.37a.082.082 0 0 0 .032-.026.082.082 0 0 0 .013-.04v.129a.071.071 0 0 1-.012.038.065.065 0 0 1-.031.026l-.643.372v-.129z"
            fill="#636363"
        />
        <path
            d="M427.46 581.78a.069.069 0 0 0 .013.037c.007.011.018.02.03.025l.642.37c.034.019.072.028.111.028s.077-.009.111-.028v.129c-.034.018-.072.027-.111.027s-.077-.009-.111-.027l-.639-.372a.066.066 0 0 1-.033-.024.066.066 0 0 1-.013-.04v-.125z"
            fill="#3D3D3D"
        />
        <path
            d="m425.16 580.23.643-.373a.068.068 0 0 0 .032-.026.07.07 0 0 0 .015-.039v.128a.075.075 0 0 1-.047.066l-.643.37v-.126z"
            fill="#636363"
        />
        <path
            d="M424.25 579.8a.077.077 0 0 0 .046.065l.638.373a.255.255 0 0 0 .223 0v.126a.24.24 0 0 1-.223 0l-.638-.37a.09.09 0 0 1-.032-.026.077.077 0 0 1-.014-.039v-.129z"
            fill="#3D3D3D"
        />
        <path
            d="m427.36 580.26.646-.372a.078.078 0 0 0 .03-.027.073.073 0 0 0 .014-.038v.128a.082.082 0 0 1-.013.038.08.08 0 0 1-.031.027l-.643.371-.003-.127z"
            fill="#636363"
        />
        <path
            d="M426.45 579.82c.002.014.007.027.015.038s.019.019.031.025l.64.372a.251.251 0 0 0 .221 0v.127a.23.23 0 0 1-.224 0l-.637-.369a.068.068 0 0 1-.032-.026.088.088 0 0 1-.015-.039l.001-.128z"
            fill="#3D3D3D"
        />
        <path
            d="m426.24 580.9.644-.371c.014-.005.025-.014.033-.026s.012-.026.012-.041v.131c0 .014-.005.027-.013.038s-.019.02-.032.024l-.644.375v-.13z"
            fill="#636363"
        />
        <path
            d="M425.33 580.47a.072.072 0 0 0 .013.038.065.065 0 0 0 .031.026l.638.371a.243.243 0 0 0 .223 0v.13a.248.248 0 0 1-.222 0l-.639-.375c-.013-.005-.023-.013-.031-.024s-.012-.024-.013-.038v-.128z"
            fill="#3D3D3D"
        />
        <path
            d="m430.68 579.62.644-.372a.08.08 0 0 0 .031-.027.098.098 0 0 0 .014-.037v.128c0 .024-.012.045-.045.066l-.644.371v-.129z"
            fill="#636363"
        />
        <path
            d="M429.78 579.19c.001.013.005.027.013.038s.019.02.031.026l.641.372a.256.256 0 0 0 .219 0v.129a.243.243 0 0 1-.219 0l-.641-.371a.09.09 0 0 1-.044-.066v-.128z"
            fill="#3D3D3D"
        />
        <path
            d="m429.56 580.27.643-.373a.075.075 0 0 0 .031-.025.093.093 0 0 0 .015-.039v.128c0 .024-.016.045-.047.063l-.643.373.001-.127z"
            fill="#636363"
        />
        <path
            d="M428.65 579.84a.09.09 0 0 0 .016.036.09.09 0 0 0 .029.026l.643.373a.25.25 0 0 0 .22 0v.127a.244.244 0 0 1-.22 0l-.641-.373c-.028-.018-.045-.037-.045-.06l-.002-.129z"
            fill="#3D3D3D"
        />
        <path
            d="m428.44 580.92.644-.371a.079.079 0 0 0 .032-.026.088.088 0 0 0 .015-.039v.127a.085.085 0 0 1-.047.068l-.644.37v-.129z"
            fill="#636363"
        />
        <path
            d="M427.53 580.48a.08.08 0 0 0 .046.062l.64.373a.242.242 0 0 0 .222 0v.129a.227.227 0 0 1-.222 0l-.64-.37c-.012-.006-.023-.016-.031-.028s-.013-.025-.015-.04v-.126z"
            fill="#3D3D3D"
        />
        <path
            d="m427.31 581.57.644-.37c.034-.019.049-.041.049-.063v.125a.077.077 0 0 1-.047.065l-.642.372-.004-.129z"
            fill="#636363"
        />
        <path
            d="M426.41 581.13c.003.014.008.026.016.037s.019.02.03.026l.64.37a.235.235 0 0 0 .22 0v.129a.24.24 0 0 1-.224 0l-.638-.369a.097.097 0 0 1-.048-.066l.004-.127z"
            fill="#3D3D3D"
        />
        <path
            d="m427.25 582.86.644-.37a.074.074 0 0 0 .031-.027.088.088 0 0 0 .015-.039v.127a.077.077 0 0 1-.014.039.068.068 0 0 1-.032.026l-.644.371v-.127z"
            fill="#636363"
        />
        <path
            d="M426.34 582.43a.079.079 0 0 0 .044.066l.64.37a.235.235 0 0 0 .221 0v.127a.236.236 0 0 1-.221 0l-.64-.371a.06.06 0 0 1-.031-.026.068.068 0 0 1-.013-.039v-.127z"
            fill="#3D3D3D"
        />
        <path
            d="m424.04 580.88.642-.374a.081.081 0 0 0 .031-.024.073.073 0 0 0 .014-.038v.126a.093.093 0 0 1-.015.039.09.09 0 0 1-.032.026l-.642.373.002-.128z"
            fill="#636363"
        />
        <path
            d="M422.98 580.53a.072.072 0 0 0 .013.038.068.068 0 0 0 .032.026l.642.372a.235.235 0 0 0 .221 0v.128a.247.247 0 0 1-.221 0l-.642-.371a.072.072 0 0 1-.031-.026.08.08 0 0 1-.014-.039v-.128z"
            fill="#3D3D3D"
        />
        <path
            d="m425.12 581.55.643-.371a.079.079 0 0 0 .044-.066v.13a.079.079 0 0 1-.013.039.079.079 0 0 1-.031.026l-.643.371v-.129z"
            fill="#636363"
        />
        <path
            d="M424.21 581.12c0 .014.005.027.012.038a.065.065 0 0 0 .031.026l.641.373a.227.227 0 0 0 .222 0v.129a.237.237 0 0 1-.222 0l-.641-.371a.083.083 0 0 1-.03-.026.086.086 0 0 1-.013-.038v-.131z"
            fill="#3D3D3D"
        />
        <path
            d="m426.19 582.21.645-.37a.076.076 0 0 0 .045-.066v.129a.076.076 0 0 1-.016.038.082.082 0 0 1-.032.026l-.641.372-.001-.129z"
            fill="#636363"
        />
        <path
            d="M425.28 581.78a.073.073 0 0 0 .014.038c.009.011.02.019.032.024l.637.37a.229.229 0 0 0 .111.028.226.226 0 0 0 .111-.028v.129a.244.244 0 0 1-.226 0l-.637-.372a.066.066 0 0 1-.032-.025.069.069 0 0 1-.014-.039l.004-.125z"
            fill="#3D3D3D"
        />
        <path
            d="m435.05 578.32.645-.371c.031-.02.05-.043.05-.066v.13a.095.095 0 0 1-.016.039.1.1 0 0 1-.032.026l-.647.369v-.127z"
            fill="#636363"
        />
        <path
            d="M434.15 577.88c0 .023.02.044.047.063l.641.369c.034.019.071.028.109.028s.076-.009.109-.028v.129a.23.23 0 0 1-.218 0l-.64-.371a.086.086 0 0 1-.031-.026.087.087 0 0 1-.017-.038v-.126z"
            fill="#3D3D3D"
        />
        <path
            d="m433.98 578.94.643-.369c.031-.022.046-.042.046-.068v.129a.08.08 0 0 1-.014.039.09.09 0 0 1-.032.026l-.645.369.002-.126z"
            fill="#636363"
        />
        <path
            d="M433.08 578.5c0 .025.015.046.047.066l.637.369a.233.233 0 0 0 .223 0v.126a.233.233 0 0 1-.223 0l-.637-.369c-.013-.005-.024-.014-.032-.025s-.013-.024-.015-.038v-.129z"
            fill="#3D3D3D"
        />
        <path
            d="m432.86 579.59.642-.372c.032-.018.049-.038.049-.066v.128a.073.073 0 0 1-.015.04.078.078 0 0 1-.034.025l-.642.373v-.128z"
            fill="#636363"
        />
        <path
            d="M431.96 579.15a.072.072 0 0 0 .013.038.063.063 0 0 0 .03.026l.64.372a.255.255 0 0 0 .222 0v.129a.251.251 0 0 1-.222 0l-.64-.373a.072.072 0 0 1-.03-.025.078.078 0 0 1-.013-.037v-.13z"
            fill="#3D3D3D"
        />
        <path
            d="m422.8 580.33 5.152-2.989a.082.082 0 0 0 .032-.026.092.092 0 0 0 .015-.04v.129c0 .022-.016.046-.069.091l-5.13 2.964v-.129zM421.66 580.99l.642-.371a.079.079 0 0 0 .045-.064v.127a.079.079 0 0 1-.045.065l-.642.37v-.127z"
            fill="#636363"
        />
        <path
            d="M420.75 580.56a.083.083 0 0 0 .048.065l.638.37a.24.24 0 0 0 .223 0v.127a.24.24 0 0 1-.223 0l-.638-.37a.09.09 0 0 1-.032-.026.073.073 0 0 1-.014-.038l-.002-.128zM421.9 579.9a.077.077 0 0 0 .046.064l.639.373a.253.253 0 0 0 .222 0v.125a.242.242 0 0 1-.222 0l-.639-.37a.072.072 0 0 1-.032-.025.072.072 0 0 1-.014-.04v-.127z"
            fill="#3D3D3D"
        />
        <path
            d="m420.52 581.67.641-.373c.035-.019.05-.041.05-.067v.129a.08.08 0 0 1-.014.04.074.074 0 0 1-.032.026l-.645.372v-.127z"
            fill="#636363"
        />
        <path
            d="M419.62 581.23a.082.082 0 0 0 .013.038c.008.011.018.02.03.026l.639.373a.253.253 0 0 0 .222 0v.127a.248.248 0 0 1-.222 0l-.639-.372a.073.073 0 0 1-.029-.026.07.07 0 0 1-.014-.037v-.129z"
            fill="#3D3D3D"
        />
        <path
            d="M428.82 575.79c-.062.032-.062.092 0 .128l.638.371c.034.018.072.028.11.028s.076-.01.11-.028l1.771-1.02c.06-.036.061-.091 0-.13l-.641-.371a.247.247 0 0 0-.111-.025.246.246 0 0 0-.11.025l-1.767 1.022z"
            fill="#4A4A4A"
        />
        <path
            d="m429.68 576.29 1.771-1.02a.09.09 0 0 0 .046-.062v.125c-.002.014-.007.027-.015.038s-.019.02-.031.026l-1.766 1.023-.005-.13z"
            fill="#636363"
        />
        <path
            d="M428.77 575.85a.07.07 0 0 0 .015.039c.008.011.019.02.033.026l.638.371a.23.23 0 0 0 .22 0v.13a.255.255 0 0 1-.223 0l-.638-.375a.073.073 0 0 1-.034-.026.077.077 0 0 1-.014-.039l.003-.126z"
            fill="#3D3D3D"
        />
        <path
            d="m422.78 581.64.641-.371a.083.083 0 0 0 .033-.026.084.084 0 0 0 .014-.04v.128a.084.084 0 0 1-.014.04.083.083 0 0 1-.033.026l-.641.372v-.129z"
            fill="#636363"
        />
        <path
            d="M421.88 581.2a.077.077 0 0 0 .015.036c.008.011.019.02.031.025l.64.371a.24.24 0 0 0 .223 0v.129a.24.24 0 0 1-.223 0l-.64-.372c-.012-.006-.022-.015-.03-.026s-.013-.024-.014-.037l-.002-.126z"
            fill="#3D3D3D"
        />
        <path
            d="m434.02 577.61.643-.37c.034-.019.048-.04.048-.066v.128a.08.08 0 0 1-.014.04.078.078 0 0 1-.034.025l-.643.369v-.126z"
            fill="#636363"
        />
        <path
            d="M433.12 577.18a.075.075 0 0 0 .047.066l.638.37a.247.247 0 0 0 .22 0v.126a.247.247 0 0 1-.22 0l-.638-.369c-.033-.019-.047-.041-.047-.063v-.13z"
            fill="#3D3D3D"
        />
        <path
            d="m432.9 578.26.647-.372a.084.084 0 0 0 .031-.025.082.082 0 0 0 .013-.037v.126a.073.073 0 0 1-.014.038.08.08 0 0 1-.03.028l-.647.369v-.127z"
            fill="#636363"
        />
        <path
            d="M431.99 577.83c0 .022.015.044.048.062l.637.372a.227.227 0 0 0 .221 0v.127a.235.235 0 0 1-.221 0l-.637-.369c-.031-.02-.048-.042-.048-.064v-.128z"
            fill="#3D3D3D"
        />
        <path
            d="m431.78 578.91.646-.371a.076.076 0 0 0 .032-.027.077.077 0 0 0 .014-.039v.13a.073.073 0 0 1-.014.038.077.077 0 0 1-.032.024l-.646.374v-.129z"
            fill="#636363"
        />
        <path
            d="M430.87 578.48a.073.073 0 0 0 .014.037c.007.011.018.02.03.027l.639.371a.248.248 0 0 0 .221 0v.129a.26.26 0 0 1-.221 0l-.639-.374a.083.083 0 0 1-.03-.026.077.077 0 0 1-.012-.036l-.002-.128z"
            fill="#3D3D3D"
        />
        <path
            d="m423.99 582.2.64-.371a.075.075 0 0 0 .033-.025.073.073 0 0 0 .013-.04v.126a.064.064 0 0 1-.013.04.066.066 0 0 1-.033.026l-.64.374v-.13z"
            fill="#636363"
        />
        <path
            d="M423.07 581.85a.072.072 0 0 0 .013.038c.007.011.018.02.03.025l.64.37a.23.23 0 0 0 .222 0v.13a.248.248 0 0 1-.222 0l-.64-.369c-.03-.023-.043-.041-.043-.069v-.125z"
            fill="#3D3D3D"
        />
        <path
            d="m422.72 582.92.645-.372a.085.085 0 0 0 .032-.025.095.095 0 0 0 .016-.037v.126c-.002.014-.007.026-.015.037s-.019.02-.031.026l-.647.37v-.125z"
            fill="#636363"
        />
        <path
            d="M421.81 582.49c.001.014.005.026.013.037s.018.02.031.025l.641.372a.24.24 0 0 0 .219 0v.125a.23.23 0 0 1-.219 0l-.639-.368a.068.068 0 0 1-.032-.026.077.077 0 0 1-.014-.039v-.126z"
            fill="#3D3D3D"
        />
        <path
            d="m420.55 584.2 1.761-1.021c.013-.005.025-.013.034-.024s.014-.025.016-.039v.127a.073.073 0 0 1-.046.063l-1.765 1.022v-.128z"
            fill="#636363"
        />
        <path
            d="M419.64 583.76a.082.082 0 0 0 .043.066l.64.371a.242.242 0 0 0 .222 0v.128a.242.242 0 0 1-.222 0l-.64-.374a.08.08 0 0 1-.03-.025.082.082 0 0 1-.013-.037v-.129z"
            fill="#3D3D3D"
        />
        <path
            d="m425.07 582.86.643-.37a.076.076 0 0 0 .032-.027.077.077 0 0 0 .014-.039v.127a.077.077 0 0 1-.014.039.068.068 0 0 1-.032.026l-.643.371v-.127z"
            fill="#636363"
        />
        <path
            d="M424.16 582.43a.076.076 0 0 0 .015.04c.008.011.019.02.032.026l.637.37a.243.243 0 0 0 .223 0v.127a.24.24 0 0 1-.223 0l-.637-.371a.066.066 0 0 1-.032-.025.067.067 0 0 1-.015-.038v-.129z"
            fill="#3D3D3D"
        />
        <path
            d="m423.95 583.51.642-.372a.082.082 0 0 0 .032-.026.084.084 0 0 0 .014-.04v.128a.078.078 0 0 1-.012.039.079.079 0 0 1-.031.026l-.645.37v-.125z"
            fill="#636363"
        />
        <path
            d="M423.02 583.12a.073.073 0 0 0 .048.062l.638.372a.247.247 0 0 0 .221 0v.128a.247.247 0 0 1-.221 0l-.638-.373a.076.076 0 0 1-.033-.023.071.071 0 0 1-.015-.037v-.129z"
            fill="#3D3D3D"
        />
        <path
            d="m421.7 584.81 1.764-1.019a.085.085 0 0 0 .033-.026.085.085 0 0 0 .015-.04v.127a.077.077 0 0 1-.014.039.076.076 0 0 1-.034.025l-1.762 1.021-.002-.127z"
            fill="#636363"
        />
        <path
            d="M420.79 584.38a.086.086 0 0 0 .016.038c.009.011.02.02.032.025l.637.371a.243.243 0 0 0 .224 0v.127a.247.247 0 0 1-.226 0l-.637-.371c-.013-.005-.024-.014-.032-.025s-.012-.025-.013-.039l-.001-.126z"
            fill="#3D3D3D"
        />
        <path
            d="m426.13 583.48.642-.372a.068.068 0 0 0 .032-.023.084.084 0 0 0 .015-.038v.128a.086.086 0 0 1-.047.064l-.643.371.001-.13z"
            fill="#636363"
        />
        <path
            d="M425.22 583.04c0 .025.015.045.046.064l.64.368a.226.226 0 0 0 .111.028.229.229 0 0 0 .111-.028v.13a.255.255 0 0 1-.222 0l-.64-.371a.07.07 0 0 1-.031-.025.068.068 0 0 1-.015-.037v-.129z"
            fill="#3D3D3D"
        />
        <path
            d="m425.01 584.13.641-.371c.013-.005.024-.014.032-.025s.013-.025.014-.039v.125a.07.07 0 0 1-.046.065l-.641.373v-.128z"
            fill="#636363"
        />
        <path
            d="M424.1 583.69a.096.096 0 0 0 .014.038c.008.011.019.02.031.026l.639.371a.243.243 0 0 0 .225 0v.128a.247.247 0 0 1-.225 0l-.639-.373a.07.07 0 0 1-.031-.025.082.082 0 0 1-.013-.038l-.001-.127z"
            fill="#3D3D3D"
        />
        <path
            d="M424.14 583.62a.076.076 0 0 0-.032.027.067.067 0 0 0-.012.039c0 .015.004.029.012.04a.068.068 0 0 0 .032.026l.639.371a.247.247 0 0 0 .225 0l.641-.371c.064-.035.064-.1 0-.132l-.638-.369a.257.257 0 0 0-.22 0l-.647.369z"
            fill="#4A4A4A"
        />
        <path
            d="m422.76 585.42 1.767-1.02a.083.083 0 0 0 .044-.065v.128a.096.096 0 0 1-.014.038.077.077 0 0 1-.03.027l-1.767 1.019v-.127z"
            fill="#636363"
        />
        <path
            d="M421.85 584.99a.07.07 0 0 0 .015.039.07.07 0 0 0 .033.026l.637.372a.242.242 0 0 0 .222 0v.127a.232.232 0 0 1-.222 0l-.637-.373a.066.066 0 0 1-.033-.024.067.067 0 0 1-.015-.038v-.129z"
            fill="#3D3D3D"
        />
        <path
            d="M418.56 583.07c-.058.035-.06.092 0 .126l.643.375a.265.265 0 0 0 .222 0l2.834-1.646a.06.06 0 0 0 .033-.024c.009-.011.013-.025.013-.039s-.004-.028-.013-.039a.066.066 0 0 0-.033-.024l-.639-.374a.247.247 0 0 0-.22 0l-2.84 1.645z"
            fill="#4A4A4A"
        />
        <path
            d="m419.42 583.57 2.834-1.646a.068.068 0 0 0 .032-.026.077.077 0 0 0 .014-.039v.13a.078.078 0 0 1-.015.039.08.08 0 0 1-.033.025l-2.834 1.643.002-.126z"
            fill="#636363"
        />
        <path
            d="M418.52 583.13a.09.09 0 0 0 .044.066l.643.371a.253.253 0 0 0 .222 0v.126a.242.242 0 0 1-.222 0l-.643-.371c-.012-.006-.023-.015-.03-.026s-.012-.024-.012-.038l-.002-.128z"
            fill="#3D3D3D"
        />
        <path
            d="M424.55 577.79a.428.428 0 0 0 .23-.652.427.427 0 0 0-.207-.163l-1.733-1.063a1.553 1.553 0 0 0-1.412-.035l-2.8 1.532a.431.431 0 0 0-.305.4.434.434 0 0 0 .278.419l1.735 1.063a1.549 1.549 0 0 0 1.413.032l2.801-1.533z"
            fill="#9E9D9D"
        />
        <path
            d="m420.82 586.16-.595-.344v-.2l.595.343v.201zM419.83 585.6l-.595-.347v-.194l.595.342v.199z"
            fill="#1C1C1C"
        />
        <path
            d="M436.79 567.71a.613.613 0 0 1 .632 0l.169.1-14.392 8.48-.3 10.521-.345-.2v-9.99a1.266 1.266 0 0 1 .638-1.1l13.598-7.811z"
            fill="#8E8D8D"
        />
        <path
            d="M423.54 575.72a1.277 1.277 0 0 0-.635 1.1v9.992l14.95-8.611v-9.988a.422.422 0 0 0-.635-.368l-13.68 7.875z"
            fill="#C1BFBD"
        />
        <path
            d="m424.85 589.59-5.229 8.2-7.857-2.479 5.711-8.06 7.375 2.339z"
            fill="#fff"
        />
        <path
            d="M420.71 591.72v.071l-5.811 5.247v-.07l5.811-5.248z"
            fill="#8C8B8B"
        />
        <path
            d="M412.55 596.97v.07l-4.924-2.831v-.07l4.924 2.831z"
            fill="#6C6C6C"
        />
        <path
            d="m421.57 590.99-6.68 5.973h-2.342l-4.925-2.831 7.74-6.186 6.207 3.044z"
            fill="#DDE8E7"
        />
        <path d="M414.9 596.97h-2.341v.072h2.341v-.072z" fill="#8C8B8B" />
        <path d="m413.72 596.29 1.174.679h-2.34l1.166-.679z" fill="#E1EAEA" />
        <path
            d="M418.08 591.31v.07l-8.123 4.72v-.071l8.123-4.719z"
            fill="#8C8B8B"
        />
        <path
            d="M409.95 596.03v.07l-6.185-3.57v-.068l6.185 3.568z"
            fill="#616161"
        />
        <path
            d="m418.08 591.31-8.123 4.719-6.185-3.568 8.106-4.71 6.202 3.559z"
            fill="#9C9B9B"
        />
        <path
            d="M418.08 590.96v.071l-8.123 4.72v-.068l8.123-4.723z"
            fill="#8C8B8B"
        />
        <path
            d="M409.95 595.68v.068l-6.185-3.57v-.069l6.185 3.571z"
            fill="#616161"
        />
        <path
            d="m418.08 590.96-8.123 4.723-6.185-3.571 8.106-4.71 6.202 3.558z"
            fill="#9C9B9B"
        />
        <path d="M418.08 590.6v.07l-8.123 4.72v-.07l8.123-4.72z" fill="#8C8B8B" />
        <path d="M409.95 595.32v.07l-6.185-3.57v-.07l6.185 3.57z" fill="#616161" />
        <path
            d="m418.08 590.6-8.123 4.72-6.185-3.57 8.106-4.708 6.202 3.558z"
            fill="#9C9B9B"
        />
        <path
            d="M418.08 590.25v.068l-8.123 4.722v-.069l8.123-4.721z"
            fill="#8C8B8B"
        />
        <path
            d="M409.95 594.97v.069l-6.185-3.571v-.067l6.185 3.569z"
            fill="#616161"
        />
        <path
            d="m418.08 590.25-8.123 4.721-6.185-3.569 8.106-4.711 6.202 3.559z"
            fill="#9C9B9B"
        />
        <path
            d="M418.08 589.89v.068l-8.123 4.721v-.069l8.123-4.72z"
            fill="#8C8B8B"
        />
        <path
            d="M409.95 594.61v.069l-6.185-3.57v-.07l6.185 3.571z"
            fill="#616161"
        />
        <path
            d="m418.08 589.89-8.123 4.72-6.185-3.571 8.106-4.709 6.202 3.56z"
            fill="#9C9B9B"
        />
        <path
            d="M418.08 589.54v.068l-8.123 4.724v-.072l8.123-4.72z"
            fill="#8C8B8B"
        />
        <path
            d="M409.95 594.26v.072l-6.185-3.572v-.071l6.185 3.571z"
            fill="#616161"
        />
        <path
            d="m418.08 589.54-8.123 4.72-6.185-3.571 8.106-4.709 6.202 3.56z"
            fill="#A8AFAF"
        />
        <path
            d="M418.08 589.14v.07l-6.983 4.059v-.07l6.983-4.059z"
            fill="#8C8B8B"
        />
        <path
            d="M408.81 593.2v.07l-5.035-2.908v-.069l5.035 2.907z"
            fill="#6C6C6C"
        />
        <path
            d="m418.08 589.14-6.983 4.059h-2.287l-5.035-2.907 8.125-4.721 6.18 3.569z"
            fill="#D2D8D8"
        />
        <path d="M416.3 589.6v.017l-.829.481v-.016l.829-.482z" fill="#858585" />
        <path
            d="M415.47 590.08v.016l-5.292-3.054v-.018l5.292 3.056z"
            fill="#5D5D5D"
        />
        <path
            d="m416.3 589.6-.829.482-5.292-3.057.829-.482 5.292 3.057z"
            fill="#959595"
        />
        <path d="M415.02 590.32v.018l-.83.481v-.015l.83-.484z" fill="#858585" />
        <path
            d="M414.19 590.81v.015l-5.294-3.055v-.018l5.294 3.058z"
            fill="#5D5D5D"
        />
        <path
            d="m415.02 590.32-.83.484-5.294-3.058.832-.482 5.292 3.056z"
            fill="#959595"
        />
        <path d="M413.74 591.07v.017l-.828.482v-.019l.828-.48z" fill="#858585" />
        <path
            d="M412.91 591.55v.019l-5.292-3.056v-.016l5.292 3.053z"
            fill="#5D5D5D"
        />
        <path
            d="m413.74 591.07-.828.48-5.292-3.053.83-.482 5.29 3.055z"
            fill="#959595"
        />
        <path d="M412.42 591.84v.016l-.831.482v-.015l.831-.483z" fill="#858585" />
        <path
            d="M411.58 592.32v.017l-5.292-3.055v-.019l5.292 3.057z"
            fill="#5D5D5D"
        />
        <path
            d="m412.42 591.84-.831.481-5.292-3.057.829-.48 5.294 3.056z"
            fill="#959595"
        />
        <path d="M411.07 592.62v.017l-.832.484v-.018l.832-.483z" fill="#858585" />
        <path
            d="M410.24 593.1v.018l-5.291-3.056v-.02l5.291 3.058z"
            fill="#5D5D5D"
        />
        <path
            d="m411.07 592.62-.832.483-5.291-3.059.829-.481 5.294 3.057z"
            fill="#959595"
        />
        <path d="M411.1 593.2h-2.291v.07h2.291v-.07z" fill="#8C8B8B" />
        <path d="m409.95 592.54 1.148.662h-2.291l1.143-.662z" fill="#C3C3C3" />
        <path
            d="m407.97 582.3-.009 4.145a.979.979 0 0 1-.578.807 3.089 3.089 0 0 1-2.809 0 .998.998 0 0 1-.586-.82l.014-4.142a.985.985 0 0 0 .586.818 3.092 3.092 0 0 0 2.809 0 .986.986 0 0 0 .576-.808h-.003z"
            fill="#C40505"
        />
        <path
            d="M407.38 581.49a.86.86 0 0 1 .01 1.627 3.1 3.1 0 0 1-2.809 0 .86.86 0 0 1-.01-1.627 3.1 3.1 0 0 1 2.809 0z"
            fill="#E50505"
        />
        <path
            d="M407.27 581.56c.718.39.721 1.024.01 1.413a2.987 2.987 0 0 1-2.586 0c-.717-.389-.719-1.023-.008-1.413a2.976 2.976 0 0 1 2.584 0z"
            fill="#8C0303"
        />
        <path
            d="m408.61 585.92-.733-.423c-.088.063-.179.12-.273.173a1.906 1.906 0 0 1-.237.124l.732.422a.124.124 0 0 0 .058.024.119.119 0 0 0 .062-.011l.512-.3a.118.118 0 0 1-.061.013.119.119 0 0 1-.06-.022z"
            fill="#8C0202"
        />
        <path
            d="m408.68 583.93-.8-.461c-.07.069-.15.128-.237.174-.087.05-.18.091-.276.122l.8.462a.743.743 0 0 1 .333.579v1.527a.233.233 0 0 1-.1.216l.511-.3a.228.228 0 0 0 .1-.215v-1.528a.738.738 0 0 0-.331-.576z"
            fill="#AF0202"
        />
        <path
            d="M408.16 584.22a.736.736 0 0 1 .333.579v1.527c0 .214-.152.3-.337.194l-.8-.463v-.268l.732.422c.092.053.167.013.167-.1v-1.377a.364.364 0 0 0-.168-.289l-.733-.424v-.268l.806.467z"
            fill="#E50505"
        />
        <path
            d="M407.27 582.34a2.994 2.994 0 0 0-2.584 0c-.15.078-.282.186-.388.316.108.135.245.244.4.321a2.98 2.98 0 0 0 2.586 0c.149-.077.281-.185.387-.316a1.276 1.276 0 0 0-.401-.321z"
            fill="#351A0A"
        />
        <path
            d="M407.28 582.98c.067-.037.132-.078.192-.124a.498.498 0 0 0-.206-.267 2.14 2.14 0 0 0-.95-.317.658.658 0 0 1 .394.532.617.617 0 0 1-.121.414c.242-.044.475-.124.691-.238z"
            fill="#683315"
        />
        <path
            d="m413.61 576.12-.548-.6.978-.864 3.424.5 1.841 1.187s.263.251.065.476c-.076.088-.3.014-.419-.042a13.94 13.94 0 0 1-.9-.453c-.252-.163-.393.147-.393.147-.047.116-.4.678-.544.924-.169.295-.44.37-.823.469-.516.133-.549-.025-.676-.154-.033-.036.033-.184.033-.184-.973-.137-2.127-.685-2.038-1.406z"
            fill="#FFE8D9"
        />
        <path
            d="M414.23 574.66s-.238-.157-.556.782a1.379 1.379 0 0 0 .183 1.31s-6.142-1.048-7.068-1.407a5.14 5.14 0 0 1-1.8-.991 2.905 2.905 0 0 1-.639-2.043v-7.823c.121-2.113 1.053-3.2 2.451-2.91 1.928.4 1.338 3.218 1.116 4.507-.147.84-.436 4.366-.551 5.5a1.057 1.057 0 0 0 .7 1.04l6.164 2.035z"
            fill="#D32A1E"
        />
        <path
            d="m442.52 639.51-20.841-12.113 44.349-25.373 20.894 12.113-44.402 25.373z"
            fill="#231F20"
            opacity={0.24}
            style={{ mixBlendMode: "multiply" }}
        />
        <path
            d="m441.97 613.15-.022 22a.657.657 0 0 1-.383.534c-.834.487-2.261.134-2.258-.541l.022-22c0 .679 1.425 1.028 2.257.545a.657.657 0 0 0 .384-.538zM429.9 605.7l-.021 22a.641.641 0 0 1-.119.321.641.641 0 0 1-.264.217 2.07 2.07 0 0 1-1.867 0 .66.66 0 0 1-.389-.546l.02-22a.661.661 0 0 0 .388.544 2.056 2.056 0 0 0 1.869 0 .647.647 0 0 0 .383-.536z"
            fill="#646D6D"
        />
        <path
            d="m442.68 620.32-20.2-11.7 44.236-25.479 20.199 11.7-44.235 25.479z"
            fill="#fff"
        />
        <path
            d="m486.92 594.84-44.236 25.48-20.2-11.7v1l20.2 11.7 44.238-25.48-.002-1z"
            fill="#E0E0E0"
        />
        <path
            d="m451.12 593.95 4.713-2.736a.959.959 0 0 0-.41.888.95.95 0 0 0 .435.749l2.569 1.485a.518.518 0 0 1 .232.409.181.181 0 0 1-.013.086.176.176 0 0 1-.054.067l-4.711 2.739a.18.18 0 0 0 .07-.154.517.517 0 0 0-.237-.41l-2.569-1.484a.952.952 0 0 1-.432-.748.966.966 0 0 1 .407-.891z"
            fill="#969696"
        />
        <path
            d="m454.12 591.48 4.712-2.736.331.578-4.709 2.739-.334-.581z"
            fill="#212525"
        />
        <path
            d="m450.79 593.38 4.711-2.739 3.33-1.9-4.712 2.736-3.329 1.903z"
            fill="#1C1E1F"
        />
        <path
            d="m454.12 591.48.334.581-3.33 1.9a.976.976 0 0 0-.407.891.955.955 0 0 0 .432.748l2.569 1.484a.515.515 0 0 1 .237.41c0 .151-.108.211-.239.136l-2.567-1.483a2.01 2.01 0 0 1-.908-1.571 1.31 1.31 0 0 1 .55-1.193l3.329-1.903z"
            fill="#656868"
        />
        <path
            d="m464.24 568.55.469.273a.632.632 0 0 0-.631.063l-.472-.273a.643.643 0 0 1 .634-.063z"
            fill="#696E70"
        />
        <path
            d="m463.48 582.41-.037-12.761.472.273.036 12.762-20.53 11.853-.472-.274 20.531-11.853z"
            fill="#464949"
        />
        <path
            d="M441.99 597.72v-1.621l.476.278v1.621a.625.625 0 0 0 .26.569l-.472-.273a.645.645 0 0 1-.259-.571l-.005-.003z"
            fill="#929292"
        />
        <path
            d="m442.46 596.38 22.541-13.016v1.613a1.962 1.962 0 0 1-.887 1.539l-8 4.616-4.836 2.791-7.938 4.581c-.494.284-.892.056-.894-.511l.014-1.613z"
            fill="#A8A8A8"
        />
        <path
            d="m463.64 569.75.036 12.762-20.53 11.851-.035-12.758 20.529-11.855z"
            fill="#A9FFFF"
        />
        <path
            d="m443.42 594.54-.472-.274-.036-12.759.472.272.036 12.761z"
            fill="#aaa"
        />
        <path
            d="m443.38 581.78-.472-.272 20.53-11.856.472.273-20.53 11.855z"
            fill="#F2F2F2"
        />
        <path
            d="M441.96 582.14a1.984 1.984 0 0 1 .888-1.539l20.76-11.983a.63.63 0 0 1 .634-.064l.469.274a.623.623 0 0 0-.631.062l-20.764 11.987a1.972 1.972 0 0 0-.886 1.535l.033 12.694v1.283l-.478-.28v-1.275l-.025-12.694z"
            fill="#2B2F30"
        />
        <path
            d="M443.31 580.87a1.966 1.966 0 0 0-.886 1.536l.033 12.694v1.286l22.542-13.022c0-.193.008 1.33-.034-13.972 0-.564-.4-.791-.893-.508L443.31 580.87zm20.637 1.816-20.53 11.853-.036-12.761 20.53-11.853.036 12.761z"
            fill="#505556"
        />
        <path
            d="m451.7 603.55 12.292-6.642a.308.308 0 0 0 .095-.117.303.303 0 0 0 .025-.148.652.652 0 0 0-.037-.215l-12.289 6.64c.024.07.036.143.037.217a.29.29 0 0 1-.027.148.288.288 0 0 1-.096.117z"
            fill="#8C8C8C"
        />
        <path
            d="M463.4 595.9a.356.356 0 0 1 .375.082l5.707 3.6-12.22 6.786-5.784-3.746-.018-.013c-.162-.114-.277-.106-.35-.065l12.29-6.644z"
            fill="#D6D8D8"
        />
        <path
            d="M469.53 599.63a.18.18 0 0 0-.043-.044l-12.219 6.785a.25.25 0 0 1 .042.044.208.208 0 0 1 .045.138.06.06 0 0 1-.028.05l12.221-6.786a.06.06 0 0 0 .02-.022.096.096 0 0 0 .008-.029.206.206 0 0 0-.046-.136z"
            fill="#C9C9C9"
        />
        <path
            d="m457.27 606.37 12.219-6.785-12.221 6.786h.006l-.004-.001z"
            fill="#E0E0E0"
        />
        <path
            d="M451.4 602.57c-.228-.132-.414-.025-.414.237a.895.895 0 0 0 .412.712c.229.131.414.025.416-.236a.696.696 0 0 0-.037-.217l.089.062 5.37 3.461c.065.037.107.016.114-.039a.22.22 0 0 0-.092-.185l-5.8-3.759-.021-.015-.012-.009-.025-.012z"
            fill="#ADADAD"
        />
        <path
            d="M462.94 596.93a.058.058 0 0 0-.039.054.056.056 0 0 0 .039.054l.52.324a.194.194 0 0 0 .181.006l.544-.29c.051-.028.053-.074 0-.1l-.518-.326a.207.207 0 0 0-.184-.006l-.543.284zM462 597.44c-.053.029-.054.076 0 .107l.518.326a.213.213 0 0 0 .186.006l.542-.292c.052-.027.054-.074 0-.107l-.519-.323a.207.207 0 0 0-.184-.006l-.543.289zM461.06 597.95c-.051.028-.051.075 0 .108l.519.323a.22.22 0 0 0 .184.007l.541-.291c.052-.029.055-.077.006-.106l-.52-.325a.195.195 0 0 0-.183-.007l-.547.291zM460.11 598.45a.065.065 0 0 0-.028.021.064.064 0 0 0-.01.033.06.06 0 0 0 .01.032c.007.01.017.017.028.021l.519.324a.194.194 0 0 0 .091.025.191.191 0 0 0 .091-.019l.542-.291c.053-.028.054-.073.005-.1l-.52-.326a.203.203 0 0 0-.09-.022.204.204 0 0 0-.091.022l-.547.28zM459.17 598.96c-.052.027-.057.076-.006.106l.52.324a.192.192 0 0 0 .183.005l.541-.291c.053-.025.053-.073.006-.1l-.52-.324a.185.185 0 0 0-.182-.006l-.542.286zM458.22 599.47c-.052.027-.054.076 0 .105l.521.324a.188.188 0 0 0 .18.007l.545-.29a.061.061 0 0 0 .024-.021.06.06 0 0 0 .008-.029.061.061 0 0 0-.008-.03.052.052 0 0 0-.024-.02l-.52-.326a.209.209 0 0 0-.091-.027.207.207 0 0 0-.094.02l-.541.287zM462.92 598.01a.047.047 0 0 0-.025.019.048.048 0 0 0-.01.029.054.054 0 0 0 .03.052l.52.324a.198.198 0 0 0 .181.007l1.489-.8c.051-.028.053-.074 0-.105l-.52-.325a.194.194 0 0 0-.091-.025.191.191 0 0 0-.091.019l-1.483.805zM461.96 598.51c-.051.029-.054.075 0 .106l.519.325a.206.206 0 0 0 .09.025.205.205 0 0 0 .092-.019l.542-.291c.052-.028.054-.074.007-.106l-.522-.325a.205.205 0 0 0-.182-.006l-.546.291zM461.02 599.02c-.052.029-.055.076-.007.105l.518.326a.201.201 0 0 0 .185.006l.541-.291c.052-.027.054-.075.006-.105l-.521-.325a.206.206 0 0 0-.183-.006l-.539.29zM460.08 599.53c-.054.03-.056.076-.006.108l.518.325c.028.014.059.023.091.024s.063-.006.092-.018l.542-.29c.053-.031.055-.076.007-.106l-.518-.326a.206.206 0 0 0-.186-.006l-.54.289zM459.13 600.03c-.052.029-.054.074 0 .1l.518.326a.195.195 0 0 0 .184.007l.542-.29c.052-.03.054-.077 0-.107l-.52-.323a.195.195 0 0 0-.182-.007l-.542.294zM463.83 598.58c-.052.03-.054.077-.007.107l.521.324a.207.207 0 0 0 .09.026.2.2 0 0 0 .093-.02l1.488-.8c.052-.027.054-.075 0-.105l-.517-.326a.214.214 0 0 0-.186-.005l-1.482.799zM462.88 599.09c-.051.029-.056.076 0 .107l.518.325a.206.206 0 0 0 .183.005l.543-.291c.011-.003.021-.01.028-.019s.011-.021.012-.032a.067.067 0 0 0-.009-.034.063.063 0 0 0-.026-.022l-.521-.323a.222.222 0 0 0-.091-.026.212.212 0 0 0-.093.019l-.544.291zM461.94 599.6a.057.057 0 0 0-.038.053c0 .011.004.023.011.032.007.01.016.017.027.021l.519.324a.21.21 0 0 0 .092.025.206.206 0 0 0 .092-.02l.543-.288a.057.057 0 0 0 .027-.021.057.057 0 0 0 .011-.033.054.054 0 0 0-.011-.032.051.051 0 0 0-.027-.021l-.518-.327a.199.199 0 0 0-.182-.005l-.546.292zM460.99 600.1a.056.056 0 0 0-.029.021.055.055 0 0 0 0 .066.05.05 0 0 0 .029.02l.519.324a.213.213 0 0 0 .183.007l.542-.291c.054-.028.054-.076 0-.108l-.517-.323a.213.213 0 0 0-.184-.006l-.543.29zM457.28 599.97a.06.06 0 0 0-.027.02.063.063 0 0 0-.01.032c0 .012.004.023.01.032.007.01.016.017.027.021l.516.323a.21.21 0 0 0 .187.007l.542-.291a.056.056 0 0 0 .027-.021.054.054 0 0 0 .011-.032.057.057 0 0 0-.038-.053l-.517-.324a.196.196 0 0 0-.184-.006l-.544.292zM458.18 600.54c-.053.026-.055.074 0 .1l.517.323a.2.2 0 0 0 .186.007l.541-.29c.053-.029.054-.075 0-.107l-.52-.323a.207.207 0 0 0-.183-.007l-.541.297zM460.05 600.61c-.053.032-.055.076 0 .107l.519.325a.208.208 0 0 0 .184 0l.542-.289a.062.062 0 0 0 .027-.021.058.058 0 0 0 .01-.032.063.063 0 0 0-.01-.032.06.06 0 0 0-.027-.02l-.522-.325a.199.199 0 0 0-.182-.007l-.541.294zM459.1 601.11c-.054.028-.054.074 0 .106l.519.324a.207.207 0 0 0 .184.006l.541-.289c.05-.029.054-.075 0-.108l-.519-.324a.21.21 0 0 0-.185-.008l-.54.293zM463.76 599.64c-.054.028-.056.076-.006.107l.519.322a.196.196 0 0 0 .092.026.212.212 0 0 0 .093-.019l2.434-1.3a.062.062 0 0 0 .027-.021c.007-.01.01-.021.01-.033s-.003-.023-.01-.033a.06.06 0 0 0-.027-.02l-.519-.323a.208.208 0 0 0-.091-.026.21.21 0 0 0-.092.018l-2.43 1.302zM462.81 600.14c-.049.029-.054.077 0 .108l.516.324c.029.016.06.024.092.025a.2.2 0 0 0 .094-.019l.54-.29a.055.055 0 0 0 .041-.051.066.066 0 0 0-.009-.033.064.064 0 0 0-.027-.022l-.519-.324a.195.195 0 0 0-.091-.026.2.2 0 0 0-.094.018l-.543.29zM461.86 600.65a.062.062 0 0 0-.027.021.058.058 0 0 0-.01.032c0 .011.004.022.01.032a.06.06 0 0 0 .027.02l.518.324c.028.016.059.025.091.026s.064-.005.094-.018l.543-.292a.055.055 0 0 0 .032-.05c0-.01-.003-.02-.009-.029s-.014-.016-.023-.021l-.517-.326a.228.228 0 0 0-.184 0l-.545.281zM460.92 601.15c-.052.028-.056.074 0 .108l.518.324a.204.204 0 0 0 .182 0l.544-.289a.065.065 0 0 0 .028-.021c.006-.01.01-.021.01-.033s-.004-.023-.01-.033a.063.063 0 0 0-.028-.02l-.52-.324a.204.204 0 0 0-.09-.026.2.2 0 0 0-.093.02l-.541.294zM459.97 601.66a.056.056 0 0 0-.026.022.053.053 0 0 0-.01.032c0 .012.003.023.01.033a.05.05 0 0 0 .026.021l.516.325a.218.218 0 0 0 .187.006l.539-.291c.053-.028.055-.077.006-.107l-.519-.324a.206.206 0 0 0-.09-.025.212.212 0 0 0-.093.019l-.546.289zM456.33 600.48c-.053.027-.055.075 0 .107l.518.324a.199.199 0 0 0 .182.005l.542-.288c.054-.029.056-.076 0-.106l-.519-.326a.205.205 0 0 0-.183-.006l-.54.29zM457.24 601.04c-.051.027-.054.073 0 .1l.517.326a.208.208 0 0 0 .185 0l.542-.29c.052-.026.054-.074 0-.106l-.517-.324a.194.194 0 0 0-.182-.005l-.545.299zM458.16 601.62c-.052.027-.053.075 0 .1l.519.327a.193.193 0 0 0 .091.024.2.2 0 0 0 .093-.019l.541-.289c.051-.03.055-.077 0-.108l-.517-.322a.2.2 0 0 0-.186-.008l-.541.295zM459.03 602.16c-.052.026-.053.075 0 .107l.518.323c.028.016.059.024.091.025s.064-.005.094-.018l.541-.292c.053-.026.055-.074 0-.1l-.519-.324a.213.213 0 0 0-.184-.006l-.541.285zM466.51 599.15c-.053.029-.055.076-.006.106l.519.326a.212.212 0 0 0 .186.005l.539-.289c.055-.029.056-.078.006-.107l-.518-.325a.21.21 0 0 0-.185-.005l-.541.289zM465.56 599.66c-.01.004-.018.011-.024.02s-.01.02-.01.03c0 .011.004.022.01.031a.057.057 0 0 0 .024.019l.519.326a.188.188 0 0 0 .181.006l.544-.29a.05.05 0 0 0 .026-.021.05.05 0 0 0 .01-.032.055.055 0 0 0-.01-.032.06.06 0 0 0-.026-.021l-.52-.324a.188.188 0 0 0-.182-.006l-.542.294zM464.62 600.17a.062.062 0 0 0-.027.021c-.006.009-.01.021-.01.032s.004.023.01.032a.062.062 0 0 0 .027.021l.518.325a.186.186 0 0 0 .183 0l.543-.289a.051.051 0 0 0 .026-.02c.007-.009.01-.021.01-.032s-.003-.023-.01-.032a.051.051 0 0 0-.026-.02l-.518-.324a.2.2 0 0 0-.184-.007l-.542.293zM459.89 602.7a.06.06 0 0 0-.027.02c-.007.01-.01.021-.01.033s.003.023.01.033a.062.062 0 0 0 .027.021l.519.324a.206.206 0 0 0 .183.005l4.327-2.312a.064.064 0 0 0 .027-.022.06.06 0 0 0 .01-.032.064.064 0 0 0-.01-.033.056.056 0 0 0-.027-.021l-.518-.325a.198.198 0 0 0-.185-.005l-4.326 2.314zM455.38 600.98a.058.058 0 0 0-.028.021.053.053 0 0 0-.01.032c0 .012.003.023.01.033a.056.056 0 0 0 .028.02l.519.324a.195.195 0 0 0 .184.007l.541-.291c.055-.027.055-.075.006-.106l-.52-.323a.212.212 0 0 0-.185-.007l-.545.29zM454.44 601.49a.048.048 0 0 0-.027.02.054.054 0 0 0 0 .065c.007.01.016.017.027.021l.518.325a.207.207 0 0 0 .184.007l.544-.292a.058.058 0 0 0 .028-.02c.007-.01.011-.021.011-.033s-.004-.023-.011-.033a.05.05 0 0 0-.028-.019l-.518-.324a.2.2 0 0 0-.184-.008l-.544.291zM452.55 602.5c-.053.025-.054.074 0 .1l.519.325a.195.195 0 0 0 .182.007l1.488-.8c.053-.028.055-.076 0-.107l-.517-.324a.2.2 0 0 0-.186-.006l-1.486.805zM456.29 601.55c-.052.028-.056.074-.006.107l.52.322c.028.016.059.025.091.026s.063-.005.092-.018l.543-.291a.057.057 0 0 0 .038-.053.057.057 0 0 0-.011-.033.064.064 0 0 0-.027-.021l-.519-.324a.206.206 0 0 0-.182 0l-.539.285zM455.35 602.05c-.052.028-.054.077 0 .107l.519.324a.207.207 0 0 0 .182.007l.543-.29a.057.057 0 0 0 .027-.021.057.057 0 0 0 .011-.033.054.054 0 0 0-.011-.032.051.051 0 0 0-.027-.021l-.519-.324a.2.2 0 0 0-.184-.007l-.541.29zM454.4 602.56c-.052.029-.052.076-.005.106l.52.325a.193.193 0 0 0 .091.024.195.195 0 0 0 .092-.019l.541-.29c.054-.027.056-.074.007-.107l-.519-.323a.207.207 0 0 0-.184-.006l-.543.29zM453.46 603.07c-.052.03-.053.076 0 .108l.52.323a.207.207 0 0 0 .182.007l.542-.291c.054-.027.056-.074 0-.107l-.517-.324a.195.195 0 0 0-.185-.006l-.542.29zM457.21 602.12c-.054.026-.054.074 0 .106l.519.324a.198.198 0 0 0 .183 0l.542-.286a.059.059 0 0 0 .027-.022.053.053 0 0 0 .01-.032.054.054 0 0 0-.01-.033.051.051 0 0 0-.027-.021l-.519-.324a.194.194 0 0 0-.091-.025.2.2 0 0 0-.093.018l-.541.295zM456.26 602.63a.06.06 0 0 0-.029.018.055.055 0 0 0-.012.032.057.057 0 0 0 .008.034c.007.01.016.017.027.022l.519.323a.21.21 0 0 0 .092.027.217.217 0 0 0 .094-.019l.54-.291c.054-.028.056-.076.005-.107l-.518-.323a.195.195 0 0 0-.183-.006l-.543.29zM454.37 603.64c-.053.029-.055.077-.006.109l.52.322a.22.22 0 0 0 .09.025.221.221 0 0 0 .092-.017l1.49-.8c.049-.027.053-.076 0-.1l-.519-.326c-.027-.016-.058-.024-.09-.025s-.063.005-.092.019l-1.485.793zM458.08 602.67c-.05.029-.054.075 0 .107l.519.324c.028.015.059.024.091.025s.063-.006.092-.019l.543-.29c.051-.028.054-.076 0-.107l-.517-.324a.2.2 0 0 0-.184-.006l-.544.29zM457.14 603.18c-.052.027-.054.075-.005.1l.518.324a.2.2 0 0 0 .185.006l.541-.289c.053-.028.055-.076 0-.106l-.517-.327a.207.207 0 0 0-.091-.022.208.208 0 0 0-.092.022l-.539.292zM455.25 604.19a.052.052 0 0 0-.028.02.057.057 0 0 0 0 .067c.007.01.016.017.028.021l.519.323a.199.199 0 0 0 .182.006l1.489-.795c.052-.029.052-.074 0-.107l-.519-.325a.196.196 0 0 0-.185 0l-1.486.79zM458.94 603.21c-.053.028-.055.076-.005.107l.518.324a.22.22 0 0 0 .187.006l.54-.291c.05-.029.052-.075 0-.1l-.52-.324a.183.183 0 0 0-.183-.006l-.537.284zM456.1 604.72a.063.063 0 0 0-.028.02.057.057 0 0 0 0 .067c.007.01.017.017.028.021l.517.323a.2.2 0 0 0 .185.007l1.488-.8c.053-.027.054-.075 0-.107l-.518-.325a.21.21 0 0 0-.185 0l-1.487.794z"
            fill="#EAEAEA"
        />
        <path
            d="m463.65 597.37.544-.29a.06.06 0 0 0 .039-.052v.106a.065.065 0 0 1-.041.053l-.543.288.001-.105z"
            fill="#8C8C8C"
        />
        <path
            d="M462.91 596.99a.065.065 0 0 0 .036.053l.52.324a.202.202 0 0 0 .09.025.191.191 0 0 0 .091-.019v.105a.19.19 0 0 1-.09.021.188.188 0 0 1-.09-.026l-.52-.324a.051.051 0 0 1-.026-.022.057.057 0 0 1-.011-.033v-.104z"
            fill="#ADADAD"
        />
        <path
            d="m462.7 597.88.542-.292a.073.073 0 0 0 .027-.022.064.064 0 0 0 .015-.031l-.006.108a.058.058 0 0 1-.013.03.06.06 0 0 1-.026.021l-.541.289.002-.103z"
            fill="#8C8C8C"
        />
        <path
            d="M461.96 597.49c0 .011.004.022.01.032s.015.018.025.023l.518.326a.227.227 0 0 0 .186.006v.1a.2.2 0 0 1-.093.022.195.195 0 0 1-.092-.022l-.518-.324a.082.082 0 0 1-.026-.023.076.076 0 0 1-.011-.032l.001-.108z"
            fill="#ADADAD"
        />
        <path
            d="m461.76 598.38.541-.291a.067.067 0 0 0 .028-.022.064.064 0 0 0 .013-.032v.107c0 .019-.013.037-.041.052l-.541.292v-.106z"
            fill="#8C8C8C"
        />
        <path
            d="M461.02 598a.072.072 0 0 0 .011.032c.007.01.016.018.027.024l.519.323a.22.22 0 0 0 .184.007v.106a.23.23 0 0 1-.093.017.236.236 0 0 1-.091-.024l-.517-.324a.087.087 0 0 1-.027-.023.067.067 0 0 1-.01-.033l-.003-.105z"
            fill="#ADADAD"
        />
        <path
            d="m460.81 598.89.541-.291a.057.057 0 0 0 .028-.018.07.07 0 0 0 .013-.032v.106c0 .019-.014.036-.041.052l-.543.289.002-.106z"
            fill="#8C8C8C"
        />
        <path
            d="M460.07 598.5a.059.059 0 0 0 .011.032c.006.01.015.017.025.022l.52.324a.193.193 0 0 0 .09.025.193.193 0 0 0 .092-.019v.106a.19.19 0 0 1-.18-.006l-.523-.324a.064.064 0 0 1-.034-.054l-.001-.106z"
            fill="#ADADAD"
        />
        <path
            d="m459.86 599.39.541-.291c.028-.012.042-.031.042-.049v.1c0 .02-.013.039-.041.062l-.54.29-.002-.112z"
            fill="#8C8C8C"
        />
        <path
            d="M459.13 599.01a.072.072 0 0 0 .035.055l.52.324a.185.185 0 0 0 .183.005v.106c-.029.014-.061.022-.093.022s-.064-.008-.093-.022l-.52-.327c-.01-.005-.018-.013-.024-.022s-.01-.02-.012-.031l.004-.11z"
            fill="#ADADAD"
        />
        <path
            d="m458.92 599.9.545-.29c.01-.005.019-.012.026-.021s.012-.019.013-.03v.106c-.002.011-.006.021-.013.03s-.016.016-.026.021l-.545.289v-.105z"
            fill="#8C8C8C"
        />
        <path
            d="M458.18 599.52c0 .011.004.022.01.031s.015.017.025.022l.521.324a.185.185 0 0 0 .18.007v.105a.194.194 0 0 1-.091.022.191.191 0 0 1-.091-.022l-.515-.324a.06.06 0 0 1-.027-.023.063.063 0 0 1-.012-.032v-.11z"
            fill="#ADADAD"
        />
        <path
            d="m463.61 598.44 1.489-.8a.063.063 0 0 0 .028-.02.054.054 0 0 0 .013-.03v.1c-.001.012-.005.023-.012.033s-.017.017-.029.022l-1.486.8-.003-.105z"
            fill="#8C8C8C"
        />
        <path
            d="M462.87 598.06a.067.067 0 0 0 .036.053l.52.324a.199.199 0 0 0 .181.007v.107a.22.22 0 0 1-.183-.007l-.519-.324a.08.08 0 0 1-.025-.023.076.076 0 0 1-.011-.032l.001-.105z"
            fill="#ADADAD"
        />
        <path
            d="m462.66 598.95.542-.291c.026-.014.041-.031.041-.049v.1a.084.084 0 0 1-.012.031.075.075 0 0 1-.026.021l-.542.289-.003-.101z"
            fill="#8C8C8C"
        />
        <path
            d="M461.93 598.56c0 .012.004.023.01.033s.015.018.026.022l.519.325c.027.016.058.024.09.025s.063-.005.092-.019v.105a.202.202 0 0 1-.185 0l-.519-.327a.057.057 0 0 1-.025-.021.06.06 0 0 1-.01-.032l.002-.111z"
            fill="#ADADAD"
        />
        <path
            d="m461.72 599.45.541-.291a.054.054 0 0 0 .028-.019.068.068 0 0 0 .013-.033v.106a.06.06 0 0 1-.012.032.06.06 0 0 1-.027.021l-.543.289v-.105z"
            fill="#8C8C8C"
        />
        <path
            d="M460.98 599.07a.072.072 0 0 0 .011.032.072.072 0 0 0 .025.021l.519.326a.201.201 0 0 0 .184.006v.105a.198.198 0 0 1-.184-.005l-.517-.325a.053.053 0 0 1-.025-.022.059.059 0 0 1-.011-.032l-.002-.106z"
            fill="#ADADAD"
        />
        <path
            d="m460.77 599.96.542-.29a.071.071 0 0 0 .039-.053v.105c0 .02-.014.038-.041.054l-.542.29.002-.106z"
            fill="#8C8C8C"
        />
        <path
            d="M460.04 599.58a.07.07 0 0 0 .036.054l.518.325c.028.014.059.023.091.024s.063-.006.092-.018v.106a.207.207 0 0 1-.092.018.222.222 0 0 1-.09-.026l-.52-.324a.07.07 0 0 1-.036-.054l.001-.105z"
            fill="#ADADAD"
        />
        <path
            d="m459.83 600.47.542-.29c.011-.004.02-.012.027-.021s.011-.02.013-.032v.106c-.001.012-.006.023-.013.032s-.016.016-.027.02l-.542.29v-.105z"
            fill="#8C8C8C"
        />
        <path
            d="M459.09 600.08a.056.056 0 0 0 .036.053l.518.326a.195.195 0 0 0 .184.007v.105a.195.195 0 0 1-.182-.006l-.521-.324c-.01-.005-.019-.013-.025-.022s-.009-.02-.01-.032v-.107z"
            fill="#ADADAD"
        />
        <path
            d="m464.53 599.02 1.488-.8c.011-.005.021-.012.028-.021s.012-.02.013-.031l-.005.1a.058.058 0 0 1-.011.031.064.064 0 0 1-.027.022l-1.489.799.003-.1z"
            fill="#8C8C8C"
        />
        <path
            d="M463.79 598.64a.055.055 0 0 0 .011.03c.006.01.014.017.024.022l.521.324c.028.015.059.024.091.025s.063-.006.092-.019v.105a.195.195 0 0 1-.184-.006l-.517-.322a.096.096 0 0 1-.026-.023.08.08 0 0 1-.011-.033l-.001-.103z"
            fill="#ADADAD"
        />
        <path
            d="m463.58 599.52.543-.291a.064.064 0 0 0 .027-.022.07.07 0 0 0 .012-.031v.107a.07.07 0 0 1-.012.031.07.07 0 0 1-.027.021l-.544.291.001-.106z"
            fill="#8C8C8C"
        />
        <path
            d="M462.85 599.14c0 .011.003.023.009.033s.015.018.026.023l.518.325a.206.206 0 0 0 .183.005v.106a.207.207 0 0 1-.182-.006l-.518-.325a.061.061 0 0 1-.025-.023.058.058 0 0 1-.011-.031v-.107z"
            fill="#ADADAD"
        />
        <path
            d="m462.64 600.03.543-.288a.067.067 0 0 0 .027-.023.073.073 0 0 0 .012-.032v.108c-.002.011-.006.022-.013.031s-.016.016-.026.021l-.544.29.001-.107z"
            fill="#8C8C8C"
        />
        <path
            d="M461.9 599.64a.072.072 0 0 0 .036.056l.519.324c.028.015.06.024.092.024a.193.193 0 0 0 .092-.019v.107a.207.207 0 0 1-.184-.006l-.519-.325a.088.088 0 0 1-.024-.023.09.09 0 0 1-.012-.031v-.107z"
            fill="#ADADAD"
        />
        <path
            d="m461.69 600.54.542-.291a.063.063 0 0 0 .028-.02.054.054 0 0 0 .013-.032v.106c-.002.012-.007.022-.014.031s-.016.017-.027.021l-.542.288v-.103z"
            fill="#8C8C8C"
        />
        <path
            d="M460.95 600.15a.068.068 0 0 0 .036.055l.519.324c.028.015.059.023.091.024s.063-.004.092-.017v.1a.186.186 0 0 1-.184 0l-.52-.327c-.01-.004-.018-.011-.024-.02s-.01-.019-.011-.03l.001-.109z"
            fill="#ADADAD"
        />
        <path
            d="m457.98 600.41.542-.291c.01-.004.02-.012.027-.021s.011-.02.013-.032v.107a.079.079 0 0 1-.013.033.078.078 0 0 1-.026.022l-.543.288v-.106z"
            fill="#8C8C8C"
        />
        <path
            d="M457.23 600.02a.066.066 0 0 0 .012.033c.006.01.015.018.025.023l.516.323a.207.207 0 0 0 .187.007v.106a.195.195 0 0 1-.183-.006l-.52-.325c-.024-.017-.038-.035-.034-.054l-.003-.107z"
            fill="#ADADAD"
        />
        <path
            d="m458.88 600.97.541-.29c.011-.004.02-.011.027-.02s.012-.02.014-.032v.105a.075.075 0 0 1-.013.032.066.066 0 0 1-.027.02l-.542.29v-.105z"
            fill="#8C8C8C"
        />
        <path
            d="M458.14 600.59a.063.063 0 0 0 .012.032.067.067 0 0 0 .026.021l.517.324a.196.196 0 0 0 .186.006v.105a.195.195 0 0 1-.184-.006l-.521-.325a.061.061 0 0 1-.024-.021.058.058 0 0 1-.011-.031l-.001-.105z"
            fill="#ADADAD"
        />
        <path
            d="m460.75 601.04.542-.289c.011-.005.02-.012.027-.021s.011-.02.012-.031v.107c-.001.011-.005.022-.012.031s-.017.015-.028.019l-.543.291.002-.107z"
            fill="#8C8C8C"
        />
        <path
            d="M460.01 600.65c0 .012.004.023.01.033a.054.054 0 0 0 .026.021l.519.325a.196.196 0 0 0 .184 0l-.005.107a.188.188 0 0 1-.182-.006l-.52-.324a.059.059 0 0 1-.025-.022.059.059 0 0 1-.011-.032l.004-.102z"
            fill="#ADADAD"
        />
        <path
            d="m459.8 601.55.541-.289a.075.075 0 0 0 .026-.021.09.09 0 0 0 .013-.032v.1a.07.07 0 0 1-.012.034.063.063 0 0 1-.028.02l-.541.291.001-.103z"
            fill="#8C8C8C"
        />
        <path
            d="M459.06 601.16a.072.072 0 0 0 .011.032c.007.01.016.018.026.023l.519.324a.205.205 0 0 0 .184.006v.106a.212.212 0 0 1-.185-.007l-.518-.324a.078.078 0 0 1-.026-.022.076.076 0 0 1-.011-.032v-.106z"
            fill="#ADADAD"
        />
        <path
            d="m464.46 600.07 2.434-1.3c.026-.015.04-.033.04-.052v.1c0 .019-.015.037-.041.052l-2.433 1.305v-.105z"
            fill="#8C8C8C"
        />
        <path
            d="M463.72 599.69c0 .021.01.037.034.056l.519.322a.195.195 0 0 0 .091.026.214.214 0 0 0 .094-.019v.108a.213.213 0 0 1-.093.016.206.206 0 0 1-.091-.024l-.518-.324a.08.08 0 0 1-.025-.023.063.063 0 0 1-.01-.032l-.001-.106z"
            fill="#ADADAD"
        />
        <path
            d="m463.51 600.58.54-.29a.058.058 0 0 0 .028-.021.064.064 0 0 0 .013-.033v.107c-.002.012-.006.023-.013.032s-.017.016-.027.02l-.542.29.001-.105z"
            fill="#8C8C8C"
        />
        <path
            d="M462.77 600.19c0 .02.01.038.037.054l.516.324a.205.205 0 0 0 .186.006v.105a.213.213 0 0 1-.185-.005l-.517-.324a.066.066 0 0 1-.026-.021.076.076 0 0 1-.011-.033v-.106z"
            fill="#ADADAD"
        />
        <path
            d="m462.56 601.08.543-.292a.063.063 0 0 0 .028-.02.054.054 0 0 0 .013-.032v.107c-.001.012-.006.022-.013.031s-.016.016-.027.02l-.542.292-.002-.106z"
            fill="#8C8C8C"
        />
        <path
            d="M461.83 600.7c0 .011.003.021.009.031a.061.061 0 0 0 .024.021l.518.324a.21.21 0 0 0 .185.008v.106a.219.219 0 0 1-.183-.005l-.52-.328a.058.058 0 0 1-.026-.021.056.056 0 0 1-.009-.031l.002-.105z"
            fill="#ADADAD"
        />
        <path
            d="m461.62 601.59.544-.289a.066.066 0 0 0 .039-.054v.108c0 .018-.013.036-.041.051l-.543.291.001-.107z"
            fill="#8C8C8C"
        />
        <path
            d="M460.88 601.21a.06.06 0 0 0 .012.031c.007.01.015.018.026.023l.518.324a.206.206 0 0 0 .182 0v.107a.211.211 0 0 1-.092.019.207.207 0 0 1-.091-.025l-.52-.325c-.01-.006-.019-.014-.025-.024s-.009-.021-.01-.032v-.098z"
            fill="#ADADAD"
        />
        <path
            d="m460.68 602.1.539-.291a.072.072 0 0 0 .029-.02.067.067 0 0 0 .013-.034l-.005.1a.076.076 0 0 1-.011.033.062.062 0 0 1-.027.021l-.543.29.005-.099z"
            fill="#8C8C8C"
        />
        <path
            d="M459.94 601.71c0 .012.004.023.011.033.006.01.015.017.026.022l.516.325a.22.22 0 0 0 .187.006l-.005.1a.2.2 0 0 1-.183-.007l-.518-.323a.058.058 0 0 1-.027-.022.064.064 0 0 1-.01-.033l.003-.101z"
            fill="#ADADAD"
        />
        <path
            d="m457.03 600.91.542-.288c.027-.015.041-.033.041-.054v.106c-.001.012-.006.023-.013.032s-.016.017-.027.021l-.544.29.001-.107z"
            fill="#8C8C8C"
        />
        <path
            d="M456.29 600.53a.076.076 0 0 0 .011.033c.007.01.016.018.026.023l.518.324a.196.196 0 0 0 .182.005v.107a.202.202 0 0 1-.181 0l-.519-.327a.072.072 0 0 1-.036-.052l-.001-.113z"
            fill="#ADADAD"
        />
        <path
            d="m457.94 601.48.542-.29a.066.066 0 0 0 .041-.051v.106c-.001.011-.006.022-.013.031s-.017.015-.028.019l-.543.291.001-.106z"
            fill="#8C8C8C"
        />
        <path
            d="M457.2 601.1a.065.065 0 0 0 .036.052l.517.326a.202.202 0 0 0 .185 0v.106a.204.204 0 0 1-.182 0l-.52-.327a.064.064 0 0 1-.025-.021.063.063 0 0 1-.012-.031l.001-.105z"
            fill="#ADADAD"
        />
        <path
            d="m458.85 602.05.541-.289c.029-.016.042-.035.042-.053v.1c0 .02-.014.037-.043.053l-.541.29.001-.101z"
            fill="#8C8C8C"
        />
        <path
            d="M458.12 601.67a.058.058 0 0 0 .011.031.054.054 0 0 0 .024.021l.519.327a.21.21 0 0 0 .092.025.209.209 0 0 0 .092-.02v.106a.195.195 0 0 1-.182-.007l-.52-.324a.057.057 0 0 1-.025-.021.063.063 0 0 1-.012-.032l.001-.106z"
            fill="#ADADAD"
        />
        <path
            d="m459.73 602.6.541-.292c.01-.003.02-.01.027-.019s.011-.019.013-.031v.1c0 .02-.014.037-.04.051l-.543.29.002-.099z"
            fill="#8C8C8C"
        />
        <path
            d="M458.99 602.22a.067.067 0 0 0 .01.032c.007.01.015.018.025.023l.518.323a.21.21 0 0 0 .185.007v.1a.192.192 0 0 1-.182-.005l-.52-.324a.06.06 0 0 1-.026-.022.063.063 0 0 1-.009-.033l-.001-.101z"
            fill="#ADADAD"
        />
        <path
            d="m467.21 599.59.539-.289a.072.072 0 0 0 .029-.02.071.071 0 0 0 .014-.032v.1c-.001.012-.006.023-.013.032s-.016.016-.027.02l-.54.293-.002-.104z"
            fill="#8C8C8C"
        />
        <path
            d="M466.47 599.21a.068.068 0 0 0 .011.031c.006.01.014.017.024.022l.519.326a.201.201 0 0 0 .186.005v.108a.218.218 0 0 1-.186-.008l-.519-.323a.061.061 0 0 1-.025-.023.066.066 0 0 1-.012-.033l.002-.105z"
            fill="#ADADAD"
        />
        <path
            d="m466.26 600.1.544-.29c.011-.004.02-.011.027-.02s.012-.02.014-.032v.105a.07.07 0 0 1-.013.032.068.068 0 0 1-.026.022l-.544.29-.002-.107z"
            fill="#8C8C8C"
        />
        <path
            d="M465.52 599.72c0 .012.004.023.01.032a.06.06 0 0 0 .027.02l.519.326a.188.188 0 0 0 .181.006v.107a.2.2 0 0 1-.183-.008l-.519-.323a.058.058 0 0 1-.027-.022.064.064 0 0 1-.01-.033l.002-.105z"
            fill="#ADADAD"
        />
        <path
            d="m465.31 600.61.544-.289c.01-.004.02-.011.027-.02s.011-.02.013-.031v.105a.069.069 0 0 1-.014.03.067.067 0 0 1-.025.022l-.543.291-.002-.108z"
            fill="#8C8C8C"
        />
        <path
            d="M464.58 600.23c.001.01.005.021.012.029a.061.061 0 0 0 .024.021l.518.326a.196.196 0 0 0 .183 0v.108a.207.207 0 0 1-.182-.007l-.522-.323a.067.067 0 0 1-.034-.054l.001-.1z"
            fill="#ADADAD"
        />
        <path
            d="m460.59 603.14 4.327-2.312a.078.078 0 0 0 .026-.022.076.076 0 0 0 .011-.032v.107a.076.076 0 0 1-.013.031.075.075 0 0 1-.026.021l-4.325 2.313v-.106z"
            fill="#8C8C8C"
        />
        <path
            d="M459.85 602.75a.06.06 0 0 0 .01.032.067.067 0 0 0 .025.022l.519.324a.194.194 0 0 0 .183.005v.107a.2.2 0 0 1-.184-.006l-.518-.324c-.011-.004-.02-.012-.026-.022s-.009-.021-.009-.033v-.105z"
            fill="#ADADAD"
        />
        <path
            d="m456.08 601.42.541-.291a.066.066 0 0 0 .029-.021.071.071 0 0 0 .014-.032v.109a.071.071 0 0 1-.013.031.08.08 0 0 1-.027.02l-.544.289v-.105z"
            fill="#8C8C8C"
        />
        <path
            d="M455.34 601.04a.055.055 0 0 0 .011.03.064.064 0 0 0 .024.022l.519.324a.222.222 0 0 0 .091.026.212.212 0 0 0 .093-.019v.1a.2.2 0 0 1-.093.02.194.194 0 0 1-.091-.028l-.519-.321a.066.066 0 0 1-.024-.023.056.056 0 0 1-.009-.031l-.002-.1z"
            fill="#ADADAD"
        />
        <path
            d="m455.14 601.93.544-.292a.063.063 0 0 0 .026-.02.079.079 0 0 0 .013-.031v.1a.071.071 0 0 1-.041.053l-.543.289.001-.099z"
            fill="#8C8C8C"
        />
        <path
            d="M454.4 601.54a.06.06 0 0 0 .012.031c.006.01.015.018.025.023l.518.325a.21.21 0 0 0 .184.007v.1a.205.205 0 0 1-.184-.005l-.519-.323a.082.082 0 0 1-.025-.024.076.076 0 0 1-.011-.032v-.102z"
            fill="#ADADAD"
        />
        <path
            d="m453.24 602.94 1.488-.8c.011-.004.021-.01.028-.019s.012-.02.014-.032l-.006.1a.055.055 0 0 1-.011.033.05.05 0 0 1-.029.02l-1.486.8.002-.102z"
            fill="#8C8C8C"
        />
        <path
            d="M452.51 602.55a.048.048 0 0 0 .009.032.05.05 0 0 0 .026.021l.519.325a.202.202 0 0 0 .182.007v.106a.212.212 0 0 1-.093.018.195.195 0 0 1-.09-.026l-.52-.322c-.01-.006-.019-.014-.025-.024s-.01-.021-.01-.032l.002-.105z"
            fill="#ADADAD"
        />
        <path
            d="m456.99 601.99.543-.29c.028-.015.04-.031.04-.053l-.008.109a.068.068 0 0 1-.011.031.07.07 0 0 1-.026.022l-.544.289.006-.108z"
            fill="#8C8C8C"
        />
        <path
            d="M456.25 601.6c.001.011.004.022.01.032s.014.018.024.024l.52.322a.207.207 0 0 0 .183.007v.105a.208.208 0 0 1-.182-.005l-.521-.323a.061.061 0 0 1-.025-.023.058.058 0 0 1-.011-.031l.002-.108z"
            fill="#ADADAD"
        />
        <path
            d="m456.04 602.49.543-.29a.058.058 0 0 0 .039-.055v.109a.064.064 0 0 1-.014.03.063.063 0 0 1-.026.02l-.542.29v-.104z"
            fill="#8C8C8C"
        />
        <path
            d="M455.31 602.11a.05.05 0 0 0 .01.032c.006.01.014.018.025.022l.519.324a.195.195 0 0 0 .182.007v.1a.199.199 0 0 1-.184 0l-.519-.323a.06.06 0 0 1-.025-.022.064.064 0 0 1-.01-.033l.002-.107z"
            fill="#ADADAD"
        />
        <path
            d="m455.1 603 .541-.29c.027-.016.041-.033.041-.053v.108a.068.068 0 0 1-.041.051l-.541.29V603z"
            fill="#8C8C8C"
        />
        <path
            d="M454.36 602.61a.068.068 0 0 0 .036.055l.52.325c.029.015.06.023.091.024a.193.193 0 0 0 .092-.019v.106a.2.2 0 0 1-.185-.006l-.519-.324a.075.075 0 0 1-.025-.022.088.088 0 0 1-.012-.032l.002-.107z"
            fill="#ADADAD"
        />
        <path
            d="m454.15 603.51.542-.291a.074.074 0 0 0 .028-.021.066.066 0 0 0 .012-.032v.107a.06.06 0 0 1-.012.031.069.069 0 0 1-.028.02l-.54.291-.002-.105z"
            fill="#8C8C8C"
        />
        <path
            d="M453.41 603.12c0 .018.013.036.037.053l.52.323a.206.206 0 0 0 .182.007v.1a.207.207 0 0 1-.184-.006l-.519-.324a.08.08 0 0 1-.025-.023.075.075 0 0 1-.01-.032l-.001-.098z"
            fill="#ADADAD"
        />
        <path
            d="m457.91 602.56.542-.286c.011-.004.02-.012.027-.021s.012-.02.013-.032v.105a.062.062 0 0 1-.039.053l-.543.29v-.109z"
            fill="#8C8C8C"
        />
        <path
            d="M457.17 602.18a.073.073 0 0 0 .036.053l.519.324a.192.192 0 0 0 .183 0v.109a.223.223 0 0 1-.182 0l-.52-.327c-.01-.005-.019-.012-.025-.021s-.01-.019-.011-.03v-.108z"
            fill="#ADADAD"
        />
        <path
            d="m456.96 603.07.54-.291a.074.074 0 0 0 .028-.021.068.068 0 0 0 .013-.033v.108a.069.069 0 0 1-.014.03.068.068 0 0 1-.026.022l-.542.289.001-.104z"
            fill="#8C8C8C"
        />
        <path
            d="M456.22 602.68c0 .011.004.022.01.031a.07.07 0 0 0 .025.023l.519.323a.21.21 0 0 0 .092.027.22.22 0 0 0 .094-.019v.1a.213.213 0 0 1-.093.02.207.207 0 0 1-.091-.025l-.517-.325a.051.051 0 0 1-.027-.021.047.047 0 0 1-.01-.032l-.002-.102z"
            fill="#ADADAD"
        />
        <path
            d="m455.07 604.08 1.49-.8a.07.07 0 0 0 .041-.052v.1a.056.056 0 0 1-.013.032.074.074 0 0 1-.028.021l-1.488.8-.002-.101z"
            fill="#8C8C8C"
        />
        <path
            d="M454.33 603.69a.076.076 0 0 0 .011.033.076.076 0 0 0 .024.023l.52.322a.206.206 0 0 0 .182.008v.1a.195.195 0 0 1-.183-.007l-.52-.324a.056.056 0 0 1-.024-.022.068.068 0 0 1-.011-.031l.001-.102z"
            fill="#ADADAD"
        />
        <path
            d="m458.78 603.11.543-.29a.06.06 0 0 0 .039-.051v.105a.06.06 0 0 1-.012.031.064.064 0 0 1-.027.022l-.542.289-.001-.106z"
            fill="#8C8C8C"
        />
        <path
            d="M458.04 602.72a.07.07 0 0 0 .036.054l.519.324c.028.015.059.024.091.025s.063-.006.092-.019v.106a.208.208 0 0 1-.092.019.206.206 0 0 1-.09-.025l-.52-.324a.08.08 0 0 1-.025-.023.066.066 0 0 1-.012-.032l.001-.105z"
            fill="#ADADAD"
        />
        <path
            d="m457.84 603.61.541-.289c.027-.016.041-.033.042-.053l-.005.105a.053.053 0 0 1-.013.031.07.07 0 0 1-.027.021l-.541.291.003-.106z"
            fill="#8C8C8C"
        />
        <path
            d="M457.1 603.23c0 .022.011.038.035.055l.518.324a.207.207 0 0 0 .185.006v.106a.207.207 0 0 1-.184-.006l-.517-.324a.064.064 0 0 1-.027-.022.063.063 0 0 1-.01-.032v-.107z"
            fill="#ADADAD"
        />
        <path
            d="m455.94 604.62 1.489-.795a.064.064 0 0 0 .027-.022.068.068 0 0 0 .014-.031v.106c0 .012-.005.023-.012.032s-.017.016-.028.019l-1.488.8-.002-.109z"
            fill="#8C8C8C"
        />
        <path
            d="M455.2 604.24a.084.084 0 0 0 .012.031.092.092 0 0 0 .025.023l.519.323a.206.206 0 0 0 .09.025.208.208 0 0 0 .092-.019v.1c-.028.014-.06.022-.092.021s-.063-.01-.091-.026l-.52-.323c-.024-.016-.037-.035-.033-.053l-.002-.102z"
            fill="#ADADAD"
        />
        <path
            d="m459.64 603.64.54-.291c.01-.004.019-.011.026-.02s.012-.019.014-.031v.106c0 .02-.011.038-.04.052l-.542.29.002-.106z"
            fill="#8C8C8C"
        />
        <path
            d="M458.9 603.26a.093.093 0 0 0 .012.033.078.078 0 0 0 .026.022l.518.324a.205.205 0 0 0 .187.006l-.006.106a.208.208 0 0 1-.184-.005l-.518-.326a.063.063 0 0 1-.025-.021.075.075 0 0 1-.01-.032v-.107z"
            fill="#ADADAD"
        />
        <path
            d="m458.69 604.15.542-.29c.027-.014.04-.031.04-.052v.107a.06.06 0 0 1-.013.031.072.072 0 0 1-.029.02l-.541.291.001-.107z"
            fill="#8C8C8C"
        />
        <path
            d="M457.96 603.76c0 .012.003.023.01.033s.016.018.027.023l.518.323c.028.015.059.024.091.025s.063-.006.092-.019v.107a.2.2 0 0 1-.185-.007l-.516-.324a.064.064 0 0 1-.027-.022.063.063 0 0 1-.012-.032l.002-.107z"
            fill="#ADADAD"
        />
        <path
            d="M458 603.71c-.052.029-.054.076 0 .107l.518.323a.194.194 0 0 0 .091.025.186.186 0 0 0 .092-.019l.542-.29c.052-.027.054-.075.005-.105l-.519-.326a.206.206 0 0 0-.182-.005l-.547.29z"
            fill="#EAEAEA"
        />
        <path
            d="m456.8 605.16 1.488-.8a.078.078 0 0 0 .026-.022.08.08 0 0 0 .013-.032v.11c-.002.011-.006.021-.013.03s-.016.016-.026.021l-1.487.794-.001-.101z"
            fill="#8C8C8C"
        />
        <path
            d="M456.07 604.78a.06.06 0 0 0 .012.032c.006.01.015.017.025.022l.517.323c.028.016.06.025.092.027a.2.2 0 0 0 .093-.02v.1a.211.211 0 0 1-.093.021.203.203 0 0 1-.092-.026l-.518-.325a.057.057 0 0 1-.025-.021.06.06 0 0 1-.012-.032l.001-.101z"
            fill="#ADADAD"
        />
        <path
            d="M452.13 607.85a4.302 4.302 0 0 0-2.132-.609l-2.017 1.171c.75.014 1.484.225 2.128.61.643.393 1.23.872 1.743 1.425a.719.719 0 0 0 .882.137l.9-.526a.557.557 0 0 0 .184-.79 7.937 7.937 0 0 0-1.688-1.418z"
            fill="#C1C1C1"
        />
        <path
            d="M450.1 609.02a9 9 0 0 1 2.129 1.849l-.044.016c-.109.043-.338-.073-.547-.193-.108-.061-.209-.126-.284-.169l-2.509-1.448c-.075-.044-.176-.1-.284-.161a1.669 1.669 0 0 1-.549-.438l-.04-.066c.75.014 1.484.225 2.128.61z"
            fill="#999"
        />
        <path
            d="M447.99 608.13a.208.208 0 0 0 .016.378c.076.031.431.1.556.135.443.13.869.312 1.269.543a8.012 8.012 0 0 1 1.794 1.472.743.743 0 0 0 .487.256c.155.026.314.019.466-.019.153-.037.296-.106.421-.201l.641-.4a.707.707 0 0 0 .337-.492.698.698 0 0 0-.165-.574 7.969 7.969 0 0 1-.581 1.143c-.432.251-.6.377-.9.377a.944.944 0 0 1-.653-.256 8.082 8.082 0 0 0-1.845-1.506 4.864 4.864 0 0 0-1.553-.59c-.12-.023-.292-.044-.316-.118a.195.195 0 0 1 .026-.148z"
            fill="#B5B5B5"
        />
        <path
            d="M453.71 609.1a7.942 7.942 0 0 0-1.725-1.372 4.581 4.581 0 0 0-1.784-.625 1.363 1.363 0 0 0-.817.2l-1.393.815a.13.13 0 0 0-.057.139c.007.027.022.05.043.067.02.018.046.028.073.029.094.01.193.026.293.043.526.106 1.03.301 1.491.576a7.9 7.9 0 0 1 1.59 1.24c.05.048.116.12.187.2a.954.954 0 0 0 1.189.2l.072-.042.736-.428a.634.634 0 0 0 .158-.981c-.021-.022-.042-.043-.056-.061z"
            fill="#E0E0E0"
        />
        <path
            d="M449.05 608.13c.42.01.833.106 1.215.282.366.199.686.471.941.8a10.187 10.187 0 0 0-.987-.657 5.525 5.525 0 0 0-1.169-.425z"
            fill="#F2F2F2"
        />
        <path
            d="m448.24 605.64-5.127 8.035-7.7-2.43 5.6-7.9 7.227 2.295z"
            fill="#E1EAEA"
        />
        <path
            d="M444.17 607.72v.07l-5.692 5.144v-.069l5.692-5.145z"
            fill="#8C8B8B"
        />
        <path
            d="M436.18 612.87v.069l-4.827-2.773v-.07l4.827 2.774z"
            fill="#6C6C6C"
        />
        <path
            d="m445.02 607.01-6.547 5.854h-2.3l-4.829-2.774 7.587-6.064 6.089 2.984z"
            fill="#B8CCCB"
        />
        <path d="M438.48 612.87h-2.298v.07h2.298v-.07z" fill="#8C8B8B" />
        <path d="m437.33 612.2 1.152.666h-2.3l1.148-.666z" fill="#E1EAEA" />
        <path
            d="M441.6 607.32v.068l-7.966 4.627v-.067l7.966-4.628z"
            fill="#8C8B8B"
        />
        <path d="M433.63 611.95v.07l-6.063-3.5v-.068l6.063 3.498z" fill="#616161" />
        <path
            d="m441.6 607.32-7.966 4.628-6.062-3.5 7.944-4.615 6.084 3.487z"
            fill="#9C9B9B"
        />
        <path
            d="M441.6 606.98v.068l-7.963 4.628v-.067l7.963-4.629z"
            fill="#8C8B8B"
        />
        <path d="M433.63 611.6v.067l-6.063-3.5v-.069l6.063 3.502z" fill="#616161" />
        <path
            d="m441.6 606.98-7.966 4.629-6.062-3.5 7.944-4.616 6.084 3.487z"
            fill="#9C9B9B"
        />
        <path
            d="M441.6 606.63v.069l-7.966 4.626v-.071l7.966-4.624z"
            fill="#8C8B8B"
        />
        <path
            d="M433.63 611.25v.066l-6.063-3.5v-.068l6.063 3.502z"
            fill="#616161"
        />
        <path
            d="m441.6 606.63-7.966 4.629-6.062-3.5 7.944-4.618 6.084 3.489z"
            fill="#9C9B9B"
        />
        <path
            d="M441.6 606.28v.068l-7.966 4.628v-.07l7.966-4.626z"
            fill="#8C8B8B"
        />
        <path d="M433.63 610.9v.07l-6.063-3.5v-.067l6.063 3.497z" fill="#616161" />
        <path
            d="m441.6 606.28-7.966 4.626-6.062-3.5 7.944-4.619 6.084 3.493z"
            fill="#9C9B9B"
        />
        <path
            d="M441.6 605.93v.067l-7.966 4.629v-.068l7.966-4.628z"
            fill="#8C8B8B"
        />
        <path
            d="M433.63 610.56v.068l-6.063-3.5v-.067l6.063 3.499z"
            fill="#616161"
        />
        <path
            d="m441.6 605.93-7.966 4.628-6.062-3.5 7.944-4.616 6.084 3.488z"
            fill="#9C9B9B"
        />
        <path
            d="M441.6 605.58v.066l-7.966 4.629v-.069l7.966-4.626z"
            fill="#8C8B8B"
        />
        <path
            d="M433.63 610.21v.069l-6.063-3.5v-.067l6.063 3.498z"
            fill="#616161"
        />
        <path
            d="m441.6 605.58-7.966 4.626-6.062-3.5 7.944-4.617 6.084 3.491z"
            fill="#A8AFAF"
        />
        <path d="M441.6 605.19v.068l-6.85 3.977v-.067l6.85-3.978z" fill="#8C8B8B" />
        <path
            d="M432.5 609.17v.067l-4.937-2.849v-.069l4.937 2.851z"
            fill="#6C6C6C"
        />
        <path
            d="m441.6 605.19-6.85 3.979h-2.242l-4.935-2.851 7.967-4.628 6.06 3.5z"
            fill="#D2D8D8"
        />
        <path d="M439.85 605.65v.017l-.81.473v-.018l.81-.472z" fill="#858585" />
        <path d="M439.04 606.12v.018l-5.19-3v-.018l5.19 3z" fill="#5D5D5D" />
        <path
            d="m439.85 605.65-.81.472-5.187-3 .813-.473 5.184 3.001z"
            fill="#959595"
        />
        <path d="M438.6 606.35v.018l-.814.472v-.018l.814-.472z" fill="#858585" />
        <path
            d="M437.79 606.83v.018l-5.187-2.994v-.018l5.187 2.994z"
            fill="#5D5D5D"
        />
        <path
            d="m438.6 606.35-.814.472-5.187-2.994.814-.473 5.187 2.995z"
            fill="#959595"
        />
        <path d="M437.34 607.08v.019l-.812.471v-.021l.812-.469z" fill="#858585" />
        <path
            d="M436.53 607.55v.017l-5.187-2.994v-.017l5.187 2.994z"
            fill="#5D5D5D"
        />
        <path
            d="m437.34 607.08-.812.472-5.187-2.994.812-.473 5.187 2.995z"
            fill="#959595"
        />
        <path d="M436.04 607.84v.016l-.814.475v-.018l.814-.473z" fill="#858585" />
        <path d="M435.23 608.31v.019l-5.187-3v-.019l5.187 3z" fill="#5D5D5D" />
        <path
            d="m436.04 607.84-.814.472-5.187-3 .814-.473 5.187 3.001z"
            fill="#959595"
        />
        <path d="M434.73 608.6v.017l-.814.475v-.019l.814-.473z" fill="#858585" />
        <path d="M433.91 609.08v.019l-5.187-3v-.017l5.187 2.998z" fill="#5D5D5D" />
        <path
            d="m434.73 608.61-.814.473-5.187-3 .814-.475 5.187 3.002z"
            fill="#959595"
        />
        <path d="M434.75 609.17h-2.244v.067h2.244v-.067z" fill="#8C8B8B" />
        <path d="m433.63 608.52 1.126.649h-2.244l1.118-.649z" fill="#C3C3C3" />
        <path
            d="M484.03 629.2c.08.021.158.048.233.082a1.254 1.254 0 0 1 .769 1.275c-.074 1.116-2.82 2.081-2.82 2.081l-1.115.444 2.228 2.524c.269.662.42 1.365.445 2.078 0 1.041-.966 2.229-2.673 1.191-1.2-.73-5.123-2.749-5.123-2.749l-5.2 2.97s-2.079 1.188-2.378-1.114a6.055 6.055 0 0 1 .523-2.672l1.41-1.633s-4.754-2.6-6.832-3.045c-1.22-.26-1.781 2.3-3.712 2.6s-7.379-1.5-8.54-2.078c-1.485-.743-2.227-2.9-.073-3.046s7.945-3.045 7.945-3.045l5.124.447 5.567 1.412 5.525 4.107 7.024-2.4 1.673.571z"
            fill="#231F20"
            opacity={0.29}
            style={{ mixBlendMode: "multiply" }}
        />
        <path
            d="M481.52 634.11a2.094 2.094 0 0 1 .94 1.628c0 .6-.427.838-.946.535a2.047 2.047 0 0 1-.939-1.622c0-.602.425-.837.945-.541zm-.006 1.737c.315.181.569.035.571-.324a1.244 1.244 0 0 0-.569-.983c-.314-.181-.568-.038-.568.325a1.254 1.254 0 0 0 .566.984v-.002z"
            fill="#4C4C4C"
        />
        <path
            d="M481.51 634.54c-.314-.181-.568-.038-.568.325a1.242 1.242 0 0 0 .566.982c.315.181.569.035.571-.324a1.236 1.236 0 0 0-.569-.983z"
            fill="#747474"
        />
        <path
            d="M481.63 633.6a.666.666 0 0 1 .673.066 2.057 2.057 0 0 1 .934 1.627.663.663 0 0 1-.274.6l-.782.456a.666.666 0 0 0 .276-.6 2.1 2.1 0 0 0-.94-1.628.669.669 0 0 0-.67-.062l.783-.459z"
            fill="#3B3B3B"
        />
        <path
            d="M467.78 626.18a2.06 2.06 0 0 1 .934 1.629c0 .6-.418.835-.939.535a2.056 2.056 0 0 1-.938-1.622c.002-.599.422-.838.943-.542zm-.005 1.737c.316.183.57.037.572-.324a1.252 1.252 0 0 0-.567-.982c-.314-.183-.572-.037-.572.323a1.252 1.252 0 0 0 .567.983z"
            fill="#4C4C4C"
        />
        <path
            d="M467.78 626.62c-.314-.183-.572-.037-.572.323a1.261 1.261 0 0 0 .567.983c.316.183.57.037.572-.324a1.236 1.236 0 0 0-.166-.559 1.24 1.24 0 0 0-.401-.423z"
            fill="#747474"
        />
        <path
            d="M467.89 625.67a.68.68 0 0 1 .676.064 2.07 2.07 0 0 1 .935 1.627.65.65 0 0 1-.275.6l-.785.455a.652.652 0 0 0 .272-.6 2.071 2.071 0 0 0-.934-1.629.657.657 0 0 0-.67-.062l.781-.455z"
            fill="#3B3B3B"
        />
        <path
            d="M468.37 633.92a.66.66 0 0 1 .668-.069c.066.037.129.076.2.113.092.053.182.108.275.161l.313.183a.67.67 0 0 0-.672.064c-.114.07-.219.153-.313.247l.313.182a1.265 1.265 0 0 0-.4.423 1.264 1.264 0 0 0-.165.558.4.4 0 0 0 .169.364l-.528-.3c-.005.054-.013.106-.013.156a.671.671 0 0 0 .275.6l-.784-.455a.66.66 0 0 1-.276-.6 2.06 2.06 0 0 1 .938-1.627z"
            fill="#4C4C4C"
        />
        <path
            d="m469.56 634.77-.784-.458a.406.406 0 0 1 .168.367 1.265 1.265 0 0 1-.566.981l.781.456a1.239 1.239 0 0 0 .566-.981.39.39 0 0 0-.165-.365z"
            fill="#4C4C4C"
        />
        <path
            d="M469.15 634.38c.522-.3.945-.059.947.538a2.07 2.07 0 0 1-.939 1.627c-.52.3-.942.058-.945-.54a2.063 2.063 0 0 1 .937-1.625zm.006 1.736a1.241 1.241 0 0 0 .566-.981c0-.362-.256-.508-.572-.326a1.243 1.243 0 0 0-.565.981c.003.361.258.507.571.326z"
            fill="#3F3F3F"
        />
        <path
            d="M469.15 634.8c.316-.182.572-.036.572.326a1.241 1.241 0 0 1-.566.981c-.313.181-.568.035-.571-.326a1.25 1.25 0 0 1 .565-.981z"
            fill="#7B7B7B"
        />
        <path
            d="M482.1 625.99a.655.655 0 0 1 .669-.065c.066.037.13.075.2.112.088.055.181.111.273.16l.313.183a.665.665 0 0 0-.67.063c-.114.07-.22.154-.313.251l.313.181a1.243 1.243 0 0 0-.566.981.403.403 0 0 0 .167.365l-.525-.307a1.145 1.145 0 0 0-.017.156.663.663 0 0 0 .279.6l-.785-.455a.658.658 0 0 1-.274-.6 2.062 2.062 0 0 1 .936-1.625z"
            fill="#4C4C4C"
        />
        <path
            d="M482.89 626.44c.519-.3.943-.056.947.54a2.068 2.068 0 0 1-.94 1.627c-.519.3-.946.057-.948-.54a2.086 2.086 0 0 1 .941-1.627zm.005 1.738c.166-.107.303-.252.402-.422.098-.171.154-.363.164-.56 0-.361-.257-.5-.571-.324a1.255 1.255 0 0 0-.566.981c.002.361.257.507.571.325z"
            fill="#3F3F3F"
        />
        <path
            d="M482.89 626.88c.314-.181.57-.037.571.324a1.241 1.241 0 0 1-.566.982c-.314.182-.569.036-.571-.325a1.252 1.252 0 0 1 .566-.981z"
            fill="#7B7B7B"
        />
        <path
            d="m467.8 624.91 6.435 3.742v1.243l-6.437-3.74a.464.464 0 0 1-.27-.381l-.008-1.243a.474.474 0 0 0 .088.228c.05.066.116.119.192.151z"
            fill="#3E3E3E"
        />
        <path
            d="M483.37 624.91a.465.465 0 0 0 .277-.387v1.244a.47.47 0 0 1-.278.386l-6.48 3.741v-1.242l6.481-3.742z"
            fill="#303030"
        />
        <path
            d="M467.8 624.14a1.453 1.453 0 0 1 1.32 0l6.438 3.741v.263l-6.908-4.015a.412.412 0 0 0-.377 0 .109.109 0 0 0-.057.042.11.11 0 0 0-.022.068c0 .024.007.048.022.067.014.02.034.035.057.043l6.908 4.014-.945.284-6.435-3.742c-.367-.211-.365-.554-.001-.765z"
            fill="#414141"
        />
        <path
            d="M482.9 624.13a.418.418 0 0 0-.379 0l-6.955 4.017v-.263l6.483-3.742a1.458 1.458 0 0 1 1.32 0 .402.402 0 0 1 .199.619.398.398 0 0 1-.199.148l-6.48 3.742-.944-.286 6.953-4.014a.128.128 0 0 0 .058-.042.12.12 0 0 0 .001-.136.116.116 0 0 0-.057-.043z"
            fill="#494949"
        />
        <path
            d="M468.28 624.13a.121.121 0 0 0-.058.042c-.014.02-.021.044-.021.068s.007.048.021.068a.128.128 0 0 0 .058.042l6.908 4.014-6.955 4.016a.114.114 0 0 0-.057.042.114.114 0 0 0 .057.176.411.411 0 0 0 .377 0l6.957-4.013 6.906 4.013a.42.42 0 0 0 .382 0 .116.116 0 0 0 .055-.043.116.116 0 0 0-.055-.175l-6.909-4.016 6.953-4.014a.118.118 0 0 0 .077-.11.118.118 0 0 0-.077-.11.418.418 0 0 0-.379 0l-6.955 4.017-6.908-4.015a.4.4 0 0 0-.377-.002z"
            fill="#303030"
        />
        <path
            d="M467.75 633.15a1.464 1.464 0 0 0 1.322 0l6.481-3.739v1.242l-6.48 3.74a1.456 1.456 0 0 1-1.322 0 .483.483 0 0 1-.274-.381v-1.242a.464.464 0 0 0 .273.38z"
            fill="#303030"
        />
        <path
            d="m467.76 632.39 6.478-3.74.945-.284-6.955 4.016a.113.113 0 0 0-.078.109c0 .024.007.047.021.067a.12.12 0 0 0 .057.042.411.411 0 0 0 .377 0l6.957-4.013v.832l-6.481 3.739a1.46 1.46 0 0 1-1.322 0c-.369-.211-.369-.554.001-.768z"
            fill="#4C4C4C"
        />
        <path
            d="m475.56 628.59 6.906 4.013a.42.42 0 0 0 .382 0 .116.116 0 0 0 .055-.043.116.116 0 0 0-.055-.175l-6.909-4.016.944.286 6.436 3.738a.406.406 0 0 1 .199.622.406.406 0 0 1-.199.149 1.464 1.464 0 0 1-1.323 0l-6.438-3.739.002-.835z"
            fill="#4C4C4C"
        />
        <path
            d="M482 633.15a1.476 1.476 0 0 0 1.324 0 .474.474 0 0 0 .276-.387v1.243a.473.473 0 0 1-.278.384 1.464 1.464 0 0 1-1.322 0l-6.438-3.74v-1.242L482 633.15z"
            fill="#3E3E3E"
        />
        <path
            d="M474.4 625.3a.57.57 0 0 1 .329-.469 1.792 1.792 0 0 1 1.642-.016.578.578 0 0 1 .354.48l.009 3.244a.301.301 0 0 1-.012.072c0 .016 0 .034-.008.052a.591.591 0 0 1-.037.076c-.009.017-.013.031-.024.051s-.045.051-.071.077a.201.201 0 0 1-.033.039.981.981 0 0 1-.145.1 1.813 1.813 0 0 1-1.643.017 1.93 1.93 0 0 1-.154-.1l-.035-.042a.437.437 0 0 1-.074-.081c-.012-.014-.017-.034-.029-.048a.884.884 0 0 1-.039-.075c-.006-.02-.006-.039-.01-.057a.45.45 0 0 1-.012-.072v-.006l-.008-3.242z"
            fill="#303030"
        />
        <path
            d="M475.14 622.43a.91.91 0 0 1 .836-.008.305.305 0 0 1 .179.244v2.427a.193.193 0 0 1 0 .034.084.084 0 0 1-.007.026.203.203 0 0 1-.014.039c-.006.009-.007.018-.014.027a.282.282 0 0 1-.033.036.531.531 0 0 1-.093.077.92.92 0 0 1-.835.009.325.325 0 0 1-.076-.056.033.033 0 0 1-.014-.012l-.044-.044-.016-.028c0-.012-.012-.024-.016-.038s0-.02-.007-.029a.121.121 0 0 1-.007-.037v-2.426a.283.283 0 0 1 .161-.241z"
            fill="#829DA8"
        />
        <path
            d="M468.72 620.72a1.325 1.325 0 0 1 .158-.147c.015-.011.028-.025.047-.037.05-.041.103-.077.158-.107l2.882-1.665-.286-.167-2.879 1.667a1.376 1.376 0 0 0-.16.105l-.049.043a1.622 1.622 0 0 0-.106.1l-.051.051c-.036.039-.07.08-.1.122-.011.016-.026.03-.034.043l-.014.014a1.564 1.564 0 0 0-.12.18l-1.521 2.494.287.166 1.518-2.5c.041-.068.086-.13.131-.193.01-.013.024-.026.033-.038a.963.963 0 0 1 .106-.131zM466.75 623.6l-.283-.164a.174.174 0 0 1 .082-.033c.03-.003.06.002.088.015l.282.163a.175.175 0 0 0-.087-.013.183.183 0 0 0-.082.032z"
            fill="#4C4C4C"
        />
        <path
            d="M466.64 623.41a.164.164 0 0 0-.17.018l-1.33.766a.244.244 0 0 0-.062.049.047.047 0 0 0-.015.013.236.236 0 0 0-.049.055h-.006a.782.782 0 0 0-.04.06l-.008.017a.234.234 0 0 0-.023.051v.017a.6.6 0 0 1-.017.055v.016a.24.24 0 0 0-.009.076.172.172 0 0 0 .07.157l.285.163a.169.169 0 0 1-.07-.158v-.067l.006-.015a.558.558 0 0 1 .018-.058l.01-.024a.149.149 0 0 1 .019-.045l.01-.02a.602.602 0 0 1 .039-.059l.01-.014a.243.243 0 0 1 .047-.049.39.39 0 0 1 .078-.062l1.328-.767a.175.175 0 0 1 .082-.031c.03-.004.06 0 .087.012l-.29-.156z"
            fill="#6B6B6B"
        />
        <path
            d="M471.97 618.77v.193l-2.882 1.664a1.545 1.545 0 0 0-.525.538l-1.567 2.57a.527.527 0 0 1-.238.418l-1.33.769c-.133.075-.24.014-.24-.143a.518.518 0 0 1 .24-.413l1.328-.767a.17.17 0 0 1 .177-.015l1.518-2.5a1.87 1.87 0 0 1 .637-.653l2.882-1.661z"
            fill="#2A2A2A"
        />
        <path
            d="m467.23 616.13 8.264-4.773a.697.697 0 0 1 .34-.131.697.697 0 0 1 .36.062l8.225 4.736a.697.697 0 0 0-.7.073l-8.266 4.771a2.136 2.136 0 0 0-.971 1.685.684.684 0 0 0 .283.627c-2.03-1.179-6.2-3.561-8.226-4.741a.67.67 0 0 1-.284-.624 2.125 2.125 0 0 1 .975-1.685z"
            fill="#183447"
        />
        <path
            d="M475.46 620.87a2.142 2.142 0 0 0-.971 1.685c0 .62.441.872.979.559l8.265-4.772a2.146 2.146 0 0 0 .973-1.685c0-.622-.438-.87-.98-.558l-8.266 4.771z"
            fill="#2F5B68"
        />
        <path
            d="M463.68 623.68a1.016 1.016 0 0 1-1.03.662c-.469-.056-1.138-.175-1.138-.175-.759-.309-1.749-.5-2.052.051-.067.105-.116.22-.147.341-.047.439-.127.047.358.7a14.938 14.938 0 0 0 1.574 1.548c.428.383.956.636 1.523.729a3.9 3.9 0 0 1 .932.122c.382.128.18.6.1.99l1.1.746a1.941 1.941 0 0 0 2.4-.583l.643-3.1-4.263-2.031z"
            fill="#545454"
        />
        <path
            d="M463.3 627.45a7.116 7.116 0 0 1-1.673-.7 9.452 9.452 0 0 1-1.859-1.531 1.14 1.14 0 0 1-.38-.858 2.211 2.211 0 0 0-.08.242c-.109.39.189.678.433.934.442.501.946.943 1.5 1.315.438.296.93.502 1.447.606l.881.224c.161.041.362.18.352.225-.004-.027 0-.315-.621-.457zM464.97 629.05l-1.092-.742c-.026.127-.063.259-.089.385l1.1.744a1.95 1.95 0 0 0 2.4-.581l.08-.39a1.954 1.954 0 0 1-2.399.584z"
            fill="#383736"
        />
        <path
            d="m466.7 612.65-2.987.9s-1.648 11.917-1.6 12.2c.059.382.686 1.967 3.338 1.84 1.622-.077 2.561-.586 2.67-.916l1.751-11.363-3.172-2.661z"
            fill="#01283A"
        />
        <path
            d="M457.44 627.42a1.772 1.772 0 0 1-1.25.388c-.5-.024-2.113-.224-2.113-.224-.8-.1-1.811-.1-2.152.632a2.517 2.517 0 0 0-.155.5c-.009.453.362.726.821 1.035.508.335 1.037.636 1.585.9.72.354 1.5.568 2.3.632.448.033.894.09 1.337.169.414.1.269.387.219.785l1.229.678a2.08 2.08 0 0 0 2.484-.77l.373-2.982-4.678-1.743z"
            fill="#545454"
        />
        <path
            d="M457.37 631.28a10.419 10.419 0 0 1-2.45-.514 15.396 15.396 0 0 1-2.405-1.345c-.407-.274-.719-.645-.685-.907-.03.082-.052.167-.065.253-.008.451.362.726.822 1.034a13.42 13.42 0 0 0 1.588.9c.719.355 1.5.57 2.3.631l1.137.121c.254.025.481.15.475.2-.006-.025-.047-.272-.717-.373zM459.32 632.39l-1.217-.671a70.6 70.6 0 0 1-.082.569l1.232.677a2.077 2.077 0 0 0 2.481-.771l.069-.573a2.085 2.085 0 0 1-2.483.769z"
            fill="#383736"
        />
        <path
            d="m463.43 611.25-4.581 3.227s-2.336 13.265-2.3 13.553c.041.382.387 1.4 2.3 2.253.953.426 3.247.019 3.371-.307l1.728-14.021-.518-4.705z"
            fill="#024063"
        />
        <path
            d="m478.72 611.5-3.1-1.439-6.56-2.652c-1.651-.777-5.218-.9-5.127 2.519l-.209 3.617 6.459.92s4.893 2.136 7.011 1.934c3.775-.359 1.526-4.899 1.526-4.899z"
            fill="#01283A"
        />
        <path
            d="M479.44 616.85c1.619-1.259 1.664-4.54 1.664-4.54l-.9-6.923-6.92 3.6-2.248 3.418-7.111-1.181c-2.669-.247-4.356-.3-5.065 3.262l3.414 1.478s7.067 2.314 9.076 3c3.412 1.167 6.545-.914 8.09-2.114z"
            fill="#024063"
        />
        <path
            d="m473.78 599.92-1.357-.772-1.049.605 1.326.771 1.08-.604z"
            fill="#995710"
        />
        <path
            d="m470.34 585.13-2.628.572 1.744 6.728c.465 1.938 1.342 2.09 1.935 1.991a7.23 7.23 0 0 0 3.1-1.67c1.193-1.025.761-3.31.742-3.5l-.375-4.637-4.518.516z"
            fill="#FFE1CC"
        />
        <path
            d="m476.23 593.93-1.1-4.051-3.387 1.124.818 3.96c.053.568-1.655 5.688-1.492 7.457l6.348-2.712c-.065-.751-1.187-5.778-1.187-5.778z"
            fill="#FFE1CC"
        />
        <path
            d="M467.71 585.33c-.98 1.054.618 2.748.618 2.748s-.185-.474-.073-.426a2.433 2.433 0 0 1 1.408 1.73l.263.785c.033.263.539.2.662-.213.138-.465-.46-.163-.307-.414s.683-.424 1.442.951l.461 1.084a3 3 0 0 0 2.516.807 2.113 2.113 0 0 0 1.055-.776c.39-.97.716-1.963.977-2.974.836-3.428-1.391-7.327-6.308-5.337a9.565 9.565 0 0 0-2.714 2.035z"
            fill="#331E06"
        />
        <path
            d="M470.26 588.77a1.007 1.007 0 0 1 .838.633 1.16 1.16 0 0 1 .009.962 1.04 1.04 0 0 1-.439.425s-.134-1.092-.169-1.291a7.569 7.569 0 0 0-.239-.729z"
            fill="#EFCFBD"
        />
        <path
            d="M469.96 588.57s-.322.027-.035.455c.211.281.354.607.418.953.035.237.071.951.071.951s.239.264.376-.192c.075-.369.075-.75 0-1.118-.03-.202-.493-1.197-.83-1.049z"
            fill="#FFE8D9"
        />
        <path
            d="M475.74 592.74c.454-.152.581-.083.693.193s.116.287.25.547c.109.215.005.242.005.242a15.891 15.891 0 0 0-3.889 2.2c-1.154.952-1.239 1.041-1.239 1.041l.2-.972a4.262 4.262 0 0 1 2.339-2.447 13.996 13.996 0 0 1 1.641-.804z"
            fill="#E4EFF4"
        />
        <path
            d="M466.73 598.77s-2.8-.63-3.329-.718a6.945 6.945 0 0 0-2.943.718l-1.191 1.1s-.159.247.269.339 1.068-.675 1.068-.675l1.246-.36s.8-.027.833.36c.023.294-.669.444-.965.494-.2.035-.661.175-.743.382a.351.351 0 0 0-.011.257c.03.084.091.153.17.194a4.886 4.886 0 0 0 1.123-.135c.762-.136 1.336-.167 1.775-.248.375-.077.715-.274.967-.562l1.4.359.331-1.505zM459.34 605.18a17.257 17.257 0 0 0-3.1 0c-.856.181-3.372 1.169-3.372 1.169s-.721.27-.314.72c.316.258.646.499.988.72.225.18.9.226 2.25-.044a4.818 4.818 0 0 1 1.842-.047 4.42 4.42 0 0 0 1.754-.269l-.048-2.249z"
            fill="#FFE1CC"
        />
        <path
            d="M476.72 593.73s2.517-.211 2.636 2.965a24.012 24.012 0 0 1-2.156 5.367 3.18 3.18 0 0 1-3.3 1.271c-1.741-.267-8.359-2.291-8.359-2.291s-.332-.359.058-1.467a1.491 1.491 0 0 1 .75-.931l7.223.749 3.148-5.663z"
            fill="#5D6475"
        />
        <path
            d="M470.48 598.13c-.688.86-.9 1.761-.647 4.535l.7 10.637a3.927 3.927 0 0 0 2.294 3.369c1.44.66 3.076.757 4.584.27.7-.3 3.688-1.983 3.76-3.489l-1.291-14.251c-.569-4.81-3.406-5.569-3.406-5.569l-3.194 1.458-2.8 3.04z"
            fill="#757A89"
        />
        <path
            d="M458.35 606.32c.005.555.149 1.1.419 1.585 0 0 5.373.51 6.1.563a3.89 3.89 0 0 0 2.445-.558c1.7-.85 5.116-4.567 5.116-4.567s2.488-2.4 1.433-4.511a2.233 2.233 0 0 0-3.764-.15c-.878 1.118-2.874 3.806-4.009 5.148a2.144 2.144 0 0 1-1.7.764l-4.975.136a.822.822 0 0 0-.829.3c-.197.4-.279.847-.236 1.29z"
            fill="#9598A0"
        />
        <path
            d="M480.21 609.26v11.428a.797.797 0 0 1-1.07-.308.802.802 0 0 1-.106-.392v-10.365l1.176-.363z"
            fill="#303030"
        />
        <path
            d="M480.07 609.44a.458.458 0 0 1 .542.23.458.458 0 0 1 .048.206v9.889a1.153 1.153 0 0 1-.59 1 .405.405 0 0 1-.391-.008.4.4 0 0 1-.198-.337v-10.183a.838.838 0 0 1 .589-.797z"
            fill="#4C4C4C"
        />
        <path
            d="M484.22 603.6s-.764-.753-1.131.054c-.43.945-.586 1.485-2.654 2.386a9.254 9.254 0 0 1-3.772.73c-2 .039-3.07.921-3.039 2.348a2.421 2.421 0 0 0 2.014 2.193c2.258.2 3.008-.408 5.575-1.549 2.293-1.017 2.513-1.693 2.625-2.076.204-1.353.331-2.718.382-4.086z"
            fill="#204351"
        />
        <path
            d="M484.22 603.6s.279 1.851-3.043 3.043a15.468 15.468 0 0 1-4.166.974c-1.463.117-2.615.463-2.5 1.81a1.88 1.88 0 0 0 1.654 1.961 8.179 8.179 0 0 0 4.924-.5c2.248-.819 2.842-2.234 2.953-3.311.078-.785.178-3.977.178-3.977z"
            fill="#2F5B68"
        />
        <path
            d="m349.45 603.3 1.083-.628v.76a1.198 1.198 0 0 0 .543.939l.661.381-1.082.629-.66-.382a1.19 1.19 0 0 1-.542-.94l-.003-.759z"
            fill="#323232"
        />
        <path
            d="m348.62 602.82-.006 1.094a2.389 2.389 0 0 0 1.085 1.879l.952.549v-.959l-.66-.382a1.19 1.19 0 0 1-.542-.94v-.759l-.829-.482z"
            fill="#232323"
        />
        <path
            d="M359.77 629.9a2.6 2.6 0 0 0 1.189 2.062c.66.38 1.2.075 1.2-.683a2.622 2.622 0 0 0-1.191-2.06c-.661-.381-1.198-.08-1.198.681zm.47.274c0-.46.327-.642.725-.414a1.583 1.583 0 0 1 .717 1.248c0 .455-.324.641-.723.41a1.591 1.591 0 0 1-.719-1.244z"
            fill="#4C4C4C"
        />
        <path
            d="M360.96 629.76c-.4-.228-.725-.046-.725.414a1.589 1.589 0 0 0 .719 1.244c.4.231.723.045.723-.41a1.585 1.585 0 0 0-.717-1.248z"
            fill="#747474"
        />
        <path
            d="M361.1 628.56a.838.838 0 0 1 .851.083 2.633 2.633 0 0 1 1.191 2.061.837.837 0 0 1-.349.765l-.993.578a.842.842 0 0 0 .347-.765 2.608 2.608 0 0 0-1.191-2.06.845.845 0 0 0-.848-.085l.992-.577z"
            fill="#3B3B3B"
        />
        <path
            d="M342.34 619.84a2.627 2.627 0 0 0 1.192 2.062c.659.379 1.2.074 1.2-.683a2.626 2.626 0 0 0-1.191-2.063c-.662-.38-1.2-.075-1.201.684zm.472.271c0-.458.327-.641.723-.412a1.588 1.588 0 0 1 .72 1.247c0 .458-.325.643-.722.414a1.582 1.582 0 0 1-.721-1.249z"
            fill="#4C4C4C"
        />
        <path
            d="M343.53 619.7c-.4-.229-.722-.046-.723.412a1.587 1.587 0 0 0 .721 1.249c.4.229.722.044.722-.414a1.593 1.593 0 0 0-.72-1.247z"
            fill="#747474"
        />
        <path
            d="M343.68 618.49a.85.85 0 0 1 .851.082 2.624 2.624 0 0 1 1.189 2.063.837.837 0 0 1-.346.765l-.994.578a.836.836 0 0 0 .347-.766 2.63 2.63 0 0 0-1.191-2.063.843.843 0 0 0-.85-.081l.994-.578z"
            fill="#3B3B3B"
        />
        <path
            d="M344.28 628.97a.833.833 0 0 1 .85-.084c.082.05.166.1.249.144.115.07.234.136.348.2l.4.231a.84.84 0 0 0-.85.083 1.92 1.92 0 0 0-.4.313l.4.23a1.583 1.583 0 0 0-.719 1.246.518.518 0 0 0 .211.464l-.67-.389c-.006.068-.013.134-.013.2a.837.837 0 0 0 .346.767l-.994-.579a.833.833 0 0 1-.349-.766 2.637 2.637 0 0 1 1.191-2.06z"
            fill="#4C4C4C"
        />
        <path
            d="m345.79 630.04-1-.578a.503.503 0 0 1 .21.462 1.578 1.578 0 0 1-.716 1.246l.995.58c.209-.137.383-.321.508-.538.124-.217.195-.46.208-.71a.491.491 0 0 0-.208-.462h.003z"
            fill="#4C4C4C"
        />
        <path
            d="M344.09 631.61c0 .757.538 1.064 1.2.682a2.622 2.622 0 0 0 1.19-2.061c0-.76-.54-1.064-1.2-.684a2.627 2.627 0 0 0-1.19 2.063zm.472-.274a1.588 1.588 0 0 1 .719-1.246c.4-.228.723-.044.723.414a1.586 1.586 0 0 1-.716 1.248c-.402.229-.724.041-.726-.416z"
            fill="#3F3F3F"
        />
        <path
            d="M345.28 630.09c.4-.228.723-.044.723.414a1.598 1.598 0 0 1-.716 1.248c-.4.229-.724.041-.726-.416a1.579 1.579 0 0 1 .719-1.246z"
            fill="#7B7B7B"
        />
        <path
            d="M361.71 618.9a.848.848 0 0 1 .848-.081l.25.143c.115.069.234.136.347.2l.4.232a.848.848 0 0 0-.85.082 1.994 1.994 0 0 0-.4.314l.4.231a1.587 1.587 0 0 0-.721 1.246.502.502 0 0 0 .212.464l-.67-.39c-.006.067-.016.135-.016.2a.84.84 0 0 0 .351.767l-.995-.579a.846.846 0 0 1-.352-.765 2.637 2.637 0 0 1 1.196-2.064z"
            fill="#4C4C4C"
        />
        <path
            d="M361.51 621.55c0 .757.539 1.063 1.2.683a2.627 2.627 0 0 0 1.191-2.064c0-.755-.538-1.063-1.2-.683a2.63 2.63 0 0 0-1.191 2.064zm.474-.273a1.579 1.579 0 0 1 .721-1.246c.4-.229.72-.045.72.414a1.583 1.583 0 0 1-.716 1.246c-.398.234-.722.044-.725-.414z"
            fill="#3F3F3F"
        />
        <path
            d="M362.71 620.03c.4-.229.72-.045.72.414a1.582 1.582 0 0 1-.716 1.246c-.4.23-.722.044-.725-.414a1.583 1.583 0 0 1 .721-1.246z"
            fill="#7B7B7B"
        />
        <path
            d="m343.56 617.53 8.17 4.747.005 1.577-8.171-4.747a.587.587 0 0 1-.343-.483v-1.578a.586.586 0 0 0 .339.484z"
            fill="#3E3E3E"
        />
        <path
            d="M363.31 617.53a.603.603 0 0 0 .35-.491l.006 1.579a.607.607 0 0 1-.352.489l-8.226 4.75v-1.578l8.222-4.749z"
            fill="#303030"
        />
        <path
            d="M343.56 616.56a1.849 1.849 0 0 1 1.677 0l8.171 4.747-.006.332-8.766-5.1a.555.555 0 0 0-.481 0 .146.146 0 0 0-.098.14c0 .03.009.06.027.085s.043.044.071.054l8.767 5.104-1.2.36-8.17-4.747a.512.512 0 0 1 .008-.975z"
            fill="#414141"
        />
        <path
            d="M362.72 616.54a.556.556 0 0 0-.482 0l-8.826 5.1.006-.332 8.225-4.749a1.844 1.844 0 0 1 1.68 0 .512.512 0 0 1-.006.971l-8.225 4.749-1.2-.362 8.825-5.1a.147.147 0 0 0 .072-.053.15.15 0 0 0 .001-.169.147.147 0 0 0-.07-.055z"
            fill="#494949"
        />
        <path
            d="M344.16 616.54a.149.149 0 0 0-.099.139.146.146 0 0 0 .099.14l8.767 5.1-8.827 5.1a.149.149 0 0 0-.099.139.146.146 0 0 0 .099.14.529.529 0 0 0 .483 0l8.826-5.1 8.765 5.094a.53.53 0 0 0 .484 0 .149.149 0 0 0 .072-.226.147.147 0 0 0-.072-.053l-8.768-5.1 8.825-5.1a.143.143 0 0 0 .072-.054.147.147 0 0 0 0-.172.147.147 0 0 0-.072-.053.55.55 0 0 0-.482 0l-8.826 5.1-8.766-5.1a.548.548 0 0 0-.481.006z"
            fill="#303030"
        />
        <path
            d="M343.5 628a1.84 1.84 0 0 0 1.677 0l8.226-4.75v1.578l-8.225 4.749a1.836 1.836 0 0 1-1.677 0 .587.587 0 0 1-.346-.484v-1.577a.582.582 0 0 0 .345.484z"
            fill="#303030"
        />
        <path
            d="m343.5 627.03 8.225-4.751 1.2-.36-8.827 5.1a.142.142 0 0 0-.071.054.147.147 0 0 0-.028.085c0 .031.01.061.028.086a.142.142 0 0 0 .071.054.535.535 0 0 0 .483 0l8.826-5.1v1.054l-8.226 4.75a1.84 1.84 0 0 1-1.677 0 .512.512 0 0 1-.004-.972zM353.41 622.2l8.765 5.094a.524.524 0 0 0 .484 0 .147.147 0 0 0 0-.279l-8.768-5.1 1.2.362 8.168 4.749a.516.516 0 0 1 0 .971 1.844 1.844 0 0 1-1.68 0l-8.169-4.75V622.2z"
            fill="#4C4C4C"
        />
        <path
            d="M361.57 628a1.844 1.844 0 0 0 1.68 0 .59.59 0 0 0 .351-.489v1.579a.586.586 0 0 1-.35.487 1.837 1.837 0 0 1-1.677 0l-8.171-4.748v-1.578L361.57 628z"
            fill="#3E3E3E"
        />
        <path
            d="M351.93 618.03a.725.725 0 0 1 .415-.6 2.3 2.3 0 0 1 2.088-.023.752.752 0 0 1 .446.613l.013 4.119a.607.607 0 0 1-.014.087.387.387 0 0 1-.012.068.6.6 0 0 1-.045.1.321.321 0 0 1-.032.061.68.68 0 0 1-.085.1c-.016.017-.028.035-.045.051a1.26 1.26 0 0 1-.185.134 2.29 2.29 0 0 1-1.041.26 2.282 2.282 0 0 1-1.045-.24 1.161 1.161 0 0 1-.193-.133c-.019-.015-.032-.034-.048-.048a.89.89 0 0 1-.094-.1c-.013-.022-.019-.045-.033-.067a.628.628 0 0 1-.05-.092.301.301 0 0 1-.012-.073.742.742 0 0 1-.018-.094 808.65 808.65 0 0 0-.01-4.123z"
            fill="#303030"
        />
        <path
            d="M352.87 614.39a1.177 1.177 0 0 1 1.06-.012.365.365 0 0 1 .227.313l.01 3.078a.222.222 0 0 1-.007.045c0 .012 0 .023-.006.034a.265.265 0 0 1-.023.048.301.301 0 0 1-.016.031c-.013.018-.028.032-.042.049l-.027.028a.352.352 0 0 1-.092.066 1.16 1.16 0 0 1-1.061.013.734.734 0 0 1-.1-.068.132.132 0 0 0-.022-.026c-.016-.017-.033-.031-.047-.049a.231.231 0 0 1-.018-.035.255.255 0 0 1-.025-.046c0-.014 0-.026-.007-.039a.34.34 0 0 1-.006-.046v-1.538l-.006-1.54a.375.375 0 0 1 .208-.306z"
            fill="#969696"
        />
        <path
            d="M347.24 616.88c.018-.02.039-.039.059-.06.045-.045.093-.086.14-.127.019-.016.038-.034.057-.047.064-.051.131-.098.2-.14l3.658-2.111-.361-.208-3.657 2.109a2.09 2.09 0 0 0-.2.138l-.062.052a1.415 1.415 0 0 0-.134.123 1.352 1.352 0 0 0-.065.066c-.045.048-.088.1-.131.151-.017.021-.033.037-.047.058l-.013.015a2.344 2.344 0 0 0-.155.228l-1.929 3.168.361.208 1.927-3.166c.054-.086.11-.168.169-.247a2.742 2.742 0 0 1 .183-.21z"
            fill="#4C4C4C"
        />
        <path
            d="m344.74 620.52-.362-.212a.217.217 0 0 1 .218-.021l.36.209a.207.207 0 0 0-.216.024z"
            fill="#4C4C4C"
        />
        <path
            d="M344.6 620.29a.217.217 0 0 0-.218.021l-1.686.974a.348.348 0 0 0-.078.059l-.02.02a.38.38 0 0 0-.063.07l-.006.006a.31.31 0 0 0-.05.074c0 .009-.01.016-.014.025a.867.867 0 0 1-.028.063v.019a.634.634 0 0 0-.023.074v.025a.527.527 0 0 0-.01.089.213.213 0 0 0 .089.2l.362.21a.216.216 0 0 1-.091-.2.642.642 0 0 1 .009-.087l.009-.029c0-.022.012-.043.017-.064l.01-.028.029-.059.01-.024c.017-.027.033-.053.051-.077l.013-.013a.442.442 0 0 1 .056-.067l.023-.018a.294.294 0 0 1 .077-.058l1.688-.973a.207.207 0 0 1 .216-.024l-.372-.208z"
            fill="#6B6B6B"
        />
        <path
            d="M351.36 614.39v.243l-3.658 2.111a1.956 1.956 0 0 0-.664.686l-1.99 3.261a.658.658 0 0 1-.3.53l-1.686.973c-.171.1-.307.019-.308-.177a.664.664 0 0 1 .3-.524l1.688-.973a.21.21 0 0 1 .222-.022l1.927-3.166c.198-.339.476-.624.81-.831l3.659-2.111z"
            fill="#2A2A2A"
        />
        <path
            d="m356.99 598.4-.773-.45-3.64 2.118.773.449 3.64-2.117z"
            fill="#313131"
        />
        <path
            d="m355.96 599.12 1.6-7.144.771.449 3.382 1.953v.892l-3.556-2.049-1.419 6.347-.778-.448z"
            fill="#313131"
        />
        <path
            d="m352.58 601.08.773.449v-1.027l-.773-.449v1.027zM362.64 593.84v.893l-.923.537v-.892l.923-.538z"
            fill="#464646"
        />
        <path
            d="m362.64 593.84-.924.539-4.153-2.4.924-.536 4.153 2.397z"
            fill="#363636"
        />
        <path
            d="m357 598.4 1.162-5.175.684.4-1.22 5.441-4.265 2.462v-1.013L357 598.4z"
            fill="#464646"
        />
        <path
            d="M345.9 604.23c.039.029.07.067.09.111s.028.092.023.14l.006 1.822-2.318-1.348-.006-1.821a.27.27 0 0 0-.114-.25l2.319 1.346z"
            fill="#818182"
        />
        <path
            d="M345.4 587.77a3.083 3.083 0 0 0-1.426 2.9l.3 1.262c.143.607.215 4.779.217 5.489l.018 6.584c0 .492.351.69.78.443l.333-.194c.214-.126.39-.024.39.223l.006 1.822 7.486-4.323a.383.383 0 0 0 .188-.33v-1.6a.84.84 0 0 1 .389-.668l.331-.193a1.701 1.701 0 0 0 .774-1.337l-.019-6.586c0-.707.069-4.963.207-5.734l.288-1.6c.214-1.189-.489-1.8-1.441-1.252l-8.821 5.094z"
            fill="#19242B"
        />
        <path
            d="m343.09 586.42 8.813-5.089a1.039 1.039 0 0 1 1.047-.1l2.317 1.346a1.027 1.027 0 0 0-1.048.1l-8.814 5.09a3.081 3.081 0 0 0-1.426 2.9l.3 1.262c.143.607.215 4.779.217 5.489l.018 6.584a.543.543 0 0 0 .227.5l-2.318-1.347a.532.532 0 0 1-.224-.495l-.02-6.583c0-.712-.076-4.884-.218-5.492l-.295-1.259a3.077 3.077 0 0 1 1.424-2.906z"
            fill="#344049"
        />
        <path
            d="m348.49 581.52-.64-.371v3.667l.641.374-.001-3.67z"
            fill="#3B3B3B"
        />
        <path
            d="m348.49 581.52.006 3.67.967-.557-.008-3.669-.965.556z"
            fill="#292929"
        />
        <path
            d="m345.49 608.31 10.492-6.058a.878.878 0 0 1 .881-.086l10.438 6.014a.871.871 0 0 0-.881.088l-10.488 6.054a2.726 2.726 0 0 0-1.234 2.139.864.864 0 0 0 .36.795c-2.574-1.494-7.863-4.519-10.44-6.014a.871.871 0 0 1-.359-.8 2.715 2.715 0 0 1 1.231-2.132z"
            fill="#344049"
        />
        <path
            d="M355.93 614.32a2.725 2.725 0 0 0-1.234 2.139c0 .787.556 1.1 1.243.709l10.49-6.058a2.706 2.706 0 0 0 1.235-2.138c0-.786-.557-1.1-1.244-.708l-10.49 6.056z"
            fill="#969696"
        />
        <path
            d="m344.7 578.47 5.922-3.419a.548.548 0 0 1 .554-.054l1.544.9a.541.541 0 0 0-.551.052l-5.923 3.418a1.697 1.697 0 0 0-.771 1.339l.006 2.581a.542.542 0 0 0 .225.495l-1.545-.9a.537.537 0 0 1-.225-.5l-.008-2.581a1.705 1.705 0 0 1 .772-1.331z"
            fill="#344049"
        />
        <path
            d="M346.25 579.37a1.688 1.688 0 0 0-.771 1.339l.006 2.581c0 .49.35.689.775.442l5.926-3.418a1.697 1.697 0 0 0 .772-1.34l-.008-2.578c0-.493-.351-.69-.777-.444l-5.923 3.418z"
            fill="#19242B"
        />
        <path
            d="m345.32 604.88-.773-.449-3.977 2.294.773.448 3.977-2.293z"
            fill="#313131"
        />
        <path
            d="m340.35 602.78 1.312 4.207 3.65-2.106v1.015l-4.267 2.465-1.584-5.069.889-.512z"
            fill="#3B3B3B"
        />
        <path d="M343.78 604.7v.895l-.927.536v-.893l.927-.538z" fill="#3B3B3B" />
        <path
            d="m339.47 603.29 3.382 1.951v.893l-3.033-1.752 1.239 3.977-.773-.451-1.583-5.07.768.452z"
            fill="#2C2C2C"
        />
        <path
            d="m343.78 604.7-.925.538-4.154-2.4.924-.535 4.155 2.397z"
            fill="#363636"
        />
        <path
            d="m339.34 601.68 1.473-.849a.615.615 0 0 1 .619-.06l7.723 4.488c-.099-.047-.208-.066-.317-.055s-.213.051-.302.116l-1.471.848a1.917 1.917 0 0 0-.869 1.5.597.597 0 0 0 .255.56l-7.724-4.489a.601.601 0 0 1-.254-.559 1.918 1.918 0 0 1 .867-1.5z"
            fill="#344049"
        />
        <path
            d="M347.06 606.17a1.917 1.917 0 0 0-.869 1.5c0 .555.394.777.875.5l1.471-.85a1.917 1.917 0 0 0 .866-1.5c0-.552-.392-.776-.872-.5l-1.471.85z"
            fill="#19242B"
        />
        <path
            d="m357.28 590.28 1.472-.85a.608.608 0 0 1 .618-.061l7.725 4.489a.612.612 0 0 0-.622.06l-1.47.851a1.907 1.907 0 0 0-.869 1.5.617.617 0 0 0 .255.559l-7.723-4.488a.611.611 0 0 1-.254-.561 1.906 1.906 0 0 1 .868-1.499z"
            fill="#344049"
        />
        <path
            d="M365 594.77a1.91 1.91 0 0 0-.869 1.5c0 .551.394.775.873.5l1.472-.85a1.904 1.904 0 0 0 .867-1.505c0-.553-.392-.774-.873-.5l-1.47.855z"
            fill="#19242B"
        />
        <path
            d="M363.43 596.46c-.993-1.04-3.688-4.209-3.688-4.209s-2.764-4.909-1.37-5.626c1.37-.712 2.578-1.117 4.28 1.529.4.623 3.617 5.944 4.091 6.463.947 1.04-.728 4.818-.728 4.818l-2.585-2.975z"
            fill="#3A566D"
        />
        <path
            d="m367.53 621.6.876.744s4.021 1.951 4.281 2.047a.662.662 0 0 1 .446.588.483.483 0 0 1-.083.317c-.36.389-.852.631-1.381.679a14.784 14.784 0 0 1-3.69-.264c-.276-.131-1.922-.415-2.058-.516 0 0-.506-.018-.612.2-.01.166.003.333.039.495l-1.529-.592a4.098 4.098 0 0 1-.273-1.084l-.271-2.146 4.255-.468z"
            fill="#545454"
        />
        <path
            d="M373.06 625.13a2.305 2.305 0 0 1-1.435.733 9.214 9.214 0 0 1-4.163-.6 5.496 5.496 0 0 0-1.654-.325s-.525.054-.505.451c0 .081-.031.022-.018.115a.238.238 0 0 1 .012-.106c.1-.214.534.084.534.084.173-.192.046-.4 1.276-.023 1.339.534 2.768.806 4.209.8a2.707 2.707 0 0 0 1.757-.875.552.552 0 0 0 .056-.449 1.739 1.739 0 0 1-.069.195z"
            fill="#282827"
        />
        <path
            d="m365.29 625.31-1.651-.634c.044.21.099.418.165.623l1.531.594a15.767 15.767 0 0 1-.045-.583zM351.41 600.06l5.974 1.741 8.38 5.86s1.166.9 1.447 4.036c.316 3.5 1.769 10.847 1.769 10.847-.01.654-.3.862-.828 1.143-3.24 1.713-4.895.358-4.895.358-.26-.148-.238-.321-.26-.549l-2.073-11.679-6.186-3.393s-2.967-1.341-3.156-3.6c-.076-.935-.172-4.764-.172-4.764z"
            fill="#282827"
        />
        <path
            d="m364.72 624.42 2.659 2.231s1.34 1.078 1.834 1.363a.878.878 0 0 1 .281.303.877.877 0 0 1 .114.397.639.639 0 0 1-.156.483 3.194 3.194 0 0 1-1.482.71 4.795 4.795 0 0 1-3.142-.614c-.26-.166-2.025-1.3-2.153-1.408-.368-.294-.7-.409-.832-.213 0 0 .015.485.015.557l-1.478-1.017a6.954 6.954 0 0 1-.1-.875v-2.167l4.44.25z"
            fill="#282827"
        />
        <path
            d="m364.72 624.1 2.659 2.23s1.34 1.077 1.834 1.363a.89.89 0 0 1 .395.7.644.644 0 0 1-.156.483 3.184 3.184 0 0 1-1.482.71 4.808 4.808 0 0 1-3.142-.615c-.26-.168-2.025-1.3-2.153-1.4-.368-.3-.7-.412-.832-.215 0 0 .015.486.015.556l-1.478-1.016a6.804 6.804 0 0 1-.1-.877v-2.158l4.44.239z"
            fill="#545454"
        />
        <path
            d="m349.05 602.31 5.518 1.7 8.074 5.743s1.038.74 1.61 3.846c.512 2.81 1.593 9.295 1.733 11.169.048.653-.449.981-.979 1.263-3.24 1.71-4.567.224-4.567.224-.258-.148-.236-.32-.258-.552l-2.078-10.813c.006-.658-.056-.912-.634-1.229l-5.547-3.035s-2.965-1.336-3.153-3.6c-.08-.933.281-4.716.281-4.716z"
            fill="#383736"
        />
        <path
            d="M360.9 586.46c.892 1.951.622 2.545.509 4.355l-1.545 16.2a1.763 1.763 0 0 1-.685 1.5s-3.856 1.641-5.839 1.366a10.06 10.06 0 0 1-3.879-1.606c-1.2-.787-.893-2.795-.883-2.617 0 0-1.421-10.791-.972-14.156a3.028 3.028 0 0 1 1.253-1.8c.617-.472 5.23-3.371 5.23-3.371l2.949-.7s3.256-.495 3.862.829z"
            fill="#4D6B89"
        />
        <path
            d="M358.28 590.6c.608-.773.651-3.842-.553-5.012a4.926 4.926 0 0 0-.687.035l-2.949.7s-.7.406-1.542.975c.4.036 1.291 1.268 2.564 2.636 1.185 1.277 2.327 1.733 3.167.666z"
            fill="#BDCCD1"
        />
        <path
            d="M357.81 587.86c-1.708 1.391-2.455-.3-3.347-1.6l.244-4.321 3.453 1.382-.35 4.539z"
            fill="#E8C5AC"
        />
        <path
            d="M354.54 584.8s-.063.582-.051.686c.226 1.781 2.316 2.639 2.316 2.639.261.157.226.476.156.9l-.236 1.226c-.064.4-.273.346-.424.167 0 0-1.53-1.512-1.955-2.013-.994-1.177-.885-1.425-.384-2.794.307-.829.578-.811.578-.811zM357.33 588.1a.367.367 0 0 0-.146.253c-.007.05-.003.1.011.149a.354.354 0 0 0 .068.132l.574.948c.3.424.363.1.393-.226l.232-2.358c-.045-1.5-.434-1.593-.434-1.593a4.727 4.727 0 0 0-.036.651 3.125 3.125 0 0 1-.662 2.044z"
            fill="#EDEDED"
        />
        <path
            d="M360.95 608.82v.257l.593.342v-.256l-.593-.343zM360.05 608.32v.257l.594.345v-.258l-.594-.344z"
            fill="#393939"
        />
        <path
            d="m361.49 609.32-.539-.314v-.179l.539.311v.182zM360.59 608.81l-.538-.311v-.18l.541.31-.003.181z"
            fill="#1C1C1C"
        />
        <path
            d="M357.64 606.32c.549.184 1.159-.437 1.325-.937.062-.173 1.127.068 1.6-.061a.472.472 0 0 0 .208-.102.477.477 0 0 0 .092-.637 18.508 18.508 0 0 0-2.155-.155c-1.389-.093-1.61.407-1.777.907s.16.796.707.985z"
            fill="#FFE8D9"
        />
        <path
            d="M357.46 605.76c-.3.514-.417.249-.417.249-.672.446-1.392.815-2.147 1.1-1.574-.492-4.92-1.416-6.1-2.206a4.164 4.164 0 0 1-1.473-3.281s-.186-8.351.217-9.868c.675-2.538 3.66-1.408 3.885 1.353.236 2.24.249 4.498.039 6.741a1.675 1.675 0 0 0 .787 1.772l4 2.231s1.786.904 1.209 1.909z"
            fill="#688CAA"
        />
        <path
            d="m356.5 606.64.472-1.449 1.891.029.279.094 2.163.97a1.18 1.18 0 0 1 .673.624 1.193 1.193 0 0 1 .027.917c-.243.753-.026.081-.026.081a1.22 1.22 0 0 1-1.471.753l-2.974-.7c-.621-.185-1.248-.655-1.034-1.319z"
            fill="#FFE8D9"
        />
        <path
            d="M357.8 604.12c.256.108.51.9.251 1.7a3.829 3.829 0 0 1-.725 1.423c-.356.393-.639.567-.975.467 0 0-1.241-.365-1.625-.5-.247-.086-.2-.205-.2-.205.092.03.188.047.285.05.314-.042.83-.321 1.284-1.285.708-1.516-.1-2.079-.1-2.079.1-.226.225-.254.475-.135l1.33.564z"
            fill="#E4EFF4"
        />
        <path
            d="M362.77 598.11a9.608 9.608 0 0 1 .9-2.93c.655-.776 1.125-1.432 2.46-.9 1.416.57 1.084 2.366.847 2.982-.22.574-.993 2.174-.993 2.174l-3.214-1.326z"
            fill="#3A566D"
        />
        <path
            d="M363.95 600.22c-.226.532-1.1.578-1.581.371-.169-.071-.693.888-1.1 1.157a.477.477 0 0 1-.448.064.479.479 0 0 1-.303-.335c.404-.596.842-1.169 1.311-1.716.851-1.1 1.372-.935 1.856-.729s.488.655.265 1.188z"
            fill="#FFE8D9"
        />
        <path
            d="m364.94 599.58-1.4-.606-1.235 1.433-.115.272-.7 2.262s-.205.734.941 1.129a1.618 1.618 0 0 0 1.895-.755l.912-2.089c.276-.589.339-1.37-.298-1.646z"
            fill="#FFE8D9"
        />
        <path
            d="M362.69 597.6c.117-.243.9-.46 1.664-.174.502.154.965.413 1.36.76.368.36.529.646.421.967 0 0-.4 1.187-.548 1.558-.093.235-.208.18-.208.18.033-.088.053-.18.061-.274-.03-.309-.283-.821-1.208-1.3-1.449-.749-2.028.019-2.028.019-.216-.1-.239-.231-.114-.469l.6-1.267z"
            fill="#E4EFF4"
        />
        <path
            d="M355.56 579.98a.854.854 0 0 1 .942.648l.173 1.552a.472.472 0 0 1-.286.433c-.43.139-.663-.224-.907-.626a41.87 41.87 0 0 1-.353-.655c-.275-.505-.299-1.271.431-1.352z"
            fill="#FFE8D9"
        />
        <path
            d="m357.89 578.27-2.921.185.269 5.277c.062.358.064.685.143.987a1.563 1.563 0 0 0 .551 1.093s.48.24 1.12.619c.449.274.938.478 1.449.605a2.614 2.614 0 0 0 1.173-.335c.526-.254.44-.243.749-1.848 0 0 .453-2.916.6-3.8.416-2.512-.569-3.011-.569-3.011l-2.564.228z"
            fill="#EDC3A4"
        />
        <path
            d="M361.29 579.16a12.127 12.127 0 0 1-.226 1.551s.316-2.167-.76-1.748c-.022.006-.76.572-1.218.915-.255.194-.787.451-.834.39-.06-.077.148-.687-.462-.659-.758.036-1.214.977-1.232 2.055-.018.833-.023 1.516-.028 1.523-.039.1-1.113-.924-1.18-.959-.115-.064-.355.457-.355.457.019 0-.385 1.564-.474 1.39a54.748 54.748 0 0 1-1.02-2.237c-1.418-3.414 1.126-7.727 7.1-4.3.485.272.857.366.689 1.622zM360.36 585.17s-.06-.328-.117-.528c-.051-.173-.155-.332-.559-.35a5.745 5.745 0 0 0-.808.069 1.169 1.169 0 0 0-.8.479c-.34.534-.653 1.086-.935 1.652l.819.416c.21-.624.471-1.23.783-1.81.323-.178.69-.259 1.059-.233a.365.365 0 0 1 .337.312c.077.319.12.526.12.526l.101-.533z"
            fill="#49260A"
        />
        <path
            d="M355.24 583.88c-.034.497-.03.996.012 1.493.073.425.418.639 1.086 1.073.564.425 1.198.75 1.873.959a2.525 2.525 0 0 0 1.955-.763 6.07 6.07 0 0 0 .131-1.083s-.223.672-.448.688c-.08.006-.185-.211-.185-.211s-.147-.277-.355.068c-.163.268-.266.426-.339.451a2.258 2.258 0 0 1-1.751-.324 4.508 4.508 0 0 1-1.6-1.283l-.379-1.068z"
            fill="#49260A"
        />
        <path
            d="M355.06 581.25c.658-.135.866.738.866.738l.2 1.549s-.012.5-.329.557c-.37.061-.647-.174-.881-.6a39.74 39.74 0 0 1-.38-.661c-.261-.54-.25-1.423.524-1.583z"
            fill="#EDC3A4"
        />
        <path
            d="m360.7 652.46-20.842-12.112 44.35-25.374 20.9 12.112L360.7 652.46z"
            fill="#231F20"
            opacity={0.24}
            style={{ mixBlendMode: "multiply" }}
        />
        <path
            d="m387.4 597.9-.02 23.44a.699.699 0 0 1-.412.574 2.18 2.18 0 0 1-1.989 0 .701.701 0 0 1-.415-.58l.024-23.438a.702.702 0 0 0 .414.578 2.201 2.201 0 0 0 1.989 0 .712.712 0 0 0 .282-.231.716.716 0 0 0 .127-.343z"
            fill="#646D6D"
        />
        <path
            d="m387.4 597.9-.02 23.44a.699.699 0 0 1-.412.574 2.18 2.18 0 0 1-1.989 0 .701.701 0 0 1-.415-.58l.024-23.438a.702.702 0 0 0 .414.578 2.201 2.201 0 0 0 1.989 0 .712.712 0 0 0 .282-.231.716.716 0 0 0 .127-.343zM400.14 604.26l-.02 23.44a.699.699 0 0 1-.412.574 2.18 2.18 0 0 1-1.989 0 .708.708 0 0 1-.415-.58l.024-23.438a.702.702 0 0 0 .414.578 2.201 2.201 0 0 0 1.989 0 .697.697 0 0 0 .409-.574z"
            fill="#646D6D"
        />
        <path
            d="m400.14 604.26-.02 23.44a.699.699 0 0 1-.412.574 2.18 2.18 0 0 1-1.989 0 .708.708 0 0 1-.415-.58l.024-23.438a.702.702 0 0 0 .414.578 2.201 2.201 0 0 0 1.989 0 .697.697 0 0 0 .409-.574zM361.5 625.2l-.02 22a.656.656 0 0 1-.384.537c-.833.485-2.258.133-2.258-.545l.025-22c-.006.677 1.423 1.025 2.254.542a.647.647 0 0 0 .383-.536v.002zM349.44 617.76l-.023 22a.653.653 0 0 1-.381.539 2.07 2.07 0 0 1-1.867 0 .677.677 0 0 1-.39-.546l.021-22a.671.671 0 0 0 .389.546 2.073 2.073 0 0 0 1.866 0 .653.653 0 0 0 .385-.539z"
            fill="#646D6D"
        />
        <path
            d="m362.21 632.37-20.2-11.7 44.242-25.476 20.2 11.7-44.242 25.476z"
            fill="#fff"
        />
        <path
            d="m406.45 606.89-44.239 25.481-20.2-11.7v.991l20.2 11.7 44.239-25.48v-.992z"
            fill="#E0E0E0"
        />
        <path
            d="m371.7 617.16 14.95-8.611v.428a.857.857 0 0 1-.424.733l-14.1 8.124a.847.847 0 0 1-.844 0l-10.32-6.089a.63.63 0 0 1-.315-.55v-.278l11.053 6.243z"
            fill="#848484"
        />
        <path
            d="M360.89 610.57a.448.448 0 0 0-.181.626c.042.07.102.128.174.166l10.818 5.8 14.95-8.612-10.795-4.871a1.786 1.786 0 0 0-1.541.039l-13.425 6.852z"
            fill="#E2E1E0"
        />
        <path
            d="M365.85 612.85c-.135.078-.275.4.255.628l4.793 2.616c.4.245.735.022 1.1-.188l12.64-7.277a.286.286 0 0 0 0-.532l-4.618-2.913a.81.81 0 0 0-.74-.106l-13.43 7.772z"
            fill="#898686"
        />
        <path
            d="M376.52 606.79c-.064.035-.064.094 0 .128l.635.371a.24.24 0 0 0 .224 0l.643-.371c.063-.034.063-.093 0-.13l-.64-.367a.227.227 0 0 0-.222 0l-.64.369zM379.66 610.14c-.062.035-.063.091 0 .129l.64.368a.236.236 0 0 0 .221 0l.643-.372c.062-.034.064-.09 0-.125l-.641-.371a.22.22 0 0 0-.22 0l-.643.371zM378.55 610.78c-.061.037-.061.093 0 .129l.64.371a.235.235 0 0 0 .22 0l.644-.371c.064-.036.064-.092 0-.129l-.639-.374a.256.256 0 0 0-.223 0l-.642.374zM377.43 611.42c-.065.036-.065.093 0 .129l.638.37a.243.243 0 0 0 .219 0l.645-.37c.013-.005.025-.013.033-.025a.072.072 0 0 0 0-.08.075.075 0 0 0-.033-.025l-.639-.369a.236.236 0 0 0-.221 0l-.642.37zM378.74 606.85a.075.075 0 0 0-.033.025c-.008.012-.013.026-.013.04s.005.028.013.04.02.02.033.025l.639.372a.233.233 0 0 0 .22 0l1.766-1.019c.063-.032.063-.093 0-.13l-.64-.369a.251.251 0 0 0-.223 0l-1.762 1.016zM377.67 607.45c-.061.037-.061.092 0 .127l.638.37a.24.24 0 0 0 .223 0l.645-.373c.06-.034.06-.089 0-.126l-.642-.371a.237.237 0 0 0-.222 0l-.642.373zM376.46 608.14a.066.066 0 0 0-.032.025c-.008.011-.012.024-.012.038s.004.027.012.039a.07.07 0 0 0 .032.024l.643.373a.236.236 0 0 0 .221 0l.642-.373a.063.063 0 0 0 .034-.024c.008-.011.012-.025.012-.039s-.004-.028-.012-.039a.069.069 0 0 0-.034-.024l-.638-.372a.243.243 0 0 0-.225 0l-.643.372zM375.35 608.79c-.062.032-.062.093 0 .129l.637.37a.259.259 0 0 0 .224 0l.643-.373a.065.065 0 0 0 .048-.063.065.065 0 0 0-.048-.064l-.64-.373a.253.253 0 0 0-.222 0l-.642.374zM374.22 609.43c-.061.037-.061.1 0 .13l.639.369a.243.243 0 0 0 .223 0l.643-.372c.062-.032.062-.092 0-.127l-.639-.372a.251.251 0 0 0-.221 0l-.645.372zM379.82 607.49c-.062.034-.062.089 0 .125l.641.371a.237.237 0 0 0 .222 0l1.764-1.019a.061.061 0 0 0 .034-.025.066.066 0 0 0 .013-.04.067.067 0 0 0-.013-.041.072.072 0 0 0-.034-.025l-.641-.371a.264.264 0 0 0-.221 0l-1.765 1.025zM378.7 608.13a.068.068 0 0 0-.033.025c-.008.011-.013.025-.013.039s.005.028.013.039.02.02.033.024l.638.372a.242.242 0 0 0 .223 0l.643-.372a.061.061 0 0 0 .034-.025.064.064 0 0 0 .013-.04.062.062 0 0 0-.013-.04.068.068 0 0 0-.034-.026l-.641-.37a.261.261 0 0 0-.221 0l-.642.374zM377.54 608.82a.078.078 0 0 0-.034.026.068.068 0 0 0 .034.105l.641.37a.242.242 0 0 0 .222 0l.643-.37a.07.07 0 0 0 .046-.065.073.073 0 0 0-.046-.066l-.639-.371a.26.26 0 0 0-.221 0l-.646.371zM376.42 609.46c-.062.036-.066.094 0 .129l.64.371a.255.255 0 0 0 .222 0l.644-.373a.065.065 0 0 0 .034-.025.068.068 0 0 0 .013-.039.07.07 0 0 0-.013-.04.07.07 0 0 0-.034-.025l-.642-.371a.248.248 0 0 0-.222 0l-.642.373zM376.3 612.07c-.063.037-.063.1 0 .13l.642.37a.237.237 0 0 0 .222 0l.641-.37c.063-.033.063-.093 0-.13l-.639-.373a.255.255 0 0 0-.223 0l-.643.373zM373.1 610.09a.067.067 0 0 0-.045.064c0 .014.004.027.012.039a.07.07 0 0 0 .033.024l.638.373a.255.255 0 0 0 .223 0l.643-.373c.061-.035.063-.093 0-.131l-.637-.371a.248.248 0 0 0-.222 0l-.645.375zM375.3 610.11c-.062.036-.062.093 0 .128l.64.372a.255.255 0 0 0 .222 0l.646-.372a.064.064 0 0 0 .032-.024c.008-.012.013-.026.013-.04a.07.07 0 0 0-.045-.064l-.641-.373a.261.261 0 0 0-.222 0l-.645.373zM374.17 610.76c-.063.04-.063.1 0 .13l.638.371a.243.243 0 0 0 .223 0l.644-.371c.062-.032.062-.09 0-.13l-.639-.369a.25.25 0 0 0-.111-.027.256.256 0 0 0-.111.027l-.644.369zM378.62 609.48c-.062.037-.063.094 0 .128l.641.372a.247.247 0 0 0 .219 0l.644-.372c.06-.034.061-.091 0-.128l-.639-.371a.243.243 0 0 0-.219 0l-.646.371zM377.5 610.13a.072.072 0 0 0-.032.025.069.069 0 0 0 0 .078c.008.011.019.02.032.024l.643.373a.25.25 0 0 0 .22 0l.643-.373c.059-.037.059-.093 0-.127l-.64-.372a.247.247 0 0 0-.22 0l-.646.372zM376.37 610.77c-.062.037-.062.093 0 .128l.64.373a.242.242 0 0 0 .222 0l.644-.371a.064.064 0 0 0 .032-.024c.008-.012.013-.026.013-.04a.07.07 0 0 0-.045-.064l-.638-.371a.261.261 0 0 0-.222 0l-.646.369zM375.25 611.42a.068.068 0 0 0-.047.065c0 .014.005.028.013.039.008.012.02.021.034.025l.64.37a.244.244 0 0 0 .22 0l.643-.37c.064-.036.064-.093 0-.129l-.639-.37a.237.237 0 0 0-.223 0l-.641.37zM375.18 612.72c-.062.033-.062.091 0 .128l.64.37a.236.236 0 0 0 .221 0l.644-.37c.061-.037.061-.1 0-.128l-.642-.373a.236.236 0 0 0-.221 0l-.642.373zM371.82 610.82c-.06.038-.06.1 0 .128l.642.372a.247.247 0 0 0 .221 0l.642-.372c.063-.037.063-.093 0-.129l-.642-.371a.23.23 0 0 0-.219 0l-.644.372zM373.05 611.41c-.063.038-.063.094 0 .127l.641.373a.227.227 0 0 0 .222 0l.643-.371c.059-.035.059-.091 0-.129l-.64-.372a.25.25 0 0 0-.111-.027.256.256 0 0 0-.111.027l-.644.372zM374.13 612.07c-.06.037-.064.1 0 .13l.637.37a.237.237 0 0 0 .222 0l.645-.37c.013-.005.025-.013.033-.025a.072.072 0 0 0 0-.08.075.075 0 0 0-.033-.025l-.639-.373a.256.256 0 0 0-.223 0l-.642.373zM382.99 608.18c-.061.036-.061.09 0 .128l.641.371c.034.017.071.025.109.025s.075-.008.109-.025l.645-.371c.062-.038.062-.092 0-.128l-.64-.371a.247.247 0 0 0-.221 0l-.643.371zM381.92 608.8c-.065.034-.065.092 0 .131l.637.369a.237.237 0 0 0 .223 0l.643-.369c.06-.039.06-.1 0-.131l-.639-.37a.23.23 0 0 0-.223 0l-.641.37zM380.79 609.44c-.059.037-.059.091 0 .127l.64.372a.255.255 0 0 0 .222 0l.642-.372c.065-.036.065-.09 0-.129l-.637-.37a.241.241 0 0 0-.224 0l-.643.372zM370.74 610.18a.071.071 0 0 0-.035.024c-.008.012-.013.026-.013.04s.005.028.013.04c.009.011.021.02.035.024l.639.37a.237.237 0 0 0 .222 0l5.13-2.964c.061-.035.061-.091 0-.129l-.637-.369a.237.237 0 0 0-.222 0l-5.132 2.964zM369.6 610.85c-.063.036-.063.093 0 .13l.638.37a.243.243 0 0 0 .223 0l.642-.371c.063-.036.063-.093 0-.129l-.64-.37c-.034-.018-.072-.027-.111-.027s-.077.009-.111.027l-.641.37zM368.46 611.52a.066.066 0 0 0-.033.026c-.008.011-.012.025-.012.039a.067.067 0 0 0 .045.064l.639.373a.253.253 0 0 0 .222 0l.641-.373c.062-.038.062-.093 0-.129l-.64-.372a.242.242 0 0 0-.222 0l-.64.372zM370.72 611.49c-.061.033-.065.09 0 .127l.64.371a.23.23 0 0 0 .112.028.229.229 0 0 0 .111-.028l.641-.371c.062-.037.066-.094 0-.127l-.637-.371a.256.256 0 0 0-.225 0l-.642.371zM381.96 607.47c-.064.035-.064.092 0 .129l.638.37a.247.247 0 0 0 .22 0l.643-.37c.064-.038.064-.094 0-.131l-.639-.372a.268.268 0 0 0-.111-.025.27.27 0 0 0-.112.025l-.639.374zM380.84 608.11c-.064.042-.064.1 0 .131l.637.372a.227.227 0 0 0 .221 0l.647-.372c.06-.036.06-.089 0-.131l-.639-.37a.27.27 0 0 0-.224 0l-.642.37zM379.71 608.76a.07.07 0 0 0-.046.065c0 .014.004.028.013.04.008.012.019.02.033.025l.639.371a.247.247 0 0 0 .221 0l.646-.371a.068.068 0 0 0 .032-.026.069.069 0 0 0 0-.078.068.068 0 0 0-.032-.026l-.64-.372a.25.25 0 0 0-.111-.025.246.246 0 0 0-.11.025l-.645.372zM371.91 612.14a.068.068 0 0 0-.032.026c-.008.011-.012.025-.012.039s.004.028.012.039a.068.068 0 0 0 .032.026l.64.37a.227.227 0 0 0 .222 0l.643-.37a.07.07 0 0 0 .034-.025.072.072 0 0 0 0-.08.078.078 0 0 0-.034-.025l-.637-.372a.264.264 0 0 0-.222 0l-.646.372zM370.65 612.78c-.062.036-.062.091 0 .128l.641.372a.243.243 0 0 0 .219 0l.645-.372c.063-.037.063-.094 0-.128l-.642-.373a.248.248 0 0 0-.221 0l-.642.373zM368.48 614.06a.072.072 0 0 0-.032.025c-.008.012-.013.026-.013.04a.07.07 0 0 0 .045.064l.64.371c.034.018.072.027.111.027s.077-.009.111-.027l1.761-1.021c.067-.034.067-.092 0-.128l-.637-.371a.227.227 0 0 0-.222 0l-1.764 1.02zM373.01 612.72c-.062.033-.062.091 0 .128l.637.37a.243.243 0 0 0 .223 0l.643-.37c.062-.037.062-.1 0-.128l-.641-.373a.233.233 0 0 0-.221 0l-.641.373zM371.86 613.41c-.062.036-.062.094 0 .128l.638.372a.247.247 0 0 0 .221 0l.643-.372c.062-.034.064-.094 0-.128l-.636-.371a.227.227 0 0 0-.222 0l-.644.371zM369.64 614.66a.075.075 0 0 0-.033.025.069.069 0 0 0 0 .078c.008.012.02.021.033.025l.637.371a.243.243 0 0 0 .224 0l1.764-1.019a.066.066 0 0 0 .033-.024c.009-.012.013-.026.013-.04s-.004-.028-.013-.04a.075.075 0 0 0-.033-.025l-.639-.371a.251.251 0 0 0-.221 0l-1.765 1.02zM374.06 613.33a.067.067 0 0 0-.045.064.067.067 0 0 0 .045.064l.64.368a.237.237 0 0 0 .222 0l.642-.372c.062-.033.062-.09 0-.124l-.637-.374a.247.247 0 0 0-.225 0l-.642.374zM370.7 615.28c-.064.035-.064.092 0 .127l.637.372a.242.242 0 0 0 .222 0l1.767-1.02c.063-.035.063-.093 0-.129l-.641-.372a.257.257 0 0 0-.22 0l-1.765 1.022zM367.35 612.17c-.063.037-.063.1 0 .13l.638.37c.034.018.072.027.111.027s.077-.009.111-.027l.644-.372c.061-.033.061-.091 0-.128l-.639-.372a.248.248 0 0 0-.222 0l-.643.372zM366.2 612.81c-.063.038-.063.092 0 .128l.638.373a.248.248 0 0 0 .223 0l.642-.373c.061-.036.061-.09 0-.128l-.639-.371a.24.24 0 0 0-.221 0l-.643.371z"
            fill="#4A4A4A"
        />
        <path
            d="m368.2 612.67.644-.372a.057.057 0 0 0 .031-.024.065.065 0 0 0 .013-.038v.126a.067.067 0 0 1-.012.039.066.066 0 0 1-.032.025l-.643.371-.001-.127z"
            fill="#636363"
        />
        <path
            d="M367.3 612.23a.086.086 0 0 0 .048.064l.638.37c.034.018.072.027.111.027s.077-.009.111-.027v.127a.23.23 0 0 1-.112.028.229.229 0 0 1-.111-.028l-.636-.371a.068.068 0 0 1-.033-.025.067.067 0 0 1-.015-.039l-.001-.126z"
            fill="#3D3D3D"
        />
        <path
            d="m367.06 613.3.643-.373c.012-.006.023-.015.031-.026s.013-.025.014-.039v.129c-.002.014-.007.028-.015.039s-.02.02-.032.026l-.643.371.002-.127z"
            fill="#636363"
        />
        <path
            d="M366.15 612.87a.086.086 0 0 0 .016.038.08.08 0 0 0 .031.027l.638.371a.243.243 0 0 0 .224 0v.127a.235.235 0 0 1-.22 0l-.642-.371a.086.086 0 0 1-.047-.065v-.127z"
            fill="#3D3D3D"
        />
        <path
            d="m377.38 607.29.643-.371a.07.07 0 0 0 .032-.024.07.07 0 0 0 .015-.039v.128a.082.082 0 0 1-.047.064l-.643.371v-.129z"
            fill="#636363"
        />
        <path
            d="M376.47 606.85c0 .015.006.028.014.04a.07.07 0 0 0 .035.023l.635.371a.24.24 0 0 0 .224 0v.129a.243.243 0 0 1-.224 0l-.635-.369a.072.072 0 0 1-.034-.025.073.073 0 0 1-.015-.039v-.13z"
            fill="#3D3D3D"
        />
        <path
            d="m380.53 610.63.643-.373a.072.072 0 0 0 .032-.025.07.07 0 0 0 .015-.039v.131c0 .021-.016.042-.047.06l-.643.373v-.127z"
            fill="#636363"
        />
        <path
            d="M379.63 610.19a.073.073 0 0 0 .045.062l.64.373a.25.25 0 0 0 .11.025.25.25 0 0 0 .111-.025v.127a.248.248 0 0 1-.221 0l-.64-.373c-.031-.018-.045-.037-.045-.06v-.129z"
            fill="#3D3D3D"
        />
        <path
            d="m379.41 611.28.643-.373a.076.076 0 0 0 .044-.065v.127a.098.098 0 0 1-.044.077l-.643.37v-.136z"
            fill="#636363"
        />
        <path
            d="M378.5 610.83a.079.079 0 0 0 .013.039c.008.011.019.02.032.026l.64.373a.255.255 0 0 0 .223 0v.127a.237.237 0 0 1-.223 0l-.64-.371a.077.077 0 0 1-.031-.028.084.084 0 0 1-.014-.04v-.126z"
            fill="#3D3D3D"
        />
        <path
            d="m378.29 611.92.645-.37a.076.076 0 0 0 .03-.026.08.08 0 0 0 .015-.037v.125a.068.068 0 0 1-.013.039.068.068 0 0 1-.032.026l-.645.372v-.129z"
            fill="#636363"
        />
        <path
            d="M377.38 611.49c0 .022.013.044.047.063l.638.37a.231.231 0 0 0 .219 0v.129c-.034.018-.072.026-.11.026s-.075-.008-.109-.026l-.638-.372a.066.066 0 0 1-.033-.024.069.069 0 0 1-.014-.039v-.127z"
            fill="#3D3D3D"
        />
        <path
            d="m379.6 607.35 1.766-1.019a.078.078 0 0 0 .033-.024.08.08 0 0 0 .014-.039v.127a.066.066 0 0 1-.014.038.064.064 0 0 1-.032.024l-1.767 1.023v-.13z"
            fill="#636363"
        />
        <path
            d="M378.69 606.92a.078.078 0 0 0 .015.039.07.07 0 0 0 .031.026l.639.372a.225.225 0 0 0 .11.028.22.22 0 0 0 .11-.028v.13a.217.217 0 0 1-.218 0l-.641-.371a.07.07 0 0 1-.031-.026.084.084 0 0 1-.015-.038v-.132z"
            fill="#3D3D3D"
        />
        <path
            d="m378.53 607.95.645-.373a.072.072 0 0 0 .044-.063v.127c0 .024-.019.045-.046.066l-.645.37.002-.127z"
            fill="#636363"
        />
        <path
            d="M377.62 607.51c.002.014.007.027.015.038s.019.02.032.025l.638.37a.243.243 0 0 0 .223 0v.127a.24.24 0 0 1-.223 0l-.638-.37a.082.082 0 0 1-.047-.064v-.126z"
            fill="#3D3D3D"
        />
        <path
            d="m377.33 608.64.642-.373a.07.07 0 0 0 .033-.026.068.068 0 0 0 .013-.039v.128a.084.084 0 0 1-.014.04.084.084 0 0 1-.032.027l-.642.372v-.129z"
            fill="#636363"
        />
        <path
            d="M376.42 608.21c.001.014.005.027.013.038s.018.019.031.024l.643.373a.235.235 0 0 0 .221 0v.129a.236.236 0 0 1-.221 0l-.643-.372a.083.083 0 0 1-.029-.027.08.08 0 0 1-.012-.037l-.003-.128z"
            fill="#3D3D3D"
        />
        <path
            d="m376.2 609.29.643-.373a.076.076 0 0 0 .03-.026.082.082 0 0 0 .016-.037v.128a.077.077 0 0 1-.014.038.068.068 0 0 1-.032.026l-.642.371-.001-.127z"
            fill="#636363"
        />
        <path
            d="M375.3 608.85a.076.076 0 0 0 .013.039.084.084 0 0 0 .031.028l.637.369a.256.256 0 0 0 .224 0v.127a.26.26 0 0 1-.225 0l-.637-.369a.074.074 0 0 1-.031-.027.073.073 0 0 1-.013-.039l.001-.128z"
            fill="#3D3D3D"
        />
        <path
            d="m375.08 609.93.643-.372a.067.067 0 0 0 .045-.064v.136a.073.073 0 0 1-.014.038.064.064 0 0 1-.031.025l-.643.373v-.136z"
            fill="#636363"
        />
        <path
            d="M374.17 609.5a.08.08 0 0 0 .014.039c.008.011.019.02.031.026l.639.369a.24.24 0 0 0 .223 0v.13a.255.255 0 0 1-.223 0l-.639-.373c-.012-.006-.022-.015-.03-.026s-.013-.023-.014-.037l-.001-.128z"
            fill="#3D3D3D"
        />
        <path
            d="m380.68 607.98 1.764-1.019c.013-.005.024-.014.032-.025s.013-.025.014-.039v.129c0 .023-.013.045-.046.064l-1.764 1.019v-.129z"
            fill="#636363"
        />
        <path
            d="M379.78 607.55a.073.073 0 0 0 .045.062l.641.371a.232.232 0 0 0 .222 0v.129a.242.242 0 0 1-.222 0l-.641-.372a.069.069 0 0 1-.029-.027.072.072 0 0 1-.013-.038l-.003-.125z"
            fill="#3D3D3D"
        />
        <path
            d="m379.56 608.63.643-.372c.031-.021.046-.042.046-.065v.129c-.002.014-.007.027-.015.038s-.019.02-.031.025l-.643.372v-.127z"
            fill="#636363"
        />
        <path
            d="M378.65 608.2a.095.095 0 0 0 .016.037c.009.011.019.02.031.026l.638.372a.243.243 0 0 0 .223 0v.127a.23.23 0 0 1-.221 0l-.64-.372c-.029-.017-.047-.038-.045-.061l-.002-.129z"
            fill="#3D3D3D"
        />
        <path
            d="m378.4 609.32.643-.37a.095.095 0 0 0 .032-.028.09.09 0 0 0 .016-.039v.128a.078.078 0 0 1-.015.039.075.075 0 0 1-.033.026l-.643.374v-.13z"
            fill="#636363"
        />
        <path
            d="M377.49 608.88a.097.097 0 0 0 .015.04.09.09 0 0 0 .031.027l.641.37a.242.242 0 0 0 .222 0v.13a.242.242 0 0 1-.222 0l-.641-.372c-.012-.005-.022-.014-.03-.025s-.013-.023-.014-.037l-.002-.133z"
            fill="#3D3D3D"
        />
        <path
            d="m377.28 609.96.644-.373c.029-.018.047-.041.044-.063v.128c0 .025-.018.044-.047.064l-.644.37.003-.126z"
            fill="#636363"
        />
        <path
            d="M376.37 609.53c0 .022.016.043.047.061l.64.371a.255.255 0 0 0 .222 0v.126c-.034.018-.072.027-.111.027s-.077-.009-.111-.027l-.64-.37c-.031-.02-.047-.039-.047-.064v-.124z"
            fill="#3D3D3D"
        />
        <path
            d="m377.17 612.57.641-.37a.082.082 0 0 0 .032-.026.082.082 0 0 0 .013-.04v.129a.081.081 0 0 1-.012.038.07.07 0 0 1-.031.026l-.643.372v-.129z"
            fill="#636363"
        />
        <path
            d="M376.26 612.13c0 .014.005.026.012.037.008.011.019.02.031.025l.642.37a.226.226 0 0 0 .111.028.229.229 0 0 0 .111-.028v.129a.242.242 0 0 1-.222 0l-.639-.372a.062.062 0 0 1-.033-.024.066.066 0 0 1-.013-.04v-.125z"
            fill="#3D3D3D"
        />
        <path
            d="m373.96 610.59.643-.373a.068.068 0 0 0 .032-.026.078.078 0 0 0 .015-.039v.128a.08.08 0 0 1-.014.04.083.083 0 0 1-.033.026l-.643.37v-.126z"
            fill="#636363"
        />
        <path
            d="M373.05 610.15a.077.077 0 0 0 .046.065l.638.373a.255.255 0 0 0 .223 0v.126a.243.243 0 0 1-.223 0l-.638-.37a.077.077 0 0 1-.046-.065v-.129z"
            fill="#3D3D3D"
        />
        <path
            d="m376.16 610.61.646-.372c.012-.006.022-.016.03-.027s.013-.024.014-.038v.128a.073.073 0 0 1-.014.038.071.071 0 0 1-.03.027l-.643.371-.003-.127z"
            fill="#636363"
        />
        <path
            d="M375.25 610.18c.002.014.007.027.015.038s.019.019.031.025l.64.372a.251.251 0 0 0 .221 0v.127a.23.23 0 0 1-.224 0l-.637-.369a.068.068 0 0 1-.032-.026.07.07 0 0 1-.015-.039l.001-.128z"
            fill="#3D3D3D"
        />
        <path
            d="m375.03 611.26.644-.371c.014-.005.025-.014.033-.026s.012-.026.012-.041v.131c0 .014-.005.027-.013.038s-.019.02-.032.024l-.644.375v-.13z"
            fill="#636363"
        />
        <path
            d="M374.13 610.82a.072.072 0 0 0 .013.038.065.065 0 0 0 .031.026l.638.371a.24.24 0 0 0 .223 0v.13a.255.255 0 0 1-.222 0l-.639-.375c-.013-.005-.023-.013-.031-.024s-.013-.024-.013-.038v-.128z"
            fill="#3D3D3D"
        />
        <path
            d="m379.48 609.98.644-.372a.084.084 0 0 0 .045-.064v.128c0 .024-.012.045-.045.066l-.644.371v-.129z"
            fill="#636363"
        />
        <path
            d="M378.57 609.54a.079.079 0 0 0 .013.039.07.07 0 0 0 .031.025l.641.372c.034.017.072.025.11.025s.075-.008.109-.025v.129a.243.243 0 0 1-.219 0l-.641-.371a.097.097 0 0 1-.03-.027.092.092 0 0 1-.014-.039v-.128z"
            fill="#3D3D3D"
        />
        <path
            d="m378.36 610.63.643-.373a.075.075 0 0 0 .031-.025.093.093 0 0 0 .015-.039v.128c0 .024-.016.045-.047.063l-.643.373.001-.127z"
            fill="#636363"
        />
        <path
            d="M377.45 610.19a.09.09 0 0 0 .016.036.09.09 0 0 0 .029.026l.643.373a.25.25 0 0 0 .22 0v.127a.247.247 0 0 1-.22 0l-.641-.373c-.028-.018-.045-.037-.045-.06l-.002-.129z"
            fill="#3D3D3D"
        />
        <path
            d="m377.23 611.27.644-.371a.075.075 0 0 0 .047-.065v.127c-.001.015-.006.029-.014.041s-.019.021-.033.027l-.644.37v-.129z"
            fill="#636363"
        />
        <path
            d="M376.32 610.84a.08.08 0 0 0 .046.062l.64.373a.242.242 0 0 0 .222 0v.129a.227.227 0 0 1-.222 0l-.64-.37c-.012-.006-.023-.016-.031-.028s-.013-.025-.015-.04v-.126z"
            fill="#3D3D3D"
        />
        <path
            d="m376.11 611.92.643-.37c.034-.019.05-.041.05-.063v.125a.077.077 0 0 1-.047.065l-.642.372-.004-.129z"
            fill="#636363"
        />
        <path
            d="M375.2 611.49c.003.014.008.026.016.037s.018.02.03.026l.64.37c.034.018.072.026.11.026s.076-.008.11-.026v.129a.243.243 0 0 1-.224 0l-.638-.369a.097.097 0 0 1-.048-.066l.004-.127z"
            fill="#3D3D3D"
        />
        <path
            d="m376.05 613.22.644-.37a.08.08 0 0 0 .031-.027.088.088 0 0 0 .015-.039v.127a.077.077 0 0 1-.014.039.068.068 0 0 1-.032.026l-.644.371v-.127z"
            fill="#636363"
        />
        <path
            d="M375.14 612.78a.079.079 0 0 0 .044.066l.64.37a.235.235 0 0 0 .221 0v.127a.236.236 0 0 1-.221 0l-.64-.371a.068.068 0 0 1-.032-.026.075.075 0 0 1-.012-.039v-.127z"
            fill="#3D3D3D"
        />
        <path
            d="m372.84 611.23.642-.374a.081.081 0 0 0 .031-.024.073.073 0 0 0 .014-.038v.126a.086.086 0 0 1-.047.065l-.642.373.002-.128z"
            fill="#636363"
        />
        <path
            d="M371.77 610.88a.083.083 0 0 0 .014.038.07.07 0 0 0 .031.026l.642.372a.242.242 0 0 0 .221 0v.128a.247.247 0 0 1-.221 0l-.642-.371a.086.086 0 0 1-.031-.026.107.107 0 0 1-.014-.039v-.128z"
            fill="#3D3D3D"
        />
        <path
            d="m373.91 611.91.643-.371a.079.079 0 0 0 .044-.066v.13a.079.079 0 0 1-.013.039.079.079 0 0 1-.031.026l-.643.371v-.129z"
            fill="#636363"
        />
        <path
            d="M373.01 611.47c0 .014.004.027.012.038a.065.065 0 0 0 .031.026l.641.373a.227.227 0 0 0 .222 0v.129a.237.237 0 0 1-.222 0l-.641-.371a.083.083 0 0 1-.03-.026.086.086 0 0 1-.013-.038v-.131z"
            fill="#3D3D3D"
        />
        <path
            d="m374.99 612.57.645-.37a.076.076 0 0 0 .045-.066v.129a.076.076 0 0 1-.016.038.082.082 0 0 1-.032.026l-.641.372-.001-.129z"
            fill="#636363"
        />
        <path
            d="M374.08 612.13c.001.014.006.027.014.038s.019.019.032.024l.637.37c.034.019.072.028.111.028s.077-.009.111-.028v.129a.247.247 0 0 1-.226 0l-.637-.372a.073.073 0 0 1-.033-.025.076.076 0 0 1-.013-.039l.004-.125z"
            fill="#3D3D3D"
        />
        <path
            d="m383.85 608.68.645-.371c.031-.02.05-.043.05-.066v.13a.1.1 0 0 1-.016.038.09.09 0 0 1-.032.027l-.647.369v-.127z"
            fill="#636363"
        />
        <path
            d="M382.95 608.23c0 .023.02.044.047.063l.641.369c.034.019.071.028.109.028s.076-.009.109-.028v.129a.23.23 0 0 1-.218 0l-.64-.371a.1.1 0 0 1-.032-.026.086.086 0 0 1-.016-.038v-.126z"
            fill="#3D3D3D"
        />
        <path
            d="m382.78 609.3.643-.369c.031-.022.046-.042.046-.068v.129a.082.082 0 0 1-.046.065l-.645.369.002-.126z"
            fill="#636363"
        />
        <path
            d="M381.87 608.86c0 .025.015.046.047.066l.637.369a.23.23 0 0 0 .112.028.229.229 0 0 0 .111-.028v.126a.229.229 0 0 1-.111.028.23.23 0 0 1-.112-.028l-.637-.369c-.013-.005-.024-.014-.032-.025s-.013-.024-.015-.038v-.129z"
            fill="#3D3D3D"
        />
        <path
            d="m381.66 609.94.642-.372c.032-.018.049-.038.049-.066v.128a.081.081 0 0 1-.015.04.078.078 0 0 1-.034.025l-.642.373v-.128z"
            fill="#636363"
        />
        <path
            d="M380.75 609.51a.081.081 0 0 0 .012.038.07.07 0 0 0 .031.026l.64.372a.251.251 0 0 0 .222 0v.129a.255.255 0 0 1-.222 0l-.64-.373a.072.072 0 0 1-.03-.025.078.078 0 0 1-.013-.037v-.13z"
            fill="#3D3D3D"
        />
        <path
            d="m371.6 610.68 5.152-2.989a.1.1 0 0 0 .032-.026.092.092 0 0 0 .015-.04v.129c0 .022-.016.046-.069.091l-5.13 2.964v-.129zM370.46 611.35l.642-.371c.012-.006.023-.015.031-.026s.013-.024.014-.038v.127a.079.079 0 0 1-.045.065l-.642.37v-.127z"
            fill="#636363"
        />
        <path
            d="M369.55 610.91a.083.083 0 0 0 .048.065l.638.37a.24.24 0 0 0 .223 0v.127a.243.243 0 0 1-.223 0l-.638-.37c-.013-.006-.024-.015-.032-.026s-.013-.024-.014-.038l-.002-.128zM370.7 610.25a.077.077 0 0 0 .014.039c.008.012.019.02.032.025l.639.374a.253.253 0 0 0 .222 0v.124a.226.226 0 0 1-.111.028.229.229 0 0 1-.111-.028l-.639-.37a.07.07 0 0 1-.033-.024.08.08 0 0 1-.013-.04v-.128z"
            fill="#3D3D3D"
        />
        <path
            d="m369.32 612.02.641-.373c.035-.019.05-.041.05-.067v.129a.08.08 0 0 1-.014.04.074.074 0 0 1-.032.026l-.645.372v-.127z"
            fill="#636363"
        />
        <path
            d="M368.42 611.59a.076.076 0 0 0 .043.064l.639.373a.253.253 0 0 0 .222 0v.127a.255.255 0 0 1-.222 0l-.639-.372a.078.078 0 0 1-.043-.063v-.129z"
            fill="#3D3D3D"
        />
        <path
            d="M377.62 606.14c-.062.032-.062.092 0 .128l.638.371a.233.233 0 0 0 .22 0l1.771-1.02c.06-.036.061-.091 0-.13l-.641-.371a.25.25 0 0 0-.111-.025.246.246 0 0 0-.11.025l-1.767 1.022z"
            fill="#4A4A4A"
        />
        <path
            d="m378.48 606.64 1.771-1.02a.09.09 0 0 0 .046-.062v.125c-.002.014-.008.027-.016.038s-.018.02-.03.026l-1.766 1.023-.005-.13z"
            fill="#636363"
        />
        <path
            d="M377.57 606.21a.08.08 0 0 0 .016.039c.008.011.019.02.032.026l.638.371a.23.23 0 0 0 .22 0v.13a.255.255 0 0 1-.223 0l-.638-.375a.075.075 0 0 1-.033-.026.078.078 0 0 1-.015-.039l.003-.126z"
            fill="#3D3D3D"
        />
        <path
            d="m371.58 611.99.641-.371a.093.093 0 0 0 .033-.026.084.084 0 0 0 .014-.04v.128a.084.084 0 0 1-.014.04.093.093 0 0 1-.033.026l-.641.372v-.129z"
            fill="#636363"
        />
        <path
            d="M370.67 611.56a.077.077 0 0 0 .015.036.084.084 0 0 0 .031.025l.64.371a.24.24 0 0 0 .223 0v.129a.243.243 0 0 1-.223 0l-.64-.372c-.012-.006-.022-.015-.03-.026s-.013-.024-.014-.037l-.002-.126z"
            fill="#3D3D3D"
        />
        <path
            d="m382.82 607.97.643-.37c.034-.019.048-.04.048-.066v.128a.08.08 0 0 1-.014.04.078.078 0 0 1-.034.025l-.643.369v-.126z"
            fill="#636363"
        />
        <path
            d="M381.91 607.53c.001.015.006.028.014.04s.02.021.033.026l.638.37a.247.247 0 0 0 .22 0v.126a.247.247 0 0 1-.22 0l-.638-.369c-.033-.019-.047-.041-.047-.063v-.13z"
            fill="#3D3D3D"
        />
        <path
            d="m381.7 608.62.647-.372a.073.073 0 0 0 .03-.025.073.073 0 0 0 .014-.037v.126a.073.073 0 0 1-.014.038.08.08 0 0 1-.03.028l-.647.369v-.127z"
            fill="#636363"
        />
        <path
            d="M380.79 608.18c0 .022.015.044.048.062l.637.372a.227.227 0 0 0 .221 0v.127a.235.235 0 0 1-.221 0l-.637-.369c-.031-.02-.048-.042-.048-.064v-.128z"
            fill="#3D3D3D"
        />
        <path
            d="m380.57 609.26.646-.371a.076.076 0 0 0 .032-.027.077.077 0 0 0 .014-.039v.13a.073.073 0 0 1-.014.038.077.077 0 0 1-.032.024l-.646.374v-.129z"
            fill="#636363"
        />
        <path
            d="M379.67 608.83a.073.073 0 0 0 .014.038c.007.011.018.02.03.026l.639.371a.247.247 0 0 0 .221 0v.129a.248.248 0 0 1-.221 0l-.639-.374a.072.072 0 0 1-.03-.025.08.08 0 0 1-.012-.037l-.002-.128z"
            fill="#3D3D3D"
        />
        <path
            d="m372.79 612.56.64-.371a.075.075 0 0 0 .033-.025.073.073 0 0 0 .013-.04v.126a.073.073 0 0 1-.046.066l-.64.374v-.13z"
            fill="#636363"
        />
        <path
            d="M371.86 612.2a.072.072 0 0 0 .013.038c.007.011.018.02.03.025l.64.37a.227.227 0 0 0 .222 0v.13a.248.248 0 0 1-.222 0l-.64-.369c-.03-.023-.043-.041-.043-.069v-.125z"
            fill="#3D3D3D"
        />
        <path
            d="m371.51 613.28.645-.372a.075.075 0 0 0 .031-.025.084.084 0 0 0 .017-.037v.126c-.002.014-.008.026-.016.037s-.018.02-.03.026l-.647.37v-.125z"
            fill="#636363"
        />
        <path
            d="M370.61 612.84c.002.014.006.026.014.037s.018.02.03.025l.641.372a.247.247 0 0 0 .219 0v.125a.23.23 0 0 1-.219 0l-.639-.368a.077.077 0 0 1-.031-.026.078.078 0 0 1-.015-.039v-.126z"
            fill="#3D3D3D"
        />
        <path
            d="m369.35 614.56 1.761-1.021c.013-.005.025-.013.034-.024s.014-.025.016-.039v.127a.073.073 0 0 1-.046.063l-1.765 1.022v-.128z"
            fill="#636363"
        />
        <path
            d="M368.44 614.12a.083.083 0 0 0 .014.038.078.078 0 0 0 .029.028l.64.371a.242.242 0 0 0 .222 0v.128a.242.242 0 0 1-.222 0l-.64-.374a.078.078 0 0 1-.043-.062v-.129z"
            fill="#3D3D3D"
        />
        <path
            d="m373.87 613.22.643-.37a.076.076 0 0 0 .032-.027.077.077 0 0 0 .014-.039v.127a.077.077 0 0 1-.014.039.068.068 0 0 1-.032.026l-.643.371v-.127z"
            fill="#636363"
        />
        <path
            d="M372.96 612.78a.076.076 0 0 0 .015.04c.008.011.019.02.032.026l.637.37a.24.24 0 0 0 .223 0v.127a.24.24 0 0 1-.223 0l-.637-.371a.072.072 0 0 1-.032-.025.067.067 0 0 1-.015-.038v-.129z"
            fill="#3D3D3D"
        />
        <path
            d="m372.75 613.87.642-.372a.082.082 0 0 0 .032-.026.084.084 0 0 0 .014-.04v.128a.078.078 0 0 1-.012.039.079.079 0 0 1-.031.026l-.645.37v-.125z"
            fill="#636363"
        />
        <path
            d="M371.82 613.47a.076.076 0 0 0 .016.038c.008.011.02.019.032.024l.638.372a.247.247 0 0 0 .221 0v.128a.247.247 0 0 1-.221 0l-.638-.373a.073.073 0 0 1-.032-.023.082.082 0 0 1-.016-.037v-.129z"
            fill="#3D3D3D"
        />
        <path
            d="m370.5 615.16 1.764-1.019a.093.093 0 0 0 .033-.026.085.085 0 0 0 .015-.04v.127a.07.07 0 0 1-.015.039.075.075 0 0 1-.033.025l-1.762 1.021-.002-.127z"
            fill="#636363"
        />
        <path
            d="M369.59 614.73a.086.086 0 0 0 .016.038c.009.011.019.02.032.025l.637.371a.243.243 0 0 0 .224 0v.127a.247.247 0 0 1-.226 0l-.637-.371c-.013-.005-.024-.014-.032-.025s-.012-.025-.013-.039l-.001-.126z"
            fill="#3D3D3D"
        />
        <path
            d="m374.92 613.83.642-.372a.064.064 0 0 0 .032-.024.076.076 0 0 0 .015-.037v.128a.086.086 0 0 1-.047.064l-.643.371.001-.13z"
            fill="#636363"
        />
        <path
            d="M374.02 613.4c0 .025.015.045.046.064l.64.368a.232.232 0 0 0 .222 0v.13a.255.255 0 0 1-.222 0l-.64-.371a.07.07 0 0 1-.031-.025.061.061 0 0 1-.015-.037v-.129z"
            fill="#3D3D3D"
        />
        <path
            d="m373.8 614.48.641-.371c.013-.005.024-.014.032-.025s.013-.025.014-.039v.125c-.001.015-.005.028-.013.04s-.02.02-.033.025l-.641.373v-.128z"
            fill="#636363"
        />
        <path
            d="M372.89 614.05a.079.079 0 0 0 .045.064l.639.371a.247.247 0 0 0 .225 0v.128a.247.247 0 0 1-.225 0l-.639-.373a.072.072 0 0 1-.044-.063l-.001-.127z"
            fill="#3D3D3D"
        />
        <path
            d="M372.94 613.98a.076.076 0 0 0-.032.027.067.067 0 0 0-.012.039c0 .015.004.029.012.04a.068.068 0 0 0 .032.026l.639.371a.247.247 0 0 0 .225 0l.641-.371c.064-.035.064-.1 0-.132l-.638-.369a.26.26 0 0 0-.22 0l-.647.369z"
            fill="#4A4A4A"
        />
        <path
            d="m371.56 615.78 1.767-1.02a.083.083 0 0 0 .044-.065v.128a.096.096 0 0 1-.014.038.077.077 0 0 1-.03.027l-1.767 1.019v-.127z"
            fill="#636363"
        />
        <path
            d="M370.65 615.34a.08.08 0 0 0 .016.039.068.068 0 0 0 .032.026l.637.372a.242.242 0 0 0 .222 0v.127a.232.232 0 0 1-.222 0l-.637-.373a.064.064 0 0 1-.032-.024.076.076 0 0 1-.016-.038v-.129z"
            fill="#3D3D3D"
        />
        <path
            d="M367.36 613.42c-.058.035-.06.092 0 .126l.643.375a.261.261 0 0 0 .222 0l2.834-1.646a.06.06 0 0 0 .033-.024c.009-.011.013-.025.013-.039s-.004-.028-.013-.039a.066.066 0 0 0-.033-.024l-.639-.374a.247.247 0 0 0-.22 0l-2.84 1.645z"
            fill="#4A4A4A"
        />
        <path
            d="m368.22 613.92 2.834-1.646a.068.068 0 0 0 .032-.026.077.077 0 0 0 .014-.039v.13a.088.088 0 0 1-.015.039.08.08 0 0 1-.033.025l-2.834 1.643.002-.126z"
            fill="#636363"
        />
        <path
            d="M367.31 613.49a.084.084 0 0 0 .015.038.086.086 0 0 0 .029.028l.643.371a.255.255 0 0 0 .222 0v.126a.243.243 0 0 1-.222 0l-.643-.371c-.011-.006-.022-.015-.029-.026s-.012-.024-.013-.038l-.002-.128z"
            fill="#3D3D3D"
        />
        <path
            d="M373.35 608.15a.428.428 0 0 0 .23-.652.427.427 0 0 0-.207-.163l-1.733-1.063a1.553 1.553 0 0 0-1.412-.035l-2.8 1.532a.431.431 0 0 0-.305.4.432.432 0 0 0 .278.419l1.735 1.063a1.549 1.549 0 0 0 1.413.032l2.801-1.533z"
            fill="#9E9D9D"
        />
        <path
            d="m369.61 616.52-.595-.344v-.2l.595.343v.201zM368.62 615.96l-.595-.347v-.194l.595.342v.199z"
            fill="#1C1C1C"
        />
        <path
            d="M385.59 598.06a.613.613 0 0 1 .632 0l.169.1-14.392 8.48-.3 10.521-.345-.2v-9.99a1.265 1.265 0 0 1 .638-1.1l13.598-7.811z"
            fill="#8E8D8D"
        />
        <path
            d="M372.33 606.07a1.288 1.288 0 0 0-.635 1.1v9.992l14.95-8.611v-9.988a.415.415 0 0 0-.056-.212.424.424 0 0 0-.579-.156l-13.68 7.875z"
            fill="#C1BFBD"
        />
        <path
            d="m373.65 619.59-5.229 8.2-7.857-2.479 5.711-8.06 7.375 2.339z"
            fill="#DEDDE2"
        />
        <path
            d="M369.5 621.72v.071l-5.811 5.247v-.07l5.811-5.248z"
            fill="#8C8B8B"
        />
        <path
            d="M361.35 626.97v.07l-4.924-2.831v-.07l4.924 2.831z"
            fill="#6C6C6C"
        />
        <path
            d="m370.37 620.99-6.68 5.973h-2.342l-4.925-2.831 7.74-6.186 6.207 3.044z"
            fill="#DDE8E7"
        />
        <path d="M363.7 626.97h-2.341v.072h2.341v-.072z" fill="#8C8B8B" />
        <path d="m362.52 626.29 1.174.679h-2.34l1.166-.679z" fill="#E1EAEA" />
        <path
            d="M366.87 621.31v.07l-8.123 4.72v-.071l8.123-4.719z"
            fill="#8C8B8B"
        />
        <path
            d="M358.75 626.03v.07l-6.185-3.57v-.068l6.185 3.568z"
            fill="#616161"
        />
        <path
            d="m366.87 621.31-8.123 4.719-6.185-3.568 8.106-4.71 6.202 3.559z"
            fill="#9C9B9B"
        />
        <path
            d="M366.87 620.96v.071l-8.123 4.72v-.068l8.123-4.723z"
            fill="#8C8B8B"
        />
        <path
            d="M358.75 625.68v.068l-6.185-3.57v-.069l6.185 3.571z"
            fill="#616161"
        />
        <path
            d="m366.87 620.96-8.123 4.723-6.185-3.571 8.106-4.71 6.202 3.558z"
            fill="#9C9B9B"
        />
        <path d="M366.87 620.6v.07l-8.123 4.72v-.07l8.123-4.72z" fill="#8C8B8B" />
        <path d="M358.75 625.32v.07l-6.185-3.57v-.07l6.185 3.57z" fill="#616161" />
        <path
            d="m366.87 620.6-8.123 4.72-6.185-3.57 8.106-4.708 6.202 3.558z"
            fill="#9C9B9B"
        />
        <path
            d="M366.87 620.25v.068l-8.123 4.722v-.069l8.123-4.721z"
            fill="#8C8B8B"
        />
        <path
            d="M358.75 624.97v.069l-6.185-3.571v-.067l6.185 3.569z"
            fill="#616161"
        />
        <path
            d="m366.87 620.25-8.123 4.721-6.185-3.569 8.106-4.711 6.202 3.559z"
            fill="#9C9B9B"
        />
        <path
            d="M366.87 619.89v.068l-8.123 4.721v-.069l8.123-4.72z"
            fill="#8C8B8B"
        />
        <path
            d="M358.75 624.61v.069l-6.185-3.57v-.07l6.185 3.571z"
            fill="#616161"
        />
        <path
            d="m366.87 619.89-8.123 4.72-6.185-3.571 8.106-4.709 6.202 3.56z"
            fill="#9C9B9B"
        />
        <path
            d="M366.87 619.54v.068l-8.123 4.724v-.072l8.123-4.72z"
            fill="#8C8B8B"
        />
        <path
            d="M358.75 624.26v.072l-6.185-3.572v-.071l6.185 3.571z"
            fill="#616161"
        />
        <path
            d="m366.87 619.54-8.123 4.72-6.185-3.571 8.106-4.709 6.202 3.56z"
            fill="#A8AFAF"
        />
        <path
            d="M366.87 619.14v.07l-6.983 4.059v-.07l6.983-4.059z"
            fill="#8C8B8B"
        />
        <path d="M357.6 623.2v.07l-5.035-2.908v-.069l5.035 2.907z" fill="#6C6C6C" />
        <path
            d="m366.87 619.14-6.983 4.059H357.6l-5.035-2.907 8.125-4.721 6.18 3.569z"
            fill="#D2D8D8"
        />
        <path d="M365.1 619.6v.017l-.829.481v-.016l.829-.482z" fill="#858585" />
        <path
            d="M364.27 620.08v.016l-5.292-3.054v-.018l5.292 3.056z"
            fill="#5D5D5D"
        />
        <path
            d="m365.1 619.6-.829.482-5.292-3.057.829-.482 5.292 3.057z"
            fill="#959595"
        />
        <path d="M363.82 620.32v.018l-.83.481v-.015l.83-.484z" fill="#858585" />
        <path
            d="M362.99 620.81v.015l-5.294-3.055v-.018l5.294 3.058z"
            fill="#5D5D5D"
        />
        <path
            d="m363.82 620.32-.83.484-5.294-3.058.832-.482 5.292 3.056z"
            fill="#959595"
        />
        <path d="M362.54 621.07v.017l-.828.482v-.019l.828-.48z" fill="#858585" />
        <path
            d="M361.71 621.55v.019l-5.292-3.056v-.016l5.292 3.053z"
            fill="#5D5D5D"
        />
        <path
            d="m362.54 621.07-.828.48-5.292-3.053.83-.482 5.29 3.055z"
            fill="#959595"
        />
        <path d="M361.21 621.84v.016l-.831.482v-.015l.831-.483z" fill="#858585" />
        <path
            d="M360.38 622.32v.017l-5.292-3.055v-.019l5.292 3.057z"
            fill="#5D5D5D"
        />
        <path
            d="m361.21 621.84-.831.481-5.292-3.057.829-.48 5.294 3.056z"
            fill="#959595"
        />
        <path d="M359.87 622.62v.017l-.832.484v-.018l.832-.483z" fill="#858585" />
        <path
            d="M359.04 623.1v.018l-5.291-3.056v-.02l5.291 3.058z"
            fill="#5D5D5D"
        />
        <path
            d="m359.87 622.62-.832.483-5.291-3.059.829-.481 5.294 3.057z"
            fill="#959595"
        />
        <path d="M359.89 623.2h-2.291v.07h2.291v-.07z" fill="#8C8B8B" />
        <path d="m358.74 622.54 1.148.662h-2.291l1.143-.662z" fill="#C3C3C3" />
        <path
            d="m354.09 614.51-.008-.013a.494.494 0 0 1-.011-.036l-.008-.012-.007-.05c0-.016-.005-.034-.007-.053l.005-.01c.002-.017-.001-.034.002-.048.004-.019.002-.03.009-.045l-.005-.009.003-.01c.007-.016.009-.033.015-.048l.003-.008a.437.437 0 0 1 .022-.043.16.16 0 0 1 .129-.094l.533.002a.182.182 0 0 0-.078.03.182.182 0 0 0-.053.064.133.133 0 0 0-.021.047l-.004.003c-.005.016-.011.03-.015.049l-.003.009v.011a.176.176 0 0 0-.007.04l.004.007a.176.176 0 0 0-.006.046l.005.008a.282.282 0 0 0 .001.058l.003.005a.355.355 0 0 1 .006.047l.005.008c.009.015.008.033.012.043l.009.015a.23.23 0 0 0 .023.04.157.157 0 0 0 .125.091c-.175 0-.355-.001-.528.001a.157.157 0 0 1-.128-.092.284.284 0 0 1-.025-.053z"
            fill="#FC6B6B"
        />
        <path
            d="m354.48 614.51-.008-.012-.018-.033a.025.025 0 0 0-.004-.017l-.005-.046-.002-.051-.005-.008a.599.599 0 0 0 .005-.052l-.003-.005c.005-.016.004-.03.007-.042l.001-.011.003-.005-.002-.006a.407.407 0 0 1 .018-.044l-.004-.006c.007-.016.017-.032.024-.047a.158.158 0 0 1 .051-.064.156.156 0 0 1 .076-.028l8.083.023a.148.148 0 0 0-.129.093.182.182 0 0 0-.021.047.311.311 0 0 0-.016.049l-.005.003c-.005.02-.004.034-.01.054l.003.006a.13.13 0 0 0 0 .048c-.006.003-.004.01-.004.01a.52.52 0 0 1 .003.055l.003.006c.001.017.006.032.007.046l.005.009a.188.188 0 0 0 .014.042l.003.014.025.044a.153.153 0 0 0 .129.091c-2.694-.009-5.388-.017-8.084-.024a.157.157 0 0 1-.14-.139z"
            fill="#0E3C55"
        />
        <path
            d="m354.62 614.52-.006-.01c-.008-.014-.009-.03-.014-.042l-.007-.013a.254.254 0 0 0-.007-.047l-.003-.005a.505.505 0 0 1-.001-.055l-.006-.01c0-.016.002-.031.006-.046l-.004-.007a.176.176 0 0 1 .007-.04l.001-.009.002-.01c.004-.02.01-.034.015-.05a.149.149 0 0 1 .022-.048.162.162 0 0 1 .053-.063.156.156 0 0 1 .077-.03l8.08.023a.15.15 0 0 0-.076.028.148.148 0 0 0-.052.064.192.192 0 0 0-.021.046l-.006.003a.285.285 0 0 0-.014.05l.003.004a.517.517 0 0 0-.011.054l.004.006c-.002.015-.001.03-.003.044l.001.018a.451.451 0 0 0 0 .052l.004.007.007.043.006.01.014.042.007.013a.25.25 0 0 0 .023.039.163.163 0 0 0 .051.065.178.178 0 0 0 .077.03l-8.08-.024a.166.166 0 0 1-.129-.093.355.355 0 0 1-.02-.039z"
            fill="#FC6B6B"
        />
        <path
            d="m362.67 614.36-8.085.021a.46.46 0 0 0 .055.17c.012.025.03.046.052.063a.165.165 0 0 0 .077.029l8.08.024a.166.166 0 0 1-.077-.03.163.163 0 0 1-.051-.065.465.465 0 0 1-.052-.159l.001-.053z"
            fill="#ED4A4A"
        />
        <path
            d="M362.85 614.04c.036.002.54.315.54.315-.178.116-.364.22-.556.311a.15.15 0 0 1-.069-.031.145.145 0 0 1-.046-.058.488.488 0 0 1 .004-.446.158.158 0 0 1 .13-.094l-.003.003z"
            fill="#FFC892"
        />
        <path
            d="m363.39 614.36-.137.088c-.009-.002-.013-.042-.014-.086-.001-.045.008-.087.017-.083l.134.081z"
            fill="#FC6B6B"
        />
        <path
            d="m391.1 670.9-20.842-12.112 44.35-25.374 20.9 12.112L391.1 670.9z"
            fill="#231F20"
            opacity={0.24}
            style={{ mixBlendMode: "multiply" }}
        />
        <path
            d="m391.9 643.64-.02 22a.66.66 0 0 1-.384.537c-.833.485-2.258.133-2.258-.545l.025-22c-.006.677 1.423 1.025 2.254.542a.656.656 0 0 0 .383-.536v.002zM379.84 636.2l-.023 22a.66.66 0 0 1-.381.538 2.075 2.075 0 0 1-1.867 0 .676.676 0 0 1-.39-.545l.021-22a.664.664 0 0 0 .389.546 2.07 2.07 0 0 0 1.866 0 .654.654 0 0 0 .385-.539z"
            fill="#646D6D"
        />
        <path
            d="m392.61 650.81-20.2-11.7 44.242-25.476 20.2 11.7-44.242 25.476z"
            fill="#fff"
        />
        <path
            d="m436.85 625.33-44.239 25.481-20.2-11.7v.991l20.2 11.7 44.239-25.48v-.992z"
            fill="#E0E0E0"
        />
        <path
            d="m401.06 624.45 4.709-2.736a.97.97 0 0 0-.41.89.96.96 0 0 0 .434.751l2.57 1.482a.509.509 0 0 1 .234.408.17.17 0 0 1-.068.155l-4.709 2.736a.167.167 0 0 0 .068-.152.525.525 0 0 0-.237-.41l-2.569-1.483a.956.956 0 0 1-.432-.75.981.981 0 0 1 .41-.891z"
            fill="#969696"
        />
        <path
            d="m404.05 621.97 4.713-2.739.333.58-4.711 2.738-.335-.579z"
            fill="#212525"
        />
        <path
            d="m400.72 623.87 4.711-2.739 3.33-1.9-4.713 2.739-3.328 1.9z"
            fill="#1C1E1F"
        />
        <path
            d="m404.05 621.97.335.579-3.327 1.9a.97.97 0 0 0-.41.891.968.968 0 0 0 .432.75l2.569 1.483a.515.515 0 0 1 .237.41c0 .15-.1.211-.237.136l-2.569-1.483a2.016 2.016 0 0 1-.907-1.569 1.323 1.323 0 0 1 .549-1.2l3.328-1.897z"
            fill="#656868"
        />
        <path
            d="m414.17 599.04.467.274a.622.622 0 0 0-.631.061l-.471-.274a.62.62 0 0 1 .635-.061z"
            fill="#696E70"
        />
        <path
            d="m413.41 612.91-.036-12.76.469.273.036 12.762-20.528 11.853-.469-.272 20.528-11.856z"
            fill="#464949"
        />
        <path
            d="M391.92 628.22v-1.626l.475.279v1.621a.628.628 0 0 0 .259.571l-.473-.275a.626.626 0 0 1-.256-.57h-.005z"
            fill="#929292"
        />
        <path
            d="m392.39 626.87 22.541-13.014.006 1.616a1.97 1.97 0 0 1-.889 1.537l-8 4.615-4.835 2.789-7.94 4.583c-.493.284-.89.057-.892-.51l.009-1.616z"
            fill="#A8A8A8"
        />
        <path
            d="m413.57 600.25.035 12.76-20.53 11.854-.037-12.76 20.532-11.854z"
            fill="#33CCE5"
        />
        <path
            d="m393.35 625.04-.469-.272-.037-12.762.471.274.035 12.76z"
            fill="#aaa"
        />
        <path
            d="m393.32 612.28-.471-.274 20.536-11.854.469.273-20.534 11.855z"
            fill="#F2F2F2"
        />
        <path
            d="M391.89 612.63a1.965 1.965 0 0 1 .886-1.537l20.76-11.986a.627.627 0 0 1 .635-.061l.467.274a.622.622 0 0 0-.631.061l-20.76 11.986a1.97 1.97 0 0 0-.888 1.537l.033 12.693v1.281l-.479-.281v-1.274l-.023-12.693z"
            fill="#2B2F30"
        />
        <path
            d="M393.25 611.37a1.941 1.941 0 0 0-.888 1.537l.033 12.693v1.287l22.543-13.021c0-.193.008 1.33-.035-13.973 0-.565-.4-.791-.893-.507l-20.76 11.984zm20.633 1.816-20.531 11.852-.035-12.759 20.53-11.855.036 12.762z"
            fill="#505556"
        />
        <path
            d="m401.52 634.29 11.875-6.419a.291.291 0 0 0 .116-.257.666.666 0 0 0-.033-.208l-11.878 6.418a.647.647 0 0 1 .035.21.28.28 0 0 1-.115.256z"
            fill="#8C8C8C"
        />
        <path
            d="M412.83 626.9a.34.34 0 0 1 .361.08l5.514 3.476-11.809 6.559-5.585-3.62-.02-.013c-.157-.111-.267-.1-.339-.063l11.878-6.419z"
            fill="#D6D8D8"
        />
        <path
            d="M418.75 630.5a.172.172 0 0 0-.044-.041l-11.806 6.555a.204.204 0 0 1 .082.175c.001.01-.001.02-.006.029s-.012.017-.021.022l11.81-6.557a.047.047 0 0 0 .02-.022.053.053 0 0 0 .007-.028.22.22 0 0 0-.042-.133z"
            fill="#C9C9C9"
        />
        <path d="m406.9 637.01 11.807-6.555-11.81 6.559.003-.004z" fill="#E0E0E0" />
        <path
            d="M401.24 633.34c-.219-.127-.4-.025-.4.227a.893.893 0 0 0 .117.393c.07.119.167.221.283.297.22.127.4.023.4-.227a.706.706 0 0 0-.035-.21l.088.059 5.189 3.343c.061.038.1.018.108-.038a.198.198 0 0 0-.023-.099.205.205 0 0 0-.066-.077l-5.6-3.633-.019-.015-.014-.006a.062.062 0 0 0-.028-.014z"
            fill="#ADADAD"
        />
        <path
            d="M412.4 627.9c-.05.027-.052.072 0 .1l.5.315a.206.206 0 0 0 .177.007l.523-.281c.051-.027.053-.073.005-.1l-.5-.315c-.028-.014-.058-.022-.089-.023s-.061.005-.089.018l-.527.279zM411.48 628.38c-.051.027-.053.074 0 .1l.5.313a.198.198 0 0 0 .178.007l.524-.28c.049-.028.051-.074 0-.1l-.5-.314c-.027-.016-.057-.025-.088-.026s-.062.005-.091.019l-.523.281zM410.57 628.87a.053.053 0 0 0-.034.05c0 .01.003.021.009.03s.015.016.025.02l.5.313a.205.205 0 0 0 .176.006l.525-.28c.05-.029.052-.074 0-.1l-.5-.314a.2.2 0 0 0-.18-.006l-.521.281zM409.65 629.36c-.05.028-.052.072 0 .1l.5.313a.187.187 0 0 0 .175 0l.526-.279a.053.053 0 0 0 .034-.05.053.053 0 0 0-.034-.05l-.5-.315a.214.214 0 0 0-.177-.006l-.524.287zM408.74 629.85c-.051.024-.051.072 0 .1l.5.314a.205.205 0 0 0 .175.007l.526-.282c.01-.004.019-.011.025-.02a.055.055 0 0 0 0-.06.055.055 0 0 0-.025-.02l-.5-.314a.206.206 0 0 0-.18-.006l-.521.281zM407.82 630.34c-.049.029-.051.074 0 .1l.5.315a.195.195 0 0 0 .178 0l.523-.28c.05-.025.052-.072 0-.1l-.5-.313a.184.184 0 0 0-.176-.006l-.525.284zM412.36 628.93c-.049.028-.053.074-.006.1l.5.315a.194.194 0 0 0 .088.025c.03 0 .061-.006.088-.02l1.439-.768c.05-.028.054-.074 0-.1l-.5-.315a.205.205 0 0 0-.178-.006l-1.431.769zM411.45 629.42c-.051.026-.053.071 0 .105l.5.312a.204.204 0 0 0 .088.021c.03 0 .06-.008.087-.021l.526-.28c.01-.004.019-.011.025-.02s.009-.02.009-.03a.056.056 0 0 0-.009-.031.06.06 0 0 0-.025-.019l-.5-.312a.184.184 0 0 0-.176-.005l-.525.28zM410.53 629.91a.055.055 0 0 0-.023.08.055.055 0 0 0 .023.02l.5.314a.183.183 0 0 0 .088.025.185.185 0 0 0 .09-.019l.525-.28c.05-.027.052-.072 0-.1l-.5-.315a.193.193 0 0 0-.177 0l-.526.275zM409.62 630.4c-.049.029-.051.076 0 .1l.5.312a.2.2 0 0 0 .087.025.199.199 0 0 0 .09-.018l.526-.279a.066.066 0 0 0 .023-.021.053.053 0 0 0 0-.059.055.055 0 0 0-.023-.02l-.5-.313a.188.188 0 0 0-.178-.006l-.525.279zM408.7 630.88a.058.058 0 0 0-.024.02.055.055 0 0 0 0 .06.058.058 0 0 0 .024.02l.5.315a.214.214 0 0 0 .179.007l.524-.283c.049-.027.051-.072 0-.1l-.5-.314a.18.18 0 0 0-.177-.006l-.526.281zM413.25 629.48c-.05.028-.051.074-.005.1l.5.315a.201.201 0 0 0 .176.005l1.438-.768a.056.056 0 0 0 .022-.021.051.051 0 0 0 .008-.029.053.053 0 0 0-.03-.05l-.5-.311a.197.197 0 0 0-.178-.007l-1.431.766zM412.33 629.98c-.052.024-.053.07-.005.1l.5.315a.197.197 0 0 0 .179.005l.523-.279c.052-.027.054-.075.005-.1l-.5-.313a.194.194 0 0 0-.177-.007l-.525.279zM411.42 630.46c-.049.026-.051.071 0 .1l.5.312a.21.21 0 0 0 .088.024.206.206 0 0 0 .089-.019l.524-.278c.049-.028.052-.075 0-.1l-.5-.314a.188.188 0 0 0-.177-.005l-.524.28zM410.5 630.95c-.011.003-.021.01-.028.019s-.011.02-.012.032.002.023.008.033c.007.01.016.018.026.023l.5.311a.207.207 0 0 0 .176.008l.525-.283c.01-.004.019-.011.025-.02a.055.055 0 0 0 0-.06.055.055 0 0 0-.025-.02l-.5-.314a.206.206 0 0 0-.18-.006l-.515.277zM406.92 630.83c-.049.027-.05.073 0 .1l.5.313a.19.19 0 0 0 .175 0l.527-.28a.052.052 0 0 0 .023-.021.053.053 0 0 0 0-.059.045.045 0 0 0-.023-.02l-.5-.314c-.028-.014-.059-.022-.09-.022s-.062.008-.09.022l-.522.281zM407.79 631.38a.045.045 0 0 0-.023.02.053.053 0 0 0 0 .059.052.052 0 0 0 .023.021l.5.314a.197.197 0 0 0 .179 0l.522-.28c.05-.028.052-.073 0-.1l-.5-.312c-.027-.016-.056-.025-.087-.026s-.061.005-.089.018l-.525.286zM409.59 631.44c-.01.004-.018.011-.024.02s-.009.019-.009.03.003.021.009.03.014.016.024.02l.5.315a.214.214 0 0 0 .089.023.23.23 0 0 0 .09-.018l.522-.282c.051-.026.054-.071 0-.1l-.5-.312a.193.193 0 0 0-.087-.024.186.186 0 0 0-.09.017l-.524.281zM408.68 631.93c-.051.026-.051.072 0 .1l.5.315a.203.203 0 0 0 .18.007l.523-.28c.048-.029.05-.074 0-.1l-.5-.315a.184.184 0 0 0-.177-.005l-.526.278zM413.17 630.5c-.049.025-.051.072 0 .1l.5.312a.205.205 0 0 0 .177.005l2.351-1.259c.051-.025.051-.072 0-.1l-.5-.313a.194.194 0 0 0-.179-.007l-2.349 1.262zM412.26 630.99c-.048.028-.052.073 0 .1l.5.314a.194.194 0 0 0 .088.025.194.194 0 0 0 .089-.02l.522-.278a.062.062 0 0 0 .027-.021c.006-.009.01-.021.01-.032s-.004-.023-.01-.032a.054.054 0 0 0-.027-.02l-.5-.311a.2.2 0 0 0-.18-.008l-.519.283zM411.35 631.48c-.052.028-.054.074-.006.1l.5.315a.197.197 0 0 0 .178 0l.523-.281c.051-.025.054-.07 0-.1l-.5-.313a.184.184 0 0 0-.177-.005l-.518.284zM410.43 631.97c-.049.026-.051.072 0 .1l.5.313a.205.205 0 0 0 .177.006l.525-.282c.051-.026.051-.073 0-.1l-.5-.313a.181.181 0 0 0-.18 0l-.522.276zM409.52 632.46c-.052.027-.054.072-.006.1l.5.311a.205.205 0 0 0 .176.006l.523-.279c.049-.027.053-.072.005-.1l-.5-.315a.195.195 0 0 0-.176-.005l-.522.282zM406 631.32a.057.057 0 0 0-.026.02.053.053 0 0 0-.01.032.05.05 0 0 0 .01.032.06.06 0 0 0 .026.021l.5.313a.184.184 0 0 0 .175 0l.525-.28c.048-.025.052-.071 0-.1l-.5-.314a.19.19 0 0 0-.177-.006l-.523.282zM406.87 631.87c-.05.028-.05.073 0 .1l.5.314a.205.205 0 0 0 .176.006l.525-.28a.068.068 0 0 0 .024-.02.065.065 0 0 0 .009-.03.062.062 0 0 0-.009-.03.052.052 0 0 0-.024-.02l-.5-.312a.186.186 0 0 0-.087-.024.21.21 0 0 0-.089.017l-.525.279zM407.76 632.42a.06.06 0 0 0-.026.019c-.006.009-.009.02-.009.031s.003.022.009.031a.06.06 0 0 0 .026.019l.5.314a.205.205 0 0 0 .177.005l.525-.279a.063.063 0 0 0 .028-.02c.006-.01.01-.021.01-.033s-.004-.023-.01-.033a.063.063 0 0 0-.028-.02l-.5-.311c-.027-.015-.057-.024-.088-.025s-.061.006-.089.019l-.525.283zM408.6 632.95a.06.06 0 0 0-.034.048c0 .01.002.021.007.03s.012.017.021.022l.5.313a.193.193 0 0 0 .176.005l.525-.279a.053.053 0 0 0 .035-.048.052.052 0 0 0-.03-.052l-.5-.311a.18.18 0 0 0-.088-.026.176.176 0 0 0-.09.019l-.522.279zM415.83 630.04c-.049.029-.053.073 0 .1l.5.313a.197.197 0 0 0 .178.006l.525-.28a.061.061 0 0 0 .024-.021.057.057 0 0 0 .008-.029.061.061 0 0 0-.008-.03.052.052 0 0 0-.024-.02l-.5-.313c-.027-.015-.058-.022-.089-.022s-.061.007-.089.022l-.525.274zM414.92 630.53c-.05.027-.052.073 0 .1l.5.314a.18.18 0 0 0 .176 0l.525-.278a.052.052 0 0 0 .024-.02.061.061 0 0 0 0-.06.052.052 0 0 0-.024-.02l-.5-.313a.205.205 0 0 0-.176-.006l-.525.283zM414 631.02c-.051.026-.052.072 0 .1l.5.314a.194.194 0 0 0 .178.006l.523-.28c.05-.027.051-.072 0-.1l-.5-.315a.2.2 0 0 0-.177-.006l-.524.281zM409.43 633.47c-.049.027-.051.073 0 .1l.5.314a.199.199 0 0 0 .178.005l4.181-2.235a.055.055 0 0 0 .023-.08.045.045 0 0 0-.023-.02l-.5-.313a.193.193 0 0 0-.177-.005l-4.182 2.234zM405.09 631.81c-.05.027-.054.074 0 .1l.5.315a.205.205 0 0 0 .087.023.225.225 0 0 0 .089-.018l.525-.279c.051-.028.053-.074.006-.1l-.5-.313c-.027-.016-.057-.024-.088-.025s-.061.005-.089.019l-.53.278zM404.17 632.3a.052.052 0 0 0-.024.02.061.061 0 0 0-.008.03c0 .01.003.021.008.029a.061.061 0 0 0 .024.021l.5.312a.202.202 0 0 0 .176.008l.523-.281c.051-.028.053-.074.005-.1l-.5-.316a.202.202 0 0 0-.179 0l-.525.277zM402.34 633.27c-.049.027-.052.072 0 .1l.5.315a.203.203 0 0 0 .087.021c.031 0 .06-.008.088-.021l1.439-.769a.054.054 0 0 0 .034-.049.053.053 0 0 0-.029-.051l-.5-.314a.2.2 0 0 0-.179-.005l-1.44.773zM405.96 632.36a.055.055 0 0 0-.025.02.05.05 0 0 0-.01.03.05.05 0 0 0 .01.031.047.047 0 0 0 .025.019l.5.314c.028.015.058.024.089.025s.062-.006.09-.019l.523-.281a.052.052 0 0 0 .037-.048.053.053 0 0 0-.031-.052l-.5-.313a.199.199 0 0 0-.178-.006l-.53.28zM405.05 632.84a.05.05 0 0 0-.026.018.057.057 0 0 0-.004.061.061.061 0 0 0 .024.021l.5.315a.205.205 0 0 0 .178.005l.523-.28a.074.074 0 0 0 .023-.02.055.055 0 0 0 0-.06.055.055 0 0 0-.023-.02l-.5-.313a.184.184 0 0 0-.177 0l-.518.273zM404.13 633.33c-.05.027-.053.073-.006.1l.5.311a.207.207 0 0 0 .178.007l.523-.282c.051-.026.053-.07 0-.1l-.5-.313a.197.197 0 0 0-.178 0l-.517.277zM403.22 633.82c-.051.028-.052.073 0 .1l.5.312a.194.194 0 0 0 .177.007l.524-.281c.05-.025.052-.071 0-.1l-.5-.312a.194.194 0 0 0-.088-.025.186.186 0 0 0-.09.017l-.523.282zM406.85 632.91c-.05.028-.052.075-.005.1l.5.313a.187.187 0 0 0 .178.007l.523-.281c.051-.026.051-.072.006-.1l-.5-.313c-.028-.014-.058-.022-.089-.023s-.061.005-.089.018l-.524.279zM405.93 633.4c-.052.025-.052.072-.005.1l.5.314a.205.205 0 0 0 .176.006l.525-.28c.01-.004.019-.011.025-.02s.009-.02.009-.03a.056.056 0 0 0-.009-.031.06.06 0 0 0-.025-.019l-.5-.315a.193.193 0 0 0-.178-.005l-.518.28zM404.1 634.38a.055.055 0 0 0-.032.05c0 .01.003.02.009.029s.014.016.023.021l.5.312a.222.222 0 0 0 .088.024c.03.001.06-.005.088-.017l1.438-.771a.06.06 0 0 0 .026-.019.064.064 0 0 0 .011-.03.064.064 0 0 0-.008-.03.049.049 0 0 0-.024-.021l-.5-.314a.188.188 0 0 0-.178-.005l-1.441.771zM407.69 633.44c-.052.026-.054.071 0 .1l.5.314a.21.21 0 0 0 .088.023.23.23 0 0 0 .09-.018l.525-.281c.01-.004.018-.011.024-.02s.01-.02.01-.03c0-.011-.004-.021-.01-.03s-.014-.016-.024-.02l-.5-.312a.188.188 0 0 0-.175-.008l-.528.282zM406.78 633.93c-.049.026-.053.072 0 .1l.5.316a.202.202 0 0 0 .18 0l.521-.279c.051-.028.054-.075.006-.1l-.5-.314c-.026-.016-.056-.024-.087-.025s-.061.006-.088.02l-.532.282zM404.95 634.9c-.049.026-.051.072 0 .1l.5.313a.197.197 0 0 0 .177 0l1.44-.768c.049-.027.051-.072 0-.1l-.5-.311a.183.183 0 0 0-.088-.025.18.18 0 0 0-.088.019l-1.441.772zM408.52 633.96a.053.053 0 0 0-.034.05c0 .01.003.021.009.03s.015.016.025.02l.5.314c.027.014.057.021.088.021s.061-.007.088-.021l.525-.279c.05-.026.052-.073 0-.1l-.5-.312a.194.194 0 0 0-.087-.025.195.195 0 0 0-.089.019l-.525.283zM405.78 635.42c-.05.027-.054.073 0 .1l.5.314a.205.205 0 0 0 .177.006l1.44-.769c.049-.025.051-.072 0-.1l-.5-.313a.187.187 0 0 0-.178-.006l-1.439.768z"
            fill="#EAEAEA"
        />
        <path
            d="m413.07 628.32.523-.281a.06.06 0 0 0 .039-.051v.1a.06.06 0 0 1-.012.031.06.06 0 0 1-.026.021l-.524.278v-.098z"
            fill="#8C8C8C"
        />
        <path
            d="M412.36 627.94c0 .011.004.022.011.031a.06.06 0 0 0 .026.021l.5.315a.193.193 0 0 0 .087.024.215.215 0 0 0 .09-.017v.1a.188.188 0 0 1-.178-.005l-.5-.313a.075.075 0 0 1-.026-.021.072.072 0 0 1-.011-.031l.001-.104z"
            fill="#ADADAD"
        />
        <path
            d="m412.16 628.81.524-.28a.067.067 0 0 0 .025-.022.056.056 0 0 0 .012-.03v.1c0 .022-.015.037-.04.051l-.522.28.001-.099z"
            fill="#8C8C8C"
        />
        <path
            d="M411.45 628.44c0 .018.007.035.033.051l.5.313a.19.19 0 0 0 .178.007v.1a.207.207 0 0 1-.178 0l-.5-.312c-.024-.017-.035-.035-.033-.053v-.106z"
            fill="#ADADAD"
        />
        <path
            d="m411.24 629.3.525-.28a.054.054 0 0 0 .026-.021.051.051 0 0 0 .011-.031v.1a.053.053 0 0 1-.012.03.06.06 0 0 1-.027.02l-.524.282.001-.1z"
            fill="#8C8C8C"
        />
        <path
            d="M410.53 628.92a.072.072 0 0 0 .036.052l.5.313a.205.205 0 0 0 .176.006v.1a.203.203 0 0 1-.088.017.222.222 0 0 1-.087-.024l-.5-.313a.069.069 0 0 1-.024-.021.07.07 0 0 1-.009-.031l-.004-.099z"
            fill="#ADADAD"
        />
        <path
            d="m410.33 629.78.526-.279c.025-.014.039-.03.039-.05v.1a.06.06 0 0 1-.039.051l-.524.279-.002-.101z"
            fill="#8C8C8C"
        />
        <path
            d="M409.62 629.41a.06.06 0 0 0 .009.032c.006.01.015.017.026.022l.5.313a.19.19 0 0 0 .175 0v.1a.208.208 0 0 1-.177-.006l-.5-.312a.075.075 0 0 1-.024-.023.076.076 0 0 1-.01-.03l.001-.096z"
            fill="#ADADAD"
        />
        <path
            d="m409.41 630.28.526-.282a.055.055 0 0 0 .025-.02.05.05 0 0 0 .012-.029v.1a.096.096 0 0 1-.037.061l-.526.278v-.108z"
            fill="#8C8C8C"
        />
        <path
            d="M408.7 629.9a.069.069 0 0 0 .037.05l.5.314a.222.222 0 0 0 .087.024c.03.001.06-.005.088-.017v.1a.205.205 0 0 1-.175-.007l-.5-.313a.075.075 0 0 1-.025-.022.068.068 0 0 1-.011-.031l-.001-.098z"
            fill="#ADADAD"
        />
        <path
            d="m408.5 630.76.523-.28a.06.06 0 0 0 .039-.051v.1a.05.05 0 0 1-.012.029.063.063 0 0 1-.026.02l-.525.281.001-.099z"
            fill="#8C8C8C"
        />
        <path
            d="M407.78 630.39c0 .019.014.036.038.052l.5.315a.197.197 0 0 0 .178 0l-.005.1a.195.195 0 0 1-.177-.005l-.5-.313a.104.104 0 0 1-.024-.023.077.077 0 0 1-.011-.03l.001-.096z"
            fill="#ADADAD"
        />
        <path
            d="m413.03 629.35 1.439-.768c.011-.005.019-.012.026-.021s.011-.019.012-.03v.1a.068.068 0 0 1-.038.052l-1.439.768v-.101z"
            fill="#8C8C8C"
        />
        <path
            d="M412.32 628.98c0 .01.004.02.009.029a.068.068 0 0 0 .024.02l.5.315a.187.187 0 0 0 .176.005v.1a.2.2 0 0 1-.09.02.19.19 0 0 1-.087-.025l-.5-.312c-.022-.017-.035-.033-.033-.052l.001-.1z"
            fill="#ADADAD"
        />
        <path
            d="m412.12 629.84.526-.28a.075.075 0 0 0 .026-.021.06.06 0 0 0 .013-.029v.1a.086.086 0 0 1-.014.029.086.086 0 0 1-.026.02l-.525.282v-.101z"
            fill="#8C8C8C"
        />
        <path
            d="M411.4 629.47a.07.07 0 0 0 .012.031.078.078 0 0 0 .026.022l.5.312a.204.204 0 0 0 .088.021c.03 0 .06-.008.087-.021v.1a.205.205 0 0 1-.088.019.21.21 0 0 1-.089-.019l-.5-.316c-.026-.014-.039-.033-.035-.051l-.001-.098z"
            fill="#ADADAD"
        />
        <path
            d="m411.2 630.33.525-.28a.063.063 0 0 0 .026-.022.06.06 0 0 0 .013-.031v.105a.067.067 0 0 1-.037.05l-.526.282-.001-.104z"
            fill="#8C8C8C"
        />
        <path
            d="M410.49 629.96a.064.064 0 0 0 .035.051l.5.314a.183.183 0 0 0 .089.025.183.183 0 0 0 .089-.019v.1a.194.194 0 0 1-.177-.008l-.5-.312a.063.063 0 0 1-.033-.051l-.003-.1z"
            fill="#ADADAD"
        />
        <path
            d="m410.29 630.82.526-.279c.01-.005.019-.012.026-.021s.011-.02.013-.031v.1a.06.06 0 0 1-.013.031.067.067 0 0 1-.026.021l-.524.278-.002-.099z"
            fill="#8C8C8C"
        />
        <path
            d="M409.58 630.45a.06.06 0 0 0 .012.031.064.064 0 0 0 .025.021l.5.312a.195.195 0 0 0 .177.007v.1a.206.206 0 0 1-.177 0l-.5-.315a.061.061 0 0 1-.024-.021.056.056 0 0 1-.012-.03l-.001-.105z"
            fill="#ADADAD"
        />
        <path
            d="m409.38 631.31.525-.283a.055.055 0 0 0 .025-.02.067.067 0 0 0 .013-.03v.1a.065.065 0 0 1-.037.052l-.524.278-.002-.097z"
            fill="#8C8C8C"
        />
        <path
            d="M408.66 630.94c0 .011.004.022.01.031s.015.016.025.02l.5.315a.213.213 0 0 0 .178.007v.1a.2.2 0 0 1-.09.02.198.198 0 0 1-.089-.025l-.5-.313a.066.066 0 0 1-.026-.021.068.068 0 0 1-.011-.031l.003-.103z"
            fill="#ADADAD"
        />
        <path
            d="m413.92 629.91 1.438-.768c.024-.015.038-.032.038-.051v.1a.056.056 0 0 1-.012.03.071.071 0 0 1-.025.02l-1.44.77.001-.101z"
            fill="#8C8C8C"
        />
        <path
            d="M413.2 629.54c0 .02.011.037.034.051l.5.315a.205.205 0 0 0 .088.023c.03 0 .06-.006.088-.018v.1a.212.212 0 0 1-.178-.007l-.5-.312a.064.064 0 0 1-.034-.053l.002-.099z"
            fill="#ADADAD"
        />
        <path
            d="m413.01 630.4.523-.279c.01-.005.02-.011.027-.02s.012-.02.014-.031v.1a.054.054 0 0 1-.013.03.057.057 0 0 1-.026.02l-.526.281.001-.101z"
            fill="#8C8C8C"
        />
        <path
            d="M412.29 630.03a.055.055 0 0 0 .011.03.059.059 0 0 0 .024.02l.5.315a.185.185 0 0 0 .089.024.187.187 0 0 0 .09-.019l-.005.1a.19.19 0 0 1-.088.018.177.177 0 0 1-.087-.026l-.5-.312a.075.075 0 0 1-.026-.021.068.068 0 0 1-.011-.031l.003-.098z"
            fill="#ADADAD"
        />
        <path
            d="m412.09 630.88.524-.278a.079.079 0 0 0 .027-.021.066.066 0 0 0 .012-.032v.1a.06.06 0 0 1-.039.051l-.524.279v-.099z"
            fill="#8C8C8C"
        />
        <path
            d="M411.38 630.52c.001.011.005.022.011.031s.014.017.024.023l.5.312a.207.207 0 0 0 .088.024.21.21 0 0 0 .089-.019v.1a.197.197 0 0 1-.178 0l-.5-.315a.067.067 0 0 1-.034-.054v-.102z"
            fill="#ADADAD"
        />
        <path
            d="m411.18 631.38.525-.283a.074.074 0 0 0 .027-.019.07.07 0 0 0 .012-.031v.1c0 .019-.014.036-.039.05l-.524.279-.001-.096z"
            fill="#8C8C8C"
        />
        <path
            d="M410.47 631c0 .011.003.022.009.031.006.01.014.017.024.023l.5.311a.19.19 0 0 0 .087.024.196.196 0 0 0 .089-.016v.1c-.027.014-.057.022-.088.022s-.061-.008-.088-.022l-.5-.314a.061.061 0 0 1-.034-.051l.001-.108z"
            fill="#ADADAD"
        />
        <path
            d="m407.58 631.25.527-.28a.055.055 0 0 0 .025-.02.056.056 0 0 0 .012-.03v.1a.06.06 0 0 1-.04.051l-.523.28-.001-.101z"
            fill="#8C8C8C"
        />
        <path
            d="M406.87 630.88c0 .011.004.022.01.032a.067.067 0 0 0 .025.022l.5.313a.19.19 0 0 0 .175 0v.1c-.027.013-.058.019-.088.018s-.06-.009-.087-.023l-.5-.317c-.009-.004-.018-.011-.024-.019s-.009-.018-.01-.028l-.001-.098z"
            fill="#ADADAD"
        />
        <path
            d="m408.46 631.8.522-.28a.06.06 0 0 0 .04-.05v.1a.06.06 0 0 1-.013.029.06.06 0 0 1-.026.019l-.524.284.001-.102z"
            fill="#8C8C8C"
        />
        <path
            d="M407.75 631.43a.067.067 0 0 0 .033.052l.5.314a.198.198 0 0 0 .179 0v.1a.212.212 0 0 1-.178-.006l-.5-.315c-.01-.005-.018-.012-.024-.021s-.01-.02-.011-.03l.001-.094z"
            fill="#ADADAD"
        />
        <path
            d="m410.26 631.87.522-.282c.01-.004.02-.01.027-.019s.012-.02.013-.031v.1c-.002.011-.006.021-.013.03s-.016.016-.026.02l-.524.28.001-.098z"
            fill="#8C8C8C"
        />
        <path
            d="M409.55 631.49a.067.067 0 0 0 .036.052l.5.315a.215.215 0 0 0 .179.005v.1a.199.199 0 0 1-.178-.006l-.5-.313c-.01-.005-.019-.012-.025-.021s-.01-.019-.01-.03l-.002-.102z"
            fill="#ADADAD"
        />
        <path
            d="m409.35 632.36.523-.28a.082.082 0 0 0 .025-.02.079.079 0 0 0 .012-.03v.1a.067.067 0 0 1-.013.03.07.07 0 0 1-.027.019l-.523.283.003-.102z"
            fill="#8C8C8C"
        />
        <path
            d="M408.64 631.98c0 .017.01.035.033.049l.5.315a.198.198 0 0 0 .18.007l-.005.1a.206.206 0 0 1-.091.018.208.208 0 0 1-.088-.025l-.5-.314a.061.061 0 0 1-.024-.021.062.062 0 0 1-.009-.03l.004-.099z"
            fill="#ADADAD"
        />
        <path
            d="m413.85 630.93 2.351-1.259a.07.07 0 0 0 .026-.019.067.067 0 0 0 .013-.03v.1a.079.079 0 0 1-.012.03.072.072 0 0 1-.025.021l-2.351 1.259-.002-.102z"
            fill="#8C8C8C"
        />
        <path
            d="M413.14 630.55a.06.06 0 0 0 .035.055l.5.312a.205.205 0 0 0 .177.005v.1a.203.203 0 0 1-.179-.006l-.5-.313a.067.067 0 0 1-.025-.022.065.065 0 0 1-.008-.031v-.1z"
            fill="#ADADAD"
        />
        <path
            d="m412.94 631.41.523-.278c.01-.005.019-.012.026-.021s.011-.02.013-.031v.1a.06.06 0 0 1-.039.051l-.523.281v-.102z"
            fill="#8C8C8C"
        />
        <path
            d="M412.22 631.04a.063.063 0 0 0 .034.052l.5.314a.184.184 0 0 0 .177.005l-.005.1a.195.195 0 0 1-.176-.005l-.5-.315c-.01-.005-.018-.013-.024-.022s-.01-.019-.011-.03l.005-.099z"
            fill="#ADADAD"
        />
        <path
            d="m412.02 631.9.523-.281a.066.066 0 0 0 .027-.019.052.052 0 0 0 .012-.031v.1a.079.079 0 0 1-.012.03.088.088 0 0 1-.025.022l-.525.279v-.1z"
            fill="#8C8C8C"
        />
        <path
            d="M411.31 631.53a.055.055 0 0 0 .011.03.071.071 0 0 0 .025.02l.5.315a.208.208 0 0 0 .089.021c.03 0 .061-.008.089-.021v.1a.205.205 0 0 1-.178-.006l-.5-.314a.054.054 0 0 1-.025-.022.056.056 0 0 1-.009-.031l-.002-.092z"
            fill="#ADADAD"
        />
        <path
            d="m411.11 632.39.525-.282a.073.073 0 0 0 .026-.02.057.057 0 0 0 .01-.03v.1a.056.056 0 0 1-.012.03.052.052 0 0 1-.026.02l-.523.28v-.098z"
            fill="#8C8C8C"
        />
        <path
            d="M410.39 632.02a.061.061 0 0 0 .034.054l.5.313a.205.205 0 0 0 .177.006v.099a.188.188 0 0 1-.178-.005l-.5-.314a.075.075 0 0 1-.026-.021.054.054 0 0 1-.01-.03l.003-.102z"
            fill="#ADADAD"
        />
        <path
            d="m410.2 632.88.523-.279c.027-.015.039-.032.039-.05v.1a.06.06 0 0 1-.013.029.075.075 0 0 1-.026.021l-.523.28v-.101z"
            fill="#8C8C8C"
        />
        <path
            d="M409.48 632.51a.068.068 0 0 0 .011.031c.006.01.014.018.024.023l.5.311a.205.205 0 0 0 .176.006v.1a.208.208 0 0 1-.089.021.215.215 0 0 1-.089-.021l-.5-.316c-.01-.004-.018-.011-.024-.02s-.009-.019-.01-.03l.001-.105z"
            fill="#ADADAD"
        />
        <path
            d="m406.67 631.74.525-.28a.064.064 0 0 0 .025-.021.056.056 0 0 0 .012-.03v.1a.067.067 0 0 1-.038.05l-.525.279.001-.098z"
            fill="#8C8C8C"
        />
        <path
            d="M405.96 631.37c0 .012.004.023.011.033.006.01.015.018.026.023l.5.313a.191.191 0 0 0 .088.022.19.19 0 0 0 .087-.022v.1a.199.199 0 0 1-.178-.005l-.5-.313c-.01-.006-.018-.013-.024-.022s-.01-.019-.011-.03l.001-.099z"
            fill="#ADADAD"
        />
        <path
            d="m407.55 632.28.525-.28c.024-.014.039-.031.039-.051v.1c-.002.011-.007.022-.014.031s-.017.016-.027.021l-.525.28.002-.101z"
            fill="#8C8C8C"
        />
        <path
            d="M406.83 631.92a.068.068 0 0 0 .011.031.078.078 0 0 0 .026.022l.5.314a.205.205 0 0 0 .176.006v.1a.195.195 0 0 1-.176-.006l-.5-.314a.073.073 0 0 1-.024-.022.061.061 0 0 1-.011-.031l-.002-.1z"
            fill="#ADADAD"
        />
        <path
            d="m408.44 632.84.525-.279a.075.075 0 0 0 .026-.021.079.079 0 0 0 .012-.03v.1c-.001.011-.005.021-.012.03s-.016.015-.026.019l-.523.283-.002-.102z"
            fill="#8C8C8C"
        />
        <path
            d="M407.72 632.47a.068.068 0 0 0 .035.052l.5.314a.205.205 0 0 0 .177.005v.1a.197.197 0 0 1-.09.016.193.193 0 0 1-.087-.024l-.5-.314a.064.064 0 0 1-.025-.021.06.06 0 0 1-.01-.031v-.097z"
            fill="#ADADAD"
        />
        <path
            d="m409.28 633.37.525-.279a.06.06 0 0 0 .039-.05v.1a.064.064 0 0 1-.011.03.07.07 0 0 1-.027.021l-.525.28-.001-.102z"
            fill="#8C8C8C"
        />
        <path
            d="M408.57 633c.001.01.004.021.01.031a.08.08 0 0 0 .023.022l.5.313a.192.192 0 0 0 .088.023.19.19 0 0 0 .088-.018v.1a.203.203 0 0 1-.177 0l-.5-.314a.072.072 0 0 1-.023-.023.067.067 0 0 1-.01-.03l.001-.104z"
            fill="#ADADAD"
        />
        <path
            d="m416.51 630.47.525-.28a.067.067 0 0 0 .038-.05v.1a.066.066 0 0 1-.012.03.082.082 0 0 1-.025.02l-.523.282-.003-.102z"
            fill="#8C8C8C"
        />
        <path
            d="M415.79 630.09a.084.084 0 0 0 .012.031.07.07 0 0 0 .025.023l.5.313a.199.199 0 0 0 .178.006v.1a.198.198 0 0 1-.179-.008l-.5-.313a.072.072 0 0 1-.025-.021.07.07 0 0 1-.01-.031l-.001-.1z"
            fill="#ADADAD"
        />
        <path
            d="m415.59 630.95.525-.278c.01-.004.02-.01.027-.019a.07.07 0 0 0 .012-.031v.1c-.002.011-.006.021-.013.03s-.016.016-.026.02l-.525.281v-.103z"
            fill="#8C8C8C"
        />
        <path
            d="M414.88 630.58a.059.059 0 0 0 .034.053l.5.314a.18.18 0 0 0 .176 0v.1a.197.197 0 0 1-.177-.006l-.5-.315c-.01-.005-.019-.012-.025-.021s-.01-.02-.011-.031l.003-.094z"
            fill="#ADADAD"
        />
        <path
            d="m414.68 631.44.523-.28a.064.064 0 0 0 .025-.021.06.06 0 0 0 .012-.031v.1a.069.069 0 0 1-.04.05l-.523.28.003-.098z"
            fill="#8C8C8C"
        />
        <path
            d="M413.97 631.07a.061.061 0 0 0 .034.051l.5.314a.208.208 0 0 0 .088.025.2.2 0 0 0 .09-.019v.1a.199.199 0 0 1-.178-.007l-.5-.313a.056.056 0 0 1-.024-.022.054.054 0 0 1-.01-.03v-.099z"
            fill="#ADADAD"
        />
        <path
            d="m410.11 633.89 4.181-2.235a.064.064 0 0 0 .025-.021.06.06 0 0 0 .012-.03v.1a.066.066 0 0 1-.012.032.074.074 0 0 1-.028.021l-4.179 2.235.001-.102z"
            fill="#8C8C8C"
        />
        <path
            d="M409.4 633.52c0 .011.003.021.009.031a.061.061 0 0 0 .024.021l.5.314c.028.014.058.022.089.023s.061-.005.089-.018v.1a.22.22 0 0 1-.088.018.205.205 0 0 1-.088-.023l-.5-.314c-.025-.016-.036-.033-.034-.054l-.001-.098z"
            fill="#ADADAD"
        />
        <path
            d="m405.76 632.23.525-.279a.07.07 0 0 0 .026-.019.069.069 0 0 0 .014-.03v.1a.071.071 0 0 1-.013.031.086.086 0 0 1-.026.02l-.522.279-.004-.102z"
            fill="#8C8C8C"
        />
        <path
            d="M405.04 631.86a.055.055 0 0 0 .011.03.055.055 0 0 0 .025.02l.5.315a.195.195 0 0 0 .176.005v.1a.201.201 0 0 1-.18-.005l-.5-.313a.064.064 0 0 1-.034-.053l.002-.099z"
            fill="#ADADAD"
        />
        <path
            d="m404.84 632.72.523-.281c.01-.005.019-.011.026-.02s.012-.02.013-.031v.1a.06.06 0 0 1-.039.051l-.524.28.001-.099z"
            fill="#8C8C8C"
        />
        <path
            d="M404.13 632.35a.067.067 0 0 0 .036.053l.5.312a.206.206 0 0 0 .176.008v.1a.199.199 0 0 1-.178-.005l-.5-.314a.064.064 0 0 1-.034-.051v-.103z"
            fill="#ADADAD"
        />
        <path
            d="m403.02 633.7 1.439-.769a.058.058 0 0 0 .026-.021.06.06 0 0 0 .012-.031v.1a.054.054 0 0 1-.013.03.055.055 0 0 1-.026.019l-1.438.77v-.098z"
            fill="#8C8C8C"
        />
        <path
            d="M402.3 633.32a.05.05 0 0 0 .01.031c.006.01.015.017.025.022l.5.315a.19.19 0 0 0 .175 0v.1a.199.199 0 0 1-.09.018.208.208 0 0 1-.087-.025l-.5-.311a.066.066 0 0 1-.033-.055v-.095z"
            fill="#ADADAD"
        />
        <path
            d="m406.64 632.78.523-.281a.063.063 0 0 0 .026-.02.053.053 0 0 0 .012-.03v.1c0 .019-.013.035-.038.05l-.523.281v-.1z"
            fill="#8C8C8C"
        />
        <path
            d="M405.92 632.41c0 .011.004.021.01.03s.015.016.025.021l.5.314a.197.197 0 0 0 .179.006v.1a.214.214 0 0 1-.18-.006l-.5-.313a.067.067 0 0 1-.025-.022.072.072 0 0 1-.008-.032l-.001-.098z"
            fill="#ADADAD"
        />
        <path
            d="m405.72 633.27.523-.28a.057.057 0 0 0 .026-.02.071.071 0 0 0 .013-.031v.1a.074.074 0 0 1-.012.029.072.072 0 0 1-.025.021l-.525.28v-.099z"
            fill="#8C8C8C"
        />
        <path
            d="M405.01 632.9c.001.01.004.02.01.029a.069.069 0 0 0 .022.023l.5.315a.205.205 0 0 0 .178.005v.1a.193.193 0 0 1-.176 0l-.5-.314a.062.062 0 0 1-.026-.022.048.048 0 0 1-.008-.031v-.105z"
            fill="#ADADAD"
        />
        <path
            d="m404.81 633.76.523-.282a.064.064 0 0 0 .041-.049l-.006.1a.079.079 0 0 1-.012.03.072.072 0 0 1-.025.021l-.523.281.002-.101z"
            fill="#8C8C8C"
        />
        <path
            d="M404.1 633.38a.067.067 0 0 0 .033.052l.5.311c.027.015.057.023.088.024s.062-.005.09-.017v.1a.205.205 0 0 1-.178-.005l-.5-.314a.075.075 0 0 1-.025-.022.064.064 0 0 1-.011-.03l.003-.099z"
            fill="#ADADAD"
        />
        <path
            d="m403.9 634.24.524-.281a.063.063 0 0 0 .026-.02.064.064 0 0 0 .011-.03v.1a.072.072 0 0 1-.013.03.082.082 0 0 1-.025.02l-.525.28.002-.099z"
            fill="#8C8C8C"
        />
        <path
            d="M403.18 633.87c0 .02.008.036.033.052l.5.312c.026.015.056.024.087.025s.062-.005.09-.018v.1a.197.197 0 0 1-.176-.006l-.5-.313a.064.064 0 0 1-.025-.021.05.05 0 0 1-.009-.029v-.102z"
            fill="#ADADAD"
        />
        <path
            d="m407.52 633.33.523-.281a.066.066 0 0 0 .027-.019.06.06 0 0 0 .012-.031v.1c0 .018-.012.036-.039.05l-.522.282-.001-.101z"
            fill="#8C8C8C"
        />
        <path
            d="M406.81 632.96a.061.061 0 0 0 .034.051l.5.313a.187.187 0 0 0 .178.007v.1a.192.192 0 0 1-.091.017.18.18 0 0 1-.088-.026l-.5-.313c-.01-.004-.019-.011-.025-.02s-.01-.019-.01-.03l.002-.099z"
            fill="#ADADAD"
        />
        <path
            d="m406.61 633.82.525-.28a.064.064 0 0 0 .039-.053v.1c-.001.011-.005.022-.012.031s-.016.016-.027.021l-.523.278-.002-.097z"
            fill="#8C8C8C"
        />
        <path
            d="M405.89 633.45a.063.063 0 0 0 .01.03c.006.01.014.017.024.022l.5.314a.205.205 0 0 0 .176.006v.1a.194.194 0 0 1-.176-.008l-.5-.311c-.024-.016-.038-.035-.034-.054v-.099z"
            fill="#ADADAD"
        />
        <path
            d="m404.78 634.8 1.438-.771a.05.05 0 0 0 .026-.018.058.058 0 0 0 .013-.03v.1c-.001.012-.006.023-.013.032s-.017.016-.028.02l-1.435.769-.001-.102z"
            fill="#8C8C8C"
        />
        <path
            d="M404.07 634.43a.067.067 0 0 0 .01.031c.005.01.014.017.023.023l.5.312a.222.222 0 0 0 .088.024c.03.001.06-.005.088-.017v.1a.199.199 0 0 1-.179-.006l-.5-.315a.063.063 0 0 1-.034-.052l.004-.1z"
            fill="#ADADAD"
        />
        <path
            d="m408.37 633.86.525-.281a.052.052 0 0 0 .026-.02.051.051 0 0 0 .011-.031v.1c0 .02-.014.037-.039.052l-.523.281v-.101z"
            fill="#8C8C8C"
        />
        <path
            d="M407.65 633.48a.058.058 0 0 0 .011.031.064.064 0 0 0 .024.022l.5.314a.209.209 0 0 0 .178.005v.1c-.028.012-.058.018-.089.017s-.061-.009-.088-.024l-.5-.311a.075.075 0 0 1-.024-.023.068.068 0 0 1-.011-.031l-.001-.1z"
            fill="#ADADAD"
        />
        <path
            d="m407.46 634.35.522-.279a.064.064 0 0 0 .027-.022.06.06 0 0 0 .012-.031v.1c-.001.01-.006.021-.012.03s-.015.016-.025.021l-.526.281.002-.1z"
            fill="#8C8C8C"
        />
        <path
            d="M406.74 633.98c.001.01.005.021.011.03s.014.016.024.021l.5.316c.028.013.059.021.09.021s.061-.008.089-.021v.1a.195.195 0 0 1-.089.019.209.209 0 0 1-.088-.026l-.5-.312a.059.059 0 0 1-.024-.023.057.057 0 0 1-.01-.031l-.003-.094z"
            fill="#ADADAD"
        />
        <path
            d="m405.62 635.33 1.44-.768a.063.063 0 0 0 .026-.02.066.066 0 0 0 .012-.03v.1c0 .021-.014.035-.037.051l-1.44.767-.001-.1z"
            fill="#8C8C8C"
        />
        <path
            d="M404.91 634.96a.056.056 0 0 0 .012.03.064.064 0 0 0 .024.022l.5.313a.194.194 0 0 0 .177 0v.1a.193.193 0 0 1-.177 0l-.5-.313c-.023-.017-.036-.034-.034-.053l-.002-.099z"
            fill="#ADADAD"
        />
        <path
            d="m409.2 634.38.525-.279a.06.06 0 0 0 .039-.051v.1a.07.07 0 0 1-.039.05l-.522.281-.003-.101z"
            fill="#8C8C8C"
        />
        <path
            d="M408.48 634.01a.066.066 0 0 0 .012.03.078.078 0 0 0 .024.02l.5.314a.198.198 0 0 0 .088.022.191.191 0 0 0 .088-.022v.1a.208.208 0 0 1-.178-.005l-.5-.316c-.009-.005-.018-.012-.024-.021s-.009-.019-.01-.03v-.092z"
            fill="#ADADAD"
        />
        <path
            d="m408.28 634.87.525-.279c.011-.005.021-.012.028-.021s.011-.021.012-.032v.105c-.002.011-.006.021-.013.03s-.016.015-.027.02l-.523.28-.002-.103z"
            fill="#8C8C8C"
        />
        <path
            d="M407.57 634.5c0 .011.003.022.009.031.006.01.014.018.025.023l.5.313a.185.185 0 0 0 .175.005v.1a.22.22 0 0 1-.091.017.216.216 0 0 1-.089-.025l-.5-.311a.067.067 0 0 1-.025-.022.066.066 0 0 1-.012-.032l.008-.099z"
            fill="#ADADAD"
        />
        <path
            d="M407.61 634.44c-.05.027-.053.074-.006.1l.5.313a.186.186 0 0 0 .175.005l.525-.279c.052-.026.054-.074.006-.1l-.5-.315a.182.182 0 0 0-.088-.022.18.18 0 0 0-.088.022l-.524.276z"
            fill="#EAEAEA"
        />
        <path
            d="m406.45 635.85 1.44-.769a.072.072 0 0 0 .025-.021.079.079 0 0 0 .012-.03v.1a.07.07 0 0 1-.012.031.078.078 0 0 1-.026.022l-1.439.767v-.1z"
            fill="#8C8C8C"
        />
        <path
            d="M405.74 635.47a.068.068 0 0 0 .011.031c.006.01.015.017.025.022l.5.314a.205.205 0 0 0 .177.006v.1a.191.191 0 0 1-.176-.006l-.5-.313c-.009-.005-.018-.012-.024-.021s-.01-.02-.011-.03l-.002-.103z"
            fill="#ADADAD"
        />
        <path
            d="m392.37 634.97-.013 4.146a.987.987 0 0 1-.575.807 3.104 3.104 0 0 1-2.81 0 .995.995 0 0 1-.586-.819l.012-4.145a.996.996 0 0 0 .587.82 3.1 3.1 0 0 0 2.808 0 .987.987 0 0 0 .577-.809z"
            fill="#C40505"
        />
        <path
            d="M391.78 634.15a.858.858 0 0 1 .01 1.626 3.1 3.1 0 0 1-2.808 0 .86.86 0 0 1-.009-1.626 3.076 3.076 0 0 1 2.807 0z"
            fill="#E50505"
        />
        <path
            d="M391.67 634.22c.718.391.721 1.023.01 1.415a3 3 0 0 1-1.294.292 3 3 0 0 1-1.294-.292c-.717-.392-.719-1.024-.006-1.415a2.98 2.98 0 0 1 2.584 0z"
            fill="#8C0303"
        />
        <path
            d="m393 638.58-.734-.423a2.83 2.83 0 0 1-.276.173 1.74 1.74 0 0 1-.234.123l.733.424a.121.121 0 0 0 .119.012l.512-.3a.128.128 0 0 1-.061.012.12.12 0 0 1-.059-.021z"
            fill="#8C0202"
        />
        <path
            d="m393.07 636.58-.8-.461c-.07.07-.15.129-.237.176-.088.049-.18.09-.275.122l.8.462a.74.74 0 0 1 .333.579l-.005 1.527a.232.232 0 0 1-.1.215l.513-.3a.243.243 0 0 0 .08-.094.24.24 0 0 0 .02-.121v-1.528a.739.739 0 0 0-.329-.577z"
            fill="#AF0202"
        />
        <path
            d="M392.56 636.88a.74.74 0 0 1 .333.579l-.005 1.527c0 .212-.15.3-.336.193l-.8-.463v-.268l.733.424c.093.052.167.012.167-.1v-1.379a.364.364 0 0 0-.168-.289l-.732-.423v-.268l.808.467z"
            fill="#E50505"
        />
        <path
            d="M391.67 635a2.993 2.993 0 0 0-2.584 0c-.15.076-.283.184-.39.316.11.134.246.244.4.323a3.021 3.021 0 0 0 2.588 0c.15-.079.283-.187.389-.319a1.349 1.349 0 0 0-.403-.32z"
            fill="#351A0A"
        />
        <path
            d="M391.67 635.64c.067-.036.131-.077.191-.123a.476.476 0 0 0-.207-.269 2.095 2.095 0 0 0-.951-.317.65.65 0 0 1 .4.533.616.616 0 0 1-.117.413c.239-.045.469-.125.684-.237z"
            fill="#683315"
        />
        <path
            d="M419.88 622.58a4.275 4.275 0 0 0-2.131-.609l-2.016 1.173c.75.012 1.485.222 2.129.609a8.264 8.264 0 0 1 1.743 1.426.722.722 0 0 0 .881.135l.9-.523a.551.551 0 0 0 .166-.153.555.555 0 0 0 .099-.431.56.56 0 0 0-.083-.209 7.825 7.825 0 0 0-1.688-1.418z"
            fill="#C1C1C1"
        />
        <path
            d="M417.86 623.76a9.085 9.085 0 0 1 2.128 1.85l-.043.015c-.11.044-.34-.073-.547-.191-.108-.064-.21-.126-.284-.172l-2.509-1.447c-.074-.045-.178-.1-.284-.16a1.644 1.644 0 0 1-.547-.439l-.043-.065c.75.012 1.485.222 2.129.609z"
            fill="#999"
        />
        <path
            d="M415.74 622.86a.205.205 0 0 0-.084.081.205.205 0 0 0-.028.113.212.212 0 0 0 .128.185c.078.032.434.1.558.135.443.129.869.313 1.268.546a7.87 7.87 0 0 1 1.794 1.469.77.77 0 0 0 .487.258 1.161 1.161 0 0 0 .887-.221l.644-.4a.707.707 0 0 0 .335-.493.699.699 0 0 0-.166-.573 7.603 7.603 0 0 1-.581 1.141c-.433.253-.607.38-.9.38a.955.955 0 0 1-.652-.257 8.041 8.041 0 0 0-1.848-1.505 4.866 4.866 0 0 0-1.551-.592c-.119-.023-.293-.042-.315-.116a.204.204 0 0 1 .024-.151z"
            fill="#B5B5B5"
        />
        <path
            d="M421.46 623.84a7.929 7.929 0 0 0-1.723-1.373 4.618 4.618 0 0 0-1.787-.626 1.38 1.38 0 0 0-.816.207l-1.393.812a.127.127 0 0 0-.054.141.129.129 0 0 0 .115.097c.1.01.193.023.293.043.525.106 1.028.3 1.488.576a7.822 7.822 0 0 1 1.592 1.236c.051.051.115.123.186.2a.958.958 0 0 0 1.189.2l.074-.041.737-.429a.634.634 0 0 0 .294-.735.631.631 0 0 0-.138-.246c-.022-.021-.04-.045-.057-.062z"
            fill="#E0E0E0"
        />
        <path
            d="M416.8 622.86c.42.01.833.107 1.214.284.366.198.686.47.94.8a9.533 9.533 0 0 0-.986-.656 5.418 5.418 0 0 0-1.168-.428z"
            fill="#F2F2F2"
        />
        <path
            d="M432.65 657.66c.078.021.155.049.228.083a1.238 1.238 0 0 1 .769 1.272c-.075 1.11-2.815 2.073-2.815 2.073l-1.11.444 2.223 2.518c.269.66.419 1.362.444 2.074 0 1.037-.963 2.221-2.667 1.185-1.193-.726-5.111-2.74-5.111-2.74l-5.181 2.961s-2.074 1.186-2.371-1.11a6.024 6.024 0 0 1 .517-2.666l1.409-1.629s-4.74-2.59-6.811-3.035c-1.219-.263-1.779 2.295-3.705 2.592s-7.358-1.5-8.515-2.076c-1.483-.74-2.221-2.886-.075-3.035s7.924-3.036 7.924-3.036l5.111.445 5.553 1.406 5.509 4.1 7.005-2.395 1.669.569z"
            fill="#231F20"
            opacity={0.29}
            style={{ mixBlendMode: "multiply" }}
        />
        <path
            d="M416.52 653.24a2.89 2.89 0 0 1 .386 1.776c-.079 1.12-.244 1.548-.531 1.758a1.683 1.683 0 0 1-1.311.165 13.77 13.77 0 0 1-2.157-.868c-.407-.121-.291-.123-1.739-.58-2.038-.64-2.388-1.186-2.556-1.728a2.466 2.466 0 0 1 0-1.183c1.709.328 4 .884 4.656.2s3.252.46 3.252.46z"
            fill="#FAFCFC"
        />
        <path
            d="M416.7 652.64a2.88 2.88 0 0 1 .388 1.773c-.08 1.119-.247 1.547-.533 1.759-.449.255-.98.327-1.48.2a5.519 5.519 0 0 1-1.36-.458 11.484 11.484 0 0 0-2.166-.671c-1.762-.455-2.53-1.186-2.669-1.74-.12-.487.9-1.223 2.255-1.029 1.943.278 1.824-.173 2.314-.3a9.664 9.664 0 0 1 3.251.466z"
            fill="#0E2C3D"
        />
        <path
            d="m429.34 642.86-2.94-1.363-6.227-2.516c-1.563-.742-4.914-1.3-5.4 2.226l-2.51 11.6s-.446 1.792 2.151 1.924a4.826 4.826 0 0 0 2.644-.715l1.925-8.826s6.905 2.506 8.912 2.314c3.579-.336 1.445-4.644 1.445-4.644z"
            fill="#0A3075"
        />
        <path
            d="M430.72 664.56a2.065 2.065 0 0 1 .938 1.623c0 .594-.424.834-.944.533a2.057 2.057 0 0 1-.935-1.617c-.001-.597.421-.835.941-.539zm0 1.731c.315.18.568.034.569-.323a1.25 1.25 0 0 0-.565-.983c-.314-.179-.568-.036-.568.328a1.252 1.252 0 0 0 .557.978h.007z"
            fill="#4C4C4C"
        />
        <path
            d="M430.72 664.98c-.314-.179-.568-.036-.568.328a1.243 1.243 0 0 0 .564.978c.315.18.568.034.569-.323a1.237 1.237 0 0 0-.565-.983z"
            fill="#747474"
        />
        <path
            d="M430.83 664.04a.663.663 0 0 1 .668.069 2.048 2.048 0 0 1 .933 1.621.66.66 0 0 1-.275.6l-.778.453a.663.663 0 0 0 .274-.6 2.077 2.077 0 0 0-.938-1.623.671.671 0 0 0-.667-.064l.783-.456z"
            fill="#3B3B3B"
        />
        <path
            d="M417.02 656.66c.273.178.499.418.661.701.162.282.256.598.272.923 0 .593-.42.833-.939.534a2.064 2.064 0 0 1-.936-1.618c0-.599.42-.838.942-.54zm-.008 1.729c.316.183.568.037.57-.322a1.25 1.25 0 0 0-.564-.981c-.313-.181-.569-.038-.569.323a1.256 1.256 0 0 0 .563.98z"
            fill="#4C4C4C"
        />
        <path
            d="M417.02 657.08c-.313-.181-.569-.038-.569.323a1.256 1.256 0 0 0 .563.98c.316.183.568.037.57-.322a1.25 1.25 0 0 0-.564-.981z"
            fill="#747474"
        />
        <path
            d="M417.13 656.14a.662.662 0 0 1 .669.065 2.067 2.067 0 0 1 .932 1.622.656.656 0 0 1-.275.6l-.78.453a.654.654 0 0 0 .271-.6 2.077 2.077 0 0 0-.933-1.624.674.674 0 0 0-.668-.065l.784-.451z"
            fill="#3B3B3B"
        />
        <path
            d="M417.61 664.37a.66.66 0 0 1 .668-.067c.067.038.129.076.2.112.091.055.184.108.274.159s.206.12.312.184a.663.663 0 0 0-.667.064 1.5 1.5 0 0 0-.314.247l.314.179a1.246 1.246 0 0 0-.565.98.401.401 0 0 0 .167.365l-.526-.306a1.172 1.172 0 0 0-.013.156.67.67 0 0 0 .275.6l-.782-.456a.657.657 0 0 1-.274-.6 2.05 2.05 0 0 1 .931-1.617z"
            fill="#4C4C4C"
        />
        <path
            d="m418.79 665.21-.78-.455a.403.403 0 0 1 .165.364 1.243 1.243 0 0 1-.563.979l.78.453a1.23 1.23 0 0 0 .564-.978.388.388 0 0 0-.166-.363z"
            fill="#4C4C4C"
        />
        <path
            d="M418.39 664.82c.518-.3.939-.058.941.535a2.062 2.062 0 0 1-.936 1.623c-.518.3-.94.059-.942-.537.018-.325.112-.641.274-.923.163-.281.39-.52.663-.698zm0 1.73a1.23 1.23 0 0 0 .564-.978c0-.36-.256-.505-.569-.326a1.262 1.262 0 0 0-.565.98c.006.355.255.504.575.324h-.005z"
            fill="#3F3F3F"
        />
        <path
            d="M418.39 665.25c.313-.179.569-.034.569.326a1.242 1.242 0 0 1-.564.978c-.316.18-.569.036-.57-.324a1.257 1.257 0 0 1 .565-.98z"
            fill="#7B7B7B"
        />
        <path
            d="M431.3 656.46a.673.673 0 0 1 .668-.065c.062.037.129.074.2.113.086.053.18.109.271.159s.208.12.311.182a.68.68 0 0 0-.342-.057.683.683 0 0 0-.325.122 1.6 1.6 0 0 0-.309.246l.309.18a1.258 1.258 0 0 0-.563.981.401.401 0 0 0 .166.365l-.525-.306a1.16 1.16 0 0 0-.014.155.671.671 0 0 0 .276.6l-.782-.455a.648.648 0 0 1-.218-.263.65.65 0 0 1-.058-.337 2.071 2.071 0 0 1 .935-1.62z"
            fill="#4C4C4C"
        />
        <path
            d="M432.08 656.92c.519-.3.941-.058.945.536a2.073 2.073 0 0 1-.938 1.623c-.521.3-.941.058-.943-.538a2.065 2.065 0 0 1 .936-1.621zm.007 1.731a1.243 1.243 0 0 0 .564-.98c0-.358-.257-.505-.571-.325a1.278 1.278 0 0 0-.563.981c.001.362.256.505.57.324z"
            fill="#3F3F3F"
        />
        <path
            d="M432.08 657.34c.314-.18.57-.033.571.325a1.257 1.257 0 0 1-.564.98c-.314.181-.569.037-.57-.324a1.256 1.256 0 0 1 .563-.981z"
            fill="#7B7B7B"
        />
        <path
            d="m417.04 655.38 6.417 3.732.006 1.24-6.421-3.732a.455.455 0 0 1-.269-.378l-.007-1.241a.457.457 0 0 0 .274.379z"
            fill="#3E3E3E"
        />
        <path
            d="M432.56 655.38a.469.469 0 0 0 .277-.384v1.24a.462.462 0 0 1-.273.383l-6.463 3.732v-1.239l6.459-3.732z"
            fill="#303030"
        />
        <path
            d="M417.04 654.62a1.458 1.458 0 0 1 1.32 0l6.417 3.732v.261l-6.89-4a.412.412 0 0 0-.377 0 .114.114 0 0 0-.057.042c-.015.02-.022.044-.022.068s.007.048.022.068a.12.12 0 0 0 .057.042l6.887 4-.941.285-6.416-3.73a.4.4 0 0 1 0-.768z"
            fill="#414141"
        />
        <path
            d="M432.09 654.6a.411.411 0 0 0-.378 0l-6.935 4.005v-.261l6.465-3.733a1.458 1.458 0 0 1 1.319 0c.364.214.361.551-.006.765l-6.459 3.732-.945-.286 6.937-4a.12.12 0 0 0 .059-.042.12.12 0 0 0 .001-.137.114.114 0 0 0-.058-.043z"
            fill="#494949"
        />
        <path
            d="M417.51 654.6a.121.121 0 0 0-.058.042c-.014.02-.021.044-.021.068s.007.048.021.068a.128.128 0 0 0 .058.042l6.887 4-6.935 4.006a.112.112 0 0 0-.079.108.112.112 0 0 0 .079.109.4.4 0 0 0 .378 0l6.937-4 6.887 4a.4.4 0 0 0 .379 0 .112.112 0 0 0 .079-.109.112.112 0 0 0-.079-.108l-6.89-4.006 6.937-4a.118.118 0 0 0 .077-.11.118.118 0 0 0-.077-.11.417.417 0 0 0-.378 0l-6.935 4.005-6.89-4a.413.413 0 0 0-.377-.005z"
            fill="#303030"
        />
        <path
            d="M417 663.61a1.451 1.451 0 0 0 1.318 0l6.466-3.731v1.239l-6.464 3.732a1.457 1.457 0 0 1-1.319 0 .465.465 0 0 1-.271-.38v-1.239a.464.464 0 0 0 .27.379z"
            fill="#303030"
        />
        <path
            d="m416.99 662.84 6.462-3.729.941-.285-6.935 4.006a.114.114 0 0 0-.057.042c-.015.019-.022.043-.022.067s.007.047.022.067a.112.112 0 0 0 .057.041.4.4 0 0 0 .378 0l6.937-4v.83l-6.466 3.731a1.454 1.454 0 0 1-1.318 0 .402.402 0 0 1-.279-.385.405.405 0 0 1 .28-.385zM424.78 659.05l6.887 4a.42.42 0 0 0 .379 0 .114.114 0 0 0 .057-.042c.015-.019.022-.043.022-.067s-.007-.047-.022-.067a.112.112 0 0 0-.057-.041l-6.89-4.006.945.286 6.417 3.728a.403.403 0 0 1 .199.621.406.406 0 0 1-.199.149 1.462 1.462 0 0 1-1.319 0l-6.418-3.731-.001-.83z"
            fill="#4C4C4C"
        />
        <path
            d="M431.2 663.61a1.47 1.47 0 0 0 1.319 0 .472.472 0 0 0 .276-.386v1.239a.466.466 0 0 1-.274.384 1.451 1.451 0 0 1-1.319 0l-6.419-3.731v-1.239l6.417 3.733z"
            fill="#3E3E3E"
        />
        <path
            d="M423.62 655.77a.577.577 0 0 1 .331-.47 1.795 1.795 0 0 1 1.638-.014.58.58 0 0 1 .352.478l.008 3.237a.422.422 0 0 1-.01.07.502.502 0 0 0-.008.054.431.431 0 0 1-.038.074c-.009.018-.013.032-.023.05s-.044.052-.068.077a.272.272 0 0 1-.037.039.812.812 0 0 1-.145.1 1.8 1.8 0 0 1-1.637.019.958.958 0 0 1-.153-.1 1.33 1.33 0 0 1-.11-.117c-.012-.017-.018-.035-.028-.049a.673.673 0 0 1-.038-.076.126.126 0 0 1-.011-.057.454.454 0 0 1-.013-.072c-.002-.978-.008-2.273-.01-3.243z"
            fill="#303030"
        />
        <path
            d="M424.36 652.91a.928.928 0 0 1 .833-.008.295.295 0 0 1 .123.098.286.286 0 0 1 .057.146l.006 2.42a.186.186 0 0 1-.006.034v.019a.355.355 0 0 1-.021.044.102.102 0 0 1-.013.028.21.21 0 0 1-.031.036.364.364 0 0 1-.093.077.941.941 0 0 1-.835.01.521.521 0 0 1-.132-.114c-.006-.009-.009-.018-.015-.029a.106.106 0 0 1-.018-.035.072.072 0 0 1-.006-.029.099.099 0 0 1-.007-.038v-2.418a.289.289 0 0 1 .158-.241z"
            fill="#829DA8"
        />
        <path
            d="M417.96 651.21a.425.425 0 0 0 .047-.048c.035-.033.072-.069.112-.1.015-.01.027-.024.045-.037.049-.04.102-.077.158-.108l2.875-1.66-.284-.166-2.875 1.662a1.413 1.413 0 0 0-.158.107l-.047.041a1.566 1.566 0 0 0-.258.268c-.01.015-.026.03-.036.043l-.009.009a1.625 1.625 0 0 0-.123.183l-1.515 2.489.281.164 1.517-2.486c.042-.07.086-.133.131-.2.01-.013.025-.026.033-.037.034-.039.067-.083.106-.124zM415.99 654.07l-.283-.165a.177.177 0 0 1 .17-.016l.281.163a.171.171 0 0 0-.168.018z"
            fill="#4C4C4C"
        />
        <path
            d="M415.88 653.88a.177.177 0 0 0-.17.016l-1.326.768a.342.342 0 0 0-.061.047l-.017.013a.604.604 0 0 0-.048.053l-.006.006v.005a.735.735 0 0 0-.039.058l-.007.018c-.009.015-.016.032-.025.05v.017l-.016.054a.081.081 0 0 1 0 .022.335.335 0 0 0-.007.071c-.003.03.002.06.013.087a.183.183 0 0 0 .054.069l.285.162a.17.17 0 0 1-.057-.068.177.177 0 0 1-.013-.088.39.39 0 0 1 .012-.093c0-.013.009-.031.015-.047l.008-.025a.388.388 0 0 1 .022-.046l.009-.018a.511.511 0 0 1 .041-.062l.007-.01a.357.357 0 0 1 .056-.062.55.55 0 0 1 .069-.05l1.325-.766a.171.171 0 0 1 .168-.018l-.292-.163z"
            fill="#6B6B6B"
        />
        <path
            d="M421.19 649.25v.192l-2.875 1.66a1.545 1.545 0 0 0-.523.537l-1.563 2.564a.523.523 0 0 1-.237.416l-1.327.766c-.132.074-.239.014-.239-.141a.514.514 0 0 1 .07-.235.514.514 0 0 1 .169-.178l1.325-.766a.16.16 0 0 1 .084-.032.162.162 0 0 1 .089.017l1.517-2.486c.155-.267.373-.491.635-.654l2.875-1.66z"
            fill="#2A2A2A"
        />
        <path
            d="M408.64 656.83c.338.475.513 1.046.5 1.628.013 1.049-.112 1.465-.358 1.682a2.042 2.042 0 0 1-1.385.616 12.554 12.554 0 0 1-1.826-.322 20.19 20.19 0 0 1-2.07-.351 5.101 5.101 0 0 1-3.342-2.163 2.34 2.34 0 0 1 .079-1.31c1.621.18 4.781.728 5.333.036s3.069.184 3.069.184z"
            fill="#FAFCFC"
        />
        <path
            d="M408.77 656.25a2.71 2.71 0 0 1 .5 1.628c.01 1.052-.112 1.464-.364 1.682a2 2 0 0 1-1.382.616 12.396 12.396 0 0 1-1.824-.323c-.77.03-1.54-.033-2.294-.187a5.58 5.58 0 0 1-3.095-2c-.149-.446-.553-1.658 1.066-1.478s3.768.57 4.323-.122 3.07.184 3.07.184z"
            fill="#0E2C3D"
        />
        <path
            d="m412.17 643.32-2.747 1.369c-1.255 2.728-3.38 7.623-4.868 10.818-.156.33 1.428 2.738 3.4 2.508.983-.116 1.58-.213 1.522-.538l.399-1.476L414 645.416l-1.83-2.096z"
            fill="#174C99"
        />
        <path
            d="m416.47 646.62 8.241-4.761a.693.693 0 0 1 .693-.068l8.205 4.727a.703.703 0 0 0-.7.07l-8.241 4.757a2.132 2.132 0 0 0-.97 1.68.693.693 0 0 0 .283.627c-2.024-1.175-6.181-3.551-8.2-4.726a.68.68 0 0 1-.284-.624 2.138 2.138 0 0 1 .973-1.682z"
            fill="#183447"
        />
        <path
            d="M424.67 651.35a2.132 2.132 0 0 0-.97 1.68c0 .622.438.871.973.561l8.244-4.763a2.124 2.124 0 0 0 .973-1.679c0-.62-.436-.868-.979-.556l-8.241 4.757z"
            fill="#2F5B68"
        />
        <path
            d="M429.96 648.37c1.534-1.192 1.638-4.737 1.638-4.737l-.854-6.565-6.565 3.409-2.135 3.242-8.762-1.435c-2.089-.641-3.444.361-4.205 3.317l1.541 1.615s1.764 2.295 2.384.789c.36-.867.957-.687.957-.687s6.222 1.638 8.838 2.334c4.042 1.072 5.698-.141 7.163-1.282z"
            fill="#174C99"
        />
        <path
            d="M419.08 631.61s-2.578-.891-3.057-1.031a6.609 6.609 0 0 0-2.853.369l-1.239.911s-.174.217.218.349 1.079-.525 1.079-.525l1.214-.208s.758.06.746.427c-.01.278-.68.348-.963.364-.2.011-.641.094-.74.284a.323.323 0 0 0 .1.437c.357.042.717.04 1.073-.007.736-.046 1.277-.016 1.7-.045.362-.033.703-.185.97-.431l1.275.489.477-1.383z"
            fill="#E5B28C"
        />
        <path
            d="M428.73 626s2.15.538 2.15 3.493c0 .558-3.023 1.513-3.922 2.751 0 0-.931 3.077-3.136 3.494-1.659.312-7.473-2.38-7.473-2.38a3.056 3.056 0 0 1 .145-2.06.765.765 0 0 1 .9-.491l5.265.764L428.73 626z"
            fill="#069382"
        />
        <path
            d="m429.03 630.26-1.335-.968-1.171.512 1.3.966 1.206-.51z"
            fill="#995710"
        />
        <path
            d="m424.61 616.52-2.537.26.935 6.531c.233 1.874 1.044 2.108 1.615 2.077a6.833 6.833 0 0 0 3.094-1.248c1.236-.839 1.07-3.039 1.07-3.218l.134-4.407-4.311.005z"
            fill="#E5B28C"
        />
        <path
            d="M430.09 626.17a10.857 10.857 0 0 1-1.012-1.553 17.057 17.057 0 0 1-.375-2.908l-3.312.706s.293 2.191.467 2.922c.11.454.669 1.825.669 1.825-.007.543-2.939 4.258-2.974 5.943l6.269-1.885c.016-.718.268-5.05.268-5.05z"
            fill="#E5B28C"
        />
        <path
            d="M422.11 615.88c-.256.048.312.284.271.339-.566.748-.9.768-1.105.726-.114-.021.779 1.5 1.083 1.55.571.1 1.583 1.914 1.71 2.643a.548.548 0 0 1 .076-.484c.174-.223.689-.329 1.258 1.048 0 0 .611 1.12 1.513 1.183a1.365 1.365 0 0 1 1.4.929s-.019-.466.2-.6c.185-.111.395.022.375.1.255-.776.597-1.521 1.019-2.221 1.687-3.009.522-5.077-.148-5.634-.309-.256-.967-1.311-4.53-.775a3.311 3.311 0 0 1-1.931-.161c.08.24.242.443.458.575.122.086-.782.259-1.23.112-.136-.046.28.417.354.446.184.074-.773.224-.773.224z"
            fill="#492607"
        />
        <path
            d="M424.15 619.95a.945.945 0 0 1 .722.688 1.086 1.086 0 0 1-.092.9.977.977 0 0 1-.458.356s-.01-1.042-.028-1.237a6.066 6.066 0 0 0-.144-.707z"
            fill="#EFCCAF"
        />
        <path
            d="M423.89 619.73s-.307-.011-.08.424c.167.288.266.611.291.943.012.228-.031.9-.031.9s.2.276.376-.137c.107-.341.146-.699.116-1.054-.004-.194-.338-1.179-.672-1.076z"
            fill="#F4D5BE"
        />
        <path
            d="M424 629.65a11.381 11.381 0 0 0-1.076 5.4l-.316 6.965c-.01.46-1.149 3.838.685 4.917.647.378 2.832 1.914 4.513 1.389.685-.213 3.892-1.925 3.91-2.893l.694-14.671a6.266 6.266 0 0 0-2.894-5.421l-2.863 1.686A14.765 14.765 0 0 0 424 629.65z"
            fill="#069180"
        />
        <path
            d="M413.93 635.03a9.433 9.433 0 0 0-1.5-1.587 14.808 14.808 0 0 0-3.293-.856s-.857-.333-.853.05c0 .244.271.536.439.951.24.466.623.842 1.092 1.075.591.19 1.153.459 1.672.8.523.458 1.231 1 1.231 1l1.212-1.433z"
            fill="#E5B28C"
        />
        <path
            d="M412.51 635.66a2.883 2.883 0 0 0-.129 1.394s4.306 3.093 6.057 3.556a2.157 2.157 0 0 0 2.328-.55c.791-.741 4.634-5.434 4.634-5.434s2.067-1.9 1.842-3.905c-.166-1.478-1.32-2.115-2.43-1.432-1.033.635-4.622 5.722-5.55 6.761-.369.415-.631.715-1.176.6a20.212 20.212 0 0 1-4.25-1.953.696.696 0 0 0-.752 0 2.048 2.048 0 0 0-.574.963z"
            fill="#0AA58E"
        />
        <path
            d="M429.41 639.77v11.395a.787.787 0 0 1-.785-.017.795.795 0 0 1-.386-.683v-10.336l1.171-.359z"
            fill="#303030"
        />
        <path
            d="M429.28 639.95a.448.448 0 0 1 .537.229.451.451 0 0 1 .049.204v9.865a1.158 1.158 0 0 1-.586 1 .409.409 0 0 1-.197.047.397.397 0 0 1-.391-.391v-10.16a.83.83 0 0 1 .588-.794z"
            fill="#4C4C4C"
        />
        <path
            d="M433.41 634.13s-.76-.751-1.126.054c-.43.94-.583 1.482-2.648 2.38a9.188 9.188 0 0 1-3.76.727c-2 .039-3.063.918-3.034 2.342a2.416 2.416 0 0 0 2.009 2.185c2.252.206 3-.4 5.56-1.543 2.288-1.014 2.506-1.687 2.62-2.068a36.17 36.17 0 0 0 .379-4.077z"
            fill="#204351"
        />
        <path
            d="M433.41 634.13s.279 1.848-3.034 3.037a15.402 15.402 0 0 1-4.156.971c-1.459.116-2.606.462-2.492 1.8a1.877 1.877 0 0 0 1.647 1.956c1.65.344 3.366.17 4.913-.5 2.24-.816 2.832-2.228 2.945-3.3.081-.78.177-3.964.177-3.964z"
            fill="#2F5B68"
        />
        <defs>
            <radialGradient
                id="a"
                cx={0}
                cy={0}
                r={1}
                gradientTransform="rotate(60 -85.17 803.4) scale(169.5 656.03)"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#212739" offset={0} />
                <stop stopColor="#191822" offset={1} />
            </radialGradient>
        </defs>
    </svg>
)
export default SvgComponent
